/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.profile', []);
})();
/**
 * Created by Hafeez Rehman on 01/05/2019.
 */

(function () {
    'use strict';

    angular
        .module('app.profile')
        .component('profileImage', {
            controller: ProfileImageCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/profile/profile/profile-image/profile-image.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function ProfileImageCtrl($scope, $rootScope, $log, API_CONFIG, Upload) {
        var ctrl = this;

        $scope.Form = {};
        $scope.selectedFile = null;
        $scope.formValid = false;
        var files = [];

        ctrl.$onInit = function() {
            ctrl.modalData = ctrl.resolve.modalData;
        };

        $scope.onFileSelect = function (f) {
            if (f && f.length) {
                var file = f[0];
                files = f;
                $scope.validateFile();
            }
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                $scope.$apply(function () {
                    $scope.filepreview = e.target.result;
                });
            };
        };

        $scope.resetFile = function () {
            files = [];
            $scope.filepreview = null;
        };

        $scope.validateFile = function () {
            if (!files.length) {
                $scope.formValid = false;
                return;
            }
            var validTypes = ['BMP', 'GIF', 'IMG', 'JPEG', 'JPG', 'PNG', 'TIFF'];
            var noFile = files.length === 0;
            var validSize = files.length ? (files[0].size > 0 && files[0].size <= 4200000) : false;
            var validType = files[0].type.split('/')[0] === 'image' && (validTypes.indexOf(files[0].type.split('/')[1].toUpperCase()) >= 0);

            $scope.formValid = (!noFile && validSize && validType);

            return {
                NoFile: noFile,
                Size: validSize,
                Type: validType
            };
        };

        $scope.ok = function () {
            if (!files.length || !$scope.formValid) return false;
            $scope.Form.imgForm.$setSubmitted();
            if ($scope.formValid) {
                $scope.uploading = true;
                if (!files[0].$error) {
                    Upload.upload({
                        url: API_CONFIG.apiPrefix + 'assets/images',
                        data: {
                            imageFile: files[0],
                            imageName: files[0].name
                        }
                    }).then(onResponse, errorHandler, trackProgress);
                }
            }

            function onResponse(res) {
                $scope.resetFile();
                $scope.uploading = false;
                ctrl.modalInstance.close(res.data.url);
            }

            function errorHandler(res) {
                $log.error(res);
            }

            function trackProgress(e) {
                if (e.lengthComputable) {
                    $scope.uploadProgress = parseInt(100.0 * (e.loaded / e.total));
                } else {
                    $scope.uploadProgress = -1;
                }
            }
        };

        $scope.cancel = function () {
            ctrl.modalInstance.dismiss('cancel');
        };
    }
})();
/**
 * Created by Hafeez Rehman on 15/09/2019.
 */
(function(){
    'use strict';

    angular
        .module('app.product', []);
})();
(function () {
    'use strict';

    angular
        .module('app.product')
        .component('productsImportDialog', {
            controller: productsImportDialogCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/product/products/products-import-dialog/products-import.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function productsImportDialogCtrl($rootScope, $scope, $log, $timeout, gettextCatalog, CONSTANTS) {
        var ctrl = this;
        ctrl.loading = false;
        ctrl.validators = [];
        ctrl.invalidCount = 0;
        ctrl.productsPublic = false;

        var importConfig_rwa_pp = {
            label: 'RWA Plant-protection',
            excludedSheets: [],
            columnMappings: [
                { importColumnIndex: 1, field: 'vendorProductId' },
                { importColumnIndex: 3, field: 'categoryName' },
                { importColumnIndex: 19, field: 'name' },
                { importColumnIndex: 22, field: 'unit' },
                { importColumnIndex: 23, field: 'step', isNumber: true },
                { importColumnIndex: 28, field: 'benchmarkPrice', isNumber: true },
            ],
            categoryMapping: {
                'A': 'Alternativen',
                'G': 'Getreide',
                'G/F': 'Grünland/Forst',
                'Gem': 'Gemüse',
                'G/R': 'Getreide/Raps "Herbstprodukte"',
                'K': 'Kartoffel',
                'M': 'Mais',
                'O': 'Obst',
                'R': 'Rübe',
                'W': 'Wein',
                DEFAULT: 'Pflanzenschutz'
            }
        };

        var importConfig_rwaro = {
            label: 'RWA Romania',
            excludedSheets: [],
            columnMappings: [
                { field: 'vendorProductId', importColumnIndex: 0 },
                { field: 'name', importColumnIndex: 3 },
                { field: 'categoryName', importColumnIndex: 1 },
                { field: 'unit', importColumnIndex: 4 },
                { field: 'step', importColumnIndex: 6, processValueFnc: function (v) { return v.split(' ')[0] } },
                { field: 'min', importColumnIndex: 7, processValueFnc: function (v) { return v.split(' ')[0] } },
                { field: 'attributes.Type', importColumnIndex: 2, },
                { field: 'attributes.Brand', importColumnIndex: 8, },
                { field: 'distribution', value: CONSTANTS.DISTRIBUTION_METHODS.DELIVERY },
                { field: 'distributionOptions', value: { start: 1, end: 31, timeUnit: 'day' } },
            ],
            skipRows: 3,
            unitMapping: {
                'kg': 'Kg',
                'l': 'Liter',
                'bag': 'Bag',
                'BB': 'Tonne',
                'to': 'Tonne',
            },
        };

        var importConfig_rwa_export = {
            label: 'RWA Seeds export accounts',
            excludedSheets: [],
            columnMappings: [
                { field: 'categoryName', importColumnIndex: 1 },
                { field: 'name', importColumnIndex: 2, concatColumnIndex: [4] },
                { field: 'unit', importColumnIndex: 5 },
                { field: 'attributes.Variety', importColumnIndex: 2, },
                { field: 'attributes.Category', importColumnIndex: 4, },
                { field: 'attributes.Treatment', importColumnIndex: 6, },
                { field: 'stockQuantity', importColumnIndex: 7, },
                { field: 'description', importColumnIndex: 8, },
                { field: 'vendorProductId', importColumnIndex: 2, concatColumnIndex: [4, 5] }
            ],
            skipRows: 1,
        };

        ctrl.importConfigList = [
            importConfig_rwa_export,
            importConfig_rwaro,
            importConfig_rwa_pp,
        ];
        ctrl.importConfig = ctrl.importConfigList[0];

        ctrl.columns = [
            {
                width: 7,
                field: 'number',
                label: '',
            },
            {
                width: 15,
                colIndex: 0,
                field: 'vendorProductId',
                label: gettextCatalog.getString('Product ID')
            },
            {
                width: 30,
                colIndex: 1,
                field: 'name',
                label: gettextCatalog.getString('Name')
            },
            {
                width: 24,
                colIndex: 2,
                field: 'categoryName',
                label: gettextCatalog.getString('Product type')
            },
            {
                width: 7,
                field: 'step',
                label: gettextCatalog.getString('Step')
            },
            {
                width: 7,
                value: function (r) { return r.deals && (r.deals.sent && r.deals.sent.ongoing) ? r.deals.sent.ongoing.benchmarkPrice : undefined },
                label: gettextCatalog.getString('Price')
            },
            {
                width: 10,
                field: 'unit',
                label: gettextCatalog.getString('Unit')
            }
        ];

        ctrl.$onInit = function() {

        };

        ctrl.selectFile = function(file) {
            ctrl.invalidInportFile = false;
            ctrl.browserNotSupported = false;

            if (typeof (FileReader) === 'undefined') {
                ctrl.browserNotSupported = true;
                return;
            }

            ctrl.invalidCount = 0;
            ctrl.validators = [];
            ctrl.productRows = null;
            if (! /^.*\.(xls|xlsx|csv)$/.test(file.name.toLowerCase())) {
                ctrl.invalidInportFile = true;
                return;
            }           

            ctrl.loading = true;
            var reader = new FileReader();

            //All browsers except IE.
            if (reader.readAsBinaryString) {
                reader.onload = function (e) {
                    processExcelData(e.target.result);
                };
                reader.readAsBinaryString(file);
            } else {
                //For IE Browser.
                reader.onload = function (e) {
                    var data = "";
                    var bytes = new Uint8Array(e.target.result);
                    for (var i = 0; i < bytes.byteLength; i++) {
                        data += String.fromCharCode(bytes[i]);
                    }
                    processExcelData(data);
                };
                reader.readAsArrayBuffer(file);
            }
        };

        function processCategoryName(rawCategoryName, categoryMapping) {
            if (!rawCategoryName) {
                return categoryMapping.DEFAULT;
            }

            rawCategoryName = rawCategoryName.split(',').map(function(c) {
                return categoryMapping[c];
            }).filter(function(c) {
                return !!c;
            });
            if (categoryMapping.DEFAULT) {
                rawCategoryName.unshift(categoryMapping.DEFAULT);
            }
            return rawCategoryName.join(' - ');
        }

        $scope.ok = function () {
            if (ctrl.form.$invalid || ctrl.invalidCount) {
                $log.error('ERROR: invalid count');
                return false;
            }
            ctrl.productRows = ctrl.productRows.filter(function (product, idx) {
                if (product.isInvalid) {
                    $log.log('EXCLUDED invalid row', idx, product);
                }
                return !product.isInvalid;
            });
            if (ctrl.productsPublic) {
                ctrl.productRows.filter(function (product) {
                    return product.isPublic !== false;
                }).forEach(function (product) {
                    product.isPublic = true;
                });
            }
            ctrl.modalInstance.close(ctrl.productRows);
        };

        $scope.cancel = function () {
            ctrl.modalInstance.dismiss('cancel');
        };

        function cleanupCellString(cellValue) {
            return String(cellValue).trim().replace(/\s\s+/g, ' ')
        }

        function processExcelData (data) {   
            if (!ctrl.importConfig) {
                $log.error('ERROR: no config set');
                return;
            }
            $log.log('Using config: ', ctrl.importConfig.label);
            
            var workbook = XLSX.read(data, { type: 'binary' });
            var outputRows = [];
            var skipRows = ctrl.importConfig.skipRows || 1;

            var sheetName = workbook.SheetNames[ctrl.importConfig.sheetIndex || 0]
            $log.log('Processing sheet: ', sheetName);

            var excelRows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });
            $log.log('Found rows: ', excelRows.length);

            excelRows.slice(skipRows).forEach(function (row) {
                var newRow = {};
                ctrl.importConfig.columnMappings.forEach(function (colMapping) {
                    
                    if (!row[colMapping.importColumnIndex] || row[colMapping.importColumnIndex] === 'undefined') {
                        row[colMapping.importColumnIndex] = '';
                    }
                    var value = colMapping.value || cleanupCellString(row[colMapping.importColumnIndex]);
                    if (colMapping.processValueFnc) {
                        try {
                            value = colMapping.processValueFnc(value, row);
                        }
                        catch (err) {
                            $log.error('Error for value ', value, row);
                        }
                    }
                    if (!value) {
                        return;
                    }
                    if (colMapping.concatColumnIndex && colMapping.concatColumnIndex.length) {
                        var concatSeparator = colMapping.concatColumnSeparator || ' ';
                        colMapping.concatColumnIndex.forEach(function(c) {
                            value = value + concatSeparator + cleanupCellString(row[c]);
                        });                        
                    }
                    if (colMapping.field.indexOf('attributes') < 0) {
                        newRow[colMapping.field] = value;
                    }
                    else {
                        newRow.attributes = newRow.attributes || [];
                        newRow.attributes.push({
                            label: colMapping.field.split('.')[1],
                            value: value,
                        });
                    }
                });
                if (newRow.vendorProductId || newRow.name) {
                    outputRows.push(newRow);
                }
            });

            $log.log('Processing completed. Validating.');

            validateData(outputRows);

            var rowIdx = 1;
            outputRows.forEach(function(row) {
                if (!row.isInvalid) {
                    row.number = rowIdx++;
                    row.unit = row.unit || gettextCatalog.getString('Unit');
                }
                if (ctrl.importConfig.categoryMapping) {
                    row.categoryName = processCategoryName(row.categoryName, ctrl.importConfig.categoryMapping);
                }
                if (ctrl.importConfig.unitMapping) {
                    row.unit = ctrl.importConfig.unitMapping[row.unit] || row.unit;
                }
                if (row.step) {
                    row.dealSizeOptions = row.dealSizeOptions || {};
                    row.dealSizeOptions.step = row.step;
                }
                if (row.min) {
                    row.dealSizeOptions = row.dealSizeOptions || {};
                    row.dealSizeOptions.min = row.min;
                }
                if (row.target || row.benchmarkPrice || row.userGroupNames || row.distributionOptions || row.distribution) {
                    row.deals = {
                        sent: {
                            ongoing: {
                                target: row.target,
                                benchmarkPrice: row.benchmarkPrice,
                                userGroupNames: row.userGroupNames ? row.userGroupNames.split(',') : undefined,
                                distribution: row.distribution,
                                distributionOptions: row.distributionOptions,
                            }
                        }
                    };
                    row.target = undefined;
                    row.benchmarkPrice = undefined;
                    row.userGroupNames = undefined;
                    row.distribution = undefined;
                    row.distributionOptions = undefined;
                }
            });

            $log.log('Processing and validation complete. Total items count: ', outputRows.length);

            $timeout(function() {
                $scope.$apply(function () {
                    ctrl.productRows = outputRows;
                    ctrl.loading = false;
                });
            }, 100);
        }

        function validateData(data) {
            ctrl.hasInvalidRows = false;
            if (!Array.isArray(data)) {
                ctrl.hasInvalidRows = true;
                return;
            }

            data.filter(function (row) {
                if (!row.name || !row.vendorProductId) {
                    return true;
                } 
                if (ctrl.importConfig.isInvalidFunc) {
                    return ctrl.importConfig.isInvalidFunc(row);
                }
                return false;
            }).forEach(function (row) {
                row.isInvalid = true;
                ctrl.hasInvalidRows = true;
            });
            ctrl.validRowsCount = data.filter(function (row) {
                return !row.isInvalid;
            }).length;
        }
    }
})();
/**
 * Created by Hafeez Rehman on 01/05/2019.
 */

(function () {
    'use strict';

    angular
        .module('app.product')
        .component('productImagesImportDialog', {
            controller: productImagesImportDialogCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/product/products/product-images-import-dialog/product-images-import.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function productImagesImportDialogCtrl($scope, $rootScope, $log, $q, $timeout, gettextCatalog, HttpService, AlertService, Upload, API_CONFIG) {
        var ctrl = this;
        ctrl.loading = false;
        ctrl.validators = [];
        ctrl.invalidCount = 0;
        ctrl.productsPublic = true;

        ctrl.importConfig = {
            excludedSheets: ['Sheet1'],
            columnMappings: [ 
                { importColumnIndex: 0, fhName: 'vendorProductId', excludeValues: ['part no.'] }, 
                { importColumnIndex: 1, fhName: 'name' }, 
                { importColumnIndex: 3, fhName: 'benchmarkPrice', isNumber: true },
            ]
        };

        ctrl.$onInit = function() {

        };

        ctrl.selectFile = function(files) {

            ctrl.invalidInportFile = false;
            ctrl.browserNotSupported = false;

            if (typeof (FileReader) === 'undefined') {
                ctrl.browserNotSupported = true;
                return;
            }

            if (!files || !files.length) {
                ctrl.invalidInportFile = true;
                return;
            }

            ctrl.productRows = [];
            
            files.forEach(function(file) {
                var row = {
                    file: file,
                    fileName: file.name,
                };
                if (! /^.*\.(png|jpg|jpeg)$/.test(file.name.toLowerCase())) {
                    row.isInvalid = true;
                    ctrl.productRows.push(row);
                    return;
                }    
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function (e) {
                    $scope.$apply(function () {
                        row.filePreview = e.target.result;
                    });
                };
                try {
                    row.vendorProductId = file.name.split('---')[1];
                    row.vendorProductId = (row.vendorProductId.split('-').slice(1)).join('-');
                    row.vendorProductId = row.vendorProductId.split('.').slice(0, -1)[0];
                    if (row.vendorProductId.slice(-1) === '-') {
                        row.vendorProductId = row.vendorProductId.slice(0, -1);
                    }
                } catch(e) {
                    row.isInvalid = true;
                }
                if (!row.vendorProductId) {
                    row.isInvalid = true;
                    return;
                }

                HttpService.Get('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products', { vendorProductId: row.vendorProductId }).then(function(res) {
                    if (res && res.products && res.products.length) {
                        row.product = { 
                            _id: res.products[0]._id,
                            imageUrls: res.products[0].imageUrls
                        };
                        return;
                    }
                    // Try with another product ID
                    row.vendorProductId = (row.vendorProductId.split('-').slice(1)).join('-');
                    if (!row.vendorProductId) {
                        row.isInvalid = true;
                        return;
                    }
                    HttpService.Get('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products', { vendorProductId: row.vendorProductId }).then(function (res) {
                        if (res && res.products && res.products.length) {
                            row.product = { _id: res.products[0]._id };
                            return;
                        }
                        // Try with another product ID
                        row.vendorProductId = (row.vendorProductId.split('-').slice(1)).join('-');
                        if (!row.vendorProductId) {
                            row.isInvalid = true;
                            return;
                        }
                        HttpService.Get('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products', { vendorProductId: row.vendorProductId }).then(function (res) {
                            if (res && res.products && res.products.length) {
                                row.product = { _id: res.products[0]._id };
                                return;
                            }
                            row.isInvalid = true;
                        });
                    });
                    
                });
                ctrl.productRows.push(row);
            });
            ctrl.loading = false;
        };

        $scope.ok = function () {
            ctrl.loading = true;
            var validRows = ctrl.productRows.filter(function (row) {
                return !row.isInvalid && row.file && row.fileName && row.product && row.product._id;
            });
            $log.log('Processing files. Count: ', validRows.length);

            var imageUploadPromises = validRows.map(function (row) {
                $log.log('Uploading file:', row.fileName)
                return Upload.upload({
                    url: API_CONFIG.apiPrefix + 'assets/images',
                    data: {
                        imageFile: row.file,
                        imageName: row.fileName
                    }
                }).then(function(res) {
                    row.product.imageUrls = row.product.imageUrls || [];
                    row.product.imageUrls.unshift(res.data.url);
                });
            });
            $q.all(imageUploadPromises).then(function() {
                $log.log('File upload complete');       
                var producUpdatePromises = validRows.map(function (row) {
                    var data = { imageUrls: row.product.imageUrls };
                    return HttpService.Put('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products/' + row.product._id, data);
                })

                $q.all(producUpdatePromises).then(function() {
                    $log.log('Product update complete');
                    ctrl.loading = false;
                    AlertService.success(producUpdatePromises.length + ' ' + gettextCatalog.getString('images uploaded'));
                    ctrl.modalInstance.close();
                }).catch(function(err){
                    $log.log(err);
                    ctrl.loading = false;
                    ctrl.modalInstance.close();
                });
            });  
        };

        $scope.cancel = function () {
            ctrl.modalInstance.dismiss('cancel');
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.product')
        .component('productEditDialog', {
            controller: ProductEditDialogCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/product/products/product-edit-dialog/product-edit.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function ProductEditDialogCtrl($scope, $uibModal, $templateCache, Utils, $rootScope, 
        HttpService, gettextCatalog, AlertService, DealsService, DEAL_TARGET, DEAL_CATEGORY) {

        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;
        ctrl.DEAL_TARGET = DEAL_TARGET; 

        ctrl.lookup = {};
        ctrl.lookup.distributionOptionsTimeUnits = [
            { label: gettextCatalog.getString('Days'), value: 'day' },
            { label: gettextCatalog.getString('Weeks'), value: 'week' }
        ];
        ctrl.lookup.distributionMethods = [
            { label: gettextCatalog.getString('Select'), value: undefined },
            { label: gettextCatalog.getString('Delivery'), value: 'delivery' },
            { label: gettextCatalog.getString('Collection'), value: 'collection' }
        ];

        ctrl.$onInit = function() {
            if (!ctrl.isCategoryCrop()) {
                ctrl.lookup.units = DealsService.getProductUnits();
                ctrl.lookup.categories = DealsService.getProductTypes();
            }
            else {
                ctrl.lookup.units = [ gettextCatalog.getString('Tonne') ];
                ctrl.lookup.categories = [];
            }

            var modalData = ctrl.resolve.modalData;
            ctrl.isNew = modalData.isNew;
            ctrl.product = angular.copy(modalData.product);

            ctrl.product.unit = ctrl.product.unit || ((ctrl.lookup.units && ctrl.lookup.units.length) ? ctrl.lookup.units[0] : '');
            ctrl.product.unit = DealsService.getUpdatedUnit(ctrl.product.unit);
            ctrl.deal = (ctrl.product.deals && ctrl.product.deals.sent && ctrl.product.deals.sent.ongoing) ? ctrl.product.deals.sent.ongoing : {};
            ctrl.initialRetailPriceLength = (ctrl.deal && ctrl.deal.retailPrices) ? ctrl.deal.retailPrices.length : 0;

            if (ctrl.deal && ctrl.deal._id) {
                HttpService.Get('deals/' + ctrl.deal._id).then(function(res) {
                    ctrl.deal = res;
                    ctrl.oldPrice = ctrl.deal.benchmarkPrice;

                    ctrl.product.isPushNotificationEnabled = false;

                    if (modalData.focusPrice) {
                        document.getElementById('price').focus();
                    }
                    if (modalData.editDiscount) {
                        ctrl.editDiscount();
                    }
                });
            }
        };

        ctrl.isCategoryDiesel = function() {
            if (!ctrl.product.categoryName) {
                return;
            }
            var threeDigitsProductKeywords = ['treibstoffe', 'schmierstoffe', 'heizöl', 'fuel', 'diesel', 'carburant', 'energie', 'heizöl'];
            var match = Utils.altFind(threeDigitsProductKeywords, function (kw) {
                return ctrl.product.categoryName.toLowerCase().indexOf(kw) >= 0;
            });
            return !!match;
        }

        ctrl.isCategoryCrop = function() {
            if (!$rootScope.app.Auth.User.supplier.productTypes || 
                $rootScope.app.Auth.User.supplier.productTypes.length !== 1) {
                return false;
            }
            var pt = $rootScope.app.Auth.User.supplier.productTypes[0].toLowerCase();
            return pt.indexOf('verkaufen') >= 0 || pt.indexOf('sell') >= 0;
        }

        ctrl.categoryNameChanged = function() {
            if (ctrl.isCategoryDiesel()) {
                ctrl.deal.priceDecimalDigits = 3;    
            }
        }

        ctrl.isPublicChanged = function() {            
            if (!ctrl.product.isPublic || !ctrl.deal) {
                return;
            }

            if (!ctrl.product.deals) {
                ctrl.product.deals = {};
            }
            if (!ctrl.product.deals.sent) {
                ctrl.product.deals.sent = {};
            }
            if (!ctrl.product.deals.sent.ongoing) {
                ctrl.product.deals.sent.ongoing = {};
            }

            if (ctrl.isCategoryCrop()) {
                ctrl.deal.categoryName = DEAL_CATEGORY.CROP;
            }

            if (!ctrl.deal.benchmarkPrice && ctrl.product.deals.sent.ongoing && ctrl.product.deals.sent.ongoing.benchmarkPrice) {
                ctrl.deal.benchmarkPrice = +ctrl.product.deals.sent.ongoing.benchmarkPrice;
            } else if (!ctrl.deal.benchmarkPrice && ctrl.product.deals.sent.latest && ctrl.product.deals.sent.latest.length) {
                ctrl.deal.benchmarkPrice = +ctrl.product.deals.sent.latest[0].benchmarkPrice;
            }

            if (!ctrl.deal.distribution) {
                ctrl.deal.distribution = ctrl.lookup.distributionMethods[0].value;
            }
            if (!ctrl.deal.distributionOptions) {
                ctrl.deal.distributionOptions = {
                    start: 5,
                    end: 10,
                    timeUnit: ctrl.lookup.distributionOptionsTimeUnits[0].value
                }
            }
        }

        ctrl.priceClick = function() {
            if (ctrl.deal.benchmarkPrice && ctrl.deal.individualDiscount + ctrl.deal.clearanceDiscount > 0) {
                ctrl.editDiscount(true);
            }
            if (Utils.isSupplierDistributor()) {
                ctrl.editDiscount(true);
            }
        }

        ctrl.editDiscount = function (focusPrice) {
            var deal = ctrl.deal;
            var discountSettings = {
                quantityDiscountsInput: deal.quantityDiscounts || [],
                dealSizeOptions: ctrl.product.dealSizeOptions,
                dealSize: ctrl.product.stockQuantity,
                benchmarkPrice: deal.benchmarkPrice,
                individualDiscount: deal.individualDiscount || 0,
                clearanceDiscount: deal.clearanceDiscount || deal.individualDiscount || 0,
                priceDecimalDigits: deal.priceDecimalDigits,
                customUnit: ctrl.product.unit,
                isVatIncluded: deal.isVatIncluded,
                vatRate: deal.vatRate,
                focusPrice: focusPrice,
                allowPriceOnRequest: true,
                retailPrices: deal.retailPrices,
            };
            var dialog = $uibModal.open({
                animation: true,
                component: 'DealDiscountOptionsCtrl',
                windowClass: 'modal-window-second-level',
                size: 'lg',
                resolve: {
                    discountSettings: function () {
                        return discountSettings;
                    }
                }
            });

            dialog.result.then(function (ds) {
                ctrl.form.$pristine = false;

                deal.individualDiscount = ds.individualDiscount;
                deal.clearanceDiscount = ds.clearanceDiscount;
                deal.quantityDiscounts = ds.quantityDiscounts;
                deal.groupDiscount = ds.groupDiscount;
                deal.isVatIncluded = ds.isVatIncluded;
                deal.vatRate = ds.vatRate;
                deal.priceDecimalDigits = ds.priceDecimalDigits;

                deal.benchmarkPrice = ds.benchmarkPrice;
                deal.dealSize = ds.dealSize;
                deal.retailPrices = ds.retailPrices;
            });
        }

        ctrl.manageCollection = function () {            
            var dialog = $uibModal.open({
                animation: true,
                controller: 'CollectionPointCtrl',
                templateUrl: 'app/shared/templates/modals/collection-points.tpl.html',
                template: Utils.getTemplate('app/shared/templates/modals/collection-points.tpl.html'),
                size: 'md',
                windowClass: 'modal-window-second-level',
                resolve: {
                    items: function () {
                        return {
                            collectionPoints: $rootScope.app.Auth.User.supplier.collectionPoints,
                            selectedCollectionPoints: ctrl.deal.collectionPoints
                        };
                    }
                }
            });

            dialog.result.then(function (selectedCollectionPoints) {
                ctrl.form.$pristine = false;
                ctrl.deal.collectionPoints = selectedCollectionPoints;
            });
        };

        ctrl.switchVatIncluded = function () {
            DealsService.switchVatIncluded(ctrl.deal).then(function () {
                ctrl.form.$pristine = false;
            });
        };

        ctrl.isPriceDyanmicChanged = function () {
            if (!ctrl.deal.priceDynamic || !ctrl.deal.priceDynamic.isEnabled) {
                return;
            }
            ctrl.deal.priceDynamic = ctrl.deal.priceDynamic || {};
            ctrl.deal.priceDynamic.isEnabled = true;
            ctrl.deal.priceDynamic.isReminderEnabled = true;
            ctrl.deal.priceDynamic.frequency = 1;
            ctrl.deal.priceDynamic.timeUnit = 'day';
            ctrl.deal.priceDynamic.updatedAt = ctrl.deal.priceDynamic.updatedAt || Date.now();
        }

        ctrl.isConfirmationNeededChanged = function() {
            if (!ctrl.deal.distributionOptions || !ctrl.deal.distributionOptions.isConfirmationNeeded) {
                ctrl.deal.checkoutNotes = '';
                return;
            }
            ctrl.deal.distributionOptions.isProofPictureNeeded = true;
            ctrl.deal.checkoutNotes = gettextCatalog.getString('You will be asked to confirm the quantity delivered. Price per {unit} will not change.').replace('{unit}', ctrl.product.unit);
        }

        ctrl.checkPriceChange = function () {
            if (!ctrl.deal.priceDynamic) {
                return;
            }
            // TODO: duplicate code in product-list
            ctrl.deal.priceDynamic.updatedAt = Date.now();
            ctrl.deal.priceDynamic.nextUpdateAt = moment().add(1, 'day').set({hour: 6, minute: 0, second: 0}).toDate();
        }

        ctrl.deleteProduct = function() {
            Utils.CreateConfirmation(gettextCatalog.getString('Delete product?')).result.then(function () {
                HttpService.Delete('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products/' + ctrl.product._id).then(function () {
                    AlertService.warning(gettextCatalog.getString('Product deleted.'));
                    ctrl.modalInstance.close();
                });
            });
        };

        ctrl.dealDistributionChanged = function() {
            if (!DealsService.isDistributionCollection(ctrl.deal)) {
                return;
            }
            if (ctrl.deal.collectionPoints && ctrl.deal.collectionPoints.length) {
                return;
            }
            ctrl.deal.collectionPoints = $rootScope.app.Auth.User.supplier.collectionPoints;
        }

        // Clonse/OK buttons

        ctrl.ok = function () {
            if (ctrl.product.dealSizeOptions && ctrl.product.dealSizeOptions.step) {
                ctrl.product.dealSizeOptions.min = ctrl.product.dealSizeOptions.min || ctrl.product.dealSizeOptions.step
            }
            ctrl.form.$setSubmitted();
            ctrl.formDeal.$setSubmitted();
            if (ctrl.form.$invalid || ctrl.formDeal.$invalid) {
                return false;
            }
            if (ctrl.product.isPublic) {
                ctrl.deal.customType = ctrl.product.categoryName;

                ctrl.checkPriceChange();
                if (!ctrl.deal.benchmarkPrice) {
                    ctrl.deal.quantityDiscounts = [];
                    ctrl.deal.individualDiscount = 0;
                    ctrl.deal.clearanceDiscount = 0;
                }
                if (Utils.isSupplierDistributor()) {
                    ctrl.deal.target = DEAL_TARGET.SUPPLIERS;
                }
                ctrl.product.deals.sent.ongoing = ctrl.deal;
            }
            
            ctrl.modalInstance.close(ctrl.product);
        };

        ctrl.cancel = function () {
            ctrl.modalInstance.dismiss('cancel');
        };
    }
})();
(function() {
  'use strict';

  angular
      .module('app', [
        'app.patch',
        'app.commons',
        'app.auth',
        'app.order',
        'app.dashboard',
        'app.customers',
        'app.retailers',
        'app.profile',
        'app.deals',
        'app.crop',
        'app.offers',
        'app.product',
        'angulartics',
        'angulartics.mixpanel',
      ]);
})();

(function () {
    'use strict';

    angular
        .module('app')
        .service('ShoppingCartService', ShoppingCart);

    function ShoppingCart($rootScope, $timeout, $uibModal, $ngConfirm, $q, $log,
        gettextCatalog, HttpService, AlertService, Utils) {

        this.carts = [];
        this.dealsInCart = {};

        this.getCarts = function() {
            var deferred = $q.defer();
            var _this = this;
            
            HttpService.Get('carts').then(function (res) {
                _this.carts = res.carts;
                _this.carts.forEach(function(cart) {
                    refreshCartTotalValues(cart);
                    cart.items.forEach(function(item) {
                        _this.dealsInCart[item.deal._id] = true;
                    });
                });                
                deferred.resolve(_this.carts);
            }, function(error) {
                deferred.reject(error)
            });
            return deferred.promise;            
        }

        this.isDealIdInCart = function(dealId) {
            return this.dealsInCart[dealId];
        }

        this.addToCart = function (deal) {
            if (!deal) {
                return;
            }

            var cart = Utils.altFind(this.carts, function (cart) {
                return cart.supplier._id === deal.supplier._id;
            });
            if (!cart) {
                cart = { 
                    supplier: deal.supplier,
                    items: [],
                };
            }

            var item = Utils.altFind(cart.items, function (item) {
                return item.deal._id === deal._id;
            });

            if (!item) {
                item = {
                    deal: deal,
                    isNew: true
                };
            }

            var _this = this;
            promptItemQuantity(item).then(function () {
                clearLastUpdated(_this.carts);
                item.isLastAdded = true;
                item.updatedAt = Date.now();
                item.udatedBy = $rootScope.app.Auth.User._id;

                if (item.isNew) {
                    item.isNew = undefined;
                    cart.items.push(item);
                    _this.dealsInCart[item.deal._id] = true;
                }

                refreshCartTotalValues(cart);
                if (!cart._id) {
                    createCart(cart).then(function (res) {
                        cart._id = res.data._id;
                        _this.carts.push(cart);
                        AlertService.success(gettextCatalog.getString('Added to cart'));
                    });
                }
                else {
                    updateCart(cart).then(function () {
                        AlertService.success(gettextCatalog.getString('Added to cart'));
                    });
                }
            });         
        }

        this.clearCart = function (index) {
            if (index === undefined || index < 0) {
                return;
            }
            if (!this.carts.length) {
                return;
            }
            var cart = this.carts[index];
            if (!cart) {
                return;
            }
            var _this = this; 
            deleteCart(cart).then(function() {
                cart.items.forEach(function(item) {
                    _this.dealsInCart[item.deal._id] = false;
                });
                _this.carts.splice(index, 1);
            })
        }

        this.editItem = function (cart, item, cartIndex, itemIndex) {
            var _this = this;
            promptItemQuantity(item).then(function () {
                if (item.quantity <= 0) {
                    _this.dealsInCart[item.deal._id] = false;
                    cart.items.splice(itemIndex, 1);
                }
                if (!cart.items.length) {
                    _this.clearCart(cartIndex)
                    return;
                }
                refreshCartTotalValues(cart);
                updateCart(cart).then(function () {
                    AlertService.success(gettextCatalog.getString('Item updated'));
                });
            });            
        }

        this.promtClearCart = function (cart, index) {
            var _this = this;
            $ngConfirm({
                icon: 'fa fa-exclamation-triangle',
                title: gettextCatalog.getString('Claear cart'),
                content: '<p>' + gettextCatalog.getString('Number of items') + ': ' + cart.items.length + '<p>',
                columnClass: 'small',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        btnClass: 'btn-dark float-left'
                    },
                    ok: {
                        text: gettextCatalog.getString('Clear cart'),
                        btnClass: 'btn-warning btn-wide',
                        action: function () {
                            $timeout(function () {
                                _this.clearCart(index);
                            }, 100);
                        }
                    }
                }
            });
        }

        this.checkout = function (cart, cartIndex) {
            var _this = this;
            if (!cart.items.length) {
                return;
            }
            refreshCartTotalValues(cart);

            $uibModal.open({
                animation: true,
                component: 'newMultiOrder',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    modalData: function () {
                        return {
                            cart: cart,
                            cartIndex: cartIndex
                        };
                    }
                }
            }).result.then(function (orderData) {
                var checkoutData = {
                    order: orderData,
                    cart: cart,
                };
                HttpService.Post('carts/checkout', checkoutData).then(function () {
                    _this.clearCart(cartIndex);
                    $ngConfirm({
                        icon: 'fa fa-check-circle',
                        type: 'green',
                        title: gettextCatalog.getString('Order placed'),
                        content: gettextCatalog.getString('For details, go to the "Orders" page from the main menu.'),
                        buttons: { OK: function () { } }
                    });
                })
                    .catch(function () {
                        AlertService.error(gettextCatalog.getString('Error while creating order. Please try again.'));
                    });
            });
        }

        this.checkoutSingleItem = function(deal, quantity, startIntro) {
            var _this = this;
            var cart = {
                supplier: deal.supplier,
                items: [{
                    deal: deal,
                    isNew: true,
                }],
                startIntro: startIntro
            };
            if (quantity) {
                cart.items[0].quantity = quantity;
                _this.checkout(cart);  
                return;
            }

            promptItemQuantity(cart.items[0]).then(function () {
                _this.checkout(cart);
            });
        }

        // ------------------------------------------
        // Cart CRUD 

        function createCart(cart) {
            return HttpService.Post('carts', cart);
        }

        function updateCart(cart) {
            if (!cart._id) {
                return new Promise(function(resolve, reject) {
                    reject();
                });
            }
            return HttpService.Put('carts/' + cart._id, cart);
        }

        function deleteCart(cart) {
            if (!cart._id) {
                return new Promise(function (resolve, reject) {
                    reject();
                });
            }
            return HttpService.Delete('carts/' + cart._id);
        }  
        
        // ------------------------------------------

        function promptItemQuantity(item) {
            var deferred = $q.defer();

            var scope = $rootScope.$new(true);
            scope.item = item;
            scope.utils = Utils;
            scope.vm = { 
                isVariantSelelectionNeeded: item.deal.variants && item.deal.variants.length,
                selectedQuantity: item.quantity
            };

            scope.setQuantityToZero = function () {
                scope.vm.selectedQuantity = 0;
            };
            scope.selectVariant = function (variant) {
                scope.vm.isVariantSelelectionNeeded = false;
                scope.vm.selectedVariant = variant;
            };

            $ngConfirm({
                icon: 'fa fa-edit',
                title: gettextCatalog.getString('Select quantity'),
                scope: scope,
                closeIcon: true,
                contentUrl: 'app/modules/shopping-cart/list/shopping-cart-edit-item.tpl.html',
                columnClass: 'small',
                buttons: {
                    cancel: {
                        keys: ['esc'],
                        text: gettextCatalog.getString('Cancel'),
                        btnClass: 'btn-dark float-left',
                        action: deferred.reject
                    },
                    ok: {
                        keys: ['enter'],
                        text: gettextCatalog.getString('Confirm'),
                        btnClass: 'btn-success btn-wide',
                        action: function () {
                            if (item.quantity === scope.vm.selectedQUantity) {
                                deferred.reject();
                                return;
                            }
                            item.quantity = scope.vm.selectedQUantity;
                            if (scope.vm.selectedVariant) {
                                Object.assign(item, scope.vm.selectedVariant);
                            }
                            deferred.resolve();
                        }
                    }
                }
            });

            return deferred.promise;
        }

        function refreshCartTotalValues(cart) {
            cart.totalPrice = 0;
            cart.quantity = 0;
            cart.items.filter(function(item) {
                return item.deal && item.deal.benchmarkPrice > 0;
            }).forEach(function(item) {
                item.unitPrice = item.benchmarkPrice || item.deal.benchmarkPrice;
                item.totalPrice = Utils.roundCurrencyValue(item.quantity * item.unitPrice);
                cart.totalPrice = Utils.roundCurrencyValue(cart.totalPrice + item.totalPrice);
                cart.quantity = cart.quantity + item.quantity;
            });
        }

        function clearLastUpdated(carts) {
            carts.forEach(function(cart) {
                cart.items.forEach(function(item) {
                    item.isLastAdded = false;
                });
            });            
        }
    }

    ShoppingCart.$inject = ['$rootScope', '$timeout', '$uibModal', '$ngConfirm', '$q', '$log',
        'gettextCatalog', 'HttpService', 'AlertService', 'Utils'];
})();
/**
 * Created by Hafeez Rehman on 10/12/2018.
 */

(function(){
    'use strict';

     angular
         .module('app.commons', ['ngQuill'])
         .constant('NG_QUILL_CONFIG', {
             modules: {
                toolbar: [
                    ['bold', 'italic', 'underline'], // toggled buttons
                    //['blockquote', 'code-block'],
                    //[{ 'header': 2 }, { 'header': 3 }], // custom button values
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    //[{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
                    //[{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
                    //[{ 'direction': 'rtl' }], // text direction
                    //[{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown
                    [{ 'header': [3, 4, false] }],
                    //[{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
                    //[{ 'font': [] }],
                    //[{ 'align': [] }],
                    // ['clean'], // remove formatting button
                    //['link', 'image', 'video'] // link and image, video
                ]
             },
             theme: 'snow',
             placeholder: '',
             readOnly: false,
             bounds: document.body
         })
         .config(function(ngQuillConfigProvider, NG_QUILL_CONFIG) {
             ngQuillConfigProvider.set(NG_QUILL_CONFIG);
         });
})();
(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('shoppingCartList', {
            controller: ShoppingCartListCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/shopping-cart/list/shopping-cart-list.tpl.html'
        });

    function ShoppingCartListCtrl(Utils, ShoppingCartService) {
        var ctrl = this;
        ctrl.utils = Utils;

        ctrl.list = [];
        ctrl.$onInit = function () {
            ShoppingCartService.getCarts().then(function(res) {
                ctrl.list = res;
            });
        };

        ctrl.clearCart = function (cart, index) {
            ShoppingCartService.promtClearCart(cart, index);
        }

        ctrl.checkout = function(cart, cartIndex) {
            ShoppingCartService.checkout(cart, cartIndex);
        }

        ctrl.editItem = function (cart, item, cartIndex, itemIndex) {
            ShoppingCartService.editItem(cart, item, cartIndex, itemIndex);
        }

        
    }
})();
(function(){
    'use strict';

    angular
        .module('app.commons')
        .component('newMultiOrder', {
            controller: NewMultiOrderCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/shopping-cart/checkout/shopping-cart-checkout.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function NewMultiOrderCtrl($rootScope, $timeout, HttpService, Utils, DealsService, ShoppingCartService, gettextCatalog) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;
        
        ctrl.$onInit = function () {
            ctrl.cart = ctrl.resolve.modalData.cart;
            ctrl.cartIndex = ctrl.resolve.modalData.cartIndex;
            ctrl.deal = ctrl.cart.items[0].deal;

            ctrl.user = ctrl.resolve.modalData.user;
            ctrl.order = {};
            ctrl.order.billingAddress = ctrl.order.billingAddress || {};
            ctrl.order.deliveryAddress = ctrl.order.deliveryAddress || {};

            ctrl.billingOpts = $rootScope.app.Auth.User.supplier.collectionPoints;
            setupBillingOpts();

            if (ctrl.cart.startIntro) {
                $timeout(ctrl.startIntro, 500);
                ctrl.cart.startIntro = false;
            }
        };

        ctrl.setBillingData = function (value) {
            if (!value) {
                return;
            }
            ctrl.selectedCollectionPoint = value;
            if (!ctrl.selectedCollectionPoint) {
                return;
            }

            if (value.addressDetails && value.addressDetails.street) {
                ctrl.order.billingAddress = {
                    name: ctrl.selectedCollectionPoint.name,
                    street: ctrl.selectedCollectionPoint.addressDetails.street,
                    zipcode: ctrl.selectedCollectionPoint.addressDetails.zipcode,
                    city: ctrl.selectedCollectionPoint.addressDetails.city,
                };
                return;
            }

            ctrl.order.billingAddress = {
                name: ctrl.selectedCollectionPoint.name,
                street: ctrl.selectedCollectionPoint.address,
            };
            var addressParts = ctrl.selectedCollectionPoint.address.split(', ');
            if (addressParts.length <= 1) {
                return;
            }
            ctrl.order.billingAddress.street = addressParts[0];
            ctrl.order.billingAddress.city = addressParts[1]; 
            
            var cityParts = addressParts[1].split(' ');
            if (cityParts.length <= 1) {
                return;
            }
            ctrl.order.billingAddress.zipcode = cityParts[0]; 
            ctrl.order.billingAddress.city = cityParts.slice(1).join(' '); 
        }

        ctrl.copyCollectionPoint = function () {
            ctrl.order.deliveryAddress = angular.copy(ctrl.order.billingAddress);
            ctrl.user = undefined;
        };
        ctrl.copyBillingAddress = function() {
            ctrl.order.deliveryAddress.street = ctrl.order.billingAddress.street;
            ctrl.order.deliveryAddress.zipcode = ctrl.order.billingAddress.zipcode;
            ctrl.order.deliveryAddress.city = ctrl.order.billingAddress.city;
        };

        ctrl.getCustomers = function (namePart, phoneNumberPart) {
            if (!Utils.getSettings().tradeWithFarmers) {
                return [];
            }
            var payload = {
                limit: 8
            };
            if (namePart) {
                payload.name = namePart;
            }
            if (phoneNumberPart && phoneNumberPart !== '0' && phoneNumberPart !== '+') {
                payload.phoneNumber = phoneNumberPart;
                if (payload.phoneNumber[0] === '0' || payload.phoneNumber[0] === '+') {
                    payload.phoneNumber = payload.phoneNumber.slice(1);
                }
            }
            return HttpService.Get('users', payload).then(function (res) {
                var custList = [];
                res.list.forEach(function (u) {
                    u.fullName = u.name.first + ' ' + u.name.last;
                    custList.push(u);
                });
                return custList;
            }, function (err) {
                $log.err(err);
            });
        };

        ctrl.customerSelected = function (user) {
            ctrl.user = user;
            
            ctrl.order.deliveryAddress.name = user.name.first + ' ' + user.name.last;
            ctrl.order.phoneNumber = user.phoneNumber;
            ctrl.order.onBehalfOfUser = user;

            ctrl.order.deliveryAddress.city = user.address.city;
            ctrl.order.deliveryAddress.zipcode = user.address.zipcode;
            ctrl.order.deliveryAddress.street = user.address.street;

            setupBillingOpts();
        };
        
        ctrl.ok = function() {
            ctrl.form.$setSubmitted();
            if (ctrl.form.$invalid || !ctrl.hasAgreedTerms) {
                return false;
            }
            ctrl.modalInstance.close(ctrl.order);
        };

        ctrl.editCartItem = function(item, itemIndex) {
            ShoppingCartService.editItem(ctrl.cart, item, ctrl.cartIndex, itemIndex);
        }

        ctrl.cancel = function() {
            ctrl.modalInstance.dismiss('cancel');
        };

        function setupBillingOpts() {
            if (!ctrl.billingOpts || !ctrl.billingOpts.length) {
                return;
            }            
            if (ctrl.user && ctrl.user.supplierCustomers && ctrl.user.supplierCustomers.length && ctrl.user.supplierCustomers[0].collectionPointName) {
                ctrl.setBillingData(Utils.altFind(ctrl.billingOpts, function (bo) {
                    return bo.name && bo.name.toLowerCase() === ctrl.user.supplierCustomers[0].collectionPointName.toLowerCase();
                }));
                return;
            }
            if (ctrl.billingOpts && ctrl.billingOpts.length === 1) {
                ctrl.setBillingData(ctrl.billingOpts[0]);
            }
        }

        // Intro --------------------------

        ctrl.startIntro = function () {
            Utils.startIntro([
                {
                    element: '#checkout-items',
                    intro: gettextCatalog.getString('You can review the order and modify quantities.'),
                },
                {
                    element: '#checkout-addresses',
                    intro: gettextCatalog.getString('Enter a billing address and a delivery address for delivery. You can also select these addresses automatically from the address book stored in your profile.'),
                },
                {
                    element: '#checkout-message',
                    intro: gettextCatalog.getString('You can attach a message to the order for your supplier.'),
                },
            ], {
                text: gettextCatalog.getString('Done'),
                action: function () {
                    ctrl.modalInstance.dismiss('cancel');
                }
            });
        }



    }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.profile')
            .component('zipCodes', {
                controller: ZipCodeCtrl,
                controllerAs: '$ctrl',
                templateUrl: 'app/modules/profile/zipcode/zipcode.tpl.html',
                bindings: {
                    country: '=',
                    zipList: '=',
                    zipMap: '='
                }
            });

    function ZipCodeCtrl($scope, $state, $timeout, $window, $log, AuthFactory, gettextCatalog, $rootScope, HttpService, Utils) {
        var ctrl = this;

        ctrl.utils = Utils;
        ctrl.lookup = {};

        ctrl.removedMap = {};
        ctrl.newMap = {};

        ctrl.$onInit = function() {

            $scope.$on('changes-saved', function() {
                ctrl.removedMap = {};
                ctrl.newMap = {};
            });
        };

        ctrl.fetchZipCodes = function(searchKey, limit) {
            if (!limit) {
                limit = 20;
            }
            var queryParams = {
                api_key: 'TMP_PORTAL_KEY', // TODO wire into HttpService
                country: ctrl.country,
                search: searchKey, 
                limit: limit
            }
            return HttpService.Get('zipcodes', queryParams)
                .then(function(resp) {
                    return resp.zipCodes;
                })
                .catch(function(err) {
                    $log.err('Error loading zipcodes', err);
                    return [];
                });
        };

        ctrl.addNewZipCode = function(item) {
            if (!item && ctrl.newZipCode.indexOf(' ') > 0) {
                ctrl.newZipCode.split(' ').forEach(function(zc) {
                    addZipCodeToList(zc);
                    ctrl.fetchZipCodes(zc, 1).then(function(result) {
                        if (result) {
                            ctrl.zipCodesMap[result[0].value] = result[0].label;
                        }
                    });
                });
                ctrl.newZipCode = '';
                return;
            }

            if (item) {
                ctrl.newZipCode = item.value.toLowerCase();
                ctrl.zipMap[item.value] = item.label;
            }
            ctrl.newZipCode = ctrl.newZipCode.toLowerCase();
            addZipCodeToList(ctrl.newZipCode);
            ctrl.newZipCode = "";
        };

        ctrl.clearAll = function() {
            ctrl.zipList = [];
        };

        ctrl.selectNewZipCode = function(item) {
            ctrl.newZipCode = item.value.toLowerCase();
        };

        function addZipCodeToList(zipCode) {
            if (ctrl.removedMap[zipCode]) {
                ctrl.removedMap[zipCode] = false;
                emitChange();
                return;
            }
            if (ctrl.newMap[zipCode] || ctrl.zipList.indexOf(zipCode) >= 0) {
                emitChange();
                return;
            }
            ctrl.removedMap[zipCode] = false;
            ctrl.newMap[zipCode] = true;
            ctrl.zipList.push(zipCode);
            emitChange();
        }

        ctrl.removeZipCode = function(zipCode) {
            ctrl.removedMap[zipCode] = true;
            ctrl.newMap[zipCode] = false;
            emitChange();
        };

        ctrl.restoreZipCode = function(zipCode) {
            ctrl.removedMap[zipCode] = false;
            emitChange();
        };

        function emitChange() {
            $scope.$emit('unsaved-changes', { zipCode: true, newMap: ctrl.newMap, delMap: ctrl.removedMap });
        }
    }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.profile')
            .component('userInfo', {
                controller: UserInfoCtrl,
                controllerAs: '$ctrl',
                templateUrl: 'app/modules/profile/userInfo/user.info.tpl.html'
            });

    function UserInfoCtrl($scope, $state, $timeout, $window, $log, AuthFactory, gettextCatalog, $rootScope, HttpService, Utils, $ngConfirm, CONSTANTS) {
        var ctrl = this;
        ctrl.locales = CONSTANTS.LOCALES;
        ctrl.utils = Utils;
        ctrl.exampleDate = Date.now();

        ctrl.$onInit = function() {
            ctrl.user = $rootScope.app.Auth.User;
        };

        ctrl.updatePassword = function() {
            var data = {
                email: $rootScope.app.Auth.User.email,
                role: $rootScope.app.Auth.User.role
            };
            AuthFactory.requestPassReset(data).then(function() {
                $ngConfirm({
                    title: gettextCatalog.getString('Reset password'),
                    content: gettextCatalog.getString('Please check your email for password reset instructions.'),
                    buttons: { OK: function() {} }
                });
            });
        };
        ctrl.updatePasswordOld = function() {
            $ngConfirm({
                title: '<h5><i class="fa fa-key"></i> Change Password</h5>',
                contentUrl: 'app/modules/profile/userInfo/change-password.tpl.html',
                backgroundDismiss: false,
                columnClass: 'medium',
                backgroundDismissAnimation: 'shake',
                useBootstrap: true,
                containerFluid: true,
                onScopeReady: function(scope) {
                    scope.payload = { current: '', newpass: '', confirm: '' };

                    $timeout(function() {
                        scope.passForm.NewPassword.$parsers.push(function(pass) {
                            scope.passForm.NewPassword.$setValidity('length', pass.length >= 8);
                            scope.passForm.NewPassword.$setValidity('lower', (/[a-z]/.test(pass)));
                            scope.passForm.NewPassword.$setValidity('capital', (/[A-Z]/.test(pass)));
                            scope.passForm.NewPassword.$setValidity('number', (/[0-9]/.test(pass)));
                            scope.passForm.NewPassword.$setValidity('special', (/[^a-z0-9 ]/i.test(pass)));
                            return pass;
                        });
                    }, 1000);
                },
                buttons: {
                    OK: {
                        btnClass: 'btn-default',
                        keys: ['enter'],
                        text: '<i class="fa fa-check"></i> OK',
                        action: function (scope) {
                            scope.passForm.$setSubmitted();
                            if(scope.passForm.$invalid) {
                                return false;
                            }
                            HttpService.Put('me', { password: scope.payload.newpass }).then(function(){
                                // TODO: add alert for confirmation
                            });
                        }
                    },
                    Close: {
                        btnClass: 'btn-default',
                        text: '<i class="fa fa-times"></i> Cancel',
                        action: function () {
                        }
                    }
                }
            });
        };

        ctrl.getCurrentLanguage = function() {
            return gettextCatalog.getCurrentLanguage();
        };

        ctrl.switchLanguage = function(locale) {
            gettextCatalog.setCurrentLanguage(locale);
            AuthFactory.setupLocale(locale);
            $log.log('Switched translations to: ', locale);
            $scope.$emit('unsaved-changes', {
                userData: { locale: locale }
            });
        };

        ctrl.getCurrentLocaleInfo = function() {
            var currentLocale = gettextCatalog.getCurrentLanguage();
            currentLocale = currentLocale.replace('_', '-');
            var localeFound = Utils.altFind(CONSTANTS.LOCALES, function (locale) {
                return currentLocale.startsWith(locale.code);
            });
            localeFound = localeFound || CONSTANTS.LOCALES[0];
            return localeFound.label;
        }
    }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.profile')
            .component('userProfile', {
                controller: ProfileCtrl,
                controllerAs: 'vm',
                templateUrl: 'app/modules/profile/profile/profile.view.html'
            });

    function ProfileCtrl($state, $scope, $rootScope, $stateParams, $timeout, $window, $templateCache, $log, $uibModal, AuthFactory, gettextCatalog, HttpService, Utils, AlertService) {
        var vm = this;

        vm.user = {};
        vm.utils = Utils;
        vm.lookup = {};
        
        vm.collectionPoints = [];
        vm.zipCodes = [];

        var removedZipMap = {};
        var newZipMap = {};

        vm.$onInit = function() {
            init();
        };

        function init() {
            if (!$rootScope.app.Auth.User) {
              $timeout(init, 1000);
              return;
            }
            vm.currentTab = $stateParams['tab'] || 'userInfo';
            vm.user = $rootScope.app.Auth.User;
            vm.zipCodesMap = {};
            vm.zipCodes = [];
            if (vm.user.supplier.zipCodes && vm.user.supplier.zipCodes.length) {
              vm.user.supplier.zipCodes.forEach(function(zc) {
                vm.zipCodes.push(zc);
                vm.fetchZipCodes(zc, 1).then(function(result) {
                  if (result && result.length) {
                    vm.zipCodesMap[result[0].value] = result[0].label;
                    if (result) {
                      removedZipMap[result[0].value] = result[0].label;
                    }
                  }
                });
              });
            }

            vm.collectionPoints = vm.user.supplier.collectionPoints || [];
            vm.supplierId = vm.user.supplier._id;

            $scope.$on('unsaved-changes', function(e, data) {
                if (data.zipCode) {
                    angular.extend(newZipMap, data.newMap);
                    angular.extend(removedZipMap, data.delMap);
                }
                if (data.userData) {
                    vm.userData = data.userData;
                }
                vm.hasUnsavedChanges = true;
            });
        }

        vm.setTab = function(tab) {
            tab = tab || 'userInfo';
            vm.currentTab = tab;
            $state.go('app.profile.main', { tab: tab }, { inherit : false });
        };

        vm.updateImage = function() {
            
            $uibModal.open({
                animation: true,
                component: 'uploadImage',
                windowClass: 'modal-window',
                size: 'lg',
                resolve: {}
            }).result.then(function (imgUrl) {
                HttpService.Put('suppliers/' + $rootScope.app.Auth.User.supplier._id, { imageUrl: imgUrl }).then(function() {
                    vm.user.supplier.imageUrl = imgUrl;
                });
            });
        };

        vm.updateUserImg = function() {
            $uibModal.open({
                animation: true,
                component: 'uploadImage',
                windowClass: 'modal-window',
                size: 'lg',
                resolve: {}
            }).result.then(function (imgUrl) {
                $scope.$emit('unsaved-changes', {
                    userData: { imageUrl: imgUrl }
                });
            });
        };

        function saveUser(userData) {
            if (userData.locale) {
                vm.user.locale = userData.locale;
                AuthFactory.setupLocale(userData.locale)
            }
            if (userData.imageUrl) {
                vm.user.imageUrl = userData.imageUrl;
            }
            HttpService.Put('me', userData).then(function() {
                AlertService.success(gettextCatalog.getString('Changes saved'));
            });
        }

        vm.submit = function() {
            vm.user.supplier.zipCodes = [];
            var zipCodesData = [];
            vm.zipCodes.forEach(function(z) {
                if (removedZipMap[z] !== true) {
                    zipCodesData.push(z);
                }
            });
            vm.zipCodes = zipCodesData;
            vm.user.supplier.zipCodes = zipCodesData;

            vm.collectionPoints = vm.collectionPoints.filter(function (cp) {
                return !cp.isDeleted;
            });
            vm.user.supplier.collectionPoints = vm.collectionPoints;

            if (vm.userData) {
                saveUser(vm.userData);
            }

            HttpService.Put('suppliers/'+ vm.user.supplier._id, vm.user.supplier).then(function() {
                AlertService.success(gettextCatalog.getString('Changes saved'));
                vm.hasUnsavedChanges = false;
                $scope.$broadcast('changes-saved', {});
            }, function(err) {
                $log.error('Supplier update', err);
            });
        };

        vm.selectNewZipCode = function(item) {
          vm.newZipCode = item.value.toLowerCase();
        };

        vm.fetchZipCodes = function(searchKey, limit) {
            if (!limit) {
                limit = 20;
            }

            var queryParams = {
                api_key: 'TMP_PORTAL_KEY', // TODO wire into HttpService
                country: vm.user.supplier.area,
                search: searchKey,
                limit: limit
            };

            return HttpService.Get('zipcodes', queryParams).then(function(resp) {
                return resp.zipCodes;
            }).catch(function(err) {
                $log.err('Error loading zipcodes', err);
                return [];
            });
        };

        vm.adminUpdateSupplierId = function() {
          var data = { supplier: vm.supplierId };
          HttpService.Put('me', data).then(function() {
            AlertService.success('Supplier ID updated');
            $window.location.reload();
          }, function(err) {
            AlertService.error('Supplier ID update error', ''+err);
          });
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('app.profile')
    .component('collectionPoints', {
      controller: CollectionPointsCtrl,
      controllerAs: '$ctrl',
      templateUrl: 'app/modules/profile/collection.points/collection.points.tpl.html',
      bindings: {
        cpList: '='
      }
    });

  function CollectionPointsCtrl($scope, $rootScope, $timeout, $ngConfirm, Utils, gettextCatalog) {
    var ctrl = this;

    ctrl.utils = Utils;
    ctrl.lookup = {};
    ctrl.user = $rootScope.app.Auth.User;


    ctrl.$onInit = function () {
      init();
    };

    function init() {
      if (!$rootScope.app.Auth.User) {
        $timeout(init, 1000);
        return;
      }
      ctrl.cpList.filter(function (cp) {
        return !cp.addressDetails || !cp.addressDetails.street;
      }).forEach(function (cp) {
        cp.addressDetails = legacyAddressToDetails(cp);
      });
    }

    ctrl.removeRow = function (cp) {
      cp.isDeleted = true;
      emitChange();
    };
    ctrl.restoreRow = function (cp) {
      cp.isDeleted = false;
      emitChange();
    };

    ctrl.addRow = function () {
      ctrl.editRow();
    };

    ctrl.editRow = function(cp) {
      $scope.cp = {};
      if (cp) {
        $scope.cp = angular.copy(cp);
      }
      $ngConfirm({
        icon: 'fa fa-edit',
        title: gettextCatalog.getString('Shop'),
        scope: $scope,
        columnClass: 'small',
        contentUrl: 'app/modules/profile/collection.points/collection-point-edit-prompt.tpl.html',
        buttons: {
          cancel: {
            text: gettextCatalog.getString('Cancel'),
            keys: ['esc'],
            btnClass: 'btn-dark btn-wide'
          },
          ok: {
            text: gettextCatalog.getString('Confirm'),
            btnClass: 'btn-success btn-wide',
            action: function () {
              $timeout(function () {
                if (cp) {
                  cp.name = $scope.cp.name;
                  cp.email = $scope.cp.email;
                  cp.addressDetails = $scope.cp.addressDetails;
                  ctrl.itemUpdated(cp);
                }
                else {
                  ctrl.itemUpdated($scope.cp);
                  ctrl.cpList.push($scope.cp);
                }
              }, 100);
            }
          }
        }
      });
    }

    ctrl.itemUpdated = function (cp) {
      if (cp) {
        cp.address = cp.addressDetails.street + ', ' + cp.addressDetails.zipcode + ' ' + cp.addressDetails.city;
      }
      emitChange();
    };

    ctrl.canAddRow = function () {
      return !ctrl.cpList.length ||
        !ctrl.cpList.some(function (cp) {
          return !cp.name && !cp.address;
        });
    };

    function emitChange() {
      $scope.$emit('unsaved-changes', { collectionPoint: true });
    }

    function legacyAddressToDetails(cp) {
      var addressDetails = {
        street: cp.address,
      };
      var addressParts = cp.address.split(', ');
      if (addressParts.length <= 1) {
        return addressDetails;
      }
      addressDetails.street = addressParts[0];
      addressDetails.city = addressParts[1];

      var cityParts = addressParts[1].split(' ');
      if (cityParts.length <= 1) {
        return addressDetails;
      }
      addressDetails.zipcode = cityParts[0];
      addressDetails.city = cityParts.slice(1).join(' ');
      return addressDetails;
    }
  }
})();

(function(){
    'use strict';

    angular
        .module('app.profile')
        .component('billingInfo', {
            controller: BillingInfoCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/profile/billingInfo/billing-info.tpl.html',
            bindings: {
                billing: '='
            }
        });

    function BillingInfoCtrl($log, $rootScope, $state, $stateParams, $window, Utils, HttpService, gettextCatalog, CONSTANTS) {
        var ctrl = this;
        ctrl.connected = false;
        ctrl.utils = Utils;

        ctrl.$onInit = function() {
            if ($stateParams.code) {
                saveBillingInfo();
            }
        };

        ctrl.connect = function() {
            if (ctrl.billing && ctrl.billing.isEnabled) {
                return;
            }
            $window.location.href = 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=' + CONSTANTS.STRIPE.CONNECT_CLIENT_ID + '&scope=read_write&redirect_uri=' + $window.location.href;
        };

        ctrl.disconnect = function () {
            var confirm = Utils.CreateConfirmation(gettextCatalog.getString('Are you shoure you want to disable FarmHedge payments?'));
            confirm.result.then(function() {
                onDisconnect();
            });
        };

        function onDisconnect() {
            HttpService.Delete('me/billing').then(function() {
                ctrl.billing = { isEnabled: false, enabledAt: null, enabledBy: null };
                $state.go('app.profile.main', { tab: 'billing' }, {inherit:false});
            }, function(err) {
                $log.log(err);
                // TODO: add error message 
            });
        }

        function saveBillingInfo() {
            $log.log('Saving Billing Info');
            $log.log($stateParams.code)
            HttpService.Post('me/billing', { code: $stateParams.code }).then(function(res) {
                $log.log(res);
                ctrl.billing = res.data;
                $rootScope.app.Auth.User.supplier.billing = res.data;
                $state.go('app.profile.main', { tab: 'billing' }, { inherit:false });
            }, function(err) {
                ctrl.billing = { isEnabled: false, enabledAt: null, enabledBy: null };
                // TODO: add error message 
                $log.log(err);
            });
 
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.product')
        .component('productsView', {
            controller: ProductsCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/product/products/products-list.tpl.html'
        });

    function ProductsCtrl($scope, $rootScope, $state, $stateParams, $timeout, $log, $uibModal, $ngConfirm, 
            Utils, HttpService, gettextCatalog, AlertService, DealsService, ProductsService, DEAL_STATUS, DEAL_CATEGORY) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;

        ctrl.products = [];
        ctrl.paging = {
            maxSize: 3,
            itemsPerPage: 10,
            totalItems: 1,
            current: 1
        };
        ctrl.filters = {
            searchText: $stateParams.searchText
        };

        var LS_PRODUCTS_FILTER = 'LS_PRODUCTS_FILTER';

        ctrl.$onInit = function () {
            init();
        };

        function init() {
            if (!$rootScope.app.Auth.User) {
                $timeout(init, 1000);
                return;
            }

            ctrl.allTradersCount = $rootScope.app.Auth.User.supplier.retailers ? $rootScope.app.Auth.User.supplier.retailers.length : 0;
            if ($stateParams.searchText){
                ctrl.filters = { searchText: $stateParams.searchText };
                Utils.setItemLS(LS_PRODUCTS_FILTER, ctrl.filters);
                $state.go('app.products', { searchText: '' });
                return;
            }     
            ctrl.filters = Utils.getItemLS(LS_PRODUCTS_FILTER) || {
                searchText: $stateParams.searchText
            };       

            if (!$rootScope.app.Auth.User) {
                $timeout(ctrl.$onInit, 1000);
                return;
            }
            loadProducts();

            if (Utils.isUserRegionalManager()) {
                ctrl.onBehalfOfUser = $rootScope.app.Auth.User._id;
                HttpService.Get('users?role=COMMERCIAL%20PARTNER&supplier=' + $rootScope.app.Auth.User.supplier._id).then(function (res) {
                    ctrl.supplierAccounts = res.list;
                });
            }
        }

        ctrl.getCurrentPage = function() {
            if (ctrl.products && ctrl.products.length) {
                return ctrl.products[ctrl.paging.current - 1];
            }
            return [];
        };

        ctrl.addNew = function() {
            $uibModal.open({
                animation: true,
                component: 'productEditDialog',
                windowClass: 'modal-window',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    modalData: function() {
                        return { isNew: true, product: {} };
                    }
                }
            }).result.then(function(payload) {
                HttpService.Post('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products', payload).then(function() {
                    AlertService.success(gettextCatalog.getString('Product created'));

                    if (payload.isPushNotificationEnabled) {
                        AlertService.success(gettextCatalog.getString('Notification sent'));
                    }
                    loadProducts();
                });
            });
        };

        ctrl.editProduct = function (product, options) {
            ctrl.selectedProductId = product._id;
            options = options || {};
            $uibModal.open({
                animation: true,
                component: 'productEditDialog',
                windowClass: 'modal-window',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    modalData: function() {
                        return { 
                            isNew: false, 
                            product: product, 
                            focusPrice: options.focusPrice,
                            editDiscount: options.editDiscount,
                        };
                    }
                }
            }).result.then(function(payload) {
                if (!payload) {
                    loadProducts();
                    return;
                }
                Utils.mergeObject(product, payload);
                payload.forceUndefinedValues = true;
                
                HttpService.Put('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products/' + product._id, payload).then(function () {
                    AlertService.success(gettextCatalog.getString('Product updated'));

                    if (payload.isPushNotificationEnabled) {
                        AlertService.success(gettextCatalog.getString('Notification sent'));
                    }
                });
            });
        };

        ctrl.isPublicChanged = function(product) {
            var payload = {
                isPublic: product.isPublic
            };
            HttpService.Put('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products/' + product._id, payload).then(function () {
                if (product.isPublic) {
                    AlertService.success(gettextCatalog.getString('Product updated'));
                    ctrl.countPublic ++;
                }
                else {
                    AlertService.success(gettextCatalog.getString('Product updated'));
                    ctrl.countPublic --;
                }
            });
        };

        ctrl.importProducts = function() {
            $uibModal.open({
                animation: true,
                component: 'productsImportDialog',
                windowClass: 'modal-window',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    modalData: function() {
                        return { list: [] };
                    }
                }
            }).result.then(function(productsData) {
                var payload = { products: productsData };
                HttpService.Post('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products/bulk', payload).then(function () {
                    AlertService.success(productsData.length + ' ' + gettextCatalog.getString('products imported'));
                    loadProducts();
                });
            });
        };

        ctrl.importImages = function () {
            $uibModal.open({
                animation: true,
                component: 'productImagesImportDialog',
                windowClass: 'modal-window',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return { list: [] };
                    }
                }
            });
        };

        ctrl.isProductOwned = function(product) {
            if (!product.supplier || !product.supplier._id) {
                return true;
            }
            return $rootScope.app.Auth.User.supplier._id === product.supplier._id;
        }

        ctrl.isPriceStale = function(product) {
            if (!product.deals || !product.deals.sent || !product.deals.sent.ongoing || !product.deals.sent.ongoing.priceDynamic || 
                !product.deals.sent.ongoing.priceDynamic.isEnabled || !product.deals.sent.ongoing.priceDynamic.nextUpdateAt) {
                return false;
            }
            return moment().isAfter(product.deals.sent.ongoing.priceDynamic.nextUpdateAt);
        }

        ctrl.onPage = function () {
            loadProducts();
        };
        ctrl.searchTextChanged = function () {
            ctrl.paging.current = 1;
            ctrl.onPage();
        };

        ctrl.hasFilters = function () {
            return !!ctrl.filters.searchText;
        }

        ctrl.resetFilters = function () {
            ctrl.filters.searchText = '';
            loadProducts();
        }

        ctrl.editPrice = function (product) {
            ctrl.selectedProductId = product._id;
            if (!product.deals || !product.deals.sent || !product.deals.sent.ongoing) {
                return;
            }
            var deal = product.deals.sent.ongoing;
            var discountSettings = {
                dealSizeOptions: product.dealSizeOptions,
                dealSize: product.stockQuantity,
                benchmarkPrice: deal.benchmarkPrice,
                individualDiscount: deal.individualDiscount || 0,
                clearanceDiscount: deal.clearanceDiscount || deal.individualDiscount || 0,
                quantityDiscountsInput: deal.quantityDiscounts || [],
                priceDecimalDigits: deal.priceDecimalDigits,
                customUnit: product.unit,
                isVatIncluded: deal.isVatIncluded,
                vatRate: deal.vatRate,
                focusPrice: true,
                allowPriceOnRequest: true,
                retailPrices: deal.retailPrices,
            };
            var dialog = $uibModal.open({
                animation: true,
                component: 'DealDiscountOptionsCtrl',
                windowClass: 'modal-window',
                size: 'lg',
                resolve: {
                    discountSettings: function () {
                        return discountSettings;
                    }
                }
            });

            dialog.result.then(function (ds) {
                deal.individualDiscount = ds.individualDiscount;
                deal.clearanceDiscount = ds.clearanceDiscount;
                deal.quantityDiscounts = ds.quantityDiscounts;
                deal.groupDiscount = ds.groupDiscount;
                deal.isVatIncluded = ds.isVatIncluded;
                deal.vatRate = ds.vatRate;
                deal.priceDecimalDigits = ds.priceDecimalDigits;
                
                deal.benchmarkPrice = ds.benchmarkPrice;
                deal.dealSize = ds.dealSize;
                deal.retailPrices = ds.retailPrices;
                
                if (deal.priceDynamic) {
                    deal.priceDynamic.updatedAt = Date.now();
                    deal.priceDynamic.nextUpdateAt = moment().add(1, 'day').set({ hour: 6, minute: 0, second: 0 }).toDate();
                }

                product.deals.sent.ongoing = deal;
                HttpService.Put('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products/' + product._id, product).then(function () {
                    AlertService.success(gettextCatalog.getString('Price updated'));
                    
                    if (ds.retailPricesUsers && ds.retailPricesUsers.length) {
                        promptNewMessageToUers(ds.retailPricesUsers, product.name, $rootScope.app.Auth.User.supplier.name);
                    }
                });
            });
        }

        ctrl.editProductImage = function (product) {
            $uibModal.open({
                animation: true,
                component: 'uploadImage',
                windowClass: 'modal-window',
                size: 'lg',
                resolve: {}
            }).result.then(function (imageUrl) {
                product.imageUrls = product.imageUrls || [];
                product.imageUrls.unshift(imageUrl);

                var payload = { imageUrls: product.imageUrls };
                HttpService.Put('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products/' + product._id, payload).then(function () {
                    AlertService.success(gettextCatalog.getString('Product updated'));
                });
            });
        };

        function updateProduct(product, payload) {
            HttpService.Put('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products/' + product._id, payload).then(function () {
                AlertService.success(gettextCatalog.getString('Product updated'));
            });
        }

        ctrl.addAttachment = function (product) {
            ctrl.editAttachment(product);
        };
        ctrl.editAttachment = function (product, idx) {
            var newAttachment = idx === undefined;
            var descModal = $uibModal.open({
                animation: true,
                component: 'uploadAttachment',
                windowClass: 'modal-window',
                size: 'lg',
                resolve: {
                    attachment: newAttachment ? null : product.attachments[idx]
                }
            });
            descModal.result.then(function (attachmentObj) {
                if (newAttachment) {
                    product.attachments = product.attachments || [];
                    product.attachments.push(attachmentObj);
                    updateProduct(product, { attachments: product.attachments });
                    return;
                }
                product.attachments[idx] = attachmentObj;
                updateProduct(product, { attachments: product.attachments });
            });
        };
        ctrl.removeAttachment = function (product, idx) {
            idx = idx || 0;
            Utils.CreateConfirmation(gettextCatalog.getString('Remove attachment') + ' "' + product.attachments[idx].name + '"')
                .result.then(function () {
                    product.attachments.splice(idx, 1);
                    updateProduct(product, { attachments: product.attachments });
                });
        };

        ctrl.deleteProduct = function (product) {
            Utils.CreateConfirmation(gettextCatalog.getString('Delete product?')).result.then(function () {
                HttpService.Delete('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products/' + product._id).then(function () {
                    AlertService.warning(gettextCatalog.getString('Product deleted.'));
                    loadProducts();
                    if (ctrl.modalInstance) {
                        ctrl.modalInstance.close();
                    }
                });
            });
        };

        ctrl.createNewCropOffer = function (product) {
            var dealData = {
                categoryName: DEAL_CATEGORY.CROP,
                productAttributes: product.attributes,
                cropQuality: product.attributes.map(function (attr) { return attr.label + ': ' + attr.value }).join('; '),
                product: product,
                productName: product.name,
                vendorProductId: product.vendorProductId,
                imageUrl: product.imageUrls[0],
                customType: product.categoryName,
                customUnit: product.unit,
                dealSize: product.stockQuantity,
                dealSizeOptions: product.dealSizeOptions,
                attachements: product.attachements,
                description: product.description,
                skipSelectProductOnInit: true,
            };

            if (product.deals && product.deals.sent && product.deals.sent.ongoing) {
                HttpService.Get('deals/' + product.deals.sent.ongoing._id).then(function (cloneOf) {
                    
                    Utils.mergeObject(cloneOf, dealData);
                    dealData.status = DEAL_STATUS.ACTIVE;
                    dealData.priceDynamic = {};
                    DealsService.cloneDeal(cloneOf);
                });
            }

            DealsService.createNewDraft(dealData);
        }

        ctrl.createNewSaleOffer = function(product) {
            var dealData = {
                product: product,
                productName: product.name,
                vendorProductId: product.vendorProductId,
                imageUrl: product.imageUrls[0],
                customType: product.categoryName,
                customUnit: product.unit,
                dealSize: product.stockQuantity,
                dealSizeOptions: product.dealSizeOptions,
                attachements: product.attachements,
                description: product.description,
                skipSelectProductOnInit: true
            };

            if (product.deals && product.deals.sent && product.deals.sent.ongoing) {
                HttpService.Get('deals/' + product.deals.sent.ongoing._id).then(function (cloneOf) {
                    Utils.mergeObject(cloneOf, dealData);
                    dealData.status = DEAL_STATUS.ACTIVE;
                    dealData.priceDynamic = {};
                    DealsService.cloneDeal(cloneOf);
                });
                return;
            }

            if (product.deals && product.deals.sent && product.deals.sent.latest && product.deals.sent.latest.length) {
                HttpService.Get('deals/' + product.deals.sent.latest[0]._id).then(function (cloneOf) {
                    Utils.mergeObject(cloneOf, dealData);
                    DealsService.cloneDeal(cloneOf);
                });
                return;
            }

            DealsService.createNewDraft(dealData);
        }

        ctrl.duplicateProduct = function(product) {
            var productData = {
                name: product.name + ' (' + gettextCatalog.getString('Copy') + ')',
                categoryName: product.categoryName,
                unit: product.unit,
                stockQuantity: product.stockQuantity,
                dealSizeOptions: product.dealSizeOptions,
                imageUrls: product.imageUrls,
                attachements: product.attachments,
                description: product.description,
            };
            ProductsService.createProduct(productData).then(function () {
                AlertService.success(gettextCatalog.getString('Product copy created'));
                loadProducts();
            });
        }

        ctrl.deleteAllProducts = function() {
            var content = 
                '<p>Are you sure?</p>' + 
                '<p class="alert alert-warning">Check this box to confirm you intend to delete all products: <input type="checkbox" ng-model="isAllProductDeleteConfirmed"></p>';
            $scope.isAllProductDeleteConfirmed = false;
            $ngConfirm({
                title: 'Delete all products',
                scope: $scope,
                content: content,
                animation: 'bottom',
                closeAnimation: 'bottom',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide',
                    },  
                    ok: {
                        text: gettextCatalog.getString('Delete all'),
                        btnClass: 'btn-danger pull-right btn-wide',
                        action: function() {
                            if (!$scope.isAllProductDeleteConfirmed) {
                                return false;
                            }
                            ProductsService.deleteAllProducts().then(function () {
                                AlertService.warning(gettextCatalog.getString('All products deleted'));
                                loadProducts();
                            });
                        }
                    }
                }
            })
        }

        function loadProducts() {
            Utils.setItemLS(LS_PRODUCTS_FILTER, ctrl.filters);

            var queryParams = {
                limit: ctrl.paging.itemsPerPage,
                skip: (ctrl.paging.current - 1) * ctrl.paging.itemsPerPage 
            }
            if (ctrl.filters.searchText) {
                queryParams.searchText = ctrl.filters.searchText;
            }
            HttpService.Get('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products', queryParams).then(function(data) {
                ctrl.products = data.products;
                ctrl.paging.totalItems = data.count;
                ctrl.countPublic = data.countPublic;

                ctrl.products.forEach(function(product) {
                    product.unit = DealsService.getUpdatedUnit(product.unit);
                });
            });
        }

        function promptNewMessageToUers(users, productName, supplierName) {
            ctrl.messageData = {
                toUsers: users,
                subject: gettextCatalog.getString('Price updated') + ' - ' + productName,
                sendEmails: true,
            };
            var link = 'https://' + location.host + '/offers/received?searchText=' + productName;
            setTimeout(function() { // ngConfirm refresh hack
                ctrl.messageData.html = 
                    gettextCatalog.getString('<p>From: {supplierName}</p><p>Product: {productName}</p><br>').replace('{supplierName}', supplierName).replace('{productName}', productName) +
                    gettextCatalog.getString('<p>For details and to order this product:</p>') +
                gettextCatalog.getString('<p><a href="{link}"><strong>Click here</strong></a></p><br>').replace('{link}', link) +
                    gettextCatalog.getString('<p>Thanks,<br>{fullName}</p>').replace('{fullName}', $rootScope.app.Auth.User.name.first + ' ' + $rootScope.app.Auth.User.name.last);
            }, 1);

            $ngConfirm({
                icon: 'fa fa-envelope',
                title: gettextCatalog.getString('Send message'),
                scope: $scope,
                contentUrl: 'app/modules/product/products/templates/update-message.tpl.html',
                columnClass: 'large',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        btnClass: 'btn-dark float-left',
                    },
                    ok: {
                        text: gettextCatalog.getString('Send'),
                        btnClass: 'btn-success btn-wide',
                        action: function () {
                            $timeout(function () {
                                HttpService.Post('messages', ctrl.messageData).then(function () {
                                    AlertService.success(gettextCatalog.getString('Message sent'));
                                }, function () {
                                    AlertService.error(gettextCatalog.getString('Message not sent. Please try again.'));
                                });
                            }, 100);
                        }
                    }
                }
            });
        }
    }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.order', []);
})();
/**
 * Created by Hafeez Rehman on 24/12/2018.
 */

(function () {
    'use strict';

    angular
        .module('app.order')
        .component('ordersView', {
            controller: OrderCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/order/orders/orders-view.tpl.html'
        });

    function OrderCtrl($rootScope, $state, $stateParams, $log, $uibModal, $timeout, HttpService, Utils, ProductsService, DealsService, gettextCatalog, 
            ORDER_STATUS, DEAL_CATEGORY) {
        var ctrl = this;

        ctrl.utils = Utils;
        ctrl.productsService = ProductsService;
        ctrl.ORDER_STATUS = ORDER_STATUS;
        ctrl.DEAL_CATEGORY = DEAL_CATEGORY;
        ctrl.paging = { current: 1, maxSize: 3, itemsPerPage: 10 };
        ctrl.filters = {};

        var requestParams;
        var ORDERS_FILTER = 'ORDERS_FILTER';

        ctrl.ORDER_ROLES = {
            DISTRIBUTOR: 'DISTRIBUTOR',
            RETAILER: 'RETAILER'
        };
        ctrl.ORDER_TYPES = {
            ANY: 'ANY',
            SALE: 'SALE',
            PURCHASE: 'PURCHASE'
        };

        ctrl.$onInit = function () {
            ctrl.filters = Utils.getItemLS(ORDERS_FILTER) || {
                type: ctrl.ORDER_TYPES.ANY,
                role: ctrl.ORDER_ROLES.DISTRIBUTOR,
                ref: null,
                hideCompleted: false
            };
            if (!Utils.getSettings().canReceiveOffers) {
                ctrl.filters.role = ctrl.ORDER_ROLES.DISTRIBUTOR;
            }
            else if ($stateParams.role) {
                ctrl.filters.role = $stateParams.role;
            }
            else if (!ctrl.filters.role) {
                ctrl.filters.role = ctrl.ORDER_ROLES.DISTRIBUTOR;
            }
            
            if ($stateParams.type) {
                ctrl.filters.type = $stateParams.type;
            }
            else if (!ctrl.filters.type) {
                ctrl.filters.type = ctrl.ORDER_TYPES.ANY;
            }
            if ($stateParams.ref) {
                ctrl.filters.ref = $stateParams.ref;
                ctrl.filters.hideCompleted = false;
            }
            ctrl.user = null;
            if ($stateParams.orderId) {
                ctrl.selectedOrderId = $stateParams.orderId;
            }
            loadOrders();

            if ($state.params.startIntro) {
                $timeout(ctrl.startIntro, 1000);
            }
        };

        ctrl.startIntro = function() {
            if (!ctrl.orders.length) {
                ctrl.isTestOrderEnabled = true;
                ctrl.orders.unshift(ctrl.getExampleOrder());
            }
            $timeout(function() {
                Utils.startIntro([
                    {
                        element: '#order-list-tabs',
                        intro: gettextCatalog.getString('When you receive an order from a customer, you will be notified by email.'),
                    },
                    {
                        element: '#order-list-export',
                        intro: gettextCatalog.getString('You can export all your orders for integration with other software.'),
                    },
                    {
                        element: '#order-list-row-0',
                        intro: gettextCatalog.getString('Click on one of the orders to display the order details.'),
                    }
                ], {
                    text: gettextCatalog.getString('Open order details'),
                    action: function () {
                        openOrderModal(ctrl.orders[0], null, true);
                    }
                });
            }, 100);
        }

        ctrl.switchTo = function(params) {
            $state.go('app.orders', params);   
        }

        ctrl.selectOrder = function (order) {
            ctrl.selectedOrderId = order._id;

            if (order.request) {
                ctrl.viewRequestDetails(order);
                return;
            }
            
            if (order.status === ORDER_STATUS.PENDING && order.deal && order.deal.distributorDeal) {
                // FIXME: Modal does not support "Forward" functionality yet. Supproted by report page.
                $state.go('app.deals.report', {
                    id: order.deal._id,
                    order: order._id,
                });
                return;
            }

            if (order.deal) {
                HttpService.Get('deals/' + order.deal._id || order.deal).then(function (deal) {
                    openOrderModal(order, deal);
                });
                return;
            }
            
            openOrderModal(order);
        };

        function openOrderModal(order, deal, startIntro) {
            $uibModal.open({
                animation: true,
                component: 'orderDetailsModal',
                size: 'lg',
                windowClass: 'modal-window',
                resolve: {
                    modalData: function () {
                        return {
                            deal: deal,
                            user: order.user,
                            order: order,
                            startIntro: startIntro,
                            showDealLink: true
                        };
                    }
                }
            });
        }

        ctrl.viewRequestDetails = function (order) {
            var requestId = order.request._id;
            HttpService.Get('requests/' + requestId).then(function (data) {
                var request = data;
                $uibModal.open({
                    animation: true,
                    controller: 'RequestDetailsCtrl',
                    templateUrl: 'app/shared/templates/modals/request-details.tpl.html',
                    template: Utils.getTemplate('app/shared/templates/modals/request-details.tpl.html'),
                    size: 'lg',
                    windowClass: 'modal-window',
                    resolve: {
                        items: function () {
                            return {
                                request: request,
                                isCropRequest: false
                            };
                        }
                    }
                });
            });
        };

        ctrl.onPage = function () {
            loadOrders();
        };

        ctrl.refChanged = function () {
            $state.go('app.orders', { ref: '' });
            loadOrders();
        };

        ctrl.getLocalizedOrderStatus = function(order) {
            if (!order.status || order.status === ORDER_STATUS.PENDING || order.status === ORDER_STATUS.VIEWED) {
                return gettextCatalog.getString('Pending');
            }
            if (order.status === ORDER_STATUS.PAID) {
                return gettextCatalog.getString('Paid')
            }
            if (order.status === ORDER_STATUS.COMPLETED) {
                return gettextCatalog.getString('Completed')
            }
            if (order.status === ORDER_STATUS.FORWARDED) {
                return gettextCatalog.getString('Forwarded')
            }
            if (order.status === ORDER_STATUS.INVALID) {
                return gettextCatalog.getString('Invalid')
            }
            if (order.status === ORDER_STATUS.RESERVED) {
                return gettextCatalog.getString('Reserved')
            }
            if (order.status === ORDER_STATUS.REJECTED) {
                return gettextCatalog.getString('Rejected')
            }
        };

        ctrl.exportOrders = function() {
            $uibModal.open({
                animation: true,
                component: 'exportOrders',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    modalData: function () {
                        return { count: ctrl.paging.count, params: requestParams };
                    }
                }
            });
        };

        ctrl.getCustomers = function(namePart) {
            var payload = {
                limit: 20
            };
            if (namePart) {
                payload.name = namePart;
            }
            return HttpService.Get('users', payload).then(function(res) {
                var custList = [];
                res.list.forEach(function(u) {
                    u.full = u.name.first + ' ' + u.name.last;
                    custList.push(u);
                });
                return custList;
            }, function(err) {
                $log.err(err);
            });
        };

        ctrl.getRetailers = function (namePart) {
            if (!namePart) {
                return $rootScope.app.Auth.User.supplier.retailers.slice(0, 5);
            }
            namePart = namePart.toLowerCase();
            return $rootScope.app.Auth.User.supplier.retailers.filter(function (retailer) {
                var nameMatch = retailer.name.toLowerCase().indexOf(namePart) >= 0;
                if (nameMatch) {
                    return true;
                }
                return retailer.accounts.some(function(account) {
                    return (account.name.first + ' ' + account.name.last).toLowerCase().indexOf(namePart) >= 0;
                });
            }).slice(0, 5);
        };

        ctrl.customerSelected = function (cust) {
            ctrl.user = cust;
            loadOrders();
        };
        ctrl.checkSelectionUser = function () {
            if (!ctrl.userName) {
                ctrl.user = null;
                loadOrders();
            }
        };

        ctrl.productSelected = function (product) {
            ctrl.product = product;
            loadOrders();
        };

        ctrl.checkSelectionProduct = function () {
            ctrl.product = null;
            loadOrders();
        };

        ctrl.onSelectRetailer = function (retailer) {
            ctrl.retailer = retailer;
            loadOrders();
        };
        ctrl.checkSelectionRetailer = function () {
            if (!ctrl.retailerName) {
                ctrl.retailer = null;
                loadOrders();
            }
        };

        ctrl.toggleHideCompleted = function () {
            loadOrders();
        };

        ctrl.hasFilters = function() {
            return ctrl.filters.type !== ctrl.ORDER_TYPES.ANY || ctrl.filters.ref || ctrl.filters.dateFrom || ctrl.filters.dateTo ||
                ctrl.userName || ctrl.retailerName || ctrl.productName;
                
        }

        ctrl.resetFilters = function () {
            ctrl.filters.type = ctrl.ORDER_TYPES.ANY;
            ctrl.filters.ref = '';
            ctrl.filters.dateFrom = undefined;
            ctrl.filters.dateTo = undefined;
            ctrl.userName = '';
            ctrl.user = null;
            ctrl.retailerName = '';
            ctrl.retailer = null;
            ctrl.productName = null;
            ctrl.product = null;
            $state.go('app.orders', { type: ctrl.filters.type, ref: '' });
            loadOrders();
        };

        function loadOrders() {
            Utils.setItemLS(ORDERS_FILTER, ctrl.filters);

            var queryParams = {
                skip: ((ctrl.paging.current - 1) * ctrl.paging.itemsPerPage),
                limit: ctrl.paging.itemsPerPage,
            };

            if (ctrl.filters.role) {
                queryParams.role = ctrl.filters.role;
            }
            if (ctrl.filters.ref) {
                queryParams.ref = ctrl.filters.ref;
            }
            if (ctrl.filters.type) {
                queryParams.type = ctrl.filters.type;
            }
            if (ctrl.filters.hideCompleted) {
                queryParams.hideCompleted = ctrl.filters.hideCompleted;
            }
            if (ctrl.user) {
                queryParams.user = ctrl.user._id;
            }
            if (ctrl.retailer) {
                queryParams.retailer = ctrl.retailer._id;
            }

            if (ctrl.product) {
                queryParams.product = ctrl.product._id;
            }
            else if (ctrl.productName && !ctrl.product) {
                queryParams.productName = ctrl.productName;
            }
            
            if (ctrl.filters.dateFrom) {
                queryParams.dateFrom = moment(ctrl.filters.dateFrom).startOf('day').toISOString();
            }
            if (ctrl.filters.dateTo) {
                queryParams.dateTo = moment(ctrl.filters.dateTo).endOf('day').toISOString();
            }

            if (queryParams.type === ctrl.ORDER_TYPES.ANY) {
                delete queryParams.type;
            }

            ctrl.stats = null;
            requestParams = angular.copy(queryParams);
            HttpService.Get('me/orders', queryParams).then(function (res) {
                ctrl.paging.count = res.count;
                ctrl.orders = res.orders;
                ctrl.stats = res.stats;

                ctrl.orders.forEach(function(order) {
                    if (order.deal) {
                        order.deal.customUnit = DealsService.getUpdatedUnit(order.deal.customUnit);
                    }
                    
                    order.isRetailerOrder = ctrl.filters.role === ctrl.ORDER_ROLES.RETAILER;
                    order.isCrop = order.categoryName === DEAL_CATEGORY.CROP;
                    order.isPurchase = order.isRetailerOrder ? !order.isCrop : order.isCrop;

                    if (order.childrenOrders && order.childrenOrders.length) {
                        order.childrenProductNames = order.childrenOrders.map(function(order) {
                            return order.productName;
                        }).join(', ')
                    }
                });
            }, function (err) {
                $log.log(err);
            });
        }

        ctrl.toggleDate = function() {
            if (!ctrl.filters.dateTo) {
                ctrl.filters.dateFrom = moment().add(-1, 'day').toDate();
                ctrl.filters.dateTo = new Date();
            }
            else {
                ctrl.filters.dateFrom = undefined;
                ctrl.filters.dateTo = undefined;
            }
            loadOrders();
        }

        ctrl.filterDateChanged = function() {
            if (ctrl.filters.date && !ctrl.filters.date.isValid()) {
                ctrl.filters.date = null;
            }
            ctrl.onPage();
        }

        ctrl.getExampleOrder = function() {
            // TODO: move to Intro Service
            return {
                isExample: true,
                "status": "PENDING",
                "user": {
                    "_id": "5f60d64bc95d0b00160ea7de",
                    "email": "customer@email.com",
                    "phoneNumber": "123123123",
                    "name": {
                        "last": "Smith",
                        "first": "James"
                    }
                },
                "supplier": {
                    "_id": $rootScope.app.Auth.User.supplier._id,
                    "name": $rootScope.app.Auth.User.supplier.name,
                    "type": "DISTRIBUTOR",
                    "currencySymbol": "€"
                },
                "retailer": {
                    "_id": "123",
                    "name": "YourCustomer"
                },
                "totalPrice": 1010,
                "currencySymbol": "€",
                "billingAddress": {
                    "name": "Peter Smith",
                    "street": "75 Road",
                    "zipcode": "68765",
                    "city": "Graz"
                },
                "deliveryAddress": {
                    "name": "Peter Smith",
                    "street": "75 Road",
                    "zipcode": "68765",
                    "city": "Graz"
                },
                "date": "2020-09-15T15:32:42.894Z",
                "amount": 0,
                "childrenOrders": [
                    {
                        "_id": "5f60de9af707ab0016e828f4",
                        "productName": "Example product 1",
                        "vendorProductId": "Test1",
                        "categoryName": "DEAL",
                        "customType": "Winter wheat",
                        "customUnit": "ton",
                        "priceDecimalDigits": 2,
                        "isVatIncluded": false,
                        "imageUrl": "https://fh-data-1.s3.eu-west-1.amazonaws.com/1549910391272default_offer_image.png",
                        "paymentMethod": "CIP",
                        "currencySymbol": "€",
                        "totalPrice": 405,
                        "attachments": [
                            {
                                "url": "https://fh-attachments.s3.eu-west-1.amazonaws.com/1600183928619_FH_Tech_Update_-_2019_Mar_13.pdf",
                                "name": "FH Tech Update - 2019 Mar 13.pdf",
                                "_id": "5f60de7ff707ab0016e828f1",
                                "$$hashKey": "object:281"
                            }
                        ],
                        "amount": 1,
                        "productAttributes": [],
                        "$$hashKey": "object:273"
                    },
                    {
                        "_id": "5f60de9af707ab0016e828f6",
                        "productName": "WINTERGOLD",
                        "vendorProductId": "Example product 2",
                        "categoryName": "DEAL",
                        "customType": "Winter Durum",
                        "customUnit": "ton",
                        "priceDecimalDigits": 2,
                        "currencySymbol": "€",
                        "totalPrice": 605,
                        "attachments": [],
                        "amount": 1,
                        "productAttributes": [
                            {
                                "label": "Category",
                                "value": "C1",
                                "_id": "5f33e76e73a8ec00161076b3",
                                "$$hashKey": "object:285"
                            },
                            {
                                "label": "Treatment",
                                "value": "Redigo Pro",
                                "_id": "5f33e76e73a8ec00161076b2",
                                "$$hashKey": "object:286"
                            }
                        ],
                        "$$hashKey": "object:274"
                    }
                ],
                "__v": 1,
                "ref": "EXAMPLE-ORDER-1",
                "isRetailerOrder": false,
                "isCrop": false,
                "isPurchase": false,
                "childrenProductNames": "Example product 1, Example product 2",
                "$$hashKey": "object:68",
                "inShoppingCart": false
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.order')
        .component('orderView', {
            controller: OrderCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/order/order-modal-external/order-modal-external.tpl.html',
            bindings: { 'baseData': '<' }
        });

    function OrderCtrl($stateParams, gettextCatalog, $ngConfirm, HttpService, Utils, DealsService, AuthFactory, ORDER_STATUS, DEAL_CATEGORY) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;
        ctrl.ORDER_STATUS = ORDER_STATUS;

        ctrl.$onInit = function () {
            ctrl.order = false;
            verifyAccessCode();
        };

        function verifyAccessCode() {
            $ngConfirm({
                title: '',
                contentUrl: 'app/modules/order/templates/passcode.html',
                theme: 'supervan',
                buttons: {
                    submit: {
                        text: gettextCatalog.getString('Continue'),
                        btnClass: 'btn-green',
                        keys: ['enter'],
                        action: function() {
                            var pass = $('input[name="passcode"]').val();
                            if(!pass || pass === '') {
                                $('.pass-error span.error-text').innerText = gettextCatalog.getString('Passcode is required.');
                                $('.pass-error').fadeIn();
                                return false;
                            }
                            AuthFactory.setupLocale();
                            loadOrder(pass);
                        }
                    }
                },
                onReady: function() {
                    $('.ng-confirm-content-pane').addClass('pane-height-auto');
                    $('input[name="passcode"]').focus();
                }
            });
        }

        function passInvalid() {
            $ngConfirm({
                icon: 'fa fa-times-circle',
                title: gettextCatalog.getString('Invalid pincode'),
                content: '',
                theme: 'modern',
                buttons: {
                    submit: {
                        text: gettextCatalog.getString('Ok'),
                        btnClass: 'btn-green',
                        action: function () {
                            verifyAccessCode();
                        }
                    }
                }
            });
        }

        function loadOrder(code) {
            var body = { data: { token: $stateParams.token, passcode: code }};
            ctrl.order = false;
            HttpService.Post('orders/shared/' + ctrl.baseData.id, body).then(function(res) {
                ctrl.order = res.data.order;
                ctrl.order.isCrop = ctrl.order.categoryName === DEAL_CATEGORY.CROP;
                ctrl.order.isPurchase = ctrl.order.isRetailerOrder ? !ctrl.order.isCrop : ctrl.order.isCrop;

                ctrl.deal = res.data.deal;
                ctrl.distributorDeal = res.data.distributorDeal;
                ctrl.order.transactionAmount = ctrl.order.totalPrice || (ctrl.order.unitPrice * ctrl.order.amount);
                ctrl.validated = true;
            }, function() {
                passInvalid();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.order')
        .component('orderDetailsModal', {
            controller: OrderDetailsModalCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/order/order-details-modal/order-details-modal.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function OrderDetailsModalCtrl($scope, $rootScope, $ngConfirm, $window, $timeout,
        Utils, HttpService, AlertService, DealsService, gettextCatalog, ORDER_STATUS) {
        var ctrl = this;

        $scope.utils = Utils;
        $scope.DealsService = DealsService;
        $scope.ORDER_STATUS = ORDER_STATUS;

        var LS_ORDER_FORWARD_EMAIL = 'LS_ORDER_FORWARD_EMAIL';
        var LS_ORDER_FORWARD_PASSCODE = 'LS_ORDER_FORWARD_PASSCODE';
        var LS_ORDER_NOTIFICATION_ENABLED = 'LS_ORDER_NOTIFICATION_ENABLED';

        ctrl.$onInit = function () {
            var items = ctrl.resolve.modalData;
            $scope.order = items.order;
            $scope.deal = items.deal;
            $scope.user = items.user;
            $scope.showDealLink = items.showDealLink;

            if (!$scope.order.isRetailerOrder) {
                $scope.order.isPurchase = DealsService.isCategoryCrop($scope.deal);
            }

            if (!$scope.order.user) {
                ctrl.modalInstance.dismiss('cancel');
            }

            var userId = $scope.order.user._id || $scope.order.user;
            HttpService.Get('users/' + userId).then(function (res) {
                $scope.order.user = res.user;
            });

            $scope.order.inShoppingCart = !!Utils.altFind(Utils.getShoppingCart().items, function (item) {
                return item.order && item.order._id === $scope.order._id;
            });
            $scope.isLegacyOrderObject = moment('15/06/2019', 'DD/MM/YYYY').isAfter(moment($scope.order.date));

            if (items.startIntro) {
                $timeout($scope.startIntro, 500);
            }
        }

        function performShareOrder(email, passcode) {
            var payload = {
                email: email,
                passcode: passcode,
                page: 'order'
            }
            HttpService.Post('orders/' + $scope.order._id + '/share', payload).then(function (res) {
                res.data
            }).then(function () {
                $ngConfirm({
                    icon: 'fa fa-check-circle',
                    title: gettextCatalog.getString('Order shared'),
                    type: 'green',
                    content: gettextCatalog.getString('An email was sent to') + ': ' + email + '<br>' +
                        gettextCatalog.getString('Pincode') + ': ' + passcode,
                    buttons: { OK: function () { } }
                });
            });
        }

        $scope.shareOrder = function () {
            $scope.sharedOrder = {};
            $scope.sharedOrder.passcode = $window.localStorage.getItem(LS_ORDER_FORWARD_PASSCODE) || ('' + (Math.floor(1000 + Math.random() * 9000)));
            $scope.sharedOrder.email = $window.localStorage.getItem(LS_ORDER_FORWARD_EMAIL);

            $scope.loading = false;
            $scope.supplierShops = $rootScope.app.Auth.User.supplier.collectionPoints;
            if ($scope.supplierShops && $scope.supplierShops.length) {
                $scope.supplierShops = $scope.supplierShops.filter(function (shop) {
                    return shop.email;
                });
            }

            $ngConfirm({
                icon: 'fa fa-share-alt',
                title: gettextCatalog.getString('Share order'),
                scope: $scope,
                columnClass: 'small',
                contentUrl: 'app/shared/templates/prompts/share-order.tpl.html',
                animation: 'bottom',
                closeAnimation: 'bottom',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark',
                    },
                    ok: {
                        text: gettextCatalog.getString('Share'),
                        keys: ['enter'],
                        btnClass: 'btn-success btn-wide',
                        action: function (scope) {
                            $window.localStorage.setItem(LS_ORDER_FORWARD_EMAIL, scope.sharedOrder.email);
                            $window.localStorage.setItem(LS_ORDER_FORWARD_PASSCODE, scope.sharedOrder.passcode);
                            performShareOrder(scope.sharedOrder.email, scope.sharedOrder.passcode);
                        }
                    }
                }
            });
        };

        $scope.markAs = function (status) {
            if (status === ORDER_STATUS.FORWARDED) {
                $scope.newOrder();
                return;
            }

            var title = gettextCatalog.getString('Complete order');
            var btnClass = 'btn-success';

            if (status === ORDER_STATUS.REJECTED) {
                title = gettextCatalog.getString('Reject order');
                btnClass = 'btn-danger';
            }

            ctrl.status = status;
            ctrl.messageText = '';

            var lsKey = LS_ORDER_NOTIFICATION_ENABLED + '_' + status;
            ctrl.isMessageEnabled = Utils.getItemLS(lsKey);
            if (ctrl.isMessageEnabled === null && status === ORDER_STATUS.REJECTED) {
                ctrl.isMessageEnabled = true;
            }

            $ngConfirm({
                icon: 'fa fa-exclamation-triangle',
                title: title,
                scope: $scope,
                contentUrl: 'app/modules/order/order-details-modal/order-action-prompt.tpl.html',
                columnClass: 'small',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        btnClass: 'btn-dark float-left',
                    },
                    ok: {
                        text: gettextCatalog.getString('Confirm'),
                        btnClass: btnClass + ' btn-wide',
                        action: function () {
                            $timeout(function() {
                                Utils.setItemLS(lsKey, ctrl.isMessageEnabled);

                                var orderData = {
                                    data: {
                                        status: status,
                                        isMessageEnabled: ctrl.isMessageEnabled,
                                        messageText: ctrl.messageText,
                                    }
                                };

                                $scope.order.status = status;
                                $scope.order.updatedAt = moment();
                                $scope.order.updatedBy = $rootScope.app.Auth.User;
                                if (ctrl.isMessageEnabled) {
                                    $scope.order.messages = $scope.order.messages || [];
                                    $scope.order.messages.push({
                                        createdBy: { name: $rootScope.app.Auth.User.name },
                                        text: ctrl.messageText,
                                        isSupplier: true
                                    });
                                }

                                HttpService.Put('orders/' + $scope.order._id, orderData).then(function () {
                                    AlertService.success(gettextCatalog.getString('Order updated'));
                                });
                            }, 100);
                        }
                    }
                }
            });
        };

        $scope.newOrder = function () {
            ctrl.modalInstance.close({ newOrder: true });
        };

        $scope.ok = function () {
            ctrl.modalInstance.close($scope.order);
        };

        $scope.cancel = function () {
            ctrl.modalInstance.dismiss('cancel');
        };

        $scope.startIntro = function() {
            Utils.startIntro([
                {
                    element: '#order-details-container',
                    intro: gettextCatalog.getString('All the information you need about the order is here.'),
                },
                {
                    element: '#order-details-control',
                    intro: gettextCatalog.getString('You can reject or complete an order.'),
                },
                {
                    element: '#order-details-share',
                    intro: gettextCatalog.getString('You can also send the order details by email.'),
                }
            ], {
                text: gettextCatalog.getString('Done'),
                action: function() {
                    if ($scope.order.isExample) {
                        $scope.cancel();
                    }
                }
            });
        }
    }
})();

/**
 * Created by Hafeez Rehman on 06/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.offers', []);
})();

(function () {
    'use strict';

    angular.module('app.offers').component('searchOffers', {
        controller: SearchOffersCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/modules/offers/search/search.offers.tpl.html'
    });

    function SearchOffersCtrl($scope, $state, $rootScope, $stateParams, $uibModal, $ngConfirm, $timeout, gettextCatalog, 
        Utils, HttpService, AlertService, ProductsService, DealsService, ORDER_STATUS) {
        var ctrl = this;

        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;
        ctrl.shoppingCart = Utils.getShoppingCart();
        ctrl.withPriceOnly = false;

        ctrl.$onInit = function () {
            init();
        };

        function init() {
            if (!$rootScope.app.Auth.User) {
                $timeout(init, 500);
                return;
            }
            ctrl.searchText = $stateParams.searchText;
            searchOffers(true);

            ctrl.shoppingCart.items.forEach(function (item, idx) {
                if ((item.request && item.request._id === $state.params.requestId) ||
                    (item.order && item.order._id === $state.params.orderId)) {
                    ctrl.selectedShoppingCartIdx = idx;
                }
            });
            
        }

        function searchOffers(focusSearchText) {
            ctrl.isLoading = true;
            var payload = {
                categoryNames: ['buy'],
                limit: 50
            };
            if (ctrl.searchText) {
                payload.query = ctrl.searchText;
            }
            if (ctrl.withPriceOnly) {
                payload.withPriceOnly = true;
            }
            HttpService.Get('me/deals/search', payload).then(function (res) {
                ctrl.isLoading = false;
                ctrl.searchResult = res.deals;
                ctrl.searchResult.forEach(function (deal) {
                    deal.lastOrderAt = deal.orders.length ? Math.max.apply(Math, deal.orders.map(function (order) {
                        return moment(order.date);
                    })) : undefined;
                });

                if (focusSearchText) {
                    document.getElementById('searchText').focus();
                }
            });
        }

        ctrl.tabClicked = function () {
            $state.go('app.offers.incoming');
        }

        ctrl.searchCategory = function (category) {
            ctrl.searchText = category;
            window.scroll(0, 0);
            searchOffers();
        }

        ctrl.resetSearchText = function() {
            ctrl.searchText = '';
            searchOffers();
        }

        ctrl.onPage = function() {
            searchOffers();
        };

        function placeOrder(orderData, cartItem, cartIdx) {
            HttpService.Post('me/deals/' + orderData.deal._id + '/orders', orderData).then(function () {
                searchOffers();
                AlertService.success(
                    gettextCatalog.getString('Order placed'),
                    gettextCatalog.getString('For details, go to the "Orders" page from the main menu.'));
                if (cartItem && cartIdx !== undefined) {
                    ctrl.removeFromShoppingCart(cartItem, cartIdx);
                }
            }).catch(function () {
                AlertService.error(gettextCatalog.getString('Error while creating order. Please try again.'));
            });
        }

        ctrl.newOrder = function (deal) {
            $uibModal.open({
                animation: true,
                component: 'newOrder',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    modalData: function () {
                        return {
                            deal: deal,
                        };
                    }
                }
            }).result.then(function (orderData) {
                orderData.deal = deal;
                placeOrder(orderData);
            });
        };

        function sendRequest(requestData) {
            HttpService.Post('me/requests', requestData).then(function () {
                searchOffers();
                AlertService.success(
                    gettextCatalog.getString('Request sent'),
                    gettextCatalog.getString('For details, go to the "Requests" page.'));
            }).catch(function () {
                AlertService.error(gettextCatalog.getString('Error while sending request. Please try again.'));
            });
        }

        ctrl.newRequest = function (deal) {
            $uibModal.open({
                animation: true,
                component: 'newRequest',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    modalData: function () {
                        return {
                            deal: deal,
                            category: ctrl.searchText
                        };
                    }
                }
            }).result.then(function (requestData) {
                if (deal) {
                    requestData.deals = [deal._id];
                }
                sendRequest(requestData);
            });
        };

        ctrl.newOrderFromShoppingCart = function(item, idx) {
            var order = item.order || {
                amount: item.quantity
            };
            var user;
            if (item.request && item.request.createdBy && !item.order) {
                order.deliveryAddress = item.request.createdBy.address;
                user = item.request.createdBy;
            }
            if (item.order) {
                user = item.order.user;
            }

            $uibModal.open({
                animation: true,
                component: 'newOrder',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    modalData: function () {
                        return {
                            deal: item.deal,
                            user: user,
                            order: order
                        };
                    }
                }
            }).result.then(function (orderData) {
                orderData.deal = item.deal;
                if (item.request) {
                    HttpService.Post('requests/' + item.request._id + '/orders', {
                        amount: orderData.amount,
                        unitPrice: item.customerPrice,
                        productName: item.deal.product.name,
                        categoryName: item.deal.categoryName
                    }).then(function (res) {
                        orderData.retailerOrder = res.data.order._id;
                        placeOrder(orderData, item, idx);
                    });  
                    return;
                }
                if (item.order) {
                    HttpService.Put('orders/' + item.order._id, { data: {
                        status: ORDER_STATUS.FORWARDED
                    }}).then(function () {
                        orderData.retailerOrder = item.order._id;
                        placeOrder(orderData, item, idx);
                    });
                    return;
                }
                placeOrder(orderData, item, idx);
            });
        }

        ctrl.goToOrders = function (deal) {
            if (!deal.userBooking) {
                return;
            }
            var refs = deal.orders.map(function (order) {
                return order.ref;
            }).join(',');
            $state.go('app.orders', { role: 'RETAILER', type: '', ref: refs });
        };

        ctrl.isInShoppingCart = function(deal) {
            return !!Utils.altFind(ctrl.shoppingCart.items, function(item) {
                return item.deal && item.deal._id === deal._id;
            });
        };
        ctrl.addToShoppingCart = function(deal) {
            ctrl.shoppingCart.items = ctrl.shoppingCart.items || [];
            var existingItem;
            var existingItemIdx;
            ctrl.shoppingCart.items.forEach(function(item, idx) {
                if (item.deal && item.deal._id === deal._id) {
                    existingItem = item;
                    existingItemIdx = idx;
                }
            });
            if (!existingItem) {
                ctrl.shoppingCart.items.push({
                    deal: deal,
                    quantity: deal.dealSizeOptions ? (deal.dealSizeOptions.min || 1) : 1,
                    createdAt: Date.now()
                });
                ctrl.selectedShoppingCartIdx = ctrl.shoppingCart.items.length - 1;
                AlertService.success(gettextCatalog.getString('Added to shopping cart'));
            }
            else {
                existingItem.quantity += deal.dealSizeOptions ? (deal.dealSizeOptions.step || 1) : 1;
                existingItem.quantity = Math.round(existingItem.quantity * 100)/100;
                ctrl.selectedShoppingCartIdx = existingItemIdx;
            }
            Utils.saveShoppingCart(ctrl.shoppingCart);
        };
        ctrl.increaseQuantityShoppingCart = function(item) {
            item.quantity ++;
        };
        ctrl.decreaseQuanttiyShoppingCart = function (item) {
            if (item.quantity === 1) {
                return;
            }
            item.quantity --;
        };
        ctrl.removeFromShoppingCart = function (item, idx) {
            Utils.CreateConfirmation(
                item.deal.product.name + '<br>' + item.deal.vendorProductId, 
                gettextCatalog.getString('Remove from cart')).result.then(function(){
                    ctrl.shoppingCart.items.splice(idx, 1);
                    Utils.saveShoppingCart(ctrl.shoppingCart);
            });  
        };

        function getValidQuantity(quantity, deal) {
            var minQt = deal.dealSizeOptions ? (deal.dealSizeOptions.min || 1) : 1;
            var stepQt = deal.dealSizeOptions ? (deal.dealSizeOptions.min || 1) : 1;
            if (quantity < minQt) {
                quantity = minQt;
            }
            if (Math.round((quantity % stepQt) * 100) / 100 !== 0) {
                quantity = Math.floor(quantity / deal.dealSizeOptions.step) * deal.dealSizeOptions.step;
            }
            return Math.round(quantity * 100) / 100;
        }

        ctrl.changeShoppingCartQuantity = function(item) {
            ctrl.quantity = item.quantity;
            var content = '<p>' + item.deal.product.name + '</p>' +
                '<p>' + 
                '<div class="input-group">' +
                '<span class="input-group-addon">' + item.deal.customUnit + '</span>' +
                '<input autocomplete="off" autofocus type="number" ng-model="$ctrl.quantity" id="quantity" name="quantity" placeholder="" class="form-control">' +
                '</div></p>';
            $ngConfirm({
                title: gettextCatalog.getString('Quantity'),
                scope: $scope,
                content: content,
                animation: 'bottom',
                closeAnimation: 'bottom',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide',
                    },
                    ok: {
                        text: gettextCatalog.getString('Ok'),
                        keys: ['enter'],
                        btnClass: 'btn-success btn-wide',
                        action: function() {
                            $scope.$apply(function() {
                                item.quantity = getValidQuantity(ctrl.quantity, item.deal);
                                Utils.saveShoppingCart(ctrl.shoppingCart);
                            });                            
                        }
                    }
                }
            });
        };

        ctrl.getTotalInCart = function() {
            var total = 0;
            ctrl.shoppingCart.items.forEach(function(item) {
                total += item.deal.benchmarkPrice * item.quantity;
            });
            return total;
        };

        ctrl.getQuantityInCart = function() {
            var total = 0;
            ctrl.shoppingCart.items.forEach(function (item) {
                total += item.quantity;
            });
            return total;
        }
        
        ctrl.copyProduct = function(deal) {
            var productData = {
                name: deal.product.name + ' (' + gettextCatalog.getString('Copy') + ')',
                vendorProductId: deal.vendorProductId,
                imageUrls: [deal.imageUrl],
                categoryName: deal.customType,
                unit: deal.customUnit,
                dealSizeOptions: deal.dealSizeOptions,
                attachments: deal.attachments,
                description: deal.description,
            };
            ProductsService.createProduct(productData).then(function() {
                AlertService.success(gettextCatalog.getString('Product created'));
                $state.go('app.products', { searchText: productData.name })
            });
        }

        ctrl.showDetails = function(deal) {
            var distribution = '';
            if (deal.distribution) {
                distribution = '<h5>' + (DealsService.isDistributionDelivery(deal) ? gettextCatalog.getString('Delivery') : gettextCatalog.getString('Collection'))  + '</h5>' +
                    '<ul class="mb-4">' +
                    '<li>' + gettextCatalog.getString('Start') + ': ' + Utils.getLocalizedDate(deal.deliveryStart) + '</li>' + 
                    '<li>' + gettextCatalog.getString('End') + ': ' + Utils.getLocalizedDate(deal.deliveryEnd) + '</li>' +
                    '</ul>';
            }
                
            var content = 
                (distribution ? distribution : '') + 
                '<h5>' + gettextCatalog.getString('Description') + '</h5>' + 
                '<p>' + (deal.description || '---') + '</p>'
            $ngConfirm({
                title: deal.product.name,
                scope: $scope,
                content: content,
                theme: 'modern',
                animation: 'bottom',
                closeAnimation: 'bottom',
                columnClass: 'medium',
                buttons: {
                    close: {
                        text: gettextCatalog.getString('Close'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide',
                    }
                }
            });
        }

    }

})();

(function() {
    'use strict';

    angular.module('app.offers').component('offersReceived', {
        controller: IncomingOffersCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/modules/offers/received/offers.received.tpl.html'
    });

    function IncomingOffersCtrl($scope, $rootScope, $window, $state, $ngConfirm, $uibModal, $stateParams, $interval, $timeout, $log, 
        gettextCatalog, Utils, DealsService, ShoppingCartService, HttpService, AlertService, CONSTANTS, ORDER_STATUS) {
        var ctrl = this;

        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;

        ctrl.deals = [];

        ctrl.categorisedDeals = {};

        ctrl.paging = { current: 1, maxSize: 3, itemsPerPage: 10 };

        var FILTER_LS_KEY = CONSTANTS.LS_ENTRIES.OFFERS_RECEIVED_FITLER;
        ctrl.filters = Utils.getItemLS(FILTER_LS_KEY) || {};

        ctrl.refresh = function() {
            var queryParams = {
                skip: ((ctrl.paging.current - 1) * ctrl.paging.itemsPerPage),
                limit: ctrl.paging.itemsPerPage,
            };

            if (ctrl.filters.suppliers) {
                queryParams.suppliers = Object.keys(ctrl.filters.suppliers).filter(function (supplierId) {
                    return ctrl.filters.suppliers[supplierId];
                });
                if (!queryParams.suppliers.length) {
                    ctrl.deals = [];
                    ctrl.stats.suppliers = {};
                    return;
                }
            }

            if (ctrl.filters.searchText) {
                queryParams.query = ctrl.filters.searchText;
            }

            HttpService.Get('me/deals/search', queryParams).then(function(res) {
                ctrl.paging.count = res.count;
                ctrl.deals = res.deals;
                ctrl.categorisedDeals = {};
                ctrl.stats = { suppliers: {} };

                ctrl.deals.forEach(function(d) {
                    d.isExpired = DealsService.isExpired(d);
                    d.orders = d.orders.filter(function (order) {
                        return order.status === ORDER_STATUS.PENDING || order.status === ORDER_STATUS.COMPLETED;
                    });
                    if (d.orders.length) {
                        d.lastOrder = d.orders.slice(-1)[0];
                    }
                });

                ctrl.isLoading = false;

                fetchRetailerDealData();
            });
        };
        
        var promiseRefresh = $interval(ctrl.refresh, 1000 * 60);


        ctrl.$onInit = function() {
            init();
        };

        ctrl.onPage = function () {
            ctrl.refresh();
            $window.scrollTo(0, 0);
        }; 
  
        function init() {
            ctrl.isLoading = true;
            if (!$rootScope.app.Auth.User) {
              $timeout(init, 1000);
              return;
            }
            
            ctrl.selectedDealId = $stateParams.id;
            if (ctrl.selectedDealId) {
                ctrl.filters = {};
            }
            if ($stateParams.searchText) {
                ctrl.filters.searchText = $stateParams.searchText;
            }

            HttpService.Get('me/suppliers', { role: CONSTANTS.USER_ROLES.COMMERCIAL_PARTNER }).then(function (data) {
                ctrl.suppliers = data.suppliers;
                if (!ctrl.filters.suppliers && ctrl.suppliers.length) {
                    ctrl.filters.suppliers = ctrl.suppliers.reduce(function (map, s) {
                        map[s._id] = true;
                        return map;
                    }, {});
                }
                else {
                    ctrl.isLoading = false;
                }
                ctrl.refresh();

                if ($state.params.startIntro) {
                    $timeout(ctrl.startIntro, 1000);
                }
            });
        }

        function fetchRetailerDealData() {
            ctrl.deals.forEach(function (d) {
                d.retailerDealList = [];
                d.retailerDeal = undefined;
            });

            ctrl.deals.filter(function (d) {
                return d.reservationOrder && d.reservationOrder.retailerDeal;
            }).forEach(function (d) {
                var dealId = d.reservationOrder.retailerDeal;
                HttpService.Get('deals?retailerOrder=' + d.reservationOrder._id).then(function (resDealList) {
                    d.retailerDealList = resDealList.list;
                    d.retailerDealList = d.retailerDealList.filter(function (d) {
                        return !DealsService.isExpired(d);
                    });
                    d.retailerDeal = Utils.altFind(d.retailerDealList, function (d) {
                        return d._id === dealId;
                    });
                    
                    if (!d.retailerDeal) {
                        $log.log('Incoming offers: retailerDeal not found in deal list result.');
                        HttpService.Get('deals/' + dealId).then(function (resDeal) {
                            if (DealsService.isExpired(resDeal)) {
                                return;
                            }
                            d.retailerDeal = resDeal;
                            d.retailerDealList.unshift(d.retailerDeal);
                        });
                    }
                });
            });
        }

        $scope.$on('$destroy',function(){
            if (promiseRefresh) {
                $interval.cancel(promiseRefresh);   
            }
        });

        ctrl.tabClicked = function() {
            $state.go('app.offers.search');
        }

        function editReservation(deal) {
            var payload = {
                amount: ctrl.amountReserved,
                isRetailerDealAffected: ctrl.isRetailerDealAffected
            };
            if (ctrl.amountReserved <= 0) {
                payload.status = ORDER_STATUS.INVALID;
            }
            HttpService.Put('orders/' + deal.reservationOrder._id, { data: payload }).then(function () {
                AlertService.success(gettextCatalog.getString('Reservation updated'));
                ctrl.refresh();
            }).catch(function () {
                ctrl.refresh();
            });
        }

        function createOrEditReservation(deal) {
            if (deal.reservationOrder) {
                editReservation(deal);
                return;
            }
            var payload = {
                amount: ctrl.amountReserved,
                status: ORDER_STATUS.RESERVED
            };
            HttpService.Post('me/deals/' + deal._id + '/orders', payload).then(function() {
                ctrl.refresh();
                AlertService.success(gettextCatalog.getString('Reservation created'))
            }).catch(function() {
                AlertService.error(gettextCatalog.getString('Error while creating reservation. Please try again.'));
                ctrl.refresh();
            });
            
        }


        ctrl.startReservation = function(deal) {
            // TODO: refresh deal 
            
            ctrl.reservationStarted = true;
            ctrl.deal = deal;
            ctrl.selectedDealId = deal._id;

            deal.dealSizeOptions = deal.dealSizeOptions || {};
            deal.dealSizeOptions.min = deal.dealSizeOptions.min || 1;
            deal.dealSizeOptions.step = deal.dealSizeOptions.step || 1;

            ctrl.maxAmountReserved = ctrl.getMaxAmountReserved(deal);
            ctrl.minAmountReserved = 0;
            ctrl.amountReserved = deal.reservationOrder ? deal.reservationOrder.amount : deal.dealSizeOptions.min;

            ctrl.isRetailerDealAffected = true;

            $ngConfirm({
                title: gettextCatalog.getString('Reservation') + ': "' + deal.product.name + '"',
                scope: $scope,
                columnClass: 'small',
                contentUrl: 'app/modules/offers/templates/reservation.tpl.html',
                animation: 'bottom',
                closeAnimation: 'bottom',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide',
                        action: function (scope) {
                            ctrl.reservationStarted = false;
                            scope.$apply();
                        }
                    },
                    ok: {
                        text: gettextCatalog.getString('Confirm'),
                        keys: ['enter'],
                        btnClass: 'btn-success btn-wide',
                        action: function(scope) {
                            ctrl.checkAmountReserved();
                            createOrEditReservation(deal);
                            ctrl.reservationStarted = false;
                            scope.$apply();
                        }
                    }
                }
            });
        };

        ctrl.startOrder = function (deal) {
            ctrl.selectedDealId = deal._id;
            
            $uibModal.open({
                animation: true,
                component: 'newOrder',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    modalData: function () {
                        return {
                            deal: deal
                        };
                    }
                }
            }).result.then(function (orderData) {
                HttpService.Post('me/deals/' + deal._id + '/orders', orderData).then(function () {
                    ctrl.refresh();
                    $ngConfirm({
                        icon: 'fa fa-check-circle',
                        type: 'green',
                        title: gettextCatalog.getString('Order placed'),
                        content: gettextCatalog.getString('For details, go to the "Orders" page from the main menu.'),
                        buttons: { OK: function () { } }
                    });
                }).catch(function () {
                    AlertService.error(gettextCatalog.getString('Error while creating order. Please try again.'));
                });
            });
        };

        ctrl.addToCart = function(deal) {
            ShoppingCartService.addToCart(deal);
        }
        ctrl.isDealIdInCart = function(dealId) {
            return ShoppingCartService.isDealIdInCart(dealId);
        }
        ctrl.canBeForwardedToFarmers = function(deal) {
            if (!ctrl.utils.getSettings().tradeWithFarmers) {
                return false;
            }
            if (!deal.isSpecialOffer) {
                return false;
            }
            return deal.reservationOrder && !deal.retailerDealList.length;
        }
        ctrl.canBeAddedToCart = function (deal) {
            if (deal.isSpecialOffer) {
                return false;
            }
            if (DealsService.isCategoryCrop(deal)) {
                return false;
            }
            return true;
         }

        function sendRequest(requestData) {
            HttpService.Post('me/requests', requestData).then(function () {
                ctrl.refresh();
                AlertService.success(
                    gettextCatalog.getString('Request sent'),
                    gettextCatalog.getString('For details, go to the "Requests" page.'));
            }).catch(function () {
                AlertService.error(gettextCatalog.getString('Error while sending request. Please try again.'));
            });
        }

        ctrl.startRequest = function (deal) {
            $uibModal.open({
                animation: true,
                component: 'newRequest',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    modalData: function () {
                        return {
                            deal: deal,
                            category: ctrl.searchText
                        };
                    }
                }
            }).result.then(function (requestData) {
                if (deal) {
                    requestData.deals = [deal._id];
                }
                sendRequest(requestData);
            });
        };
        

        function createFarmersDeal(sourceDeal, forwardedDealData) {
            forwardedDealData.retailerOrder = ctrl.deal.reservationOrder ? ctrl.deal.reservationOrder._id : undefined;
            HttpService.Post('me/deals/' + sourceDeal._id + '/forward', forwardedDealData)
                .then(function (res) {                    
                    ctrl.deal.retailerDeal = res.data.deal;
                    AlertService.success(gettextCatalog.getString('Offer draft created'));
                    ctrl.openDeal(ctrl.deal.retailerDeal);
                })
                .catch(function() {
                    AlertService.error(gettextCatalog.getString('Error while creating offer. Please try again.'));
                });
        }

        ctrl.forwardDeal = function (deal, isCreateForced) {
            if (!deal) {
                return;
            }
            ctrl.deal = deal;
            ctrl.forwardedDeal = {};
            ctrl.forwardedDeal.product = ctrl.deal.product;
            ctrl.forwardedDeal.customUnit = ctrl.deal.customUnit;
            ctrl.forwardedDeal.dealSizeOptions = { min: ctrl.deal.dealSizeOptions.min || 1, step: ctrl.deal.dealSizeOptions.step || 1 };
            
            ctrl.forwardedDeal.bookingEnd = deal.reservationOrder ? moment(ctrl.deal.reservationOrder.modifyTimeExpiresAt) : moment().add(1, 'week');
            ctrl.forwardedDeal.dealSize = deal.reservationOrder ? deal.reservationOrder.amount : (deal.dealSizeOptions.min * 10);

            ctrl.forwardedDeal.description = deal.description;
            ctrl.forwardedDeal.attachments = deal.attachments;
            ctrl.forwardedDeal.attachments.forEach(function (a) {
                a.isIncluded = true;
            });

            ctrl.productVariants = undefined;
            if (ctrl.deal.variants && ctrl.deal.variants.length) {
                ctrl.productVariants = ctrl.deal.variants.map(function (v) {
                    return {
                        _id: v.product,
                        productName: v.productName,
                        vendorProductId: v.vendorProductId,
                        isIncluded: true
                    }
                });
            }

            $ngConfirm({
                icon: 'fa fa-share',
                title: gettextCatalog.getString('Forward offer to farmers'),
                scope: $scope,
                columnClass: 'medium',
                contentUrl: 'app/modules/offers/templates/forward-offer.tpl.html',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide'
                    },
                    ok: {
                        text: gettextCatalog.getString('Continue'),
                        btnClass: 'btn-success btn-wide',
                        action: function () {
                            if (ctrl.productVariants) {
                                ctrl.forwardedDeal.variants = ctrl.productVariants.filter(function (v) {
                                    return v.isIncluded;
                                });
                            }
                            ctrl.forwardedDeal.attachments = ctrl.forwardedDeal.attachments.filter(function (a) {
                                return a.isIncluded;
                            });
                            createFarmersDeal(deal, ctrl.forwardedDeal, isCreateForced);
                        }
                    }
                }
            });
        };
        
        ctrl.forwardDealAgain = function(deal) {
            ctrl.forwardDeal(deal, true)
        }

        ctrl.openDeal = function (deal) {
            if (DealsService.isDraft(deal) && DealsService.isCategoryCrop(deal)) {
                $state.go('app.crop.proc', { id: deal._id });
                return;
            }
            if (DealsService.isDraft(deal)) {
                $state.go('app.deals.update', { id: deal._id });
                return;
            }
            $state.go('app.deals.report', { id: deal._id });
            return;
        };

        ctrl.goToOrders = function (deal) {
            var refs = deal.orders.map(function(order) {
                return order.ref;
            }).join(',');
            $state.go('app.orders', { role: 'RETAILER', type: 'ANY', ref: refs });
        };

        ctrl.hasRetailerDealLive = function(deal) {
            return deal && deal.retailerDealList && deal.retailerDealList.length;
        };

        ctrl.decreaseAmountReserved = function() {
            var deal = ctrl.deal;
            ctrl.amountReserved -= deal.dealSizeOptions.step;
            ctrl.checkAmountReserved(deal);
        }
        ctrl.increaseAmountReserved = function() {
            var deal = ctrl.deal;
            ctrl.amountReserved += deal.dealSizeOptions.step;
            ctrl.checkAmountReserved(deal);
        }
        ctrl.getAvailabilityForUser = function (deal) {
            return DealsService.getAvailabilityForUser(deal);
        };
        ctrl.getMaxAmountReserved = function(deal) {
            return ctrl.getAvailabilityForUser(deal);
        };

        ctrl.checkAmountReserved = function() { 
            var deal = ctrl.deal;
            if (ctrl.amountReserved < ctrl.minAmountReserved) {
                ctrl.amountReserved = ctrl.minAmountReserved;
            }
            var maxQt = ctrl.getMaxAmountReserved(deal);
            if (ctrl.amountReserved > maxQt) {
                ctrl.amountReserved = maxQt;
            }
            if (ctrl.amountReserved %  deal.dealSizeOptions.step !== 0) {
                ctrl.amountReserved = Math.floor(ctrl.amountReserved / deal.dealSizeOptions.step) * deal.dealSizeOptions.step;
            }
        };

        ctrl.showDetails = function (deal) {
            ctrl.deal = deal;
            ctrl.selectedDealId = deal._id;
            var ngConfirmOptions = {
                title: deal.product.name,
                scope: $scope,
                columnClass: 'large',
                contentUrl: 'app/modules/offers/templates/offer-details.tpl.html',
                theme: 'modern',
                animation: 'bottom',
                closeAnimation: 'bottom',
                buttons: {
                    close: {
                        text: gettextCatalog.getString('Close'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide',
                    },
                }
            };
            if (ctrl.deal.orders && ctrl.deal.orders.length) {
                ngConfirmOptions.buttons.goToOrders = {
                    text: gettextCatalog.getString('Orders details'),
                    icon: 'fa fa-list',
                    btnClass: 'btn-wide',
                    action: function () {
                        ctrl.goToOrders(ctrl.deal);
                    }
                };
            }
            $ngConfirm(ngConfirmOptions);
        }

        ctrl.searchTextChanged = function() {
            ctrl.paging.current = 1;
            Utils.setItemLS(FILTER_LS_KEY, ctrl.filters);
            ctrl.refresh();
        }

        ctrl.supplierSelectionChanged = function() {
            ctrl.paging.current = 1;
            Utils.setItemLS(FILTER_LS_KEY, ctrl.filters);
            ctrl.refresh();
        }

        ctrl.clearFilters = function () {
            ctrl.filters.searchText = '';
            ctrl.filters.suppliers = null;
            ctrl.paging.current = 1;
            Utils.setItemLS(FILTER_LS_KEY, ctrl.filters);

            ctrl.filters.suppliers = ctrl.suppliers.reduce(function (map, s) {
                map[s._id] = true;
                return map;
            }, {});
            ctrl.refresh();
        }

        ctrl.areFiltersActive = function() {
            return ctrl.paging.current > 1 || ctrl.filters.searchText || 
                (ctrl.filters.suppliers && Object.values(ctrl.filters.suppliers).filter(function (v) { return !v; }).length > 0);
        }

        // Intro --------------------------

        ctrl.startIntro = function () {
            var doneButton;
            if (ctrl.deals.length) {
                doneButton = {
                    text: gettextCatalog.getString('Show me the checkout'),
                    action: function () {
                        ctrl.startOrder(ctrl.deals[0], 1, true);
                    }
                };
            }
            Utils.startIntro([
                {
                    element: '#offers-received-search',
                    intro: gettextCatalog.getString('Here you can either use the search function or scroll through the list.'),
                },
                {
                    element: '#offers-received-suppliers',
                    intro: gettextCatalog.getString('On the left hand side you can set which dealers you want to see offers from.'),
                },
                {
                    element: '#offers-received-add-cart-row-0',
                    intro: gettextCatalog.getString('Add all products you want to buy to the shopping cart.'),
                },
                {
                    element: '#offers-received-shopping-carts',
                    intro: gettextCatalog.getString('Different shopping carts will open automatically for products from different suppliers.'),
                },                
            ], doneButton);
        }
    }

})();

(function() {
    'use strict';

    angular.module('app.offers').component('incomingOffers', {
        controller: IncomingOffersCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'app/modules/offers/incomingOffers/incoming.offers.tpl.html'
    });

    function IncomingOffersCtrl($scope, $rootScope, $state, $ngConfirm, $uibModal, $stateParams, $interval, $timeout, $log, 
        gettextCatalog, Utils, DealsService, ProductsService, HttpService, AlertService, DEAL_STATUS, ORDER_STATUS) {
        var ctrl = this;

        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;

        ctrl.deals = [];

        ctrl.categorisedDeals = {};

        ctrl.refresh = function() {
            // TODO: Move categorisedDeals population to API
            var params = {};
            if (ctrl.onBehalfOfUser) {
                params.onBehalfOfUser = ctrl.onBehalfOfUser;
            }
            HttpService.Get('me/deals/home', params).then(function(res) {
                $log.log('Refresh incoming offers');
                if (!res.length || res[0].name !== 'distributor') {
                    ctrl.deals = [];
                } else {
                    ctrl.deals = res[0].deals;
                }
                ctrl.categorisedDeals = {};
                ctrl.deals.forEach(function(d) {
                    ctrl.categorisedDeals[d.supplier.name] = ctrl.categorisedDeals[d.supplier.name] || [];
                    ctrl.categorisedDeals[d.supplier.name].push(d);
                });
                if (!Utils.isSupplierDistributor() && Utils.isSupplierCountryAustria()) {
                    ctrl.categorisedDeals['RWA - Düngemittel'] = ctrl.categorisedDeals['RWA - Düngemittel'] || [];
                    ctrl.categorisedDeals['RWA - Landwirtschaftliche Erzeugnisse'] = ctrl.categorisedDeals['RWA - Landwirtschaftliche Erzeugnisse'] || [];
                    ctrl.categorisedDeals['RWA - Pflanzenschutz'] = ctrl.categorisedDeals['RWA - Pflanzenschutz'] || [];
                    ctrl.categorisedDeals['RWA - Saatgut'] = ctrl.categorisedDeals['RWA - Saatgut'] || [];
                }
                ctrl.hasCategories = Object.keys(ctrl.categorisedDeals).length > 0;

                ctrl.deals.forEach(function(d) {
                    d.isExpired = moment().isAfter(d.bookingEnd);
                    d.orders = d.orders.filter(function (order) {
                        return order.status === ORDER_STATUS.PENDING || order.status === ORDER_STATUS.COMPLETED;
                    });
                });

                fetchRetailerDealData();
            });
        };
        
        var promiseRefresh = $interval(ctrl.refresh, 1000 * 60);


        ctrl.$onInit = function() {
            init();
        };
  
        function init() {
            if (!$rootScope.app.Auth.User) {
              $timeout(init, 1000);
              return;
            }
            if (Utils.isSupplierDistributor()) {
                $state.go('app.offers.received', { id: $stateParams.id })
                return;
            }
            ctrl.selectedDealId = $stateParams.id;
            ctrl.refresh();

            if (Utils.isUserRegionalManager()) {
                ctrl.onBehalfOfUser = $rootScope.app.Auth.User._id;
                HttpService.Get('users?role=COMMERCIAL%20PARTNER&supplier=' + $rootScope.app.Auth.User.supplier._id).then(function (res) {
                    ctrl.supplierAccounts = res.list;
                });
            }
        }

        function fetchRetailerDealData() {
            ctrl.deals.forEach(function (d) {
                d.retailerDealList = [];
                d.retailerDeal = undefined;
            });

            ctrl.deals.filter(function (d) {
                return d.reservationOrder && d.reservationOrder.retailerDeal;
            }).forEach(function (d) {
                var dealId = d.reservationOrder.retailerDeal;
                HttpService.Get('deals?retailerOrder=' + d.reservationOrder._id).then(function (resDealList) {
                    d.retailerDealList = resDealList.list;
                    d.retailerDealList = d.retailerDealList.filter(function (d) {
                        return !DealsService.isExpired(d);
                    });
                    d.retailerDeal = Utils.altFind(d.retailerDealList, function (d) {
                        return d._id === dealId;
                    });
                    
                    if (!d.retailerDeal) {
                        $log.log('Incoming offers: retailerDeal not found in deal list result.');
                        HttpService.Get('deals/' + dealId).then(function (resDeal) {
                            if (DealsService.isExpired(resDeal)) {
                                return;
                            }
                            d.retailerDeal = resDeal;
                            d.retailerDealList.unshift(d.retailerDeal);
                        });
                    }
                });
            });
        }

        $scope.$on('$destroy',function(){
            if (promiseRefresh) {
                $interval.cancel(promiseRefresh);   
            }
        });

        ctrl.tabClicked = function() {
            $state.go('app.offers.search');
        }

        function editReservation(deal) {
            var payload = {
                amount: ctrl.amountReserved,
                isRetailerDealAffected: ctrl.isRetailerDealAffected
            };
            if (ctrl.amountReserved <= 0) {
                payload.status = ORDER_STATUS.INVALID;
            }
            HttpService.Put('orders/' + deal.reservationOrder._id, { data: payload }).then(function () {
                AlertService.success(gettextCatalog.getString('Reservation updated'));
                ctrl.refresh();
            }).catch(function () {
                ctrl.refresh();
            });
        }

        function createOrEditReservation(deal) {
            if (deal.reservationOrder) {
                editReservation(deal);
                return;
            }
            var payload = {
                amount: ctrl.amountReserved,
                unitPrice: ctrl.deal.benchmarkPrice,
                status: ORDER_STATUS.RESERVED
            };
            HttpService.Post('me/deals/' + deal._id + '/orders', payload).then(function() {
                ctrl.refresh();
                AlertService.success(gettextCatalog.getString('Reservation created'))
            }).catch(function() {
                AlertService.error(gettextCatalog.getString('Error while creating reservation. Please try again.'));
                ctrl.refresh();
            });
            
        }


        ctrl.startReservation = function(deal) {
            // TODO: refresh deal 
            
            ctrl.reservationStarted = true;
            ctrl.deal = deal;

            deal.dealSizeOptions = deal.dealSizeOptions || {};
            deal.dealSizeOptions.min = deal.dealSizeOptions.min || 1;
            deal.dealSizeOptions.step = deal.dealSizeOptions.step || 1;

            ctrl.maxAmountReserved = ctrl.getMaxAmountReserved(deal);
            ctrl.minAmountReserved = 0;
            ctrl.amountReserved = deal.reservationOrder ? deal.reservationOrder.amount : deal.dealSizeOptions.min;

            ctrl.isRetailerDealAffected = true;

            $ngConfirm({
                title: gettextCatalog.getString('Reservation') + ': "' + deal.product.name + '"',
                scope: $scope,
                columnClass: 'small',
                contentUrl: 'app/modules/offers/templates/reservation.tpl.html',
                animation: 'bottom',
                closeAnimation: 'bottom',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide',
                        action: function() {
                            ctrl.reservationStarted = false;
                        }
                    },
                    ok: {
                        text: gettextCatalog.getString('Confirm'),
                        keys: ['enter'],
                        btnClass: 'btn-success btn-wide',
                        action: function(scope) {
                            ctrl.checkAmountReserved();
                            createOrEditReservation(deal);
                            ctrl.reservationStarted = false;
                            scope.$apply();
                        }
                    }
                }
            });
        };

        ctrl.startOrder = function (deal) { 
            
            $uibModal.open({
                animation: true,
                component: 'newOrder',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    modalData: function () {
                        return {
                            deal: deal
                        };
                    }
                }
            }).result.then(function (orderData) {
                HttpService.Post('me/deals/' + deal._id + '/orders', orderData).then(function () {
                    ctrl.refresh();
                    $ngConfirm({
                        icon: 'fa fa-check-circle',
                        title: gettextCatalog.getString('Order placed'),
                        content: gettextCatalog.getString('For details, go to the "Orders" page from the main menu.'),
                        buttons: { OK: function () { } }
                    });
                })
                .catch(function() {
                    AlertService.error(gettextCatalog.getString('Error while creating order. Please try again.'));
                });
            });
        };

        function createFarmersDeal(sourceDeal, forwardedDealData) {
            forwardedDealData.retailerOrder = ctrl.deal.reservationOrder._id;
            HttpService.Post('me/deals/' + sourceDeal._id + '/forward', forwardedDealData)
                .then(function (res) {                    
                    ctrl.deal.retailerDeal = res.data.deal;
                    AlertService.success(gettextCatalog.getString('Offer draft created'));
                    ctrl.openDeal(ctrl.deal.retailerDeal);
                })
                .catch(function() {
                    AlertService.error(gettextCatalog.getString('Error while creating offer. Please try again.'));
                });
        }

        ctrl.forwardDeal = function (deal, isCreateForced) {
            if (!deal) {
                return;
            }
            ctrl.deal = deal;
            ctrl.forwardedDeal = {};
            ctrl.forwardedDeal.product = ctrl.deal.product;
            ctrl.forwardedDeal.bookingEnd = (ctrl.deal.reservationOrder) ? moment(ctrl.deal.reservationOrder.modifyTimeExpiresAt) : moment();
            ctrl.forwardedDeal.dealSize = deal.reservationOrder.amount;
            ctrl.forwardedDeal.description = deal.description;
            ctrl.forwardedDeal.attachments = deal.attachments;
            ctrl.forwardedDeal.attachments.forEach(function (a) {
                a.isIncluded = true;
            });

            ctrl.productVariants = undefined;
            if (ctrl.deal.variants && ctrl.deal.variants.length) {
                ctrl.productVariants = ctrl.deal.variants.map(function (v) {
                    return {
                        _id: v.product,
                        productName: v.productName,
                        vendorProductId: v.vendorProductId,
                        isIncluded: true
                    }
                });
            }

            $ngConfirm({
                icon: 'fa fa-share',
                title: gettextCatalog.getString('Forward offer to farmers'),
                scope: $scope,
                columnClass: 'medium',
                contentUrl: 'app/modules/offers/templates/forward-offer.tpl.html',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide'
                    },
                    ok: {
                        text: gettextCatalog.getString('Continue'),
                        btnClass: 'btn-success btn-wide',
                        action: function () {
                            if (ctrl.productVariants) {
                                ctrl.forwardedDeal.variants = ctrl.productVariants.filter(function (v) {
                                    return v.isIncluded;
                                });
                            }
                            ctrl.forwardedDeal.attachments = ctrl.forwardedDeal.attachments.filter(function (a) {
                                return a.isIncluded;
                            });
                            createFarmersDeal(deal, ctrl.forwardedDeal, isCreateForced);
                        }
                    }
                }
            });
        };
        
        ctrl.forwardDealAgain = function(deal) {
            ctrl.forwardDeal(deal, true)
        }

        ctrl.openDeal = function (deal) {
            if (DealsService.isDraft(deal) && DealsService.isCategoryCrop(deal)) {
                $state.go('app.crop.proc', { id: deal._id });
                return;
            }
            if (DealsService.isDraft(deal)) {
                $state.go('app.deals.update', { id: deal._id });
                return;
            }
            $state.go('app.deals.report', { id: deal._id });
            return;
        };

        ctrl.goToOrders = function (deal) {
            var refs = deal.orders.map(function(order) {
                return order.ref;
            }).join(',');
            $state.go('app.orders', { role: 'RETAILER', type: 'ANY', ref: refs });
        };

        ctrl.hasRetailerDealLive = function(deal) {
            return deal && deal.retailerDealList && deal.retailerDealList.length;
        };

        ctrl.decreaseAmountReserved = function() {
            var deal = ctrl.deal;
            ctrl.amountReserved -= deal.dealSizeOptions.step;
            ctrl.checkAmountReserved(deal);
        }
        ctrl.increaseAmountReserved = function() {
            var deal = ctrl.deal;
            ctrl.amountReserved += deal.dealSizeOptions.step;
            ctrl.checkAmountReserved(deal);
        }
        ctrl.getAvailabilityForUser = function (deal) {
            return DealsService.getAvailabilityForUser(deal);
        };
        ctrl.getMaxAmountReserved = function(deal) {
            return ctrl.getAvailabilityForUser(deal);
        };

        ctrl.checkAmountReserved = function() { 
            var deal = ctrl.deal;
            if (ctrl.amountReserved < ctrl.minAmountReserved) {
                ctrl.amountReserved = ctrl.minAmountReserved;
            }
            var maxQt = ctrl.getMaxAmountReserved(deal);
            if (ctrl.amountReserved > maxQt) {
                ctrl.amountReserved = maxQt;
            }
            if (ctrl.amountReserved %  deal.dealSizeOptions.step !== 0) {
                ctrl.amountReserved = Math.floor(ctrl.amountReserved / deal.dealSizeOptions.step) * deal.dealSizeOptions.step;
            }
        };
    }

})();

/**
 * Created by Hafeez Rehman on 06/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.deals', []);
})();

(function() {
    'use strict';

    angular.module('app.deals').component('dealUpdate', {
        controller: DealFormController,
        controllerAs: 'vm',
        templateUrl: 'app/modules/deals/deal-update/deals.update.html'
    });

    /** @ngInject */
    function DealFormController($scope, $rootScope, $state, $stateParams, $log, $uibModal, $templateCache, $timeout, $anchorScroll,
      HttpService, AlertService, MapFactory, uiGmapGoogleMapApi, gettextCatalog, Utils, DealsService, ProductsService,
      DEAL_STATUS, DEAL_TARGET, DEAL_CONSTANTS) {

        var vm = this;
        vm.utils = Utils;
        vm.dealsService = DealsService
        vm.productsService = ProductsService;

        vm.productTypes = DealsService.getProductTypes();
        vm.DEAL_STATUS = DEAL_STATUS;
        vm.DEAL_TARGET = DEAL_TARGET;

        $rootScope.place = {};
        $rootScope.showPlaceDetails = function(param) {
            vm.place = param;
        };

        vm.lookup = {};
        vm.lookup.categories = [];
        vm.lookup.distMethods = [
            { label: '---', value: undefined },
            { label: gettextCatalog.getString('Collection'), value: 'collection' },
            { label: gettextCatalog.getString('Delivery'), value: 'delivery' }
        ];
        vm.lookup.distMethodsMap = Utils.valueToLabelMap(vm.lookup.distMethods);
        vm.lookup.units = DealsService.getProductUnits();
        vm.farmTypes = [];
        vm.incoterms = ['EXW', 'FCA', 'CPT', 'CIP', 'DAT', 'DAP', 'DDP', 'FAS', 'FOB', 'CFR', 'CIF'];

        vm.model = {
            bookingStart: new Date(),
            bookingEnd: new Date(),
            supplier: $rootScope.app.Auth.User ? $rootScope.app.Auth.User.supplier : {},
            product: null,
            location: { coordinates: [], type: 'Point' },
            benchmarkPrice: null,
            dealSize: null,
            individualDiscount: null,
            deliveryEnd: new Date(),
            distribution: null,
            system: null
        };

        vm.startIntro = function () {
            Utils.startIntro([
                {
                    element: '#deal-update-product',
                    intro: gettextCatalog.getString('You can set the product'),
                },
                {
                    element: '#deal-update-price',
                    intro: gettextCatalog.getString('Price'),
                },
                {
                    element: '#deal-update-duration',
                    intro: gettextCatalog.getString('duration of the offer'),
                },
                {
                    element: '#deal-update-delivery',
                    intro: gettextCatalog.getString('delivery method and many other settings from scratch'),
                },
                {
                    element: '#deal-update-target',
                    intro: gettextCatalog.getString('On the right side you set who should receive this offer. You can also set different prices for different recipients.'),
                },
                {
                    element: '#deal-update-submit',
                    intro: gettextCatalog.getString('You can review the details and publish the offer. After that you can start receiving orders.'),
                },
            ], {
                text: gettextCatalog.getString('Go to orders page'),
                action: function () {
                    $state.go('app.orders', { startIntro: true });
                }
            });
        }

        vm.manageCollection = function() {
            var dialog = $uibModal.open({
                animation: true,
                controller: 'CollectionPointCtrl',
                templateUrl: 'app/shared/templates/modals/collection-points.tpl.html',
                template: Utils.getTemplate('app/shared/templates/modals/collection-points.tpl.html'),
                size: 'lg',
                windowClass: 'modal-window',
                resolve: {
                    items: function() {
                        return  {
                          collectionPoints: $rootScope.app.Auth.User.supplier.collectionPoints,
                          selectedCollectionPoints: vm.model.collectionPoints
                        };
                    }
                }
            });

            dialog.result.then(function(selectedCollectionPoints) {
              vm.model.collectionPoints = selectedCollectionPoints;
            });
        };

        vm.modelChangedAfterSave = false;
        vm.readyToPublish = false;

        $scope.$watch("vm.model", function() {
            vm.modelChangedAfterSave = true;
        }, true);
        $scope.$watch('vm.model.bookingStart', function () {
            vm.modelChangedAfterSave = true;    
        }, true);
        $scope.$watch('vm.model.bookingEnd', function () {
            vm.modelChangedAfterSave = true;
        }, true);
        $scope.$watch("vm.product", function() {
            vm.modelChangedAfterSave = true;
        }, true);
        $scope.$watch("vm.farmTypes", function() {
            vm.modelChangedAfterSave = true;
        }, true);

        vm.salePriceChange = function() {
            if (vm.salePrice > vm.model.benchmarkPrice) {
                vm.model.benchmarkPrice = vm.salePrice;
            } 
            vm.model.individualDiscount = Utils.getDiscountPercent(vm.model.benchmarkPrice, vm.salePrice);
            if (!vm.model.individualDiscount) {
                vm.model.individualDiscount = 0;
            }
        };
        vm.discountChange = function() {
            if (!vm.model.individualDiscount) {
                vm.model.individualDiscount = 0;
            }
            vm.salePrice = Utils.getSalePrice(vm.model.benchmarkPrice, vm.model.individualDiscount, vm.model.priceDecimalDigits);
        };

        vm.productTypeChanged = function() {
            if (!vm.model.customType) {
                return;
            }
            var threeDigitsProductKeywords = ['treibstoffe', 'heizöl', 'fuel', 'diesel', 'carburant'];
            var match = Utils.altFind(threeDigitsProductKeywords, function(kw) {
                return vm.model.customType.toLowerCase().indexOf(kw) >= 0;
            });
            vm.model.priceDecimalDigits = match ? 3 : 2;
        };

        vm.setImage = function() {
            $uibModal.open({
                animation: true,
                component: 'uploadImage',
                windowClass: 'modal-window',
                size: 'lg',
                resolve: {}
            }).result.then(function(imgUrl) {
                vm.model.imageUrl = imgUrl;
            });
        };

        vm.editDiscount = function() {
            var deal = vm.model;
            var discountSettings = {
                dealSize: deal.dealSize || 100,
                dealSizeOptions: deal.dealSizeOptions,
                benchmarkPrice: deal.benchmarkPrice,
                individualDiscount: deal.individualDiscount || 0,
                clearanceDiscount: deal.clearanceDiscount || deal.individualDiscount || 0,
                quantityDiscountsInput: deal.quantityDiscounts || [],
                priceDecimalDigits: deal.priceDecimalDigits,
                customUnit: deal.customUnit,
                isVatIncluded: deal.isVatIncluded,
                vatRate: deal.vatRate,
            };
            var dialog = $uibModal.open({
                animation: true,
                component: 'DealDiscountOptionsCtrl',
                windowClass: 'modal-window',
                size: 'lg',
                resolve: {
                    discountSettings: function () { return discountSettings; }
                }
            });

            dialog.result.then(function(ds) {
                deal.individualDiscount = ds.individualDiscount;
                deal.clearanceDiscount = ds.clearanceDiscount;
                deal.quantityDiscounts = ds.quantityDiscounts;
                deal.groupDiscount = ds.groupDiscount;
                deal.isVatIncluded = ds.isVatIncluded;
                deal.vatRate = ds.vatRate;
                deal.priceDecimalDigits = ds.priceDecimalDigits;

                deal.benchmarkPrice = ds.benchmarkPrice;
                deal.dealSize = ds.dealSize;
                vm.salePrice = Utils.getSalePrice(deal.benchmarkPrice, deal.individualDiscount, deal.priceDecimalDigits);
            });
        };

        vm.confirmPublish = function() {
            // Modal close delay
            $timeout(function() {
              vm.model.status = DEAL_STATUS.ACTIVE;
              DealsService.saveDeal(vm.model, vm.product, vm.farmTypes, vm.map).then(function() {
                vm.modelChangedAfterSave = false;
                $state.go('app.deals.list', { type: 'ACTIVE', dealId: vm.model._id });
              });
            }, 200);
        };

        vm.safeDraft = function() {
          DealsService.saveDeal(vm.model, vm.product, vm.farmTypes, vm.map).then(function() {
            vm.modelChangedAfterSave = false;
          });
        };

        vm.submit = function () {
            var validators = {
              booking: validateBookingDates(),
              distribution: validateDeliveryDates(),
            };

            if (!validators.booking || !validators.distribution) {
                return false;
            }

            vm.dealForm.$submitted = true;
            if (vm.dealForm.$invalid || vm.productDoesNotExist()) {
                $anchorScroll('top');
                return false;
            }

            if (DealsService.isDraft(vm.model)) {
                DealsService.saveDeal(vm.model, vm.product, vm.farmTypes, vm.map).then(function() {
                vm.modelChangedAfterSave = false;
                });
            }

            var dialog = $uibModal.open({
                animation: true,
                controller: 'DealConfirmCtrl',
                templateUrl: 'app/shared/templates/modals/deal-confirm.tpl.html',
                template: Utils.getTemplate('app/shared/templates/modals/deal-confirm.tpl.html'),
                size: 'lg',
                windowClass: 'modal-window',
                resolve: {
                    items: function() {
                        return  { 
                            model: vm.model, 
                        };
                    }
                }
            });

            dialog.result.then(function() {
                vm.confirmPublish();
            });
        };

        vm.productDoesNotExist = function() {
            // return vm.product && !vm.product._id && vm.model.product;
            return !vm.product || (vm.product && !vm.product._id);
        };

        function validateBookingDates() {
            if (vm.model.bookingStart.isBefore(vm.model.bookingEnd)) {
                vm.dealLengthError = false;
                return true;
            }
            vm.dealLengthError = true;
            return false;
        }

        function validateDeliveryDates() {
            var isValid = vm.model.deliveryStart.startOf('day').isBefore(vm.model.deliveryEnd.endOf('day'));
            if (!vm.model.distribution) {
                return true;
            }
            vm.dealForm.deliveryStart.$setValidity("distEndBeforeStart", isValid);
            vm.dealForm.deliveryEnd.$setValidity("distEndBeforeStart", isValid);

            isValid = vm.model.bookingEnd.isBefore(vm.model.deliveryEnd.endOf('day'));
            vm.dealForm.deliveryEnd.$setValidity("distEndBeforeStart", isValid);
            return isValid;
        }

        vm.deleteDeal = function() {
          var confirm = Utils.CreateConfirmation(gettextCatalog.getString('Discard unsaved changes?'));
          confirm.result.then(function() {
            HttpService.Delete('deals/' + vm.model._id).then(function() {
                AlertService.success(gettextCatalog.getString('Draft deleted'));
                vm.modelChangedAfterSave = false;
                vm.goBack();
            }, function(err) {
                $log.error('Error occurred loading lists.', err);
            });
          });
        };

        // TODO: (possibly) move to deal map
        vm.viewUsers = function() {
            var selectUsersDiaglog = $uibModal.open({
                animation: true,
                controller: 'DealUsersCtrl',
                templateUrl: 'app/shared/templates/modals/deal-users.tpl.html',
                template: Utils.getTemplate('app/shared/templates/modals/deal-users.tpl.html'),
                size: 'lg',
                windowClass: 'modal-window',
                resolve: {
                    items: function() {
                        return  { model: vm.model, users: vm.allUsersFound, farmTypes: vm.lookup.farmTypes };
                    }
                }
            });
            selectUsersDiaglog.result.then(function() {
                vm.updateMapCircle(vm.model.target);
                if (vm.model.target === DEAL_TARGET.NEW_USERS) {
                    vm.model.radius = 600;
                    vm.model.location.coordinates = DEAL_CONSTANTS.INTIAL_COORDINATES[$rootScope.app.Auth.User.supplier.area.toLowerCase()];
                    MapFactory.SetMapCenterToDealLocation(vm.map, vm.model);
                    // It should be just setupMarkers(...);
                    loadAffectedUsers();
                }
                else {
                    setupMarkers(vm.model.users);
                }
            });
        };

        // TODO move to deals map
        vm.radiusFieldChanged = function() {
            MapFactory.SetMapZoomToDealRadius(vm.map, vm.model);
        };

        // TODO move to deals map
        vm.getUserSelectedCount = function() {
          if (!vm.model || !vm.model.users) {
            return 0;
          }
          return vm.model.users.length;
        };

        // TODO: remove this function (formerly know as 'setTarget')
        vm.updateMapCircle = function(newTarget) {
            if (newTarget === newTarget !== DEAL_TARGET.ALL_USERS) {
                vm.map.circles[0].editable = vm.model.target !== DEAL_TARGET.NEW_USERS;
            }
        };

        vm.goBack = function() {
            var page = $state.params.referrer || 'app.deals.list';
            if (!vm.modelChangedAfterSave) {
                $state.go(page);
                return;
            }
            var confirm = Utils.CreateConfirmation(gettextCatalog.getString('Discard unsaved changes?'));
            confirm.result.then(function() {
                $state.go(page);
            });
        };
        
        vm.selectProduct = function(prod) {
            vm.product = prod;
            vm.model.vendorProductId = undefined;
            DealsService.copyProductInfoToDeal(vm.model, vm.product).then(function() {
                vm.discountChange();
            });

            ProductsService.getProductDeal(prod).then(function(deal) {
                if (deal.benchmarkPrice) {
                    vm.model.distributorDeal = deal;
                }
            });
            vm.discountChange();
            vm.productTypeChanged();
        };

        vm.restoreProduct = function() {
            if (!vm.product) {
                vm.cancelCreateProduct();
            }
        }

        vm.cancelCreateProduct = function() {
            if (!vm.model.product) {
                return;
            }
            vm.product = vm.model.product;
        };

        vm.createProduct = function() {
            var data = vm.product.name ? vm.product : { name: vm.product };
            var confirmationMessage = gettextCatalog.getString('Do you want to create product "{0}"?').replace('{0}', data.name);
            Utils.CreateConfirmation(confirmationMessage).result.then(function() {
                HttpService.Post('suppliers/' + vm.model.supplier._id  + '/products', data).then(function(res) {
                    vm.product = res.data;
                    AlertService.success(gettextCatalog.getString('Product created'));
                    vm.model.vendorProductId = vm.product.vendorProductId;
                    vm.safeDraft();
                }, function(err) {
                    $log.error('Error creating product', err);
                });
            });
        };

        vm.switchVatIncluded = function () {
            DealsService.switchVatIncluded(vm.model).then(function() {
                vm.discountChange();
            });
        };

        // TODO: move to deals map
        vm.reloadUsers = function() {
            loadAffectedUsers();
        };
        
        vm.updateDesc = function() {
            var descModal = $uibModal.open({
                animation: true,
                controller: 'RichTextModalCtrl',
                templateUrl: 'app/shared/templates/modals/rich-text.tpl.html',
                template: Utils.getTemplate('app/shared/templates/modals/rich-text.tpl.html'),
                size: 'lg',
                windowClass: 'modal-window',
                resolve: {
                    items: function() {
                        return { title: gettextCatalog.getString('Offer description'), descText: angular.copy(vm.model.description) };
                    }
                }
            });
            descModal.result.then(function(text) {
                vm.model.description = text;
            });
        };

        vm.addAttachment = function() {
            vm.editAttachment();
        };
        vm.editAttachment = function(idx) {
            var newAttachment = idx === undefined;
            var descModal = $uibModal.open({
                animation: true,
                component: 'uploadAttachment',
                windowClass: 'modal-window',
                size: 'lg',
                resolve: {
                    attachment: newAttachment ? null : vm.model.attachments[idx]
                }
            });
            descModal.result.then(function (attachmentObj) {
                if (newAttachment) {
                    vm.model.attachments = vm.model.attachments || [];
                    vm.model.attachments.push(attachmentObj);
                    return;
                }
                vm.model.attachments[idx] = attachmentObj;
            }); 
        };
        vm.removeAttachment = function (idx) {
            Utils.CreateConfirmation(gettextCatalog.getString('Remove attachment') + ' "' + vm.model.attachments[idx].name + '"')
                .result.then(function () {
                    vm.model.attachments.splice(idx, 1);
                });
        };

        vm.addVariant = function() {

            $uibModal.open({
                animation: true,
                component: 'SelectProduct',
                size: 'md',
                windowClass: 'modal-window',
                resolve: {}
            }).result.then(function(res) {
                vm.model.variants = vm.model.variants || [];
                vm.model.variants.push({
                    product: res,
                    productName: res.name,
                    vendorProductId: res.vendorProductId,
                    benchmarkPrice: vm.model.benchmarkPrice
                });
            });
        }

        vm.removeVariant = function(idx) {
            Utils.CreateConfirmation(gettextCatalog.getString('Remove variant') + ' "' + vm.model.variants[idx].productName + '"')
                .result.then(function () {
                    vm.model.variants.splice(idx, 1);
                });
        }

        vm.viewRequestDetails = function() {
            var requestId = vm.model.requests[0]._id;
            HttpService.Get('requests/' + requestId).then(function(data) {
                var request = data; 
                $uibModal.open({
                  animation: true,
                  controller: 'RequestDetailsCtrl',
                  templateUrl: 'app/shared/templates/modals/request-details.tpl.html',
                  template: Utils.getTemplate('app/shared/templates/modals/request-details.tpl.html'),
                  size: 'lg',
                  windowClass: 'modal-window',
                  resolve: {
                      items: function() {
                          return  {
                            request: request,
                            isCropRequest: false
                          };
                      }
                  }
                });
            });
        }

        vm.isReadOnly = function() {
            return !vm.model || vm.model.distributorDeal;
        }

        vm.canAcceptPayment = function() {
            return Utils.isFeatureEnabled('BILLING_INFO') && 
                $rootScope.app.Auth.User.supplier.billing && 
                $rootScope.app.Auth.User.supplier.billing.isEnabled &&
                $rootScope.app.Auth.User.supplier.billing.stripeUserId;
        }

        vm.getPriceWithQuantityDiscount = function() {
            return '' + Utils.getLocalizedCurrency(Utils.getSalePrice(vm.model.benchmarkPrice, vm.model.individualDiscount, vm.model.priceDecimalDigits), vm.model.priceDecimalDigits) + 
                ' ~ ' + Utils.getLocalizedCurrency(Utils.getSalePrice(vm.model.benchmarkPrice, vm.model.clearanceDiscount, vm.model.priceDecimalDigits), vm.model.priceDecimalDigits);
        }

        vm.getDistributorVariantPrice = function(variant) {
            if (!vm.model || !vm.model.distributorDeal) {
                return 0;
            }
            if (!variant) {
                return vm.model.distributorDeal.benchmarkPrice;
            }
            if (!vm.model.distributorDeal.variants || !vm.model.distributorDeal.variants.length) {
                return 0;
            }
            var found = Utils.altFind(vm.model.distributorDeal.variants, function(v) {
                return v.productName === variant.productName;
            });
            return found ? found.benchmarkPrice : 0;
        }

        vm.getMargin = function(variant) {
            var receivedPrice = vm.getDistributorVariantPrice(variant);
            var sentPrice = variant ? variant.benchmarkPrice : vm.salePrice;
            
            if (!receivedPrice || !sentPrice) {
                return 0;
            }            

            return 100 * (sentPrice - receivedPrice) / receivedPrice;
        }
        
        // ---------------- Initialization ----------------

        vm.$onInit = function() {
            init();
        };
  
        function init() {
            if (!$rootScope.app.Auth.User) {
                $timeout(init, 1000);
                return;
            }
            loadDeal($stateParams.id);
        }

        // TODO: move this function to deals.map.component (together with vm.map object)
        function initializeMap() {
            vm.map = MapFactory.GetDealMapConfig(function() { 
                var selectionCircle = vm.map.circles[0];
                vm.model.location.coordinates = [selectionCircle.center.longitude, selectionCircle.center.latitude ];
                vm.model.radius = Math.round(selectionCircle.radius/1000);
                MapFactory.SetMapCenterToDealLocation(vm.map, vm.model, true);
                loadAffectedUsers(); 
            });
            vm.searchbox = MapFactory.GetSearchboxConfig(function (autocomplete) {
                var place = autocomplete.getPlace();
                if (!place.address_components) {
                    return;
                }
                vm.model.location.coordinates = [ place.geometry.location.lng(), place.geometry.location.lat() ];
                MapFactory.SetMapCenterToDealLocation(vm.map, vm.model, vm.model.target === DEAL_TARGET.NEW_USERS);
            });
        }

        // TODO: move this function to deals.map.component
        function setupMarkers(users){
            vm.map.markers = [];
            users.forEach(function(user, i) {
                var loc = user.locations[0].location.coordinates;
                var icon = user.isExcluded ? 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png' : 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png';

                var title = user.name.first + ' ' + user.name.last;
                if (user.isExcluded) {
                    title += '<br><b>' + gettextCatalog.getString('Excluded') + '</b>';
                }
                vm.map.markers.push({
                    id: user._id,
                    icon: icon,
                    latitude:  loc[1],
                    longitude: loc[0],
                    options: {
                        label: '' + (i + 1),
                        user: user,
                        title: title
                    }
                });
            });
            vm.markerEevents = {
                mouseover: function (marker, eventName, m) {
                    var content = '<div class="text-center">'+ m.options.title +'</div>';
                    var infoWindow = new google.maps.InfoWindow({ content: content }); // eslint-disable-line no-undef
                    infoWindow.open(vm.map, marker);

                    marker.addListener('mouseout', function() {
                        infoWindow.close();
                    });
                }
            };
        }

        function loadDeal(id) {
            vm.initialized = false;
            DealsService.loadDeal(id).then(function (result) {
                vm.model = result.model;
                vm.farmTypes = result.farmTypes;
                vm.product = vm.model.product;

                // TODO move this deal deamap
                if (!Utils.isSupplierDistributor()) {
                    initializeMap();
                    MapFactory.SetMapCenterToDealLocation(vm.map, vm.model);
                    vm.updateMapCircle(vm.model.target);
                    loadAffectedUsers(result.existingDealUsers);
                }

                vm.discountChange();
                vm.modelChangedAfterSave = false;
                vm.isQuantityOptionsEnabled = vm.model.dealSizeOptions && (vm.model.dealSizeOptions.min > 0 || vm.model.dealSizeOptions.step > 0 || vm.model.dealSizeOptions.max);

                if (Utils.isUserRegionalManager()) {
                    HttpService.Get('users?role=COMMERCIAL%20PARTNER&supplier=' + $rootScope.app.Auth.User.supplier._id).then(function (res) {
                        vm.createdByUserList = res.list;
                    });
                }

                if ($stateParams.selectProductOnInit) {
                    vm.product = null;
                    vm.model.product = null;
                    $('#product').select();
                }

                vm.initialized = true;

                if ($state.params.startIntro) {
                    $timeout(vm.startIntro, 500);
                }
            });
        }

        // TODO: move to deals map
        function loadAffectedUsers() {
            DealsService.fetchAffectedUsers(vm.model).then(function(users) {
                vm.allUsersFound = users;
                setupMarkers(vm.model.users);
            });
        }
    }

})();


(function() {
    'use strict';

    angular.module('app.deals').component('dealSuppliers', {
        controller: DealSupplierController,
        controllerAs: '$ctrl',
        templateUrl: 'app/modules/deals/deal-suppliers/deals.suppliers.html',
        bindings: {
            users: '=',
            benchmarkPrice: '=',
            dealSize: '=',
            dealSizeOptions: '=',
            retailPrices: '=',
            priceDecimalDigits: '=',
            hideAccounts: '=',
            hideSupplierSelection: '=',
            hidePrices: '=',
            hideQuantities: '=',
            hideImages: '=',
            hideFarmSettings: '=',
            system: '=',
            farmTypes: '='  
        }
    });

    /** @ngInject */
    function DealSupplierController($scope, $rootScope, $ngConfirm, $log, $timeout, Utils, gettextCatalog, DealsService) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.initialized = false;

        ctrl.lookup = {};
        ctrl.lookup.farmSystems = DealsService.getSystems();
        ctrl.lookup.farmTypes = DealsService.getFarmTypes();

        ctrl.$onInit = function () {
            $log.log('DealSuppliers: Initializing...');
            initPriceTolerance();
            initTargetSuppliers();
            $log.log('DealSuppliers: Init complete.');
            ctrl.initialized = true;
        };

        $scope.$watch('$ctrl.benchmarkPrice', function (newValue, oldValue) {
            if (Math.abs(newValue - oldValue) < 0.001) {
                return;
            }
            ctrl.benchmarkPriceChanged();
        });

        function quantityPrompt(title, content, defaultValue, actionFcn) {
            $ngConfirm({
                title: title,
                scope: $scope,
                content: content,
                animation: 'bottom',
                closeAnimation: 'bottom',
                buttons: {
                    
                    reset: {
                        text: gettextCatalog.getString('Reset'),
                        btnClass: 'btn-warning btn-wide d-block ',
                        action: function() {
                            ctrl.quantity = defaultValue;
                            return false;
                        }
                    },
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide',
                    },
                    ok: {
                        text: gettextCatalog.getString('Confirm'),
                        keys: ['enter'],
                        btnClass: 'btn-success pull-right btn-wide',
                        action: actionFcn
                    }
                }
             });   
        }

        ctrl.promptDealSize = function(supplier) {
            var initialIndividualMax = ctrl.dealSizeOptions ? ctrl.dealSizeOptions.max : null;
            initialIndividualMax = supplier.dealSize || initialIndividualMax || ctrl.dealSize;
            ctrl.quantity = initialIndividualMax;
            var content = '<input autocomplete="off" autofocus type="number" ng-model="$ctrl.quantity" id="quantity" name="quantity" placeholder="" class="form-control">'
            quantityPrompt(gettextCatalog.getString('Max for') + ' ' + supplier.name, content, ctrl.dealSize, 
                function(scope) {
                    if ((Math.abs(initialIndividualMax - scope.$ctrl.quantity))/scope.$ctrl.quantity < 0.001) {
                        return; // Same value
                    }
                    if (ctrl.dealSizeOptions && ctrl.dealSizeOptions.step) {
                        scope.$ctrl.quantity = Math.floor(scope.$ctrl.quantity /  ctrl.dealSizeOptions.step) * ctrl.dealSizeOptions.step;
                    }
                    supplier.dealSize = scope.$ctrl.quantity;
                    if (!ctrl.hasDifferentDealSize(supplier)) {
                        supplier.dealSize = null;
                    }
                    storeRetailPrices();
                    scope.$apply();
                });
        }

        ctrl.promptRrp = function(supplier) {
            var initialPrice = supplier.rrp || ctrl.benchmarkPrice;
            ctrl.quantity = initialPrice;
            var content = '<input ng-currency currency-symbol="" fraction="{{$ctrl.priceDecimalDigits}}" autocomplete="off" autofocus type="text" ng-model="$ctrl.quantity" id="quantity" name="quantity" placeholder="" class="form-control">'
            quantityPrompt(gettextCatalog.getString('Price for') + ' ' + supplier.name, content, ctrl.benchmarkPrice, 
                function(scope) {
                    if (!scope.$ctrl.quantity || !Utils.isNumber(scope.$ctrl.quantity)) {
                        supplier.rrp = null;
                        supplier.rrpDiff = 0;
                        storeRetailPrices();
                        scope.$apply();
                        return;
                    }
                    supplier.rrp = scope.$ctrl.quantity;
                    supplier.rrpDiff = Utils.roundCurrencyValue(supplier.rrp - ctrl.benchmarkPrice);
                    if (!ctrl.hasDifferentPrice(supplier)) {
                        supplier.rrp = null;
                    }
                    storeRetailPrices();
                    scope.$apply();
                });        
        }

        ctrl.resetRetailPrices = function() {
            Utils.CreateConfirmation(gettextCatalog.getString('Reset prices')).result.then(function() {
                ctrl.retailPrices = [];
                ctrl.targetSuppliers.forEach(function (s) {
                    s.rrp = undefined;
                    s.dealSize = undefined;
                });
                ctrl.storeSelectedAccounts();
            });
        };

        ctrl.includeAll = function () {
            ctrl.targetSuppliers.forEach(function (s) {
                s.isEnabled = true;
            });
            ctrl.storeSelectedAccounts();
        };
        ctrl.excludeAll = function() {
            ctrl.targetSuppliers.forEach(function (s) {
                s.isEnabled = false;
            });
            ctrl.storeSelectedAccounts();
        };

        ctrl.hasDifferentPrice = function(supplier) {
            if (!supplier.rrp) {
                return false;
            }
            return Math.abs(supplier.rrpDiff) > ctrl.priceTolerance;
        };
        ctrl.hasDifferentDealSize = function(supplier) {
            if (!supplier.dealSize) {
                return false;
            }
            return supplier.dealSize !== ctrl.dealSize;
        };

        ctrl.hasLargelyDifferentPrice = function(supplier) {
            if (!supplier.rrp) {
                return false;
            }
            return Math.abs(supplier.rrpDiff) > ctrl.benchmarkPrice * 0.1;
        };

        ctrl.getEnableSuppliersCount = function () {
            if (!ctrl.targetSuppliers || !ctrl.targetSuppliers.length) {
                return 0;
            }
            return ctrl.targetSuppliers.filter(function (s) {
                return s.isEnabled;
            }).length;
        };

        ctrl.storeSelectedAccounts = function() {
            ctrl.users = [];
            ctrl.targetSuppliers.filter(function(s) {
                return s.isEnabled;
            }).forEach(function(s) {
                ctrl.users = ctrl.users.concat(s.accounts);
            });
            storeRetailPrices();
        };

        ctrl.supplierClicked = function (supplier) {
            if (ctrl.hideSupplierSelection) {
                return;
            }
            supplier.isEnabled = true; 
            ctrl.storeSelectedAccounts();
        }

        ctrl.benchmarkPriceChanged = function() {
            if (!ctrl.benchmarkPrice) {
                return;
            }
            ctrl.targetSuppliers.filter(function (s) {
                return s.isEnabled && s.rrpDiff;
            }).forEach(function (s) {
                s.rrp = ctrl.benchmarkPrice + s.rrpDiff;
            });
            storeRetailPrices();
        }

        function storeRetailPrices() { 
            ctrl.retailPrices = [];
            ctrl.targetSuppliers.filter(function (s) {
                return s.isEnabled;
            }).forEach(function (s) {
                ctrl.retailPrices.push({
                    retailer: s._id,
                    rrp: s.rrp,
                    dealSize: s.dealSize
                });
            });
        }

        function initPriceTolerance() {
            ctrl.priceDecimalDigits = ctrl.priceDecimalDigits || 2;
            ctrl.priceTolerance = 1 / Math.pow(10, ctrl.priceDecimalDigits);
        }

        function initTargetSuppliers() {
            ctrl.retailPrices = ctrl.retailPrices || [];
            var rrpMap = {};
            ctrl.retailPrices.forEach(function (rrpEntry) {
                rrpMap[rrpEntry.retailer] = rrpEntry;
            });

            ctrl.targetSuppliers = $rootScope.app.Auth.User.supplier.retailers.filter(function (retailer) {
                return retailer.accounts && retailer.accounts.length;
            }).map(function (retailer) {
                var targetSupplier = {
                    _id: retailer._id,
                    name: retailer.name,
                    imageUrl: retailer.imageUrl,
                    accounts: retailer.accounts,
                };
                if (rrpMap[targetSupplier._id]) {
                    targetSupplier.isEnabled = true;
                    targetSupplier.rrp = rrpMap[targetSupplier._id].rrp;
                    targetSupplier.rrpDiff = targetSupplier.rrp ? (targetSupplier.rrp - ctrl.benchmarkPrice) : 0;
                    targetSupplier.dealSize = rrpMap[targetSupplier._id].dealSize;
                }
                return targetSupplier;
            });
            ctrl.storeSelectedAccounts();
        }
      }

})();



(function () {
    'use strict';

    angular.module('app.deals').component('dealRequest', {
        controller: RequestController,
        controllerAs: '$ctrl',
        templateUrl: 'app/modules/deals/deal-request/deals.request.html'
    });

    /** @ngInject */
    function RequestController($state, $rootScope, $stateParams, $timeout, HttpService, Utils, RequestsService, DealsService, AlertService, gettextCatalog,
        $uibModal, DEAL_CATEGORY, DEAL_TARGET, CONSTANTS) {

        var ctrl = this;
        var LS_FILTER_KEY = 'REQUESTS_FILTER';
        ctrl.utils = Utils;
        ctrl.REQUEST_STATUS = CONSTANTS.REQUEST_STATUS;
        ctrl.paging = { current: 1, maxSize: 3, itemsPerPage: 10 };
        ctrl.filters = {};
        ctrl.requests = [];

        ctrl.FILTER_ROLES = {
            DISTRIBUTOR: 'DISTRIBUTOR',
            RETAILER: 'RETAILER'
        };
        ctrl.FILTER_TYPES = {
            ANY: 'ANY',
            SALE: 'SALE',
            PURCHASE: 'PURCHASE'
        };

        ctrl.$onInit = function () {
            init();
        };

        function init() {
            if (!$rootScope.app.Auth.User) {
                $timeout(init, 1000);
                return;
            }

            ctrl.filters = Utils.getItemLS(LS_FILTER_KEY) || {
                type: ctrl.FILTER_TYPES.ANY,
                role: ctrl.FILTER_ROLES.DISTRIBUTOR,
                hideCompleted: false
            };

            if (!Utils.getSettings().canSendRequests) {
                ctrl.filters.role = ctrl.FILTER_ROLES.DISTRIBUTOR;
            }
            else if ($stateParams.role) {
                ctrl.filters.role = $stateParams.role;
            }
            else if (!ctrl.filters.role) {
                ctrl.filters.role = ctrl.FILTER_ROLES.DISTRIBUTOR;
            }

            if ($stateParams.type) {
                ctrl.filters.type = $stateParams.type;
            }
            else if (!ctrl.filters.type) {
                ctrl.filters.type = ctrl.FILTER_TYPES.ANY;
            }

            ctrl.user = null;
            loadData($stateParams.id);
        }

        ctrl.switchTo = function (params) {
            params.id = null;
            $state.go('app.deals.request', params);
        }

        ctrl.onPage = function() {
            loadData();
        }

        function loadData(openRequestId) {
            Utils.setItemLS(LS_FILTER_KEY, ctrl.filters);

            var queryParams = {
                skip: ((ctrl.paging.current - 1) * ctrl.paging.itemsPerPage),
                limit: ctrl.paging.itemsPerPage,
            };

            var requestUrl = (ctrl.filters.role === ctrl.FILTER_ROLES.RETAILER) ? 'me/requests' : 'requests';

            if (ctrl.filters.type) {
                queryParams.type = ctrl.filters.type;
            }
            if (ctrl.filters.hideCompleted) {
                queryParams.hideCompleted = ctrl.filters.hideCompleted;
            }
            if (queryParams.type === ctrl.FILTER_TYPES.ANY) {
                delete queryParams.type;
            }

            // TODO: add export, and use requestParams = angular.copy(queryParams);
            HttpService.Get(requestUrl, queryParams).then(function (res) {
                ctrl.paging.count = res.count;
                ctrl.requests = res.requests;

                var newThreshold = moment().subtract(1, 'week');
                ctrl.requests.forEach(function (request) {
                    request.isRecent = ctrl.filters.role === ctrl.FILTER_ROLES.DISTRIBUTOR && newThreshold.isBefore(request.createdAt);
                    RequestsService.initRequest(request);
                    request.isGreyedOut = request.status && request.status !== ctrl.REQUEST_STATUS.PENDING && request.status !== ctrl.REQUEST_STATUS.RESPONDED;
                });

                if (openRequestId) {
                    ctrl.selectedRequestId = openRequestId;
                    ctrl.openRequestModal(openRequestId);
                }
            }, function (err) {
                $log.log(err);
            });
        }

        ctrl.openRequestModal = function (requestId) {
            if (!requestId) {
                return;
            }
            ctrl.selectedRequestId = requestId;
            HttpService.Get('requests/' + requestId).then(function (data) {
                var request = data;

                var dialog = $uibModal.open({
                    animation: true,
                    controller: 'RequestDetailsCtrl',
                    templateUrl: 'app/shared/templates/modals/request-details.tpl.html',
                    template: Utils.getTemplate('app/shared/templates/modals/request-details.tpl.html'),
                    size: 'lg',
                    windowClass: 'modal-window',
                    resolve: {
                        items: function () {
                            return {
                                request: request,
                                isSentRequest: ctrl.filters.role === ctrl.FILTER_ROLES.RETAILER,
                                isCropRequest: request.isPurchase,
                            };
                        }
                    }
                });
                dialog.result.then(function () {
                    loadData();
                });
            });
        }
    }

})();

(function() {
    'use strict';

    angular.module('app.deals').component('dealsReport', {
        controller: DealsReportCtrl,
        controllerAs: 'vm',
        templateUrl: 'app/modules/deals/deal-report/deals.report.html',
    });

  /*
   * @ngInject
   */
  function DealsReportCtrl($log, $state, HttpService, $anchorScroll, $location, $stateParams, $uibModal, $ngConfirm,
    Utils, DealsService, gettextCatalog, AlertService, ORDER_STATUS) {

    var vm = this;
    vm.utils = Utils;
    vm.dealsService = DealsService;
    vm.date = Date.now();
    vm.ORDER_STATUS = ORDER_STATUS;

    init();

    function init() {
      getDealById(true);
    }

    vm.refresh = function() {
      getDealById();
    };

    function getDealById(shouldOpenOrderDetails) {
        HttpService.Get('deals/' + $state.params.id).then(function(resp) {
          vm.deal = resp;

          var selectedOrderId = $stateParams.order;
          var selectedOrder = null;

          vm.deal.hasDealSize = vm.deal.dealSize && vm.deal.dealSize < 999999;
          vm.allOrdersQuantity = 0;
          vm.allOrdersAmount = 0;
          vm.deal.orders.filter(function(order) {
            return order.status !== ORDER_STATUS.INVALID && order.status !== ORDER_STATUS.REJECTED && order.status !== ORDER_STATUS.RESERVED
          }).forEach(function(order) {
            order.transactionAmount = order.unitPrice ? (order.unitPrice * order.amount) : (order.stripeResponse ? order.stripeResponse.amount / 100 : 0);
            order.isCategoryCrop = vm.isCategoryCrop();
            vm.allOrdersQuantity = vm.allOrdersQuantity + order.amount;
            vm.allOrdersAmount = vm.allOrdersAmount + order.transactionAmount;
            if (selectedOrderId === order._id) {
              selectedOrder = order;
            }
          });

          if (selectedOrder && shouldOpenOrderDetails) {
            vm.openOrderDetails(selectedOrder);
          }
 
          vm.orders = filterVisibleOrders(vm.deal.orders);
        })
        .catch(function(err) {
          $log.error('get deal by id', err);
        });
    }

    function filterVisibleOrders(orders) {
      vm.invalidOrdersCount = 0;
      return orders.filter(function (order) {
        if (order.status === ORDER_STATUS.INVALID || order.status === ORDER_STATUS.CANCELLED || order.status === ORDER_STATUS.REJECTED) {
          vm.invalidOrdersCount++;
          if (!vm.areInvalidOrdersVisible) {
            return false;
          }
        }
        return order.status !== ORDER_STATUS.RESERVED;
      });
    }

    vm.openOrderDetails = function(order) {

      if (!order) {
        return;
      }

      var dialog = $uibModal.open({
        animation: true,
        component: 'orderDetailsModal',
        size: 'lg',
        windowClass: 'modal-window',
        resolve: {
          modalData: function () {
            return {
              deal: vm.deal,
              order: order
            };
          }
        }
      });
      dialog.result.then(function(result) {
        if (result.newOrder) {
          openNewOrderModal(order);
          return;
        }
      });
    };

    // FIXME: move this order-details-modal component
    function openNewOrderModal(order) {
        $uibModal.open({
            animation: true,
            component: 'newOrder',
            windowClass: 'modal-window',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                modalData: function() {
                    return {
                      deal: vm.deal.distributorDeal,
                      user: order.user,
                      order: order
                    };
                }
            }
        }).result.then(function(orderData) {
          orderData.retailerOrder = order._id;
          HttpService.Post('me/deals/' + vm.deal.distributorDeal._id + '/orders', orderData)
            .then(function () {
              order.status = ORDER_STATUS.FORWARDED;
              getDealById();
              $ngConfirm({
                icon: 'fa fa-check-circle',
                type: 'green',
                title: gettextCatalog.getString('Order forwarded'),
                content: gettextCatalog.getString('Order forwarded to distributor. For details, go to the "Orders" page from the main menu.'),
                buttons: { OK: function () { } }
              });
            })
            .catch(function () {
              AlertService.error(gettextCatalog.getString('Error while creating order. Please try again.'));
            });
        });
    }

    vm.getOrderDiscount = function(order) {
      if (!order) {
        return 0;
      }
      if (order.discountPercent) {
        return order.discountPercent;
      }
      var unitPrice = order.transactionAmount / order.amount;
      return 100 * (vm.deal.benchmarkPrice - unitPrice) / vm.deal.benchmarkPrice;
    };

    vm.isDistributionCollection = function() {
      if (!vm.deal) {
        return false;
      }
      return vm.deal.distribution === 'delivery';
    };


    vm.isOrderCompleted = function(order) {
      if (!order) {
        return 0;
      }
      return order.status === ORDER_STATUS.COMPLETED;
    };
    vm.isOrderPending = function(order) {
      if (!order) {
        return 0;
      }
      return !order.status || order.status === ORDER_STATUS.VIEWED || order.status === ORDER_STATUS.PENDING;
    };
    vm.isOrderInvalid = function(order) {
      if (!order) {
        return 0;
      }
      return order.status === ORDER_STATUS.INVALID;
    };
    vm.isOrderPaid = function(order) {
      if (!order) {
        return 0;
      }
      return order.status === ORDER_STATUS.PAID;
    };

    vm.isCategoryCrop = function() {
      return vm.deal && vm.deal.categoryName &&
        vm.deal.categoryName === 'CROP';
    };

    vm.toggleInvalidOrders = function() {
      vm.orders = filterVisibleOrders(vm.deal.orders);
    }
  }
})();

/**
 * Created by Hafeez Rehman on 06/11/2017.
 */

(function() {
    'use strict';

    angular.module('app.deals').component('dealMap', {
        controller: DealMapController,
        controllerAs: '$ctrl',
        templateUrl: 'app/modules/deals/deal-map/deals.map.html',
        bindings: {

            radiusChanged: '&',
            viewUsers: '&',
            reloadUsers: '&',

            map: '=',
            searchBox: '<',
            allUsersFound: '=',
            
            users: '=',
            target: '=',
            radius: '=',
            system: '=',
            farmTypes: '=',   
            benchmarkPrice: '=',

        }
    });

    /** @ngInject */
    function DealMapController($scope, Utils, DealsService, DEAL_TARGET) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;
        ctrl.DEAL_TARGET = DEAL_TARGET;

        ctrl.lookup = {};
        ctrl.lookup.farmSystems = DealsService.getSystems();
        ctrl.lookup.farmTypes = DealsService.getFarmTypes();

        $scope.$watch('$ctrl.radius', function (nv, ov) {
            if (!ov || nv === ov) return;
            ctrl.reloadUsers();
        });
        $scope.$watch('$ctrl.farmTypes', function (nv, ov) {
            if (!ov || nv === ov) return;
            ctrl.reloadUsers();
        });
        $scope.$watch('$ctrl.system', function (nv, ov) {
            if ((!nv && !ov) || nv === ov) return;
            ctrl.reloadUsers();
        });

        ctrl.resetFilters = function () {
            ctrl.farmTypes = [];
            ctrl.system = '';
            ctrl.reloadUsers();
        };

        ctrl.$onInit = function() {
            // TODO: move map initialization here.  
        };
    }
})();

(function() {
  'use strict';

  angular.module('app.deals').component('dealsList', {
      controller: ListController,
      controllerAs: 'vm',
      templateUrl: 'app/modules/deals/deal-list/deals.list.html',
  });

  /** @ngInject */
  function ListController($state, $stateParams, $scope, $rootScope, $timeout, $log, $interval, $q,
    HttpService, CropService, DealsService, Utils, AlertService, gettextCatalog,
    DEAL_STATUS, DEAL_CATEGORY, DEAL_CONSTANTS, ORDER_STATUS, DEAL_TARGET) {
    var vm = this;

    vm.type = $stateParams.type || 'ACTIVE';

    vm.paging = { current: 1, maxSize: 3, itemsPerPage: 10 };
    vm.form = {};
    vm.filter = {};
    vm.deals = [];
    vm.selected = null;
    vm.DEAL_STATUS = DEAL_STATUS;
    vm.DEAL_CONSTANTS = DEAL_CONSTANTS;
    vm.DEAL_TARGET = DEAL_TARGET;

    vm.farmTypes = DealsService.getFarmTypes();

    vm.goToEditIfDraft = goToEditIfDraft;

    vm.utils = Utils;
    vm.dealsService = DealsService;

    vm.promiseRefresh;

    vm.$onInit = function() {
      vm.expandedRowId = $stateParams.dealId;
      if (!vm.expandedRowId) {
          window.localStorage.getItem(getLSKey());
      }
      vm.deals = [];
      loadDeals();
      vm.promiseRefresh = $interval(vm.refresh, 1000 * 60);

      initProductPublicCount();   
      
      if ($state.params.startIntro) {
        $timeout(function(){
          vm.startIntro();
        }, 500);        
      }
    };

    vm.startIntro = function () {
      Utils.startIntro([
        {
          element: '#deals-list-create-button',
          intro: gettextCatalog.getString('To create a new time-limited offer, click the green button.'),
        }
      ], {
        text: gettextCatalog.getString('Create new offer'),
        action: function() {
          vm.createNewSaleOffer(true);
        }
      });
    }

    function initProductPublicCount() {
      if (!$rootScope.app.Auth.User) {
        $timeout(initProductPublicCount, 1000); 
        return;
      }
      HttpService.Get('suppliers/' + $rootScope.app.Auth.User.supplier._id + '/products', { limit: 1 }).then(function (data) {
        vm.productPublicCount = data.countPublic;
      });
    }

    $scope.$on('$destroy',function(){
      if (vm.promiseRefresh) {
          $interval.cancel(vm.promiseRefresh);   
      }
    });

    function getLSKey() {
      return 'LS_SELECTED_DEAL_ID_' + vm.type;
    }

    vm.onPage = function(){
      if (vm.init) {
        loadDeals();
      }
    };

    vm.refresh = function() {
      $log.log('Refresh deal list')
      loadDeals();
    };

    vm.switchTo = function(params) {
      $state.go('app.deals.list', params);
    }

    function loadDeals() {
        var deferred = $q.defer();

        if (!vm.type) {
          vm.type = DEAL_STATUS.DRAFT;
        }
        if (vm.type === vm.DEAL_STATUS.EXPIRED) {
          vm.sortField = '-bookingEnd';
        }
        else if (vm.type === vm.DEAL_STATUS.ACTIVE) {
          vm.sortField = 'bookingStart';
        }
        else {
          vm.sortField = '-createdAt';
        }
        HttpService.Get('deals?type=' + vm.type + '&sort=' + vm.sortField + '&skip=' + ((vm.paging.current - 1) * vm.paging.itemsPerPage) + '&limit=' + vm.paging.itemsPerPage).then(function(data) {
          vm.paging.count = data.count;

          vm.deals = [];
          data.list.forEach(function(d) {
            d.expanded = false;
            d.ordersCount = {};
            d.hasDealSize = d.dealSize && d.dealSize < 999999;
            d.orders.forEach(function(order) {
              order.status = (!order.status || order.status === ORDER_STATUS.VIEWED) ? ORDER_STATUS.PENDING : order.status;
              order.status = (order.status === ORDER_STATUS.FORWARDED) ? ORDER_STATUS.COMPLETED : order.status;
              d.ordersCount[order.status] = 1 + (d.ordersCount[order.status] || 0);
            });           
            d.customUnit = DealsService.getUpdatedUnit(d.customUnit);         
            d.bookingEndInDays = -moment().diff(d.bookingEnd, 'hour') / 24; // eslint-disable-line no-undef
            d.bookingEndDiff = Utils.getDateDiff(d.bookingEnd);
            vm.deals.push(d);

            // TODO: move to API
            d.amountReserved = 0;
            if (vm.isTypeActive) {
              d.orders.forEach(function (order) { 
                if (order.status === ORDER_STATUS.RESERVED && moment().isBefore(order.modifyTimeExpiresAt)) {
                  d.amountReserved += order.amount;
                }
              });
            }

            d.soldOut = d.progress >= d.dealSize && !d.amountReserved;
          });
            
          vm.init = true;
          deferred.resolve();
        }, function(err) {
            $log.error('Error occurred loading lists.', err);
            deferred.reject(err);
        });

        return deferred.promise;
    }

    vm.createNewSaleOffer = function (startIntro) {
      DealsService.createNewDraft({
        product: $rootScope.app.Auth.User.products[0],
        categoryName: DEAL_CATEGORY.DEAL,
        startIntro: startIntro
      });
    };

    vm.createNewCropOffer = function () {
      DealsService.createNewDraft({
        categoryName: DEAL_CATEGORY.CROP
      });
    };

    vm.createOffer = function () {
      if (Utils.supplierHasProductTypeSell()) {
        vm.createNewCropOffer();
        return;
      }
      vm.createNewSaleOffer();
    };

    vm.hasMultipleChoiceCreateNew = function() {
      return Utils.supplierHasProductTypeSell() && Utils.supplierHasProductTypeBuy();
    }

    function goToEditIfDraft(deal) {
        if(deal.categoryName === DEAL_CATEGORY.CROP) {
          $state.go('app.crop.proc', {id: deal._id});
        } else {
          $state.go('app.deals.update', { id: deal._id, startIntro: $state.params.startIntro });
        }
    }

    vm.isCategoryCrop = function(deal) {
        return deal.hasOwnProperty('categoryName') && deal.categoryName === DEAL_CATEGORY.CROP;
    };
    vm.isTypeDraft = function() {
      return vm.type === vm.DEAL_STATUS.DRAFT;
    };
    vm.isTypeActive = function() {
      return vm.type === vm.DEAL_STATUS.ACTIVE;
    };
    vm.isTypeExpired = function() {
      return vm.type === vm.DEAL_STATUS.EXPIRED;
    };
    vm.toggleRowExpanded = function(d) {
      vm.expandedRowId = vm.expandedRowId === d._id ? null : d._id;
      window.localStorage.setItem(getLSKey(), vm.expandedRowId);
    };


    vm.goToProducts = function () {
      $state.go('app.products');
    }
  }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.dashboard', []);
})();
/**
 * Created by Hafeez Rehman on 10/12/2018.
 */
(function(){
    'use strict';

    angular
        .module('app.dashboard')
        .component('slider', {
            controller: dashboardSliderCtrl,
            bindings: {
              slides: '<'
            },
            controllerAs: 'ctrl',
            templateUrl: 'app/modules/dashboard/slider/slider.tpl.html'
        });

    function dashboardSliderCtrl($state, $timeout) {
        var ctrl = this;
        var options = {
            items: 1,
            rtl: true,
            autoplay: true,
            autoplayTimeout: 10000,
            autoplaySpeed: 700,
            loop: true,
            nav: false,
            navText: false,
            dots: false
        };

        ctrl.$onInit = function() {
            $timeout(function(){
                $(".owl-carousel.content-slider").owlCarousel(options);
                setupMagnifier();
            }, 400);
        };

        function setupMagnifier(){
            $(".owl-carousel").each(function() {
                $(this).find(".owl-item:not(.cloned) .owl-carousel--popup-img").magnificPopup({
                    type:"image",
                    gallery: {
                        enabled: true
                    },
                    image: {
                        titleSrc: function (item) {
                            var title = ctrl.slides[item.index].title;
                            var desc = ctrl.slides[item.index].text;
                            return '<strong>' + title + '</strong><div>' + desc + '</div>';
                        }
                    }
                });
            });
        }
    }
})();
/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.customers', []);
})();
/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.customers')
            .component('customersInvites', {
                controller: CustomerInvitesCtrl,
                controllerAs: '$ctrl',
                templateUrl: 'app/modules/customers/invites/customer-invites.html',
                bindings: {
                    refreshCustomers: '&'
                }
            });

    function CustomerInvitesCtrl($scope, $rootScope, $log, $interval, gettextCatalog, Utils, HttpService) {
        var ctrl = this;
        ctrl.utils = Utils;

        ctrl.$onInit = function() {
            loadInvites();
            $interval(loadInvites, 60000);
        };

        ctrl.accept = function(inv) {
            var msg = gettextCatalog.getString('<b>Accept</b> {name} as a new customer?').replace('{name}', inv.createdBy.name.first + ' ' + inv.createdBy.name.last);
            Utils.CreateConfirmation(msg).result.then(function () {
                var payload = {
                    acceptedAt: Date.now(),
                    acceptedBy: $rootScope.app.Auth.User._id
                };
                HttpService.Put('invites/' + inv._id, payload).then(function () {
                    loadInvites();
                    ctrl.refreshCustomers();
                }, function (err) {
                    $log.error(err);
                });
            });
        };

        ctrl.ignore = function (inv) {
            var msg = gettextCatalog.getString('<b>Ignore</b> {name}\'s request to become a customer?').replace('{name}', inv.createdBy.name.first + ' ' + inv.createdBy.name.last);
            Utils.CreateConfirmation(msg).result.then(function () {
                var payload = {
                    ignoredAt: Date.now(),
                    ignoredBy: $rootScope.app.Auth.User._id,
                    isValid: false
                };
                HttpService.Put('invites/' + inv._id, payload).then(function () {
                    loadInvites();
                }, function (err) {
                    $log.error(err);
                });
            });
        };

        function loadInvites() {
            $log.log('Loading invites from customers.');
            HttpService.Get('me/invites').then(function(data) {
                ctrl.Invites = data.invites;
            }, function(err) {
                $log.error(err);
            });
        }
    }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.auth', [])
        .value('postLoginRedirect', { url: '/' })
        .run(function($rootScope, $state, $transitions, AuthFactory) {
            $transitions.onStart({}, function() {
                if(!AuthFactory.checkAuth()) {
                    AuthFactory.saveRedirectUrl();
                }
            });
        });
})();
/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.auth')
            .component('passwordReset', {
                controller: PasswordForm,
                controllerAs: '$ctrl',
                templateUrl: 'app/modules/auth/password/password.tpl.html'
            });

    function PasswordForm($state, $stateParams, $timeout, $scope, AuthFactory, gettextCatalog) {
        
        var ctrl = this;
        ctrl.loading = false;
        ctrl.error = null;
        ctrl.captcha = null;

        $scope.showPassword = true;

        ctrl.submit = function () {
            if(ctrl.form.$invalid) {
                ctrl.submitted = true;
                return false;
            }

            ctrl.submitted = true;
            ctrl.loading = true;
            AuthFactory.resetPassword($stateParams.token, { password: ctrl.password }).then(function (res) {
                ctrl.loading = false;
                if (res.data && res.data.apiKey && res.data.role && res.data.role !== 'USER') {
                    AuthFactory.setupTokenAndGoToDashboard(res.data.apiKey, res.data.role);
                } else {
                    window.location = 'farmhedge://auth';
                }
            }, function (err) {
                  $timeout(function() {
                      ctrl.loading = false;
                      ctrl.submitted = false;

                      if([-1, 400].indexOf(err.status) >= 0)
                          ctrl.error = gettextCatalog.getString('Request Error: An error occurred while processing the request.');

                      if([500, 501].indexOf(err.status) >= 0)
                          ctrl.error = gettextCatalog.getString('Server Error: user authentication failed. Please report this to system administrator.');

                      if(err.status === 401) {
                          ctrl.error = gettextCatalog.getString('Unauthorized: invalid username or password.');
                      }

                  }, 1000);
              });
        };

        ctrl.checkPassword = function() {
            ctrl.form.Password.$setValidity('minlength', false);
            ctrl.form.Password.$setValidity('noletterupper', false);
            ctrl.form.Password.$setValidity('noletterlower', false);
            ctrl.form.Password.$setValidity('nodigit', false);

            var password = ctrl.password;
            if (!password) {
                return;
            }

            if (password.length >= 8) {
                ctrl.form.Password.$setValidity('minlength', true);
            }
            if (password.search(/[a-z]/) >= 0) {
                ctrl.form.Password.$setValidity('noletterlower', true);
            }
            if (password.search(/[A-Z]/) >= 0) {
                ctrl.form.Password.$setValidity('noletterupper', true);
            }
            if (password.search(/[0-9]/) >= 0) {
                ctrl.form.Password.$setValidity('nodigit', true);
            }
        }
    }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.auth')
            .component('authForm', {
                controller: AuthForm,
                controllerAs: 'vm',
                templateUrl: 'app/modules/auth/login/auth.login.view.html'
            });

    function AuthForm($state, $timeout, vcRecaptchaService, AuthFactory, APP_CAPTCHA_CONFIG, gettextCatalog) {
        var vm = this;
        this.form = {};
        vm.loadingImg = '';
        vm.loading = false;
        vm.error = null;
        vm.captcha = false;

        var ROLE_COMMERCIAL_PARTNER = 'COMMERCIAL PARTNER';

        vm.doLogin = function () {

          if(vm.form.login.$invalid) {
              vm.submitted = true;
              return false;
          }

          vm.submitted = true;
          vm.loading = true;
          AuthFactory.login(vm.user).then(function () {
              vm.loading = false;
          }, function (err) {
              $timeout(function(){
                  vm.loading = false;
                  vm.submitted = false;

                  if([-1, 400].indexOf(err.status) >= 0)
                      vm.error = gettextCatalog.getString('Request Error: An error occurred while processing the request.');

                  if([500, 501].indexOf(err.status) >= 0)
                      vm.error = gettextCatalog.getString('Server Error: user authentication failed. Please report this to system administrator.');

                  if(err.status === 401) {
                      vm.error = gettextCatalog.getString('Unauthorized: invalid username or password.');
                  }

              }, 1000);
          });
        };

        vm.requestPassReset = function() {
            if(vm.form.passreset.$invalid) {
                vm.submitted = true;
                return false;
            }
            vm.passResetObj.role = ROLE_COMMERCIAL_PARTNER;
            AuthFactory.requestPassReset(vm.passResetObj).then(function() {
                vm.passResetSuccess = true;
            });
        };

        vm.toggleForgotPassMode = function() {
            vm.forgotPassMode = !vm.forgotPassMode;
            vm.passResetSuccess = false;
            vm.submitted = false;
            if(vm.forgotPassMode) {
                vm.passResetObj = { 
                    email: vm.user.email 
                };
            }
        };

        vm.$onInit = function() {
            if (AuthFactory.checkAuth()) {
                // TODO: remove when dashboard is localized to HU
                if (gettextCatalog.getCurrentLanguage().indexOf('hu')  < 0) {
                    $state.go('app.dashboard');
                 }
                 else {
                    $state.go('app.deals.list');
                 }
            }
        };
    }
})();

/**
 * Created by Hafeez Rehman on 24/12/2018.
 */

(function () {
    'use strict';

    angular
        .module('app.auth')
        .component('registerInvite', {
            controller: InviteCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/modules/auth/invitation/invite.tpl.html',
            bindings: { invitation: '<' }
        });

    function InviteCtrl($scope, $stateParams, $q, $timeout, $log, $anchorScroll, Utils, AuthFactory, gettextCatalog, HttpService, CONSTANTS) {
        $scope.showPassword = true;
        var ctrl = this;
        ctrl.loading = false;
        ctrl.error = null;
        ctrl.captcha = null;
        ctrl.utils = Utils;

        var MOBILE_OS = {
            ANDROID: 'ANDROID', 
            IOS: 'IOS',
            UNKNOWN: 'UNKNOWN'
        }

        ctrl.$onInit = function () {
            ctrl.invitation.expired = !ctrl.invitation.isValid;
            if (ctrl.invitation.role === CONSTANTS.USER_ROLES.USER && ctrl.invitation.expired) {
                ctrl.goToMobileApp();
                return false;
            }
            if (ctrl.invitation.expired) {
                return false;
            }
            if (ctrl.invitation.supplier && ctrl.invitation.supplier.area) {
                setLocaleCountry(ctrl.invitation.supplier.area)
            }

            ctrl.hideRegistrationForm = ctrl.invitation.isUserRegistered && (ctrl.invitation.role === CONSTANTS.USER_ROLES.USER);
            ctrl.user = {
                name: ctrl.invitation.name,
                email: ctrl.invitation.email,
                phoneNumber: ctrl.invitation.phoneNumber || '',
                supplier: ctrl.invitation.supplier || '',
                password: undefined
            };
            ctrl.user.isEmailDisabled = !!ctrl.user.email;
            ctrl.user.isPhoneNumberDisabled = !!ctrl.user.phoneNumber;

            if (ctrl.invitation.createdBy.name) {
                ctrl.invitation.createdBy.nameFull = ctrl.invitation.createdBy.name.first + ' ' + ctrl.invitation.createdBy.name.last;
            }
        };

        ctrl.acceptInvite = function() {
            var user = {
                name: ctrl.user.name,
                email: ctrl.user.email,
                phoneNumber: ctrl.user.phoneNumber,
                password: ctrl.user.password,
                supplier: ctrl.user.supplier
            };
            var payload = {
                token: $stateParams.token,
                user: user,
                invite: ctrl.invitation
            };
            ctrl.loading = true;
            HttpService.Post('invites/' + ctrl.invitation._id + '/accept', payload)
                .then(function (res) {
                    ctrl.loading = false;
                    if (ctrl.invitation.role === CONSTANTS.USER_ROLES.USER) {
                        ctrl.goToMobileApp();
                        return;
                    }
                    $timeout(function () {
                        AuthFactory.setupTokenAndGoToDashboard(res.data.apiKey, res.data.role);
                    }, 1000);
                })
                .catch(function(err) {
                    $log.log('ERROR', err);
                    ctrl.loading = false;
                })
        };

        ctrl.checkEmailAndPhone = function() {
            if (ctrl.invitation.role !== CONSTANTS.USER_ROLES.USER) {
                return Promise.resolve();
            }
            var deferred = $q.defer();
            var params = {
                email: ctrl.user.email
            };
            ctrl.form.Email.$setValidity('alreadyregistered', true);
            ctrl.form.Phone.$setValidity('alreadyregistered', true);
            HttpService.Get('users/check', params).then(function (res) {
                if (res.exists === false) {
                    deferred.resolve();
                    return;
                }
                deferred.reject(res.field);
                if (res.field === 'email') {
                    ctrl.form.Email.$setValidity('alreadyregistered', false);
                }
                else {
                    ctrl.form.Phone.$setValidity('alreadyregistered', false);
                }
            });
            return deferred.promise;
        }

        ctrl.submitForm = function () {
            ctrl.form.$setSubmitted();
            if (ctrl.form.$invalid) {
                $anchorScroll('inviteForm');
                return false;
            }
            ctrl.checkEmailAndPhone().then(function() {   
                ctrl.acceptInvite();
            }).catch(function() {
                $anchorScroll('inviteForm');
            });
        };

        ctrl.togglePasswordVisibility = function() {
            ctrl.form.Password.attr("type", "text");
        };

        ctrl.checkPassword = function() {
            ctrl.form.Password.$setValidity('minlength', false);
            ctrl.form.Password.$setValidity('noletter', false);
            ctrl.form.Password.$setValidity('nodigit', false);

            var password = ctrl.user.password;
            if (!password) {
                return;
            }

            if (password.length >= 8) {
                ctrl.form.Password.$setValidity('minlength', true);
            }
            if (password.search(/[a-zA-Z]/) >= 0) {
                ctrl.form.Password.$setValidity('noletter', true);
            }
            if (password.search(/[0-9]/) >= 0) {
                ctrl.form.Password.$setValidity('nodigit', true);
            }
        };

        function setLocaleCountry(supplierCountry) {
            supplierCountry = supplierCountry.toLowerCase();
            var country = Utils.altFind(CONSTANTS.COUNTRIES_DATA, function(country) {
                return country.id === supplierCountry;
            });
            if (country) {
                $log.log('Found locale for supplier: ', country.locale);
                gettextCatalog.setCurrentLanguage(country.locale);
            }
        }

        function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/android/i.test(userAgent)) {
                return MOBILE_OS.ANDROID;
            }
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return MOBILE_OS.IOS;
            }
            return MOBILE_OS.UNKNOWN;
        }

        ctrl.goToMobileApp = function () {
            $log.log('Invites: Rediecting to mobile app');
            window.scrollTo(0, 0);
            ctrl.promptAppDownload = true;

            var mobileOS = getMobileOperatingSystem();
            $log.log('Deteceted mobile OS:', mobileOS);
            if (mobileOS === MOBILE_OS.ANDROID) {
                window.location = 'https://play.google.com/store/apps/details?id=io.farmhedge';
                return;
            }
            if (mobileOS === MOBILE_OS.IOS) {
                window.location = 'https://apps.apple.com/ie/app/farmhedge-dev/id1059744999';
                return;
            }
        }
    }
})();

/**
 * Created by Hafeez Rehman on 20/04/2019.
 */
(function () {
    'use strict';

    angular
        .module('app.commons')
        .directive('checkStrength', function () {
            return {
                replace: false,
                restrict: 'EACM',
                link: function (scope, iElement, iAttrs) {
                    $(document).on('keydown', iElement, function(e) {
                        if (e.keyCode == 32) return false;
                    });
                    var strength = {
                        colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                        measureStrength: function (p) {
                            var _force = 0;
                            var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // eslint-disable-line no-useless-escape

                            var _lowerLetters = /[a-z]+/.test(p);
                            var _upperLetters = /[A-Z]+/.test(p);
                            var _numbers = /[0-9]+/.test(p);
                            var _symbols = _regex.test(p);

                            var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                            var _passedMatches = $.grep(_flags, function (el) { return el === true; }).length;

                            _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                            _force += _passedMatches * 10;

                            // check for shortness of password
                            _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                            // Check for ppor variety of characters in password
                            _force = (_passedMatches == 1) ? Math.min(_force, 10) : _force;
                            _force = (_passedMatches == 2) ? Math.min(_force, 20) : _force;
                            _force = (_passedMatches == 3) ? Math.min(_force, 40) : _force;

                            return {
                                lower: _lowerLetters,
                                capital: _upperLetters,
                                number: _numbers,
                                special: _symbols,
                                overall: _force
                            };
                        },
                        getColor: function (s) {

                            var idx = 0;
                            if (s <= 10) { idx = 0; }
                            else if (s <= 20) { idx = 1; }
                            else if (s <= 30) { idx = 2; }
                            else if (s <= 40) { idx = 3; }
                            else { idx = 4; }

                            return { idx: idx + 1, col: this.colors[idx] };

                        }
                    };

                    scope.$watch(iAttrs.checkStrength, function (val) {
                        if (val === '' || !val) {
                            iElement.css({ "display": "none"  });
                        } else {
                            scope.strength = strength.measureStrength(val);
                            var c = strength.getColor(strength.measureStrength(val).overall);
                            iElement.css({ "display": "inline" });
                            iElement.children('li')
                                .css({ "background": "#DDD" })
                                .slice(0, c.idx)
                                .css({ "background": c.col });
                        }
                    });
                },
                templateUrl: 'app/app-commons/directives/pass-strength/pass-strength.tpl.html'
            };
        });
})();
(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('uploadImage', {
            controller: UploadImageCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/upload-image/upload-image.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    // Moved from modals.js on Sep2019 (explains useage of $scope instead of ctrl)
    function UploadImageCtrl($scope, $rootScope, $log, $http, ProductsService, Upload, Utils, API_CONFIG) {
        var ctrl = this;
        ctrl.utils = Utils;

        $scope.Form = {};
        ctrl.imgUrlList = [];

        init();
        function init() {
            var urlMap = {};
            // TODO: move to api /me/media
            ctrl.loading = true;
            ProductsService.getFilteredProducts('', 50).then(function(products) {

                urlMap[$rootScope.app.Auth.User.imageUrl] = true;
                urlMap[$rootScope.app.Auth.User.supplier.imageUrl] = true;
                
                products.filter(function (product) {
                    return product.imageUrls && product.imageUrls.length;
                }).forEach(function (product) {
                    product.imageUrls.filter(function(url) {
                        return url && url.trim().length > 0;
                    }).forEach(function (url) {
                        urlMap[url] = true;
                    });
                });
                ctrl.imgUrlList = Object.keys(urlMap);

                appendStockImages();
            });
            
        }

        function appendStockImages() {
            ctrl.imgUrlList = ctrl.imgUrlList || [];

            var req = {
                method: 'GET',
                url: 'https://api.pexels.com/v1/search?query=farming&per_page=50',
                headers: {
                    'Authorization': '563492ad6f9170000100000144d3840082b54a24aa40696764cf6f58'
                }
            };
            $http(req, { cache: true }).then(function (res) {
                ctrl.loading = false;
                if (!res || !res.data || !res.data.photos) {
                    return;
                }
                var stockImages = (res.data.photos.map(function (p) {
                    return p.src.medium;
                })).filter(function(img) {
                    // Image black list
                    return img.indexOf('2704048') < 0 && img.indexOf('257849') < 0;
                });
                ctrl.imgUrlList = ctrl.imgUrlList.concat(stockImages);
            }, function() {
                ctrl.loading = false;
            });
        }

        $scope.selectImage = function (imgUrl) {
            ctrl.modalInstance.close(imgUrl);
        };

        $scope.onFileSelect = function (files) {
            selectFirstValidFile(files);
        };

        function selectFirstValidFile(files) {
            if (!files || !files.length) {
                ctrl.invalidFiles = true;
                return;
            }
            $log.log('Showing preview for file');
            ctrl.selectedFile = files[0];
            var reader = new FileReader();
            reader.readAsDataURL(ctrl.selectedFile);
            reader.onload = function (e) {
                $scope.$apply(function () {
                    $scope.filepreview = e.target.result;
                });
            };
        }
        
        $scope.resetFile = function () {
            $scope.filepreview = null;
        };

        $scope.ok = function () {
            if (!ctrl.selectedFile || ctrl.selectedFile.$error) {
                return;
            }
            $scope.Form.imgForm.$setSubmitted();
            Upload.upload({
                url: API_CONFIG.apiPrefix + 'assets/images',
                data: {
                    imageFile: ctrl.selectedFile,
                    imageName: ctrl.selectedFile.name
                }
            }).then(onResponse, errorHandler, trackProgress);
            
            function onResponse(res) {
                $scope.resetFile();
                $scope.uploading = false;
                ctrl.modalInstance.close(res.data.url);
            }
            function errorHandler(res) {
                $log.error(res);
            }
            function trackProgress(e) {
                if (e.lengthComputable) {
                    $scope.uploadProgress = parseInt(100.0 * (e.loaded / e.total));
                } else {
                    $scope.uploadProgress = -1;
                }
            }
        };

        $scope.cancel = function () {
            ctrl.modalInstance.dismiss('cancel');
        };
        
    }
})();

(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('uploadAttachment', {
            controller: UploadAttachmentCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/upload-attachment/upload-attachment.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function UploadAttachmentCtrl($scope, $log, Upload, Utils, API_CONFIG) {
        var ctrl = this;
        ctrl.utils = Utils;

        ctrl.attachment = {};

        ctrl.$onInit = function() {
            if (ctrl.resolve && ctrl.resolve.attachment) {
                ctrl.attachment = angular.copy(ctrl.resolve.attachment);
            }
        }

        $scope.onFileSelect = function (files) {
            if (!files || !files.length) {
                ctrl.invalidFile = true;
                return;
            }
            $log.log('Showing preview for file');
            ctrl.selectedFile = files[0];

            $log.log('UploadAttachement: Starting upload for file: ', ctrl.selectedFile.name);
            

            if (!ctrl.selectedFile.name || !/^.*\.(pdf)$/.test(ctrl.selectedFile.name.toLowerCase())) {
                ctrl.invalidFile = true;
                return;
            }
            ctrl.attachment.name = ctrl.selectedFile.name.trim(); 

            ctrl.invalidFile = false;
            ctrl.uploading = true;
            Upload.upload({
                url: API_CONFIG.apiPrefix + 'assets/attachments',
                data: {
                    file: ctrl.selectedFile,
                    name: ctrl.attachment.name.replace(/\s/g, '_'),
                    ContentType: 'application/pdf'
                }
            }).then(onResponse, errorHandler, trackProgress);

            function onResponse(res) {
                ctrl.uploading = false;
                $scope.uploading = false;
                ctrl.attachment.url = res.data.url;
                
            }
            function errorHandler(res) {
                ctrl.invalidFile = true;
                ctrl.uploading = false;
                $log.error(res);
            }
            function trackProgress(e) {
                if (e.lengthComputable) {
                    $scope.uploadProgress = parseInt(100.0 * (e.loaded / e.total));
                } else {
                    $scope.uploadProgress = -1;
                }
            }
        };

        

        ctrl.ok = function () {
            $scope.Form.imgForm.$setSubmitted();

            if (!ctrl.attachment.name || !ctrl.attachment.url) {
                return;
            }

            ctrl.modalInstance.close({
                url: ctrl.attachment.url,
                name: ctrl.attachment.name
            });
        };

        ctrl.cancel = function () {
            ctrl.modalInstance.dismiss('cancel');
        };
        
    }
})();

(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('statusBadge', {
            controller: StatusBadgeCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/status-badge/status-badge.html',
            bindings: { 
                status: '=',
            }
        });

    function StatusBadgeCtrl(gettextCatalog, Utils, CONSTANTS) {
        var ctrl = this;
        ctrl.STATUS = CONSTANTS.REQUEST_STATUS;

        ctrl.STATUS_MAPPINGS = [
            { status: CONSTANTS.REQUEST_STATUS.PENDING, label: gettextCatalog.getString('Pending'), cssClass: 'pending ' },
            { status: CONSTANTS.REQUEST_STATUS.RESPONDED, label: gettextCatalog.getString('Offer sent'), cssClass: 'paid' },
            { status: CONSTANTS.REQUEST_STATUS.COMPLETED, label: gettextCatalog.getString('Completed'), cssClass: 'completed' },
            { status: CONSTANTS.REQUEST_STATUS.FULFILLED, label: gettextCatalog.getString('Completed'), cssClass: 'completed' },
            { status: CONSTANTS.REQUEST_STATUS.REJECTED, label: gettextCatalog.getString('Rejected'), cssClass: 'rejected' },
            { status: CONSTANTS.REQUEST_STATUS.CANCELLED, label: gettextCatalog.getString('Cancelled'), cssClass: 'rejected' },
        ]

        ctrl.$onInit = function () {
            ctrl.statusData = Utils.altFind(ctrl.STATUS_MAPPINGS, function(item) {
                return item.status === ctrl.status;
            });
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('selectProduct', {
            controller: SelectProductCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/select-product/select-product.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function SelectProductCtrl($log, Utils, ProductsService) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.products = [];
        ctrl.searchText = '';
        ctrl.loading = true;

        ctrl.$onInit = function() {
            ctrl.searchProducts();
        }

        ctrl.searchProducts = function() {
            ProductsService.getFilteredProducts(ctrl.searchText, 30).then(function(res) {
                ctrl.products = res;
                ctrl.loading = false;
            });
        }

        ctrl.createProduct = function () {
            if (!ctrl.searchText) {
                return;
            }
            
            ctrl.selectProduct({
                name: ctrl.searchText.trim(),
                vendorProductId: ctrl.newVendorProductId
            });
        };

        ctrl.selectProduct = function (prod) {
            if (prod._id) {
                ctrl.modalInstance.close(prod);
                return;
            }
            ProductsService.createProduct(prod).then(function (res) {
                prod._id = res.data._id;
                $log.log('Created product', prod._id);
                ctrl.modalInstance.close(prod);
            });
        };

        ctrl.cancel = function () {
            ctrl.modalInstance.dismiss('cancel');
        };
    }
})();
/**
 * Created by Hafeez Rehman on 01/02/2019.
 */

(function() {
    'use strict';

    function richTextController($log) {
        var ctrl = this;
        $log.log('Rich Text Editor Loaded');
        ctrl.$onInit = function () {
            ctrl.readOnly = false;
            ctrl.required = 'required';

            registerDelegates();
        };

        function registerDelegates() {
            ctrl.editorCreated = function () {
            };

            ctrl.contentChanged = function (editor, html) {
                ctrl.ngModel = html;
            };

            ctrl.selectionChanged = function () {
            };
        }
    }

    angular
        .module('app.commons')
            .component('richTextEditor', {
                bindings: {
                    ngModel: '='
                },
                controllerAs: '$ctrl',
                controller: richTextController,
                templateUrl: 'app/app-commons/components/richtext-editor/richtext-editor.html'
            });
})();
(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('productAttributesEdit', {
            controller: ProductAttributesEdit,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/product-attributes-edit/product-attributes-edit.tpl.html',
            bindings: { 
                attributes: '=',
                defaultPreset: '=',
                readOnly: '='
            }
        });

    function ProductAttributesEdit($scope, $rootScope, $ngConfirm, $timeout, gettextCatalog, CropService, Utils) {
        var ctrl = this;

        ctrl.labelOptions = [
            'Protein', 'Hektolitergewicht',
            'Fallzahl', 'Feuchte', 'Besatz',
            'Sedimentationswert', 'Mutterkorn', 'Vollgerste',
            'Keimfähigkeit', 'Bruchkorn', 'Olgehalt',
            'Auswuchs',
            'Schwarzbesatz', 'Weißbesatz', 'Stechapfelsamen',
            'Ambrosiasamen', 'Farbe', 'Deoxynivalenol (DON)',
            'Zearalenon (ZEA)', 'Aflatoxine', 
            'Feuchtigkeit', 'Besatz', 'FFA',
            'Wassergehalt', 'Besatz', 'Reinheit',
            'Schwarze Sonnenblumenkerne', 'Stossung', 'Ambrosia',
            'Kleber',
        ];

        
        ctrl.attributePresets = [];

        ctrl.editAttributes = function() {
            if (ctrl.readOnly) {
                return;
            }
            ctrl.attributes = ctrl.attributes || [];

            ctrl.editedAttributes = ctrl.attributes.map(function (a) {
                return { label: a.label, value: a.value };
            });
            ctrl.attributePresets = ctrl.fetchAttributePresets();

            if (!ctrl.attributes.length && ctrl.defaultPreset) {
                ctrl.selectedPreset = Utils.altFind(ctrl.attributePresets, function (p) {
                    return p.label === ctrl.defaultPreset;
                });
                if (ctrl.selectedPreset) {
                    ctrl.loadSelectedPreset();
                } else {
                    ctrl.clearAttributes();
                }
            }
            else if (!ctrl.attributes.length) {
                ctrl.clearAttributes();
            }

            $ngConfirm({
                icon: 'fa fa-edit',
                title: gettextCatalog.getString('Product attributes'),
                scope: $scope,
                columnClass: 'medium',
                contentUrl: 'app/app-commons/components/product-attributes-edit/product-attributes-edit-prompt.tpl.html',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide',
                        action: function() {
                            $timeout(function () {
                                ctrl.cancelEdit();
                            }, 100);
                        }
                    },
                    ok: {
                        text: gettextCatalog.getString('Confirm'),
                        btnClass: 'btn-success btn-wide',
                        action: function () {
                            $timeout(function () {
                                ctrl.confirmEdit();
                            }, 100);
                        }
                    }
                }
            });
        }
        
        ctrl.cancelEdit = function () {
        }

        ctrl.confirmEdit = function() {
            ctrl.attributes = ctrl.editedAttributes.filter(function (a) {
                return a.label || a.value;
            });
        }

        ctrl.addAttribute = function () {
            ctrl.editedAttributes.push({ label: '', value: '' });
            ctrl.attributesChanged();
        }

        function convertCropTypeToProductAttributes(ct) {
            if (!ct || !ct.qualityStandards || !ct.qualityStandards.length) {
                return [{ label: '', value: '' }];
            }
            return ct.qualityStandards.map(function (qs) {
                return {
                    label: qs.label,
                    value: (qs.limit ? qs.limit + ' ' : '') + qs.value + ' ' + qs.unit,
                }
            });
        }

        ctrl.attributesChanged = function() {
            if (!ctrl.attributePresets || !ctrl.attributePresets.length) {
                return;
            }
            ctrl.selectedPreset = ctrl.attributePresets[0];
        }

        ctrl.fetchAttributePresets = function () {
            var cropTypes = CropService.getCropTypes($rootScope.app.Auth.User.supplier);
            var presets = cropTypes.map(function(ct) {
                return { label: ct.label, attributes: convertCropTypeToProductAttributes(ct) };
            });
            presets.unshift({ label: gettextCatalog.getString('Custom'), attributes: [{ label: '', value: '' }] });
            return presets;
        }

        ctrl.loadSelectedPreset = function() {
            if (!ctrl.attributePresets || !ctrl.attributePresets.length || !ctrl.attributes || !ctrl.selectedPreset) {
                return;
            }
            ctrl.editedAttributes = ctrl.selectedPreset.attributes.map(function (a) {
                return { label: a.label, value: a.value };
            });
        }

        ctrl.removeAttribute = function(index) {
            if (index < 0 || index >= ctrl.editedAttributes.length) {
                return;
            }
            ctrl.editedAttributes.splice(index, 1);
            ctrl.attributesChanged();
        }

        ctrl.clearAttributes = function() {
            ctrl.editedAttributes = [{ label: '', value: '' }];
        }
    }
})();
/**
 * Created by Hafeez Rehman on 01/08/2019.
 */

(function(){
    'use strict';

    angular
        .module('app.commons')
        .component('pendingInvites', {
            controller: PendingInvitesCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/pending-invites/pending-invites.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function PendingInvitesCtrl(HttpService, Utils) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.paging = { current: 1, maxSize: 3, itemsPerPage: 20 };

        ctrl.$onInit = function () {
            ctrl.invites = ctrl.resolve.invites;

            var options = { 
                limit: ctrl.paging.itemsPerPage, 
                skip: (ctrl.paging.current-1) * ctrl.paging.itemsPerPage 
            };
            HttpService.Get('invites', options).then(function (data) {
                ctrl.invites = data.list;
                ctrl.pendingInvitesCount = +(data.headers('x-pending-count') || 0);
            });
        };

        ctrl.cancel = function() {
            ctrl.modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('orderDetails', {
            controller: OrderDetailsCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/order-details-directive/order-details-directive.tpl.html',
            bindings: { 
                order: '=',
                deal: '=',
                distributorDeal: '='
            }
        });

    function OrderDetailsCtrl(Utils, DealsService, ORDER_STATUS) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;
        ctrl.ORDER_STATUS = ORDER_STATUS;

        ctrl.$onInit = function() {
            if (ctrl.order.unitPrice) {
                ctrl.order.totalPrice = ctrl.order.totalPrice || (ctrl.order.unitPrice * ctrl.order.amount);
            }
            if (ctrl.deal) {
                ctrl.order.productName = ctrl.order.productName || ctrl.deal.productName;
                ctrl.order.vendorProductId = ctrl.order.vendorProductId || ctrl.deal.vendorProductId;
                ctrl.order.productAttributes = ctrl.order.productAttributes || ctrl.deal.productAttributes;
                ctrl.order.customUnit = ctrl.order.customUnit || ctrl.deal.customUnit;
                ctrl.order.customType = ctrl.order.customType || ctrl.deal.customType;
                ctrl.order.customType = ctrl.order.customType || ctrl.deal.customType;
                ctrl.order.currencySymbol = ctrl.order.currencySymbol || ctrl.deal.currencySymbol;
                ctrl.order.isVatIncluded = ctrl.order.isVatIncluded || ctrl.deal.isVatIncluded;
                ctrl.order.vatRate = ctrl.order.vatRate || ctrl.deal.vatRate;
                ctrl.order.attachments = ctrl.order.attachments || ctrl.deal.attachments;
            }
            if (!ctrl.order.childrenOrders || !ctrl.order.childrenOrders.length) {
                ctrl.childrenOrders = [ {
                    productName: ctrl.order.productName,
                    vendorProductId: ctrl.order.vendorProductId,
                    productAttributes: ctrl.order.productAttributes,
                    customUnit: ctrl.order.customUnit,
                    customType: ctrl.order.customType,
                    currencySymbol: ctrl.order.currencySymbol,
                    isVatIncluded: ctrl.order.isVatIncluded,
                    vatRate: ctrl.order.vatRate,
                    amount: ctrl.order.amount,
                    unitPrice: ctrl.order.unitPrice,
                    unitPriceText: ctrl.order.unitPriceText,
                    totalPrice: ctrl.order.totalPrice,
                    attachments: ctrl.order.attachments
                } ];
            }
            else {
                ctrl.childrenOrders = ctrl.order.childrenOrders;
            }
        }
    }
})();
(function(){
    'use strict';

    angular
        .module('app.commons')
        .component('newRequest', {
            controller: NewRequestCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/new-request/new-request.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function NewRequestCtrl($scope, $state, $rootScope, $ngConfirm, HttpService, AlertService, Utils, DealsService, gettextCatalog, CONSTANTS) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;
        ctrl.lookup = {};
        ctrl.lookup.units = DealsService.getProductUnits();
        ctrl.lookup.categories = DealsService.getProductTypes();
        ctrl.lookup.distributionMethods = DealsService.getDistributionMethods();

        ctrl.lookup.requestTypes = [
            gettextCatalog.getString('Buy'),
            gettextCatalog.getString('Sell')            
        ];
        
        ctrl.$onInit = function () {
            ctrl.deal = ctrl.resolve.modalData.deal || { supplier: {} };
            ctrl.deal.dealSizeOptions = ctrl.deal.dealSizeOptions || { min: 1, step: 1 };
            ctrl.deal.dealSizeOptions.min = ctrl.deal.dealSizeOptions.min || 1;
            ctrl.deal.dealSizeOptions.step = ctrl.deal.dealSizeOptions.step || 1;

            HttpService.Get('me/suppliers', { role: CONSTANTS.USER_ROLES.COMMERCIAL_PARTNER }).then(function(res) {
                ctrl.suppliers = res.suppliers;
                if (!ctrl.suppliers || !ctrl.suppliers.length) {
                    AlertService.error('An error occurred. The request cannot be submitted. Please contact support.');
                    ctrl.cancel();
                }
            });

            ctrl.request = { 
                suppliers: [ctrl.deal.supplier._id],
                product: ctrl.deal.product, 
                amount: ctrl.getMinAmount(),
                content: [ctrl.lookup.requestTypes[0]],
                category: ctrl.resolve.modalData.category,
                unit: ctrl.deal.customUnit || ctrl.lookup.units[0],
                distribution: ctrl.deal.distribution || ctrl.lookup.distributionMethods[0].value
            };            
        };

        ctrl.canChangeAmount = function() {
            return true;
        }

        ctrl.decreaseAmount = function () {
            var deal = ctrl.deal;
            ctrl.hasAgreedTerms = false
            ctrl.request.amount -= deal.dealSizeOptions.step;
            ctrl.checkAmount();
        };
        ctrl.increaseAmount = function () {
            var deal = ctrl.deal;
            ctrl.hasAgreedTerms = false
            ctrl.request.amount += deal.dealSizeOptions.step;
            ctrl.checkAmount();
        };
        ctrl.getMinAmount = function () {
            return ctrl.deal.dealSizeOptions.min;
        };
        ctrl.getMaxAmount = function () {
            return 999999999;
        };
        ctrl.checkAmount = function () {
            var deal = ctrl.deal;
            var minQt = ctrl.getMinAmount();
            if (ctrl.request.amount < minQt) {
                ctrl.request.amount = minQt;
            }
            var maxQt = ctrl.getMaxAmount();
            if (ctrl.request.amount > maxQt) {
                ctrl.request.amount = maxQt;
            }
            if (ctrl.request.amount % deal.dealSizeOptions.step !== 0) {
                ctrl.request.amount = Math.floor(ctrl.request.amount / deal.dealSizeOptions.step) * deal.dealSizeOptions.step;
            }
            ctrl.request.amount = Math.round(ctrl.request.amount * 100) / 100;
        }
        
        ctrl.ok = function() {
            ctrl.form.$setSubmitted();
            if (ctrl.form.$invalid) {
                return false;
            }

            if (ctrl.request.product) {
                ctrl.request.product = ctrl.request.product._id;
                ctrl.request.content.push(ctrl.deal.customType);
            }
            else if (ctrl.request.category) {
                ctrl.request.content = ctrl.request.content.concat(ctrl.request.category.split(' - '));
            }

            ctrl.request.value = ctrl.request.amount;
            ctrl.request.attributes = [{
                name: 'quantity',
                label: gettextCatalog.getString('Quantity'),
                value: ctrl.request.amount  
            }];

            if (ctrl.request.message) {
                ctrl.request.messages = [{
                    createdAt: Date.now(),
                    createdBy: $rootScope.app.Auth.User._id,
                    text: ctrl.request.message
                }];
            }
            ctrl.modalInstance.close(ctrl.request);            
        };

        ctrl.cancel = function() {
            ctrl.modalInstance.dismiss('cancel');
        };
    }
})();

(function(){
    'use strict';

    angular
        .module('app.commons')
        .component('newOrder', {
            controller: NewOrderCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/new-order/new-order.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function NewOrderCtrl($scope, $state, $rootScope, $ngConfirm, HttpService, AlertService, Utils, DealsService, gettextCatalog) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;
        
        ctrl.$onInit = function () {
            ctrl.deal = ctrl.resolve.modalData.deal;

            if (!ctrl.deal) {
                AlertService.error('An error occurred. A new order cannot be created for this offer. Please try again.');
                ctrl.cancel();
                return;
            }

            ctrl.product = ctrl.resolve.modalData.product;
            ctrl.user = ctrl.resolve.modalData.user;
            ctrl.order = { amount: ctrl.getMinAmount() };
            ctrl.order.billingAddress = ctrl.order.billingAddress || {};
            ctrl.order.deliveryAddress = ctrl.order.deliveryAddress || {};

            if (ctrl.resolve.modalData.order) {
                ctrl.order.amount = ctrl.resolve.modalData.order.amount;
                ctrl.order.deliveryAddress = ctrl.resolve.modalData.order.deliveryAddress;
            }

            if (ctrl.order && ctrl.order.deliveryAddress && ctrl.user && ctrl.user.name) {
                ctrl.order.deliveryAddress.name = ctrl.user.name.first + ' ' + ctrl.user.name.last;
                ctrl.order.phoneNumber = ctrl.user.phoneNumber;
            }
            if (ctrl.resolve.modalData.request && ctrl.user) {
                ctrl.request = ctrl.resolve.modalData.request;
                ctrl.order.amount = ctrl.request.quantity;
                ctrl.checkAmount();
                ctrl.customerSelected(ctrl.user);
            }

            if (moment(ctrl.deal.bookingEnd).diff(moment(), 'year') > 0) {
                ctrl.deal.bookingEnd = null;
            }
            
            ctrl.deal.dealSizeOptions = ctrl.deal.dealSizeOptions || { min: 1, step: 1 };
            ctrl.deal.dealSizeOptions.min = ctrl.deal.dealSizeOptions.min || 1;
            ctrl.deal.dealSizeOptions.step = ctrl.deal.dealSizeOptions.step || 1;

            ctrl.billingOpts = $rootScope.app.Auth.User.supplier.collectionPoints;

            setupBillingOpts();
            promptVariantSelection();
        };

        ctrl.canChangeAmount = function() {
            return true;
        }

        ctrl.decreaseAmount = function () {
            var deal = ctrl.deal;
            ctrl.hasAgreedTerms = false
            ctrl.order.amount -= deal.dealSizeOptions.step;
            ctrl.checkAmount();
        };
        ctrl.increaseAmount = function () {
            var deal = ctrl.deal;
            ctrl.hasAgreedTerms = false
            ctrl.order.amount += deal.dealSizeOptions.step;
            ctrl.checkAmount();
        };
        ctrl.getMinAmount = function () {
            return ctrl.deal.dealSizeOptions.min;
        };
        ctrl.getMaxAmount = function () {
            return DealsService.getAvailabilityForUser(ctrl.deal);
        };
        ctrl.checkAmount = function () {
            var deal = ctrl.deal;
            var minQt = ctrl.getMinAmount();
            if (ctrl.order.amount < minQt) {
                ctrl.order.amount = minQt;
            }
            var maxQt = ctrl.getMaxAmount();
            if (ctrl.order.amount > maxQt) {
                ctrl.order.amount = maxQt;
            }
            if (ctrl.order.amount % deal.dealSizeOptions.step !== 0) {
                ctrl.order.amount = Math.floor(ctrl.order.amount / deal.dealSizeOptions.step) * deal.dealSizeOptions.step;
            }
            ctrl.order.amount = Math.round(ctrl.order.amount * 100) / 100;
        }

        ctrl.setBillingData = function (value) {
            if (!value) {
                return;
            }
            ctrl.selectedCollectionPoint = value;
            if (!ctrl.selectedCollectionPoint) {
                return;
            }

            if (ctrl.selectedCollectionPoint.addressDetails && ctrl.selectedCollectionPoint.addressDetails.street) {
                ctrl.order.billingAddress = {
                    name: ctrl.selectedCollectionPoint.name,
                    street: ctrl.selectedCollectionPoint.addressDetails.street,
                    zipcode: ctrl.selectedCollectionPoint.addressDetails.zipcode,
                    city: ctrl.selectedCollectionPoint.addressDetails.city,
                };
                return;
            }

            ctrl.order.billingAddress = {
                name: ctrl.selectedCollectionPoint.name,
                street: ctrl.selectedCollectionPoint.address,
            };
            var addressParts = ctrl.selectedCollectionPoint.address.split(', ');
            if (addressParts.length <= 1) {
                return;
            }
            ctrl.order.billingAddress.street = addressParts[0];
            ctrl.order.billingAddress.city = addressParts[1]; 
            
            var cityParts = addressParts[1].split(' ');
            if (cityParts.length <= 1) {
                return;
            }
            ctrl.order.billingAddress.zipcode = cityParts[0]; 
            ctrl.order.billingAddress.city = cityParts.slice(1).join(' '); 
        }

        ctrl.copyCollectionPoint = function () {
            ctrl.order.deliveryAddress = angular.copy(ctrl.order.billingAddress);
        };
        ctrl.copyBillingAddress = function() {
            ctrl.order.deliveryAddress.street = ctrl.order.billingAddress.street;
            ctrl.order.deliveryAddress.zipcode = ctrl.order.billingAddress.zipcode;
            ctrl.order.deliveryAddress.city = ctrl.order.billingAddress.city;
        };

        ctrl.getCustomers = function (namePart, phoneNumberPart) {
            var payload = {
                limit: 8
            };
            if (namePart) {
                payload.name = namePart;
            }
            if (phoneNumberPart && phoneNumberPart !== '0' && phoneNumberPart !== '+') {
                payload.phoneNumber = phoneNumberPart;
                if (payload.phoneNumber[0] === '0' || payload.phoneNumber[0] === '+') {
                    payload.phoneNumber = payload.phoneNumber.slice(1);
                }
            }
            return HttpService.Get('users', payload).then(function (res) {
                var custList = [];
                res.list.forEach(function (u) {
                    u.fullName = u.name.first + ' ' + u.name.last;
                    custList.push(u);
                });
                return custList;
            }, function (err) {
                $log.err(err);
            });
        };

        ctrl.customerSelected = function (user) {
            HttpService.Get('users/' + user._id).then(function(res) {
                ctrl.user = res.user;

                ctrl.order.deliveryAddress.name = ctrl.user.name.first + ' ' + ctrl.user.name.last;
                ctrl.order.phoneNumber = ctrl.user.phoneNumber;
                ctrl.order.onBehalfOfUser = ctrl.user;

                ctrl.order.deliveryAddress.city = ctrl.user.address.city;
                ctrl.order.deliveryAddress.zipcode = ctrl.user.address.zipcode;
                ctrl.order.deliveryAddress.street = ctrl.user.address.street;
                setupBillingOpts();
            });
        };
        
        ctrl.ok = function() {
            ctrl.form.$setSubmitted();
            if (ctrl.form.$invalid || !ctrl.hasAgreedTerms) {
                return false;
            }

            ctrl.order.product = ctrl.selectedVariant.product;
            ctrl.order.productName = ctrl.selectedVariant.productName;
            if (Utils.isNumber(ctrl.selectedVariant.benchmarkPrice)) {
                ctrl.order.unitPrice = ctrl.selectedVariant.benchmarkPrice;
            } else {
                ctrl.order.unitPriceText = ctrl.selectedVariant.benchmarkPrice;
            }

            if (ctrl.order.phoneNumber || ctrl.dealsService.isCategoryCrop(ctrl.deal)) {
                ctrl.modalInstance.close(ctrl.order);
                return;
            }

            $ngConfirm({
                icon: 'fa fa-check-circle',
                title: gettextCatalog.getString('Confirm'),
                content: gettextCatalog.getString('You did not submit a phone number. Continue anyway?'),
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        btnClass: 'btn-dark btn-wide'
                    },
                    ok: {
                        text: gettextCatalog.getString('Confirm'),
                        btnClass: 'btn-success btn-wide',
                        action: function () {
                            ctrl.modalInstance.close(ctrl.order);
                        }
                    },
                },
            });

            
        };

        ctrl.cancel = function() {
            ctrl.modalInstance.dismiss('cancel');
        };

        function setupBillingOpts() {
            if (!ctrl.billingOpts || !ctrl.billingOpts.length) {
                return;
            }            
            if (ctrl.user && ctrl.user.supplierCustomers && ctrl.user.supplierCustomers.length && ctrl.user.supplierCustomers[0].collectionPointName) {
                ctrl.setBillingData(Utils.altFind(ctrl.billingOpts, function (bo) {
                    return bo.name && bo.name.toLowerCase() === ctrl.user.supplierCustomers[0].collectionPointName.toLowerCase();
                }));
                return;
            }
            if (ctrl.billingOpts && ctrl.billingOpts.length === 1) {
                ctrl.setBillingData(ctrl.billingOpts[0]);
            }
        }

        function promptVariantSelection() {
            ctrl.selectedVariant = {
                product: ctrl.deal.product,
                productName: ctrl.deal.productName || ctrl.deal.product.name,
                vendorProductId: ctrl.deal.vendorProductId || ctrl.deal.product.vendorProductId,
                benchmarkPrice: ctrl.deal.benchmarkPrice,
            };
            if (!ctrl.deal.variants || !ctrl.deal.variants.length) {
                return;
            }
            var variants = [ctrl.selectedVariant].concat(ctrl.deal.variants);

            if (ctrl.resolve.modalData.order && ctrl.resolve.modalData.order.product) {
                // Order with specific product.
                var matchingVariant = Utils.altFind(variants, function (v) {
                    return v.productName === ctrl.resolve.modalData.order.product.name;
                });
                if (matchingVariant) {
                    ctrl.selectedVariant = matchingVariant;
                    return;
                }
            }

            $scope.variantCtrl = {
                currencySymbol: ctrl.deal.currencySymbol,
                selectedProduct: ctrl.deal.product._id,
                unit: ctrl.deal.customUnit,
                variants: variants,
                selectedVariant: ctrl.selectedVariant
            };           

            $ngConfirm({
                title: gettextCatalog.getString('Select product'),
                scope: $scope,
                columnClass: 'medium',
                contentUrl: 'app/app-commons/components/new-order/new-order-select-variant.tpl.html',
                animation: 'bottom',
                closeAnimation: 'bottom',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide',
                        action: function () {}
                    },
                    ok: {
                        text: gettextCatalog.getString('Confirm'),
                        keys: ['enter'],
                        btnClass: 'btn-success btn-wide',
                        action: function (scope) {
                            ctrl.selectedVariant = scope.variantCtrl.selectedVariant;
                            ctrl.order = { amount: ctrl.getMinAmount() };
                            scope.$apply();
                        }
                    }
                }
            });
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('app.commons')
        .component('inviteCustomers', {
            controller: InviteCustomersCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/invite-customers/invite-customers.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function InviteCustomersCtrl($timeout, $q, $rootScope, gettextCatalog, HttpService, AlertService, Utils, CONSTANTS) {
        var ctrl = this;
        ctrl.utils = Utils;

        ctrl.MIN_PHONE_NUMBER_LENGTH = 6;

        ctrl.payload = {};
        ctrl.countriesData = CONSTANTS.COUNTRIES_DATA;
        ctrl.bulkPhoneNumbers = '';
        ctrl.countryExt = '+353';

        ctrl.$onInit = function () {
            ctrl.modalData = ctrl.resolve.modalData;
            ctrl.supplier = ctrl.modalData.supplier || $rootScope.app.Auth.User.supplier;

            if ($rootScope.app.Auth.User.supplier) {
                var currentCountry = Utils.altFind(ctrl.countriesData, function (country) {
                    return country.id === $rootScope.app.Auth.User.supplier.area.toLowerCase();
                });
                if (currentCountry) {
                    ctrl.countryExt = currentCountry.phonePrefix;
                }
            }

            ctrl.newInvitee = { ext: ctrl.countryExt, phoneNumber: undefined, email: undefined };

            var message = gettextCatalog.getString('Hi, it’s {contactName} from {supplierName}. I\'d like to invite you to FarmHedge to submit orders and send me product requests.')
                .replace('{contactName}', $rootScope.app.Auth.User.name.first + ' ' + $rootScope.app.Auth.User.name.last)
                .replace('{supplierName}', $rootScope.app.Auth.User.supplier.name)
            ctrl.payload = {  
                message: message,
                supplier: ctrl.supplier._id
            };
            if (Utils.isSupplierDistributor()) {
                ctrl.payload.invitees = [angular.copy(ctrl.newInvitee)];
                ctrl.payload.role = CONSTANTS.USER_ROLES.COMMERCIAL_PARTNER;
            }
            else {
                ctrl.payload.invitees = [angular.copy(ctrl.newInvitee)];
                ctrl.payload.role = CONSTANTS.USER_ROLES.USER;
            }

            // Update the with slight delay to update the form.
            $timeout(function() {
                ctrl.payload.sendEmail = !!Utils.isSupplierDistributor();
                ctrl.payload.sendSms = !Utils.isSupplierDistributor();
            }, 200);
        };

        ctrl.addItem = function() {
            ctrl.payload.invitees.unshift(angular.copy(ctrl.newInvitee));
            ctrl.payload.sendSms = true;
        };

        ctrl.removeItem = function(invitee, idx) {
            if(ctrl.payload.invitees.length > 1) {
                ctrl.payload.invitees.splice(idx, 1);
                return;
            }
            invitee.phoneNumber = '';
            invitee.existingCustomer = false;
        };

        ctrl.bulkAddPhoneNumbers = function() {
            if (ctrl.payload.invitees.length && !ctrl.payload.invitees[0].phoneNumber) {
                ctrl.payload.invitees.splice(0, 1);
            }
            var phoneNumbersMap = {}
            ctrl.payload.invitees.forEach(function(invitee) {
                phoneNumbersMap[invitee.phoneNumber] = true;
            });
            var phoneNumberList = ctrl.bulkPhoneNumbers.split(/[;,]+/); // eslint-disable-line
            phoneNumberList = phoneNumberList.filter(function (phoneNumber) {
                return !!phoneNumber;
            }).map(function(phoneNumber) {
                var invitee = ctrl.checkPhoneNumber({ phoneNumber: phoneNumber });
                invitee.ext = invitee.ext || ctrl.countryExt;
                return invitee;
            }).filter(function(invitee) {
                return invitee.phoneNumber;
            }).forEach(function(invitee) {
                if (!phoneNumbersMap[invitee.phoneNumber]) {
                    phoneNumbersMap[invitee.phoneNumber] = true;
                    ctrl.payload.invitees.push(invitee);
                }
            });
            ctrl.bulkPhoneNumbers = '';
            ctrl.payload.sendSms = true;            
        }

        ctrl.cleanPhoneNumber = function(invitee) {
            if (!invitee.phoneNumber) {
                return invitee;
            }
            var matchingCountry = Utils.altFind(ctrl.countriesData, function (country) {
                return invitee.phoneNumber.indexOf(country.phonePrefix) >= 0;
            });
            if (matchingCountry) {
                invitee.ext = matchingCountry.phonePrefix;
                invitee.phoneNumber = invitee.phoneNumber.replace(matchingCountry.phonePrefix, '');
            }
            invitee.phoneNumber = invitee.phoneNumber.replace(/\D/g, '');
            invitee.phoneNumber = invitee.phoneNumber.replace(/^0/g, '');
            return invitee;
        }

        ctrl.checkPhoneNumber = function(invitee) {
            invitee = ctrl.cleanPhoneNumber(invitee);
            if (!invitee.phoneNumber || invitee.phoneNumber.length < ctrl.MIN_PHONE_NUMBER_LENGTH) {
                return invitee;
            }
            HttpService.Get('users', { phoneNumber: invitee.phoneNumber }).then(function (resp) {
                if (!resp || !resp.list || !resp.list.length) {
                    invitee.existingCustomer = false;
                    return;
                }
                invitee.existingCustomer = resp.list[0];
            });
            return invitee;
        }

        function getValidInvitees() {
            return ctrl.payload.invitees.filter(function (invitee) {
                return (invitee.email || (invitee.phoneNumber && invitee.phoneNumber.length >= ctrl.MIN_PHONE_NUMBER_LENGTH)) && !invitee.existingCustomer;
            });
        }
        ctrl.getValidInviteesCount = function() {
            if (!ctrl.payload || !ctrl.payload.invitees || !ctrl.payload.invitees.length) {
                return 0;
            }
            return getValidInvitees().length;
        }

        ctrl.ok = function() {
            if (!ctrl.getValidInviteesCount()) {
                return false;
            }
            var addedPhoneNumbers = {};
            ctrl.payload.invitees = ctrl.payload.invitees.filter(function (invitee) {
                var isNew = !addedPhoneNumbers[invitee.phoneNumber];
                addedPhoneNumbers[invitee.phoneNumber] = true;
                return isNew;
            });

            sendInvites(getValidInvitees()).then(function (inviteData) {
                if (!ctrl.payload.sendSms && !ctrl.payload.sendEmail) {
                    ctrl.inviteData = inviteData;
                    return;
                }
                var invitesCount = inviteData.length || 1;
                AlertService.success(gettextCatalog.getString('Invites sent') + ' (' + invitesCount +  ')');
                ctrl.modalInstance.close({ success: true});
                return;
            });
        };

        function sendInvites(invitees) {
            var deferred = $q.defer();
            ctrl.loading = true;

            var payload = {
                role: ctrl.payload.role,
                supplier: ctrl.payload.supplier,
                message: ctrl.payload.message,
                sendSms: ctrl.payload.sendSms,
                sendEmail: ctrl.payload.sendEmail,
                locale: gettextCatalog.getCurrentLanguage()
            };
            
            if (invitees.length === 1 || Utils.isSupplierDistributor()) {
                var invitee = invitees[0];
                payload.email = invitee.email;
                if (invitee.phoneNumber) {
                    payload.phoneNumber = invitee.ext + invitee.phoneNumber;
                }
                HttpService.Post('invites', payload).then(function (resp) {
                    ctrl.loading = false;
                    deferred.resolve(resp.data.invite);
                });     
                return deferred.promise;
            }

            payload.phoneNumbers = invitees.map(function(invitee) {
                return invitee.ext + invitee.phoneNumber;
            });
            
            HttpService.Post('invites/bulk', payload).then(function (resp) {
                ctrl.loading = false;
                deferred.resolve(resp.data.invites);
            }).catch(function (err) {
                ctrl.loading = false;
                deferred.reject(err);
            });
            return deferred.promise;
        }

        ctrl.cancel = function() {
            ctrl.modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('inputPrice', {
            controller: InputPriceCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/input-price-directive/input-price-directive.tpl.html',
            bindings: { 
                deal: '=',
                form: '=',
                priceChanged: '=',
                disabled: '<',
                allowPriceOnRequest: '<',
                allowFreeText: '<',
            }
        });

    function InputPriceCtrl(gettextCatalog, Utils, DealsService) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;

        ctrl.$onInit = function() {
            ctrl.placeholder = ctrl.allowPriceOnRequest ? gettextCatalog.getString('On request') : '';
        }

        ctrl.switchVatIncluded = function () {
            if (ctrl.disabled) {
                return;
            }
            DealsService.switchVatIncluded(ctrl.deal).then(function () {
                ctrl.priceChanged();
            });
        };
    }
    
})();
(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('inputDealSize', {
            controller: InputDealSizeCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/input-deal-size-directive/input-deal-size-directive.tpl.html',
            bindings: { 
                dealSizeOptions: '=',
                dealSize: '=',
                unit: '=',
                form: '=',
                dealSizeRequired: '<',
                stepReadonly: '<',
                isSale: '<',
            }
        });

    function InputDealSizeCtrl($scope, $ngConfirm, $timeout, gettextCatalog, Utils, DealsService) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;

        ctrl.$onInit = function() {
            ctrl.dealSizePlaceholder = ctrl.dealSizeRequired ? '' : gettextCatalog.getString('Unlimited');
            ctrl.dealSizeOptions = ctrl.dealSizeOptions || {};
            ctrl.dealSizeOptions.step = ctrl.dealSizeOptions.step || 1;
            ctrl.dealSizeOptions.min = ctrl.dealSizeOptions.min || 1;
        }

        ctrl.openAdvancedSetting = function() {
            ctrl.dealSizeOptionsNew = {
                min: ctrl.dealSizeOptions.min,
                max: ctrl.dealSizeOptions.max,
            };
            $ngConfirm({
                title: gettextCatalog.getString('Min') + ' / ' + gettextCatalog.getString('Max'),
                contentUrl: 'app/app-commons/components/input-deal-size-directive/advanced-options-prompt.tpl.html',
                icon: 'fa fa-cubes',
                size: 'medium',
                scope: $scope,
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        btnClass: 'btn-dark'
                    },
                    ok: {
                        text: gettextCatalog.getString('Confirm'),
                        btnClass: 'btn-success btn-wide',
                        action: function () {
                            $timeout(function() {
                                ctrl.dealSizeOptions.min = ctrl.dealSizeOptionsNew.min;
                                ctrl.dealSizeOptions.max = ctrl.dealSizeOptionsNew.max;
                                ctrl.checkDealSizeOptions();
                            }, 100);
                        }
                    },
                },
            });
        }

        ctrl.checkDealSizeOptions = function() {
            var sizeOpts = ctrl.dealSizeOptions;
            if (ctrl.dealSize) {
                ctrl.dealSize = Math.round(ctrl.dealSize / sizeOpts.step) * sizeOpts.step;
            }
            if (!sizeOpts.step) {
                sizeOpts.step = 1;
            }
            sizeOpts.min = Math.round(sizeOpts.min / sizeOpts.step) * sizeOpts.step;
            if (sizeOpts.min < sizeOpts.step) {
                sizeOpts.min = sizeOpts.step;
            }
            if (sizeOpts.max === 0) {
                sizeOpts.max = undefined;
            }
            if (sizeOpts.max) {
                sizeOpts.max = Math.round(sizeOpts.max / sizeOpts.step) * sizeOpts.step;
                if (sizeOpts.max < sizeOpts.step) {
                    sizeOpts.max = sizeOpts.step;
                }
            }
            ctrl.dealSize = Utils.roundDecimals(ctrl.dealSize);
            if (ctrl.dealSize === 0) {
                ctrl.dealSize = undefined;
            }
        }

        ctrl.clearDealSize = function() {
            ctrl.dealSize = undefined;
        }

        ctrl.isMinMaxSet = function() {
            if (!ctrl.dealSizeOptions) {
                return false;
            }
            return ctrl.dealSizeOptions.max || ctrl.dealSizeOptions.step < ctrl.dealSizeOptions.min;
        }

        ctrl.resetMinMax = function() {
            ctrl.dealSizeOptionsNew.min = ctrl.dealSizeOptions.step;
            ctrl.dealSizeOptionsNew.max = undefined;
        }
    }
    
})();
(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('inputDateTime', {
            controller: InputDateTimeCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/input-date-time/input-date-time.html',
            bindings: { 
                id: '=',
                value: '=',
                icon: '=',
                hideTime: '=',
                ngDisabled: '=',
                onChange: '&'
            }
        });

    function InputDateTimeCtrl($scope, $timeout, $log, Utils) {
        var ctrl = this;
        ctrl.utils = Utils;

        ctrl.$onInit = function() {
            ctrl.loading = true;
            var id = Math.round(Math.random() * 1000);
            if (!ctrl.id) {
                ctrl.dateId = 'date-picker' + id;
                ctrl.timeId = 'time-picker' + id;
            }
            else {
                ctrl.dateId = ctrl.id;
                ctrl.timeId = ctrl.id + '-time';
            }
            $timeout(init, 500);
        }

        function init() {
            $log.log('Init date time components: ' + ctrl.dateId + ' ' + ctrl.timeId);

            if (ctrl.icon !== 'none') {
                ctrl.iconClass = ctrl.icon || 'fa-calendar';
            }

            var timeObj = $('#' + ctrl.timeId);
            var dateObj = $('#' + ctrl.dateId);
            
            timeObj.datetimepicker({
                date: ctrl.value,
                format: 'HH:mm',
                stepping: 1,
                icons: {
                    time: 'fa fa-clock-o',
                    date: 'fa fa-calendar',
                    up: 'fa fa-plus',
                    down: 'fa fa-minus',
                    next: 'fa fa-chevron-left',
                    previous: 'fa fa-chevron-right'
                }
            });
            
            dateObj.datetimepicker({
                date: ctrl.value,
                format: 'DD MMM YYYY',
                showTodayButton: true,
                icons: {
                    time: 'fa fa-clock-o',
                    date: 'fa fa-calendar',
                    up: 'fa fa-plus',
                    down: 'fa fa-minus',
                    next: 'fa fa-chevron-right',
                    previous: 'fa fa-chevron-left',
                    today: 'fa fa-calendar'
                }
            });

            timeObj.on("dp.change", function (value) {
                ctrl.timeValue = value.date;
                updateDateTime();
                dateTimeChanged();
            });   
            dateObj.on("dp.change", function (value) {
                ctrl.dateValue = value.date;
                updateDateTime();
                dateTimeChanged();
            });              

            ctrl.value = moment(ctrl.value);
            ctrl.timeValue = ctrl.value;
            ctrl.dateValue = ctrl.value;
            ctrl.loading = false;
            updateDateTime();
        }

        function updateDateTime() {
            ctrl.value = moment(ctrl.dateValue)
            ctrl.value.set({
                hour: ctrl.timeValue.hour(),
                minute: ctrl.timeValue.minute(),
            });
            $scope.$apply();
        }

        function dateTimeChanged() {
            if (!ctrl.onChange) {
                return;
            }
            ctrl.onChange();
        }
    }
})();
/**
 * Created by Hafeez Rehman on 08/02/2019.
 */

(function () {
    'use strict';

     angular
         .module('app.commons')
             .component('fhCaptcha', {
                 controller: CaptchaCtrl,
                 controllerAs: '$ctrl',
                 templateUrl: 'app/app-commons/components/fh-captcha/captcha.tpl.html',
                 bindings: { captcha: '=' }
             });

     function CaptchaCtrl(vcRecaptchaService, APP_CAPTCHA_CONFIG) {
         var ctrl = this;

         ctrl.$onInit = function() {
             ctrl.key = APP_CAPTCHA_CONFIG.key;
             ctrl.widgetId = null;
             ctrl.captcha = null;
         };

         ctrl.onCreate = function(id) {
             ctrl.widgetId = id;
         };

         ctrl.onResponse = function (res) {
             ctrl.captcha = res;
         };

         ctrl.onExpire = function() {
             vcRecaptchaService.reload(ctrl.widgetId);
             ctrl.captcha = null;
         }
     }
})();
(function(){
    'use strict';

    angular
        .module('app.commons')
        .component('extendDeal', {
            controller: ExtendDealCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/extend-deal/extend-deal.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function ExtendDealCtrl(Utils, DealsService, HttpService, gettextCatalog, AlertService, DEAL_STATUS) {
        var ctrl = this;
        ctrl.utils = Utils;

        ctrl.typeNames = {
            BOOKING_END: 'BOOKING_END',
            DEAL_SIZE: 'DEAL_SIZE',
            RETAIL_PRICES: 'RETAIL_PRICES',
        }
        ctrl.types = [
            { name: ctrl.typeNames.BOOKING_END, label: gettextCatalog.getString('Deal end'), icon: 'calendar' },
            { name: ctrl.typeNames.DEAL_SIZE, label: gettextCatalog.getString('Stock'), icon: 'cubes' },
            { name: ctrl.typeNames.RETAIL_PRICES, label: gettextCatalog.getString('Add customers'), icon: 'user' }
        ];

        ctrl.$onInit = function () {
            ctrl.deal = angular.copy(ctrl.resolve.modalData.deal);
            ctrl.dealSizeCurrent = ctrl.deal.dealSize;
            ctrl.bookingEndCurrent = ctrl.deal.bookingEnd;

            ctrl.notifyCustomers = true;

            ctrl.message = gettextCatalog.getString('Offer for {productName} extended').replace('{productName}', ctrl.deal.productName);
            ctrl.currentTypeName = ctrl.typeNames.BOOKING_END; 

            ctrl.isSale = DealsService.isCategoryCrop(ctrl.deal);
            ctrl.initialized = true;
        };

        ctrl.isNewBookingEndValid = function() {
            return !(moment().isAfter(ctrl.deal.bookingEnd));
        }

        ctrl.isTypeName = function(typeName) {
            return ctrl.currentTypeName === typeName;
        }
        ctrl.setTypeName = function (typeName) {
            ctrl.currentTypeName = typeName;
        }
        
        ctrl.ok = function() {
            ctrl.form.$setSubmitted();
            if (ctrl.form.$invalid || !ctrl.isNewBookingEndValid()) {
                return false;
            }
            var payload = {
                type: ctrl.currentTypeName
            };

            if (ctrl.isTypeName(ctrl.typeNames.DEAL_SIZE)) {
                payload.dealSize = ctrl.deal.dealSize;
                payload.dealSizeOptions = ctrl.deal.dealSizeOptions;
                payload.users = ctrl.deal.users;
            } else if (ctrl.isTypeName(ctrl.typeNames.RETAIL_PRICES)) {
                payload.notifyOnlyNewCustomers = true;
                payload.retailPrices = ctrl.deal.retailPrices;
                payload.users = ctrl.deal.users;
            } else {
                payload.bookingEnd = ctrl.deal.bookingEnd;
                payload.status = DEAL_STATUS.ACTIVE;
            }

            if (ctrl.notifyCustomers) {
                payload.message = ctrl.message;
            }

            ctrl.isLoading = true;
            HttpService.Post('deals/' + ctrl.deal._id + '/extend', payload).then(function () {
                AlertService.success(gettextCatalog.getString('Offer extended'));
                ctrl.modalInstance.close(true);
            });
        };

        ctrl.cancel = function() {
            ctrl.modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.commons')
        .component('exportOrders', {
            controller: ExportOrdersCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/export-orders/export-orders.tpl.html',
            bindings: { modalInstance: "<", resolve: "<" }
        });

    function ExportOrdersCtrl($timeout, $q, $rootScope, gettextCatalog, HttpService, AlertService, Utils, DealsService, ORDER_STATUS) {
        var ctrl = this;
        ctrl.utils = Utils;

        ctrl.lookup = {};
        ctrl.lookup.farmTypesMap = DealsService.getFarmTypesMap();
        ctrl.lookup.systemsMap = DealsService.getSystemsMap();

        ctrl.payload = {};
        ctrl.fileFormats = [
            { name: 'Excel', type: 'XLSX' },
            { name: 'CSV', type: 'CSV' },
        ];
        ctrl.fileFormat = ctrl.fileFormats[0];
        ctrl.slider = { value: 1, options: { floor: 0, ceil: 10, step: 1 } };

        ctrl.$onInit = function () {
            var step = ctrl.resolve.modalData.count > 20 ? 10 : 1;
            var ceil = ctrl.resolve.modalData.count;
            
            $timeout(function() {
                // Wait for slider to be initialized
                ctrl.slider = {
                    value: ctrl.resolve.modalData.count < 120 ? ctrl.resolve.modalData.count : 100,
                    options: { floor: 0, ceil: ceil, step: step }
                };
            }, 200);            
        };

        ctrl.ok = function () {
            ctrl.isExporting = true;
            var docStyle = { headers: true, columns: [] };

            docStyle.columns.push({
                name: gettextCatalog.getString('FarmHedge order ID'),
                mappingFunc: function(order) { return order.ref; }
            });
            docStyle.columns.push({
                name: gettextCatalog.getString('Date'),
                mappingFunc: function(order) { return Utils.getLocalizedDateAndTime(order.date); }
            });
            docStyle.columns.push({
                name: gettextCatalog.getString('Type'),
                mappingFunc: function(order) { return order.isPurchase ? gettextCatalog.getString('Purchase') : gettextCatalog.getString('Sale'); }
            });

            docStyle.columns.push({
                name: gettextCatalog.getString('Product name'),
                mappingFunc: function(order) { return order.productName || (order.deal? order.deal.productName : ''); }
            });
            docStyle.columns.push({
                name: gettextCatalog.getString('Product ID'),
                mappingFunc: function(order) { return (order.vendorProductId || (order.deal ? order.deal.vendorProductId : '')); }
            });

            if (!Utils.isSupplierDistributor()) {
                docStyle.columns.push({
                    name: gettextCatalog.getString('Supplier'),
                    mappingFunc: function (order) { return order.supplier.name; }
                });
                docStyle.columns.push({
                    name: gettextCatalog.getString('Customer name'),
                    mappingFunc: function (order) { return order.user.name.first + ' ' + order.user.name.last }
                });
                docStyle.columns.push({ 
                    name: gettextCatalog.getString('Customer ID'), 
                    mappingFunc: function (order) { return order.user.customerId; }
                });   
            }
            else {
                docStyle.columns.push({
                    name: gettextCatalog.getString('Distributor'),
                    mappingFunc: function (order) { return order.supplier.name; }
                });
                docStyle.columns.push({
                    name: gettextCatalog.getString('Customer'),
                    mappingFunc: function (order) { return order.retailer ? order.retailer.name : ''; }
                });
                docStyle.columns.push({
                    name: gettextCatalog.getString('Customer name'),
                    mappingFunc: function (order) { return order.user.name.first + ' ' + order.user.name.last }
                });
            }            

            docStyle.columns.push({
                name: gettextCatalog.getString('Unit'),
                mappingFunc: function(order) { return order.deal ? order.deal.customUnit : '---'; }
            });
            docStyle.columns.push({
                name: gettextCatalog.getString('Unit price'),
                mappingFunc: function(order) { return Utils.getLocalizedCurrency(Math.round(order.unitPrice * 100) / 100); }
            });
            docStyle.columns.push({
                name: gettextCatalog.getString('Quantity'),
                mappingFunc: function(order) { return order.amount; }
            });
            docStyle.columns.push({
                name: gettextCatalog.getString('Total price'),
                mappingFunc: function (order) { return Utils.getLocalizedCurrency(Math.round((order.totalPrice || (order.unitPrice * order.amount)) * 100) / 100); }
            });

            docStyle.columns.push({
                name: gettextCatalog.getString('Status'),
                mappingFunc: function(order) { return getLocalizedOrderStatus(order); }
            });
            docStyle.columns.push({
                name: gettextCatalog.getString('Updated'),
                mappingFunc: function(order) { return Utils.getLocalizedDateAndTime(order.updatedAt); }
            });

            ctrl.resolve.modalData.params.limit = ctrl.slider.value;
            HttpService.Get('me/orders', ctrl.resolve.modalData.params).then(function(data) {
                var ordersList = data.orders.map(function (order) {
                    var orderRow = {};
                    docStyle.columns.forEach(function(column) {
                        if (column.mappingFunc) {
                            orderRow[column.name] = column.mappingFunc(order);
                        } else if (column.mappingField) {
                            orderRow[column.name] = order[column.mappingField];
                        }
                    });
                    return orderRow;
                });
                alasql('SELECT * INTO ' + ctrl.fileFormat.type + '("orders_list_' + moment().format('YYYY-MM-DD_HH-mm-ss') + '.' + ctrl.fileFormat.type + '",?) FROM ?', [docStyle, ordersList]);
                ctrl.isExporting = false;
            }, function(err) {
                $log.error(err);
                ctrl.isExporting = false;
            });
        };

        ctrl.cancel = function() {
            ctrl.modalInstance.dismiss('cancel');
        };

        function getLocalizedOrderStatus(order) {
            if (!order.status || order.status === ORDER_STATUS.PENDING || order.status === ORDER_STATUS.VIEWED) {
                return gettextCatalog.getString('Pending');
            }
            if (order.status === ORDER_STATUS.PAID) {
                return gettextCatalog.getString('Paid')
            }
            if (order.status === ORDER_STATUS.COMPLETED) {
                return gettextCatalog.getString('Completed')
            }
            if (order.status === ORDER_STATUS.FORWARDED) {
                return gettextCatalog.getString('Forwarded')
            }
            if (order.status === ORDER_STATUS.INVALID) {
                return gettextCatalog.getString('Invalid')
            }
            if (order.status === ORDER_STATUS.RESERVED) {
                return gettextCatalog.getString('Reserved')
            }
            if (order.status === ORDER_STATUS.REJECTED) {
                return gettextCatalog.getString('Rejected')
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.commons')
        .component('exportCustomers', {
            controller: ExportCustomersCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/export-customers/export-customers.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    function ExportCustomersCtrl($timeout, $q, $rootScope, gettextCatalog, HttpService, AlertService, Utils, DealsService) {
        var ctrl = this;
        ctrl.utils = Utils;

        ctrl.lookup = {};
        ctrl.lookup.farmTypesMap = DealsService.getFarmTypesMap();
        ctrl.lookup.systemsMap = DealsService.getSystemsMap();

        ctrl.payload = {};
        ctrl.fileFormats = [
            { name: 'Excel', type: 'XLSX' },
            { name: 'CSV', type: 'CSV' },
        ];
        ctrl.fileFormat = ctrl.fileFormats[0];

        ctrl.$onInit = function () {
            var step = ctrl.resolve.modalData.count > 20 ? 10 : 1;
            var ceil =  ctrl.resolve.modalData.count;
            $timeout(function () {
                // Wait for slider to be initialized
                ctrl.slider = {
                    value: ctrl.resolve.modalData.count < 120 ? ctrl.resolve.modalData.count : 100,
                    options: { floor: 0, ceil: ceil, step: step }
                };
            }, 200);
        };

        function getFarmTypesStr(user) {
            if (!user.farmTypes || !user.farmTypes.length) {
                return '';
            }
            return user.farmTypes.map(function(ft) {
                return ctrl.lookup.farmTypesMap[ft];
            }).join(', ');
        }

        function getLastActive(lastDealsAck) {
            if (!lastDealsAck) {
                return '';
            }
            var activeDaysAgo = moment().diff(lastDealsAck, 'days'); // eslint-disable-line no-undef
            if (activeDaysAgo === 0) return gettextCatalog.getString('Today');
            if (activeDaysAgo <= 7) return gettextCatalog.getString('Last 7 days');
            if (activeDaysAgo <= 31) return gettextCatalog.getString('Last 30 days');
        }

        ctrl.ok = function () {
            ctrl.isExporting = true;
            var docStyle = {
                headers: true,
                columns: [
                    { name: gettextCatalog.getString('First name'), mappingFunc: function(user) { return user.name.first } },
                    { name: gettextCatalog.getString('Last name'), mappingFunc: function(user) { return user.name.last; } },
                    { name: gettextCatalog.getString('Registration date'), mappingFunc: function (user) { return Utils.getLocalizedDateAndTime(user.createdAt); } },
                    { name: gettextCatalog.getString('Customer ID'), mappingField: 'customerId' },
                    { name: gettextCatalog.getString('Farm types'), mappingFunc: getFarmTypesStr },
                    { name: gettextCatalog.getString('System'), mappingFunc: function (user) { return ctrl.lookup.systemsMap[user.system || '']; } },
                    { name: gettextCatalog.getString('Street'), mappingFunc: function (user) { return user.address.street } },
                    { name: gettextCatalog.getString('Zip code'), mappingFunc: function (user) { return user.address.zipcode } },
                    { name: gettextCatalog.getString('City'), mappingFunc: function (user) { return user.address.city } },
                    { name: gettextCatalog.getString('FarmHedge ID'), mappingFunc: function (user) { return user._id } },
                    { name: gettextCatalog.getString('Email'), mappingFunc: function (user) { return user.email } },
                    { name: gettextCatalog.getString('Phone number'), mappingFunc: function (user) { return user.phoneNumber } },
                    { name: gettextCatalog.getString('Active'), mappingFunc: function (user) { return getLastActive(user.lastDealsAck) } },
                    { name: gettextCatalog.getString('Supplier'), mappingFunc: function () { return $rootScope.app.Auth.User.supplier.name } },
                ]
            };
            var params = {
                limit: ctrl.slider.value
            };
            
            HttpService.Get('users', params).then(function(data) {
                var custList = data.list.map(function (user) {
                    var userData = {};
                    docStyle.columns.forEach(function(column) {
                        if (column.mappingFunc) {
                            userData[column.name] = column.mappingFunc(user);
                        }
                        else if (column.mappingField) {
                            userData[column.name] = user[column.mappingField];
                        }
                    });
                    return userData;
                });
                alasql('SELECT * INTO ' + ctrl.fileFormat.type + '("customers_list_' + moment().format('YYYY-MM-DD_HH-mm-ss') + '.' + ctrl.fileFormat.type + '",?) FROM ?', [docStyle, custList]);
                ctrl.isExporting = false;
            }, function(err) {
                $log.error(err);
                ctrl.isExporting = false;
            });
        };

        ctrl.cancel = function() {
            ctrl.modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('distributorDeal', {
            controller: DistributorDealCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/distributor-deal/distributor-deal.html',
            bindings: { 
                deal: '=', 
                product: '='
            }
        });

    function DistributorDealCtrl($scope, $log, Utils, DealsService) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;

        $scope.$watch('$ctrl.deal', function () {
            init();
        });
        function init() {
            $log.log('DistributorDealCtrl: init');
            if (!ctrl.deal) {
                return;
            }
            if (!ctrl.deal._id) {
                // TODO: fetch deal GET /me/deals/{ctrl.deal}
                return;
            }
            checkDealVariants();
            
            if (moment(ctrl.deal.bookingEnd).diff(moment(), 'year') > 1) {
                ctrl.deal.bookingEnd = null;
            }
            ctrl.isInitialized = true;
        }

        function checkDealVariants() {
            if (!ctrl.deal.variants || !ctrl.deal.variants.length ||
                !ctrl.product || ctrl.product.name === ctrl.deal.product.name) {
                return;
            }
            var matchingVariant = Utils.altFind(ctrl.deal.variants, function (v) {
                return v.productName === ctrl.product.name;
            });
            if (!matchingVariant) {
                return;
            }

            ctrl.deal.product = {
                _id: matchingVariant.product,
                name: matchingVariant.productName,
                vendorProductId: matchingVariant.vendorProductId
            };
            ctrl.deal.benchmarkPrice = matchingVariant.benchmarkPrice;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('dealQuantitySelector', {
            controller: OrderDetailsCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/deal-quantity-selector/deal-quantity-selector.tpl.html',
            bindings: { 
                deal: '=',
                selectedQuantity: '='
            }
        });

    function OrderDetailsCtrl(Utils, DealsService) {
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;

        ctrl.$onInit = function () {
            ctrl.deal.dealSizeOptions = ctrl.deal.dealSizeOptions || {};
            ctrl.deal.dealSizeOptions.min = ctrl.deal.dealSizeOptions.min || 1;
            ctrl.deal.dealSizeOptions.step = ctrl.deal.dealSizeOptions.step || 1;
            
            if (!ctrl.selectedQuantity) {
                ctrl.selectedQuantity = ctrl.deal.dealSizeOptions.min;
            }
        }

        ctrl.decreaseQuantity = function () {
            var deal = ctrl.deal;
            ctrl.selectedQuantity -= deal.dealSizeOptions.step;
            ctrl.checkselectedQuantity();
        }
        ctrl.increaseQuantity = function() {
            var deal = ctrl.deal;
            ctrl.selectedQuantity += deal.dealSizeOptions.step;
            ctrl.checkselectedQuantity();
        }

        ctrl.checkselectedQuantity = function () {
            var deal = ctrl.deal;
            if (ctrl.selectedQuantity < 0) {
                ctrl.selectedQuantity = 0;
            }
            var maxQt = DealsService.getAvailabilityForUser(deal);
            if (ctrl.selectedQuantity > maxQt) {
                ctrl.selectedQuantity = maxQt;
            }
            if (ctrl.selectedQuantity % deal.dealSizeOptions.step !== 0) {
                ctrl.selectedQuantity = Math.floor(ctrl.selectedQuantity / deal.dealSizeOptions.step) * deal.dealSizeOptions.step;
            }
        }
    }
})();
/**
 * Created by Hafeez Rehman on 10/12/2018.
 */

(function() {
    'use strict';

    function wrapperController($scope, $rootScope, $state) {
        var ctrl = this;

        //Responsive Contacts Feature Branch test push
        ctrl.$onInit = function() {
            ctrl.size = angular.isString(ctrl.size) ? ctrl.size : $state.current.data.size;
        };
    }

    angular
        .module('app.commons')
        .component('dialogWrapper', {
            bindings: {
                size: '<'
            },
            controllerAs: '$ctrl',
            controller: wrapperController,
            templateUrl: 'app-commons/components/dialog-wrapper/dialog-wrapper.html'
            // transclude: true
        })
        .directive('escKey', function () {
            return function (scope, element, attrs) {
                element.bind('keydown keypress', function (event) {
                    if(event.which === 27) { // 27 = esc key
                        scope.$apply(function (){
                            scope.$eval(attrs.escKey);
                        });

                        event.preventDefault();
                    }
                });
            };
        });
})();
(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('dealDiscountOptionsCtrl', {
            controller: DealDiscountOptionsCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/deal-discount-options/deal-discount-options.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    // Moved from modals.js on May2020 (explains useage of $scope instead of ctrl)
    function DealDiscountOptionsCtrl($scope, $timeout, Utils, gettextCatalog) {
        var ctrl = this;
        ctrl.utils = Utils;
        var ds;

        ctrl.$onInit = function () {
            ds = ctrl.resolve.discountSettings;
            $scope.ds = ds;
            if (!ds.priceDecimalDigits) {
                ds.priceDecimalDigits = 2;
            }
            if (ds.individualDiscount) {
                ds.individualDiscount = +ds.individualDiscount.toFixed(4);
            }
            ds.dealSizeOptions = ds.dealSizeOptions || { min: 1, step: 1};

            if (ds.focusPrice) {
                $timeout(function() {
                    document.getElementById('benchmarkPrice').focus();
                }, 100);
            }

            ds.customUnit = ds.customUnit || gettextCatalog.getString('Unit');

            initQuantityDiscounts(ds.quantityDiscountsInput);
            checkDealSizeOptions();
        }

        function initQuantityDiscounts(qdInput) {
            if (!qdInput || qdInput.length === 0) {
                var qd = {
                    quantity: 1,
                    discount: ds.individualDiscount,
                    priceTotal: ds.benchmarkPrice
                };
                $scope.qdDiscountChanged(qd);
                ds.quantityDiscounts = [qd];
                return;
            }
            ds.quantityDiscounts = [];
            qdInput.forEach(function (qd) {
                qd = { quantity: qd.quantity, discount: qd.discount, };
                qd.priceTotal = ds.benchmarkPrice * qd.quantity;
                $scope.qdDiscountChanged(qd);
                ds.quantityDiscounts.push(qd);
            });
        }

        $scope.refreshAllDiscounts = function () {
            ds.quantityDiscounts.forEach(function (qd) {
                $scope.refreshDiscount(qd);
            });
        };
        $scope.refreshAllPrices = function () {
            ds.quantityDiscounts.forEach(function (qd) {
                $scope.qdDiscountChanged(qd);
            });
        };
        $scope.refreshDiscount = function (qd) {
            qd.discount = Utils.getDiscountPercent(ds.benchmarkPrice, qd.price);
            
        };

        $scope.qdQuantityChanged = function (qd, checkSize, idx) {
            qd.priceTotal = qd.quantity * ds.benchmarkPrice;
            qd.priceTotalDiscounted = qd.priceTotal - qd.discountTotal;
            if (checkSize) {
                reorderQd();
                checkDealSizeOptionsForQd(qd, idx);
            }
        }
        $scope.qdPriceChanged = function (qd) {
            qd.discountPrice = ds.benchmarkPrice - qd.price;
            qd.discount = Utils.roundDecimals(100 * qd.discountPrice / ds.benchmarkPrice);
            qd.discountTotal = Utils.roundDecimals(qd.priceTotal * qd.discount / 100);
            qd.priceTotalDiscounted = qd.priceTotal - qd.discountTotal;
        }
        $scope.qdDiscountPriceChanged = function (qd) {
            qd.price = ds.benchmarkPrice - qd.discountPrice;
            qd.discount = Utils.roundDecimals(100 * qd.discountPrice / ds.benchmarkPrice);
            qd.discountTotal = Utils.roundDecimals(qd.priceTotal * qd.discount / 100);
            qd.priceTotalDiscounted = qd.priceTotal - qd.discountTotal;
        }
        $scope.qdDiscountChanged = function (qd) {
            qd.price = Utils.getSalePrice(ds.benchmarkPrice, qd.discount, ds.priceDecimalDigits);
            qd.discountPrice = ds.benchmarkPrice - qd.price;
            qd.discountTotal = Utils.roundDecimals(qd.priceTotal * qd.discount / 100);
            qd.priceTotalDiscounted = qd.priceTotal - qd.discountTotal;
        };
        $scope.qdDiscountTotalChanged = function (qd) {
            qd.discount = Utils.roundDecimals(100 * qd.discountTotal / qd.priceTotal);
            qd.price = Utils.getSalePrice(ds.benchmarkPrice, qd.discount, ds.priceDecimalDigits);
            qd.discountPrice = ds.benchmarkPrice - qd.price;
            qd.priceTotalDiscounted = qd.priceTotal - qd.discountTotal;
        };
        $scope.benchmarkPriceChanged = function() {
            ds.quantityDiscounts.forEach(function(qd) {
                qd.priceTotal = ds.benchmarkPrice * qd.quantity;
                qd.priceTotalDiscounted = qd.priceTotal - qd.discountTotal;
                $scope.qdDiscountTotalChanged(qd);
            });
        }
        

        $scope.removeRow = function (idx) {
            ds.quantityDiscounts.splice(idx, 1);
        };

        function reorderQd() {
            ds.quantityDiscounts = ds.quantityDiscounts.sort(function (a, b) {
                return a.quantity - b.quantity;
            });
        }

        function checkDealSizeOptionsForQd(qd, idx) {
            if (idx === 0) {
                qd.quantity = 1;
                return;
            }
            var sizeOpts = ds.dealSizeOptions;
            if (qd.quantity < sizeOpts.min) {
                qd.quantity = sizeOpts.min;
            }
            qd.quantity = Utils.roundDecimals(Math.floor(qd.quantity / sizeOpts.step) * sizeOpts.step);
        }

        function checkDealSizeOptions() {
            var sizeOpts = ds.dealSizeOptions;
            if (!sizeOpts.min) {
                sizeOpts.min = 1;
            }
            if (!sizeOpts.step) {
                sizeOpts.step = 1;
            }
            ds.quantityDiscounts.forEach(function(qd, idx) {
                checkDealSizeOptionsForQd(qd, idx);
            });
            reorderQd();
        }

        $scope.clearDiscount = function() {
            ds.quantityDiscounts.splice(1);
            ds.quantityDiscounts[0].discount = 0;
            $scope.qdDiscountChanged(ds.quantityDiscounts[0]);
        }

        $scope.addRow = function () {
            checkDealSizeOptions();
            var prevQd = ds.quantityDiscounts[ds.quantityDiscounts.length - 1];
            var quantityStep = (ds.dealSizeOptions && ds.dealSizeOptions.step > 1) ? (ds.dealSizeOptions.step * 10) : 10;
            if (prevQd.quantity === 1) {
                quantityStep--;
            }

            var qd = {
                quantity: prevQd.quantity + quantityStep,
                discount: Math.min(100, prevQd.discount + 5),
            };
            qd.priceTotal = ds.benchmarkPrice * qd.quantity;
            $scope.qdDiscountChanged(qd);
            ds.quantityDiscounts.push(qd);
        };
        $scope.getMin = function (a, b) {
            if (!a) {
                return b;
            }
            if (!b) {
                return a;
            }
            return Math.min(a, b);
        };
        $scope.getMax = function (a, b) {
            if (!a) {
                return b;
            }
            if (!b) {
                return a;
            }
            return +(Math.max(a, b).toFixed(4))
        };
        $scope.ok = function () {
            ds.groupDiscount = null;
            
            if (Utils.isSupplierDistributor()) {
                ctrl.modalInstance.close($scope.ds);
                return;
            }

            if (!ds.benchmarkPrice) {
                ds.quantityDiscounts = [];
                ds.individualDiscount = 0;
                ds.clearanceDiscount = 0;
                ctrl.modalInstance.close($scope.ds);
                return;
            }

            if (ds.quantityDiscounts.length === 1) {
                ds.individualDiscount = ds.quantityDiscounts[0].discount;
                ds.clearanceDiscount = null;
                ds.quantityDiscounts = [];
                ctrl.modalInstance.close($scope.ds);
                return;
            }

            ds.individualDiscount = Math.min.apply(null, ds.quantityDiscounts
                .map(function (q) {
                    return q.discount;
                }));
            ds.clearanceDiscount = Math.max.apply(null, ds.quantityDiscounts
                .map(function (q) {
                    return q.discount;
                }));
            ctrl.modalInstance.close($scope.ds);
        };
        $scope.cancel = function () {
            ctrl.modalInstance.dismiss('cancel');
        };

        $scope.disableGroupDiscount = function () {
            ds.quantityDiscounts = [{
                discount: ds.individualDiscount,
                quantity: 1
            }];
            $scope.qdDiscountChanged(ds.quantityDiscounts[0]);
            $scope.isGroupDiscountEnabled = false;
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('dealDetails', {
            controller: DealDetailsCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/deal-details-directive/deal-details-directive.tpl.html',
            bindings: { 
                deal: '=',
                loadDeals: '=',
                hideReportButton: '<'
            }
        });

    function DealDetailsCtrl($scope, $rootScope, $state, $log, $uibModal, $ngConfirm,
            Utils, DealsService, gettextCatalog, AlertService, HttpService, 
            DEAL_CATEGORY, ORDER_STATUS) {
                
        var ctrl = this;
        ctrl.utils = Utils;
        ctrl.dealsService = DealsService;

        ctrl.farmTypesMap = DealsService.getFarmTypesMap();
        ctrl.systemsMap = DealsService.getSystemsMap();

        ctrl.$onInit = function() {
            ctrl.initRetailers();
            ctrl.priceTolerance = 1 / Math.pow(10, ctrl.deal.priceDecimalDigits || 2);
        }

        ctrl.initRetailers = function() {
            $log.log('DealDetails: Init deal.');
            var d = ctrl.deal;
            if (!Utils.isSupplierDistributor()) {
                return;
            }

            var retailPricesMap = d.retailPrices.reduce(function (map, rp) {
                map[rp.retailer] = rp;
                return map;
            }, {});

            var retailerOrders = {};
            d.orders.forEach(function (order) {
                var retailerId = order.retailer._id || order.retailer;
                retailerOrders[retailerId] = retailerOrders[retailerId] || { amount: 0 };
                if (order.status === ORDER_STATUS.RESERVED && moment().isBefore(order.modifyTimeExpiresAt)) {
                    retailerOrders[retailerId].modifyTimeExpiresAt = order.modifyTimeExpiresAt;
                    retailerOrders[retailerId].amountReserved = (order.amount || 0);
                }
                else if (order.status === ORDER_STATUS.PENDING || order.status === ORDER_STATUS.COMPLETED) {
                    retailerOrders[retailerId].amount += (order.amount || 0);
                }
            });

            d.targetRetailers = $rootScope.app.Auth.User.supplier.retailers.filter(function (retailer) {
                return (retailerOrders[retailer._id] || ctrl.isExpandedTargetRetailers) && retailPricesMap[retailer._id];
            }).map(function (retailer) {
                retailerOrders[retailer._id] = retailerOrders[retailer._id] || {};
                var targetSupplier = {
                    _id: retailer._id,
                    name: retailer.name,
                    imageUrl: retailer.imageUrl,
                    accounts: retailer.accounts,
                    amount: retailerOrders[retailer._id].amount,
                    rrp: retailPricesMap[retailer._id].rrp,
                    dealSize: retailPricesMap[retailer._id].dealSize,
                    amountReserved: retailerOrders[retailer._id].amountReserved,
                    modifyTimeExpiresAt: retailerOrders[retailer._id].modifyTimeExpiresAt
                };
                return targetSupplier;
            });

            if (ctrl.isRetailerListExpanded) {
                d.inactiveRetailersNames = [];
                return;
            }

            var allRetailers = {};
            d.retailPrices.forEach(function (rp) {
                allRetailers[rp.retailer] = true;
            });
            d.inactiveRetailersNames = $rootScope.app.Auth.User.supplier.retailers.filter(function (retailer) {
                return allRetailers[retailer._id] && !retailerOrders[retailer._id];
            }).map(function (retailer) {
                return retailer.name;
            });  
        }

        ctrl.toggleExpandedTargetRetailers = function() {
            ctrl.isExpandedTargetRetailers = !ctrl.isExpandedTargetRetailers;
            ctrl.initRetailers();
        }


        ctrl.canOpenReport = function() {
            return !ctrl.hideReportButton && !DealsService.isDraft(ctrl.deal);
        }
        ctrl.isCategoryCrop = function () {
            return DealsService.isCategoryCrop(ctrl.deal);
        };
        ctrl.isTypeDraft = function () {
            return DealsService.isDraft(ctrl.deal);
        };
        ctrl.isTypeActive = function () {
            return DealsService.isActive(ctrl.deal);
        };
        ctrl.isTypeExpired = function () {
            return DealsService.isExpired(ctrl.deal);
        };

        ctrl.goToEditIfDraft = function() {
            if (ctrl.deal.categoryName === DEAL_CATEGORY.CROP) {
                $state.go('app.crop.proc', { id: ctrl.deal._id });
            } else {
                $state.go('app.deals.update', { id: ctrl.deal._id, startIntro: $state.params.startIntro });
            }
        }

        ctrl.cloneDeal = function() {
            var confirm = Utils.CreateConfirmation(gettextCatalog.getString('Do you want to clone this deal?'));
            confirm.result.then(function () {
                DealsService.cloneDeal(ctrl.deal);
            });
        }

        ctrl.canStopOffer = function () {
            if (!ctrl.isTypeActive() || ctrl.dealsService.isBookingStartInTheFuture(ctrl.deal)) {
                return false;
            }
            return true;
        }

        ctrl.askToDeleteDeal = function() {
            var message;
            if (ctrl.isTypeDraft()) {
                message = gettextCatalog.getString('Are you sure you want to delete the selected deal?');
                Utils.CreateConfirmation(message).result.then(function () {
                    performDeleteDeal();
                });
                return;
            }

            if (!Utils.isSupplierDistributor()) {
                message = gettextCatalog.getString('If you press “OK”, this deal will be moved to "Past deals" and farmers will not be allowed to make any further bookings.');
                Utils.CreateConfirmation(message).result.then(function () {
                    performDeleteDeal();
                });
                return;
            }                
            
            ctrl.isReservationsWarningEnabled = ctrl.deal.orders.some(function(order) {
                return order.status === ORDER_STATUS.RESERVED && moment().isBefore(order.modifyTimeExpiresAt);
            });         

            ctrl.isMessageEnabled = true;

            $ngConfirm({
                icon: 'fa fa-stop-circle',
                title: gettextCatalog.getString('Stop offer'),
                scope: $scope,
                contentUrl: 'app/app-commons/components/deal-details-directive/deal-stop-prompt.tpl.html',
                columnClass: 'small',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        btnClass: 'btn-dark float-left',
                    },
                    ok: {
                        text: gettextCatalog.getString('Confirm'),
                        btnClass: 'btn-warning btn-wide',
                        action: function () {
                            if (ctrl.isMessageEnabled && !ctrl.messageText) {
                                return false;
                            }
                            var payload = {
                                bookingEnd: Date.now()
                            };
                            if (ctrl.isMessageEnabled) {
                                payload.message = ctrl.messageText;
                            }
                            HttpService.Post('deals/' + ctrl.deal._id + '/extend', payload).then(function () {
                                AlertService.warning(gettextCatalog.getString('Offer stopped'));
                                ctrl.loadDeals();
                            });
                        }
                    }
                }
            });
        }

        function performDeleteDeal() {
            HttpService.Delete('deals/' + ctrl.deal._id).then(function () {
                AlertService.success(gettextCatalog.getString('Offer deleted'));
                if (ctrl.loadDeals) {
                    ctrl.loadDeals();
                }
            }, function (err) {
                $log.error('Error delete deal', err);
            });
        }

        ctrl.extendDeal = function() {
            $uibModal.open({
                animation: true,
                component: 'extendDeal',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    modalData: function () {
                        return {
                            deal: ctrl.deal
                        };
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    ctrl.loadDeals(ctrl.deal._id);
                }
            });
        }

        ctrl.hasDifferentPrice = function (supplier) {
            if (!supplier.rrp) {
                return false;
            }
            return Math.abs(supplier.rrp - ctrl.deal.benchmarkPrice) > ctrl.priceTolerance;
        };

        ctrl.viewUsers = function () {
            var deal = ctrl.deal;
            // Load deal details to populate user details
            HttpService.Get('deals/' + deal._id).then(function (data) {
                deal.users = data.users;
                $uibModal.open({
                    animation: true,
                    controller: 'DealUsersCtrl',
                    templateUrl: 'app/shared/templates/modals/deal-users.tpl.html',
                    template: Utils.getTemplate('app/shared/templates/modals/deal-users.tpl.html'),
                    size: 'lg',
                    windowClass: 'modal-window',
                    resolve: {
                        items: function () {
                            return { readOnly: true, publish: false, model: deal, users: null, farmTypes: DealsService.getFarmTypes() };
                        }
                    }
                });
            }, function (err) {
                $log.log('Error deal users loading', err);
            });
        };
    }
    
})();
(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('customerEdit', {
            controller: CustomerEditController,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/customer-edit/customer-edit.tpl.html',
            bindings: {
                modalInstance: "<",
                resolve: "<"
            }
        });

    // Moved from modals.js and renamed from userDetailsController on Feb2020 (explains useage of $scope instead of ctrl)
    function CustomerEditController($scope, $rootScope, $q, Utils, HttpService, DealsService, gettextCatalog) {
        var ctrl = this;
        $scope.utils = Utils;

        $scope.lookup = {};
        $scope.lookup.farmTypesMap = DealsService.getFarmTypesMap();
        $scope.lookup.systemsMap = DealsService.getSystemsMap();

        ctrl.$onInit = function () {
            $scope.addGroupMode = false;
            $scope.newGrpValid = true;
            
            $scope.shops = $rootScope.app.Auth.User.supplier.collectionPoints;

            $scope.userData = ctrl.resolve.userData;
            $scope.userData.groups = $scope.userData.groups.filter(function (g) {
                return g && g.name;
            })
            $scope.groupList = ctrl.resolve.groupList;
            init();
        }

        function init() {
            if (!$scope.userData.supplierCustomers || !$scope.userData.supplierCustomers.length) {
                $scope.userData.supplierCustomers = [{
                    isVerified: false
                }];
            }
            $scope.customerIdLabel = $rootScope.app.Auth.User.supplier.customerIdLabel || gettextCatalog.getString('Customer ID');
            if (Utils.isFeatureEnabled('CUSTOMERS_SPECIFIC_ID')) {
                $scope.userData.supplierCustomers[0].customerId = $scope.userData.customerId;
            }
            $scope.supplierCustomer = $scope.userData.supplierCustomers[0];
        }

        $scope.ok = function () {
            // TODO: prompt group creation if ctrl.newGroupName
            
            if (Utils.isFeatureEnabled('CUSTOMERS_SPECIFIC_ID')) {
                $scope.userData.customerId = $scope.userData.supplierCustomers[0].customerId;
            }
            if ($scope.userData.supplierCustomers[0].isVerified) {
                $scope.userData.supplierCustomers[0].isExcluded = false;
            }
            var promises = [];
            $scope.userData.groups.forEach(function (g) {
                if (g.isNew) {
                    var payload = g;
                    promises.push(HttpService.Post('groups', payload).then(function (res) {
                        g._id = res.data._id;
                    }));
                }
            });
            $q.all(promises).then(function () {
                $scope.userData.supplierCustomers[0].groups = $scope.userData.groups;
                ctrl.modalInstance.close($scope.userData);
            });
            if ($scope.supplierCustomer && !$scope.supplierCustomer.collectionPointName) {
                $scope.supplierCustomer.collectionPointName = ''
            }
        };

        $scope.cancel = function () {
            ctrl.modalInstance.dismiss('cancel');
        };

        $scope.setShopData = function (item) {
            $scope.userData.shop = item;
        };

        $scope.filteredGroups = function () {
            var selected = $scope.userData.groups.map(function (g) {
                return g.name;
            });
            if (selected.length) {
                return $scope.groupList.filter(function (g) { return selected.indexOf(g.name) === -1 }).concat([{
                    name: ctrl.groupName
                }]);
            }

            return $scope.groupList.concat([{
                name: ctrl.groupName
            }]);
        };

        $scope.groupNameChanged = function() {
            ctrl.newGroupName = $('#groupName').val() || '';
            ctrl.newGroupName = ctrl.newGroupName.trim();
        }
        $scope.resetNewGroupName = function () {
            ctrl.newGroupName = '';
        }
        $scope.promptCreateNewGroup = function() {
            $scope.addGroupMode = true;
        }

        $scope.cancelNewGroup = function() {
            ctrl.newGroupName = '';
            $scope.addGroupMode = false;
        }

        $scope.addGroup = function() {
            $scope.userData.groups.push(ctrl.selectedGroup);
            ctrl.selectedGroup= null;
        }

        $scope.createNewGroup = function () {
            var val = $('#newGroup').val();
            if (!val) return false;

            var exists = $scope.groupList.filter(function (g) {
                return g.name.toLowerCase().trim() === val.toLowerCase().trim();
            });

            var pending = $scope.userData.groups.filter(function (g) {
                return g.isNew && g.name.toLowerCase().trim() === val.toLowerCase().trim();
            });

            if (exists.length || pending.length) {
                $scope.newGrpValid = false;
                return false;
            }

            if (val) {
                $scope.userData.groups.push({
                    name: val,
                    color: Utils.getRandomHexLightColor(),
                    isNew: true
                });
                $scope.newGrpValid = true;
            }

            $('#newGroup').val('');
            $scope.addGroupMode = false;
            ctrl.newGroupName = '';
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.commons')
        .component('countdown', {
            controller: CountdownCtrl,
            controllerAs: '$ctrl',
            templateUrl: 'app/app-commons/components/countdown/countdown.html',
            bindings: { 
                caption: '=', 
                icon: '=', 
                dateTime: '=',
                hideMinutes: '=', 
                hideSeconds: '=',
                altText: '='
            }
        });

    function CountdownCtrl($scope, $interval, $log, Utils) {
        var ctrl = this;

        $scope.$watch('$ctrl.dateTime', function () {
            stop();
            if (ctrl.dateTime) {
                start();
            }
        });

        $scope.$on('$destroy', function () {
            stop();
        });

        function computeTimeDiff() {
            if (!ctrl.dateTime) {
                ctrl.timeDiff = null;
            }
            ctrl.timeDiff = Utils.getDateDiff(ctrl.dateTime);
        }

        function start() {
            $log.log('Countdown: start', moment(ctrl.dateTime).toDate());
            computeTimeDiff();
            // FIXME: Performance issue with keeping track of seconds in Incoming Page. Switched to Minutes only.
            ctrl.promiseTimeDiff = $interval(computeTimeDiff, 1000 * 60);
        }

        function stop() {
            ctrl.timeDiff = null;
            if (ctrl.promiseTimeDiff) {
                $log.log('Countdown: stop');
                $interval.cancel(ctrl.promiseTimeDiffs);
            }
        }
    }
})();
/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-csstransitions-touchevents-video-videoautoplay-domprefixes-mq-prefixes-setclasses-shiv-testallprops-testprop !*/
!function(A,e,t){function n(A,e){return typeof A===e}function o(){var A,e,t,o,r,a,i;for(var l in w)if(w.hasOwnProperty(l)){if(A=[],e=w[l],e.name&&(A.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(t=0;t<e.options.aliases.length;t++)A.push(e.options.aliases[t].toLowerCase());for(o=n(e.fn,"function")?e.fn():e.fn,r=0;r<A.length;r++)a=A[r],i=a.split("."),1===i.length?Modernizr[i[0]]=o:(!Modernizr[i[0]]||Modernizr[i[0]]instanceof Boolean||(Modernizr[i[0]]=new Boolean(Modernizr[i[0]])),Modernizr[i[0]][i[1]]=o),E.push((o?"":"no-")+i.join("-"))}}function r(A){var e=B.className,t=Modernizr._config.classPrefix||"";if(T&&(e=e.baseVal),Modernizr._config.enableJSClass){var n=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");e=e.replace(n,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(e+=" "+t+A.join(" "+t),T?B.className.baseVal=e:B.className=e)}function a(){return"function"!=typeof e.createElement?e.createElement(arguments[0]):T?e.createElementNS.call(e,"http://www.w3.org/2000/svg",arguments[0]):e.createElement.apply(e,arguments)}function i(){var A=e.body;return A||(A=a(T?"svg":"body"),A.fake=!0),A}function l(A,t,n,o){var r,l,c,s,u="modernizr",d=a("div"),f=i();if(parseInt(n,10))for(;n--;)c=a("div"),c.id=o?o[n]:u+(n+1),d.appendChild(c);return r=a("style"),r.type="text/css",r.id="s"+u,(f.fake?f:d).appendChild(r),f.appendChild(d),r.styleSheet?r.styleSheet.cssText=A:r.appendChild(e.createTextNode(A)),d.id=u,f.fake&&(f.style.background="",f.style.overflow="hidden",s=B.style.overflow,B.style.overflow="hidden",B.appendChild(f)),l=t(d,A),f.fake?(f.parentNode.removeChild(f),B.style.overflow=s,B.offsetHeight):d.parentNode.removeChild(d),!!l}function c(A,e){return!!~(""+A).indexOf(e)}function s(A){return A.replace(/([a-z])-([a-z])/g,function(A,e,t){return e+t.toUpperCase()}).replace(/^-/,"")}function u(A,e){if("object"==typeof A)for(var t in A)M(A,t)&&u(t,A[t]);else{A=A.toLowerCase();var n=A.split("."),o=Modernizr[n[0]];if(2==n.length&&(o=o[n[1]]),"undefined"!=typeof o)return Modernizr;e="function"==typeof e?e():e,1==n.length?Modernizr[n[0]]=e:(!Modernizr[n[0]]||Modernizr[n[0]]instanceof Boolean||(Modernizr[n[0]]=new Boolean(Modernizr[n[0]])),Modernizr[n[0]][n[1]]=e),r([(e&&0!=e?"":"no-")+n.join("-")]),Modernizr._trigger(A,e)}return Modernizr}function d(A,e){return function(){return A.apply(e,arguments)}}function f(A,e,t){var o;for(var r in A)if(A[r]in e)return t===!1?A[r]:(o=e[A[r]],n(o,"function")?d(o,t||e):o);return!1}function h(A){return A.replace(/([A-Z])/g,function(A,e){return"-"+e.toLowerCase()}).replace(/^ms-/,"-ms-")}function m(e,t,n){var o;if("getComputedStyle"in A){o=getComputedStyle.call(A,e,t);var r=A.console;if(null!==o)n&&(o=o.getPropertyValue(n));else if(r){var a=r.error?"error":"log";r[a].call(r,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!t&&e.currentStyle&&e.currentStyle[n];return o}function p(e,n){var o=e.length;if("CSS"in A&&"supports"in A.CSS){for(;o--;)if(A.CSS.supports(h(e[o]),n))return!0;return!1}if("CSSSupportsRule"in A){for(var r=[];o--;)r.push("("+h(e[o])+":"+n+")");return r=r.join(" or "),l("@supports ("+r+") { #modernizr { position: absolute; } }",function(A){return"absolute"==m(A,null,"position")})}return t}function g(A,e,o,r){function i(){u&&(delete S.style,delete S.modElem)}if(r=n(r,"undefined")?!1:r,!n(o,"undefined")){var l=p(A,o);if(!n(l,"undefined"))return l}for(var u,d,f,h,m,g=["modernizr","tspan","samp"];!S.style&&g.length;)u=!0,S.modElem=a(g.shift()),S.style=S.modElem.style;for(f=A.length,d=0;f>d;d++)if(h=A[d],m=S.style[h],c(h,"-")&&(h=s(h)),S.style[h]!==t){if(r||n(o,"undefined"))return i(),"pfx"==e?h:!0;try{S.style[h]=o}catch(v){}if(S.style[h]!=m)return i(),"pfx"==e?h:!0}return i(),!1}function v(A,e,t,o,r){var a=A.charAt(0).toUpperCase()+A.slice(1),i=(A+" "+x.join(a+" ")+a).split(" ");return n(e,"string")||n(e,"undefined")?g(i,e,o,r):(i=(A+" "+C.join(a+" ")+a).split(" "),f(i,e,t))}function y(A,e,n){return v(A,t,t,e,n)}var E=[],w=[],R={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(A,e){var t=this;setTimeout(function(){e(t[A])},0)},addTest:function(A,e,t){w.push({name:A,fn:e,options:t})},addAsyncTest:function(A){w.push({name:null,fn:A})}},Modernizr=function(){};Modernizr.prototype=R,Modernizr=new Modernizr;var F=R._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];R._prefixes=F;var B=e.documentElement,T="svg"===B.nodeName.toLowerCase();T||!function(A,e){function t(A,e){var t=A.createElement("p"),n=A.getElementsByTagName("head")[0]||A.documentElement;return t.innerHTML="x<style>"+e+"</style>",n.insertBefore(t.lastChild,n.firstChild)}function n(){var A=y.elements;return"string"==typeof A?A.split(" "):A}function o(A,e){var t=y.elements;"string"!=typeof t&&(t=t.join(" ")),"string"!=typeof A&&(A=A.join(" ")),y.elements=t+" "+A,c(e)}function r(A){var e=v[A[p]];return e||(e={},g++,A[p]=g,v[g]=e),e}function a(A,t,n){if(t||(t=e),u)return t.createElement(A);n||(n=r(t));var o;return o=n.cache[A]?n.cache[A].cloneNode():m.test(A)?(n.cache[A]=n.createElem(A)).cloneNode():n.createElem(A),!o.canHaveChildren||h.test(A)||o.tagUrn?o:n.frag.appendChild(o)}function i(A,t){if(A||(A=e),u)return A.createDocumentFragment();t=t||r(A);for(var o=t.frag.cloneNode(),a=0,i=n(),l=i.length;l>a;a++)o.createElement(i[a]);return o}function l(A,e){e.cache||(e.cache={},e.createElem=A.createElement,e.createFrag=A.createDocumentFragment,e.frag=e.createFrag()),A.createElement=function(t){return y.shivMethods?a(t,A,e):e.createElem(t)},A.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+n().join().replace(/[\w\-:]+/g,function(A){return e.createElem(A),e.frag.createElement(A),'c("'+A+'")'})+");return n}")(y,e.frag)}function c(A){A||(A=e);var n=r(A);return!y.shivCSS||s||n.hasCSS||(n.hasCSS=!!t(A,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),u||l(A,n),A}var s,u,d="3.7.3",f=A.html5||{},h=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,m=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,p="_html5shiv",g=0,v={};!function(){try{var A=e.createElement("a");A.innerHTML="<xyz></xyz>",s="hidden"in A,u=1==A.childNodes.length||function(){e.createElement("a");var A=e.createDocumentFragment();return"undefined"==typeof A.cloneNode||"undefined"==typeof A.createDocumentFragment||"undefined"==typeof A.createElement}()}catch(t){s=!0,u=!0}}();var y={elements:f.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:d,shivCSS:f.shivCSS!==!1,supportsUnknownElements:u,shivMethods:f.shivMethods!==!1,type:"default",shivDocument:c,createElement:a,createDocumentFragment:i,addElements:o};A.html5=y,c(e),"object"==typeof module&&module.exports&&(module.exports=y)}("undefined"!=typeof A?A:this,e);var G="Moz O ms Webkit",C=R._config.usePrefixes?G.toLowerCase().split(" "):[];R._domPrefixes=C,Modernizr.addTest("video",function(){var A=a("video"),e=!1;try{e=!!A.canPlayType,e&&(e=new Boolean(e),e.ogg=A.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),e.h264=A.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),e.webm=A.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,""),e.vp9=A.canPlayType('video/webm; codecs="vp9"').replace(/^no$/,""),e.hls=A.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/,""))}catch(t){}return e});var Q=function(){var e=A.matchMedia||A.msMatchMedia;return e?function(A){var t=e(A);return t&&t.matches||!1}:function(e){var t=!1;return l("@media "+e+" { #modernizr { position: absolute; } }",function(e){t="absolute"==(A.getComputedStyle?A.getComputedStyle(e,null):e.currentStyle).position}),t}}();R.mq=Q;var b=R.testStyles=l;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in A||A.DocumentTouch&&e instanceof DocumentTouch)t=!0;else{var n=["@media (",F.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");b(n,function(A){t=9===A.offsetTop})}return t});var x=R._config.usePrefixes?G.split(" "):[];R._cssomPrefixes=x;var M;!function(){var A={}.hasOwnProperty;M=n(A,"undefined")||n(A.call,"undefined")?function(A,e){return e in A&&n(A.constructor.prototype[e],"undefined")}:function(e,t){return A.call(e,t)}}(),R._l={},R.on=function(A,e){this._l[A]||(this._l[A]=[]),this._l[A].push(e),Modernizr.hasOwnProperty(A)&&setTimeout(function(){Modernizr._trigger(A,Modernizr[A])},0)},R._trigger=function(A,e){if(this._l[A]){var t=this._l[A];setTimeout(function(){var A,n;for(A=0;A<t.length;A++)(n=t[A])(e)},0),delete this._l[A]}},Modernizr._q.push(function(){R.addTest=u}),Modernizr.addAsyncTest(function(){function A(a){o++,clearTimeout(e);var i=a&&"playing"===a.type||0!==r.currentTime;return!i&&n>o?void(e=setTimeout(A,t)):(r.removeEventListener("playing",A,!1),u("videoautoplay",i),void(r.parentNode&&r.parentNode.removeChild(r)))}var e,t=200,n=5,o=0,r=a("video"),i=r.style;if(!(Modernizr.video&&"autoplay"in r))return void u("videoautoplay",!1);i.position="absolute",i.height=0,i.width=0;try{if(Modernizr.video.ogg)r.src="data:video/ogg;base64,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";else{if(!Modernizr.video.h264)return void u("videoautoplay",!1);r.src="data:video/mp4;base64,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"}}catch(l){return void u("videoautoplay",!1)}r.setAttribute("autoplay",""),r.style.cssText="display:none",B.appendChild(r),setTimeout(function(){r.addEventListener("playing",A,!1),e=setTimeout(A,t)},0)});var Z={elem:a("modernizr")};Modernizr._q.push(function(){delete Z.elem});var S={style:Z.elem.style};Modernizr._q.unshift(function(){delete S.style});R.testProp=function(A,e,n){return g([A],t,e,n)};R.testAllProps=v,R.testAllProps=y,Modernizr.addTest("csstransitions",y("transition","all",!0)),o(),r(E),delete R.addTest,delete R.addAsyncTest;for(var Y=0;Y<Modernizr._q.length;Y++)Modernizr._q[Y]();A.Modernizr=Modernizr}(window,document);
/* Theme Name: The Project - Responsive Website Template
 * Author: HtmlCoder
 * Author URI:http://www.htmlcoder.me
 * Author e-mail:htmlcoder.me@gmail.com
 * Version: 2.0.5
 * Created: March 2015
 * License URI: http://support.wrapbootstrap.com/
 * File Description: Place here your custom scripts
 */

(function($){
	$(document).ready(function(){

		// Notify Plugin - The below code (until line 42) is used for demonstration purposes only
		//-----------------------------------------------
		if (($(".main-navigation.onclick").length>0) && !Modernizr.touch ){ // eslint-disable-line
			$.notify({
				// options
				message: 'The Dropdowns of the Main Menu, are now open with click on Parent Items. Click "Home" to checkout this behavior.'
			},{
				// settings
				type: 'info',
				delay: 10000,
				offset : {
					y: 150,
					x: 20
				}
			});
		}
		if (!($(".main-navigation.animated").length>0) && !Modernizr.touch && $(".main-navigation").length>0){ // eslint-disable-line
			$.notify({
				// options
				message: 'The animations of main menu are disabled.'
			},{
				// settings
				type: 'info',
				delay: 10000,
				offset : {
					y: 150,
					x: 20
				}
			}); // End Notify Plugin - The above code (from line 14) is used for demonstration purposes only

		}
	}); // End document ready

})(this.jQuery);

(function(){
    'use strict';

    angular
        .module('app.profile')
            .component('subscriptionAlert', {
                controller: SubscriptionAlert,
                controllerAs: '$ctrl',
                templateUrl: 'app/modules/subscription/subscription-alert.tpl.html',
                bindings: {}
            });

    function SubscriptionAlert(Utils) {
        var ctrl = this;
        ctrl.utils = Utils;
    }
})();

(function(){
    'use strict';

    angular
        .module('app.retailers', []);
})();
(function () {
    'use strict';

    angular
        .module('app.retailers')
            .config(retaielrsConfig);

    function retaielrsConfig($stateProvider) {

        $stateProvider
            .state('app.retailers', {
                url: '/retailers',
                component: 'retailers'
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('app.retailers')
            .component('retailers', {
                controller: RetailersCtrl,
                controllerAs: 'vm',
                templateUrl: 'app/modules/retailers/retailers.html'
            });

    function RetailersCtrl($rootScope, $state, $timeout, $uibModal, HttpService, Utils) {
        var vm = this;
        vm.utils = Utils;

        vm.$onInit = function() {
            init();
        };

        function init() {
            if (!$rootScope.app.Auth.User) {
                $timeout(init, 1000);
                return;
            }
            if (!Utils.isSupplierDistributor()) {
                $state.go('app.customers.list');
            }

            loadRetailers();
        }

        function loadRetailers() {
            HttpService.Get('suppliers').then(function (data) {
                vm.retailers = data.list;
            });
        }

        vm.inviteRetailer = function (retailer) {
            $uibModal.open({
                animation: true,
                component: 'inviteCustomers',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    modalData: function () {
                        return {
                            supplier: retailer
                        };
                    }
                }
            }).result.then(function () {
                loadRetailers();
            });
        }

        vm.showPendingInvites = function () {
            $uibModal.open({
                animation: true,
                component: 'pendingInvites',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    invites: function () {
                        return [];
                    }
                }
            });
        };
    }
})();

/**
 * Created by Hafeez Rehman on 15/02/2018.
 */

(function(){
    'use strict';

     angular
         .module('app.profile')
            .service('ProfileService', ProfileService);

     ProfileService.$inject = ['$rootScope'];

     function ProfileService(){

     }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.profile')
            .config(profileConfig);

    function profileConfig($stateProvider) {

        $stateProvider
            .state('app.profile',{
                url: '/profile',
                abstract: true
            })
            .state('app.profile.main',{
                url: '?tab?code',
                component: 'userProfile'
            })
            .state('app.profile.password',{
                url: '/updatePassword',
                component: 'userProfile'
            });
    }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.product')
            .config(productConfig);

    function productConfig($stateProvider, $httpProvider) {

        $httpProvider.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';

        $stateProvider
            .state('app.products',{
                url: '/products?searchText',
                component: 'productsView'
            });
    }
})();
/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.order')
            .config(orderConfig);

    function orderConfig($stateProvider, $httpProvider) {

        $httpProvider.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';

        $stateProvider
            .state('app.orders',{
                url: '/orders?type?role?ref?orderId?startIntro',
                component: 'ordersView'
            })
            .state('order',{
                url: '/order?token',
                component: 'orderView',
                skipAuthorization: true,
                resolve: {
                    'baseData': function($stateParams, jwtHelper) {
                        try {
                            if (jwtHelper.isTokenExpired($stateParams.token)) {
                                return false;
                            }
                            return jwtHelper.decodeToken($stateParams.token);
                        } catch(err) {
                            return false;
                        }
                    }
                }
            });
    }
})();
/**
 * Created by Hafeez Rehman on 06/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.offers')
            .config(offersConfig);

    function offersConfig($stateProvider) {
        $stateProvider
            .state('app.offers', {
                url: '/offers',
                template: '<div ui-view></div>',
                abstract: true
            })
            .state('app.offers.incoming', {
                url: '/incoming?id',
                component: 'incomingOffers'
            })
            .state('app.offers.search', {
                url: '/search?searchText?requestId?orderId',
                component: 'searchOffers'
            })
            .state('app.offers.received', {
                url: '/received?id?searchText?startIntro',
                component: 'offersReceived'
            });
    }
})();

/**
 * Created by Hafeez Rehman on 06/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.deals')
            .config(dealsConfig);

    function dealsConfig($stateProvider){
        $stateProvider
            .state('app.deals', {
                url: '/deals',
                template: '<div ui-view></div>',
                abstract: true
            })
            .state('app.deals.list', {
                url: '?type?page?size?dealId?startIntro',
                component: 'dealsList'
            })
            .state('app.deals.request', {
                url: '/requests?id?role?type',
                component: 'dealRequest'
            })
            .state('app.deals.new', {
                url: '/create',
                component: 'dealsNew'
            })
            .state('app.deals.update', {
                url: '/:id/update?referrer?startIntro',
                component: 'dealUpdate',
                params: {
                    selectProductOnInit: false
                }
            })
            .state('app.deals.history', {
                url: '/history',
                component: 'dealsList',
                params: {
                  'show': ['FULFILLED', 'EXPIRED']
                }
            })
            .state('app.deals.draft', {
                url: '/draft',
                component: 'dealsList'
            })
            .state('app.deals.report', {
                url: '/:id/report?order',
                component: 'dealsReport'
            });
    }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.dashboard')
            .config(dashboardConfig);

    function dashboardConfig($stateProvider) {

        $stateProvider
            .state('app.dashboard', {
                url: '/dashboard',
                component: 'dashboard'
            });
    }
})();
/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app.dashboard')
            .component('dashboard', {
                controller: Dashboardvm,
                controllerAs: 'vm',
                templateUrl: 'app/modules/dashboard/dashboard.html'
            });

    function Dashboardvm($state, $rootScope, $log, $timeout, $window, gettextCatalog, HttpService, DealsService, Utils, DEAL_CATEGORY) {
        var vm = this;
        vm.stats = $rootScope.app.Stats;
        vm.utils = Utils;

        

        vm.$onInit = function() {
            if (!Utils.getSettings().isInternational) {
                setupSlides();
            }
            
            HttpService.Get('me/statistics').then(function(data) {
                vm.stats = data;
            }, function(err) {
                $log.error(err);
            });

            $timeout(function() {
                vm.redirectToNewAppIfNecessary();
            }, 1000);
        };

        function setupSlides() {
            vm.slides = [
                { img: 'app/shared/images/tutorial/tutorial_steps_1.png', title: gettextCatalog.getString('Create an offer'), 
                    text: gettextCatalog.getString('Click on "Create new offer" to setup a new offer for your customers.') },
                { img: 'app/shared/images/tutorial/tutorial_steps_2.png', title: gettextCatalog.getString('Notify farmers'), 
                    text: gettextCatalog.getString('Click on "Publish" when you are happy for the offer details. Farmers will receive a notification on their mobile phones.')},
                { img: 'app/shared/images/tutorial/tutorial_steps_3.png', title: gettextCatalog.getString('Receive orders'), 
                    text: gettextCatalog.getString('You will be notified on farmers bookings.')},
                { img: 'app/shared/images/tutorial/tutorial_preview_contact_details.png', title: gettextCatalog.getString('Mobile preview: contact details'), 
                    text: gettextCatalog.getString('Business name and your contacts can be optionally shared on the offer.')},
                { img: 'app/shared/images/tutorial/tutorial_preview_product_and_image.png', title: gettextCatalog.getString('Mobile preview: product name and image'), 
                    text: gettextCatalog.getString('Product name and a picture associated to it is displayed to farmers on the mobile app.') },
                { img: 'app/shared/images/tutorial/tutorial_preview_price_and_discount.png', title: gettextCatalog.getString('Mobile preview: price and discount'), 
                    text: gettextCatalog.getString('Multiple discount options available: flat discount, quantity-based or group discount.') },
                { img: 'app/shared/images/tutorial/tutorial_preview_units_available.png', title: gettextCatalog.getString('Mobile preview: units available and distribution method'), 
                    text: gettextCatalog.getString('The number of units available and distribution methods will be showed to famers on the mobile app.') },
            ];
        }

        vm.isLangDe = function() {
            var locale = '' + gettextCatalog.getCurrentLanguage();
            if (locale.indexOf('de') >= 0) {
                return true;
            }
            return false;
        }

        vm.createNewSaleOffer = function () {
            DealsService.createNewDraft({
                product: $rootScope.app.Auth.User.products[0],
                categoryName: DEAL_CATEGORY.DEAL
            });
        };

        vm.createNewCropOffer = function () {
            DealsService.createNewDraft({
                categoryName: DEAL_CATEGORY.CROP
            });
        };

        vm.createOffer = function () {
            if (Utils.supplierHasProductTypeSell()) {
                vm.createNewCropOffer();
                return;
            }
            vm.createNewSaleOffer();
        };

        vm.hasMultipleChoiceCreateNew = function () {
            return Utils.supplierHasProductTypeSell() && Utils.supplierHasProductTypeBuy();
        }

        vm.startIntro = function() {
            
            Utils.startIntro([
                {
                    element: '#header-logo',
                    intro: gettextCatalog.getString('You access this page at any time by clicking on the FarmHedge icon in the upper left corner.'),
                },
                {
                    element: '#dashboard-overview',
                    intro: gettextCatalog.getString('Keep the important stuff under control.')
                },
                {
                    element: '#dashboard-tutorial',
                    intro: gettextCatalog.getString('You can also click through a short tutorial of the FarmHedge platform.'),
                },
                {
                    element: '#dashboard-support',
                    intro: gettextCatalog.getString('If you need our help, you can contact us directly via email from the dashboard.'),
                },
                {
                    element: '#header-buttons-container',
                    intro: gettextCatalog.getString('Here you can see current offers, planned offers, received requests and open orders.'),
                },
            ], 
            {
                text: gettextCatalog.getString('Go to "Offers sent"'),
                action: function () {
                    $state.go('app.deals.list', {
                        startIntro: true
                    });
                }
            });
        }

        vm.redirectToNewAppIfNecessary = function () {
            var supplierIdToDashboardUrl = {
                '603fa83c2f613a0016e6e6c0': 'https://dashboard-staging.rwa.farmhedge.ro',
                '605a19f35a10a80016c90ce9': 'https://dashboard.rwa.farmhedge.ro',
                '5fcfac0c84d06800163a0f01': 'https://dashboard-staging.ufeeds.farmhedge.co.uk',
                '6048b632c760c000163f23a3': 'https://dashboard.ufeeds.farmhedge.co.uk',
            };
            vm.newDashboardUrl = supplierIdToDashboardUrl[$rootScope.app.Auth.User.supplier._id];
            if (!vm.newDashboardUrl || Utils.isUserRegionalManager() || !$rootScope.app.Auth.User.supplier) {
                return;
            }
            if (vm.newDashboardUrl) {
                vm.redirectToNewDashboardUrl();        
            }
        } 

        vm.redirectToNewDashboardUrl = function() {
            if (vm.newDashboardUrl) {
                $log.log('Redirecting new dashboard:', vm.newDashboardUrl);
                $window.location = vm.newDashboardUrl + '/auth/login?email=' + $rootScope.app.Auth.User.email
            }
        }
    }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.customers')
            .config(customerConfig);

    function customerConfig($stateProvider) {

        $stateProvider
            .state('app.customers', {
                url: '/customers',
                abstract: true
            })
            .state('app.customers.list',{
                url: '?showInvites?inviteCustomers',
                component: 'customers'
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('app.customers')
            .component('customers', {
                controller: CustomersCtrl,
                controllerAs: 'vm',
                templateUrl: 'app/modules/customers/customers.html'
            });

    function CustomersCtrl($state, $rootScope, $log, $timeout, $stateParams, gettextCatalog, Utils, HttpService, DealsService, AlertService, $uibModal, $anchorScroll) {
        var vm = this;
        vm.utils = Utils;
        vm.csvReportLimit = 100;
        vm.invitesMode = true;

        vm.sorting = {
            field: 'becameCustomerAt',
            order: -1,
        };

        vm.$onInit = function() {
            init();
        };

        vm.toggleInbound = function() {
            vm.invitesMode = !vm.invitesMode;
        };

        function init() {
            if (!$rootScope.app.Auth.User) {
                $timeout(init, 1000);
                return;
            }
            if (Utils.isSupplierDistributor()) {
                $state.go('app.dashboard');
            }

            vm.lookup = {};
            vm.paging = { current: 1, maxSize: 3, itemsPerPage: 20 };

            vm.lookup.farmTypes = DealsService.getFarmTypes();
            vm.lookup.farmTypesMap = DealsService.getFarmTypesMap();
            vm.lookup.systems = DealsService.getSystems();
            vm.lookup.systemsMap = DealsService.getSystemsMap();

            vm.selectedSystem = '';
            vm.selectedFarmTypes = [];

            vm.customerIdLabel = $rootScope.app.Auth.User.supplier.customerIdLabel || gettextCatalog.getString('Customer ID');

            loadUsers();
            loadGroups();
            loadInvites();
        }

        vm.applyFilter = function() {
            loadUsers();
        };

        vm.onPage = function() {
            if (vm.init) {
                loadUsers();
                loadGroups();
                loadInvites();
                $anchorScroll('top');
            }
        };

        vm.reset = function() {
            vm.selectedName = '';
            vm.selectedSystem = '';
            vm.selectedFarmTypes = [];
            vm.selectedGroup = '';
            loadUsers();
        };

        vm.inviteCustomers = function() {
            var dialog = $uibModal.open({
                animation: true,
                component: 'inviteCustomers',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    modalData: function() {
                        return {};
                    }
                }
            })
            
            dialog.result.then(function(result) {
                if (!result) {
                    return;
                }
                loadInvites();
                vm.showPendingInvites();
            });
        };

        vm.exportCustomers = function() {
            $uibModal.open({
                animation: true,
                component: 'exportCustomers',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    modalData: function () {
                        return vm.paging;
                    }
                }
            });
        };

        vm.showPendingInvites = function () {
            $uibModal.open({
                animation: true,
                component: 'pendingInvites',
                windowClass: 'modal-window',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    invites: function () {
                        return vm.invites;
                    }
                }
            });
        };

        function getUsersQuery(currentPage, pageSize) {
            var queryUrl = 'users?skip=' + (currentPage - 1) * pageSize + '&limit=' + pageSize;

            if(vm.selectedName) {
                queryUrl += '&name=' + vm.selectedName;
            }

            if(vm.selectedFarmTypes.length) {
                var farmsJoined = vm.selectedFarmTypes.map(function(f){
                                     return f.value;
                                  }).join(',');
                queryUrl += '&farmTypes=' + farmsJoined;
            }

            if (vm.selectedSystem) {
                queryUrl += '&system=' + vm.selectedSystem;
            }

            if (vm.selectedGroup) {
                queryUrl += '&group=' + vm.selectedGroup;
            }

            if (vm.sorting && vm.sorting.field) {
                queryUrl += '&sortField=' + vm.sorting.field;
            }
            if (vm.sorting && vm.sorting.order) {
                queryUrl += '&sortOrder=' + vm.sorting.order;
            }

            return queryUrl;
        }

        function loadUsers() {
            HttpService.Get(getUsersQuery(vm.paging.current, vm.paging.itemsPerPage)).then(function(data) {
                vm.Customers = data.list;
                vm.paging.count = +data.count;
                vm.newEntriesThisWeekCount = data.headers('x-last-week-count');
                vm.newEntriesThisMonthCount = data.headers('x-last-month-count');
                vm.init = true;
                var newThreshold = moment().subtract(1, 'week');
                vm.Customers.forEach(function(customer) {
                    customer.hasRegisteredRecently = newThreshold.isBefore(customer.suppliersLastChangedAt || customer.createdAt);
                    if (customer.lastDealsAck) {
                        customer.activeDaysAgo = moment().diff(customer.lastDealsAck, 'days'); // eslint-disable-line no-undef
                        customer.isActiveToday = customer.activeDaysAgo === 0;
                        customer.isActiveWeekly = !customer.isActiveToday && customer.activeDaysAgo <= 7;
                        customer.isActiveMonthly = !customer.isActiveToday && !customer.isActiveWeekly && customer.activeDaysAgo <= 31;
                    }
                });
            }, function(err) {
                $log.error(err);
            });

            
        }

        function loadInvites() {
            HttpService.Get('invites', { limit: 1 }).then(function (data) {
                vm.invites = data.list;
                vm.pendingInvitesCount = +(data.headers('x-pending-count') || 0);

                if ($stateParams.inviteCustomers) {
                    vm.inviteCustomers();
                }
                else if ($stateParams.showInvites) {
                    vm.showPendingInvites();
                }
                
            });
        }

        vm.openUserDetailsModal = function (selectedUserData) {
            HttpService.Get('users/' + selectedUserData._id).then(function (userDataWrapper) {
                // console.log('HERE')
                $uibModal.open({
                    animation: true,
                    component: 'customerEdit',
                    windowClass: 'modal-window',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        userData: function () { return userDataWrapper.user; },
                        groupList: function () { return vm.groupList; }
                    }
                }).result.then(function (userData) {
                        if (!userData) {
                            return;
                        }
                        HttpService.Put('users/' + userData._id, userData).then(function () {
                            AlertService.success(gettextCatalog.getString('Customer data updated successfully'));
                            loadGroups();
                        }, function (err) {
                            $log.log('Error occurred while updating customer data.', err);
                        });
                    })
                    .catch(function () {
                        loadUsers();
                    });
            });
        };

        function getDateString() {
            var date = new Date();
            return date.getFullYear()  + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        }

        function downloadDataAsCsv(content) {
            var supplierName = $rootScope.app.Auth.User.supplier.name.toLowerCase().replace(' ', '-');
            var fileName = 'fh_customers_' + supplierName + '_max' + vm.csvReportLimit + '_' + getDateString() + '.csv';
            $log.log('Exporting as: ', fileName);


            if (navigator.msSaveBlob) {
                $log.log('Exporting CSV file (IE10+)');
                var blob = new Blob([content], {
                    type:'text/csv;charset=utf-8;'
                });
                navigator.msSaveBlob(blob, fileName);
                $log.log('Exported data as: ', fileName);
                return;
            }

            $log.log('Exporting CSV file (Not IE)');
            var hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:attachment/csv,' + encodeURI(content);
            hiddenElement.target = '_blank';
            hiddenElement.download = fileName;
            hiddenElement.click();
            $log.log('Exported data as: ', fileName);
        }

        function localizeFarmTypesForCsv(farmTypes) {
            if (!farmTypes || !farmTypes.length) {
                return '---';
            }
            return farmTypes.map(function(ft) {
                return vm.lookup.farmTypesMap[ft];
            }).join('; ');
        }

        vm.downloadCsv = function() {
            HttpService.Get(getUsersQuery(1, vm.csvReportLimit || 100)).then(function(data) {
                $log.log('Got customer data');
                var result = data.list;
                var header = 'Name,Customer ID,Farm zip code,Farm types,Farm system,Registered\n'
                var body = result.map(function(c) {
                    var row = [];
                    row.push(c.name.first + ' ' + c.name.last);
                    row.push(c.customerId || '');
                    row.push(c.address ? (c.address.zipcode || '') : '');
                    row.push(localizeFarmTypesForCsv(c.farmTypes)); // TODO: localize
                    row.push(vm.lookup.systemsMap[c.system] || '');
                    row.push(Utils.getLocalizedDate(c.createdAt));
                    return row.join(',');
                }).join('\n');
                downloadDataAsCsv(header + body);
            });            
        };

        vm.sortUsers = function (sortField, sortOrder) {
            vm.sorting.order = (vm.sorting.field === sortField) ? -vm.sorting.order : (sortOrder || 1);
            vm.sorting.field = sortField;
            loadUsers();
        };

        vm.getSortClass = function (sortField) {
            if (vm.sorting.field !== sortField) {
                return '';
            }
            return (vm.sorting.order < 0) ? 'fa-sort-amount-desc' : 'fa-sort-amount-asc';
        }


        function loadGroups() {
            HttpService.Get('groups').then(function(data) {
                vm.groupList = data.list || [];
            });
        }

    }
})();

/**
 * Created by Hafeez Rehman on 06/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.crop', []);
})();

/**
 * Created by Hafeez Rehman on 20/12/2017.
 */

(function(){
    'use strict';

    angular
        .module('app.crop')
            .service('CropService', CropService);

    function CropService(Utils) {

        var cropTypeToVendorProductId = {
            'Premiumweizen': '673803',
            'Qualitätsweizen': '10181', 
            'Mahlweizen': '10173', 
            'Futterweizen': '166', 
            'Roggen': '10165', 
            'Durumweizen': '673791', 
            'Gerste': '117', 
            'Mais': '6023', 
        };
        
        this.initCrops = function() {
            var allCropConfigs = this.allCropConfigs;
            Object.keys(allCropConfigs).forEach(function(country) {
                var qc = allCropConfigs[country];
                qc.cropTypes.filter(function(cropType) {
                    return !cropType.qualityStandards; // Add crop standards for records stored using qualityValues arrays.
                }).forEach(function(cropType) {
                    cropType.qualityStandards = cropType.qualityValues.map(function(v, i) {
                        return {
                            label: qc.qualityStandards[i].label,
                            unit: qc.qualityStandards[i].unit,
                            limit: qc.qualityStandards[i].limit,
                            required: v !== 0,
                            value: v
                        };
                    }).filter(function(qs) {
                        return qs.value >= 0;
                    });
                });
            });
        }

        this.getCropConfig = function(supplier) {
            var countryConfig = this.allCropConfigs[supplier.area.toLowerCase()];
            return countryConfig ? countryConfig : this.allCropConfigs.austria;
        }

        this.getCropTypes = function(supplier) {
            var cropTypes = this.getCropConfig(supplier).cropTypes;
            if (Utils.isSupplierDistributor()) {
                cropTypes.forEach(function(ct) {
                    ct.vendorProductId = cropTypeToVendorProductId[ct.label];
                });
            }
            return this.getCropConfig(supplier).cropTypes;
        };

        this.getQualityStandards = function(supplier) {
            return this.getCropConfig(supplier).qualityStandards;
        };

        this.allCropConfigs = {
            "germany": {
                "cropTypes": [
                    {
                        "label": "Futterweizen",
                        "qualityValues": [-1, 72, -1, 14.5, 2, -1, -1, -1, -1, -1, -1, 5]
                    }, {
                        "label": "Brotweizen",
                        "qualityValues": [11.5, 76, 220, 14.5, 2, 22, -1, -1, -1, -1, -1, 1]
                    }, {
                        "label": "A-Weizen",
                        "qualityValues": [13, 77, 250, 14.5, 2, 50, -1, -1, -1, -1, -1, 1]
                    }, {
                        "label": "E-Weizen",
                        "qualityValues": [14.5, 77, 280, 14, 2, 50, -1, -1, -1, -1, -1, 1]
                    }, {
                        "label": "Roggen",
                        "qualityValues": [72, 120, 14.5, 2, -1, -1.05, -1, -1, -1, -1, -1, 1]
                    }, {
                        "label": "Braugerste",
                        "qualityValues": [11, -1, -1, 14.5, 2, -1, -1, 90, 95, -1, -1, 2]
                    }, {
                        "label": "Futtergerste",
                        "qualityValues": [-1, 63, -1, 14.5, 2, -1, -1, -1, -1, -1, -1, 5]
                    }, {
                        "label": "Hafer",
                        "qualityValues": [-1, 52, -1, 14.5, 2, -1, -1, -1, -1, -1, -1, 1]
                    }, {
                        "label": "Triticale",
                        "qualityValues": [-1, 70, -1, 14.5, 2, -1, -1.1, -1, -1, -1, -1, 5]
                    }, {
                        "label": "Futtemais",
                        "qualityValues": [-1, -1, -1, 14.5, 2, -1, -1, -1, -1, 8, -1, -1]
                    }, {
                        "label": "Lebensmittel Mais",
                        "qualityValues": [-1, -1, -1, 14.5, 2, -1, -1, -1, -1, 5, -1, -1]
                    }, {
                        "label": "Raps",
                        "qualityValues": [-1, -1, -1, 14.5, 2, -1, -1, -1, -1, 5, -1, -1]
                    }
                ],
                "qualityStandards": [
                    { "label": "Protein", "unit": "%", "limit": "min." },
                    { "label": "Hektolitergewicht", "unit": "kg/hl", "limit": "min." },
                    { "label": "Fallzahl", "unit": "sec.", "limit": "min." },
                    { "label": "Feuchte", "unit": "%", "limit": "max." },
                    { "label": "Besatz", "unit": "%", "limit": "max." },
                    { "label": "Sedimentationswert", "unit": "mm", "limit": "min." },
                    { "label": "Mutterkorn", "unit": "%", "limit": "max." },
                    { "label": "Vollgerste", "unit": "%", "limit": "min." },
                    { "label": "Keimfähigkeit", "unit": "%", "limit": "min." },
                    { "label": "Bruchkorn", "unit": "%", "limit": "max." },
                    { "label": "Olgehalt", "unit": "%", "limit": "Basis." },
                    { "label": "Auswuchs", "unit": "%", "limit": "max." }
                ]
            },
            "ireland": {
                "cropTypes": [
                    {
                        "label": "Rapeseed",
                        "qualityValues": [10]
                    }
                ],
                "qualityStandards": [
                    {
                        "label": "Protein", "unit": "%", "limit": "min."
                    }
                ]
            },
            "gb": {
                "cropTypes": [
                    {
                        "label": "Rapeseed",
                        "qualityValues": [10]
                    }
                ],
                "qualityStandards": [
                    {
                        "label": "Protein", "unit": "%", "limit": "min."
                    }
                ]
            },
            "austria": {
                "cropTypes": [
                    {
                        "label": "Futterweizen",
                        "qualityValues": [14, -1, 72, -1, -1, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Mahlweizen I",
                        "qualityValues": [14, 11.5, 78, 220, -1, -1, 0, -1, -1, -1]
                    }, {
                        "label": "Mahlweizen II",
                        "qualityValues": [14, 12, 78, 220, -1, -1, 0, -1, -1, -1]
                    }, {
                        "label": "Mahlweizen III",
                        "qualityValues": [14, 12.5, 78, 220, -1, -1, 0, -1, -1, -1]
                    }, {
                        "label": "Qualitätsweizen",
                        "qualityValues": [14, 14, 80, 250, -1, -1, 0, -1, -1, -1]
                    }, {
                        "label": "Premiumweizen",
                        "qualityValues": [14, 15, 80, 280, -1, -1, 0, -1, -1, -1]
                    }, {
                        "label": "Hartweizen",
                        "qualityValues": [14, -1, 80, -1, 80, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Roggen",
                        "qualityValues": [14, -1, 71, -1, -1, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Triticale",
                        "qualityValues": [14, -1, 70, -1, -1, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Raps",
                        "qualityValues": [8.5, -1, -1, -1, -1, 40, -1, -1, -1, -1]
                    }, {
                        "label": "Futtergerste",
                        "qualityValues": [14, -1, 62, -1, -1, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Mais",
                        "qualityValues": [14, -1, -1, -1, -1, -1, -1, 5, 0, 0]
                    }, {
                        "label": "Nassmais",
                        "qualityValues": []
                    }, {
                        "label": "Sojabohne Klasse I Speisesojabohne",
                        "qualityValues": [13, -1, -1, -1, -1, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Durumweizen",
                        "qualityValues": [14.5, 13.5, 80, 280, 80, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Dinkelweizen",
                        "qualityValues": [14.5, -1, -1, 220, -1, -1, -1, -1, -1, -1, 2]
                    }, {
                        label: 'Gelbhirse',
                        qualityStandards: [
                            { label: 'Feuchtigkeit', unit: '%', limit: 'Max', value: 13.0 },
                            { label: 'Fremdbesatz', unit: '%', limit: 'Max', value: 0.1 },
                            { label: 'Schwarzbesatz', unit: '%', limit: 'Max', value: 0.2 },
                            { label: 'Weißbesatz', unit: '%', limit: 'Max', value: 0.1 },
                            { label: 'Stechapfelsamen', unit: ' Stück/kg', limit: 'Max', value: 3 },
                            { label: 'Ambrosiasamen', unit: '%', limit: 'Max', value: 0.02 },
                            { label: 'Farbe', type: 'text', unit: '', limit: '', value: 'Gleichmäßig' },
                            { label: 'Deoxynivalenol (DON)', unit: 'ppb', limit: 'Max', value: 1250 },
                            { label: 'Zearalenon (ZEA)', unit: 'ppb', limit: 'Max', value: 100 },
                            { label: 'Aflatoxine', unit: 'µg/kg', limit: 'Max', value: 2 },
                        ],
                    }, {
                        label: 'Sonnenblume',
                        qualityStandards: [
                            { label: 'Feuchtigkeit', unit: '%', limit: 'Max', value: 8.0 },
                            { label: 'Besatz', unit: '%', limit: 'Max', value: 2.0 },
                            { label: 'FFA', unit: '%', limit: 'Max', value: 2.0 },
                        ]
                    }, {
                        label: 'Sommerbraugerste',
                        qualityStandards: []
                    },
                    {
                        label: 'Futterhafer',
                        qualityStandards: [
                            { label: 'Feuchte', unit: '%', limit: 'Max', value: 14 },
                            { label: 'Hektolitergewicht', unit: 'Kg/Hl', limit: 'Min', value: 50 },
                        ]
                    },
                    {
                        label: 'Gestreifte Sonnenblumen für Vogelfutter',
                        qualityStandards: [
                            { label: 'Wassergehalt', unit: '%', limit: 'Max', value: 8 },
                            { label: 'Besatz', unit: '%', limit: 'Max', value: 2 },
                            
                            { label: 'Reinheit', unit: '%', limit: 'Min', value: 98.5 },
                            { label: 'Schwarze Sonnenblumenkerne', unit: '%', limit: 'Max', value: 5 },
                            { label: 'Stossung', unit: '%', limit: 'Min', value: 5 },

                            
                            { label: 'Ambrosia', unit: 'mg/kg', limit: 'Max', value: 50 },
                        ]
                    }, {
                        label: 'Gelbsenf',
                        qualityStandards: []
                    }, {
                        label: 'Gelbsenf Bio',
                        qualityStandards: []
                    }, {
                        label: 'Braunsenf',
                        qualityStandards: []
                    }, 
                    {
                        label: "Winterbraugerste KWS Donau",
                        qualityStandards: [
                            {
                                label: "Feuchte",
                                unit: "%",
                                limit: "",
                                value: 14
                            },
                            {
                                label: "Protein",
                                unit: "%",
                                limit: "mind.",
                                value: 9.5
                            },
                            {
                                label: "Protein",
                                unit: "%",
                                limit: "max.",
                                value: 11.5
                            },
                            {
                                label: "Siebung Vollkornanteil",
                                unit: "%",
                                limit: "",
                                value: 90
                            },
                            {
                                label: "DON",
                                unit: "ppb",
                                limit: "max.",
                                value: 1250
                            },
                            {
                                label: "Keimfähigkeit",
                                unit: "%",
                                limit: "mind.",
                                value: 95
                            },
                        ]
                    },
                    {
                        label: 'HIGH OLEIC Sonnenblume',
                        qualityStandards: [
                            {
                                label: "Feuchte",
                                unit: "%",
                                limit: "Max",
                                value: 8
                            },
                            {
                                label: "FFA",
                                unit: "%",
                                limit: "Max",
                                value: 2
                            },
                            {
                                label: "Ölsäure",
                                unit: "%",
                                limit: "Min",
                                value: 2
                            },
                        ]
                    }, 
                ],
                "qualityStandards": [
                    { "label": "Feuchte", "unit": "%", "limit": "" },
                    { "label": "Protein", "unit": "%", "limit": "min." },
                    { "label": "Hektolitergewicht", "unit": "kg/hl", "limit": "min." },
                    { "label": "Fallzahl", "unit": "sec.", "limit": "min." },
                    { "label": "Glasigkeit", "unit": "%", "limit": "" },
                    { "label": "Ölgehalt", "unit": "%", "limit": "" },
                    { "label": "Kleber", "unit": "%", "limit": "min." },
                    { "label": "Bruchkorn", "unit": "%", "limit": "" },
                    { "label": "DON", "unit": "%", "limit": "max." },
                    { "label": "ZEA", "unit": "ppb", "limit": "max." },
                    { "label": "Besatz", "unit": "%", "limit": "max." }
                ]
            },
            "hu": {
                "cropTypes": [
                    {
                        "label": "Futterweizen",
                        "qualityValues": [14, -1, 72, -1, -1, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Mahlweizen I",
                        "qualityValues": [14, 11.5, 78, 220, -1, -1, 0, -1, -1, -1]
                    }, {
                        "label": "Mahlweizen II",
                        "qualityValues": [14, 12, 78, 220, -1, -1, 0, -1, -1, -1]
                    }, {
                        "label": "Mahlweizen III",
                        "qualityValues": [14, 12.5, 78, 220, -1, -1, 0, -1, -1, -1]
                    }, {
                        "label": "Qualitätsweizen",
                        "qualityValues": [14, 14, 80, 250, -1, -1, 0, -1, -1, -1]
                    }, {
                        "label": "Premiumweizen",
                        "qualityValues": [14, 15, 80, 280, -1, -1, 0, -1, -1, -1]
                    }, {
                        "label": "Hartweizen",
                        "qualityValues": [14, -1, 80, -1, 80, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Roggen",
                        "qualityValues": [14, -1, 71, -1, -1, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Triticale",
                        "qualityValues": [14, -1, 70, -1, -1, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Raps",
                        "qualityValues": [8.5, -1, -1, -1, -1, 40, -1, -1, -1, -1]
                    }, {
                        "label": "Futtergerste",
                        "qualityValues": [14, -1, 62, -1, -1, -1, -1, -1, -1, -1]
                    }, {
                        "label": "Mais",
                        "qualityValues": [14, -1, -1, -1, -1, -1, -1, 5, 0, 0]
                    }
                ],
                "qualityStandards": [
                    { "label": "Feuchte", "unit": "%", "limit": "" },
                    { "label": "Protein", "unit": "%", "limit": "min." },
                    { "label": "Hektolitergewicht", "unit": "kg/hl", "limit": "min." },
                    { "label": "Fallzahl", "unit": "sec.", "limit": "min." },
                    { "label": "Glasigkeit", "unit": "%", "limit": "" },
                    { "label": "Ölgehalt", "unit": "%", "limit": "" },
                    { "label": "Kleber", "unit": "%", "limit": "min." },
                    { "label": "Bruchkorn", "unit": "%", "limit": "" },
                    { "label": "DON", "unit": "%", "limit": "max." },
                    { "label": "ZEA", "unit": "ppb", "limit": "max." }
                ]
            },
            nz: {
                cropTypes: [
                    {
                        label: 'Wheat CSG 110 APH1',
                        qualityStandards: [
                            { label: 'Protein', unit: '%', limit: 'Min',                value: 14.0 },
                            { label: 'Protein', unit: '%', limit: 'Max',                value: null },
                            { label: 'Moisture', unit: '%', limit: 'Max',               value: 12.5 },
                            { label: 'Test Weight', unit: 'Kg/hl', limit: 'Min',        value: 76.5 },
                            { label: 'Unmillable material', unit: '%', limit: 'Max',    value: 0.6 },
                            { label: 'Screenings', unit: '%', limit: 'Max',             value: 5.0 },
                            { label: 'Falling number', unit: 'sec', limit: 'Min',       value: 350 },
                        ],
                    },
                    {
                        label: 'Wheat CSG 100 APH2',
                        qualityStandards: [
                            { label: 'Protein', unit: '%', limit: 'Min',                value: 13.0 },
                            { label: 'Protein', unit: '%', limit: 'Max',                value: null },
                            { label: 'Moisture', unit: '%', limit: 'Max',               value: 12.5 },
                            { label: 'Test Weight', unit: 'Kg/hl', limit: 'Min',        value: 76.5 },
                            { label: 'Unmillable material', unit: '%', limit: 'Max',    value: 0.6 },
                            { label: 'Screenings', unit: '%', limit: 'Max',             value: 5.0 },
                            { label: 'Falling number', unit: 'sec', limit: 'Min',       value: 350 },
                        ],
                    },
                    {
                        label: 'Wheat CSG 101 H1',
                        qualityStandards: [
                            { label: 'Protein', unit: '%', limit: 'Min',                value: 13.0 },
                            { label: 'Protein', unit: '%', limit: 'Max',                value: null },
                            { label: 'Moisture', unit: '%', limit: 'Max',               value: 12.5 },
                            { label: 'Test Weight', unit: 'Kg/hl', limit: 'Min',        value: 76.5 },
                            { label: 'Unmillable material', unit: '%', limit: 'Max',    value: 0.6 },
                            { label: 'Screenings', unit: '%', limit: 'Max',             value: 5.0 },
                            { label: 'Falling number', unit: 'sec', limit: 'Min',       value: 300 },
                        ],
                    },
                    {
                        label: 'Wheat CSG 102 H2',
                        qualityStandards: [
                            { label: 'Protein', unit: '%', limit: 'Min',                value: 11.5 },
                            { label: 'Protein', unit: '%', limit: 'Max',                value: null },
                            { label: 'Moisture', unit: '%', limit: 'Max',               value: 12.5 },
                            { label: 'Test Weight', unit: 'Kg/hl', limit: 'Min',        value: 76.5 },
                            { label: 'Unmillable material', unit: '%', limit: 'Max',    value: 0.6 },
                            { label: 'Screenings', unit: '%', limit: 'Max',             value: 5.0 },
                            { label: 'Falling number', unit: 'sec', limit: 'Min',       value: 300 },
                        ],
                    },
                    {
                        label: 'Barley CSG 20 Malt 1',
                        qualityStandards: [
                            { label: 'Variatal purity', unit: '%', limit: 'Min',        value: 95 },
                            { label: 'Moisture', unit: '%', limit: 'Max',               value: 12.5 },
                            { label: 'Protein', unit: '%', limit: 'Min',                value: 9.0 },
                            { label: 'Protein', unit: '%', limit: 'Max',                value: 12.0 },
                            { label: 'Test Weight', unit: 'Kg/hl', limit: 'Min',        value: 65.0 },
                            { label: 'Retention', unit: '%', limit: 'Min',              value: 70.0 },
                            { label: 'Screenings', unit: '%', limit: 'Max',             value: 7.0 },
                            { label: 'Germinative energy', unit: '%', limit: 'Min',     value: 95 },
                            { label: 'Germinative energy', unit: '%', limit: 'Max',     value: 98 },
                            { label: 'Rapid visco anialyser', unit: 'unit', limit: 'Min', value: 130 },                            
                            { label: 'Falling number', unit: 'sec', limit: 'Min',       value: 300 },
                        ],
                    },
                    {
                        label: 'Barley CSG 21 Malt 2',
                        qualityStandards: [
                            { label: 'Variatal purity', unit: '%', limit: 'Min',        value: 95 },
                            { label: 'Moisture', unit: '%', limit: 'Max',               value: 12.5 },
                            { label: 'Protein', unit: '%', limit: 'Min',                value: 9.0 },
                            { label: 'Protein', unit: '%', limit: 'Max',                value: 12.0 },
                            { label: 'Test Weight', unit: 'Kg/hl', limit: 'Min',        value: 65.0 },
                            { label: 'Retention', unit: '%', limit: 'Min',              value: 62.0 },
                            { label: 'Screenings', unit: '%', limit: 'Max',             value: 10.0 },
                            { label: 'Germinative energy', unit: '%', limit: 'Min',     value: 95 },
                            { label: 'Germinative energy', unit: '%', limit: 'Max',     value: 98 },
                            { label: 'Rapid visco anialyser', unit: 'unit', limit: 'Min', value: 130 },                            
                            { label: 'Falling number', unit: 'sec', limit: 'Min',       value: 300 },
                        ],
                    },
                    {
                        label: 'Barley CSG 22 Malt 3',
                        qualityStandards: [
                            { label: 'Variatal purity', unit: '%', limit: 'Min',        value: 95 },
                            { label: 'Moisture', unit: '%', limit: 'Max',               value: 12.5 },
                            { label: 'Protein', unit: '%', limit: 'Min',                value: 9.0 },
                            { label: 'Protein', unit: '%', limit: 'Max',                value: 12.8 },
                            { label: 'Test Weight', unit: 'Kg/hl', limit: 'Min',        value: 65.0 },
                            { label: 'Retention', unit: '%', limit: 'Min',              value: 58.0 },
                            { label: 'Screenings', unit: '%', limit: 'Max',             value: null },
                            { label: 'Germinative energy', unit: '%', limit: 'Min',     value: 95 },
                            { label: 'Germinative energy', unit: '%', limit: 'Max',     value: 98 },
                            { label: 'Rapid visco anialyser', unit: 'unit', limit: 'Min', value: 130 },                            
                            { label: 'Falling number', unit: 'sec', limit: 'Min',       value: 300 },
                        ],
                    },
                    {
                        label: 'Maize CSG 41 Prime Maize',
                        qualityStandards: [
                            { label: 'Moisture', unit: '%', limit: 'Max',               value: 14.0 },
                            { label: 'Test Weight', unit: 'Kg/hl', limit: 'Min',        value: 72.0 },
                            { label: 'Total admixture', unit: '%', limit: 'Max',        value: 5.0 },
                            { label: 'Foreign material', unit: '%', limit: 'Max',       value: 3.0 },
                            { label: 'Screenings', unit: '%', limit: 'Max',             value: 2.0 },
                            { label: 'Trash', unit: '%', limit: 'Max',                  value: 2.0 },
                        ],
                    },
                    {
                        label: 'Maize CSG 41 Feed No.1 Maize',
                        qualityStandards: [
                            { label: 'Moisture', unit: '%', limit: 'Max',               value: 14.0 },
                            { label: 'Test Weight', unit: 'Kg/hl', limit: 'Min',        value: 70.0 },
                            { label: 'Total admixture', unit: '%', limit: 'Max',        value: 8.0 },
                            { label: 'Foreign material', unit: '%', limit: 'Max',       value: 5.0 },
                            { label: 'Screenings', unit: '%', limit: 'Max',             value: 5.0 },
                            { label: 'Trash', unit: '%', limit: 'Max',                  value: 4.0 },
                        ],
                    },
                    {
                        label: 'Maize CSG 41 Feed No.1 Maize',
                        qualityStandards: [
                            { label: 'Moisture', unit: '%', limit: 'Max',               value: 14.0 },
                            { label: 'Test Weight', unit: 'Kg/hl', limit: 'Min',        value: 67.0 },
                            { label: 'Total admixture', unit: '%', limit: 'Max',        value: 8.0 },
                            { label: 'Foreign material', unit: '%', limit: 'Max',       value: 5.0 },
                            { label: 'Screenings', unit: '%', limit: 'Max',             value: 5.0 },
                            { label: 'Trash', unit: '%', limit: 'Max',                  value: 4.0 },
                        ],
                    },
                ]
            }
        };

        this.initCrops();
    }

    CropService.$inject = ['Utils'];
})();

/**
 * Created by Hafeez Rehman on 06/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.crop')
            .config(cropConfig);

    function cropConfig($stateProvider){
        $stateProvider
            .state('app.crop', {
                url: '/crop',
                template: '<div ui-view></div>',
                abstract: true
            })
            .state('app.crop.proc', {
                url: '/:id',
                component: 'cropProcurement'
            })
    }
})();

/**
 * Created by Hafeez Rehman on 06/11/2017.
 */

(function() {
    'use strict';

    angular.module('app.crop').component('cropProcurement', {
        controller: CropProcController,
        controllerAs: 'vm',
        templateUrl: 'app/modules/crop/crop.procurement.html',
    });

    /** @ngInject */
    function CropProcController($scope, $rootScope, $state, $stateParams, $uibModal, $templateCache, $log, $timeout,
        HttpService, CropService, AlertService, MapFactory, gettextCatalog, Utils, DealsService, ProductsService,
        DEAL_STATUS, DEAL_TARGET, DEAL_CONSTANTS) {

        var vm = this;
        vm.utils = Utils;
        vm.dealsService = DealsService;

        vm.DEAL_STATUS = DEAL_STATUS;
        vm.DEAL_TARGET = DEAL_TARGET;

        vm.quantityEnabled = false;
        vm.incoterms = ['EXW', 'FCA', 'CPT', 'CIP', 'DAT', 'DAP', 'DDP', 'FAS', 'FOB', 'CFR', 'CIF'];

        $rootScope.place = {};
        $rootScope.showPlaceDetails = function(param) {
            vm.place = param;
        };

        vm.lookup = {};
        vm.lookup.categories = [];
        vm.lookup.distMethods = [
            { label: '---', value: undefined },
            { label: gettextCatalog.getString('Collection'), value: 'collection' },
            { label: gettextCatalog.getString('Delivery'), value: 'delivery' }
        ];

        vm.lookup.cropTypes = [
            { value: '', label: '' }
        ];

        vm.lookup.distMethodsMap = Utils.valueToLabelMap(vm.lookup.distMethods);
        vm.lookup.farmTypes = DealsService.getFarmTypes();
        vm.lookup.system = DealsService.getSystems();
        vm.lookup.units = DealsService.getProductUnits();
        vm.farmTypes = [];

        vm.model = {
            categoryName: 'CROP',
            bookingStart: new Date(),
            bookingEnd: new Date(),
            supplier: $rootScope.app.Auth.User ? $rootScope.app.Auth.User.supplier : {},
            product: null,
            location: { coordinates: [], type: 'Point' },
            customUnit: gettextCatalog.getString('Tonne'),
            benchmarkPrice: null,
            dealSize: null,
            individualDiscount: null,
            deliveryEnd: new Date(),
            distribution: null
        };

        vm.modelChangedAfterSave = false;
        vm.readyToPublish = false;

        $scope.$watch("vm.model", function() {
          vm.modelChangedAfterSave = true;
        }, true);
        $scope.$watch('vm.model.bookingStart', function () {
            vm.modelChangedAfterSave = true;
        }, true);
        $scope.$watch('vm.model.bookingEnd', function () {
            vm.modelChangedAfterSave = true;
        }, true);
        $scope.$watch("vm.product", function() {
          vm.modelChangedAfterSave = true;
        }, true);
        $scope.$watch("vm.farmTypes", function() {
          vm.modelChangedAfterSave = true;
        }, true);
        $scope.$watch("vm.model.distribution", function () {
            vm.modelChangedAfterSave = true;
        }, true);

        vm.setImage = function () {
            $uibModal.open({
                animation: true,
                component: 'uploadImage',
                windowClass: 'modal-window',
                size: 'lg',
                resolve: {}
            }).result.then(function (imgUrl) {
                vm.model.imageUrl = imgUrl;
            });
        };

        vm.confirmPublish = function () {
            // Modal close delay
            $timeout(function () {
                vm.model.status = DEAL_STATUS.ACTIVE;
                DealsService.saveDeal(vm.model, vm.product, vm.farmTypes, vm.map).then(function () {
                    vm.modelChangedAfterSave = false;
                    $state.go('app.deals.list', { type: 'ACTIVE', dealId: vm.model._id });
                });
            }, 200);
        };

        vm.safeDraft = function() {
          DealsService.saveDeal(vm.model, vm.product, vm.farmTypes, vm.map).then(function() {
            vm.modelChangedAfterSave = false;
          });
        };

        vm.submit = function () {
            var validators = {
                booking: validateBookingDates(),
                distribution: validateDeliveryDates()
            };

            if (!validators.booking || !validators.distribution) {
                return false;
            }

            vm.dealForm.$submitted = true;
            if (vm.dealForm.$invalid) {
                return false;
            }

            if (DealsService.isDraft(vm.model)) {
                DealsService.saveDeal(vm.model, vm.product, vm.farmTypes, vm.map).then(function () {
                    vm.modelChangedAfterSave = false;
                });
            }

            var dialog = $uibModal.open({
                animation: true,
                controller: 'DealConfirmCtrl',
                templateUrl: 'app/shared/templates/modals/deal-confirm.tpl.html',
                template: Utils.getTemplate('app/shared/templates/modals/deal-confirm.tpl.html'),
                size: 'lg',
                windowClass: 'modal-window',
                resolve: {
                    items: function() {
                        return  { 
                            model: vm.model, 
                        };
                    }
                }
            });
            
            dialog.result.then(function() {
                vm.confirmPublish();
            });
        };

        vm.productDoesNotExist = function () {
            return !vm.model.product;
        };

        function validateBookingDates() {
            if (vm.model.bookingStart.isBefore(vm.model.bookingEnd)) {
                vm.dealLengthError = false;
                return true;
            }
            vm.dealLengthError = true;
            return false;
        }

        function validateDeliveryDates() {
            var isValid = vm.model.deliveryStart.startOf('day').isBefore(vm.model.deliveryEnd.endOf('day'));
            vm.dealForm.deliveryStart.$setValidity("distEndBeforeStart", isValid);
            vm.dealForm.deliveryEnd.$setValidity("distEndBeforeStart", isValid);

            isValid = vm.model.bookingEnd.isBefore(vm.model.deliveryEnd.endOf('day'));
            vm.dealForm.deliveryEnd.$setValidity("distEndBeforeStart", isValid);
            return isValid;
        }

        vm.deleteDeal = function() {
          var confirm = Utils.CreateConfirmation(gettextCatalog.getString('Discard unsaved changes?'));
          confirm.result.then(function() {
            HttpService.Delete('deals/' + vm.model._id).then(function() {
                $state.go('app.deals.list');
                AlertService.success(gettextCatalog.getString('Draft deleted'), gettextCatalog.getString('Deal draft deleted successfully'));
            }, function() {
                $log.error('Error occurred loading lists.');
            });
          });
        };

        vm.viewUsers = function() {
            var selectUsersDiaglog = $uibModal.open({
                animation: true,
                controller: 'DealUsersCtrl',
                templateUrl: 'app/shared/templates/modals/deal-users.tpl.html',
                template: Utils.getTemplate('app/shared/templates/modals/deal-users.tpl.html'),
                size: 'lg',
                windowClass: 'modal-window',
                resolve: {
                    items: function() {
                        return  { model: vm.model, users: vm.allUsersFound, farmTypes: vm.lookup.farmTypes };
                    }
                }
            });
            selectUsersDiaglog.result.then(function() {
                vm.updateMapCircle(vm.model.target);
                if (vm.model.target === DEAL_TARGET.NEW_USERS) {
                    vm.model.radius = 600;
                    vm.model.location.coordinates = DEAL_CONSTANTS.INTIAL_COORDINATES[$rootScope.app.Auth.User.supplier.area.toLowerCase()];
                    MapFactory.SetMapCenterToDealLocation(vm.map, vm.model);
                    // It should be just setupMarkers(...);
                    loadAffectedUsers();
                }
                else {
                    setupMarkers(vm.model.users);
                }
            });
        };

        vm.toggleUser = function(user) {
          user.isExcluded = !user.isExcluded;
        };

        vm.toggleQuantityLimit = function() {
            vm.quantityEnabled = !vm.quantityEnabled;
            if (vm.quantityEnabled) {
                vm.model.dealSize = '';
            } else {
                vm.model.dealSize = 99999999;
            }
        };

        vm.radiusFieldChanged = function() {
            MapFactory.SetMapZoomToDealRadius(vm.map, vm.model);
        };

        vm.getUserSelectedCount = function() {
          if (!vm.model || !vm.model.users) {
            return 0;
          }
          return vm.model.users.length;
        };

        // TODO: remove this function (formerly know as 'setTarget')
        vm.updateMapCircle = function(newTarget) {
            if (newTarget === newTarget !== DEAL_TARGET.ALL_USERS) {
                vm.map.circles[0].editable = vm.model.target !== DEAL_TARGET.NEW_USERS;
            }
        };

        vm.goBack = function() {
          if (!vm.modelChangedAfterSave) {
            $state.go('app.deals.list');
            return;
          }
          var confirm = Utils.CreateConfirmation(gettextCatalog.getString('Discard unsaved changes?'));
          confirm.result.then(function() {
            $state.go('app.deals.list');
          });
        };

        vm.switchVatIncluded = function () {
            DealsService.switchVatIncluded(vm.model).then(function () {
                vm.discountChange();
            });
        };

        vm.onCropSelect = function() {
            if (vm.cropName === undefined) {
              return;
            }
            var selectedCrop = vm.cropsList.filter(function (c) {
                return c.label === vm.cropName;
            });
            if (!selectedCrop.length) {
                return;
            }
            selectedCrop = selectedCrop[0];
            if (!selectedCrop.qualityStandards || !selectedCrop.qualityStandards.length) {
                vm.doesNotHaveQualityStandards = true;
                setupOrCreateProduct(selectedCrop);
                vm.model.cropQuality = '';
                DealsService.copyProductInfoToDeal(vm.model, selectedCrop);
                return;
            }
            vm.doesNotHaveQualityStandards = false;

            var cropDialog  = $uibModal.open({
                animation: true,
                controller: 'CropModalCtrl',
                templateUrl: 'app/shared/templates/modals/crop-config.tpl.html',
                size: 'lg',
                windowClass: 'modal-window',
                resolve: {
                    items: function() {
                        return  {
                            selectedCrop: selectedCrop,
                            standards: vm.qualityStandards
                        };
                    }
                }
            });

            cropDialog.result.then(function(resultProduct) {
                setupOrCreateProduct(resultProduct);
                vm.model.cropQuality = resultProduct.cropQuality;
                DealsService.copyProductInfoToDeal(vm.model, resultProduct);
            }, function () {
                vm.cropName = vm.model.product.name || null;
            });
        };

        vm.reloadUsers = function() {
            loadAffectedUsers();
        };
        
        vm.updateDesc = function() {
            var descModal = $uibModal.open({
                animation: true,
                controller: 'RichTextModalCtrl',
                templateUrl: 'app/shared/templates/modals/rich-text.tpl.html',
                template: Utils.getTemplate('app/shared/templates/modals/rich-text.tpl.html'),
                size: 'lg',
                windowClass: 'modal-window',
                resolve: {
                    items: function() {
                        return { title: gettextCatalog.getString('Offer description'), descText: angular.copy(vm.model.description) };
                    }
                }
            });
            descModal.result.then(function(text) {
                vm.model.description = text;
            });
        };
        
        vm.addAttachment = function () {
            vm.editAttachment();
        };
        vm.editAttachment = function (idx) {
            var newAttachment = idx === undefined;
            var descModal = $uibModal.open({
                animation: true,
                component: 'uploadAttachment',
                windowClass: 'modal-window',
                size: 'lg',
                resolve: {
                    attachment: newAttachment ? null : vm.model.attachments[idx]
                }
            });
            descModal.result.then(function (attachmentObj) {
                if (newAttachment) {
                    vm.model.attachments = vm.model.attachments || [];
                    vm.model.attachments.push(attachmentObj);
                    return;
                }
                vm.model.attachments[idx] = attachmentObj;
            });
        };
        vm.removeAttachment = function (idx) {
            Utils.CreateConfirmation(gettextCatalog.getString('Remove attachment') + ' "' + vm.model.attachments[idx].name + '"')
                .result.then(function () {
                    vm.model.attachments.splice(idx, 1);
                });
        };

        vm.manageDeliveryLocation = function() {
            var dialog = $uibModal.open({
                animation: true,
                controller: 'CollectionPointCtrl',
                templateUrl: 'app/shared/templates/modals/collection-points.tpl.html',
                template: Utils.getTemplate('app/shared/templates/modals/collection-points.tpl.html'),
                size: 'lg',
                windowClass: 'modal-window',
                resolve: {
                    items: function() {
                        return  {
                          collectionPoints: $rootScope.app.Auth.User.supplier.collectionPoints,
                          selectedCollectionPoints: vm.model.collectionPoints,
                          isCategoryCrop: true
                        };
                    }
                }
            });

            dialog.result.then(function(selectedCollectionPoints) {
                vm.model.collectionPoints = selectedCollectionPoints;
                vm.model.deliveryLocation = vm.model.collectionPoints.map(function(cp) {
                    return cp.name + ' (' + cp.address + ')';
                })
                .join(' \u2022 OR \u2022 ');
            });
        };

        vm.viewRequestDetails = function() {
            var requestId = vm.model.requests[0]._id;
            HttpService.Get('requests/' + requestId).then(function(data) {
                var request = data; 
                $uibModal.open({
                  animation: true,
                  controller: 'RequestDetailsCtrl',
                  templateUrl: 'app/shared/templates/modals/request-details.tpl.html',
                  template: Utils.getTemplate('app/shared/templates/modals/request-details.tpl.html'),
                  size: 'lg',
                  windowClass: 'modal-window',
                  resolve: {
                      items: function() {
                          return  {
                            request: request,
                            isCropRequest: true
                          };
                      }
                  }
                });
            });
        }
        
        vm.isReadOnly = function() {
            return !vm.model || vm.model.distributorDeal;
        }

        // ---------------- Initialization ----------------

        vm.$onInit = function() {
            init();
        };
  
        function init() {
            if (!$rootScope.app.Auth.User) {
                $timeout(init, 1000);
                return;
            }
            loadDeal($stateParams.id);
        }

        function initializeMap() {
            vm.map = MapFactory.GetDealMapConfig(function() { 
                var selectionCircle = vm.map.circles[0];
                vm.model.location.coordinates = [selectionCircle.center.longitude, selectionCircle.center.latitude ];
                vm.model.radius = Math.round(selectionCircle.radius/1000);
                MapFactory.SetMapCenterToDealLocation(vm.map, vm.model, true);
                loadAffectedUsers(); 
            });
            vm.searchbox = MapFactory.GetSearchboxConfig(function (autocomplete) {
                var place = autocomplete.getPlace();
                if (!place.address_components) {
                    return;
                }
                vm.model.location.coordinates = [ place.geometry.location.lng(), place.geometry.location.lat() ];
                MapFactory.SetMapCenterToDealLocation(vm.map, vm.model, vm.model.target === DEAL_TARGET.NEW_USERS);
            });
        }

        function setupMarkers(users){
            vm.map.markers = [];
            users.forEach(function(user, i) {
                var loc = user.locations[0].location.coordinates;
                var icon = user.isExcluded ? 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png' : 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png';

                var title = user.name.first + ' ' + user.name.last;
                if (user.isExcluded) {
                    title += '<br><b>' + gettextCatalog.getString('Excluded') + '</b>';
                }
                vm.map.markers.push({
                    id: user._id,
                    icon: icon,
                    latitude:  loc[1],
                    longitude: loc[0],
                    options: {
                        label: '' + (i + 1),
                        user: user,
                        title: title
                    }
                });
            });
            vm.markerEevents = {
                mouseover: function (marker, eventName, m) {
                    var content = '<div class="text-center">'+ m.options.title +'</div>';
                    var infoWindow = new google.maps.InfoWindow({ content: content }); // eslint-disable-line no-undef
                    infoWindow.open(vm.map, marker);

                    marker.addListener('mouseout', function() {
                        infoWindow.close();
                    });
                }
            };
        }

        function loadDeal(id) {
            DealsService.loadDeal(id).then(function (result) {
                vm.model = result.model;
                vm.cropsList = CropService.getCropTypes(vm.model.supplier);
                vm.qualityStandards = CropService.getQualityStandards(vm.model.supplier);
                
                vm.farmTypes = result.farmTypes;
                vm.deliveryStart = result.deliveryStart;
                vm.deliveryEnd = result.deliveryEnd;

                vm.cropName = vm.model.product.name;
                vm.quantityEnabled = vm.model.dealSize < 999999;

                vm.isCropNameInCropList = !!Utils.altFind(vm.cropsList,  function (item) { 
                    return item.label === vm.cropName;
                });

                if (!vm.model.customUnit) {
                    vm.model.customUnit = gettextCatalog.getString('Tonne');
                }
                
                // TODO move this deal deamap
                if (!Utils.isSupplierDistributor()) {
                    initializeMap();
                    MapFactory.SetMapCenterToDealLocation(vm.map, vm.model);
                    vm.updateMapCircle(vm.model.target);
                    loadAffectedUsers(result.existingDealUsers);
                }
                
                vm.modelChangedAfterSave = false;
                vm.isQuantityOptionsEnabled = vm.model.dealSizeOptions.min > 0 || vm.model.dealSizeOptions.step > 0 || vm.model.dealSizeOptions.max;
                
                if (Utils.isUserRegionalManager()) {
                    HttpService.Get('users?role=COMMERCIAL%20PARTNER&supplier=' + $rootScope.app.Auth.User.supplier._id).then(function(res) {
                        vm.createdByUserList = res.list;
                    });
                }
                
                vm.allowPriceFreeText = !Utils.isNumber(vm.model.benchmarkPrice);

                vm.initialized = true;
            });
        }

        function loadAffectedUsers() {
            DealsService.fetchAffectedUsers(vm.model).then(function(users) {
                vm.allUsersFound = users;
                setupMarkers(vm.model.users);
            });
        }


        // TODO: make this function more specific
        function setupOrCreateProduct(product) {
            product.name = product.name || product.label;
            ProductsService.getProductByName(product.name).then(function (existingProducts) {
                if (existingProducts && existingProducts.length) {
                    vm.model.product = existingProducts[0];
                    return;
                }
                var data = {
                    name: product.name,
                    vendorProductId: product.vendorProductId,
                    categoryName: vm.model.categoryName
                };
                HttpService.Post('suppliers/' + vm.model.supplier._id + '/products', data).then(function (res) {
                    vm.model.product = res.data;
                }, function (err) {
                    $log.error(err);
                });
            });             
        }
    }
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('app.auth')
            .config(authConfig);

    function authConfig($stateProvider, $httpProvider) {

        $httpProvider.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';

        function decodeToken(jwtHelper, token) {
            if (!token) {
                return null;
            }
            try {
                if (jwtHelper.isTokenExpired(token)) {
                    return null;
                }
                return jwtHelper.decodeToken(token);
            }
            catch (error) {
                console.error('authConfig: Error while decoding token.'); // eslint-disable-line no-console
                return null;
            }
        }

        $stateProvider
            .state('login',{
                url: '/login',
                component: 'authForm',
                skipAuthorization: true
            })
            .state('invitation',{
                url: '/register?token',
                component: 'registerInvite',
                skipAuthorization: true,
                resolve: {
                    'invitation': function($stateParams, jwtHelper, HttpService) {
                        var decodedToken = decodeToken(jwtHelper, $stateParams.token);
                        if (!decodedToken) {
                            return { expired: true };
                        }
                        return HttpService.Get('invites/' + jwtHelper.decodeToken($stateParams.token).id)
                            .then(function(data) {
                                return data.invite;
                            })
                            .catch(function() {
                                return { expired: true };
                            });
                    }
                }
            })
            .state('password',{
                url: '/password/reset?token',
                component: 'passwordReset',
                skipAuthorization: true,
                resolve: {
                    'user': function($stateParams, jwtHelper, $state) {
                        var decodedToken = decodeToken(jwtHelper, $stateParams.token);
                        if (!decodedToken) {
                            $state.go('login');
                        }
                    }
                }
            });
    }
})();
/**
 * Created by Hafeez Rehman on 10/11/2017.
 */

(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('AuthFactory', AuthFactory);

    function AuthFactory(
        $rootScope,
        $state,
        $stateParams,
        $q,
        $http,
        $log,
        $timeout,
        $localStorage,
        $location,
        $analytics,
        API_CONFIG,
        HttpService,
        ProductsService,
        Utils,
        jwtHelper,
        postLoginRedirect,
        gettextCatalog,
        tmhDynamicLocale,
        CONSTANTS) {

        var ONE_MININUTE_IN_MS = 60000;
        var ROLE_COMMERCIAL_PARTNER = 'COMMERCIAL PARTNER';
        var _self = this;
        _self.token = null;
        _self.role = ROLE_COMMERCIAL_PARTNER;
        _self.user = null;

        var auth = {};

        auth.setupTokenAndGoToDashboard = setupTokenAndGoToDashboard;
        auth.initUser = initUser;
        auth.setupLocale = setupLocale;

        auth.login = function (params) {

            var deferred = $q.defer();

            if (!params.email || !params.password) {
                deferred.reject(new Error(gettextCatalog.getString('Missing required email or password')));
                return deferred.promise;
            }

            $http.post(API_CONFIG.apiPrefix + 'login?role=' + ROLE_COMMERCIAL_PARTNER, params)
                .then(function (res) {
                    var loginResult = setupTokenAndGoToDashboard(res.data.apiKey, res.data.role);
                    if (!loginResult) {
                        deferred.reject(new Error(gettextCatalog.getString('User not authorized')));
                        return deferred.promise;
                    }
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        auth.logout = function () {
            HttpService.Get('logout');
            $timeout(function() {
                delete $localStorage.api_key;
                $state.go('login');
            }, 200);
        };

        auth.checkAuth = function () {
            if ($localStorage.api_key === undefined) return false;
            return !jwtHelper.isTokenExpired($localStorage.api_key);
        };

        auth.getCurrentUser = function () {
            if (!$localStorage.api_key || jwtHelper.isTokenExpired($localStorage.api_key)) {
                $state.go('login');
                return false;
            }
            return jwtHelper.decodeToken($localStorage.api_key).id;
        };

        auth.getProfile = function () {
            if (jwtHelper.isTokenExpired($localStorage.api_key)) return false;
            return auth.Profile;
        };

        auth.getToken = function () {
            return $localStorage.api_key;
        };

        auth.unsetToken = function () {
            delete $localStorage.api_key;
            return true;
        };

        auth.getTokenExpiry = function () {
            return jwtHelper.getTokenExpirationDate($localStorage.api_key);
        };

        auth.isExpired = function () {
            if ($localStorage.api_key === undefined) {
                return false;
            }

            return jwtHelper.isTokenExpired($localStorage.api_key);
        };

        auth.requestPassReset = function (body) {
            return HttpService.Post('users/forgotpassword', body);
        };

        auth.resetPassword = function (token, body) {
            return HttpService.Post('users/resetpassword?apiKey=' + token, body);
        };

        auth.saveRedirectUrl = function () {
            if ($location.path().toLowerCase() != '/login' && $location.path().toLowerCase().indexOf('password/reset') < 0) {
                postLoginRedirect.url = window.location.href;
            } else {
                postLoginRedirect.url = '/';
            }
        };

        auth.redirectToPrevUrl = function () {
            $log.log('Found previous URL:', postLoginRedirect.url);
            if (!postLoginRedirect.url || postLoginRedirect.url === '/' || postLoginRedirect.url.indexOf('register') > 0) {
                $log.log('Redirect to dashboard.');
                $state.go('app.dashboard');
            } else {
                $log.log('Redirect to previous URL.');
                window.location = postLoginRedirect.url;
            }
        };

        return auth;

        function setupTokenAndGoToDashboard(token, role) {
            if (role !== ROLE_COMMERCIAL_PARTNER) {
                return false;
            }

            $localStorage.api_key = token;
            auth.token = token;
            auth.role = role;
            // initUser will be called in the verification process in app.routes.
            auth.redirectToPrevUrl();
        }

        function initUser() {
            $log.log('Initializing user..');
            var deferred = $q.defer();

            if (!$localStorage.api_key || $localStorage.api_key === undefined || jwtHelper.isTokenExpired($localStorage.api_key)) {
                delete $localStorage.api_key;
                deferred.reject();
                return deferred.promise;
            }

            $rootScope.app.Stats = { requests: 0, offers: 0 };
            setupLocale(); // Setup user locale to app language while loading user profile

            HttpService.Get('me').then(function (data) {
                _self.user = data.user;

                $rootScope.app.Auth.User = data;
                $rootScope.app.Auth.User.fullName = data.name.first + ' ' + data.name.last;

                $log.log('User permissions:', $rootScope.app.Auth.User.permissions);

                setupLocale(data.locale);

                $analytics.setUsername(data.email);
                $log.log('User found. Setting up suppliers data.');

                getStats();
                deferred.resolve(data.user);

                // TODO: TMP: remove this call and replace all $rootScope.app.Auth.User.products use cases.
                ProductsService.getFilteredProducts('', 1).then(function(products) {
                    $rootScope.app.Auth.User.products = products;
                });                
                
                if (!Utils.isUserRegionalManager()) {
                    return [];
                }
                return HttpService.Get('suppliers/managed');
            }, function (err) {
                deferred.reject(err);
            }).then(function (res) {
                res.forEach(function(s) {
                    s.label = s.name;
                    if (s.isDistributor) {
                        s.label = '[D] ' + s.label;
                    }
                    if (s.isTest) {
                        s.label = '[T] ' + s.label;
                    }
                })
                $rootScope.app.Auth.User.suppliersManaged = res;
            });

            return deferred.promise;
        }

        function setLocale(locale) {
            locale = locale || CONSTANTS.LOCALES[0].code;
            gettextCatalog.setCurrentLanguage(locale.replace('-', '_'));
            var thmLocale = locale.toLowerCase().replace('_', '-');
            tmhDynamicLocale.set(thmLocale);
            $log.log('Auth: Set gettext locale: ' + locale + ' (tmhDynamicLocale: ' + tmhDynamicLocale.get() + ')');
        }

        function setupLocale(userLocale) {
            if (userLocale) {
                $log.log('Auth: User locale:', userLocale);
                setLocale(userLocale);
                return;
            }
            $log.log('Auth: User locale not found. Using system locale');
            var systemLocale = window.navigator.language || window.navigator.userLanguage;
            $log.log('Auth: App locale: ', systemLocale);

            var localeFound = Utils.altFind(CONSTANTS.LOCALES, function (locale) {
                return systemLocale.startsWith(locale.code);
            });
            if (localeFound) {
                $log.log('Found locale: ', localeFound.label + ' (' + localeFound.code + ')');
                setLocale(localeFound.code);
                return;
            }

            localeFound = CONSTANTS.LOCALES[0];
            $log.log('Using default locale locale: ', localeFound.label + ' (' + localeFound.code + ')');
            setLocale(localeFound.code); 
        }

        function getStats() {
            $log.log('Auth module: Fetching stats');
            HttpService.Get('me/statistics').then(function (data) {
                $rootScope.app.Stats = data;
                if (auth.checkAuth()) $timeout(getStats, ONE_MININUTE_IN_MS);
            });
        }
    }
})();

(function(){
    'use strict';

    angular.module('app.deals').controller('RequestDetailsCtrl', RequestDetailsCtrl);

    RequestDetailsCtrl.$inject = ['$scope', '$rootScope', '$uibModalInstance', '$state', '$timeout', '$ngConfirm', '$log', '$uibModal',
        'items', 'Utils', 'HttpService', 'gettextCatalog', 'AlertService', 'DealsService', 'ProductsService', 'RequestsService', 
        'DEAL_CATEGORY', 'CONSTANTS', 'DEAL_TARGET', 'DEAL_STATUS'];

    function RequestDetailsCtrl($scope, $rootScope, $uibModalInstance, $state, $timeout, $ngConfirm, $log, $uibModal,
        items, Utils, HttpService, gettextCatalog, AlertService, DealsService, ProductsService, RequestsService,
        DEAL_CATEGORY, CONSTANTS, DEAL_TARGET, DEAL_STATUS) {

        var ctrl = this;

        $scope.REQUEST_STATUS = CONSTANTS.REQUEST_STATUS;

        $scope.request = items.request;
        $scope.utils = Utils;
        
        function initSmsAndEmailSubjectAndBody() {
            var presentation = gettextCatalog.getString('Hi') + ' ' +
                $scope.request.createdBy.name.first + ', ' +
                gettextCatalog.getString('I am') + ' ' +
                $rootScope.app.Auth.User.name.first + ' ' +
                gettextCatalog.getString('from') + ' ' + 
                $rootScope.app.Auth.User.supplier.name;
                
            $scope.messageText =  presentation + '. ' +
                gettextCatalog.getString('About your FarmHedge request') + ' "' + 
                $scope.request.content.slice(0, 2).join(' - ') + '": ';

            $scope.mailSubject = gettextCatalog.getString('Question about your FarmHedge request') + ' "' +
                $scope.request.content.slice(0, 2).join(' - ') + '"';
            $scope.mailBody = presentation + '\n';
        }

        function initDistributorDeal() {
            if (!$scope.request.product) {
                $scope.distributorDeal = null;
                return;
            }

            ProductsService.getProductDeal($scope.request.product, $scope.request.content.slice(0, 1)).then(function (deal) {
                if (deal.benchmarkPrice > 0) {
                    $scope.distributorDeal = deal;
                }
            });
        }

        ctrl.$onInit = function() {
            RequestsService.initRequest($scope.request);
            initSmsAndEmailSubjectAndBody();
            initDistributorDeal();            

            if ($scope.request.responses && $scope.request.responses.length) {                
                $scope.request.isCompleted = $scope.request.responses[0].isCompleted;
                $scope.request.completedAt = $scope.request.responses[0].completedAt;
                $scope.request.completedBy = $scope.request.responses[0].completedBy;
            }

            $scope.isPending = !$scope.request.status || $scope.request.status === CONSTANTS.REQUEST_STATUS.PENDING;
        }
        
        $scope.cancelCompleted = function() {
            $scope.request.isCompleted = false; 
            HttpService.Put('requests/' + $scope.request._id, {
                isCompleted: $scope.request.isCompleted
            });
        }

        $scope.sendDistributorOrder = function() {
            var request = $scope.request;
            var distributorDeal = $scope.distributorDeal;

            if (!request || !distributorDeal) {
                AlertService.error('An Error has occurred.');
                return;
            }

            $scope.loading = true;
            HttpService.Get('users/' + request.createdBy._id).then(function (userData) {
                $scope.loading = false;
                $uibModal.open({
                    animation: true,
                    component: 'newOrder',
                    windowClass: 'modal-window-second-level',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        modalData: function () {
                            return {
                                deal: distributorDeal,
                                request: request,
                                user: userData.user
                            };
                        }
                    }
                }).result.then(function (orderData) {
                    orderData.deal = distributorDeal;
                    placeDistributorOrder(request, orderData);
                });
            });
        }

        $scope.updateDealDate = function() {
            $scope.deal.bookingSpan = $scope.deal.bookingSpan || 'week';
            $scope.deal.bookingEnd = moment().add(1, $scope.deal.bookingSpan);
        }

        function getDealFromRequest() {
            var request = $scope.request;
            var deal = DealsService.getDealDraft();

            deal.categoryName = request.isPurchase ? DEAL_CATEGORY.CROP : DEAL_CATEGORY.DEAL;
            deal.requests = [request];
            deal.users = [request.createdBy._id];
            deal.target = DEAL_TARGET.ALL_USERS;

            deal.dealSize = request.quantity;
            deal.customUnit = request.unit;
            deal.distribution = request.isDistributionCollection ? 'collection' : 'delivery';
            deal.customType = request.customType;

            deal.bookingSpan = 'day';
            deal.bookingStart = moment();
            deal.bookingEnd = moment().add(7, deal.bookingSpan);
            deal.individualDiscount = 0;
            deal.clearanceDiscount = 0;
            deal.productAttributes = request.attributes;

            if ($scope.distributorDeal) {
                deal.distributorDeal = $scope.distributorDeal;
                deal.customUnit = deal.distributorDeal.customUnit;
                deal.customType = deal.distributorDeal.customType;
                deal.vendorProductId = deal.distributorDeal.vendorProductId;
            }

            if (request.product) {
                // TODO: Copy product if not owned (either in service or API)
                deal.product = request.product;
                if (request.product.imageUrls && request.product.imageUrls.length) {
                    deal.imageUrl = request.product.imageUrls[0];
                }
                deal.dealSizeOptions = request.product.dealSizeOptions;
                deal.skipSelectProductOnInit = true;
            }
            if (request.retailer) {
                deal.retailPrices = [{ retailer: request.retailer._id }];
            }

            return deal;
        }

        $scope.sendOffer = function() {    
            $uibModalInstance.close();

            if ($scope.request.deals.length && ($scope.request.deals[0].status === DEAL_STATUS.DRAFT || moment().isAfter($scope.request.deals[0].bookingEnd))) {
                $scope.goToOffer();
                return;
            }

            var dealDraft = getDealFromRequest();
            DealsService.createNewDraft(dealDraft);
        };

        function addToMessages(messageText) {
            if (!messageText) {
                return;
            }
            $scope.request.messages.push({
                createdAt: Date.now(),
                createdBy: $rootScope.app.Auth.User._id,
                isSupplier: !$scope.request.isSentRequest,
                text: messageText
            });
        }

        $scope.rejectRequest = function() {
            $ngConfirm({
                title: $scope.request.isSentRequest ? gettextCatalog.getString('Cancel request') : gettextCatalog.getString('Reject request'),
                scope: $scope,
                content: 
                    '<p>' + gettextCatalog.getString('Please explain to your customer why you are rejecting this request:') + '</p>' +
                    '<textarea autofocus id="messageText" ng-model="rejectMessage" class="form-control" rows="2"></textarea>' + 
                    '<p class="text-warning small"><span translate>Field is required</span></p>',
                animation: 'bottom',
                closeAnimation: 'bottom',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide',
                    },
                    ok: {
                        text: gettextCatalog.getString('Confirm'),
                        keys: ['enter'],
                        btnClass: 'btn-success btn-wide',
                        action: function() {
                            if (!$scope.rejectMessage) {
                                return false;
                            }
                            addToMessages($scope.rejectMessage);
                            $scope.request.status = 
                                $scope.request.isSentRequest ? CONSTANTS.REQUEST_STATUS.CANCELLED : CONSTANTS.REQUEST_STATUS.REJECTED;
                            HttpService.Put('requests/' + $scope.request._id, {
                                status: $scope.request.status,
                                messages: $scope.request.messages
                            });   
                            $uibModalInstance.close();   
                        }
                    }
                }
            });   

            $timeout(function () {
                document.getElementById('messageText').focus();
            }, 500);                    
        };

        $scope.createRequestOrder = function() {
            $scope.unitsAmount = $scope.request.quantity;
            $scope.productName = $scope.request.content[$scope.request.content.length - 1];
            
            var content =
                '<div class="mt-3">' + gettextCatalog.getString('Leave a message for your customer:') + '</div>' +
                '<textarea autofocus ng-model="fulfillMessage" class="form-control" rows="2" id="messageText"></textarea>' +
                '<div class="mt-4"><small>' + gettextCatalog.getString('Complete the information below to store the order information for future reference.') + '</small></div>' +
                '<div class="mt-3"><span>' + gettextCatalog.getString('How many units?') + '</span></div>' + 
                '<div><input autocomplete="off" type="number" ng-model="unitsAmount" id="unitsAmount" name="unitsAmount" placeholder="" class="form-control"></div>' +
                '<div class="mt-3"><span>' + gettextCatalog.getString('Unit price') + '</span>:</div>' + 
                '<div class="mb-3"><input autocomplete="off" type="number" ng-model="unitPrice" id="unitPrice" name="unitPrice" placeholder="" class="form-control"></div>' + 
                '<div class="pb-5 font-weight-bold"><span>' + gettextCatalog.getString('Total') + '</span>: {{utils.getLocalizedCurrency(unitsAmount * unitPrice)}}</div>'
            
            $ngConfirm({
                title: gettextCatalog.getString('Mark request as completed'),
                scope: $scope,
                content: content,
                columnClass: 'small',
                animation: 'bottom',
                closeAnimation: 'bottom',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        keys: ['esc'],
                        btnClass: 'btn-dark btn-wide',
                        action: function() {}
                    },
                    ok: {
                        text: gettextCatalog.getString('Confirm'),
                        keys: ['enter'],
                        btnClass: 'btn-success btn-wide',
                        action: function() {
                            $scope.request.status = CONSTANTS.REQUEST_STATUS.FULFILLED;
                            addToMessages($scope.fulfillMessage);
                            HttpService.Post('requests/' + $scope.request._id + '/orders', {
                                amount: $scope.unitsAmount, 
                                messages: $scope.fulfillMessage ? $scope.request.messages : null,
                                unitPrice: $scope.unitPrice,
                                productName: $scope.productName,
                                categoryName: $scope.request.isPurchase ? DEAL_CATEGORY.CROP : DEAL_CATEGORY.DEAL
                            }).then(function() {
                                $uibModalInstance.close();
                                AlertService.success(gettextCatalog.getString('Transaction saved to "Orders" page'));
                            });                             
                        }
                    }
                }
            });

            $timeout(function () {
                document.getElementById('messageText').focus();
            }, 500);
        };

        $scope.createNewDeal = function() {
            $uibModalInstance.close({
                _id: $scope.request._id,
                isCompleted: $scope.request.isCompleted,
                createNewDeal: true
            });
        }

        
        $scope.goToOffer = function() {
            if (!$scope.request.latestDeal) {
                AlertService.error('An Error has occurred.');
                return;
            }
            var deal = $scope.request.latestDeal;
            $uibModalInstance.close();

            if ($scope.request.isSentRequest) {
                $state.go('app.offers.received', { id: deal._id})
                return;
            }
            
            if (DealsService.isDraft(deal) && DealsService.isCategoryCrop(deal)) {
                $state.go('app.crop.proc', { id: deal._id });
                return;
            }
            if (DealsService.isDraft(deal)) {
                $state.go('app.deals.update', { id: deal._id, referrer: 'app.deals.request' });
                return;
            }
            $state.go('app.deals.report', { id: deal._id });    
        };

        $scope.goToOrder = function() {
            if (!$scope.request.orders.length) {
                return;
            }
            $uibModalInstance.close();
            var refs = $scope.request.orders.map(function(order) {
                return order.ref;
            });
            var orderRole = $scope.request.isSentRequest ? 'RETAILER' : 'DISTRIBUTOR';
            $timeout(function () { // Give time to close the modal
                $state.go('app.orders', { role: orderRole, type: 'ANY', ref: refs });
            }, 500);
        }

        $scope.ok = function(){
            $uibModalInstance.close();
        };

        $scope.cancel = function() {
            $uibModalInstance.close();
        };

        $scope.deleteRequest = function() {
            HttpService.Delete('requests/' + $scope.request._id).then(function() {
                $scope.request.isDeleted = true;
            });
        };
        $scope.restoreRequest = function() {
            HttpService.Put('requests/' + $scope.request._id, { isDeleted: false }).then(function() {
                $scope.request.isDeleted = false;
            });
        };

        // Utils ------------------------------------------------

        function placeDistributorOrder(request, orderData) {
            if (orderData.messageForCustomer) {
                request.messages.push({
                    createdAt: Date.now(),
                    createdBy: $rootScope.app.Auth.User._id,
                    isSupplier: true,
                    text: orderData.messageForCustomer
                });
            }
            HttpService.Post('me/deals/' + orderData.deal._id + '/orders', orderData).then(function (orderResult) {
                request.isCompleted = true;
                HttpService.Put('requests/' + request._id, {
                    status: CONSTANTS.REQUEST_STATUS.FULFILLED,
                    isCompleted: request.isCompleted,
                    orders: [orderResult.data.order._id],
                    messages: request.messages
                });

                AlertService.success(gettextCatalog.getString('Order placed'));
                $uibModalInstance.close();
                
            }).catch(function () {
                AlertService.error(gettextCatalog.getString('Error while creating order. Please try again.'));
            });
        }
    }
})();
(function(){
    angular
        .module('app.commons')
            .directive("showPassword", function() {
                return function linkFn(scope, elem, attrs) {
                    scope.$watch(attrs.showPassword, function(newValue) {
                        if (newValue) {
                            elem.attr("type", "text");
                        } else {
                            elem.attr("type", "password");
                        }
                    });
                };
            });
})();
(function(){
    function showSubscriptionUpgradeModal(scope, $ngConfirm, Utils, gettextCatalog) {
        scope.utils = Utils;
        
        $ngConfirm({
            scope: scope,
            icon: 'fa fa-exclamation-triangle',
            title: gettextCatalog.getString('FarmHedge subscription upgrade'),
            contentUrl: 'app/modules/subscription/subscription-upgrade.tpl.html',
            columnClass: 'large',
            buttons: { OK: function() {} }
        }); 
    }
    angular
        .module('app.commons')
        .directive("upgradeButton", function($ngConfirm, Utils, gettextCatalog) {
            return {
                link: function (scope, elem, attrs) {
                    scope.$watch(attrs.paidFeature, function() { 
                        elem.unbind('click').bind('click', function() {
                            showSubscriptionUpgradeModal(scope, $ngConfirm, Utils, gettextCatalog);
                        });
                    });
                }
            };
        })
        .directive("paidFeature", function($ngConfirm, Utils) {
            return {
                link: function (scope, elem, attrs) {
                    scope.$watch(attrs.paidFeature, function() {
                        if (!Utils.isSubscriptionExpired($ngConfirm) && 
                            (Utils.isSubscriptionTrial() || !attrs.paidFeature || Utils.isSubscriptionPackage(attrs.paidFeature))) {
                            elem.removeClass('text-hidden');
                            return;
                        }
                        elem.removeAttr('href');
                        elem.attr('disabled', 'disabled');
                           
                        elem.addClass('paid-feature');
                        if (!elem.is(':button') && !elem.is(':link')) {
                            elem.addClass('text-hidden');
                        }                        
                    });
                }
            };
        }); 
})();
/**
 * Created by Hafeez Rehman on 25/12/2018.
 */
(function () {
    'use strict';

     angular
         .module('app.commons')
            .directive('equalWith', function() {
                 return {
                     require: 'ngModel',
                     scope: { equalWith: '&'},
                     link: function(scope, elem, attrs, ngModelCtrl) {
                         ngModelCtrl.$validators.equalWith = function (modelValue) {
                             return (modelValue === scope.equalWith())
                         };

                         scope.$watch(scope.equalWith, function() {
                             ngModelCtrl.$validate()
                         });
                     }
                 };
             });
})();
(function() {
  'use strict';

  angular.module('app').component('show', {
    controller: ShowController,
    controllerAs: 'vm',
    templateUrl: 'app/show/show.view.html',
  });

  /** @ngInject */
  function ShowController($state, $log, $stateParams, AuthFactory, HttpService) {
    var vm = this;

    vm.dealId = $stateParams.id;

    activate();

    function activate() {
      HttpService.Get('deals/' + vm.dealId + 'preview').then(function() {
        // TODO Complete this function
      });
    }
  }

})();

/**
 * Created by Hafeez Rehman on 23/11/2017.
 */

(function () {
    'use strict';

    angular
        .module('app')
            .service('Utils', Utilities);

    function Utilities($rootScope, $window, $templateCache, $ngConfirm, $q, $uibModal, $filter, gettextCatalog, 
            FEATURE_FLAGS, CONSTANTS) {
        var regionalManagerEmails = [
            'john.garvey@farmhedge.io',
            'john.garvey+cp@farmhedge.io',
            'hkeyes@farmhedge.io',
            'hkeyes+cp@farmhedge.io',
            'bfrola@farmhedge.io', 
            'bfrola+cp@farmhedge.io', 
            'fbluemke@farmhedge.io',
            'fbluemke+cp@farmhedge.io',
            'bfrola+staging@farmhedge.io',
            'bfrola+local@farmhedge.io',
            'josef.buehler@baywa.de',
            'katharina.adlhoch@baywa.de',
            'claudia.mittermayr@rwa.at', 
            'astrid.riedweg@rwa.at',
            'f.camus+cp@agroinnolab.com',
            'fabian.camus+cp@rwa.at',
        ];

        this.CreateConfirmation = function (question, title) {
            var deferred = $q.defer();

            $ngConfirm({
                icon: 'fa fa-exclamation-triangle',
                title: title || gettextCatalog.getString('Confirm Action'),
                content: '<p>' + question + '<p>',
                columnClass: 'small',
                buttons: {
                    cancel: {
                        text: gettextCatalog.getString('Cancel'),
                        btnClass: 'btn-dark float-left',
                        action: function () {
                            deferred.reject();
                        }
                    },
                    ok: {
                        text: gettextCatalog.getString('OK'),
                        btnClass: 'btn-success btn-wide',
                        action: function () {
                            deferred.resolve();
                        }
                    }
                }
            });

            return {
                result: deferred.promise
            };
        };

        this.CreateNotification = function (type) {
            return $uibModal.open({
                animation: true,
                controller: 'NotificationCtrl',
                templateUrl: 'app/shared/templates/modals/notification.tpl.html',
                template: $templateCache.get('app/shared/templates/modals/notification.tpl.html'),
                size: 'sm',
                resolve: {
                    vm: function () { return type; }
                }
            });
        };

        this.getTemplate = function (templateId) {
            return $templateCache.get(templateId);
        };

        this.getSalePrice = function (originalPrice, discountPercent, decimalDigits) {
            decimalDigits = decimalDigits || 2;
            if (discountPercent < 0 || discountPercent > 100) {
                return originalPrice;
            }
            return +(originalPrice - originalPrice * discountPercent / 100).toFixed(decimalDigits);
        };

        this.getDiscountPercent = function (originalPrice, discountedPrice) {
            if (originalPrice < discountedPrice) {
                return 0;
            }
            return +(((originalPrice - discountedPrice) / originalPrice) * 100).toFixed(4);
        };

        /** Convert a list of {value, label} into a map m[value]=label */
        this.valueToLabelMap = function (list) {
            return list.reduce(function (map, obj) {
                map[obj.value] = obj.label;
                return map;
            }, {});
        };

        // --------------------------
        // IE compatibility functions

        // IE-compatible alternative of  array.find
        this.altFind = function (arr, callback) {
            for (var i = 0; i < arr.length; i++) {
                if (callback(arr[i], i)) {
                    return arr[i];
                }
            }
        };

        // IE-compatible Alternative for Object.assign
        this.mergeObject = function (target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        };

        this.isNumber = function (value) {
            return !isNaN(parseFloat(value)) && isFinite(value);
        }

        this.getRandomArbitrary = function (min, max) {
             return Math.random() * (max - min) + min;
        };

        this.getRandomInt = function (min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        };

        this.getLocalizedDate = function (value) {
            return $filter('date')(moment(value).toDate(), 'mediumDate');
        };

        this.getLocalizedDateAndTime = function (value) {
            return this.getLocalizedDate(value) + ' ' + $filter('date')(moment(value).toDate(), 'shortTime');
        };

        this.getLocalizedCurrency = function (value, decimalDigits) {
            if (!value) {
                value = 0;
            }
            else if (!this.isNumber(value)) {
                return value;
            }
            else {
                value = +value;
            }
            
            decimalDigits = decimalDigits || 2;
            var currencySymbol = ($rootScope.app.Auth.User && $rootScope.app.Auth.User.supplier &&
                $rootScope.app.Auth.User.supplier.currencySymbol) ? $rootScope.app.Auth.User.supplier.currencySymbol : '€';
            return $filter('currency')(value, currencySymbol, decimalDigits);
        };

        this.isUserRegionalManager = function() {
            if (!$rootScope.app.Auth.User || !$rootScope.app.Auth.User.email) {
                return false;
            }
            if (regionalManagerEmails.indexOf($rootScope.app.Auth.User.email.toLowerCase()) < 0) {
                return false;
            }
            return true;
        }
        this.isFeatureEnabled = function(featureName) {
            if (!$rootScope.app.Auth || !$rootScope.app.Auth.User || !$rootScope.app.Auth.User.supplier) {
                return false;
            }
            if (!$rootScope.app.Auth.User.supplier || !$rootScope.app.Auth.User.supplier.area) {
                return false;
            }
            var flagByCountry = FEATURE_FLAGS.BY_COUNTRY[featureName];
            var supplierCountry = $rootScope.app.Auth.User.supplier.area.toLowerCase();
            if (!flagByCountry || flagByCountry.indexOf(supplierCountry) < 0) {
                return false;
            }
            return true;
        };

        this.getRandomHexColor = function () {
            var color = '#'+'0123456789abcdef'.split('').map(function(v,i,a) {
                return i>5 ? null : a[Math.floor(Math.random()*16)];
            }).join('');
            return color;
        };

        this.getRandomHexLightColor = function () {
            var letters = '456788abc'.split('');
            var color = '#';
            for (var i = 0; i < 6; i++ ) {
                color += letters[Math.floor(Math.random() * letters.length)];
            }
            return color;
        };

        this.roundCurrencyValue = function(value) {
            return Math.round(value * 1000000) / 1000000;
        };

        this.getTrimmedString = function(str, maxLength) {
            if (!str) {
                return '';
            }
            maxLength = maxLength || 30;
            return (str.length <= maxLength) ? str : str.substring(0, maxLength) + '...';
        };

        this.isSupplierCountryAustria = function() {
            return $rootScope.app.Auth.User && $rootScope.app.Auth.User.supplier.area.toLowerCase() === CONSTANTS.COUNTRIES.AT;
        }
        this.isSupplierCountryGermany = function() {
            return $rootScope.app.Auth.User && $rootScope.app.Auth.User.supplier.area.toLowerCase() === CONSTANTS.COUNTRIES.DE;
        }
        this.isSupplierCountryHungary = function() {
            return $rootScope.app.Auth.User && $rootScope.app.Auth.User.supplier.area.toLowerCase() === CONSTANTS.COUNTRIES.HU;
        }
        this.isSupplierCountry = function (country) {
            return $rootScope.app.Auth.User && $rootScope.app.Auth.User.supplier.area.toLowerCase() === country;
        }
        this.isSupplierDistributor = function() {
            return $rootScope.app.Auth.User && !!$rootScope.app.Auth.User.supplier.type;
        }

        this.supplierHasProductTypeSell = function() {
            if (!$rootScope.app.Auth.User || !$rootScope.app.Auth.User.supplier.productTypes || !$rootScope.app.Auth.User.supplier.productTypes.length) {
                return false;
            }
            var targetProductType = this.altFind($rootScope.app.Auth.User.supplier.productTypes, function (pt) {
                return pt.indexOf('verkaufen') >= 0 || pt.indexOf('sell') >= 0;
            });
            return !!targetProductType;
        }
        this.supplierHasProductTypeBuy = function() {
            if (!$rootScope.app.Auth.User || !$rootScope.app.Auth.User.supplier.productTypes || !$rootScope.app.Auth.User.supplier.productTypes.length) {
                return true;
            }
            if ($rootScope.app.Auth.User.supplier.productTypes.length === 1 && this.supplierHasProductTypeSell()) {
                return false;
            }
            return true;
        }

        this.getSettings = function() {
            if (!$rootScope.app.Auth.User || !$rootScope.app.Auth.User.settings) {
                return {};
            }
            return $rootScope.app.Auth.User.settings;
        }

        /**
         * Returns diff between dates 'date' and 'ref' in days, hours, munutes and seconds.
         * Default value of 'ref' is now.
         */
        this.getDateDiff = function(date, ref) {
            ref = ref ? new Date(ref) : Date.now();
            var countDownDate = new Date(date).getTime();
            var distance = countDownDate - ref;
            if (distance < 0) {
                return null;
            }
            return {
                months: Math.floor(distance / (1000 * 60 * 60 * 24 * 30)),
                days: Math.floor(distance / (1000 * 60 * 60 * 24)),
                hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                seconds: Math.floor((distance % (1000 * 60)) / 1000)
            }
        }

        this.isNumber = function(value) {
            return !isNaN(parseFloat(value)) && isFinite(value);
        }

        this.isUpgradeInfoVisible = function() {
            if (this.isSubscriptionTrial()) {
                return true;
            }
            if (this.isSubscriptionExpiringSoon()) {
                return true;
            }
            return false;
        }
        
        this.isSubscriptionPackage = function(packageName) {
            if (!$rootScope.app.Auth.User || !$rootScope.app.Auth.User.supplier) {
                return false;
            }
            if (!$rootScope.app.Auth.User.supplier.subscriptionPackage || this.isSupplierDistributor()) {
                return true;
            }
            return $rootScope.app.Auth.User.supplier.subscriptionPackage.toLowerCase() === packageName.toLowerCase();
        };
        this.isSubscriptionTrial = function () {
            if (!$rootScope.app.Auth.User || !$rootScope.app.Auth.User.supplier || !$rootScope.app.Auth.User.supplier.subscriptionPackage) {
                return false;
            }
            if (this.isSupplierDistributor()) {
                return false;
            }
            return this.isSubscriptionPackage('TRIAL');
        }
        this.getSubsciptionExpiresInDays = function() {
            return -moment().diff(this.getSubscriptionExpiresAt(), 'days');
        }
        this.isSubscriptionExpiringSoon = function() {
            return (this.getSubsciptionExpiresInDays() < 15);
        }
        this.isSubscriptionExpired = function() {
            var expiresAt = this.getSubscriptionExpiresAt();
            if (!expiresAt) {
                return false;
            }
            return moment().isAfter(expiresAt);
        }
        this.getSubscriptionPackage = function() {
            if (!$rootScope.app.Auth.User || !$rootScope.app.Auth.User.supplier || !$rootScope.app.Auth.User.supplier.subscriptionPackage) {
                return null;
            }
            return $rootScope.app.Auth.User.supplier.subscriptionPackage;
        }
        this.getSubscriptionExpiresAt = function() {
            if (!$rootScope.app.Auth.User || !$rootScope.app.Auth.User.supplier || !$rootScope.app.Auth.User.supplier.subscriptionExpiresAt) {
                return null;
            }
            return $rootScope.app.Auth.User.supplier.subscriptionExpiresAt;
        }

        this.setItemLS = function (key, jsonValue) {
            $window.localStorage.setItem(key, JSON.stringify(jsonValue));
        }
        this.getItemLS = function (key) {
            var value = $window.localStorage.getItem(key);
            if (value === 'undefined' || value === 'null') {
                return undefined;
            }
            try {
                value = JSON.parse(value);
            }
            catch(err) {
                return undefined;
            }
            return value;
        };

        this.getShoppingCart = function () {
            var shoppingCart = this.getItemLS(CONSTANTS.LS_ENTRIES.SHOPPING_CART) || { items: [] };
            shoppingCart.items = shoppingCart.items || [];
            return shoppingCart;
        }
        this.saveShoppingCart = function (shoppingCart) {
            this.setItemLS(CONSTANTS.LS_ENTRIES.SHOPPING_CART, shoppingCart);
        }

        this.roundDecimals = function (value) {
            return Math.round(value * 10000) / 10000;
        } 

        this.isBefore = function(date) {
            return moment().isBefore(moment(date, 'YYYY-MM-DD'));
        }

        this.startIntro = function(steps, nextPageAction) {
            var intro = introJs();
            var options = { 
                steps: steps,
                overlayOpacity: 0.1
            };
            if (nextPageAction) {
                intro.setOption('doneLabel', nextPageAction.text).start().oncomplete(nextPageAction.action);
            }
            intro.setOptions(options);
            intro.start();
        }
     }

    Utilities.$inject = ['$rootScope', '$window', '$templateCache', '$ngConfirm', '$q', '$uibModal', '$filter', 'gettextCatalog', 'FEATURE_FLAGS', 'CONSTANTS'];
})();

(function () {
    'use strict';

    angular
        .module('app')
        .service('RequestsService', RequestsService);

    function RequestsService($rootScope, gettextCatalog) {
        this.initRequest = function(request) {

            if (request.deals && request.deals.length) {
                request.latestDeal = request.deals.slice(-1)[0];
            }
            
            if (!request.status) {
                request.status = 'PENDING';
            }

            request.isSentRequest = request.retailer ? $rootScope.app.Auth.User.supplier._id === request.retailer._id : false;
            request.isPurchase = request.content[0].toLowerCase().indexOf('sell') > 0 || request.content[0].toLowerCase().indexOf('verkaufen') > 0;

            if (!request.productName && !request.isPurchase) {
                if (request.product && request.product.name) {
                    request.productName = request.product.name;
                    if (!request.customType && request.content.length > 1) {
                        request.customType = request.content.slice(-1)[0];
                    }
                }
                else {                    
                    if (!request.customType && request.content.length > 2) {
                        request.productName = request.content.slice(-2).join(' - ');
                        request.customType = request.content.slice(-3)[0];
                    }
                    else if (!request.customType && request.content.length > 1) {
                        request.productName = request.content.slice(-1)[0];
                        request.customType = request.content.slice(-2)[0];
                    }
                }
            }
            else if (request.isPurchase) {
                request.productName = request.content.slice(-1).join(' - ');
                request.customType = '';
                request.unit = gettextCatalog.getString('Tonne');
            }

            request.attributes = request.attributes.filter(function (a) {
                var attributeLabel = a.label.toLowerCase();
                if (a.name === 'quantity' || attributeLabel.indexOf('quantity') >= 0 || attributeLabel.indexOf('menge') >= 0) {
                    request.quantity = +(a.value);
                    return false;
                }
                if (a.name === 'distribution' || attributeLabel.indexOf('distribution') >= 0 || attributeLabel.indexOf('abholung') >= 0) {
                    request.distribution = a.value;
                    if (request.distribution.toLowerCase() === 'abholung' || request.distribution.toLowerCase() === 'collection') {
                        request.isDistributionCollection = true;
                    }
                    return false;
                }
                if (a.name === 'details' || attributeLabel.indexOf('details?') >= 0 || attributeLabel.indexOf('detailanfrage') >= 0) {
                    request.messages.unshift({
                        createdAt: request.createdAt,
                        createdBy: request.createdBy,
                        text: a.value
                    });
                    return false;
                }
                return true;
            });

            if (request.product && request.product.attributes) {
                request.attributes = request.product.attributes.concat(request.attributes);
            }

            if (request.messages && request.messages.length) {
                request.lastMessage = request.messages.slice(-1)[0].text;
            }
        };
    }  

    

    RequestsService.$inject = ['$rootScope', 'gettextCatalog'];
})();
(function () {
    'use strict';

    angular
        .module('app')
            .service('ProductsService', ProductsService);

    function ProductsService($rootScope, $q, $log, HttpService) {

        // TODO: move to products DB
        function getProductsWithAdditions(supplierProducts, additions) {
            supplierProducts = supplierProducts || [];            
            if (!additions || !additions.length) {
                return supplierProducts;
            }
            var existingIds = {};
            supplierProducts.forEach(function(p) {
                existingIds[p.vendorProductId] = true;
            });
            var filteredAdditions = additions.filter(function(p) {
                return !existingIds[p.vendorProductId];
            });
            return supplierProducts.concat(filteredAdditions);
        }
         
        // TODO: deprecated - remove all calls to this function.
        this.reloadProducts = function() {
            // No-op
        };

        this.getProductDeal = function (product, categoryNames) {
            var deferred = $q.defer();
            var payload = {
                limit: 1,
                query: product.vendorProductId || product.name
            };
            if (categoryNames) {
                payload.categoryNames = categoryNames;
            }
            HttpService.Get('me/deals/search', payload).then(function (res) {
                if (!res.deals || !res.deals.length) {
                    deferred.reject();
                    return;
                }                
                deferred.resolve(res.deals[0]);
            });
            return deferred.promise;
        };

        // TODO: Use this function in deal.update instead of getFilteredProducts
        this.getProductByName = function (name) {
            var queryParams = { name: name };
            var supplierId = $rootScope.app.Auth.User.supplier._id;

            return HttpService.Get('suppliers/' + supplierId + '/products', queryParams).then(function (res) {
                if (res && res.products && res.products.length) {
                    return res.products[0];
                }
                // TODO: add additionalProducts
                return null;
            }).catch(function (error) {
                $log.error(error);
                return [];
            });
        }

        this.getFilteredProducts = function (searchText, resultLimit) {
            searchText = (searchText || '').toLowerCase();
            $log.log('ProductsService: getFilteredProducts');
            resultLimit = resultLimit || 10;
            
            var queryParams = {
                limit: resultLimit,
                skip: 0
            };
            if (searchText) {
                queryParams.searchText = searchText;
            }

            var supplierId = $rootScope.app.Auth.User.supplier._id;
            var _this = this;
            
            additionalProducts = (_this.additionalProducts[String(supplierId)]);
            if (additionalProducts) {
                additionalProducts = additionalProducts.filter(function (p) {
                    return p.name.toLowerCase().indexOf(searchText) >= 0 ||
                        (p.categoryName && p.categoryName.toLowerCase().indexOf(searchText) >= 0) ||
                        (p.vendorProductId && p.vendorProductId.toLowerCase().indexOf(searchText) >= 0)
                }).slice(0, resultLimit);
            }
           
            return HttpService.Get('suppliers/' + supplierId + '/products', queryParams).then(function (res) {
                return getProductsWithAdditions(res.products, additionalProducts);
            }).catch(function (error) {
                $log.error(error);
                return [];
            });
        }

        this.createProduct = function(productData) {
            var deferred = $q.defer();
            var supplierId = $rootScope.app.Auth.User.supplier._id;
            HttpService.Post('suppliers/' + supplierId + '/products', productData).then(function (res) {
                deferred.resolve(res);
            }).catch(function(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        this.deleteAllProducts = function() {
            var deferred = $q.defer();
            var supplierId = $rootScope.app.Auth.User.supplier._id;
            HttpService.Delete('suppliers/' + supplierId + '/products/bulk').then(function (res) {
                deferred.resolve(res);
            }).catch(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        // TODO: move this list to API.
        var additionalProducts_5c76645d34ce49001536eb6a = [
            { 'vendorProductId': '30001156', 'name': 'PK 0:13:15 PHYSIO NATURPKS 41 LOSE' },
            { 'vendorProductId': '30001157', 'name': 'PK 0:13:15 PHYSIO NATUR PKS 41 BB 600 KG' },
            { 'vendorProductId': '30001158', 'name': 'PK 0:13:15 PHYSIO NATUR PKS 41 50 KG' },
            { 'vendorProductId': '30200660', 'name': 'AMIDAS GRAN 40N+5,6S LOSE' },
            { 'vendorProductId': '30200675', 'name': 'AMIDAS GRAN. 40N+5,6S BIG BAG 600 KG' },
            { 'vendorProductId': '30200862', 'name': 'NPK UBINAS 20-20-20+ME 25/1 KG' },
            { 'vendorProductId': '30201362', 'name': 'NPK 12:24:12 LOSE' },
            { 'vendorProductId': '30201437', 'name': 'PK 0:10:25 GRAN LOSE' },
            { 'vendorProductId': '30201438', 'name': 'PK 0:10:25 GRAN BIG BAG' },
            { 'vendorProductId': '30201723', 'name': 'NP 11:52:0 Big Bag MAP 1000kg' },
            { 'vendorProductId': '30201737', 'name': 'NP 11:52:0 Big Bag MAP 600kg' },
            { 'vendorProductId': '30208882', 'name': 'NPK 21:6:12 BB 600 KG YaraMila Getreide' },
            { 'vendorProductId': '30231284', 'name': 'NPK 15:15:15+3S BIG BAG 600 KG' },
            { 'vendorProductId': '30231959', 'name': 'KTS 0:0:25 + 17S' },
            { 'vendorProductId': '30231960', 'name': 'NP 11:37:0 APP' },
            { 'vendorProductId': '30232412', 'name': 'ROCK PHOSPHATE LOSE 31%' },
            { 'vendorProductId': '30235278', 'name': 'UNSER BIO PRIMAFERT NPK 5-3-3 LOSE' },
            { 'vendorProductId': '30243701', 'name': 'ROCK PHOSPHATE BPL LOSE65-67 %' },
            { 'vendorProductId': '30243704', 'name': 'UNSER BIO PRIMAFERT NPK 5-3-3 BB 700 KG' },
            { 'vendorProductId': '30255952', 'name': 'BRANNTKALK FEIN GEMAH- LEN 25 KG' },
            { 'vendorProductId': '30255953', 'name': 'BioPhos GRANULIERT 2-6 MM LOSE' },
            { 'vendorProductId': '30255954', 'name': 'BIOPHOS GRANULIERT 2-6 MM 25 KG' },
            { 'vendorProductId': '30255955', 'name': 'BIOPHOS GRANULIERT 2-6 MM BB 600 KG' },
            { 'vendorProductId': '30255956', 'name': 'BIOPHOS GRANULIERT 2-6 MM BB 1000 KG' },
            { 'vendorProductId': '30258604', 'name': 'SALETROSAN 26 macro 26N+13S BB 600 KG' },
            { 'vendorProductId': '30270819', 'name': 'EPSO TOP 25 KG' },
            { 'vendorProductId': '30274597', 'name': 'BIOSOL PULVER SACK 25 KG' },
            { 'vendorProductId': '30274598', 'name': 'NPK 14:7:16 EUROFERTIL 67 N-PROCESS 40/1' },
            { 'vendorProductId': '30278810', 'name': 'NPK 13:32:13 25 KG' },
            { 'vendorProductId': '30278842', 'name': 'NPK 32:10:10 ACHTANG 25 KG' },
            { 'vendorProductId': '30279031', 'name': 'KALKKORN-MG 30 GRAN. 2-6 MM LOSE' },
            { 'vendorProductId': '30279032', 'name': 'KALKKORN-MG 30 GRAN. 2-6 MM BB 1000 KG' },
            { 'vendorProductId': '30279033', 'name': 'KALKKORN-MG 30 GRAN. 2-6 MM BB 600 KG' },
            { 'vendorProductId': '30279034', 'name': 'KALKKORN-MG 30 GRAN. 2-6 MM GES. 25 KG' },
            { 'vendorProductId': '30279035', 'name': 'KALCIS MAG 2 BIG BAG' },
            { 'vendorProductId': '30279807', 'name': 'NPK 20:8:8+2 KRISTALON VIOLETT 25 KG' },
            { 'vendorProductId': '30291979', 'name': 'NPK 13:33:7 +5S BIG BAG' },
            { 'vendorProductId': '30291980', 'name': 'NITRAMON S 26N+13S 25KG(DASA)' },
            { 'vendorProductId': '30291982', 'name': 'ENSIN 26+13 25 KG' },
            { 'vendorProductId': '30292075', 'name': 'NPK 15:13:13+5S LOSE NITROPHOSKA' },
            { 'vendorProductId': '30292273', 'name': 'NPK 15:13:13+5S 50 KG NITROPHOSKA' },
            { 'vendorProductId': '30292274', 'name': 'NPK 15:13:13+5S BIG BAG600KG NITROPHOSKA' },
            { 'vendorProductId': '30292275', 'name': 'NPK 15:13:13+5S BB1000 KG NITROPHOSKA' },
            { 'vendorProductId': '30293269', 'name': 'AMMONSULFAT 20%N+24%S GRANULIERT LOSE' },
            { 'vendorProductId': '30293498', 'name': 'AMMONSULFAT 20%N+24%S GRAN. BIG BAG' },
            { 'vendorProductId': '30294803', 'name': 'ENSIN 26+13 BIG BAG 600 KG' },
            { 'vendorProductId': '30298550', 'name': 'AMMONSULFAT 20,6%N (PRATIKO 21) GRAN. BB' },
            { 'vendorProductId': '30309566', 'name': 'SALETROSAN 26 macro 26N+13S BB 700 KG' },
            { 'vendorProductId': '30318304', 'name': 'PK 0:13:15 PHYSIO NATURPKS 47 LOSE' },
            { 'vendorProductId': '30319782', 'name': 'PK 0:13:15 PHYSIO NATUR PKS 47 BB 600 KG' },
            { 'vendorProductId': '30319795', 'name': 'PK 0:13:15 PHYSIO NATUR PKS 47 50 KG' },
            { 'vendorProductId': '30322027', 'name': 'HÜHNERTROCKENKOT BIO LOSE' },
            { 'vendorProductId': '30332205', 'name': 'KAS 27% GRAN 25 KG NAC 27 N' },
            { 'vendorProductId': '30332206', 'name': 'NPK 15:15:15 25 KG COMPLEX' },
            { 'vendorProductId': '30332207', 'name': 'NPK 20:8:8 25KG COMPLEX' },
            { 'vendorProductId': '30332208', 'name': 'NPK 12:12:17 25KG COMPLEX' },
            { 'vendorProductId': '30332209', 'name': 'NPK 15:5:18 25 KG COMPLEX' },
            { 'vendorProductId': '30332210', 'name': 'NP 20:20:0 25KG COMPLEX' },
            { 'vendorProductId': '30334232', 'name': 'BONUS DÜNGEMITTEL' },
            { 'vendorProductId': '30334460', 'name': 'N + S DÜNGER 26+18 GRAN. BIG BAG 500 KG' },
            { 'vendorProductId': '30351997', 'name': 'KIESERIT FEIN LOSE' },
            { 'vendorProductId': '30352529', 'name': 'KALKPHOS P15 GRANULIERT 2-6 MM LOSE' },
            { 'vendorProductId': '30352542', 'name': 'KALKPHOS P15 GRANULIERT 2-6 MM BB 600 KG' },
            { 'vendorProductId': '30352545', 'name': 'KALKPHOS P15 GRANULIERT 2-6 MM 25 KG' },
            { 'vendorProductId': '30356979', 'name': 'EPSO MICROTOP 25 KG' },
            { 'vendorProductId': '30360236', 'name': 'ORGANOMAX BIG BAG 500 KG' },
            { 'vendorProductId': '30366786', 'name': 'KUNDENBONUS DÜNGEMITTEL' },
            { 'vendorProductId': '30368335', 'name': 'EPSO TOP BIG BAG 1.000 KG' },
            { 'vendorProductId': '30375969', 'name': 'PHYSIOMAX PLUS S LOSE' },
            { 'vendorProductId': '30376180', 'name': 'PHYSIOMAX PLUS S BIG BAG 600 KG' },
            { 'vendorProductId': '30376181', 'name': 'PHYSIOMAX PLUS S GESACKT 50 KG' },
            { 'vendorProductId': '30376184', 'name': 'PHYSIO NATUR G18S LOSE' },
            { 'vendorProductId': '30376215', 'name': 'PHYSIO NATUR G18S BIG BAG 600KG' },
            { 'vendorProductId': '30376216', 'name': 'PHYSIO NATUR G18S 50KG' },
            { 'vendorProductId': '30376222', 'name': 'UNSER BIO HTK-PELLETS 4-3-3 LOSE' },
            { 'vendorProductId': '30376223', 'name': 'UNSER BIO HTK-PELLETS 4-3-3 BB 1000 KG' },
            { 'vendorProductId': '30376225', 'name': 'UNSER BIO HTK-PELLETS 4-3-3 BB 500 KG' },
            { 'vendorProductId': '30377119', 'name': 'ROLL-KALI 48% LOSE' },
            { 'vendorProductId': '30377123', 'name': 'ROLL-KALI 48% BIG BAG 600 KG' },
            { 'vendorProductId': '30377244', 'name': 'DIABAS SAND grob 0/4 mm FEUCHT LOSE' },
            { 'vendorProductId': '30380211', 'name': 'STALLKALK MIKROFEIN Kreidespritzk. 40kg' },
            { 'vendorProductId': '30383078', 'name': 'PERLKA NP Starter 600 KG BIG BAG' },
            { 'vendorProductId': '30383092', 'name': 'NPK 21:6:11+3S 500 KG BIG BAG' },
            { 'vendorProductId': '30388776', 'name': 'HÜHNERTROCKENKOT KONVENTIONELL LOSE' },
            { 'vendorProductId': '30389987', 'name': 'NPK 16:8:16 600 KG BIG BAG YARAMILA Raps' },
            { 'vendorProductId': '30390729', 'name': 'NPK 8:12:24 600 KG BIG BAG' },
            { 'vendorProductId': '30390998', 'name': 'NPK 10:26:26 25 KG' },
            { 'vendorProductId': '30394241', 'name': 'NPK 20:10:8 LOSE COMPLEX' },
            { 'vendorProductId': '30394242', 'name': 'NPK 20:10:8 25KG COMPLEX' },
            { 'vendorProductId': '30394243', 'name': 'NPK 20:10:8 BIG BAG 600 KG COMPLEX' },
            { 'vendorProductId': '30394247', 'name': 'NP 24:14:0 LOSE COMPLEX' },
            { 'vendorProductId': '30394248', 'name': 'NP 24:14:0 25KG COMPLEX' },
            { 'vendorProductId': '30394251', 'name': 'NP 24:14:0 BIG BAG 600 KG COMPLEX' },
            { 'vendorProductId': '30394285', 'name': 'DASAMAG 24%N+10%S+6%MgO BIG BAG 600 KG' },
            { 'vendorProductId': '30406855', 'name': 'KORNKALI + B 40/6 lose' },
            { 'vendorProductId': '30408127', 'name': 'AMMONSULFAT 20%N+24%S GRAN. 25kg' },
            { 'vendorProductId': '30409314', 'name': 'AMMONSULFAT 20%N+24%S GRAN. 50kg' },
            { 'vendorProductId': '30411518', 'name': 'HARNSTOFF 46% GRAN 25KG' },
            { 'vendorProductId': '30412619', 'name': 'KOHLENS KALK + S BIG BAG 1000 KG' },
            { 'vendorProductId': '30412620', 'name': 'KAPHOS 5 FEUCHT LOSE' },
            { 'vendorProductId': '30412621', 'name': 'KAPHOS 5 BIG BAG 1000 KG' },
            { 'vendorProductId': '30412622', 'name': 'MISCHKALK +S BIG BAG 1000 KG' },
            { 'vendorProductId': '30412623', 'name': 'KOHLENS KALK MG +S BIG BAG 1000 KG' },
            { 'vendorProductId': '30412624', 'name': 'KOHLENS KALK MG +S LOSE' },
            { 'vendorProductId': '30413913', 'name': 'KAS 27% GRAN 25KG 1200KG/Pal.' },
            { 'vendorProductId': '30413924', 'name': 'PIAMON 33 S BIG BAG 500 KG' },
            { 'vendorProductId': '30417400', 'name': 'DOMAMON L26 20N +6S FLÜSSIG' },
            { 'vendorProductId': '30418486', 'name': 'KALI 60% GRAN BIG BAG 700 KG' },
            { 'vendorProductId': '30420722', 'name': 'KALKSALPETER BIG BAG STREUQUALITÄT' },
            { 'vendorProductId': '30420779', 'name': 'SOLUMOP 25KG' },
            { 'vendorProductId': '30420928', 'name': 'EPSO COMBITOP 25KG' },
            { 'vendorProductId': '30421521', 'name': 'NP 12:52:0 MAP BIG BAG 500 KG' },
            { 'vendorProductId': '30421597', 'name': 'Ammoniumnitrat gran. (ZakSAN) 600 KG BIG' },
            { 'vendorProductId': '30424368', 'name': 'UREA S 38N+7S GRAN BIG BAG 600 KG' },
            { 'vendorProductId': '30425011', 'name': 'NAC+S 24N+15S BIG BAG 600 KG' },
            { 'vendorProductId': '30426545', 'name': 'NK 15:0:20+3+10 25KG BLAUKORN NK' },
            { 'vendorProductId': '30427261', 'name': 'NK 15:0:20+3+10 BB 600KG BLAUKORN NK' },
            { 'vendorProductId': '30427263', 'name': 'NK 15:0:20+3+10 25KG NOVA TEC NK' },
            { 'vendorProductId': '30427264', 'name': 'NK 15:0:20+3+10 BB 600KG NOVA TEC NK' },
            { 'vendorProductId': '30429439', 'name': 'ASN 26N +15S LOSE' },
            { 'vendorProductId': '30429440', 'name': 'ASN 26N +15S BIG BAG 600 KG' },
            { 'vendorProductId': '30429441', 'name': 'ASN 26N +15S 25 KG' },
            { 'vendorProductId': '30429461', 'name': 'PKpluS 16-16+2MgO+8S BIG BAG 600 KG' },
            { 'vendorProductId': '30430215', 'name': 'UNSER BIO PRIMAFERT NP 10-4 BB 1000 KG' },
            { 'vendorProductId': '30431076', 'name': 'DASA 26N+13S Big Bag 600 kg' },
            { 'vendorProductId': '30433173', 'name': 'ORGANOMAX BIG BAG 1000 KG' },
            { 'vendorProductId': '30433775', 'name': 'NPK 12:12:17 +2+14 GESACKT 25 kg' },
            { 'vendorProductId': '30433776', 'name': 'NPK 12:12:17+2+14 LOSE' },
            { 'vendorProductId': '30433777', 'name': 'NPK 12:12:17+2+14 GESACKT 50KG' },
            { 'vendorProductId': '30433778', 'name': 'NPK 12:12:17+2+14 BIG BAG 600KG' },
            { 'vendorProductId': '30438361', 'name': 'TOP PHOS P36 LOSE' },
            { 'vendorProductId': '30438362', 'name': 'TOP PHOS P36 50 KG' },
            { 'vendorProductId': '30438363', 'name': 'TOP PHOS P36 600 KG BIG BAG' },
            { 'vendorProductId': '30439159', 'name': 'Petiso+S 24:12 lose' },
            { 'vendorProductId': '30439160', 'name': 'Petiso+S 24:12 BIG BAG 700 KG' },
            { 'vendorProductId': '709807', 'name': 'BIG BAG DM' },
            { 'vendorProductId': '9000003', 'name': 'NPK 4:20:20 50KG' },
            { 'vendorProductId': '9000391', 'name': 'SULFAMMO 23 MESACTYL N-PRO GESACKT' },
            { 'vendorProductId': '9000392', 'name': 'SULFAMMO 23 MESACTYL N-PRO BIG BAG' },
            { 'vendorProductId': '9000393', 'name': 'NPK 5:10:22 EUROFERTIL 37 PLUS GESACKT' },
            { 'vendorProductId': '9000394', 'name': 'NPK 5:10:22 EUROFERTIL 37 PLUS BIG BAG' },
            { 'vendorProductId': '9000395', 'name': 'PHYSIOMAX 975 GRAN. GESACKT' },
            { 'vendorProductId': '9000396', 'name': 'PHYSIOMAX 975 GRAN. BIG BAG' },
            { 'vendorProductId': '9000397', 'name': 'PHYSIO MESCAL G18 GESACKT' },
            { 'vendorProductId': '9000398', 'name': 'PHYSIO MESCAL G18 BIG BAG' },
            { 'vendorProductId': '9001741', 'name': 'N-PRO SULFAMMO 18 MESACTYL LOSE' },
            { 'vendorProductId': '9001958', 'name': 'SULFAMMO 20 N-PRO BIG BAG' },
            { 'vendorProductId': '9001959', 'name': 'NP 15:20 EUROFERTIL 35 PLUS BIG BAG' },
            { 'vendorProductId': '9001960', 'name': 'NPK 16:5:8 EUROFERTIL 29 N-PRO BIG BAG' },
            { 'vendorProductId': '9001962', 'name': 'NP 15:20 EUROFERTIL 35 PLUS GESACKT' },
            { 'vendorProductId': '9001965', 'name': 'SULFAMMO 30 MESACTYL N-PRO BIG BAG' },
            { 'vendorProductId': '9004412', 'name': 'AHL 13% LOSE' },
            { 'vendorProductId': '9004879', 'name': 'NP 14:5 MEASCTYL N14 PLUS NP LOSE' },
            { 'vendorProductId': '9004880', 'name': 'NP 14:5 MEASCTYL N14 PLUS NP GESACKT' },
            { 'vendorProductId': '9004881', 'name': 'NP 14:5 MEASCTYL N14 PLUS NP BIG BAG' },
            { 'vendorProductId': '9004882', 'name': 'PK 8:18 EUROFERTIL 26 PLUS GESACKT' },
            { 'vendorProductId': '9004883', 'name': 'PK 8:18 EUROFERTIL 26 PLUS BIG BAG' },
            { 'vendorProductId': '9004884', 'name': 'PK 18:18 EUROFERTIL 36 PLUS GES.' },
            { 'vendorProductId': '9004885', 'name': 'PK 18:18 EUROFERTIL 36 PLUS BIGBAG' },
            { 'vendorProductId': '9004887', 'name': 'NPK 13:7:17 EUROFERTIL 37 N-PRO GES.' },
            { 'vendorProductId': '9004888', 'name': 'NPK 13:7:17 EUROFERTIL 37 N-PRO BIGBAG' },
            { 'vendorProductId': '9004889', 'name': 'SULFAMMO 30 MESACTYL N-PRO GESACKT' },
            { 'vendorProductId': '9004896', 'name': 'NPK 16:5:8 EUROFERTIL 29 N-PRO ges.' },
            { 'vendorProductId': '9005013', 'name': 'NPK 20:5:8 BIGBAG' },
            { 'vendorProductId': '9005015', 'name': 'NPK 20:5:8 15kg' },
            { 'vendorProductId': '9006591', 'name': 'KAPHOS 5 LOSE' },
            { 'vendorProductId': '9009062', 'name': 'TRIPLEPHOSPHAT 45% Pulver LOSE' },
            { 'vendorProductId': '9011367', 'name': 'KALKSTICKSTOFF GEP BIG BAG 600 kg' },
            { 'vendorProductId': '9011394', 'name': 'EUROFERTIL 19 N-PRO (NP14/5/0) lose' },
            { 'vendorProductId': '9011396', 'name': 'EUROFERTIL 19 N-PRO (NP14/5/0) ges.' },
            { 'vendorProductId': '9011403', 'name': 'EUROFERTIL 19 N-PRO (NP14/5/0) BIGBAG' },
            { 'vendorProductId': '9016602', 'name': 'NPK 12:7:15 LOSE LAT' },
            { 'vendorProductId': '9016603', 'name': 'NPK 12:7:15 40kg LAT' },
            { 'vendorProductId': '9016832', 'name': 'SCHWEFELKALK LOSE' },
            { 'vendorProductId': '9020175', 'name': 'NPK 8:21:21 LOSE' },
            { 'vendorProductId': '9021528', 'name': 'NP 12:52:0 BIG BAG MAP' },
            { 'vendorProductId': '9023296', 'name': 'HARNSTOFF 46% GEPR 40KG' },
            { 'vendorProductId': '9023315', 'name': 'NPK 16:16:16 lose' },
            { 'vendorProductId': '9023335', 'name': 'KAS 26% GEPR 40KG' },
            { 'vendorProductId': '9024157', 'name': 'NP 10:40 BIG BAG' },
            { 'vendorProductId': '9025819', 'name': 'KAS 26% GEPRILLT LOSE' },
            { 'vendorProductId': '9026046', 'name': 'NPK(S) 12:8:15 BIG BAG' },
            { 'vendorProductId': '9026047', 'name': 'NPK 14:7:17+2+9 BB 1000KG ENTEC PERFEKT' },
            { 'vendorProductId': '9032090', 'name': 'HYPERKALK P16 BIG BAG' },
            { 'vendorProductId': '9033845', 'name': 'NPK 5:10:30 50KG' },
            { 'vendorProductId': '9033846', 'name': 'NPK 5:10:30 BIG BAG' },
            { 'vendorProductId': '9034385', 'name': 'NPK 20:10:10 LOSE' },
            { 'vendorProductId': '9034569', 'name': 'PK 15:30 50KG' },
            { 'vendorProductId': '9035260', 'name': 'ENTEC 26+13 BIG BAG 1.000 KG' },
            { 'vendorProductId': '9038901', 'name': 'NPK 8:24:24 LOSE' },
            { 'vendorProductId': '9039167', 'name': 'DIALIT DIABASMEHL 40KG' },
            { 'vendorProductId': '9039505', 'name': 'NPK 12:7:18 BIG BAG ENTEC VINO' },
            { 'vendorProductId': '9041837', 'name': 'DASAMAG 24%N+10S+MgO LOSE' },
            { 'vendorProductId': '9041838', 'name': 'DASAMAG 24%N+10%S+6%MgO BIG BAG 1.000 KG' },
            { 'vendorProductId': '9042561', 'name': 'PK 0:9:30 LOSE' },
            { 'vendorProductId': '9045549', 'name': 'NPK 8:20:30 LOSE' },
            { 'vendorProductId': '9045550', 'name': 'NPK 8:20:30 50 KG' },
            { 'vendorProductId': '9045574', 'name': 'NPK 8:20:30 BIG BAG' },
            { 'vendorProductId': '9046362', 'name': 'NPK 7:10:32 LOSE' },
            { 'vendorProductId': '9046364', 'name': 'NPK 7:10:32 40KG' },
            { 'vendorProductId': '9046366', 'name': 'NPK 7:10:32 BIG BAG' },
            { 'vendorProductId': '9047303', 'name': 'HYDRO N-TESTER' },
            { 'vendorProductId': '9047460', 'name': 'EUROFERTIL PLUS NPS49 LOSE' },
            { 'vendorProductId': '9047461', 'name': 'EUROFERTIL PLUS NPS49 GESACKT' },
            { 'vendorProductId': '9047463', 'name': 'EUROFERTIL PLUS NPS49 BIG BAG' },
            { 'vendorProductId': '9048316', 'name': 'NPK 20:10:10 50KG' },
            { 'vendorProductId': '9048317', 'name': 'NPK 15:15:15 25KG' },
            { 'vendorProductId': '9050082', 'name': 'CASULF lose' },
            { 'vendorProductId': '9050083', 'name': 'CASULF GESACKT 40 KG' },
            { 'vendorProductId': '9050084', 'name': 'NATURGIPS-MEHL LOSE' },
            { 'vendorProductId': '9050085', 'name': 'NATURGIPS-MEHL GESACKT 25 KG' },
            { 'vendorProductId': '9050086', 'name': 'MIKALYT 60/2 LOSE' },
            { 'vendorProductId': '9050087', 'name': 'SCHWEFELKALK LOSE' },
            { 'vendorProductId': '9050354', 'name': 'TRIPLEPHOSPHAT 46% BIG BAG 600 KG' },
            { 'vendorProductId': '9050431', 'name': 'NPK 20:10:10 30KG' },
            { 'vendorProductId': '9052279', 'name': 'AMMOPHOS 10:46 50 KG' },
            { 'vendorProductId': '9052735', 'name': 'NPK 16:12:14 GESACKT' },
            { 'vendorProductId': '9052784', 'name': 'NPK 16:12:16 50KG' },
            { 'vendorProductId': '9053201', 'name': 'NPK 16:14:16 BIG BAG 500/1' },
            { 'vendorProductId': '9054221', 'name': 'NPK 8:8:8 LOSE' },
            { 'vendorProductId': '9055892', 'name': 'EUROFERTIL 34 N-PRO LOSE' },
            { 'vendorProductId': '9055893', 'name': 'EUROFERTIL 34 N-PRO GESACKT' },
            { 'vendorProductId': '9055894', 'name': 'EUROFERTIL 34 N-PRO BIG BAG' },
            { 'vendorProductId': '9056466', 'name': 'PK 9/30 50 KG' },
            { 'vendorProductId': '9056475', 'name': 'PK 9/30 BIG BAG' },
            { 'vendorProductId': '9061477', 'name': 'NPK 10:08:20 BIG BAG DC ROT' },
            { 'vendorProductId': '9063371', 'name': 'KALKKORN S 2-6 MM LOSE' },
            { 'vendorProductId': '9063372', 'name': 'KALKKORN S 40 KG' },
            { 'vendorProductId': '9063373', 'name': 'KALKKORN S 2-6 MM BIG BAG 1.000 KG' },
            { 'vendorProductId': '9063484', 'name': 'SULFAMMO NPRO 21P LOSE' },
            { 'vendorProductId': '9063496', 'name': 'SULFAMMO NPRO 21P GESACKT' },
            { 'vendorProductId': '9063529', 'name': 'SULFAMMO NPRO 21P BIG BAG' },
            { 'vendorProductId': '9064859', 'name': 'NP 18:46:0 BIG BAG DAP' },
            { 'vendorProductId': '9064951', 'name': 'KAS 26% GEPR BIG BAG' },
            { 'vendorProductId': '9065291', 'name': 'NPK 8:14:16 EUROFERTIL 38 PLUS LOSE' },
            { 'vendorProductId': '9065292', 'name': 'NPK 8:14:16 EUROFERTIL 38 PLUS GESACKT' },
            { 'vendorProductId': '9065294', 'name': 'NPK 8:14:16 EUROFERTIL 38 PLUS BIG BAG' },
            { 'vendorProductId': '9065722', 'name': 'KAS 26% GEPR 50KG' },
            { 'vendorProductId': '9068092', 'name': 'HARNSTOFF 46% GEPR 25KG' },
            { 'vendorProductId': '9068625', 'name': 'Ammophos 10:46 lose' },
            { 'vendorProductId': '9069375', 'name': 'Ammophos 10:46 Big Bag' },
            { 'vendorProductId': '9069424', 'name': 'NP 20:20 BIG BAG' },
            { 'vendorProductId': '9069426', 'name': 'NP 20:20 50 KG' },
            { 'vendorProductId': '9074355', 'name': 'DOLOSOL PELETT 25KG' },
            { 'vendorProductId': '9077029', 'name': 'KALKSALPETER 25KG Spritzqualität' },
            { 'vendorProductId': '9077030', 'name': 'NPK 15:15:15 BIG BAG' },
            { 'vendorProductId': '9077131', 'name': 'NPK 16:16:16 BIG BAG 500 KG' },
            { 'vendorProductId': '9077549', 'name': 'PK 20:30 LOSE' },
            { 'vendorProductId': '9077550', 'name': 'PK 30:15 LOSE' },
            { 'vendorProductId': '9077551', 'name': 'PK 30:15 50KG' },
            { 'vendorProductId': '9080624', 'name': 'NPK 24:8:7 LOSE ENTEC' },
            { 'vendorProductId': '9080625', 'name': 'NPK 24:8:7 50 KG ENTEC' },
            { 'vendorProductId': '9080626', 'name': 'NP 25:15:0 LOSE ENTEC' },
            { 'vendorProductId': '9080627', 'name': 'NP 25:15:0 50 KG ENTEC' },
            { 'vendorProductId': '9080628', 'name': 'NPK 12:12:17+2+8 LOSE ENTEC SPEZIAL' },
            { 'vendorProductId': '9080629', 'name': 'NPK 12:12:17+2+8 50 KG ENTEC SPEZIAL' },
            { 'vendorProductId': '9080630', 'name': 'NPK 12:7:16+4+5 LOSE ENTEC AVANT S/CL' },
            { 'vendorProductId': '9080631', 'name': 'NPK 12:7:16+4+5 50 KG ENTEC AVANT S/CL' },
            { 'vendorProductId': '9080633', 'name': 'NPK 12:12:17+2+8 LOSE NITROPH. SPECIAL' },
            { 'vendorProductId': '9080648', 'name': 'NPK 12:10:20+2+9 LOSE NITROPHOSKA EXTRA' },
            { 'vendorProductId': '9080649', 'name': 'NPK 12:10:20+2+9 50 KG NITROPHOSKA EXTRA' },
            { 'vendorProductId': '9080651', 'name': 'NPK 12:8:16+3+10 25 KG BLAUKORN CLASSIC' },
            { 'vendorProductId': '9080664', 'name': 'NPK 12:8:16+3+10 50 KG BLAUKORN CLASSIC' },
            { 'vendorProductId': '9080665', 'name': 'NPK 15:3:20+3+10 25 KG BLAUKORN PREMIUM' },
            { 'vendorProductId': '9080669', 'name': 'NPK 15:3:20+3+10 50 KG BLAUKORN PREMIUM' },
            { 'vendorProductId': '9080670', 'name': 'NPK 21:5:10+3+6 25 KG BLAUKORN SUPREM' },
            { 'vendorProductId': '9080672', 'name': 'NPK 21:5:10+3+6 50 KG BLAUKORN SUPREM' },
            { 'vendorProductId': '9080703', 'name': 'NPK 12:8:16+3+10 25 KG NOVA TEC CLASSIC' },
            { 'vendorProductId': '9080704', 'name': 'NPK 12:8:16+3+10 50 KG NOVA TEC CLASSIC' },
            { 'vendorProductId': '9080705', 'name': 'NPK 15:3:20+3+10 25 KG NOVA TEC PREMIUM' },
            { 'vendorProductId': '9080707', 'name': 'NPK 15:3:20+3+10 50 KG NOVA TEC PREMIUM' },
            { 'vendorProductId': '9080708', 'name': 'NPK 21:5:10+3+6 25 KG NOVA TEC SUPREM' },
            { 'vendorProductId': '9080709', 'name': 'NPK 21:5:10+3+6 50 KG NOVA TEC SUPREM' },
            { 'vendorProductId': '9080710', 'name': 'NPK 24:5:5+2+5 25 KG NOVA TEC N-MAX' },
            { 'vendorProductId': '9080712', 'name': 'NPK 24:5:5+2+5 50 KG NOVA TEC N-MAX' },
            { 'vendorProductId': '9087981', 'name': 'NP 26:10:0 LOSE' },
            { 'vendorProductId': '9087983', 'name': 'NP 26:10:0 50KG' },
            { 'vendorProductId': '9088431', 'name': 'MEERKALK GRAN. BIG BAG 600 KG' },
            { 'vendorProductId': '9088432', 'name': 'MEERKALK GRAN. GESACKT 40 KG' },
            { 'vendorProductId': '9091919', 'name': 'PK 0:14:28 BIG BAG' },
            { 'vendorProductId': '9093192', 'name': 'NPK 20:10:10 BIG BAG' },
            { 'vendorProductId': '9093431', 'name': 'NPK 8:24:24 BIG BAG' },
            { 'vendorProductId': '9095443', 'name': 'NPK 15:5:5 BIG BAG' },
            { 'vendorProductId': '9095509', 'name': 'NPK 5:8:12 EUROFERTIL 35 PLUS LOSE' },
            { 'vendorProductId': '9095510', 'name': 'NPK 5:8:12 EUROFERTIL 35 PLUS GESACKT' },
            { 'vendorProductId': '9095511', 'name': 'NPK 5:8:12 EUROFERTIL 35 PLUS BIG BAG' },
            { 'vendorProductId': '9096779', 'name': 'NPK 20:14:7 BIG BAG' },
            { 'vendorProductId': '9097901', 'name': 'NPK 6:12:24 BIG BAG 600 KG' },
            { 'vendorProductId': '9098217', 'name': 'NPK 6:12:18 50KG' },
            { 'vendorProductId': '9098570', 'name': 'SSP 18 % gran. lose' },
            { 'vendorProductId': '9101380', 'name': 'N 26% + 44% SO3 25 KG' },
            { 'vendorProductId': '9101381', 'name': 'N 26% + 44% SO3 Big Bag' },
            { 'vendorProductId': '9101384', 'name': 'NPK 12:6:18 25KG' },
            { 'vendorProductId': '9101385', 'name': 'NPK 8:16:20 25KG' },
            { 'vendorProductId': '9102830', 'name': 'NPK 5:7:30+MgO 50KG' },
            { 'vendorProductId': '9102831', 'name': 'GÜLLEKALK LOSE' },
            { 'vendorProductId': '9103068', 'name': 'NP 10:25 BIG BAG' },
            { 'vendorProductId': '9103069', 'name': 'NPK 8:16:20 BIG BAG 600 KG' },
            { 'vendorProductId': '9103070', 'name': 'PK 20:30 50 KG' },
            { 'vendorProductId': '9103259', 'name': 'KORNKALI 40/6 Big Bag 1.000 kg' },
            { 'vendorProductId': '9103387', 'name': 'AMMONSULFAT 21% BIG BAGGROB KRISTALLIN' },
            { 'vendorProductId': '9103658', 'name': 'NPK 15:5:20+2+8 BB 1000NITROPH. PERFECT' },
            { 'vendorProductId': '9106694', 'name': 'DIALIT DIABASMEHL BIG BAG 1000 KG' },
            { 'vendorProductId': '9107590', 'name': 'BIOFERT BIG BAG' },
            { 'vendorProductId': '9107911', 'name': 'NPK 5:15:30 BIG BAG 600 KG' },
            { 'vendorProductId': '9107981', 'name': 'NPK 15:15:15 40 KG' },
            { 'vendorProductId': '9114961', 'name': 'NPK 5:19:10 EF TOP 34 LOSE' },
            { 'vendorProductId': '9114962', 'name': 'NPK 5:19:10 EF TOP 34 GESACKT' },
            { 'vendorProductId': '9114963', 'name': 'NPK 5:19:10 EF TOP 34 BIG BAG' },
            { 'vendorProductId': '9114965', 'name': 'NPK 8:8:17 EUROFERTIL 33 N-PRO LOSE' },
            { 'vendorProductId': '9114967', 'name': 'NPK 8:8:17 EUROFERTIL 33 N-PRO GESACKT' },
            { 'vendorProductId': '9114968', 'name': 'NPK 8:8:17 EUROFERTIL 33 N-PRO BIG BAG' },
            { 'vendorProductId': '9115599', 'name': 'NPK 15:5:20 LOSE ENTEC VINO NEU' },
            { 'vendorProductId': '9115602', 'name': 'NPK 15:5:20 50KG ENTEC VINO NEU' },
            { 'vendorProductId': '9117037', 'name': 'ASS 25N+12S LOSE Ammonsulfatsalp.' },
            { 'vendorProductId': '9117038', 'name': 'ASS 25N+12S 50 KG Ammonsulfatsalp.' },
            { 'vendorProductId': '9117039', 'name': 'ASS 25N+12S BIG BAG Ammonsulfatsalp.' },
            { 'vendorProductId': '9119693', 'name': 'MEERKALK + P BIG BAG 600 KG' },
            { 'vendorProductId': '9119694', 'name': 'MEERKALK + P GESACKT 40 KG' },
            { 'vendorProductId': '9121141', 'name': 'NPK 12:12:17+2MgO 25 kg' },
            { 'vendorProductId': '9121143', 'name': 'NPK 6:12:22 BTC 25 KG' },
            { 'vendorProductId': '9121145', 'name': 'NPK 5:15:30 25 KG' },
            { 'vendorProductId': '9121146', 'name': 'NPK 8:24:24 25 KG' },
            { 'vendorProductId': '9121147', 'name': 'NPK 8:24:20 BTC 25 KG' },
            { 'vendorProductId': '9121611', 'name': 'amber HAS 26 (N20%+S6%)' },
            { 'vendorProductId': '9122113', 'name': 'NP 10:25 25 KG' },
            { 'vendorProductId': '9122171', 'name': 'BRANNTKALK GEK 3-8 MM 25 KG' },
            { 'vendorProductId': '9122203', 'name': 'NPK 7:20:28 40KG' },
            { 'vendorProductId': '9123354', 'name': 'KOHLENSAURER KALK LOSE MIT SPRITZKORN' },
            { 'vendorProductId': '9123575', 'name': 'NPK 15:5:20 Big Bag ENTEC VINO NEU' },
            { 'vendorProductId': '9123648', 'name': 'NPK 20:10:10 25KG' },
            { 'vendorProductId': '9123649', 'name': 'NPK 6:12:22 BTC 600 kg Big Bag' },
            { 'vendorProductId': '9123650', 'name': 'NPK 7:14:21 25 KG' },
            { 'vendorProductId': '9123684', 'name': 'NPK 16:5:7 + 10S LOSE' },
            { 'vendorProductId': '9123687', 'name': 'NPK 16:5:7 + 10S 50KG' },
            { 'vendorProductId': '9123688', 'name': 'NPK 16:5:7 +10S BIG BAG' },
            { 'vendorProductId': '9124140', 'name': 'PK 0:20:20 BIGBAG' },
            { 'vendorProductId': '9125258', 'name': 'PK 0:10:30 LOSE' },
            { 'vendorProductId': '9125259', 'name': 'PK 0:10:30 BIG BAG' },
            { 'vendorProductId': '9125457', 'name': 'NP 5:25 25 KG' },
            { 'vendorProductId': '9126206', 'name': 'NPK 7:20:28 BIG BAG' },
            { 'vendorProductId': '9126449', 'name': 'NPK 11:22:16 BIG BAG' },
            { 'vendorProductId': '9132600', 'name': 'NPK 20:6:11 LOSE' },
            { 'vendorProductId': '9138776', 'name': 'NPK 20:6:11 BIG BAG 1.000 KG' },
            { 'vendorProductId': '9138802', 'name': 'NPK 20:10:10 40KG' },
            { 'vendorProductId': '9143737', 'name': 'KALISULFAT 50% FEIN 25KG t' },
            { 'vendorProductId': '9144029', 'name': 'AMMONSULFAT 21N+24S GRAN. BIG BAG 500 KG' },
            { 'vendorProductId': '9144170', 'name': 'AHL 28% LOSE' },
            { 'vendorProductId': '9145513', 'name': 'GÜLLEKALK BIG BAG 1.000 kg' },
            { 'vendorProductId': '9145561', 'name': 'KALI 60% FEIN BIG BAG' },
            { 'vendorProductId': '9146639', 'name': 'NPK 12:12:17 BTC 600 kg BIG BAG' },
            { 'vendorProductId': '9150726', 'name': 'NPK 8:16:24 BIG BAG 600 KG' },
            { 'vendorProductId': '9151026', 'name': 'EUROFERTIL PLUS NPS53 LOSE' },
            { 'vendorProductId': '9151027', 'name': 'EUROFERTIL PLUS NPS53 GESACKT' },
            { 'vendorProductId': '9151028', 'name': 'EUROFERTIL PLUS NPS53 BIG BAG' },
            { 'vendorProductId': '9151105', 'name': 'SAN 33 % 50 KG' },
            { 'vendorProductId': '9155237', 'name': 'MEERKALK OHNE MG BIG BAG 600 KG' },
            { 'vendorProductId': '9155238', 'name': 'MEERKALK OHNE MG GESACKT 40 KG' },
            { 'vendorProductId': '9156714', 'name': 'PK 20:30 BIG BAG' },
            { 'vendorProductId': '9156734', 'name': 'NP 25:15:0 ENTEC BIG BAG 1.000 KG' },
            { 'vendorProductId': '9157852', 'name': 'PIAMON 33 S BIG BAG 1000 KG' },
            { 'vendorProductId': '9159721', 'name': 'SAN 33 % BIG BAG' },
            { 'vendorProductId': '9159722', 'name': 'NPK 8:16:24 25 KG' },
            { 'vendorProductId': '9160795', 'name': 'KAS 27% GRAN BIG BAG 600 KG' },
            { 'vendorProductId': '9160796', 'name': 'KAS 27% GRAN BB 1000 KG' },
            { 'vendorProductId': '9160798', 'name': 'HARNSTOFF 46% GEPR BIG BAG 600 KG' },
            { 'vendorProductId': '9160799', 'name': 'HARNSTOFF 46% GEPR BIG BAG 1.000 KG' },
            { 'vendorProductId': '9160800', 'name': 'HARNSTOFF 46% GRAN BIG BAG 600 KG' },
            { 'vendorProductId': '9160801', 'name': 'HARNSTOFF 46% GRAN BIG BAG 1.000 KG' },
            { 'vendorProductId': '9160894', 'name': 'NP 18:46:0 DAP BIG BAG 600 KG' },
            { 'vendorProductId': '9160895', 'name': 'NP 18:46:0 BIG BAG DAP 1.000 KG' },
            { 'vendorProductId': '9160896', 'name': 'KAS 27% GRAN BIG BAG 700 KG' },
            { 'vendorProductId': '9160897', 'name': 'HARNSTOFF 46% GEPR BIG BAG 500 KG' },
            { 'vendorProductId': '9160898', 'name': 'TRIPLEPHOSPHAT 46% BIG BAG 1.000 KG' },
            { 'vendorProductId': '9160950', 'name': 'KALKSALPETER 25KG Streuqualität' },
            { 'vendorProductId': '9161403', 'name': 'NPK 8:24:24 50 KG' },
            { 'vendorProductId': '9161703', 'name': 'NP 25:15:0 ENTEC BIG BAG 600 KG' },
            { 'vendorProductId': '9163829', 'name': 'UREAstabil 46% geprilltBIG BAG 1.000 KG' },
            { 'vendorProductId': '9169035', 'name': 'NPK 12:12:17+2+8 BIGBAGNITROPH. SPECIAL' },
            { 'vendorProductId': '9173782', 'name': 'NPK 18:11:11 LOSE VARIO' },
            { 'vendorProductId': '9173783', 'name': 'NPK 18:11:11 BIG BAG VARIO' },
            { 'vendorProductId': '9173784', 'name': 'NPK 22:5:5 LOSE VARIO' },
            { 'vendorProductId': '9173785', 'name': 'NPK 22:5:5 BIG BAG VARIO' },
            { 'vendorProductId': '9173786', 'name': 'NPK 21:7:7 LOSE LINZER VARIO' },
            { 'vendorProductId': '9173788', 'name': 'NPK 21:7:7 BIG BAG VARIO' },
            { 'vendorProductId': '9174224', 'name': 'PK 0:12:20 GRAN BIG BAGDC 45 NEU' },
            { 'vendorProductId': '9174368', 'name': 'HARNSTOFF 46% GEPR BIG BAG 800 KG' },
            { 'vendorProductId': '9174369', 'name': 'KIESERIT GRANULIERT BIG BAG 1.000 KG' },
            { 'vendorProductId': '9174918', 'name': 'NPK 17:6:11 BIG BAG 500 KG' },
            { 'vendorProductId': '9174919', 'name': 'NPK 18:8:8 BIG BAG 500 KG' },
            { 'vendorProductId': '9175514', 'name': 'NP 20:20 LOSE' },
            { 'vendorProductId': '9176471', 'name': 'NPK 12:12:17 LOSE COMPLEX' },
            { 'vendorProductId': '9176472', 'name': 'NPK 12:12:17 50KG COMPLEX' },
            { 'vendorProductId': '9176474', 'name': 'NPK 12:12:17 BIG BAG COMPLEX' },
            { 'vendorProductId': '9176475', 'name': 'NPK 14:10:20 LOSE COMPLEX' },
            { 'vendorProductId': '9176476', 'name': 'NPK 14:10:20 50 KG COMPLEX' },
            { 'vendorProductId': '9176477', 'name': 'NPK 14:10:20 BIG BAG COMPLEX' },
            { 'vendorProductId': '9176478', 'name': 'NPK 15:15:15 LOSE COMPLEX' },
            { 'vendorProductId': '9176479', 'name': 'NPK 15:15:15 50KG COMPLEX' },
            { 'vendorProductId': '9176480', 'name': 'NPK 15:15:15 BIG BAG COMPLEX' },
            { 'vendorProductId': '9176481', 'name': 'NPK 15:5:18 LOSE COMPLEX' },
            { 'vendorProductId': '9176482', 'name': 'NPK 15:5:18 50 KG COMPLEX' },
            { 'vendorProductId': '9176483', 'name': 'NPK 15:5:18 BIG BAG COMPLEX' },
            { 'vendorProductId': '9176615', 'name': 'NPK 16:10:10 LOSE COMPLEX' },
            { 'vendorProductId': '9176616', 'name': 'NPK 16:10:10 50KG COMPLEX' },
            { 'vendorProductId': '9176617', 'name': 'NPK 16:10:10 BIG BAG COMPLEX' },
            { 'vendorProductId': '9176618', 'name': 'NP 18:25:0 LOSE COMPLEX' },
            { 'vendorProductId': '9176619', 'name': 'NP 18:25:0 50KG COMPLEX' },
            { 'vendorProductId': '9176620', 'name': 'NP 18:25:0 BIG BAG COMPLEX' },
            { 'vendorProductId': '9176622', 'name': 'NPK 20:8:8 LOSE COMPLEX' },
            { 'vendorProductId': '9176623', 'name': 'NPK 20:8:8 50KG COMPLEX' },
            { 'vendorProductId': '9176624', 'name': 'NPK 20:8:8 BIG BAG COMPLEX' },
            { 'vendorProductId': '9176625', 'name': 'NP 24:14:0 LOSE COMPLEX' },
            { 'vendorProductId': '9176626', 'name': 'NP 24:14:0 50KG COMPLEX' },
            { 'vendorProductId': '9176627', 'name': 'NP 24:14:0 BIG BAG COMPLEX' },
            { 'vendorProductId': '9176628', 'name': 'KAS 27% GRAN LOSE NAC 27 N' },
            { 'vendorProductId': '9176629', 'name': 'KAS 27% GRAN 50KG NAC 27 N' },
            { 'vendorProductId': '9176630', 'name': 'KAS 27% GRAN BB 600KG LINZER NAC' },
            { 'vendorProductId': '9176632', 'name': '23 N + 10 S LOSE VARIO' },
            { 'vendorProductId': '9176633', 'name': '23 N + 10 S 50KG VARIO' },
            { 'vendorProductId': '9176634', 'name': '23 N + 10 S BIG BAG VARIO' },
            { 'vendorProductId': '9176675', 'name': 'HARNSTOFF 46% GEPR LOSEUREA 46 N' },
            { 'vendorProductId': '9176677', 'name': 'HARNSTOFF 46% GEPR 50KGUREA 46 N' },
            { 'vendorProductId': '9176678', 'name': 'HARNSTOFF 46% GEPR BIG BAG UREA 46 N' },
            { 'vendorProductId': '9176679', 'name': 'NPK 21:7:7 LOSE VARIO' },
            { 'vendorProductId': '9176718', 'name': 'NP 20:20:0 LOSE COMPLEX' },
            { 'vendorProductId': '9176719', 'name': 'NP 20:20:0 50KG COMPLEX' },
            { 'vendorProductId': '9176720', 'name': 'NP 20:20:0 BIG BAG COMPLEX' },
            { 'vendorProductId': '9177006', 'name': 'BIOLIT FEIN plus BIG BAG 500 KG' },
            { 'vendorProductId': '9177066', 'name': 'NPK 12:6:18 BIG BAG 500 KG' },
            { 'vendorProductId': '9178676', 'name': 'NPK 18:8:8 50 KG' },
            { 'vendorProductId': '9178929', 'name': 'KOHLENS KALK FEUCHT+S LOSE' },
            { 'vendorProductId': '9178931', 'name': 'KOHLENS KALK MG FEUCHT +S LOSE' },
            { 'vendorProductId': '9178942', 'name': 'KALISULFAT 50% GRAN. LOSE GranuPotasse' },
            { 'vendorProductId': '9178943', 'name': 'KALISULFAT 50% GRAN. BIG BAG GranuPota' },
            { 'vendorProductId': '9179060', 'name': 'EUROFERTIL 32 N-PRO (NP16/16/0)BIGBAG' },
            { 'vendorProductId': '9179061', 'name': 'EUROFERTIL 32 N-PRO (NP 16/16/0) lose' },
            { 'vendorProductId': '9179062', 'name': 'EUROFERTIL 32 N-PRO (NP 16/16/0) ges.' },
            { 'vendorProductId': '9179937', 'name': 'DOMOGRAN 45 (21%N+24%S)BIG BAG 1.000 KG' },
            { 'vendorProductId': '9181835', 'name': 'DOLOPHOS 15 BIG BAG 1.000 KG' },
            { 'vendorProductId': '9181836', 'name': 'DOLOPHOS 26 BIG BAG 1.000 KG' },
            { 'vendorProductId': '9181837', 'name': 'MAKAPHOS 5 % LOSE' },
            { 'vendorProductId': '9181838', 'name': 'MAKAPHOS 5 % BIG BAG' },
            { 'vendorProductId': '9181839', 'name': 'MAKAPHOS 10 % LOSE' },
            { 'vendorProductId': '9181840', 'name': 'MAKAPHOS 10 % BIG BAG' },
            { 'vendorProductId': '9181842', 'name': 'MAKAPHOS 15 % LOSE' },
            { 'vendorProductId': '9181843', 'name': 'MAKAPHOS 15 % BIG BAG' },
            { 'vendorProductId': '9181844', 'name': 'PATENTKALI 30% GRAN BIG BAG 600 KG' },
            { 'vendorProductId': '9181845', 'name': 'MAGNESIA KAINIT BIG BAG' },
            { 'vendorProductId': '9181846', 'name': 'KOHLENS KALK BIG BAG 1000 KG' },
            { 'vendorProductId': '9181847', 'name': 'KOHLENS KALK MG BIG BAG 1000 KG' },
            { 'vendorProductId': '9181848', 'name': 'DOLOKORN BIG BAG 1.000 KG' },
            { 'vendorProductId': '9181849', 'name': 'GRAUKALK BIG BAG 1000 KG' },
            { 'vendorProductId': '9181850', 'name': 'BASALIT BIG BAG' },
            { 'vendorProductId': '9181851', 'name': 'BASADIADOL 40 KG' },
            { 'vendorProductId': '9181852', 'name': 'BASADIADOL BIG BAG' },
            { 'vendorProductId': '9181920', 'name': 'NPK 8:24:8 +9S +0,5ZN LOSE' },
            { 'vendorProductId': '9181921', 'name': 'NPK 8:24:8 +9S +0,5ZN BIG BAG' },
            { 'vendorProductId': '9181924', 'name': 'UREAstabil 46% geprilltLOSE' },
            { 'vendorProductId': '9181926', 'name': 'UREAstabil 46% geprilltBIG BAG 500 KG' },
            { 'vendorProductId': '9181927', 'name': 'UREAstabil 46% gran. LOSE' },
            { 'vendorProductId': '9181928', 'name': 'UREAstabil 46% gran. BIG BAG 1.000 KG' },
            { 'vendorProductId': '9181929', 'name': 'UREAstabil 46% gran. BIG BAG 500 KG' },
            { 'vendorProductId': '9183120', 'name': 'NPK 6:8:16 BTC 25 KG' },
            { 'vendorProductId': '9183775', 'name': 'HARNSTOFF 46% GRAN BIG BAG 500 KG' },
            { 'vendorProductId': '9183776', 'name': 'KALKSTEINSPLITT LOSE GROB 2-4 mm' },
            { 'vendorProductId': '9185279', 'name': 'BRANNTKALK GEK 3-8 MM BIG BAG 1.000 KG' },
            { 'vendorProductId': '9185280', 'name': 'AMMONSULFAT 21%N+24%S GRANULIERT 50 KG' },
            { 'vendorProductId': '9187412', 'name': 'NP 8:38:0+Me+5% 25 KG MIKROGRANULAT' },
            { 'vendorProductId': '9188102', 'name': 'NP 8:41:0+Me 25 KG MIKROGRANULAT' },
            { 'vendorProductId': '9189573', 'name': 'MAGNESIUMMEHL LOSE' },
            { 'vendorProductId': '9189574', 'name': 'ÖKOPHOS PLUS LOSE' },
            { 'vendorProductId': '9189575', 'name': 'ÖKOPHOS PLUS BIG BAG 1.000 KG' },
            { 'vendorProductId': '9190083', 'name': 'PK 15:30 LOSE' },
            { 'vendorProductId': '9190487', 'name': 'NPK 15:5:20+2+8 50KG ENTEC PERFECT-NEU' },
            { 'vendorProductId': '9195972', 'name': 'PK 0:10:24 GRAN LOSE' },
            { 'vendorProductId': '9197397', 'name': 'SULFAN 24 (+6%) LOSE' },
            { 'vendorProductId': '9200808', 'name': 'KORNKALI 40/6 Big Bag 600 KG' },
            { 'vendorProductId': '9201789', 'name': 'SULFAN 24 (+6%) BIG BAG 600 KG' },
            { 'vendorProductId': '9201790', 'name': 'SULFAN 24 (+6%) BIG BAG 1.000 KG' },
            { 'vendorProductId': '9203121', 'name': 'DEKAMIX BIG BAG 1.000 KG' },
            { 'vendorProductId': '9206048', 'name': 'ALZON 46 LOSE' },
            { 'vendorProductId': '9206049', 'name': 'ALZON 46 BIG BAG 1.000 KG' },
            { 'vendorProductId': '9206351', 'name': 'NPK 7:20:30 BIG BAG 600 KG' },
            { 'vendorProductId': '9206779', 'name': 'NP 16:20+S+B BIG BAG 500 KG' },
            { 'vendorProductId': '9207068', 'name': 'NPK 7:14:21 BIG BAG 600 KG' },
            { 'vendorProductId': '9207714', 'name': 'ALZON 46 BIG BAG 500 KG' },
            { 'vendorProductId': '9207731', 'name': 'NPK 5:15:25+2S BIG BAG 500 KG' },
            { 'vendorProductId': '9207855', 'name': 'NPK 10:20:20 BIG BAG 500 KG' },
            { 'vendorProductId': '9208609', 'name': 'NPK 12:11:22 +7S BIG BAG 500 KG' },
            { 'vendorProductId': '9208966', 'name': 'NPK 8:15:30+S BIG BAG 500 KG' },
            { 'vendorProductId': '9209598', 'name': 'KAS 27% GRAN 40KG' },
            { 'vendorProductId': '9210102', 'name': 'PK 25:25 BIG BAG' },
            { 'vendorProductId': '9210103', 'name': 'PK 25:25 LOSE' },
            { 'vendorProductId': '9210643', 'name': 'NP 20:20 25 KG' },
            { 'vendorProductId': '9210645', 'name': 'NPK 15:15:15 50KG MIXED' },
            { 'vendorProductId': '9211807', 'name': 'NP 10:30 BIG BAG 600 KG' },
            { 'vendorProductId': '9212743', 'name': 'NPK 15:15:15 BIG BAG 600 KG' },
            { 'vendorProductId': '9212744', 'name': 'NPK 15:15:15 BIG BAG 1.000 KG' },
            { 'vendorProductId': '9221859', 'name': 'NPK 20:7:7 LOSE VARIO' },
            { 'vendorProductId': '9221860', 'name': 'NPK 20:7:7 BIG BAG VARIO' },
            { 'vendorProductId': '9222270', 'name': 'SULFAN 24 (+6%) 40 KG' },
            { 'vendorProductId': '9222586', 'name': 'NPK 20:6:11 BIG BAG 600 KG' },
            { 'vendorProductId': '9222810', 'name': 'NPK 15:10:10 +13S BIG BAG' },
            { 'vendorProductId': '9223370', 'name': 'NPK 8:20:20 BIG BAG 500 KG' },
            { 'vendorProductId': '9225389', 'name': 'PK 0:10:30 BIG BAG 600 KG DC 44' },
            { 'vendorProductId': '9225589', 'name': 'NPK 9:25:25 BIG BAG' },
            { 'vendorProductId': '9226239', 'name': 'NP 26:10:0 LOSE COMPLEX' },
            { 'vendorProductId': '9226250', 'name': 'NP 26:10:0 50KG COMPLEX' },
            { 'vendorProductId': '9226251', 'name': 'NP 26:10:0 BIG BAG COMPLEX' },
            { 'vendorProductId': '9227579', 'name': 'PK 0:10:30 50 KG' },
            { 'vendorProductId': '9230962', 'name': 'NPK 5:14:14 50 KG' },
            { 'vendorProductId': '9230963', 'name': 'INNOFERT HOPFEN 15 % N FLÜSSIG' },
            { 'vendorProductId': '9231458', 'name': 'TRIPLESUPERPHOSPHAT 46% BIG BAG 500 KG' },
            { 'vendorProductId': '9231939', 'name': 'NPK 12:24:12 BIG BAG 500 KG' },
            { 'vendorProductId': '9232135', 'name': 'NP 20:10 N-GOOO 25 KG' },
            { 'vendorProductId': '9232355', 'name': 'NP 20:10 N-GOOO BIG BAG 600 KG' },
            { 'vendorProductId': '9232431', 'name': 'SULFAN 24/18 BIG BAG 500 KG' },
            { 'vendorProductId': '9232433', 'name': 'KAS + S 25 KG' },
            { 'vendorProductId': '9232434', 'name': 'KAS + S BIG BAG' },
            { 'vendorProductId': '9240864', 'name': 'NPK 20:6:11 50 KG' },
            { 'vendorProductId': '9242220', 'name': 'ENSIN 26+13 LOSE' },
            { 'vendorProductId': '9248733', 'name': 'ALZON 46 25 KG' },
            { 'vendorProductId': '9251897', 'name': 'NP 11:52:0 LOSE MAP' },
            { 'vendorProductId': '9251898', 'name': 'NP 11:52:0 Big Bag MAP' },
            { 'vendorProductId': '9251899', 'name': 'NP 11:52:0 50KG MAP' },
            { 'vendorProductId': '9253590', 'name': 'BRANNTKALK FEIN GEMAH- LEN BB 1000 KG' },
            { 'vendorProductId': '9254536', 'name': 'NPK 7:20:30 BIG BAG 500 KG' },
            { 'vendorProductId': '9254537', 'name': 'NPK 7:20:30 LOSE' },
            { 'vendorProductId': '9259723', 'name': 'NP 12:52:0 MAP BIG BAG 1.000 KG' },
            { 'vendorProductId': '9259725', 'name': 'NP 12:52:0 MAP BIG BAG 600 KG' },
            { 'vendorProductId': '9261841', 'name': 'DIABAS SAND MEDIUM 0/2 mm TROCKEN LOSE' },
            { 'vendorProductId': '9262456', 'name': 'BIOSOL PULVER BIG BAG' },
            { 'vendorProductId': '9262629', 'name': 'BRANNTKALK GEK 0-4 MM LOSE' },
            { 'vendorProductId': '9262646', 'name': 'BRANNTKALK GEK 0-4 MM BIG BAG 1.000 KG' },
            { 'vendorProductId': '9263850', 'name': 'NPK 10:20:10 BIG BAG 500 KG' },
            { 'vendorProductId': '9263871', 'name': 'NPK 7:20:14 BIG BAG 600 KG' },
            { 'vendorProductId': '9265337', 'name': 'NPK 13:13:21 BIG BAG' },
            { 'vendorProductId': '9265552', 'name': 'NPK 10:15:15 BIG BAG 600 KG' },
            { 'vendorProductId': '9265989', 'name': 'KALKmeister KM 8000 K LOSE' },
            { 'vendorProductId': '9265990', 'name': 'KALKMEISTER KM 8000 K BIG BAG 1.000 KG' },
            { 'vendorProductId': '9265993', 'name': 'KALKmeister KM 8000 MK LOSE' },
            { 'vendorProductId': '9265994', 'name': 'KALKMEISTER KM 8000 MK BIG BAG 1.000 KG' },
            { 'vendorProductId': '9265996', 'name': 'KALKmeister KM 8000 L LOSE' },
            { 'vendorProductId': '9265997', 'name': 'KALKMEISTER KM 8000 L BIG BAG 1.000 KG' },
            { 'vendorProductId': '9266399', 'name': 'NPK 6:18:34+S BIG BAG 500 KG' },
            { 'vendorProductId': '9268411', 'name': 'NPK 15:15:15 25KG-KUTINA' },
            { 'vendorProductId': '9270325', 'name': 'NPK 7:20:14 25 kg' },
            { 'vendorProductId': '9270329', 'name': 'PK 0:10:24 500 kg BIG BAG' },
            { 'vendorProductId': '9272710', 'name': 'EF PLUS PHOS 38 LOSE' },
            { 'vendorProductId': '9272711', 'name': 'EF PLUS PHOS 38 GESACKT' },
            { 'vendorProductId': '9272712', 'name': 'EF PLUS PHOS 38 BIG BAG' },
            { 'vendorProductId': '9274893', 'name': 'MISCHKALK BIG BAG 1000 KG' },
            { 'vendorProductId': '9274894', 'name': 'MISCHKALK MG BIG BAG' },
            { 'vendorProductId': '9276174', 'name': 'DOMOGRAN 45 (21%N+24%S)GESACKT 50 KG' },
            { 'vendorProductId': '9276656', 'name': 'NPK 13:5:15 BIG BAG' },
            { 'vendorProductId': '9276970', 'name': 'NPK 12:5:15 BIG BAG DC FRUCHT' },
            { 'vendorProductId': '9277971', 'name': 'KALKmeister + Zeo LOSE' },
            { 'vendorProductId': '9277972', 'name': 'KALKmeister + Zeo BIG BAG 1.000 KG' },
            { 'vendorProductId': '9280943', 'name': 'NPK 10:5:15 25KG' },
            { 'vendorProductId': '9284914', 'name': 'NPK 4:24:30 BIG BAG 600 KG' },
            { 'vendorProductId': '9285236', 'name': 'KALKSALPETER BIG BAG SPRITZQUALITÄT' },
            { 'vendorProductId': '9286095', 'name': 'NPK 4:20:30 BIG BAG 600 KG' },
            { 'vendorProductId': '9286096', 'name': 'BRANNTKALK GEK 1-3 MM LOSE' },
            { 'vendorProductId': '9286097', 'name': 'BRANNTKALK GEK 1-3 MM BIG BAG 1.000 KG' },
            { 'vendorProductId': '9286098', 'name': 'BRANNTKALK GEK 1-3 MM 25 KG' },
            { 'vendorProductId': '9286113', 'name': 'ENTEC 26+13 BIG BAG 600 KG' },
            { 'vendorProductId': '9286644', 'name': 'AMOSULFAN 20%N + 24%S BIG BAG' },
            { 'vendorProductId': '9286645', 'name': 'NP 16:20 25 KG' },
            { 'vendorProductId': '9287277', 'name': 'ENERGICO 30%N+35%SO3 BIG BAG' },
            { 'vendorProductId': '9297053', 'name': 'SK-PHOSPHATDÜNG.L.-SUPERPHOSPH19%' },
            { 'vendorProductId': '9300806', 'name': 'KALKmeister 8000 P LOSE' },
            { 'vendorProductId': '9300807', 'name': 'KALKmeister 8000 P BIG BAG 1.000 KG' },
            { 'vendorProductId': '9301531', 'name': 'NPK 14:10:12 25KG' },
            { 'vendorProductId': '9303239', 'name': 'NPK 24:5:5+2+5 BB 600KGNOVA TEC N-MAX' },
            { 'vendorProductId': '9304554', 'name': 'AMMONSULFAT 21%N+24%S GRAN. BIG BAG' },
            { 'vendorProductId': '9304926', 'name': 'STALLKALK MIKROFEIN LOSE' },
            { 'vendorProductId': '9304927', 'name': 'STALLKALK MIKROFEIN BIG BAG 1.000 KG' },
            { 'vendorProductId': '9307091', 'name': 'MEERKALK GRAN. GESACKT 25 KG' },
            { 'vendorProductId': '9307096', 'name': 'MEERKALK OHNE MG GESACKT 25 KG' },
            { 'vendorProductId': '9307187', 'name': 'BRANNTKALK GEK 3-8 MM BIG BAG 500 KG' },
            { 'vendorProductId': '9316269', 'name': 'MIKROSEM (Ersatzteile für Sämaschinen)' },
            { 'vendorProductId': '9318611', 'name': 'UREA S 38N+7S GRAN LOSE' },
            { 'vendorProductId': '9318612', 'name': 'UREA S 38N+7,5S GRAN BIG BAG 600 KG' },
            { 'vendorProductId': '9321263', 'name': 'FERTIL FORTE N20+24%S 25/1 KG' },
            { 'vendorProductId': '9328255', 'name': 'NPK 8:19:29 BIG BAG 500 KG' },
            { 'vendorProductId': '9332727', 'name': 'NPK 7:20:30 50 KG' },
            { 'vendorProductId': '9332732', 'name': 'NPK 15:5:20+2+8 BB 600 NITROPH. PERFECT' },
            { 'vendorProductId': '9333297', 'name': 'KALI 60% GRAN BIG BAG 600 KG K+S' },
            { 'vendorProductId': '9333342', 'name': 'KALI 60% GRAN BIG BAG 500 KG' },
            { 'vendorProductId': '9334236', 'name': 'ENSIN 26+13 BIG BAG 1.000 KG' },
            { 'vendorProductId': '9340413', 'name': 'KALKSTICKSTOFF GROBKÖR.1,7-3,5 MM 50 KG' },
            { 'vendorProductId': '9340414', 'name': 'KALKSTICKSTOFF GROBKÖR.1,7-3,5MM BB600KG' },
            { 'vendorProductId': '9343057', 'name': 'PK 12:24 EUROFERTIL PLUS 36 LOSE' },
            { 'vendorProductId': '9343058', 'name': 'PK 12:24 EUROFERTIL PLUS 36 BB 600 KG' },
            { 'vendorProductId': '9343059', 'name': 'PK 12:24 EUROFERTIL PLUS 36 GESACKT' },
            { 'vendorProductId': '9343061', 'name': 'NP 15:20 EF TOP 35 NP LOSE' },
            { 'vendorProductId': '9343062', 'name': 'NP 15:20 EF TOP 35 NP GESACKT' },
            { 'vendorProductId': '9343063', 'name': 'NP 15:20 EF TOP 35 NP BIG BAG 600 KG' },
            { 'vendorProductId': '9343064', 'name': 'NP 8:30 EF TOP 38 NP LOSE' },
            { 'vendorProductId': '9343065', 'name': 'NP 8:30 EF TOP 38 NP GESACKT' },
            { 'vendorProductId': '9343066', 'name': 'NP 8:30 EF TOP 38 NP BIG BAG 600 KG' },
            { 'vendorProductId': '9343067', 'name': 'NP 3:22 EF TOP 49 NPS LOSE' },
            { 'vendorProductId': '9343068', 'name': 'NP 3:22 EF TOP 49 NPS GESACKT' },
            { 'vendorProductId': '9343069', 'name': 'NP 3:22 EF TOP 49 NPS BIG BAG 600 KG' },
            { 'vendorProductId': '9343070', 'name': 'NP 8:18 EF TOP 53 NPS LOSE' },
            { 'vendorProductId': '9343071', 'name': 'NP 8:18 EF TOP 53 NPS GESACKT' },
            { 'vendorProductId': '9343072', 'name': 'NP 8:18 EF TOP 53 NPS BIG BAG 600 KG' },
            { 'vendorProductId': '9343073', 'name': 'NPK 4:10:20 EF TOP 51 NPK LOSE' },
            { 'vendorProductId': '9343074', 'name': 'NPK 4:10:20 EF TOP 51 NPK GESACKT' },
            { 'vendorProductId': '9343075', 'name': 'NPK 4:10:20 EF TOP 51 NPK BIG BAG 600KG' },
            { 'vendorProductId': '9343805', 'name': 'AMMONIUMNITRAT 33,5 % N BIG BAG 600 KG' },
            { 'vendorProductId': '9344028', 'name': 'KALI 60% GRAN 50 KG' },
            { 'vendorProductId': '9344029', 'name': 'KALI 60% GRAN BIG BAG 1.000 KG' },
            { 'vendorProductId': '9344031', 'name': 'KALI 60% GRAN BIG BAG 600 KG' },
            { 'vendorProductId': '9344032', 'name': 'KALI 60% GRAN LOSE' },
            { 'vendorProductId': '9344741', 'name': 'NPK 15:5:20 25 KG ENTEC VINO NEU' },
            { 'vendorProductId': '9346189', 'name': 'NPK 14:7:17+2+9 BB 600 KG ENTEC PERFEKT' },
            { 'vendorProductId': '9346262', 'name': 'NPK 8:15:15 25 KG' },
            { 'vendorProductId': '9346267', 'name': 'PK 20:30 25 KG' },
            { 'vendorProductId': '9349130', 'name': 'NPK 10:26:26 BIG BAG' },
            { 'vendorProductId': '9349364', 'name': 'AlzoMix S BIG BAG 1.000 KG' },
            { 'vendorProductId': '9350164', 'name': 'NPK 8:15:15+9S BIG BAG' },
            { 'vendorProductId': '9350166', 'name': 'NPK 7:20:30 25 KG' },
            { 'vendorProductId': '9350167', 'name': 'PK 0:16:32 25 KG' },
            { 'vendorProductId': '9350168', 'name': 'AMOSULFAN 20%N + 24%S 25 KG' },
            { 'vendorProductId': '9350184', 'name': 'SSP 18 % 25 KG' },
            { 'vendorProductId': '9350185', 'name': 'NPK 10:10:20 25 KG NutriVeg' },
            { 'vendorProductId': '9351942', 'name': 'ENERGICO 33,5%N+28%SO3 BIG BAG' },
            { 'vendorProductId': '9351944', 'name': 'NPK 27:6:6 BIG BAG' },
            { 'vendorProductId': '9355409', 'name': 'KIESERIT GRANULIERT BIG BAG 600 KG' },
            { 'vendorProductId': '9355449', 'name': 'PHYSIOMAX 975 GRAN. SACK 15 KG' },
            { 'vendorProductId': '9355450', 'name': 'PHYSIO MESCAL G18 SACK 15 KG' },
            { 'vendorProductId': '9355451', 'name': 'NPK 8:8:17 EUROFERTIL 33N-PRO SACK 15KG' },
            { 'vendorProductId': '9356013', 'name': 'BRANNTKALK GEK 1-3 MM BIG BAG 500 KG' },
            { 'vendorProductId': '9356606', 'name': 'AMMONIUMNITRAT 33,5 % N 25 KG' },
            { 'vendorProductId': '9359028', 'name': 'NP 16:20 BIG BAG' },
            { 'vendorProductId': '9359647', 'name': 'NP 18:46:0 DAP 25 KG' },
            { 'vendorProductId': '9360473', 'name': 'KOHLENS KALK + S LOSE' },
            { 'vendorProductId': '9361238', 'name': 'STALLKALK LOSE' },
            { 'vendorProductId': '9361239', 'name': 'STALLKALK BIG BAG 1.000 KG' },
            { 'vendorProductId': '9361913', 'name': 'NP 10:35 SuperStart MICROGRAN. 25 KG' },
            { 'vendorProductId': '9366552', 'name': 'KALI 60% GRAN 25 KG K+S' },
            { 'vendorProductId': '9366553', 'name': 'KALI 60% FEIN 25 KG K+S' },
            { 'vendorProductId': '9366555', 'name': 'KALISULFAT 50% GRAN. 25 KG KALISOP' },
            { 'vendorProductId': '9366557', 'name': 'KORNKALI 40/6 25 KG' },
            { 'vendorProductId': '9366558', 'name': 'KIESERIT GRANULIERT 25 KG' },
            { 'vendorProductId': '9366589', 'name': 'AMMONIUMNITRAT 34,4 % N BIG BAG 500 KG' },
            { 'vendorProductId': '9367706', 'name': 'NP 10:20:0 BIG BAG 600 KG' },
            { 'vendorProductId': '9367709', 'name': 'NPK 16:16:16 BIG BAG 600 KG' },
            { 'vendorProductId': '9370084', 'name': 'TERRAMOL TE 50G GESACKT' },
            { 'vendorProductId': '9370743', 'name': 'PATENTKALI 30% GRAN BIG BAG 1.000 KG' },
            { 'vendorProductId': '9370744', 'name': 'KALISULFAT 50% GRAN BIGBAG 1000 KALISOP' },
            { 'vendorProductId': '9370888', 'name': 'ROCK PHOSPHATE BPL LOSE64-69 %' },
            { 'vendorProductId': '9370909', 'name': 'NP 10:40:0 NutriMAP BIG BAG' },
            { 'vendorProductId': '9377565', 'name': 'NPK 6:24:12 BIG BAG' },
            { 'vendorProductId': '9377790', 'name': 'NPK 14:14:14 BIG BAG' },
            { 'vendorProductId': '9377958', 'name': 'MEERKALK +S GRANULIERT BIG BAG 600 KG' },
            { 'vendorProductId': '9380245', 'name': 'OPTIMAG 24N+8S+8Mg BIG BAG 600 KG' },
            { 'vendorProductId': '9383813', 'name': 'NPK 16:16:16 25 KG' },
            { 'vendorProductId': '9385694', 'name': 'SOLACTIVE 14 % N BIG BAG 600 KG' },
            { 'vendorProductId': '9385696', 'name': 'SOLACTIVE 14 % N GESACKT 50 KG' },
            { 'vendorProductId': '9385697', 'name': 'SOLACTIVE 14 % N LOSE' },
            { 'vendorProductId': '9385699', 'name': 'NP 15:8 EF TOP 54 N-PROBIG BAG 600 KG' },
            { 'vendorProductId': '9385700', 'name': 'NP 15:8 EF TOP 54 N-PROGESACKT 50 KG' },
            { 'vendorProductId': '9385701', 'name': 'NP 15:8 EF TOP 54 N-PROLOSE' },
            { 'vendorProductId': '9385703', 'name': 'NK 13:0:24 KALISOL NK BIG BAG 600 KG' },
            { 'vendorProductId': '9385704', 'name': 'NK 13:0:24 KALISOL NK GESACKT 50 KG' },
            { 'vendorProductId': '9385705', 'name': 'NK 13:0:24 KALISOL NK LOSE' },
            { 'vendorProductId': '9391195', 'name': 'BIOLIT FEIN plus 25KG' },
            { 'vendorProductId': '9391280', 'name': 'PK 0:10:28 BIG BAG 700 KG' },
            { 'vendorProductId': '9391454', 'name': 'NPK 20:10:10 BIG BAG 1.000 KG' },
            { 'vendorProductId': '9395653', 'name': 'PIASAN S 25N+6S FLÜSSIG' },
            { 'vendorProductId': '9396225', 'name': 'KALKSTEIN-SPLIT 0/16 MMBIG BAG 1.000 KG' },
            { 'vendorProductId': '9397759', 'name': 'DASA 25N + 12S BIG BAG' },
            { 'vendorProductId': '9399730', 'name': 'SULFAN 24 (+6%) BIG BAG' },
            { 'vendorProductId': '9399993', 'name': 'NPK 7:21:21 BIG BAG' },
            { 'vendorProductId': '9399994', 'name': 'NPK 7:21:21 25 KG' },
            { 'vendorProductId': '9400017', 'name': 'NPK 8:15:15 LOSE' },
            { 'vendorProductId': '9400347', 'name': 'AMOSULFAN 20%N + 24%S 50 KG' },
            { 'vendorProductId': '9400589', 'name': 'MISCHKALK +S LOSE' },
            { 'vendorProductId': '9406316', 'name': 'NPK 6:24:12 25 KG' },
            { 'vendorProductId': '9407308', 'name': 'SAN 33 % 25 KG' },
            { 'vendorProductId': '9407309', 'name': 'AMMONIUMNITRAT 34,4 % N 50 KG' },
            { 'vendorProductId': '9409889', 'name': 'KALI 60 % GRAN BIG BAG' },
            { 'vendorProductId': '9409902', 'name': 'KALKKORN S 2-6 MM BIG BAG 600 KG' },
            { 'vendorProductId': '9409903', 'name': 'KALKKORN 2-6 MM LOSE' },
            { 'vendorProductId': '9409904', 'name': 'KALKKORN 2-6 MM BIG BAG 600 KG' },
            { 'vendorProductId': '9409905', 'name': 'KALKKORN 2-6 MM BIG BAG 1.000 KG' },
            { 'vendorProductId': '9411530', 'name': 'KALKKORN 2-6 MM 25 KG' },
            { 'vendorProductId': '9411598', 'name': 'KALKKORN S 2-6 MM 25 KG' },
            { 'vendorProductId': '9411930', 'name': 'NPK 10:26:26 50 KG' },
            { 'vendorProductId': '9412348', 'name': 'HARNSTOFF 46% GEPR 25KG RUSSIA' },
            { 'vendorProductId': '9413194', 'name': 'NP 19:17 BIG BAG 600 KG YaraMila MAIS' },
            { 'vendorProductId': '9414711', 'name': 'NPK 9:15:15 25 KG' },
            { 'vendorProductId': '9414749', 'name': 'UREA S 38N+7S GRAN BIG BAG 500 KG' },
            { 'vendorProductId': '9414750', 'name': 'STALLKALK FEUCHT LOSE' },
            { 'vendorProductId': '9415024', 'name': 'NaturGipsKorn gran. 2-6 mm lose' },
            { 'vendorProductId': '9415025', 'name': 'NATURGIPSKORN GRAN. 2-6 mm 25 kg' },
            { 'vendorProductId': '9415026', 'name': 'NATURGIPSKORN GRAN. 2-6 MM BB 600 KG' },
            { 'vendorProductId': '9415027', 'name': 'NATURGIPSKORN GRAN. 2-6 MM BB 1000 KG' },
            { 'vendorProductId': '9415028', 'name': 'KALKKORN-MG GRANULIERT 2-6 MM LOSE' },
            { 'vendorProductId': '9415029', 'name': 'KALKKORN-MG GRANULIERT 2-6 MM GES. 25 KG' },
            { 'vendorProductId': '9415030', 'name': 'KALKKORN-MG GRANULIERT 2-6 MM BB 600 KG' },
            { 'vendorProductId': '9415031', 'name': 'KALKKORN-MG GRANULIERT 2-6 MM BB 1000 KG' },
            { 'vendorProductId': '9415244', 'name': 'N-TESTER' },
            { 'vendorProductId': '9415434', 'name': 'NS 24+7 YaraBela WEIDE SULFAN 600 KG BB' },
            { 'vendorProductId': '9415838', 'name': 'SULFAN 24N/15 SO3 BIG BAG' },
            { 'vendorProductId': '9416013', 'name': 'KALKKORN-P5 GRANULIERT 2-6 MM LOSE' },
            { 'vendorProductId': '9416016', 'name': 'KALKKORN-P5 GRANULIERT 2-6 MM 25 KG' },
            { 'vendorProductId': '9416018', 'name': 'KALKKORN-P5 GRANULIERT 2-6 MM BB 600 KG' },
            { 'vendorProductId': '9416020', 'name': 'KALKKORN-P5 GRANULIERT 2-6 MM BB 1000 KG' },
            { 'vendorProductId': '9417486', 'name': 'POLIFOSKA 21 % BIG BAG' },
            { 'vendorProductId': '9418350', 'name': 'ROCK PHOSPHATE LOSE 30%' },
            { 'vendorProductId': '9419852', 'name': 'AMMONIUMNITRAT 34,4 % N 25 KG' },
            { 'vendorProductId': '9420527', 'name': 'PK 28:20 LOSE' },
            { 'vendorProductId': '9422182', 'name': 'HARNSTOFF 46% GRAN 40KG' },
            { 'vendorProductId': '9424306', 'name': 'NPK 13:10:20 +3S LOSE' },
            { 'vendorProductId': '9424912', 'name': 'NPK 6:20:30+7SO3 BB 500KG POLIFOSKA 6' },
            { 'vendorProductId': '9425667', 'name': 'NPK 14:10:20 25 KG COMPLEX' },
            { 'vendorProductId': '9426207', 'name': 'MISCHKALK 25 KG PE' },
            { 'vendorProductId': '9427870', 'name': 'ROCK PHOSPHATE LOSE 29%' },
            { 'vendorProductId': '9427871', 'name': 'ROCK PHOSPHATE BPL LOSE65-69 %' },
            { 'vendorProductId': '9428166', 'name': 'DOMOGRAN 45 (21%N+24%S)LOSE' },
            { 'vendorProductId': '9428605', 'name': 'NPK 10:26:26 LOSE' },
            { 'vendorProductId': '9430084', 'name': 'ROCK PHOSPHATE LOSE 28%' },
            { 'vendorProductId': '9430143', 'name': 'ASS 26N+13S LOSE Ammonsulfatsalp.' },
            { 'vendorProductId': '9430144', 'name': 'ASS 26N+13S BB 600 KG Ammonsulfatsalp.' },
            { 'vendorProductId': '9430145', 'name': 'ASS 26N+13S BB 1000 KG Ammonsulfatsalp.' },
            { 'vendorProductId': '9430147', 'name': 'SALETROSAN 26 macro 26N+13S LOSE' },
            { 'vendorProductId': '9430148', 'name': 'SALETROSAN 26 macro 26N+13S BB 500 KG' },
            { 'vendorProductId': '9434200', 'name': 'NP 8:30 DUOFERTIL TOP3850/1 KG GESACKT' },
            { 'vendorProductId': '9434201', 'name': 'NP 8:30 DUOFERTIL TOP3850/1 KG GESACKT' },
            { 'vendorProductId': '9439429', 'name': 'BRANNTKALK GEK 3-8 MM BIG BAG 600 KG' },
            { 'vendorProductId': '9440524', 'name': 'SSP 18 % GRAN. BIG BAG' },
            { 'vendorProductId': '944490', 'name': 'BIOLIT ULTRAFEIN plus 20 KG' },
            { 'vendorProductId': '944491', 'name': 'BIOLIT ULTRAFEIN plus BIG BAG 700 KG' },
            { 'vendorProductId': '944492', 'name': 'BIOLIT SAND LOSE' },
            { 'vendorProductId': '944493', 'name': 'BIOLIT URGESTEINSM 40KG' },
            { 'vendorProductId': '944494', 'name': 'BIOLIT FEIN plus LOSE' },
            { 'vendorProductId': '944495', 'name': 'BIOLIT FEIN plus BIG BAG 1.000 KG' },
            { 'vendorProductId': '944496', 'name': 'BIOLIT ULTRAFEIN LOSE' },
            { 'vendorProductId': '944497', 'name': 'NPK 13:5:15 LOSE' },
            { 'vendorProductId': '944498', 'name': 'NPK 12:10:15 50KG DC 37' },
            { 'vendorProductId': '944499', 'name': 'NPK 12:8:16 50KG' },
            { 'vendorProductId': '944500', 'name': 'NPK 12:10:15 LOSE DC 37' },
            { 'vendorProductId': '944501', 'name': 'PK 0:12:20 GRAN 50KG DC 45 NEU' },
            { 'vendorProductId': '944502', 'name': 'PK 0:12:20 GRAN LOSE DC 45 NEU' },
            { 'vendorProductId': '944503', 'name': 'NPK 8:6:20 LOSE DC VITAL' },
            { 'vendorProductId': '944505', 'name': 'NPK 13:5:15 50KG' },
            { 'vendorProductId': '944506', 'name': 'NPK 8:6:20 50KG DC VITAL' },
            { 'vendorProductId': '944507', 'name': 'SUPERPHOSPHAT 18% 50KG' },
            { 'vendorProductId': '944508', 'name': 'HYPERPHOSPHAT FEIN 29% 50KG' },
            { 'vendorProductId': '944509', 'name': 'SUPERPHOSPHAT 18% LOSE' },
            { 'vendorProductId': '944510', 'name': 'NPK 5:7:16 50KG DC 31' },
            { 'vendorProductId': '944511', 'name': 'NPK 6:10:16 LOSE DC START' },
            { 'vendorProductId': '944512', 'name': 'NPK 6:10:16 50KG DC START' },
            { 'vendorProductId': '944513', 'name': 'HYPERKORN 26% BIG BAG' },
            { 'vendorProductId': '944514', 'name': 'HYPERKALK P16 LOSE' },
            { 'vendorProductId': '944515', 'name': 'HYPERKALK P16 50KG' },
            { 'vendorProductId': '944516', 'name': 'NPK 14:7:7 BIG BAG DC 28' },
            { 'vendorProductId': '944517', 'name': 'NPK 12:8:16 50KG' },
            { 'vendorProductId': '944518', 'name': 'NPK 6:12:24 LOSE' },
            { 'vendorProductId': '944519', 'name': 'NPK 6:12:24 25KG' },
            { 'vendorProductId': '944520', 'name': 'AMMONSULFAT 21% LOSE KRISTALLIN FEIN' },
            { 'vendorProductId': '944521', 'name': 'AMMONSULFAT 21% 50 KG KRISTALLIN FEIN' },
            { 'vendorProductId': '944522', 'name': 'NPK 12:5:15 50KG DC FRUCHT' },
            { 'vendorProductId': '944523', 'name': 'NPK 6:8:20 LOSE DC VITAL' },
            { 'vendorProductId': '944524', 'name': 'PK 0:10:30 LOSE DC RÜBE' },
            { 'vendorProductId': '944525', 'name': 'PK 0:10:17 LOSE' },
            { 'vendorProductId': '944526', 'name': 'NATURPHOSPHAT 26% 50KG' },
            { 'vendorProductId': '944527', 'name': 'NATURPHOSPHAT 26% LOSE' },
            { 'vendorProductId': '944528', 'name': 'PK 0:10:17 50KG' },
            { 'vendorProductId': '944529', 'name': 'KOHLENS KALK FEUCHT LOSE' },
            { 'vendorProductId': '944530', 'name': 'PK 0:10:30 50KG DC RÜBE' },
            { 'vendorProductId': '944531', 'name': 'NPK 6:8:20 50KG DC VITAL' },
            { 'vendorProductId': '944532', 'name': 'BIOSOL FORTE GES' },
            { 'vendorProductId': '944533', 'name': 'NPK 11:5:18 50KG' },
            { 'vendorProductId': '944534', 'name': 'NPK 6:10:16 LOSE DC BOR START' },
            { 'vendorProductId': '944535', 'name': 'NPK 15:5:5 50KG' },
            { 'vendorProductId': '944537', 'name': 'NPK 12:8:16 LOSE' },
            { 'vendorProductId': '944538', 'name': 'BIOSOL FORTE LOSE' },
            { 'vendorProductId': '944539', 'name': 'NPK 15:5:5 LOSE' },
            { 'vendorProductId': '944540', 'name': 'NPK 12:5:15 LOSE DC FRUCHT' },
            { 'vendorProductId': '944541', 'name': 'NPK 12:5:20 LOSE' },
            { 'vendorProductId': '944542', 'name': 'PK 0:5:55 LOSE' },
            { 'vendorProductId': '944543', 'name': 'NPK 14:7:7 LOSE DC 28' },
            { 'vendorProductId': '944544', 'name': 'NPK 11:5:18 LOSE' },
            { 'vendorProductId': '944545', 'name': 'NPK 10:08:20 50 KG DC ROT' },
            { 'vendorProductId': '944546', 'name': 'NPK 10:08:20 LOSE DC ROT' },
            { 'vendorProductId': '944547', 'name': 'PK 0:5:30 50KG DC TABAK' },
            { 'vendorProductId': '944548', 'name': 'PK 0:15:30 DC45er LOSE' },
            { 'vendorProductId': '944549', 'name': 'PK 22:10 LOSE HYPERKALI' },
            { 'vendorProductId': '944550', 'name': 'PK 0:15:30 DC45er 50KG' },
            { 'vendorProductId': '944551', 'name': 'PK 0:10:30 50KG DC 44' },
            { 'vendorProductId': '944552', 'name': 'HYPERKORN 26% LOSE' },
            { 'vendorProductId': '944553', 'name': 'HYPERKORN 26% 50KG' },
            { 'vendorProductId': '944554', 'name': 'HYPERPHOSPHAT FEIN 29% LOSE' },
            { 'vendorProductId': '944555', 'name': 'NPK 6:10:16 50KG DC BOR START' },
            { 'vendorProductId': '944556', 'name': 'PK 22:10 50KG HYPERKALI' },
            { 'vendorProductId': '944558', 'name': 'PK 18:18 50KG HYPERKALI' },
            { 'vendorProductId': '944559', 'name': 'TRIPLEPHOSPHAT 46% LOSE' },
            { 'vendorProductId': '944560', 'name': 'PK 0:10:30 LOSE DC 44' },
            { 'vendorProductId': '944561', 'name': 'PK 0:10:30 50KG DC FIT' },
            { 'vendorProductId': '944563', 'name': 'PK 0:10:30 LOSE DC FIT' },
            { 'vendorProductId': '944565', 'name': 'NPK 12:12:12 50KG DC 4x12' },
            { 'vendorProductId': '944566', 'name': 'NATURPHOSPHAT 26% BIG BAG' },
            { 'vendorProductId': '944567', 'name': 'NPK 12:12:12 LOSE DC 4x12' },
            { 'vendorProductId': '944568', 'name': 'TRIPLEPHOSPHAT 46% 50KG' },
            { 'vendorProductId': '944569', 'name': 'PK 18:18 LOSE HYPERKALI' },
            { 'vendorProductId': '944570', 'name': 'BRANNTKALK FEIN GEMAH- LEN 40 KG' },
            { 'vendorProductId': '944571', 'name': 'BRANNTKALK FEIN GEMAH- LEN LOSE' },
            { 'vendorProductId': '944572', 'name': 'MISCHKALK GES' },
            { 'vendorProductId': '944573', 'name': 'BASADOL BIG BAG' },
            { 'vendorProductId': '944574', 'name': 'KOHLENS KALK MG FEU 40KG' },
            { 'vendorProductId': '944575', 'name': 'BASADOL 40KG' },
            { 'vendorProductId': '944576', 'name': 'DOLOSOL FEUCHT LOSE' },
            { 'vendorProductId': '944578', 'name': 'DOLOPHOS 15 LOSE' },
            { 'vendorProductId': '944579', 'name': 'DOLOPHOS 15 40 KG' },
            { 'vendorProductId': '944580', 'name': 'KOHLENS KALK MG 25KG' },
            { 'vendorProductId': '944581', 'name': 'FEUCHTKALK 43 LOSE' },
            { 'vendorProductId': '944584', 'name': 'SCHWARZKALK LOSE' },
            { 'vendorProductId': '944586', 'name': 'DOLOSOL LOSE' },
            { 'vendorProductId': '944587', 'name': 'DOLOSOL 40KG' },
            { 'vendorProductId': '944588', 'name': 'DOLOSOL PELETT LOSE' },
            { 'vendorProductId': '944589', 'name': 'DOLOSOL PELETT 40KG' },
            { 'vendorProductId': '944590', 'name': 'GRAUKALK LOSE' },
            { 'vendorProductId': '944591', 'name': 'KOHLENS KALK MG FEUCHT LOSE' },
            { 'vendorProductId': '944592', 'name': 'DOLO 4O FEUCHT LOSE' },
            { 'vendorProductId': '944593', 'name': 'GRAUKALK 40KG' },
            { 'vendorProductId': '944594', 'name': 'KOHLENS KALK MG LOSE' },
            { 'vendorProductId': '944595', 'name': 'BASALIT LOSE' },
            { 'vendorProductId': '944596', 'name': 'MISCHKALK LOSE' },
            { 'vendorProductId': '944597', 'name': 'KOHLENS KALK LOSE' },
            { 'vendorProductId': '944598', 'name': 'DIALIT DIABASMEHL LOSE' },
            { 'vendorProductId': '944599', 'name': 'BASADIADOL LOSE' },
            { 'vendorProductId': '944600', 'name': 'BASADOL LOSE' },
            { 'vendorProductId': '944601', 'name': 'DOLOKORN 40 KG' },
            { 'vendorProductId': '944602', 'name': 'DOLO 40 LOSE' },
            { 'vendorProductId': '944603', 'name': 'MISCHKALK MG LOSE' },
            { 'vendorProductId': '944604', 'name': 'DOLOKORN LOSE' },
            { 'vendorProductId': '944605', 'name': 'DIALIT DIABASMEHL 25KG' },
            { 'vendorProductId': '944606', 'name': 'DOLOPHOS 26 40KG' },
            { 'vendorProductId': '944608', 'name': 'PHYSIOSTART 25KG' },
            { 'vendorProductId': '944610', 'name': 'MISCHKALK SPEZ 40KG' },
            { 'vendorProductId': '944611', 'name': 'MISCHKALK MG 40KG' },
            { 'vendorProductId': '944612', 'name': 'MISCHKALK MG 25KG' },
            { 'vendorProductId': '944613', 'name': 'SCHWARZKALK GES' },
            { 'vendorProductId': '944614', 'name': 'DOLOKORN 20KG' },
            { 'vendorProductId': '944616', 'name': 'KOHLENS KALK MG 40KG' },
            { 'vendorProductId': '944617', 'name': 'KOHLENS KALK 40KG' },
            { 'vendorProductId': '944618', 'name': 'BRANNTKALK GEK 3-8 MM 50 KG' },
            { 'vendorProductId': '944619', 'name': 'BRANNTKALK GEK 3-8 MM LOSE' },
            { 'vendorProductId': '944620', 'name': 'MISCHKALK MG SPEZ 40KG' },
            { 'vendorProductId': '944621', 'name': 'MISCHKALK 40KG' },
            { 'vendorProductId': '944622', 'name': 'MISCHKALK MG SPEZ LOSE' },
            { 'vendorProductId': '944623', 'name': 'MISCHKALK SPEZ LOSE' },
            { 'vendorProductId': '944624', 'name': 'DOLOPHOS 26 LOSE' },
            { 'vendorProductId': '944625', 'name': 'BASALIT 40KG' },
            { 'vendorProductId': '944628', 'name': 'ALPHA-KOHLENS KALK 50KG' },
            { 'vendorProductId': '944629', 'name': 'PIAMON 33 S LOSE' },
            { 'vendorProductId': '944630', 'name': 'PIAMON 33 S 50KG' },
            { 'vendorProductId': '944631', 'name': 'NPK 15:15:15 50KG' },
            { 'vendorProductId': '944632', 'name': 'NPK 15:15:15 LOSE' },
            { 'vendorProductId': '944634', 'name': 'NPK 12:5:17 50KG NITROPH MG PLUS' },
            { 'vendorProductId': '944635', 'name': 'NPK 15:5:20+2+8 LOSE NITROPH. PERFECT' },
            { 'vendorProductId': '944636', 'name': 'NPK 15:5:20+2+8 50 KG NITROPH. PERFECT' },
            { 'vendorProductId': '944637', 'name': 'NPK 14:7:17+2+9 25KG ENTEC PERFEKT' },
            { 'vendorProductId': '944639', 'name': 'NPK 20:5:10+3+5 50 KG NITROPHOSKA SUPER' },
            { 'vendorProductId': '944640', 'name': 'ENTEC 26+13 50 KG' },
            { 'vendorProductId': '944641', 'name': 'ENTEC 26+13 LOSE' },
            { 'vendorProductId': '944642', 'name': 'NPK 12:12:17+2+8 25 KG NITROPH. SPECIAL' },
            { 'vendorProductId': '944644', 'name': 'NPK 12:12:17+2+8 50 KG NITROPH. SPECIAL' },
            { 'vendorProductId': '944645', 'name': 'NPK 20:5:10+3+5 LOSE NITROPHOSKA SUPER' },
            { 'vendorProductId': '944646', 'name': 'NPK 15:5:20 25KG NITROPH PERFEKT' },
            { 'vendorProductId': '944647', 'name': 'NPK 14:7:17+2+9 50 KG ENTEC PERFECT' },
            { 'vendorProductId': '944648', 'name': 'NPK 14:7:17+2+9 LOSE ENTEC PERFECT' },
            { 'vendorProductId': '944649', 'name': 'KAS 27% GRAN 50KG' },
            { 'vendorProductId': '944650', 'name': 'NITRAMON S 26N+13S LOSE (DASA)' },
            { 'vendorProductId': '944651', 'name': 'NITRAMON S 26N+13S 50KG (DASA)' },
            { 'vendorProductId': '944652', 'name': 'HARNSTOFF 46 % GEPR BIG BAG' },
            { 'vendorProductId': '944653', 'name': 'AHL 27% LOSE' },
            { 'vendorProductId': '944654', 'name': 'KAS 27% GRAN LOSE' },
            { 'vendorProductId': '944655', 'name': 'KAS 27% GRAN BIG BAG' },
            { 'vendorProductId': '944656', 'name': 'AHL 30% LOSE' },
            { 'vendorProductId': '944657', 'name': 'NP 24:14:0 50KG LINZER GOLD' },
            { 'vendorProductId': '944659', 'name': 'HARNSTOFF 46% GEPR 50KG' },
            { 'vendorProductId': '944660', 'name': 'NPK 16:25:5 LOSE LINZER TIP' },
            { 'vendorProductId': '944662', 'name': 'NPK 16:25:5 50KG LINZER TIP' },
            { 'vendorProductId': '944663', 'name': 'HARNSTOFF 46% GEPR LOSE' },
            { 'vendorProductId': '944664', 'name': 'NPK 15:15:15 50KG LINZER STAR' },
            { 'vendorProductId': '944665', 'name': 'NPK 14:10:20 50 KG LINZER PRO' },
            { 'vendorProductId': '944666', 'name': 'KAS 27% GRAN 50KG LINZER NAC' },
            { 'vendorProductId': '944667', 'name': 'NPK 20:8:8 50KG LINZER PLUS' },
            { 'vendorProductId': '944668', 'name': 'NPK 20:8:8 LOSE LINZER PLUS' },
            { 'vendorProductId': '944670', 'name': 'NPK 16:10:17 50KG LINZER PRO' },
            { 'vendorProductId': '944671', 'name': 'NPK 13:13:21 LOSE' },
            { 'vendorProductId': '944672', 'name': 'RASENDÜNGER 20:8:8 25KG' },
            { 'vendorProductId': '944673', 'name': 'NPK 13:13:21 50KG' },
            { 'vendorProductId': '944675', 'name': 'KAS 27% GRAN LOSE LINZER NAC' },
            { 'vendorProductId': '944676', 'name': 'NPK 15:15:15 LOSE LINZER STAR' },
            { 'vendorProductId': '944678', 'name': 'KAS+S 50KG LINZER NAC+S' },
            { 'vendorProductId': '944683', 'name': 'NPK 16:10:17 LOSE LINZER PRO' },
            { 'vendorProductId': '944684', 'name': 'NPK 14:10:20 LOSE LINZER PRO' },
            { 'vendorProductId': '944685', 'name': 'KEHRGUT' },
            { 'vendorProductId': '944686', 'name': 'KORNKALI 40/6 50KG' },
            { 'vendorProductId': '944687', 'name': 'KALI 60% GRAN LOSE K+S' },
            { 'vendorProductId': '944688', 'name': 'PATENTKALI 30% FEIN LOSE' },
            { 'vendorProductId': '944689', 'name': 'KALI 60% GRAN 50 KG K+S' },
            { 'vendorProductId': '944690', 'name': 'KALISULFAT 50% GRAN. LOSE KALISOP' },
            { 'vendorProductId': '944691', 'name': 'MAGNESIA KAINIT LOSE' },
            { 'vendorProductId': '944692', 'name': 'PATENTKALI 30% FEIN 50KG' },
            { 'vendorProductId': '944693', 'name': 'PATENTKALI 30% GRAN LOSE' },
            { 'vendorProductId': '944694', 'name': 'KALI 60% FEIN LOSE' },
            { 'vendorProductId': '944695', 'name': 'PK 0:11:11 50KG THOMASKALI' },
            { 'vendorProductId': '944696', 'name': 'PK 0:10:20 50KG THOMASKALI' },
            { 'vendorProductId': '944697', 'name': 'PK 0:10:20 LOSE THOMASKALI' },
            { 'vendorProductId': '944698', 'name': 'KIESERIT FEIN 50KG' },
            { 'vendorProductId': '944699', 'name': 'PATENTKALI 30 % GRAN. 25 KG' },
            { 'vendorProductId': '944700', 'name': 'PK 0:11:11 LOSE THOMASKALI' },
            { 'vendorProductId': '944701', 'name': 'MAGNESIA KAINIT 50KG' },
            { 'vendorProductId': '944702', 'name': 'PK 0:12:18 50KG THOMASKALI' },
            { 'vendorProductId': '944703', 'name': 'PK 0:12:18 LOSE THOMASKALI' },
            { 'vendorProductId': '944704', 'name': 'KALI 60% FEIN 50KG' },
            { 'vendorProductId': '944705', 'name': 'KORNKALI 40/6 LOSE' },
            { 'vendorProductId': '944706', 'name': 'KALISULFAT 50% FEIN LOSE' },
            { 'vendorProductId': '944707', 'name': 'KALISULFAT 50% FEIN 50KG' },
            { 'vendorProductId': '944708', 'name': 'KIESERIT GRANULIERT LOSE' },
            { 'vendorProductId': '944709', 'name': 'KIESERIT GRANULIERT 50KG' },
            { 'vendorProductId': '944710', 'name': 'KALISULFAT 50% GRAN. 50 KG KALISOP' },
            { 'vendorProductId': '944711', 'name': 'PATENTKALI 30% GRAN 50KG' },
            { 'vendorProductId': '944712', 'name': 'KAS 27% GEPR BIG BAG' },
            { 'vendorProductId': '944713', 'name': 'AMMONIUMNITRAT 50KG' },
            { 'vendorProductId': '944714', 'name': 'KAS 27% GEPR 50KG' },
            { 'vendorProductId': '944715', 'name': 'KAS 27% GEPR LOSE' },
            { 'vendorProductId': '944716', 'name': 'NPK 10:6:18 LOSE' },
            { 'vendorProductId': '944717', 'name': 'NPK 20:10:0 LOSE' },
            { 'vendorProductId': '944722', 'name': 'NPK 15:20:0 50KG' },
            { 'vendorProductId': '944723', 'name': 'SULFAMMO 20 LITHACTYL N PRO LOSE' },
            { 'vendorProductId': '944725', 'name': 'NPK 14:5:0 LOSE' },
            { 'vendorProductId': '944726', 'name': 'NPK 14:5:0 50KG' },
            { 'vendorProductId': '944727', 'name': 'NPK 16:5:8 50KG' },
            { 'vendorProductId': '944729', 'name': 'PHYSIOMAX 975 GRAN LOSE' },
            { 'vendorProductId': '944730', 'name': 'NPK 22:7:0 LOSE' },
            { 'vendorProductId': '944731', 'name': 'NPK 22:0:0 LOSE' },
            { 'vendorProductId': '944732', 'name': 'NPK 20:0:5 50KG' },
            { 'vendorProductId': '944733', 'name': 'NPK 13:5:17 LOSE' },
            { 'vendorProductId': '944734', 'name': 'NPK 15:8:5 LOSE' },
            { 'vendorProductId': '944735', 'name': 'NPK 20:0:5 LOSE' },
            { 'vendorProductId': '944736', 'name': 'NPK 20:10:0 50KG' },
            { 'vendorProductId': '944737', 'name': 'NPK 10:6:18 25KG' },
            { 'vendorProductId': '944738', 'name': 'NPK 13:5:17 50KG' },
            { 'vendorProductId': '944739', 'name': 'NPK 15:8:5 50KG' },
            { 'vendorProductId': '944742', 'name': 'SULFAMMO 26 LITHACTYL N PRO LOSE' },
            { 'vendorProductId': '944746', 'name': 'NPK 15:20:0 LOSE' },
            { 'vendorProductId': '944750', 'name': 'NPK 16:5:8 EUROFERTIL 29 N-PRO LOSE' },
            { 'vendorProductId': '944751', 'name': 'HARNSTOFF 46% GRAN 50KG' },
            { 'vendorProductId': '944752', 'name': 'HARNSTOFF 46% GRAN BIG BAG' },
            { 'vendorProductId': '944753', 'name': 'HARNSTOFF 46% GRAN LOSE' },
            { 'vendorProductId': '944754', 'name': 'KALKSTICKSTOFF GEP 50KG' },
            { 'vendorProductId': '944755', 'name': 'KALKSTICKSTOFF GEP LOSE' },
            { 'vendorProductId': '944756', 'name': 'AMMONSULFAT 21% 50 KG GROB KRISTALLIN' },
            { 'vendorProductId': '944757', 'name': 'AMMONSULFAT 21% LOSE GROB KRISTALLIN' },
            { 'vendorProductId': '944758', 'name': 'KALKSALPETER 50KG' },
            { 'vendorProductId': '944759', 'name': 'KALKSALPETER LOSE' },
            { 'vendorProductId': '944760', 'name': 'NP 12:52:0 LOSE MAP' },
            { 'vendorProductId': '944761', 'name': 'NP 18:46:0 LOSE DAP' },
            { 'vendorProductId': '944762', 'name': 'NP 12:52:0 50KG MAP' },
            { 'vendorProductId': '944763', 'name': 'NP 18:46:0 50KG DAP' },
            { 'vendorProductId': '9451473', 'name': 'ROCK PHOSPHATE 32 % BPL 64-69 % LOSE' },
            { 'vendorProductId': '9451478', 'name': 'DOLO 40 GESACKT 25 KG' },
            { 'vendorProductId': '9451479', 'name': 'BRANNTKALK GEK 1-3 MM BIG BAG 600 KG' },
            { 'vendorProductId': '9451555', 'name': 'DIABAS URGESTEINSMEHL BIG BAG' },
            { 'vendorProductId': '9452785', 'name': 'NPK 10:30:15 BIG BAG' },
            { 'vendorProductId': '945519', 'name': 'NPK 12:12:12 +6S 50KG' },
            { 'vendorProductId': '945524', 'name': 'NPK 12:12:12 +6S LOSE' },
            { 'vendorProductId': '9455537', 'name': 'CITROSOL LOSE' },
            { 'vendorProductId': '9455538', 'name': 'CITROSOL BIG BAG 1000KG' },
            { 'vendorProductId': '9456798', 'name': 'THIO-SUL 12-0-0 + 26S FLÜSSIG' },
            { 'vendorProductId': '945843', 'name': 'NPK 6:12:24 50KG DC 42' },
            { 'vendorProductId': '945844', 'name': 'NPK 16:6:6 LOSE' },
            { 'vendorProductId': '945847', 'name': 'NPK 16:6:6 50KG' },
            { 'vendorProductId': '945995', 'name': 'DIABAS SAND MEDIUM 0/2 mm FEUCHT LOSE' },
            { 'vendorProductId': '9461330', 'name': 'CITROSOL BIG BAG 500 KG' },
            { 'vendorProductId': '9462480', 'name': 'HARNSTOFF 46% GEPR 20KG' },
            { 'vendorProductId': '946469', 'name': 'AMMONSULFAT 20N + 20,5S GRANULIERT LOSE' },
            { 'vendorProductId': '946716', 'name': 'NPK 12:12:12 +6S BIG BAG 600 KG' },
            { 'vendorProductId': '946724', 'name': 'PHYSIOMAX+975 LOSE' },
            { 'vendorProductId': '946731', 'name': 'PHYSIO MESCAL G18 LOSE' },
            { 'vendorProductId': '946734', 'name': 'SULFAMMO 20 MESACTYL N-PRO LOSE' },
            { 'vendorProductId': '946736', 'name': 'NPK 13:5:17 LOSE LITHACTHYL NPRO SULFAT' },
            { 'vendorProductId': '946738', 'name': 'NPK 5:10:22 LOSE LITHACTHYL N PRO' },
            { 'vendorProductId': '946740', 'name': 'PK 0:10:17 SULFAT LOSE' },
            { 'vendorProductId': '9469539', 'name': 'NP 12:52:0 25KG MAP' },
            { 'vendorProductId': '9469859', 'name': 'KALKKORN-P15 GRANULIERT2-6 MM 25 KG' },
            { 'vendorProductId': '9469860', 'name': 'KALKKORN-P15 GRANULIERT2-6 MM BB 1000 KG' },
            { 'vendorProductId': '9469861', 'name': 'KALKKORN-P15 GRANULIERT2-6 MM BB 600 KG' },
            { 'vendorProductId': '9469862', 'name': 'KALKKORN-P15 GRANULIERT2-6 MM LOSE' },
            { 'vendorProductId': '9470314', 'name': 'NP 3:22 DUOFERTIL TOP43 NPS LOSE' },
            { 'vendorProductId': '9470315', 'name': 'NP 3:22 DUOFERTIL TOP43 NPS GESACKT 50KG' },
            { 'vendorProductId': '9470316', 'name': 'NP 3:22 DUOFERTIL TOP43 NPS BB 600 KG' },
            { 'vendorProductId': '9470317', 'name': 'NPK 5:19:10 DUOFERTIL TOP 34 LOSE' },
            { 'vendorProductId': '9470318', 'name': 'NPK 5:19:10 DUOFERTIL TOP 34 GES. 50 KG' },
            { 'vendorProductId': '9470319', 'name': 'NPK 5:19:10 DUOFERTIL TOP 34 BB 600 KG' },
            { 'vendorProductId': '9471307', 'name': 'AMMONIUMNITRAT 34,4 % N BIG BAG 600 KG' },
            { 'vendorProductId': '947135', 'name': 'LITHACTYL N PRO 10-6-18 LOSE' },
            { 'vendorProductId': '9472034', 'name': 'KAS 27% GEPR 25 KG' },
            { 'vendorProductId': '9473313', 'name': 'DOLO 40 BIG BAG 1000 KG' },
            { 'vendorProductId': '9474507', 'name': 'GÜLLEKALK + S LOSE' },
            { 'vendorProductId': '9475218', 'name': 'NPK 21:5:10+3+6 BB600KGNOVA TEC SUPREM' },
            { 'vendorProductId': '9475221', 'name': 'ALZON NEO-N 46 LOSE' },
            { 'vendorProductId': '9475222', 'name': 'ALZON NEO-N 46 BIG BAG 1.000 KG' },
            { 'vendorProductId': '9475223', 'name': 'ALZON NEO-N 46 BIG BAG 500 KG' },
            { 'vendorProductId': '9475224', 'name': 'ALZON NEO-N 46 25 KG' },
            { 'vendorProductId': '9475934', 'name': 'SULFAMMO 25 MPPA 40/1' },
            { 'vendorProductId': '9476549', 'name': 'NPK 8:24:8 +10S +0,2CU LOSE' },
            { 'vendorProductId': '9476550', 'name': 'NPK 8:24:8 +10S +0,2CU BIG BAG' },
            { 'vendorProductId': '9477408', 'name': 'KALKKORN 1-2 MM 25 KG' },
            { 'vendorProductId': '9477409', 'name': 'NATURGIPS-MEHL BIG BAG 1.000 KG' },
            { 'vendorProductId': '947890', 'name': 'MAKAPHOS LOSE' },
            { 'vendorProductId': '950624', 'name': 'BIOSOL GES' },
            { 'vendorProductId': '950625', 'name': 'BIOSOL LOSE' },
            { 'vendorProductId': '951124', 'name': 'AMMONSULFAT 21% KRIST. BIG BAG' },
            { 'vendorProductId': '951469', 'name': 'NPK 11:10:5 MESACTYL NPK LOSE' },
            { 'vendorProductId': '951471', 'name': 'SULFAMMO 30 MESACTYL N-PRO LOSE' },
            { 'vendorProductId': '951489', 'name': 'PK 0:10:20 BIGBAG' },
            { 'vendorProductId': '953629', 'name': 'NPK 14:10:20+7GRAN 50KG DUSLOFERT' },
            { 'vendorProductId': '954416', 'name': 'HARNSTOFF 46% GEPR BIG BAG 700kg' },
            { 'vendorProductId': '954433', 'name': 'KALISULFAT 50% FEIN BIGBAG' },
            { 'vendorProductId': '954505', 'name': 'NP 20:20:0 50KG LINZER TIP' },
            { 'vendorProductId': '955182', 'name': 'SUPERPHOSPHAT 18% BIGBAG' },
            { 'vendorProductId': '955198', 'name': 'NPK 15:15:10 lose' },
            { 'vendorProductId': '955199', 'name': 'NPK 15:15:10 50KG' },
            { 'vendorProductId': '955531', 'name': 'AMMONSULFAT 20%+20,5%S GRANULIERT BIGBAG' },
            { 'vendorProductId': '955553', 'name': 'BIOSOL BIG BAG' },
            { 'vendorProductId': '955554', 'name': 'AMMONSULFAT 20%+20,5%S GRANULIERT LOSE' },
            { 'vendorProductId': '955555', 'name': 'AMMONSULFAT 20%+20,5%S GRANULIERT 50KG' },
            { 'vendorProductId': '958351', 'name': 'AMMONIUMNITRAT 33,5 % N BIG BAG 500 KG' },
            { 'vendorProductId': '959917', 'name': 'DASA 26N+13S Big Bag 1.000 kg' },
            { 'vendorProductId': '959933', 'name': 'NPK 12:10:15 BIG BAG DC 37' },
            { 'vendorProductId': '961187', 'name': 'KALISULFAT 50% GRAN.BIGBAG 600KG KALISOP' },
            { 'vendorProductId': '961592', 'name': 'PK 0:10:24 50KG' },
            { 'vendorProductId': '963017', 'name': 'NPK 15:10:10 GRAN LOSE' },
            { 'vendorProductId': '964789', 'name': 'BIOFERT LOSE' },
            { 'vendorProductId': '965357', 'name': 'BIOSOL FORTE BIG BAG' },
            { 'vendorProductId': '965517', 'name': 'NPK 5:10:22 EUROFERTIL 37 PLUS LOSE' },
            { 'vendorProductId': '965518', 'name': 'NPK 13:7:17 EUROFERTIL 37 N-PRO LOSE' },
            { 'vendorProductId': '965519', 'name': 'NP 15:20 EUROFERTIL 35 PLUS LOSE' },
            { 'vendorProductId': '965979', 'name': 'NPK 12:12:12 BIGBAG DC 4x12' },
            { 'vendorProductId': '965980', 'name': 'NPK 6:12:24 GRAN 50KG DC 42' },
            { 'vendorProductId': '965981', 'name': 'PK 0:10:24 GRAN 50KG' },
            { 'vendorProductId': '965983', 'name': 'PK 0:10:24 GRAN BIG BAG' },
            { 'vendorProductId': '972894', 'name': 'NPK 13:6:16 LOSE LAT NPK' },
            { 'vendorProductId': '972895', 'name': 'NPK 13:6:16 50 KG LAT NPK' },
            { 'vendorProductId': '972896', 'name': 'NPK 12:12:17 LOSE LINZER TOP' },
            { 'vendorProductId': '972897', 'name': 'NPK 12:12:17 50KG LINZER TOP' },
            { 'vendorProductId': '973290', 'name': 'KOHLENS KALK 25KG' },
            { 'vendorProductId': '975071', 'name': 'NPK 5:13:24 LOSE' },
            { 'vendorProductId': '975101', 'name': 'KAS 27% GRAN 25KG' },
            { 'vendorProductId': '975371', 'name': 'NPK 12:7:18 LOSE ENTEC VINO' },
            { 'vendorProductId': '975372', 'name': 'NPK 12:7:18 50KG ENTEC VINO' },
            { 'vendorProductId': '976076', 'name': 'PK 0:10:30+6S+B BB 600KG DC RÜBE' },
            { 'vendorProductId': '976099', 'name': 'NPK 14:10:20+7GRAN LOSE DUSLOFERT' },
            { 'vendorProductId': '976142', 'name': 'PK 8:18 EUROFERTIL 26 PLUS LOSE' },
            { 'vendorProductId': '979303', 'name': 'PK 0:15:30 DC45er BIG BAG 600 KG' },
            { 'vendorProductId': '981170', 'name': 'PK 18:18 EUROFERTIL 36 PLUS LOSE' },
            { 'vendorProductId': '981171', 'name': 'SULFAMMO 23 MESACTYL N-PRO LOSE' },
            { 'vendorProductId': '981704', 'name': 'NPK 6:10:16 BIG BAG DC BOR START' },
            { 'vendorProductId': '982029', 'name': 'BIOFERT GESACKT' },
            { 'vendorProductId': '982773', 'name': 'NPK 14:10:20+7GRAN BIGBAG DUSLOFERT' },
            { 'vendorProductId': '987764', 'name': 'PATENTKALI 30% GRAN LOSE' },
            { 'vendorProductId': '987895', 'name': 'AMMONSULFAT 21%N+24%S GRANULIERT LOSE' },
            { 'vendorProductId': '987937', 'name': 'NPK 16:16:16 50KG' },
            { 'vendorProductId': '988064', 'name': 'NPK 12:8:15 50KG' },
            { 'vendorProductId': '988066', 'name': 'NPK 12:8:15 LOSE' },
            { 'vendorProductId': '989653', 'name': 'KALI 60% GRAN BIG BAG 1.000 KG K+S' },
        ];

        var additionalProducts = {};
        additionalProducts['5c76645d34ce49001536eb6a'] = additionalProducts_5c76645d34ce49001536eb6a; // RWA - Düngemittel
        additionalProducts['5cd1b774f5d36d0015753d88'] = additionalProducts_5c76645d34ce49001536eb6a; // RWA test
        additionalProducts['5bdc855793e9dd001455358f'] = additionalProducts_5c76645d34ce49001536eb6a; // Staging
        additionalProducts['5d88c13e07b32f00154b7b2a'] = additionalProducts_5c76645d34ce49001536eb6a; // Staging

        this.additionalProducts = additionalProducts;
    }  

    

    ProductsService.$inject = ['$rootScope', '$q', '$log', 'HttpService'];
})();
(function () {
  'use strict';

  angular
    .module('app')
    .service('DealsService', DealsService);

  function DealsService($rootScope, $state, $templateCache, $ngConfirm, $q, $log,
    gettextCatalog, HttpService, AlertService, Utils, AuthFactory, CropService, ProductsService,
    DEAL_STATUS, DEAL_CATEGORY, DEAL_CONSTANTS, PRODUCT_TYPES, PRODUCT_UNITS, REQUEST_TYPES, DEAL_TARGET, ORDER_STATUS) {

    var DISTRIBUTION_METHODS = {
      DELIVERY: 'delivery',
      COLLECTION: 'collection',
    }

    this.getFarmTypes = function () {
      return [
        { value: 'cereal', label: gettextCatalog.getString('Cereal') },
        { value: 'pig', label: gettextCatalog.getString('Pig') },
        { value: 'piglet', label: gettextCatalog.getString('Piglet') },
        { value: 'beef', label: gettextCatalog.getString('Beef') },
        { value: 'dairy', label: gettextCatalog.getString('Dairy') },
        { value: 'poultry', label: gettextCatalog.getString('Poultry') },
        { value: 'fruit', label: gettextCatalog.getString('Fruit') },
        { value: 'winegrowing', label: gettextCatalog.getString('Winegrowing') },
        { value: 'horticulture', label: gettextCatalog.getString('Horticulture/gardening') },
        { value: 'foresty', label: gettextCatalog.getString('Foresty') },
        { value: 'suckler', label: gettextCatalog.getString('Suckler') },
        { value: 'sheep', label: gettextCatalog.getString('Sheep') },
        { value: 'contractor', label: gettextCatalog.getString('Agricultural Contractor') },
        { value: 'technic', label: gettextCatalog.getString('Technic') },
      ];
    };

    this.getFarmTypesMap = function () {
      return Utils.valueToLabelMap(this.getFarmTypes());
    };

    this.getSystems = function () {
      return [
        { value: '', label: gettextCatalog.getString('Any') },
        { value: 'organic', label: gettextCatalog.getString('Organic') },
        { value: 'conventional', label: gettextCatalog.getString('Conventional') }
      ];
    }

    this.getSystemsMap = function () {
      return Utils.valueToLabelMap(this.getSystems());
    }

    this.getProductTypes = function () {
      if (Utils.getSettings().customProductTypes) {
        return $rootScope.app.Auth.User.supplier.productTypes;
      }
      if (Utils.isSupplierCountryAustria() || Utils.isSupplierCountryGermany()) {
        return PRODUCT_TYPES.DE;
      }
      if (Utils.isSupplierCountryHungary()) {
        return PRODUCT_TYPES.HU;
      }
      return PRODUCT_TYPES.IE;
    };

    this.getProductUnits = function () {
      if (Utils.isSupplierCountryAustria() || Utils.isSupplierCountryGermany()) {
        return PRODUCT_UNITS.DE;
      }
      if (Utils.isSupplierCountryHungary()) {
        return PRODUCT_UNITS.HU;
      }
      return PRODUCT_UNITS.IE;
    };

    this.getRequestTypes = function () {
      if (Utils.isSupplierCountryAustria() || Utils.isSupplierCountryGermany()) {
        return REQUEST_TYPES.DE;
      }
      if (Utils.isSupplierCountryHungary()) {
        return REQUEST_TYPES.HU;
      }
      return REQUEST_TYPES.IE;
    }

    this.getDistributionMethods = function() {
      return [
        { label: '---', value: undefined },
        { label: gettextCatalog.getString('Delivery'), value: DISTRIBUTION_METHODS.DELIVERY },
        { label: gettextCatalog.getString('Collection'), value: DISTRIBUTION_METHODS.COLLECTION }
      ];
    }

    this.loadDeal = function (dealId) {
      $log.log('Loading deal', dealId)
      var deferred = $q.defer();
      var result = {};
      var _this = this;

      HttpService.Get('deals/' + dealId).then(function (data) {
        if ($rootScope.app.Auth.User.supplier._id != data.supplier._id) {
          AlertService.error(gettextCatalog.getString('Unauthorized access'), gettextCatalog.getString('You do not have permissions to view this deal.'));
          $state.go('app.deals.list');
        }
        // Setup model
        result.model = data;
        if (Utils.isNumber(result.model.benchmarkPrice)) {
          result.model.benchmarkPrice = parseFloat(result.model.benchmarkPrice);
        }
        else {
          result.model.individualDiscount = 0;
          result.model.clearanceDiscount = 0;
          result.model.groupDiscount = {};
        }
        result.model.system = result.model.system || '';
        if (!result.model.imageUrl) {
          result.model.imageUrl = DEAL_CONSTANTS.DEFAULT_IMAGE;
        }

        result.model.bookingStart = moment(data.bookingStart);
        result.model.bookingEnd = moment(new Date(data.bookingEnd));
        result.deliveryStart = moment(new Date(data.deliveryStart));
        result.deliveryEnd = moment(new Date(data.deliveryEnd));
        
        result.model.customUnit = _this.getUpdatedUnit(result.model.customUnit);

        var minDate = moment();
        if (result.model.status === DEAL_STATUS.DRAFT) {
          if (minDate.isAfter(data.bookingStart)) {
            result.model.bookingStart = moment(minDate); // eslint-disable-line no-undef
          }
          if (minDate.isAfter(data.bookingStart)) {
            result.model.bookingEnd = moment(minDate).add(DEAL_CONSTANTS.DEAL_LENGTH_DAYS, 'day').endOf('day'); // eslint-disable-line no-undef
          }
          if (minDate.isAfter(data.deliveryStart)) {
            result.deliveryStart = moment(minDate).add(DEAL_CONSTANTS.DELIVERY_START_AFTER_DAYS, 'day').startOf('day'); // eslint-disable-line no-undef
          }
          if (minDate.isAfter(data.deliveryEnd)) {
            result.deliveryEnd = moment(minDate).add(DEAL_CONSTANTS.DELIVERY_LENGTH_DAYS, 'day').endOf('day'); // eslint-disable-line no-undef
          }
        }

        result.existingDealUsers = result.model.users.slice();

        if (result.model.target === DEAL_TARGET.NEW_USERS) {
          result.model.radius = 600;
          result.model.location.coordinates = DEAL_CONSTANTS.INTIAL_COORDINATES[$rootScope.app.Auth.User.supplier.area.toLowerCase()];
        }
        result.model.radius = Math.round(result.model.radius);

        if (Utils.isSupplierDistributor()) {
          result.model.isRetailerOrderFlexible = true;
        }
        if (Utils.isSupplierDistributor() && !result.model.allowModifyOrderHours && result.model.allowModifyOrderHours !== 0) {
          result.model.allowModifyOrderHours = 24;
        }

        $log.log('Load deal complete.');
        deferred.resolve(result);
      }, function (err) {
        $log.error('Error occurred while loading the deal.', err);
        AlertService.error(gettextCatalog.getString('Invalid deal'), gettextCatalog.getString('This deal does not exist anymore.'));
        $state.go('app.deals.list');

        deferred.reject(err);
      });

      return deferred.promise;
    };

    // TODO: remove farmTypes and macConfig parameters
    this.saveDeal = function (deal, product, farmTypes, mapConfig) {
      var deferred = $q.defer();

      // Make sure discount info is not stored for CROP deals
      if (this.isCategoryCrop(deal) || Utils.isSupplierDistributor()) {
        deal.individualDiscount = null;
        deal.clearanceDiscount = null;
        deal.groupDiscount = null;
        deal.quantityDiscounts = null;
      }

      if (!this.isCategoryCrop(deal)) {
        deal.product = product;
        if (!deal.clearanceDiscount || (!this.isGroupDiscountEnabled(deal) && !this.isQuantityDiscountEnabled(deal))) {
          deal.clearanceDiscount = deal.individualDiscount;
        }
      }

      if (this.isDistributionCollection(deal)) {
        deal.deliveryLocation = null;
      }

      if (!deal.dealSizeOptions) {
        deal.dealSizeOptions = {
          min: 1,
          step: 1
        };
      }
      if (deal.dealSize) {
        deal.dealSize = Math.floor(deal.dealSize / deal.dealSizeOptions.step) * deal.dealSizeOptions.step;
        deal.dealSize = Utils.roundDecimals(deal.dealSize);
      }

      if (deal.deliveryStart) {
        deal.deliveryStart = deal.deliveryStart.startOf('day');
      }      
      if (deal.deliveryEnd) {
        deal.deliveryEnd = deal.deliveryEnd.endOf('day');
      }

      // TODO: remove references to circles
      if (!Utils.isSupplierDistributor()) {
        // If target is group, set dummy coordinate, otherwise use circle coordinates.
        deal.location.coordinates = [mapConfig.circles[0].center.longitude, mapConfig.circles[0].center.latitude];
        deal.radius = Math.round(mapConfig.circles[0].radius / 1000);
      }

      if (deal.target === DEAL_TARGET.NEW_USERS) {
        deal.radius = 600;
        deal.location.coordinates = DEAL_CONSTANTS.INTIAL_COORDINATES[$rootScope.app.Auth.User.supplier.area.toLowerCase()];
      }

      if (Utils.isSupplierDistributor() && deal.allowModifyOrderHours < 0) {
        deal.allowModifyOrderHours = 0;
      }

      deal.forceUndefinedValues = true;

      HttpService.Put('deals/' + deal._id, deal).then(function (res) {
        if (deal.status === DEAL_STATUS.ACTIVE) {
          AlertService.success(gettextCatalog.getString('Offer published'));
        } else {
          AlertService.success(gettextCatalog.getString('Offer saved'));
        }
        deferred.resolve(res.data);
      }, function (err) {
        $log.error(err);
        deferred.reject(err);
      });

      return deferred.promise;
    };

    this.createDraftWithNewProduct = function (dealData, productName) {
      var _this = this;
      var supplier = $rootScope.app.Auth.User.supplier;
      
      if (!productName) {
        productName = this.isCategoryCrop(dealData) ?
          CropService.getCropTypes(supplier)[0].label :
          gettextCatalog.getString('Sample product');
      }
      var data = {
        name: productName,
        categoryName: this.isCategoryCrop(dealData) ? 'CROP' : undefined
      };
      $log.log('DealsService: Creating new default product.');
      HttpService.Post('suppliers/' + supplier._id + '/products', data).then(function (res) {
        dealData.product = res.data;
        _this.createNewDraft(dealData);
        return;
      }, function (err) {
        $log.error('Error supplier fetch', err);
      });
    }

    this.getDealDraft = function() {
      var supplier = $rootScope.app.Auth.User.supplier;
      return {
        supplier: supplier._id,
        location: {
          coordinates: DEAL_CONSTANTS.INTIAL_COORDINATES[supplier.area.toLowerCase()],
          type: 'Point'
        },
        target: DEAL_TARGET.NEW_USERS,
        radius: 600,
        users: [],
        benchmarkPrice: null,
        dealSize: null,
        individualDiscount: null,
        distribution: 'delivery',
        farmType: 'any'
      };
    }

    // TODO: move to API
    this.createNewDraft = function (dealData) {
      var _this = this;
      var supplier = $rootScope.app.Auth.User.supplier;
      
      if (!dealData.product && this.isCategoryCrop(dealData)) {
        $log.log('DealsService: Looking for existing crop.');
        var cropName = CropService.getCropTypes(supplier)[0].label;
        ProductsService.getFilteredProducts(cropName, 1).then(function (existingProducts) {
          if (!existingProducts || !existingProducts.length) {
            _this.createDraftWithNewProduct(dealData);
            return;
          }
          dealData.product = existingProducts[0];
          _this.createNewDraft(dealData);
          return;
        });
        return;
      }
      else if (!dealData.product) {
        _this.createDraftWithNewProduct(dealData);
        return;
      }

      var dealDraft = {
        supplier: supplier._id,
        location: {
          coordinates: DEAL_CONSTANTS.INTIAL_COORDINATES[supplier.area.toLowerCase()],
          type: 'Point'
        },
        target: DEAL_TARGET.NEW_USERS,
        radius: 600,
        users: [],
        benchmarkPrice: null,
        dealSize: null,
        individualDiscount: null,
        distribution: 'delivery',
        farmType: 'any'
      };

      dealDraft.bookingStart = moment();
      dealDraft.bookingEnd = moment(dealDraft.bookingStart ).add(DEAL_CONSTANTS.DEAL_LENGTH_DAYS, 'day').endOf('day');
      dealDraft.deliveryStart = moment(dealDraft.bookingStart ).add(DEAL_CONSTANTS.DELIVERY_START_AFTER_DAYS, 'day').startOf('day');
      dealDraft.deliveryEnd = moment(dealDraft.bookingStart ).add(DEAL_CONSTANTS.DELIVERY_LENGTH_DAYS, 'day').endOf('day');

      dealDraft._id = undefined;
      dealDraft.status = DEAL_STATUS.DRAFT; // Make sure deal id is not set and status is DRAFT
      dealDraft.progress = 0;
      dealDraft.purchases = [];
      dealDraft.orders = [];
      dealDraft.soldOut = false;
      dealDraft.isPromoted = false;
      dealDraft.isStopped = false;

      dealDraft.updatedAt = undefined;
      dealDraft.createdAt = undefined;
      dealDraft.createdBy = undefined;
      dealDraft.updatedBy = undefined;
      dealDraft.retailerOrder = undefined;
      dealDraft.requests = undefined;
      dealDraft.notificationId = undefined;
      dealDraft.retailDeals = [];

      if (dealData) {
        dealDraft = Utils.mergeObject(dealDraft, dealData);
      }

      if (Utils.isSupplierDistributor()) {
        dealDraft.target = DEAL_TARGET.SUPPLIERS;
      }

      HttpService.Post('deals', dealDraft).then(function (res) {
        AlertService.success(gettextCatalog.getString('Draft created'));
        _this.goToEditIfDraft(res.data, !dealData.cloneOf && !dealData.skipSelectProductOnInit, dealData.startIntro);
      }, function (err) {
        $log.error('Error create deal', err);
        AlertService.error('', gettextCatalog.getString('Error while creating new deal'));
      });
    };

    this.cloneDeal = function (dealSource) {
      var dealCloned = Utils.mergeObject({}, dealSource);

      dealCloned.cloneOf = dealSource._id;

      dealCloned._id = undefined;
      dealCloned.status = DEAL_STATUS.DRAFT; // Make sure deal id is not set and status is DRAFT
      dealCloned.progress = 0;
      dealCloned.purchases = [];
      dealCloned.orders = [];
      dealCloned.soldOut = false;
      dealCloned.isPromoted = false;
      dealCloned.isStopped = false;

      dealCloned.updatedAt = undefined;
      dealCloned.createdAt = undefined;
      dealCloned.createdBy = undefined;
      dealCloned.updatedBy = undefined;
      dealCloned.retailerOrder = undefined;
      dealCloned.requests = undefined;
      dealCloned.notificationId = undefined;
      dealCloned.retailDeals = [];

      dealCloned.bookingStart = moment();
      dealCloned.bookingEnd = moment(dealCloned.bookingStart).add(DEAL_CONSTANTS.DEAL_LENGTH_DAYS, 'day').endOf('day');

      return this.createNewDraft(dealCloned);
    }

    // TODO have createNewDraft return promise and remove this function
    this.goToEditIfDraft = function (deal, selectProductOnInit, startIntro) {
      if (deal.status === DEAL_STATUS.DRAFT) {
        if (deal.categoryName === DEAL_CATEGORY.CROP) {
          $state.go('app.crop.proc', { id: deal._id });
        } else {
          $state.go('app.deals.update', { id: deal._id, selectProductOnInit: selectProductOnInit, startIntro: startIntro });
        }
      }
    };

    this.getUpdatedUnit = function (unit) {
      var vatStrList = [
        '(inc. vat)', 'inc. vat', '(incl. vat)', 'incl. vat', '(inclusive vat)', 'inclusive vat',
        '(exc. vat)', 'exc. vat', '(excl. vat)', 'excl. vat', '(exclusive vat)', 'exclusive vat',
        '(ink. ust)', 'ink. ust', '(inkl. ust)', 'inkl. ust', '(inklusive vat)', 'inklusive vat',
        '(exk. ust)', 'exk. ust', '(exkl. ust)', 'exkl. ust', '(exklusive vat)', 'exklusive vat',
        '(ÁFA nélkül)', '(ÁFÁ-val)'
      ];
      if (!unit || !unit.trim()) {
        return unit;
      }
      var cleanUnit = unit;
      vatStrList.forEach(function (vatStr) {
        var idx = cleanUnit.toLowerCase().indexOf(vatStr.toLowerCase());
        if (idx >= 0) {
          cleanUnit = cleanUnit.substring(0, idx) + cleanUnit.substring(idx + vatStr.length, cleanUnit.length);
        }
      });
      return cleanUnit.trim();
    };

    this.isCategoryCrop = function (d) {
      if (!d) {
        return false;
      }
      return d.hasOwnProperty('categoryName') && d.categoryName === DEAL_CATEGORY.CROP;
    };
    this.isQuantityDiscountEnabled = function (d) {
      if (!d) {
        return false;
      }
      if (this.isGroupDiscountEnabled(d)) {
        return false;
      }
      return d.quantityDiscounts && d.quantityDiscounts.length > 1;
    };
    this.isGroupDiscountEnabled = function (d) {
      return d && d.groupDiscount && !!d.groupDiscount.quantityThreshold;
    };
    // TODO rename this function to isGroupDiscountEnabledButNotActive
    this.isGroupDiscountInvalid = function (d) {
      return d && d.progress < d.groupDiscount.quantityThreshold;
    };
    this.isDraft = function (d) {
      return d && d.status === DEAL_STATUS.DRAFT;
    };
    this.isBookingStartInTheFuture = function (d) {
      return d && moment().isBefore(d.bookingStart); // eslint-disable-line no-undef
    }
    this.isActive = function (d) {
      return d && d.status === DEAL_STATUS.ACTIVE && !this.isBookingStartInTheFuture(d) && moment().isBefore(d.bookingEnd); // eslint-disable-line no-undef
    };
    this.isExpired = function (d) {
      return d && (d.status === DEAL_STATUS.EXPIRED || moment().isAfter(d.bookingEnd)); // eslint-disable-line no-undef
    };
    this.isDistributionDelivery = function (d) {
      return d && d.distribution === DISTRIBUTION_METHODS.DELIVERY;
    };
    this.isDistributionCollection = function (d) {
      return d && d.distribution === DISTRIBUTION_METHODS.COLLECTION;
    };
    this.isScheduled = function (d) {
      return d && d.status === DEAL_STATUS.ACTIVE && this.isBookingStartInTheFuture(d) && moment().isBefore(d.bookingEnd); // eslint-disable-line no-undef
    }

    this.isOrderCompleted = function (order) {
      if (!order) {
        return false;
      }
      return order.status === ORDER_STATUS.COMPLETED;
    };
    this.isOrderPending = function (order) {
      if (!order) {
        return false;
      }
      return !order.status || order.status === ORDER_STATUS.VIEWED || order.status === ORDER_STATUS.PENDING;
    };
    this.isOrderInvalid = function (order) {
      if (!order) {
        return false;
      }
      return order.status === ORDER_STATUS.INVALID;
    };
    this.isOrderPaid = function (order) {
      if (!order) {
        return false;
      }
      return order.status === ORDER_STATUS.PAID;
    };

    this.decreasePriceDecimalDigits = function (deal) {
      if (deal.priceDecimalDigits < 3) {
        return;
      }
      deal.priceDecimalDigits--;
    }
    this.increasePriceDecimalDigits = function(deal) {
      deal.priceDecimalDigits ++;
    }

    this.switchVatIncluded = function (deal) {
      var deferred = $q.defer();
      
      deal.vatRate = (deal.vatRate || $rootScope.app.Auth.User.supplier.vatRate || 0.2);
      if (deal.isVatIncluded) {
        deal.isVatIncluded = false;
        deal.benchmarkPrice = Utils.roundCurrencyValue(deal.benchmarkPrice / (1 + deal.vatRate));
        deferred.resolve(deal.isVatIncluded);
        return deferred.promise;
      }

      var scope = $rootScope.$new(true);
      scope.vatRatePercent = Utils.roundDecimals((deal.vatRate || $rootScope.app.Auth.User.supplier.vatRate || 0) * 100);
      var content = 
        '<div class="input-group mb-5">' +
        '<span class="input-group-addon">%</span>' +
        '<input autocomplete="off" autofocus type="number" ng-model="vatRatePercent" id="vatRate" name="vatRate" placeholder="" class="form-control">' +
        '</div>';

      $ngConfirm({
        title: gettextCatalog.getString('VAT'),
        content: content,
        scope: scope,
        animation: 'bottom',
        closeAnimation: 'bottom',
        buttons: {
          cancel: {
            text: gettextCatalog.getString('Cancel'),
            keys: ['esc'],
            btnClass: 'btn-dark btn-wide',
          },
          ok: {
            text: gettextCatalog.getString('Ok'),
            keys: ['enter'],
            btnClass: 'btn-success btn-wide',
            action: function () {
              deal.vatRate = scope.vatRatePercent / 100;
              deal.isVatIncluded = true;
              deal.benchmarkPrice = Utils.roundCurrencyValue(deal.benchmarkPrice * (1 + deal.vatRate))
              deferred.resolve(deal.isVatIncluded);
            }
          }
        }
      });
      return deferred.promise;
    }

    this.fetchAffectedUsers = function (d, additionalParams) {
      // TODO generalize this
      if (d.target === DEAL_TARGET.SUPPLIERS) {
        return;
      }

      var deferred = $q.defer();
      var _this = this;

      if (d.target === DEAL_TARGET.NEW_USERS) {
        d.radius = 600;
        d.location.coordinates = DEAL_CONSTANTS.INTIAL_COORDINATES[$rootScope.app.Auth.User.supplier.area.toLowerCase()];
      }

      var payload = {};
      if (d.farmTypes && d.farmTypes.length) {
        payload.farmTypes = d.farmTypes;
      }
      if (d.system) {
        payload.system = d.system;
      }

      payload = Utils.mergeObject(payload, additionalParams);
      HttpService.Post('deals/users', payload).then(function (res) {
        var foundUsers = res.data;
        if (d.target !== DEAL_TARGET.NEW_USERS) {
          _this.flagExcludedUsers(foundUsers, d.users);
        }
        d.users = foundUsers.filter(function (u) { return !u.isExcluded; });
        deferred.resolve(foundUsers);
      }, function (err) {
        $log.error('Error loading data for users in specified area.', err);
        deferred.reject(err);
      });

      return deferred.promise;
    };

    this.flagExcludedUsers = function (allUsers, dealUsers) {
      var existingDealUsersMap = dealUsers.reduce(function (map, obj) {
        map[obj._id] = true;
        return map;
      }, {});
      allUsers.forEach(function (user) {
        if (!existingDealUsersMap[user._id]) {
          user.isExcluded = true;
        }
      });
    };

    this.getRetailerPricesRange = function (deal) {
      if (!Utils.isSupplierDistributor() || !deal.retailPrices || !deal.retailPrices.length) {
        return Utils.getLocalizedCurrency(deal.benchmarkPrice, deal.priceDecimalDigits)
      }
      if (deal.retailPrices.length === 1) {
        return Utils.getLocalizedCurrency(deal.retailPrices[0].rrp || deal.benchmarkPrice, deal.priceDecimalDigits);
      }

      var prices = deal.retailPrices.map(function (p) {
        return p.rrp || deal.benchmarkPrice;
      })
      var minValue = prices.reduce(function (p, c) {
        return Math.min(p, c);
      }, prices[0]);
      var maxValue = prices.reduce(function (p, c) {
        return Math.max(p, c);
      }, prices[0]);

      if (minValue === maxValue) {
        return Utils.getLocalizedCurrency(minValue, deal.priceDecimalDigits);
      }
      return Utils.getLocalizedCurrency(minValue, deal.priceDecimalDigits) + ' - ' + Utils.getLocalizedCurrency(maxValue, deal.priceDecimalDigits);
    }

    // ----------------
    // Internal functions

    function copyProductInfoToDealNullFields(deal, product) {
      if (!deal.vendorProductId) {
        deal.vendorProductId = product.vendorProductId;
      }
      if (!deal.customType) {
        deal.vendorProductId = product.categoryName;
      }
      if (!deal.unit) {
        deal.vendorProductId = product.unit;
      }

      var fieldToCopy = [
        { source: 'vendorProductId', dest: 'vendorProductId' },
        { source: 'categoryName', dest: 'customType' },
        { source: 'unit', dest: 'customUnit' },
        { source: 'dealSizeOptions', dest: 'dealSizeOptions' },
      ];

      fieldToCopy.forEach(function (field) {
        deal[field.dest] = product[field.source];
      });
      if (!deal.imageUrl && product.imageUrls && product.imageUrls.length) {
       deal.imageUrl = product.imageUrls[0]; 
      }

      if (product.attributes) {
        deal.productAttributes = [];
        product.attributes.forEach(function (attr) {
          deal.productAttributes.push(Object.assign({}, attr));
        }); 
      }

      if (deal.dealSize >= DEAL_CONSTANTS.DEAL_SIZE_INFINITE) {
        deal.dealSize = undefined;
      }
      deal.dealSizeOptions = deal.dealSizeOptions || {};
      deal.dealSizeOptions.step = deal.dealSizeOptions.step || 1;
      deal.dealSizeOptions.min = deal.dealSizeOptions.min || deal.dealSizeOptions.step;
    }

    function getDealToCopyInfoFrom(product) {
      if (!product.deals || !product.deals.sent) {
        return null;
      }
      var ongoing = product.deals.sent.ongoing;
      var latest = product.deals.sent.latest && product.deals.sent.latest.length ? product.deals.sent.latest[0] : undefined;

      if (!latest && !ongoing) {
        return null;
      }
      if (!latest && ongoing) {
        return ongoing;
      }
      if (latest && !ongoing) {
        return latest;
      }
      // both latest and ongoing present, send the latest.
      return moment(latest.publishedAt).isBefore(ongoing.publishedAt) ? ongoing : latest;
    }

    /**
     * Copy all information from product to deal.
     * @param {*} deal Destination
     * @param {*} product Source
     */
    this.copyProductInfoToDeal = function (deal, product) {
      var deferred = $q.defer();
      var latestDeal = getDealToCopyInfoFrom(product);

      if (!latestDeal || (deal.requests && deal.requests.length)) {
        copyProductInfoToDealNullFields(deal, product);
        deferred.resolve();
        return deferred.promise;
      }

      

      HttpService.Get('deals/' + latestDeal._id).then(function (latestDeal) { 
        var fieldToCopy = ['customType', 'customUnit', 'vendorProductId', 'imageUrl',
          'benchmarkPrice', 'quantityDiscounts', 'individualDiscount', 'clearanceDiscount', 'isVatIncluded', 'retailPrices', 'priceDecimalDigits',
          'dealSize', 'dealSizeOptions', 'description', 'attachments', 'variants',
          'distribution', 'deliveryLocation', 'collectionPoints',
          'location', 'radius', 'searchText', 'farmTypes', 'system', 'country', 'zipCodes', 'users',
          'paymentMethod', 'payment', 'isCollectionPointRequired', 'isCustomerIdRequired', 'allowModifyOrderHours'];
        
        fieldToCopy.forEach(function(field) {
          deal[field] = latestDeal[field];
        });

        copyProductInfoToDealNullFields(deal, product);
        deferred.resolve();
      }).catch(function() {
        deferred.reject();
      })
      return deferred.promise;
    };

    this.getAvailabilityForUser = function (deal) {
      var availablity = deal.dealSize - deal.progress;
      if (deal.reservationOrder) {
        availablity += deal.reservationOrder.amount;
      }
      if (!deal.dealSizeOptions || !deal.dealSizeOptions.max) {
        return availablity > 0 ? availablity : 0;
      }
      var individualAvailability = deal.dealSizeOptions.max - deal.userBooking;
      if (individualAvailability < availablity) {
        return individualAvailability > 0 ? individualAvailability : 0;
      }
      return availablity > 0 ? availablity : 0;
    };


  } // DealsService

  DealsService.$inject = ['$rootScope', '$state', '$templateCache', '$ngConfirm', '$q', '$log',
    'gettextCatalog', 'HttpService', 'AlertService', 'Utils', 'AuthFactory', 'CropService', 'ProductsService',
    'DEAL_STATUS', 'DEAL_CATEGORY', 'DEAL_CONSTANTS', 'PRODUCT_TYPES', 'PRODUCT_UNITS', 'REQUEST_TYPES', 'DEAL_TARGET', 'ORDER_STATUS'];
})();

(function() {
  'use strict';

  angular.module('app').component('home', {
    controller: HomeController,
    controllerAs: 'vm',
    templateUrl: 'app/home/home.view.html',
  });

  /** @ngInject */
  function HomeController($state) {
    $state.go('app.dashboard');
  }

})();

/**
 * Created by Hafeez Rehman on 27/01/2018.
 */

(function(){
    'use strict';

     angular
         .module('app')
            .filter('propsFilter', function() {
                 return function(items, props) {
                     var out = [];

                     if (angular.isArray(items)) {
                         var keys = Object.keys(props);

                         items.forEach(function(item) {
                             var itemMatches = false;

                             for (var i = 0; i < keys.length; i++) {
                                 var prop = keys[i];
                                 var text = props[prop].toLowerCase();
                                 if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                                     itemMatches = true;
                                     break;
                                 }
                             }

                             if (itemMatches) {
                                 out.push(item);
                             }
                         });
                     } else {
                         // Let the output be the input untouched
                         out = items;
                     }

                     return out;
                 };
             });
})();
/**
 * Created by Hafeez Rehman on 14/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app')
            .filter('capitalize', CapitalizeFilter);

    function CapitalizeFilter() {
        return function(input) {
            return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : ''; // eslint-disable-line
        }
    }
})();
/**
 * Created by Hafeez Rehman on 08/12/2017.
 */

(function () {
    'use strict';

    angular
        .module('app')
        .factory('MapFactory', MapFactory);

    MapFactory.$inject = ['$rootScope', 'uiGmapGoogleMapApi'];

    function MapFactory($rootScope, uiGmapGoogleMapApi) {

        function MapHandler() {}

        MapHandler.prototype.GetTypeMaps = function (list) {
            return list.reduce(function (map, obj) {
                map[obj.value] = obj.label;
                return map;
            }, {});
        };

        MapHandler.prototype.init = function (callBack) {
            uiGmapGoogleMapApi.then(function (map) {
                callBack(map);
            });
        };

        MapHandler.prototype.GetSearchboxConfig = function (placeCallback) {
            return {
                template: 'searchbox.tpl.html',
                options: {
                    autocomplete: true,
                    types: ['(regions)'],
                    componentRestrictions: {
                        country: ['ie', 'de', 'at', 'gb', 'hu']
                    }
                },
                events: {
                    place_changed: placeCallback
                }
            };
        };

        MapHandler.prototype.SetMapCenterToDealLocation = function (map, model, skipCircleUpdate) {
            map.center.latitude = model.location.coordinates[1];
            map.center.longitude = model.location.coordinates[0];
            if (!skipCircleUpdate) {
                map.circles[0].center.latitude = map.center.latitude;
                map.circles[0].center.longitude = map.center.longitude;
            }
            this.SetMapZoomToDealRadius(map, model, skipCircleUpdate);
        };

        MapHandler.prototype.SetMapZoomToDealRadius = function (map, model, skipCircleUpdate) {
            if (!model.radius) {
                return;
            }
            var radiusInKm = model.radius;
            var maxZoom = 8;
            // IE11 does not support log2
            map.zoom = Math.min(maxZoom, 15.5 - Math.log(radiusInKm) / Math.log(2));
            if (!skipCircleUpdate) {
                map.circles[0].radius = radiusInKm * 1000;
            }
        };

        MapHandler.prototype.GetDealMapConfig = function (locationAndRadiusChangesHandler) {
            var defaultCenter = {
                latitude: 0,
                longitude: 0
            };
            var defaultZoom = 8;
            var defaultRadius = 30;

            return {
                control: {},
                center: { latitude: defaultCenter.latitude, longitude: defaultCenter.longitude },
                zoom: defaultZoom,
                dragging: false,
                markers: [],
                idkey: 'place_id',
                options: {
                    mapTypeId: google.maps.MapTypeId.HYBRID, // eslint-disable-line
                    streetViewControl: false,
                    fullscreenControl: false,
                    scrollwheel: false,
                    draggable: true
                },
                events: {
                    idle: function (map) {} // eslint-disable-line
                },
                circles: [{
                    id: 1,
                    center: { latitude: defaultCenter.latitude, longitude: defaultCenter.longitude },
                    radius: defaultRadius * 1000,
                    stroke: {
                        color: '#08B21F',
                        weight: 5,
                        opacity: 1
                    },
                    fill: {
                        color: '#08B21F',
                        opacity: 0.15
                    },
                    geodesic: true,
                    draggable: false,
                    clickable: false,
                    editable: true,
                    visible: true,
                    events: {
                        radius_changed: function () {
                            setTimeout(function () {
                                locationAndRadiusChangesHandler();
                            }, 200);
                        },
                        center_changed: function () {
                            setTimeout(function () {
                                locationAndRadiusChangesHandler();
                            }, 200);
                        }
                    }
                }]
            };
        };

        return new MapHandler();
    }

})();
/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app')
            .service('APIInterceptor', HttpInterceptor);

    function HttpInterceptor($rootScope, $q, $localStorage, AlertService){

        var loadCount = 0;
        this.request = function(config) {
            loadCount++;
            $('.global-spinner').show();
            return config;
        };

        this.response = function(response){
            if((--loadCount) === 0) {
                $('.global-spinner').fadeOut(1);
            }
            if(response.headers('X-Total-Count')) {
                response.data = { list : response.data, count: response.headers('X-Total-Count') };
            }
            return response || $q.when(response);
        };

        this.responseError = function(rej) {
            AlertService.error(null, 'Error code ' + rej.status);
            if((--loadCount) === 0) {
                $('.global-spinner').fadeOut(1);
            }
            if(rej.status===401) {
                $rootScope.$broadcast('unauthorized');
            }
            return $q.reject(rej);
        };
    }

    HttpInterceptor.$inject = ['$rootScope', '$q', '$localStorage', 'AlertService'];
})();
/**
 * Created by Hafeez Rehman on 10/11/2017.
 */
(function(){
    'use strict';

    angular
        .module('app')
            .factory('HttpService', HttpService);

    function HttpService($state, $q, $http, $log, API_CONFIG) {

        var _self = this;
        _self.name = 'farmhedge api handler factory';
        _self.baseUrl = API_CONFIG.apiPrefix;

        var api = {};
        api.Get = function(url, params) {
            var apiUrl;
            if (params){
                var queryString = '?' + Object.keys(params).map(function(k) {
                    return k + '=' + params[k];
                }).join('&');
                apiUrl = _self.baseUrl + url + encodeURI(queryString);
            } else {
                apiUrl = _self.baseUrl + url;
            }

            var deferred = $q.defer();
            $http.get(apiUrl)
                .then(function(res) {
                    var data = res.data;
                    data.headers = res.headers;
                    deferred.resolve(data);
                }, function(data, status, headers, config){
                    $log(data);
                    $log('Error occurred while performing \nGET:', apiUrl);
                    $log(config);
                    deferred.reject(data);
                });

            return deferred.promise;
        };

        api.Post = function(url, requestBody) {
            var apiUrl = _self.baseUrl + url;
            var deferred = $q.defer();

            $http.post(apiUrl, requestBody)
                .then(function(res){
                    deferred.resolve(res);
                }, function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        api.Put = function(url, requestBody) {
            var apiUrl = _self.baseUrl + url;
            var deferred = $q.defer();

            $http.put(apiUrl, requestBody)
                .then(function(res){
                    deferred.resolve(res);
                }, function(data, status, headers, config){
                    $log(data);
                    $log('Error occurred while performing \nPUT:', apiUrl);
                    $log(config);
                    deferred.reject(data);
                });

            return deferred.promise;
        };

        api.Delete = function(url) {
            var apiUrl = _self.baseUrl + url;
            var deferred = $q.defer();

            $http.delete(apiUrl)
                .then(function(res){
                    deferred.resolve(res);
                }, function(data, status, headers, config) {
                    $log(data);
                    $log('Error occurred while performing \nDELETE:', apiUrl);
                    $log(config);
                    deferred.reject(data);
                });

            return deferred.promise;
        };

        return api;
    }

    HttpService.$inject = ['$rootScope', '$q', '$http', '$log', 'API_CONFIG'];
})();

/**
 * Created by Hafeez Rehman on 10/11/2017.
 */

(function () {
    'use strict';

    angular
        .module('app')
            .factory('AlertService', AlertFactory);

     function AlertFactory($rootScope, toastr){
         var alerts = {};

         alerts.success = function(head, msg){
             toastr.success(msg, head || 'Success!');
         };

         alerts.info = function(head, msg){
             toastr.info(msg, head || 'Info!');
         };

         alerts.error = function(head, msg){
             toastr.error(msg, head || 'Error!');
         };

         alerts.warning = function(head, msg){
             toastr.warning(msg, head || 'Warning!');
         };

         return alerts;
     }

     AlertFactory.$inject = ['$rootScope', 'toastr'];
})();
/**
 * Created by Hafeez Rehman on 23/11/2017.
 */


(function () {
    'use strict';

    angular
        .module('app')
            .controller('ConfirmationCtrl', ConfirmationDialogCtrl);

    ConfirmationDialogCtrl.$inject = ['$scope', '$uibModalInstance', 'items'];

    function ConfirmationDialogCtrl ($scope, $uibModalInstance, items) {

        $scope.vm = items;

        $scope.ok = function(){
            $uibModalInstance.close();
        };

        $scope.cancel = function(){
            $uibModalInstance.dismiss('cancel');
        };
    }

})();

(function () {
    'use strict';

     angular
         .module('app')
            .controller('NotificationCtrl', NotificationDialogCtrl);

    NotificationDialogCtrl.$inject = ['$scope', '$uibModalInstance'];

    function NotificationDialogCtrl ($scope, $uibModalInstance) {
     $scope.ok = function() {
         $uibModalInstance.dismiss('cancel');
     };
    }
})();


(function () {
    'use strict';

    angular
        .module('app')
        .controller('DealUsersCtrl', DealUsersModalCtrl);

    DealUsersModalCtrl.$inject = ['$scope', '$rootScope', '$uibModalInstance', '$log', 'items', 'HttpService', 'Utils', 'DealsService', 'AlertService', 'gettextCatalog', 'DEAL_TARGET'];

    function DealUsersModalCtrl($scope, $rootScope, $uibModalInstance, $log, items, HttpService, Utils, DealsService, AlertService, gettextCatalog, DEAL_TARGET) {

        $scope.vm = {};
        $scope.farmTypesMap = DealsService.getFarmTypesMap();
        $scope.systemsMap = DealsService.getSystemsMap();
        $scope.DEAL_TARGET = DEAL_TARGET;
        $scope.utils = Utils;

        $scope.bookingStart = items.model.bookingStart;
        $scope.target = items.model.target;
        $scope.readOnly = items.readOnly;

        $scope.sorting = {
            field: 'name.last',
            order: -1,
        };
    
        $scope.paging = {
            maxSize: 3,
            itemsPerPage: 10,
            totalItems: 1,
            current: 1
        };

        // Move to Service
        function init() {
            $scope.users = items.users || [];

            if (!$scope.users || $scope.users.length === 0){
                $scope.sortUsers('lastDealsAck', -1);
            }
            else {
                initUsers($scope.users, items.model);
            }

            $scope.isTargetNewUsers = $scope.target === DEAL_TARGET.NEW_USERS;
            loadGroups(items.model.userGroup ? items.model.userGroup.name : null);

            $scope.viewSelectedOnly = $scope.readOnly && !$scope.isTargetNewUsers;
            $scope.customerIdLabel = $rootScope.app.Auth.User.supplier.customerIdLabel || gettextCatalog.getString('Customer ID');
        }

        function loadGroups(selectedName) {
            HttpService.Get('groups').then(function(data) {
                $scope.groupList = data.list || [];
                if (selectedName) {
                    $scope.vm.selectedGroup = Utils.altFind($scope.groupList, function(g) {
                        return selectedName === g.name;
                    });
                }
            });
        }

        function initUsers(allUsers, model) {
            // TODO: move paging to API
            if ($scope.userFilter) {
                var searchKey = $scope.userFilter.toLowerCase();
                allUsers = allUsers.filter(function(user) {
                    return user.name.first.toLowerCase().indexOf(searchKey) >= 0 || user.name.last.toLowerCase().indexOf(searchKey) >= 0 || 
                        user.address.zipcode.toLowerCase().indexOf(searchKey) >= 0 || 
                        (user.email && user.email.toLowerCase().indexOf(searchKey) >= 0) || 
                        (user.phoneNumber && user.phoneNumber.toLowerCase().indexOf(searchKey) >= 0);
                })
            }
            if ($scope.viewSelectedOnly) {
                allUsers = allUsers.filter(function (user) { 
                    return !user.isExcluded;
                });
            }
            $scope.paging.totalItems = allUsers.length;
            $scope.currentPageUsers = allUsers.slice(
                ($scope.paging.current - 1) * $scope.paging.itemsPerPage, 
                ($scope.paging.current) * $scope.paging.itemsPerPage);
            var users = $scope.currentPageUsers;

            var bookingStart = moment($scope.bookingStart); // eslint-disable-line no-undef
            var requestMap = model.requests.reduce(function(map, r) {
                map[String(r.createdBy)] = r;
                return map;
            }, {});
            users.forEach(function (u) {
                u.isExcluded = u.isExcluded ? true : false;
                if (u.lastDealsAck) {
                    u.activeDaysAgo = moment().diff(u.lastDealsAck, 'days'); // eslint-disable-line no-undef
                    u.isActiveToday = u.activeDaysAgo === 0;
                    u.isActiveWeekly = !u.isActiveToday && u.activeDaysAgo <= 7;
                    u.isActiveMonthly = !u.isActiveToday && !u.isActiveWeekly && u.activeDaysAgo <= 31;
                    u.isActiveAfterBookingStart = bookingStart.isBefore(u.lastDealsAck);
                }
                u.request = requestMap[u._id];
                u.farmTypesStr = u.farmTypes.slice(0,2).map(function(ft) {
                    return $scope.farmTypesMap[ft];
                }).join(', ');
                if (u.farmTypes.length > 2) {
                    u.farmTypesStr = u.farmTypesStr + ' +' + (u.farmTypes.length - 2);
                }
            });
            $scope.selectedCount = computeSelectedCount();
        }

        function computeSelectedCount() {
            $log.log('compute selected')
            return $scope.users.filter(function(u) {
                return !u.isExcluded;
            }).length;
        }

        $scope.onPage = function() {
            initUsers($scope.users, items.model);
        };

        $scope.sortUsers = function(sortField, sortOrder) {
            $scope.sorting.order = ($scope.sorting.field === sortField) ? -$scope.sorting.order : (sortOrder || 1);
            $scope.sorting.field = sortField;
            var additionalParams = {
                sortField: $scope.sorting.field,
                sortOrder: $scope.sorting.order,
            };
            DealsService.fetchAffectedUsers(items.model, additionalParams).then(function (users) {
                $scope.users = users;
                initUsers($scope.users, items.model);
            });
        };

        $scope.getSortClass = function (sortField) {
            if ($scope.sorting.field !== sortField) {
                return '';
            }
            return ($scope.sorting.order < 0) ? 'fa-sort-amount-desc' : 'fa-sort-amount-asc'; 
        }

        $scope.toggleUser = function (user) {
            user.isExcluded = !user.isExcluded;
            $scope.isGroupModified = true;
            $scope.vm.selectedGroup = undefined;
            $scope.viewSelectedOnly = false;
            $scope.selectedCount = computeSelectedCount();
        };

        $scope.setAllUsersExclusionState = function (isExcluded) {
            $scope.users.forEach(function (u) {
                u.isExcluded = isExcluded;
            });
            $scope.vm.selectedGroup = undefined;
            $scope.selectedCount = computeSelectedCount();
        };

        $scope.toggleIncludeNewUsers = function () {
            if ($scope.target !== DEAL_TARGET.NEW_USERS) {
                $scope.target = DEAL_TARGET.NEW_USERS;
                $scope.setAllUsersExclusionState(false);
                return;
            }
            $scope.target = DEAL_TARGET.ALL_USERS;
            $scope.viewSelectedOnly = false;
            $scope.selectedCount = computeSelectedCount();
        };

        $scope.toggleViewSelectedOnly = function() {
            $scope.viewSelectedOnly = !$scope.viewSelectedOnly;
            $scope.userFilter = '';
            initUsers($scope.users, items.model);
        }

        $scope.loadUserGroup = function() {
            if (!$scope.vm.selectedGroup) {
                return;
            }
            $scope.users.forEach(function (u) {
                u.isExcluded = !u.groups || !u.groups.length || 
                    (u.groups.map(function(group) {
                        return group._id;
                    }).indexOf($scope.vm.selectedGroup._id) < 0);
            });
            $scope.isGroupModified = false;
            $scope.selectedCount = computeSelectedCount();
        };

        $scope.promptSaveUserGroup = function() {
            $scope.isGroupModified = false;
            $scope.isSaveGroupVisible = true;
        };
        $scope.cancelSaveGroup = function() {
            $scope.isGroupModified = true;
            $scope.isSaveGroupVisible = false;
        };

        $scope.updateUserGroup = function() {
            var payload = { users: [] };
            $scope.users.forEach(function (u) {
                if (!u.isExcluded) {
                    payload.users.push(u._id);
                }
            });
            HttpService.Put('groups/' + $scope.vm.selectedGroup._id, payload).then(function () {
                AlertService.success(gettextCatalog.getString('Group saved'));
                loadGroups($scope.vm.selectedGroup.name);
            });
        };

        $scope.saveUserGroup = function() {
            var payload = {
                name: $scope.vm.newGroupName.trim(),
                color: Utils.getRandomHexColor(),
                users: []
            };
            $scope.users.forEach(function (u) {
                if (!u.isExcluded) {
                    payload.users.push(u._id);
                }
            });
            HttpService.Post('groups', payload).then(function () {
                AlertService.success(gettextCatalog.getString('Group saved'));
                $scope.isGroupModified = false;
                $scope.isSaveGroupVisible = false;
                loadGroups(payload.name);
            }, function() {
                AlertService.error(gettextCatalog.getString('Group name already exists'));
            });
        };

        $scope.ok = function () {
            items.model.target = $scope.target;
            items.model.users = $scope.users.filter(function(u) {
                return !u.isExcluded;
            });
            items.model.userGroup = $scope.isGroupModified ? null : $scope.vm.selectedGroup;
            $uibModalInstance.close();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        init();
    }
})();

(function(){
    'use strict';

     angular.module('app.crop').controller('CropModalCtrl', cropModalCtrl);

     cropModalCtrl.$inject = ['$scope', '$uibModalInstance', 'items'];

     function cropModalCtrl($scope, $uibModalInstance, items) {

         $scope.form = {};
         $scope.Fields = [];
         $scope.Selected = items.selectedCrop;

         $scope.Selected.qualityStandards.forEach(function(qs) {
            $scope.Fields.push({
                label: qs.label,
                type: qs.type,
                unit: qs.unit,
                limit: qs.limit,
                required: qs.required,
                value: qs.value || 0
            });
         });

         $scope.ok = function(){
             $scope.form.cropStandard.$setSubmitted();
             if($scope.form.cropStandard.$invalid) {
               return false;
             }

             var cropQualityStr = $scope.Fields.filter(function(f) {
               return f.type === 'text' || (f.value && f.value > 0);
             }).map(function(f) {
               return f.label + ': ' +
                (f.limit ? (f.limit + ' ') : '') +
                f.value + f.unit;
             }).join('; ');

             $uibModalInstance.close( {
                name: $scope.Selected.label,
                vendorProductId: $scope.Selected.vendorProductId,
                cropQuality: cropQualityStr
             });
         };

         $scope.cancel = function() {
             $uibModalInstance.dismiss('cancel');
         };
     }
})();


(function () {
    'use strict';

     angular
         .module('app')
            .controller('MobilePreviewCtrl', MobilePreviewCtrl);

    MobilePreviewCtrl.$inject = ['$scope', '$uibModalInstance', '$rootScope', 'dealUuid', 'Utils', 'DealsService', 'HttpService'];

    function MobilePreviewCtrl ($scope, $uibModalInstance, $rootScope, dealUuid, Utils, DealsService, HttpService) {
      $scope.user = {
        email: getEmail(),
        pwd: '2018'
      };

      setupUser();
      function setupUser() {
        var userData;
        if ($rootScope.app.Auth.User.testUser) {
          userData = {
            email: $scope.user.email,
            forcedDeals: [ dealUuid ]
          };
          HttpService.Put('users/' + $rootScope.app.Auth.User.testUser._id, userData);
          return;
        }

        userData = {
          email: $scope.user.email,
          password: $scope.user.pwd,
          name: {
            first: $rootScope.app.Auth.User.name.first,
            last: $rootScope.app.Auth.User.name.last + ' (TEST)'
          },
          address: {
            zipcode: 'TEST',
            city: 'TEST',
            country: $rootScope.app.Auth.User.supplier.area.toLowerCase()
          },
          farmTypes: [],
          isTest: true,
          forcedDeals: [ dealUuid ]
        };
        HttpService.Post('users', userData).then(function(res) {
            var testUserData = {
              testUser: res.data._id
            };
            $rootScope.app.Auth.User.testUser = userData._id;
            HttpService.Put('users/' + $rootScope.app.Auth.User._id, testUserData);
        });
      }

      function getEmail() {
        var emailParts = $rootScope.app.Auth.User.email.split('@');
        emailParts[0] += '.fh';
        return emailParts.join('@');
      }

      $scope.ok = function() {
        $uibModalInstance.close($scope.imageSrc);
      };

      $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };
    }
})();


(function () {
    'use strict';

    angular.module('app.deals').controller('CollectionPointCtrl', collectionPointCtrl);

    collectionPointCtrl.$inject = ['$scope', '$uibModalInstance', 'items'];

    function collectionPointCtrl($scope, $uibModalInstance, items) {

        $scope.selectedCollectionPoints = items.selectedCollectionPoints;
        $scope.collectionPoints = items.collectionPoints;
        $scope.isCategoryCrop = items.isCategoryCrop;
        $scope.form = {};

        init();

        function init() {
            var cpMap = {};
            $scope.selectedCollectionPoints.forEach(function (cp) {
                cpMap[cp.name] = true;
            });
            $scope.collectionPoints.forEach(function (cp) {
                cp.active = cpMap[cp.name] ? true : false;
            });
        }

        $scope.toggleActivationForAll = function (isActive) {
            $scope.collectionPoints.forEach(function (cp) {
                cp.active = isActive;
            });
        };
        
        $scope.toggleActivation = function (cp) {
            cp.active = !cp.active;
        };

        $scope.ok = function () {
            var selectedCollectionPoints = [];
            $scope.collectionPoints.forEach(function (cp) {
                if (cp.active) {
                    selectedCollectionPoints.push(cp);
                }
            });
            $uibModalInstance.close(selectedCollectionPoints);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';

     angular
         .module('app')
            .controller('RichTextModalCtrl', richTextModalController);

    richTextModalController.$inject = ['$scope', '$uibModalInstance', 'items'];

    function richTextModalController($scope, $uibModalInstance, items) {

        $scope.title = items.title;
        $scope.text = items.descText;

        $scope.ok = function() {
            $uibModalInstance.close($scope.text);
        };

        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();


(function () {
    'use strict';

     angular
         .module('app')
            .controller('DealConfirmCtrl', dealConfirmCtrl);

    dealConfirmCtrl.$inject = ['$scope', '$uibModalInstance', 'items', 'Utils', 'DealsService', 'DEAL_TARGET'];

    function dealConfirmCtrl($scope, $uibModalInstance, items, Utils, DealsService, DEAL_TARGET) {
        $scope.vm = {
            model:  items.model,
            utils: Utils,
            DEAL_TARGET: DEAL_TARGET,
            service: DealsService,
            farmTypesMap: DealsService.getFarmTypesMap(),
            systemsMap: DealsService.getSystemsMap()
        };    

        function init() {
            
        }

        $scope.ok = function() {
            $uibModalInstance.close();
        };
        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.viewUsers = function() {
            $uibModalInstance.dismiss('users');
        }
        init();
    }
})();

/**
 * Created by Hafeez Rehman on 04/11/2017.
 */

(function(){
    'use strict';

    angular
        .module('app')
            .controller('HomeCtrl', HomeCtrl);

    function HomeCtrl(){

    }

    HomeCtrl.$inject = [];
})();

(function(){
    'use strict';

    angular
        .module('app')
            .controller('AppCtrl', AppCtrl);

    function AppCtrl($scope, $rootScope, $state, $stateParams, $window, $log, $timeout, 
            HttpService, AuthFactory, gettextCatalog, Utils, API_CONFIG, CONSTANTS) {
        $scope.place = {};
        $scope.utils = Utils;
        $scope.selectedSupplier = null;
        $scope.apiEnv = API_CONFIG.env;

        function init() {
            if (Utils.isUserRegionalManager() && $stateParams.supplier) {
                var targetUrl = window.location.href.split('?')[0];
                $scope.switchSupplier($stateParams.supplier, targetUrl);
            }
            $scope.isInternetExplorer = /*@cc_on!@*/false || !!document.documentMode;
        }

        $rootScope.$on('unauthorized', function() {
            $log.log('Unauthorized: go to login page.');
            AuthFactory.saveRedirectUrl();
            AuthFactory.unsetToken();
            $state.go('login');
        });

        // State not found
        $rootScope.$on('$stateNotFound', function (event, unfoundState, fromState, fromParams) { // eslint-disable-line
            $rootScope.loading = false;
        });

        $scope.logout = function() {
          var confirm = Utils.CreateConfirmation(gettextCatalog.getString('Logout?'));
          confirm.result.then(function() {
              AuthFactory.logout();
          });
        };

        $scope.getCurrentLanguage = function() {
          return gettextCatalog.getCurrentLanguage();
        };

        $scope.switchLanguage = function(language) {
            gettextCatalog.setCurrentLanguage(language);
            $log.log('Switched translations to: ', language);
        };

        $scope.showPlaceDetails = function(param) {
            $scope.place = param;
        };

        $scope.showSupplierMenu = function() {
            if (!Utils.isUserRegionalManager()) {
                return;
            }
            $scope.selectedSupplier = $rootScope.app.Auth.User.supplier._id;
            $scope.isSelectSupplierEnabled = true;
        };

        $scope.goToNewDashboard = function() {
            $window.location.href = 'https://dashboard.rwa.farmhedge.at/auth/login?email=' + 
                encodeURIComponent($rootScope.app.Auth.User.email);
        }

        $scope.switchSupplier = function(selectedSupplier) {
            var data = {
                supplier: selectedSupplier
            };
            $log.log('Redirecting to supplier:', selectedSupplier);
            HttpService.Put('me', data).then(function() {
                $window.location.reload();  
                Utils.setItemLS(CONSTANTS.LS_ENTRIES.OFFERS_RECEIVED_FITLER, {});
            });
        };

        // Give time to load supplier data.
        $timeout(init, 1000);
    }

    AppCtrl.$inject = ['$scope', '$rootScope', '$state', '$stateParams', '$window', '$log', '$timeout', 'HttpService', 'AuthFactory', 'gettextCatalog', 'Utils', 'API_CONFIG', 'CONSTANTS'];

})();

angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
/* jshint -W100 */
    gettextCatalog.setStrings('de_AT', {"(1 offer)":"(1 Angebot)","(Only multiples of {{vm.model.dealSizeOptions.step}} can be booked)":"(Nur eine durch {{vm.model.dealSizeOptions.step}} teilbare Anzahl kann gebucht werden)","({{deals.length}} offers)":"({{deals.length}} Angebote)","* Field is required":"* Bitte füllen Sie das Feld aus","* Field not valid":"* Wert ungültig","* Value must be a real number":"* Wert muss einer reellen Zahl entsprechen","* file size cannot exceed 4.0 MB":"* Die Dateigröße darf 4,0 MB nicht überschreiten","* selected file must be an image file":"* Die ausgewählte Datei muss eine Bilddatei sein","* value must not be greater than original price":"NOT_ACTIVE","* {{f.label}} is required":"* {{f.label}} ist erforderlich","* {{f.label}} value is not valid":"* {{f.label}} Wert ist nicht gültig","1 attachment":"1 Anhang","1 day":"1 Tag","1 month":"1 Monat","1 offer":"1 Angebot","1 product":"1 Produkt","1 week":"1 Woche","8 characters length":"8 Zeichen","<b>Accept</b> {name} as a new customer?":"{name} als neuen Kunden <b>akzeptieren</b>?","<b>Ignore</b> {name}'s request to become a customer?":"Kundenanfrage von {name} <b>ignorieren</b>?","<b>{{$ctrl.invitation.createdBy.nameFull}}</b> invited you to join FarmHedge.":"<b>{{$ctrl.invitation.createdBy.nameFull}}</b> hat Sie eingeladen FarmHedge zu nutzen.","<b>{{vm.productPublicCount}}</b> products visible to customers":"<b>{{vm.productPublicCount}}</b> Produkte für Kunden verfügbar","<p><a href=\"{link}\"><strong>Click here</strong></a></p><br>":"<p><a href=\"{link}\"><strong>Klicken Sie hier</strong></a></p>","<p>For details and to order this product:</p>":"<p>Für Details und um das Angebot zu reservieren:</p>","<p>From: {supplierName}</p><p>Product: {productName}</p><br>":"<p>Von: {supplierName}</p><p>Produkt: {productName}</p>","<p>Thanks,<br>{fullName}</p>":"<p>Danke<br>{fullName}</p>","A link like \"https://farmhedge.ie\" will be automatically added to the message.":"Ein Link wie “https://farmhedge.ie/at” wird automatisch der Nachricht hinzugefügt.","A lower-case letter (a, b, ...)":"Ein Kleinbuchstabe (a, b, …)","A number (1, 2, ...)":"Eine Zahl (1, 2, …)","About your FarmHedge request":"Bezüglich Ihrer FarmHedge Anfrage","About {{$ctrl.invitation.supplier.name}}":"Über {{$ctrl.invitation.supplier.name}}","Accept customer":"Kunden hinzufügen","Accept invite":"Einladung akzeptieren","Accepted":"Akzeptiert","Accepted invites":"Einladungen angenommen","Account ID:":"Kontonummer:","Accounts":"Accounts","Actions":"Aktionen","Activate FarmHedge payments":"FarmHedge (in App) Zahlungen aktivieren","Active":"Aktiv","Add":"Hinzufügen","Add all":"Alle hinzufügen","Add all products you want to buy to the shopping cart.":"Fügen Sie alle Produkte, die Sie kaufen möchten, dem Warenkorb hinzu.","Add attachment":"Anhang hinzufügen","Add customers":"Kunden hinzufügen","Add discount":"Rabatt hinzufügen","Add group":"Einfügen","Add multiple entries":"Mehrere Einträge hinzufügen","Add multiple phone numbers separated by comma and then click \"Add all\".":"Fügen Sie mehrere Telefonnummern hinzu, die durch Komma getrennt sind, und klicken Sie dann auf \"Alle hinzufügen\".","Add new":"Modifizieren / Hinzufügen","Add one more":"Eine weitere hinzufügen","Add to cart":"In den Einkaufswagen","Add variant":"Variante hinzufügen","Added to cart":"Im Einkaufswagen","Added to shopping cart":"In den Einkaufswagen","Additional variants":"Zusätzliche Varianten","Address":"Adresse","Addresses":"Adressen","Agricultural Contractor":"Auftragnehmer","All farmers will receive {{gdDiscount | number:0}}% discount":"Alle Landwirte erhalten einen Rabatt von {{gdDiscount | number:0}}%","All products deleted":"Alle Produkte gelöscht","All the information you need about the order is here.":"Alle Informationen, die Sie über die Bestellung benötigen, finden Sie hier.","Already a customer?":"Schon Kunde?","Already existing customer":"Bereits bestehender Kunde","Always applied and independent on the quantity sold.":"Der Basis-Rabatt wird bei jedem Verkauf gewährt. Dieser Rabatt ist mengenunabhängig.","Always available to customers":"Immer für Kunden verfügbar","Amount":"Preis","An Error has occurred.":"Ein Fehler ist aufgetreten.","An email was sent to":"Eine E-Mail wurde verschickt an","An upper-case letter (A, B, ...)":"Ein Großbuchstabe (A, B, …)","And much more!":"Und vieles mehr!","Any":"Alle Bewirtschaftungsarten","Any type":"Alle","Are you agribusiness?":"Sind Sie ein Agrarunternehmen?","Are you shoure you want to disable FarmHedge payments?":"Sind sie sicher, dass sie FarmHedge (in App) Zahlungen deaktivieren wollen?","Are you sure you want to delete the selected deal?":"Möchten Sie das ausgewählte Element wirklich löschen?","Ask farmers to sell their crop":"Fordern Sie die Landwirte auf, ihre Ernte zu verkaufen","Associate customer to \"{{$ctrl.order.billingAddress.name}}\" for future orders.":"Ordnen Sie den Kunden für zukünftige Bestellungen dem “{{$ctrl.order.billingAddress.name}}” zu.","Attachment":"Anhang","Attachments":"Anhänge","Available":"Verfügbar","Available from":"Verfügbar bei","Available to customers":"Für Kunden verfügbar","Available to customers:":"Für Kunden verfügbar:","Back":"Zurück","Base discount":"Basis-Rabatt","Beef":"Rindermast","Billing Info":"Rechnungsübersicht","Billing address":"Rechnungsempfänger","Billing info":"Rechnungsübersicht","Billing information":"Rechnungsübersicht","Bookings":"Buchungen","Business name and your contacts can be optionally shared on the offer.":"Der Firmenname und Ihre Kontaktdaten können optional im Angebot angezeigt werden.","Buy":"Kaufen","Buyer":"Käufer","Buyer:":"Käufer:","By:":"Von:","Cancel":"Abbrechen","Cancel offer":"Angebot löschen","Cancel request":"Anfrage abbrechen","Cancel reservation":"Reservierung abbrechen","Cancelled":"Abgebrochen","Card payment":"Kartenzahlung","Category":"Kategorie","Cereal":"Ackerbau","Change language":"Sprache ändern","Changes saved":"Gespeichert","Checkout":"Kasse","City":"Ort","Claear cart":"Einkaufswagen löschen","Clear":"Löschen","Clear cart":"Einkaufswagen löschen","Click \"Confirm\" to cancel reservation":"Klicken Sie auf “Bestätigen” um die Reservierung abzubrechen","Click \"Confirm\" to remove from cart":"Klicken Sie auf “Bestätigen” zum entfernen","Click \"Continue\" to review and confirm the offer details.":"Klicken Sie auf “Weiter” um die Angebotsdetails zu prüfen und zu bestätigen.","Click \"Save\" to make sure changes are not lost.":"Klicken Sie “Änderungen speichern” damit keine geänderten Einstellungen verloren gehen.","Click on \"Create new offer\" to setup a new offer for your customers.":"Klicken Sie auf “Neues Angebot erstellen” um ein neues Angebot für Ihre Kunden zu erstellen.","Click on \"Publish\" when you are happy for the offer details. Farmers will receive a notification on their mobile phones.":"Klicken Sie auf “Veröffentlichen”, wenn Sie mit Ihrem Angebot zufrieden sind. Die Landwirte erhalten dann eine Benachrichtigung auf ihren Mobiltelefonen.","Click on one of the orders to display the order details.":"Klicken Sie auf eine der Bestellungen um die Bestelldetails anzuzeigen.","Click to change image":"Klicken Sie hier, um das Bild zu ändern","Click to choose an image":"Klicken Sie hier, um ein Bild auszuwählen","Clone offer":"Kopieren","Close":"Abbrechen","Collection":"Abholung","Collection Point":"Abholstandort","Collection Points":"Abholstandorte","Collection points":"Abholstandorte","Coming soon":"Bald verfügbar","Complete order":"Bestellung abschließen","Complete the information below to store the order information for future reference.":"Tragen Sie die folgenden Informationen ein, um eine Bestellung zu speichern.","Completed":"Erledigt","Configuration":"Konfiguration","Confirm":"Bestätigen","Confirm Action":"Bestätigen","Confirm and Place order":"Bestätigen und Bestellung aufgeben","Contact":"Kontakt","Contact us today to renew your subscription and access all the features and information you need.":"Kontaktieren Sie uns noch heute um Ihr Abonnement zu erneuern und Zugriff auf alle Funktionen zu erhalten.","Content":"Inhalt","Continue":"Weiter","Conventional":"Konventionell","Copy":"Kopieren","Copy image (CTRL + C) and paste here using CTRL + V":"Kopieren Sie ein Bild (STRG + C) und fügen Sie es hier ein (STRG + V)","Copy product":"Produkt duplizieren","Counties":"PLZ","Country":"Land","Create New":"Neu anlegen","Create an offer":"Ein Angebot erstellen","Create group \"{{$ctrl.newGroupName}}\"":"Gruppe erstellen \"{{$ctrl.newGroupName}}\"","Create new offer":"Neues Angebot","Create product":"Produkt anlegen","Created":"Erstellt am","Created:":"Erstellt am:","Crop":"Ernte","Crop Standards Configuration":"Ernte-Standards-Konfiguration","Crop deal":"Ernte","Crop procurement":"Neues Ernteangebot","Crop quality":"Produktspezifikation","Crop type":"Erzeugnisauswahl","Current items available":"Derzeit verfügbare Menge","Current offer end":"Derzeitiges Angebotsende","Currently active offers.":"Derzeit aktive Angebote.","Custom":"Benutzerdefiniert","Custom discount":"Stufen-Rabatt","Customer":"Kunde","Customer ID":"Kundennummer","Customer Id":"Kundennummer","Customer data updated successfully":"Kundendaten wurden erfolgreich aktualisiert","Customer invites":"Kundeneinladungen","Customer name":"Kundenname","Customer price":"Kundenpreis","Customer request":"Kundenanfrage","Customers":"Kunden","Customers must confirm quantity delivered":"Kunden müssen gelieferte Menge bestätigen","Dairy":"Milchproduktion","Date":"Datum","Days":"Tage","Deal draft deleted successfully":"Deal-Entwurf wurde erfolgreich gelöscht","Deal end":"Angebot gültig bis","Deal start":"Angebot gültig ab","Decimal digits":"Dezimalstellen","Delete all":"Alle löschen","Delete draft":"Entwurf löschen","Delete product":"Produkt entfernen","Delete product?":"Produkt entfernen?","Delivered":"Geliefert","Delivery":"Lieferung","Delivery Info":"Lieferinformationen","Delivery address":"Warenempfänger","Delivery locations":"Bereitstellungsorte","Delivery period":"Lieferzeitraum","Description":"Angebotsbeschreibung","Details":"Details","Different shopping carts will open automatically for products from different suppliers.":"Für Produkte von unterschiedlichen Anbietern öffnen sich automatisch unterschiedliche Einkaufswagen.","Discard unsaved changes?":"Möchten Sie nicht gespeicherte Änderungen verwerfen?","Discount":"Rabatt","Discount (%)":"Rabatt (%)","Discount / {{ds.customUnit}}":"Rabatt / {{ds.customUnit}}","Distribution":"Distribution","Distribution Start date must be after the Booking Start date.":"Lieferdatum muss nach dem Buchungsdatum liegen.","Distribution method":"Verteilungsmethode","Distributor":"RWA Abteilung","Distributor orders":"Bei RWA","Distributor price":"Preis von RWA","Distributors":"RWA Abteilungen","Distributors offers":"RWA Angebote","Do not forward description":"Angebotsbeschreibung nicht weiterleiten","Do you already have the mobile app installed?":"Haben Sie die mobile App bereits installiert?","Do you have a supplier account?":"Haben Sie einen Lagerhaus Account?","Do you want to clone this deal?":"Möchten Sie dieses Angebot duplizieren?","Do you want to create product \"{0}\"?":"Möchten Sie das Produkt \"{0}\" neu anlegen?","Done":"Fertig","Download PDF Manual":"PDF Handbuch herunterladen","Download for Android":"Donwload für Android","Download for iOS":"Donwload für iOS","Draft":"Entwürfe","Draft created":"Erster Entwurf erstellt","Draft deleted":"Entwurf gelöscht","Drafts":"Entwürfe","Drag-and-drop here":"Drag-and-Drop hier","Duplicate product":"Produkt duplizieren","E.g. +431111111, 02222222, 3333333":"z.B. +431111111, 02222222, 3333333","E.g. Concentrate feed":"z.B. Futtermittel","E.g. FCA":"z.B. FCA","E.g. Germany 2018":"z.B. Österreich, 2018","E.g. Liters":"z.B. Liter","E.g. Protein 10%":"z.B. Protein 10%","E.g. Tonne":"z.B. Tonne","Easy to use":"Einfach zu bedienen","Edit":"Bearbeiten","Edit product":"Produkt bearbeiten","Edit reservation":"Reservierung bearbeiten","Email":"E-mail","Email already registered":"Diese E-Mail-Adresse wird bereits verwendet","Email is required":"E-Mail wird benötigt","Email must be valid":"Die E-Mail muss gültig sein","Email:":"E-mail:","End":"Ende","Ends":"Endet","Ends in:":"Endet in:","Enter a billing address and a delivery address for delivery. You can also select these addresses automatically from the address book stored in your profile.":"Geben Sie eine Rechnungsadresse an und bei Lieferung eine Lieferadresse. Auch diese Adressen können Sie automatisch aus dem in Ihrem Profil hinterlegten Adressbuch auswählen.","Error while creating new deal":"Fehler beim Erstellen eines neuen Deals","Error while creating offer. Please try again.":"Fehler beim Erstellen des Angebots. Bitte versuchen Sie es erneut.","Error while creating order. Please try again.":"Während der Bestellung ist ein Fehler aufgetreten.Bitte versuchen Sie es erneut.","Error while creating reservation. Please try again.":"Während der Reservierung ist ein Fehler aufgetreten.Bitte versuchen Sie es erneut.","Error while sending request. Please try again.":"Fehler beim Senden der Anfrage. Bitte versuchen Sie es erneut.","Examples":"Beispiele","Excl. VAT":"Exkl. USt","Exclude all":"Einzelauswahl","Exclude from all offers":"Von allen Angeboten ausschließen","Excluded":"Ausgeschlossen","Excluded from all offers":"Von allen Angeboten ausgeschlossen","Existing":"Vorhanden","Expired":"Abgelaufen","Expires on:":"Gültig bis:","Export":"Exportieren","Export Orders":"Bestellungen exportieren","Export all":"Alles exportieren","Export last {{$ctrl.slider.value}}":"Die letzten {{$ctrl.slider.value}} exportieren","Extend":"Ausweiten","Extend offer":"Angebot ausweiten","Farm system":"Bewirtschaftungsart","Farm system and farm type suggested to retailers when forwarding offer to farmers.":"Bewirtschaftungsarten und Betriebszweige, die den Lagerhäusern für die Weiterleitung des Angebots an Landwirte empfohlen werden.","Farm type filter":"Betriebszweige-Filter","Farm types":"Betriebszweige","FarmHedge <i>for agribusinesses</i>":"Farmhedge <i>für Agrarunternehmen</i>","FarmHedge ID":"FarmHedge ID","FarmHedge order ID":"Farmhedge Bestellnummer","FarmHedge payments are disabled.":"FarmHedge (in App) Zahlungen sind deaktiviert.","FarmHedge payments are enabled":"FarmHedge (in App) Zahlungen sind aktiviert","FarmHedge payments to allow your customers to pay with their credit/debit card.":"FarmHedge (in App) Zahlung erlaubt Ihren Kunden mit ihrer Kredit- oder Debitkarte auf der FarmHedge-App zu bezahlen.","FarmHedge subscription upgrade":"FarmHedge Abonnement Upgrade","FarmHedge supription package:":"FarmHedge Abonnement:","FarmHedge will no longer support Internet Explorer starting from the 30th of November 2020.":"FarmHedge wird den Internet Explorer ab dem 30. November 2020 nicht mehr unterstützen.","Farmer orders":"Von Landwirt","Farmers offer ends":"Angebot an Landwirte endet","Farmers offer is not active yet":"Angebot an Landwirte ist noch nicht aktiv","Farmers offers":"Angebot an Landwirte","Field is required":"Bitte füllen Sie das Feld aus","Field must be a positive value":"Wert muss einer positiven Zahl entsprechen","File URL":"URL der Datei","File URL:":"URL der Datei:","File name":"Dateiname","File name:":"Dateiname:","Filters":"Filter","First":"Erste","First Name":"Vorname","First name":"Vorname","For details, go to the \"Orders\" page from the main menu.":"Für Details, klicken Sie auf “Bestellungen” im Hauptmenü.","For details, go to the \"Requests\" page.":"Klicken Sie auf “Bestellungen” im Hauptmenü, um Details einzusehen.","For help, please contact":"Um Hilfe zu erhalten, kontaktieren Sie bitte","For questions or help, please contact":"Um Hilfe zu erhalten, kontaktieren Sie bitte","For:":"Für:","Foresty":"Forst","Forgot password":"Passwort vergessen","Forgot your password?":"Passwort vergessen?","Forward offer to farmers":"An Landwirte weiterleiten","Forward this order to coworkers who do not have a FarmHedge account.<br>They will receive a link protected by a pincode. The information will be accessible for 2 weeks.":"Leiten Sie diese Bestellung an Kollegen weiter, die keinen FarmHedge Account haben. Diese werden einen Link erhalten, der durch einen Pincode geschützt ist. Der Link ist 2 Wochen lang gültig.","Forward to distributor":"An RWA weiterleiten","Forward to farmers":"An Landwirte weiterleiten","Forwarded":"Weitergeleitet","From":"Ab","From <b>{{$ctrl.deal.supplier.name}}</b>":"Von <b>{{$ctrl.deal.supplier.name}}</b>","From distributor":"Von RWA","From: {{supplierName}}":"Von: {{supplierName}}","Fruit":"Obstbau","Generate invite":"Einladung erstellen","Getting started":"Beginnen","Go to \"Offers sent\"":"Gehen Sie zu “Angebote gesendet”","Go to farmers offer":"Angebot an Landwirte","Go to offer details":"Angebotdetails","Go to orders page":"Gehen Sie zur Seite “Bestellungen”","Group":"Gruppe","Group discount":"Gemeinschaftsrabatt","Group name":"Gruppenname","Group name already exists":"Gruppenname existiert bereits","Group saved":"Gruppe gespeichert","Groups":"Gruppen","Here you can either use the search function or scroll through the list.":"Hier können Sie entweder die Suchfunktion nutzen, oder die Liste durchscrollen.","Here you can see current offers, planned offers, received requests and open orders.":"Hier sehen Sie aktuell laufende Angebote, geplante Angebote, eingegangene Anfragen und offene Bestellungen.","Hi":"Hallo","Hi, it’s {contactName} from {supplierName}. I'd like to invite you to FarmHedge to submit orders and send me product requests.":"Sehr geehrte Landwirte, Sie können die kostenlose FarmHedge App nutzen, um in der aktuellen Situation auch von daheim aus detaillierte Lieferanfragen an Ihr Lagerhaus zu senden. Ihr {supplierName}.","Horticulture/gardening":"Gartenbau","Hours":"Stunden","How many units?":"Wieviele Einheiten?","How many?":"Wie viele?","I am":"Ich bin","I understand this is a legally binding transaction.":"Hiermit wird eine verbindliche Transaktion ausgelöst.","ID":"ID","If less units are sold, orders will be cancelled and famers will be notified.":"Sollten weniger Einheiten verkauft werden, werden die Buchungen automatisch storniert und die Landwirte benachrichtigt.","If you don't receive an email, and it's not in your spam folder this could mean you signed up with a different address.":"Wenn Sie keine E-Mail erhalten und sie nicht in Ihrem Spam-Ordner ist, könnte dies bedeuten, dass Sie sich mit einer anderen Adresse angemeldet haben.","If you need our help, you can contact us directly via email from the dashboard.":"Wenn Sie unsere Hilfe brauchen, können Sie uns vom Dashboard aus auch direkt per E-Mail kontaktieren.","If you press “OK”, this deal will be moved to \"Past deals\" and farmers will not be allowed to make any further bookings.":"Wenn Sie “OK” drücken, wird dieses Angebot in “Ausgelaufene Angebote” verschoben und Landwirte werden keine weiteren Buchungen mehr vornehmen.","Ignore":"Ignorieren","Image":"Bild","Import images":"Bilder importieren","Import product images":"Produktbilder importieren","Import products":"Produkte importieren","In cart":"Im Einkaufswagen","In shopping cart":"Im Einkaufswagen","Inactive suppliers":"Inaktive Lagerhaus","Incl. VAT":"Inkl. USt","Include all":"Alle auswählen","Include attachments":"Anhänge weiterleiten","Include description":"Beschreibung weiterleiten","Include new customers":"An alle Landwirte (inklusive neue)","Included":"Aufgenommen","Incoterms":"Incoterms","Invalid":"Ungültig","Invalid deal":"Ungültige Angebot","Invalid or expired registration link":"Ungültiger oder abgelaufener Registrierungslink","Invalid pincode":"Ungültiger Pincode","Invite customer to join FarmHedge":"Kunden einladen, FarmHedge zu nutzen","Invite customers":"Kunden einladen","Invite new Customers":"Neue Kunden einladen","Invites sent":"Einladungen gesendet","Item updated":"Produkt aktualisiert","Items Available":"Angebotsmenge","Items available":"Produkt verfügbar","Items available to farmers":"Angebotsmenge für Landwirte","Keep the important stuff under control.":"Behalten Sie die wichtigen Dinge unter Kontrolle.","LIVE":"LIVE","Language":"Sprache","Last":"Letzte","Last 30 days":"Letzten 30 Tagen","Last 7 days":"Letzten 7 Tagen","Last Name":"Familienname","Last name":"Nachname","Last offer":"Letztes Angebot","Last order":"Letzte Bestellung","Last update":"Letzte Aktualisierung","Learn more about FarmHedge":"Erfahren Sie mehr über FarmHedge","Learn more about pricing and subscriptions":"Erfahren Sie mehr über unsere Kostenstruktur und Abonnements","Leave a message for your customer:":"Senden Sie eine Nachricht an den Kunden:","Less info":"Weniger Info","Link your customer permanently with a shop":"Verknüpfen Sie Ihren Kunden dauerhaft mit einem Standort","List of counties assigned to supplier:":"Liste der dem Lagerhaus zugeordneten PLZ:","Live":"Live","Load preset":"Voreinstellung laden","Loading":"Laden","Loading images..":"Bilder werden geladen..","Login":"Anmelden","Login on FarmHedge app":"In FarmHedge App einloggen","Logout":"Ausloggen","Logout?":"Abmelden?","Make products visible to customers (Public)":"Produkte für Kunden sichtbar machen (öffentlich)","Manage":"Verwalten","Margin":"Marge","Margin is not showed to customers":"Die Marge wird Landwirten nicht angezeigt","Mark as completed":"Als erledigt markieren","Mark request as completed":"Anfrage als erledigt markieren","Max":"Max","Max for":"Maximum für","Maximum bookable":"Maximal","Maximum quantity bookable by a single user":"Maximalmenge pro Benutzer","Message":"Nachricht","Message for":"Nachricht an","Message for customer":"Nachricht an Kunden","Message for customers":"Nachricht an Kunden","Message from user":"Nachricht des Nutzers","Message length:":"Nachrichtenlänge:","Message not sent. Please try again.":"Nachricht nicht gesendet. Bitte versuchen Sie es erneut.","Message sent":"Nachricht gesendet","Message subject":"Betreff der Nachricht","Messages":"Nachrichten","Min":"Min","Minimum bookable":"Minimum","Minimum quantity bookable by a single user":"Mindestmenge pro Benutzer","Missing required email or password":"Benötigte E-Mail oder Passwort fehlt","Mobile preview: contact details":"Mobile Vorschau: Kontaktdaten","Mobile preview: price and discount":"Mobile Vorschau: Preis und Rabatte","Mobile preview: product name and image":"Mobile Vorschau: Produktname und Bild","Mobile preview: units available and distribution method":"Mobile Vorschau: verfügbare Einheiten und Liefermethoden","More info":"Mehr info","Most features will not be available after that date.":"Die meisten Funktionen werden nach diesem Datum nicht mehr für Sie verfügbar sein.","Multiple discount options available: flat discount, quantity-based or group discount.":"Verschiedene Rabatt-Optionen sind verfügbar: allgemeiner Rabatt, Mengenrabatt oder Gruppenrabatt.","N/A":"N/A","NEW":"NEU","Name":"Name","Need help?":"Brauchen Sie Hilfe?","New":"Neu","New crop offer":"Erzeugnisaufkauf","New customers":"Neue Kunden","New items available":"Neue Angebotsmenge verfügbar","New offer":"Neues Angebot","New offer end":"Neues Angebotsende","New order":"Neue Bestellung","New order to {{distributorDeal.supplier.name}}":"Neue Bestellung an {{distributorDeal.supplier.name}} senden","New product":"Neues Produkt","New request":"Neue Anfrage","New requests":"Neue Anfragen","New sale offer":"Betriebsmittelverkauf","New special offer":"Neues Sonderangebot","Next":"Nächste","No":"Nein","No accounts present":"Keine Konten vorhanden","No attachments":"Keine Anhänge","No customers available to show":"Es sind keine Kunden zum Anzeigen verfügbar","No description":"Keine Beschreibung","No end":"Kein Enddatum","No farmers found":"Keine Landwirte gefunden","No messages":"Keine Nachrichten","No offers available.":"Keine Angebote zur Verfügung.","No orders":"Keine Bestellungen","No orders found.":"Keine Bestellungen gefunden.","No orders or reservations":"Keine Bestellungen oder Reservierungen","No pending orders":"Keine ausstehenden Bestellungen","No products found.":"Keine Produkte gefunden.","No requests found.":"Keine Anfragen gefunden.","No reservations":"Keine Reservierungen","No results found for \"{{$ctrl.filters.searchText}}\".":"Keine Ergebnisse gefunden für “{{$ctrl.filters.searchText}}”.","No results found for \"{{$ctrl.searchText}}\".":"Keine Ergebnisse gefunden für “{{$ctrl.searchText}}”.","No results found.":"Keine Ergebnisse gefunden.","No shops":"Keine Standorte","No zipcodes assigned to supplier":"Keine PLZ dem Lieferanten zugeordnet","Not visible to farmers yet.":"Noch nicht für Landwirte sichtbar.","Notes":"Notizen","Notification sent":"Benachrichtigung gesendet","Notify customer":"Kunden benachrichtigen","Notify customers":"Kunden benachrichtigen","Notify farmers":"Landwirte benachrichtigen","Notify farmers on their mobile phones":"Benachrichtigen Sie die Landwirte über ihre Mobiltelefone","Number of items":"Anzahl der Produkte","OK":"OK","Offer":"Angebot","Offer deleted":"Angebot gelöscht","Offer description":"Angebotsbeschreibung","Offer details":"Angebotsdetails","Offer draft created":"Angebotsvorlage erstellt","Offer end":"Angebot gültig bis","Offer ends":"Angebot gültig bis","Offer ends in":"Angebot endet in","Offer ends in:":"Angebot endet in:","Offer epired":"Angebot abgelaufen","Offer expired":"Angebot abgelaufen","Offer extended":"Angebot ausgeweitet","Offer for {productName} extended":"Das “{productName}” wurde verlängert","Offer image":"Bild","Offer published":"Veröffentlichte Angebote","Offer saved":"Gespeichert","Offer sent":"Gesendete Angebote","Offer start":"Angebot gültig ab","Offer starts":"Angebot gültig ab","Offer stopped":"Angebot gestoppt","Offers":"Angebote","Offers from your distributors.":"Angebote von RWA.","Offers only":"Nur Angebote","Offers received":"Erhaltene Angebote","Offers sent":"Angebote gesendet","Ok":"Ok","On request":"Auf Anfrage","On the left hand side you can set which dealers you want to see offers from.":"Auf der linken Seite können Sie einstellen, von welchen Händlern sie Angebote sehen möchten.","On the right side you set who should receive this offer. You can also set different prices for different recipients.":"Auf der rechten Seiten stellen Sie ein, wer dieses Angebot erhalten soll.","One or more items are not valid. Please review the list below before going ahead.":"Eines oder mehrere Produkte sind ungültig. Bitte überprüfen Sie die untenstehende Liste bevor Sie fortfahren.","Only multiple of this can be booked":"Schrittgröße - Nur eine durch \"Schritt\" teilbare Anzahl kann gebucht werden","Only new customers will receive this message":"Nur neue Kunden erhalten diese Nachricht","Open order details":"Bestelldetails öffnen","Open the FarmHedge app":"Öffnen Sie die FarmHedge App","Or":"Oder","Or google \"Farmhedge\" on your mobile":"Oder googlen Sie \"Farmhedge\" auf Ihrem Handy","Order":"Bestellung","Order ID":"Bestellnummer","Order date":"Bestelldatum","Order details":"Bestelldetails","Order forwarded":"Bestellung weitergeleitet","Order forwarded to distributor. For details, go to the \"Orders\" page from the main menu.":"Bestellung wurde an die RWA weitergeleitet. Für mehr Informationen, klicken Sie auf “Bestellungen” im Hauptmenü.","Order now":"Jetzt bestellen","Order placed":"Bestellung erfolgreich","Order placed successfully.":"Bestellung erfolgreich getätigt.","Order shared":"Bestellung geteilt","Order updated":"Bestellung aktualisiert","Ordered":"Bestellt","Orders":"Bestellungen","Orders details":"Bestelldetails","Organic":"Biologisch","Origin &amp; Year":"Herkunft &amp; Jahr","Original price":"Listenpreis","Our features:":"Unsere Funktionen:","Page":"Seite","Paid":"Bezahlt","Passcode is required.":"Pincode ist notwendig.","Password":"Passwort","Password is required":"Passwort ist notwendig","Password:":"Passwort:","Past":"Ausgelaufen","Payments were enabled on:":"(In App) Bezahlung aktiviert am:","Pending":"Ausstehend","Pending invites":"Einladungen ausstehend","Pending only":"Nur ausstehend","Phone":"Telefonnummer","Phone number":"Telefonnummer","Phone number RA":"Tel. Aviso","Phone number already registered":"Telefonnummer bereits registriert","Pig":"Schweinemast","Piglet":"Ferkelaufzucht","Pincode":"Pincode","Please check your email for password reset instructions.":"Überprüfen Sie Ihren Posteingang für die nächsten Schritte.","Please complete the following ({{Fields.length}}) fields":"Bitte füllen Sie die folgenden Felder aus ({{Fields.length}})","Please do not press back or refresh the page.":"Bitte drücken Sie nicht auf zurück und aktualisieren Sie nicht die Seite.","Please donot press <i class=\"fa fa-arrow-circle-o-left\"></i> back or <i class=\"fa fa-refresh\"></i> refresh while image is uploading.":"Bitte drücken Sie nicht Zurück oder Aktualisieren, während das Bild hochgeladen wird.","Please explain to your customer why you are rejecting this request:":"Teilen Sie dem Kunden mit, warum die Anfrage abgelehnt wurde:","Please fill your details to accept the invite:":"Bitte registrieren Sie sich, um die Einladung anzunehmen:","Please note that the order details are not forwarded to the distributor. If you want this, please click on \"Forward to distributor\"":"Bitte beachten Sie, dass die Bestelldetails nicht via FarmHedge an die RWA weitergeleitet werden. Sollten Sie eine Weiterleitung wünschen, klicken Sie bitte auf \"An RWA weiterleiten\".","Please note: if a product with same ID or name already exists, the existing product data will be updated.":"Bitten beachten: wenn ein Produkt mit der selben ID bereits existiert, wird dieses überschrieben.","Please select a variant":"Bitte wählen Sie eine Variante","Please use one of these browsers:":"Bitte verwenden Sie einen der folgenden Browser:","Potential new customers":"Potenzielle neue Kunden","Poultry":"Geflügel","Prev":"Vorherige","Preview on mobile":"Vorschau am Smartphone","Price":"Preis","Price / {{ds.customUnit}}":"Preis / {{ds.customUnit}}","Price as agreed":"Preis wie vereinbart","Price changes every day":"Preis ändert sich jeden Tag","Price for":"Preis für","Price is substantially different from offer price":"Der Preis weicht deutlich vom Angebotspreis ab","Price settings":"Preis Einstellungen","Price updated":"Preis aktualisiert","Prices exclude VAT.":"Alle Preisangaben exkl. USt.","Pricing":"Kostenstruktur","Product":"Produkt","Product '{{vm.product.name || vm.product}}' does not exist.":"Produkt \"{{vm.product.name || vm.product}}\" ist nicht vorhanden.","Product ID":"Materialnummer","Product Id":"Materialnummer","Product attributes":"Produktattribute","Product copy created":"Produktduplikat erstellt","Product created":"Produkt erstellt","Product deleted.":"Produkt gelöscht.","Product name":"Produktbezeichnung","Product name and a picture associated to it is displayed to farmers on the mobile app.":"Der Produktname und ein zugewiesenes Bild werden Landwirten in der mobilen App angezeigt.","Product type":"Produkttyp","Product updated":"Produkt aktualisiert","Product/Category":"Produkt/Kategorie","Products":"Produkte","Profile Settings":"Profil","Progress":"Verkäufe","Publish":"Öffentlich","Publish on":"Öffentlich am","Purchase":"Kauf","Purchases":"Meine Käufe","Qty":"Menge","Quantity":"Menge","Quantity Limit":"Mengenbegrenzung","Question about your FarmHedge request":"Frage bezüglich Ihrer FarmHedge Anfrage","Reach new farmers":"Erreichen Sie neue Landwirte","Receipients":"Empfänger","Receive orders":"Bestellungen erhalten","Receive real-time requests":"Erhalten Sie Echtzeit-Anfragen","Received":"Erhalten","Recipient":"Empfänger","Refresh":"Aktualisieren","Registration date":"Registrierungsdatum","Reject order":"Bestellung ablehnen","Reject request":"Anfrage ablehnen","Rejected":"Abgelehnt","Remember me":"Benutzername merken","Remind me to update price":"Erinnere mich daran, den Preis zu aktualisieren","Remove":"Löschen","Remove attachment":"Anhang entfernen","Remove from cart":"Aus Einkaufswagen entfernen","Remove variant":"Variante entfernen","Report &amp; orders":"Buchungsbericht","Request Error: An error occurred while processing the request.":"Anfrage Fehler: Fehler beim Verarbeiten der Anforderung.","Request created by":"Anfrage von","Request for":"Anfrage für","Request sent":"Anfrage gesendet","Request type":"Anfragetyp","Requested":"Erfragt","Requested verification":"Verifizierung angefordert","Requests":"Anfragen","Reservation":"Reservierung","Reservation created":"Reservierung vorgenommen","Reservation ends in":"Reservierung endet in","Reservation time":"Zeit für Reservierung","Reservation updated":"Reservierung aktualisiert","Reserve":"Reservieren","Reserved":"Reserviert","Reserved amount":"Reservierte Menge","Reset":"Zurücksetzen","Reset Password":"Passwort zurücksetzen","Reset filters":"Filter zurücksetzen","Reset password":"Passwort zurücksetzen","Reset prices":"Preise zurücksetzen","Result":"Resultat","Resume":"Fortsetzen","Retailer":"Lagerhaus","Retailers":"Lagerhaus","Review":"Prüfen","Review and publish":"Angebot veröffentlichen","Sale":"Verkauf","Sale Price":"Angebotspreis","Sale offer":"Angebote","Sale price":"Angebotspreis","Sales":"Meine Verkäufe","Sample product":"Beispielprodukt","Save":"Änderungen speichern","Save 1 product":"1 Produkt speichern","Save and publish 1 product":"1 Produkt speichern und veröffentlichen","Save and publish {{$ctrl.validRowsCount}} products":"{{$ctrl.validRowsCount}} Produkte speichern und veröffentlichen","Save and send notification":"Benachrichtigung speichern und senden","Save draft":"Entwurf speichern","Save {{$ctrl.validRowsCount}} products":"{{$ctrl.validRowsCount}} Produkte speichern","Scheduled":"Geplant","Search":"Suche","Search product catalog":"Produktkatalog durchsuchen","See attachment preview":"Anhangvorschau anzeigen","See customers":"Kunden anzeigen","See offer":"Angebot anzeigen","Select":"Auswählen","Select Target Suppliers":"Gewünschten Anbieter auswählen","Select all farmers in a particular area":"Wählen Sie alle Landwirte in einem bestimmten Gebiet aus","Select crop":"Bitte auswählen","Select farm type...":"Betriebszweig auswählen...","Select farmers":"Landwirte auswählen","Select farmers based on their farm type":"Wählen Sie Landwirte basierend auf ihrem Betriebszweig aus","Select file format":"Dateiformat wählen","Select file from your computer":"Datei von Ihrem Computer auswählen","Select product":"Produkt auswählen","Select quantity":"Menge wählen","Select standards":"Wählen Sie Normen","Sell":"Verkaufen","Seller":"Verkäufer","Seller:":"Verkäufer:","Send":"Senden","Send SMS and email to customers":"E-Mail und SMS an Kunden senden","Send SMS to customers":"Senden Sie eine SMS an Kunden","Send a request":"Anfrage senden","Send a request for \"{{$ctrl.filters.searchText}}\"":"Anfrage senden für “{{$ctrl.filters.searchText}}”","Send a request for \"{{$ctrl.searchText}}\"":"Anfrage senden für “{{$ctrl.searchText}}”","Send an offer":"Angebot senden","Send email to customers":"E-Mail an Kunden senden","Send generic request":"Neue allgemeine Anfragen","Send message":"Nachricht senden","Send new request":"Neue Anfrage senden","Send offers on farm inputs":"Senden Sie Angebote für landwirtschaftliche Betriebsmittel","Send push notification to customers":"Senden Sie eine Push-Benachrichtigung an Ihre Kunden","Send request":"Anfrage senden","Send request to":"Anfrage senden an","Send us an email":"Senden Sie uns eine E-Mail","Sent":"Gesendet","Server Error: user authentication failed. Please report this to system administrator.":"Server-Fehler: Benutzerauthentifizierung fehlgeschlagen. Bitte melden Sie dies an Systemadministrator.","Set price":"Preis festlegen","Set/Update offer image":"Bild hochladen / aktualisieren","Share":"Teilen","Share order":"Bestellung teilen","Share the following link with {{$ctrl.inviteData.phoneNumber}}":"Teilen Sie den folgenden Link mit {{$ctrl.inviteData.phoneNumber}}","Sheep":"Schaf","Shop":"Standort","Shopping cart empty":"Einkaufswagen leer","Shops":"Standorte","Show all":"Alle anzeigen","Show me the checkout":"Kasse anzeigen","Show rejected/invalid orders":"Abgelehnte und ungültige Bestellungen anzeigen","Since":"Seit","Sold out":"Ausgebucht","Special offer until":"Sonderangebot bis","Specify custom discount based on quantity purchased.":"Der Rabatt für den Landwirt ist abhängig von der gekauften Menge. Das Lagerhaus definiert die jeweiligen Rabatt-Stufen.","Start":"Start","Start typing...":"Hier schreiben…","Starts":"Beginnt in","Starts in:":"Beginnt in:","Starts now":"Beginnt jetzt","Status":"Status","Step":"Schritt","Step 1: Get FarmHedge on your smartphone":"Schritt 1: Holen Sie sich FarmHedge auf Ihr Smartphone","Step 2: Login on FarmHedge app":"Schritt 2: Melden Sie sich bei der FarmHedge App an","Stock":"Bestand","Stock price":"Börsenpreis","Stop forwarded offer to farmers":"Angebot abbrechen","Stop offer":"Angebot abbrechen","Streamline operations and reduce costs":"Rationalisieren Sie Abläufe und senken Sie Kosten","Street":"Straße","Subject":"Betreff","Subscription expiration date:":"Abonnement Ende:","Success":"Erfolg","Suckler":"Mutterkühe","Supplier":"Lagerhaus","System":"Bewirtschaftungsart","Target":"Target","Technic":"Technik","That's it!":"Fertig!","The easy, secure and private way to trade with your suppliers.":"Der einfache, sichere und persönliche Weg mit Ihrem Lagerhaus zu kommunizieren.","The following FarmHedge users asked to become your customer. You can accept or ignore their requests.":"Die folgenden FarmHedge Nutzer haben Ihnen Kundenanfragen gesendet. Sie können die Anfragen akzeptieren oder ignorieren.","The new way to communicate with farmers":"Die neue Art der Kommunikation mit Landwirten","The number of units available and distribution methods will be showed to famers on the mobile app.":"Die Menge der verfügbaren Einheiten und die möglichen Liefermethoden werden den Landwirten in der mobilen App angezeigt.","The registration process takes only a few minutes.":"Der Registrierungsvorgang dauert nur wenige Minuten.","There are active reservations on this offer":"Es gibt aktive Reservierungen zu diesem Angebot","There are no offers from your distributors.":"Es liegen keine Angebote von RWA vor.","These offers are not active anymore. Most recent offers are on top.":"Diese Angebote sind nicht mehr aktiv. Die letzten Angebote sind zuerst gereiht.","This browser does not support the import function.":"Dieser Browser unterstützt nicht die Import Funktion.","This deal does not exist anymore.":"Dieses Angebot existiert nicht mehr.","This is the notification text.":"Dies ist der Benachrichtigungstext.","This item is already in your shopping cart":"Dieses Produkt ist bereits in Ihrem Einkaufswagen","This means that your customers can pay on the FarmHedge app using their credit or debit card.":"Das bedeutet, dass Ihre Kunden mit ihrer Kredit- oder Debitkarte auf der FarmHedge-App bezahlen können.","This window will auto-close once the image upload completes.":"Dieses Fenster wird automatisch geschlossen, sobald das Bild hochgeladen wurde.","To create a new time-limited offer, click the green button.":"Um ein neues, zeitlich begrenztes Angebot zu erstellen, klicken Sie auf die grüne Schaltfläche.","Today":"Heute","Tonne":"Tonnen","Total":"Gesamt","Total discount":"Gesamtrabatt","Total price":"Gesamtpreis","Trader":"Händler","Traders":"Händler","Transaction saved to \"Orders\" page":"Transaktion wurde unter “Bestellungen” gespeichert","Tutorial":"Tutorial","Type":"Art","Unauthorized access":"Nicht autorisierter Zugriff","Unauthorized: invalid username or password.":"Ungültiger Benutzername oder Passwort.","Unit":"Einheit","Unit price":"Preis pro Einheit","Units":"Einheiten","Unlimited":"Unbegrenzt","Until":"Bis","Update":"Bearbeiten","Update due":"Aktualisierung fällig","Update needed":"Aktualisierung erforderlich","Update product":"Produkt aktualisieren","Update quantity available of forwarded offer to {{$ctrl.amountReserved}}":"Für weitergeleitete Angebote verfügbare Menge bearbeiten","Updated":"Aktualisiert am","Updated:":"Aktualisiert am:","Upgrade":"Upgrade","Upload":"Datei-Upload","Upload Profile image":"Profilbild hochladen","Upload failed. File must be a valid Excel or CSV file.":"Hochladen fehlgeschlagen. Die Datei muss eine gültige Excel oder CSV Datei sein.","Upload failed. File must be a valid PDF file.":"Hochladen fehlgeschlagen. Die Datei muss eine gültige PDF Datei sein.","Uploading...":"Lädt hoch…","Use these credentials:":"Verwenden Sie diese Anmeldeinformationen:","User":"Benutzer","User not authorized":"Nicht autorisierter Zugriff","User profile":"Profil","VAT":"USt","VAT number":"Betriebsnummer","Value is not valid":"Wert ist nicht gültig","Variants":"Varianten","Verified":"Verifiziert","View / Select farmers":"Anzeige / Landwirte auswählen","Want to know more?":"Möchten Sie mehr wissen?","Weeks":"Wochen","Welcome to":"Willkommen bei","Welcome to FarmHedge":"Willkommen bei FarmHedge","What is FarmHedge?":"Was ist FarmHedge?","When you receive an order from a customer, you will be notified by email.":"Wenn Sie eine Bestellung von einem Kunden erhalten, werden sie per E-Mail benachrichtigt.","Winegrowing":"Weinbau","Yes":"Ja","You access this page at any time by clicking on the FarmHedge icon in the upper left corner.":"Sie erreichen diese Seite jederzeit, wenn Sie auf das FarmHedge Symbol links oben klicken.","You can also click through a short tutorial of the FarmHedge platform.":"Außerdem können Sie ein kurzes Tutorial der FarmHedge Plattform durchklicken.","You can also send the order details by email.":"Sie können die Bestelldetails per E-Mail versenden.","You can attach a message to the order for your supplier.":"Sie können eine Nachricht mitsenden an die Bestellung anhängen.","You can export all your orders for integration with other software.":"Sie können alle Bestellungen für die Integration in andere Software exportieren.","You can reject or complete an order.":"Sie können eine Bestellung ablehnen oder als erledigt markieren.","You can review the details and publish the offer. After that you can start receiving orders.":"Sie können die Details prüfen und das Angebot absenden. Danach können Sie Bestellungen erhalten.","You can review the order and modify quantities.":"Sie können die Bestellung prüfen und Mengen anpassen.","You can set the product":"Sie können das Produkt einstellen","You did not submit a phone number. Continue anyway?":"Sie haben keine Nummer für die tel. Aviso angegeben. Trotzdem fortfahren?","You do not have permissions to view this deal.":"Sie sind nicht berechtigt, diesen Angebote anzuzeigen.","You will be asked to confirm the quantity delivered. Price per {unit} will not change.":"Sie werden aufgefordert, die gelieferte Menge zu bestätigen. Der Preis pro {unit} ändert sich nicht.","You will be notified on farmers bookings.":"Sie werden bei Buchungen von Landwirten benachrichtigt.","You will receive the funds directly on a bank account of your choice.":"Sie erhalten den Betrag direkt auf ein Bankkonto Ihrer Wahl.","You will receive the funds directly on the bank account specified during the registration process.":"Sie erhalten den Betrag direkt auf das während der Registrierung angegebene Bankkonto.","Your FarmHedge subscription has expired.":"Ihr FarmHedge Abonnement ist abgelaufen.","Your FarmHedge subscription will expire on {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}":"Ihr FarmHedge Abonnement läuft ab am {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}","Your TRIAL subscription will expire on {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}":"Ihr Testzugang läuft ab am {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}","Your message":"Ihre Nachricht","Your products":"Ihre Produkte","Your request":"Ihre Anfrage","Zip code":"PLZ","affected":"betroffen","by {{gdDate}} (end of the deal).":"{{gdAmount}} Einheiten verkauft werden.","customers":"Kunden","dashboard":"Dashboard","day":"Tag","days":"Tage","deals":"Angebote","deals/requests":"Anfragen","delivery method and many other settings from scratch":"Liefermethode und viele andere Einstellungen von Grund auf","discount":"Rabatt","duration of the offer":"Angebotsdauer","farmer(s) selected":"Landwirt(e) ausgewählt","for:":"Für:","from":"ab","hour":"Stunde","hours":"Stunden","https://fh-data-1.s3.eu-west-1.amazonaws.com/1533808623752Screen%20Shot%202018-08-09%20at%2010.56.33.png":"https://fh-data-1.s3.eu-west-1.amazonaws.com/1533808704908Screen%20Shot%202018-08-09%20at%2010.56.39.png","if {{gdAmount}} units are sold":"wenn bis zum {{gdDate}} weitere","images uploaded":"Bilder hochgeladen","item":"Produkt","items":"Produkte","min.":"Min.","months":"Monate","new this month":"neue diesen Monat","new this week":"neue diese Woche","offers/received":"Erhaltene Angebote","order":"Bestellung","orders":"Bestellungen","pending":"Ausstehend","products":"Produkte","products imported":"Produkte importiert","profile":"Profil","reservation":"Reservierung","reservations":"Reservierung","selected":"ausgewählt","units":"Einheiten","until":"bis","variants":"Varianten","{{$ctrl.invitation.createdBy.name.first}}'s message:":"{{$ctrl.invitation.createdBy.name.first}}’s Nachricht:","{{deal.attachments.length}} attachments":"{{deal.attachments.length}} Anhänge","{{group.name}} ({{group.users.length}} customers)":"{{group.name}} ({{group.users.length}} Kunden)","{{supplier.stats.offersCount}} offers":"{{supplier.stats.offersCount}} Angebote","{{supplier.stats.productsCount}} products":"{{supplier.stats.productsCount}} Produkte","{{vm.lookup.distMethodsMap[vm.model.distribution]}} ends":"{{vm.lookup.distMethodsMap[vm.model.distribution]}} möglich bis","{{vm.lookup.distMethodsMap[vm.model.distribution]}} starts":"{{vm.lookup.distMethodsMap[vm.model.distribution]}} möglich ab","{{vm.orders.length}} order":"{{vm.orders.length}} Bestellung","{{vm.orders.length}} orders":"{{vm.orders.length}} Bestellungen","{{vm.pendingInvitesCount || 0}} pending invites":"{{vm.pendingInvitesCount || 0}} unbeantwortete Einladungen","{{vm.pendingInvitesCount}} pending invite":"{{vm.pendingInvitesCount}}  unbeantwortete Einladung"});
    gettextCatalog.setStrings('de_DE', {"(1 offer)":"(1 Angebot)","(Only multiples of {{vm.model.dealSizeOptions.step}} can be booked)":"(Nur eine durch {{vm.model.dealSizeOptions.step}} teilbare Anzahl kann gebucht werden)","({{deals.length}} offers)":"({{deals.length}} Angebote)","* Field is required":"* Bitte füllen Sie das Feld aus","* Field not valid":"* Wert ungültig","* Value must be a real number":"* Wert muss einer reellen Zahl entsprechen","* file size cannot exceed 4.0 MB":"* Die Dateigröße darf 4,0 MB nicht überschreiten","* selected file must be an image file":"* Die ausgewählte Datei muss eine Bilddatei sein","* value must not be greater than original price":"NOT_ACTIVE","* {{f.label}} is required":"* {{f.label}} ist erforderlich","* {{f.label}} value is not valid":"* {{f.label}} Wert ist nicht gültig","1 day":"1 Tag","1 month":"1 Monat","1 week":"1 Woche","8 characters length":"8 Zeichen","<b>Accept</b> {name} as a new customer?":"{name} als neuen Kunden <b>akzeptieren</b>?","<b>Ignore</b> {name}'s request to become a customer?":"Kundenanfrage von {name} <b>ignorieren</b>?","<b>{{$ctrl.invitation.createdBy.nameFull}}</b> invited you to join FarmHedge.":"<b>{{$ctrl.invitation.createdBy.nameFull}}</b> hat Sie eingeladen FarmHedge zu nutzen.","<b>{{vm.productPublicCount}}</b> products visible to customers":"<b>{{vm.productPublicCount}}</b> Produkte für Kunden verfügbar","A link like \"https://farmhedge.ie\" will be automatically added to the message.":"Ein Link wie “https://farmhedge.ie/de” wird automatisch der Nachricht hinzugefügt.","A lower-case letter (a, b, ...)":"Ein Kleinbuchstabe (a, b, …)","A number (1, 2, ...)":"Eine Zahl (1, 2, …)","About your FarmHedge request":"Bezüglich Ihrer FarmHedge Anfrage","About {{$ctrl.invitation.supplier.name}}":"Über {{$ctrl.invitation.supplier.name}}","Accept customer":"Kunden hinzufügen","Accept invite":"Einladung akzeptieren","Accepted":"Akzeptiert","Accepted invites":"Einladungen angenommen","Account ID:":"Kontonummer:","Actions":"Aktionen","Activate FarmHedge payments":"FarmHedge (in App) Zahlungen aktivieren","Active":"Aktiv","Add":"Hinzufügen","Add all":"Alle hinzufügen","Add attachment":"Anhang hinzufügen","Add discount":"Rabatt hinzufügen","Add group":"Gruppe hinzufügen","Add multiple entries":"Mehrere Einträge hinzufügen","Add multiple phone numbers separated by comma and then click \"Add all\".":"Fügen Sie mehrere Telefonnummern hinzu, die durch Komma getrennt sind, und klicken Sie dann auf “Alle hinzufügen”.","Add new":"Modifizieren / Hinzufügen","Add one more":"Eine weitere hinzufügen","Add to cart":"In den Einkaufswagen","Add variant":"Variante hinzufügen","Added to shopping cart":"In den Einkaufswagen","Additional variants":"Zusätzliche Varianten","Address":"Adresse","Agricultural Contractor":"Auftragnehmer","All Categories":"Alle Kategorien","All farmers will receive {{gdDiscount | number:0}}% discount":"Alle Landwirte erhalten einen Rabatt von {{gdDiscount | number:0}}%","All offers":"Alle Angebote","Already a customer?":"Schon Kunde?","Already existing customer":"Bereits bestehender Kunde","Always applied and independent on the quantity sold.":"Der Basis-Rabatt wird bei jedem Verkauf gewährt. Dieser Rabatt ist mengenunabhängig.","Always available to customers":"Immer für Kunden verfügbar","Amount":"Preis","An Error has occurred.":"Ein Fehler ist aufgetreten.","An email was sent to":"Eine E-Mail wurde verschickt an","An upper-case letter (A, B, ...)":"Ein Großbuchstabe (A, B, …)","And much more!":"Und vieles mehr!","Any":"Alle Bewirtschaftungsarten","Any type":"Alle","Are you agribusiness?":"Sind Sie ein Agrarunternehmen?","Are you shoure you want to disable FarmHedge payments?":"Sind sie sicher, dass sie FarmHedge (in App) Zahlungen deaktivieren wollen?","Are you sure you want to delete the selected deal?":"Möchten Sie das ausgewählte Element wirklich löschen?","Areas:":"Regionen:","Ask farmers to sell their crop":"Fordern Sie die Landwirte auf, ihre Ernte zu verkaufen","Associate customer to \"{{$ctrl.order.billingAddress.name}}\" for future orders.":"Ordnen Sie den Kunden für zukünftige Bestellungen dem “{{$ctrl.order.billingAddress.name}}” zu.","Attachment":"Anhang","Attachments":"Anhänge","Available":"Verfügbar","Available to customers":"Für Kunden verfügbar","Available to customers:":"Für Kunden verfügbar:","Back":"Zurück","Base discount":"Basis-Rabatt","Beef":"Rindermast","Billing Info":"Rechnungsübersicht","Billing address":"Rechnungsempfänger","Billing info":"Rechnungsübersicht","Billing information":"Rechnungsübersicht","Bookings":"Buchungen","Business name and your contacts can be optionally shared on the offer.":"Der Firmenname und Ihre Kontaktdaten können optional im Angebot angezeigt werden.","Buy":"Kaufen","Buyer":"Käufer","Buyer:":"Käufer:","By:":"Von:","Cancel":"Abbrechen","Cancel offer":"Angebot löschen","Cancel reservation":"Reservierung abbrechen","Cancelled":"Abgebrochen","Cancelled by farmer":"Von Landwirt abgebrochen","Card payment":"Kartenzahlung","Card payment required at checkout":"Kartenzahlung zum Abschluss benötigt","Cereal":"Ackerbau","Change language":"Sprache ändern","Changes saved":"Gespeichert","City":"Stadt","Click \"Confirm\" to cancel reservation":"Klicken Sie auf “Bestätigen” um die Reservierung abzubrechen","Click \"Continue\" to review and confirm the offer details.":"Klicken Sie auf “Weiter” um die Angebotsdetails zu prüfen und zu bestätigen.","Click \"Save\" to make sure changes are not lost.":"Klicken Sie “Änderungen speichern” damit keine geänderten Einstellungen verloren gehen.","Click on \"Create new offer\" to setup a new offer for your customers.":"Klicken Sie auf “Neues Angebot erstellen” um ein neues Angebot für Ihre Kunden zu erstellen.","Click on \"Publish\" when you are happy for the offer details. Farmers will receive a notification on their mobile phones.":"Klicken Sie auf “Veröffentlichen”, wenn Sie mit Ihrem Angebot zufrieden sind. Die Landwirte erhalten dann eine Benachrichtigung auf ihren Mobiltelefonen.","Click to change image":"Klicken Sie hier, um das Bild zu ändern","Click to choose an image":"Klicken Sie hier, um ein Bild auszuwählen","Clone offer":"Kopieren","Close":"Abbrechen","Collection":"Abholung","Collection Point":"Abholstandort","Collection Points":"Abholstandorte","Collection from:":"Abholung ab:","Collection points":"Abholstandorte","Collection until:":"Abholung bis:","Coming soon":"Bald verfügbar","Complete order":"Bestellung abschließen","Complete the information below to store the order information for future reference.":"Tragen Sie die folgenden Informationen ein, um eine Bestellung zu speichern.","Completed":"Erledigt","Confirm":"Bestätigen","Confirm Action":"Bestätigen","Confirm and Place order":"Bestätigen und Bestellung aufgeben","Contact":"Kontakt","Contact us today to renew your subscription and access all the features and information you need.":"Kontaktieren Sie uns noch heute um Ihr Abonnement zu erneuern und Zugriff auf alle Funktionen zu erhalten.","Continue":"Weiter","Conventional":"Konventionell","Copy":"Kopieren","Copy image (CTRL + C) and paste here using CTRL + V":"Kopieren Sie ein Bild (STRG + C) und fügen Sie es hier ein (STRG + V)","Counties":"PLZ","Country":"Land","Create New":"Neu anlegen","Create an offer":"Ein Angebot erstellen","Create group \"{{$ctrl.newGroupName}}\"":"Gruppe erstellen “{{$ctrl.newGroupName}}”","Create new offer":"Neues Angebot erstellen","Create product":"Produkt anlegen","Created":"Erstellt am","Created:":"Erstellt am:","Crop":"Ernte","Crop Standards Configuration":"Ernte-Standards-Konfiguration","Crop deal":"Ernte","Crop procurement":"Neues Ernteangebot","Crop quality":"Produktspezifikation","Crop type":"Erzeugnisauswahl","Current and past \"{{req.content[1]}}\" offers":"Aktuelle und ausgelaufene “{{req.content[1]}}” Angebote","Current items available":"Derzeit verfügbare Menge","Current offer end":"Derzeitiges Angebotsende","Currently active offers.":"Derzeit aktive Angebote.","Custom discount":"Stufen-Rabatt","Customer":"Kunde","Customer ID":"Kundennummer","Customer Id":"Kundennummer","Customer data updated successfully":"Kundendaten wurden erfolgreich aktualisiert","Customer invites":"Kundeneinladungen","Customer name":"Kundenname","Customer price":"Kundenpreis","Customer request":"Kundenanfrage","Customers":"Kunden","Customers must confirm quantity delivered":"Kunden müssen gelieferte Menge bestätigen","Dairy":"Milchproduktion","Date":"Datum","Days":"Tage","Deal draft deleted successfully":"Deal-Entwurf wurde erfolgreich gelöscht","Deal end":"Angebot gültig bis","Deal end:":"Gültig bis:","Deal start":"Angebot gültig ab","Deal start:":"Gültig ab:","Delete draft":"Entwurf löschen","Delete product":"Produkt entfernen","Delete product?":"Produkt entfernen?","Delivered":"Geliefert","Delivery":"Lieferung","Delivery Info":"Lieferinformationen","Delivery address":"Warenempfänger","Delivery from:":"Lieferung ab:","Delivery locations":"Bereitstellungsorte","Delivery period":"Lieferzeitraum","Delivery until:":"Lieferung bis:","Description":"Angebotsbeschreibung","Details":"Details","Discard unsaved changes?":"Möchten Sie nicht gespeicherte Änderungen verwerfen?","Discount":"Rabatt","Discount:":"Rabatt:","Distribution":"Distribution","Distribution Start date must be after the Booking Start date.":"Lieferdatum muss nach dem Buchungsdatum liegen.","Distribution method":"Verteilungsmethode","Distributor":"Zulieferer","Distributor orders":"Bestellungen beim Zulieferer","Distributor price":"Preis des Zulieferers","Distributors offers":"Zulieferer Angebote","Do not forward description":"Angebotsbeschreibung nicht weiterleiten","Do you already have the mobile app installed?":"Haben Sie die mobile App bereits installiert?","Do you have a supplier account?":"Haben Sie einen Händleraccount?","Do you want to clone this deal?":"Möchten Sie dieses Angebot duplizieren?","Do you want to create product \"{0}\"?":"Möchten Sie das Produkt \"{0}\" neu anlegen?","Download for Android":"Donwload für Android","Download for iOS":"Donwload für iOS","Draft":"Entwurf","Draft created":"Erster Entwurf erstellt","Draft deleted":"Entwurf gelöscht","Drafts":"Entwürfe","Drag-and-drop here":"Drag-and-Drop hier","E.g. +431111111, 02222222, 3333333":"z.B. +431111111, 02222222, 3333333","E.g. Concentrate feed":"z.B. Konzentrat feed","E.g. FCA":"z.B. FCA","E.g. Germany 2018":"z.B. Österreich, 2018","E.g. Liters":"z.B. Liter","E.g. Protein 10%":"z.B. Protein 10%","E.g. Tonne":"z.B. Tonne","Easy to use":"Einfach zu bedienen","Edit":"Bearbeiten","Edit filters and notifications":"Filter und Benachrichtigungen bearbeiten","Edit product":"Produkt bearbeiten","Edit reservation":"Reservierung bearbeiten","Email":"E-mail","Email already registered":"Diese E-Mail-Adresse wird bereits verwendet","Email is required":"E-Mail wird benötigt","Email must be valid":"Die E-Mail muss gültig sein","Email:":"E-mail:","Ends in:":"Endet in:","Error while creating new deal":"Fehler beim Erstellen eines neuen Deals","Error while creating offer. Please try again.":"Fehler beim Erstellen des Angebots. Bitte versuchen Sie es erneut.","Error while creating order. Please try again.":"Während der Bestellung ist ein Fehler aufgetreten.Bitte versuchen Sie es erneut.","Error while creating reservation. Please try again.":"Während der Reservierung ist ein Fehler aufgetreten.Bitte versuchen Sie es erneut.","Excl. VAT":"Exkl. USt","Exclude all":"Einzelauswahl","Exclude from all offers":"Von allen Angeboten ausschließen","Excluded":"Ausgeschlossen","Excluded from all offers":"Von allen Angeboten ausgeschlossen","Existing":"Vorhanden","Expired":"Abgelaufen","Expires on:":"Gültig bis:","Export":"Exportieren","Export Orders":"Bestellungen exportieren","Export all":"Alles exportieren","Export last {{$ctrl.slider.value}}":"Die letzten {{$ctrl.slider.value}} exportieren","Extend":"Ausweiten","Extend offer":"Angebot ausweiten","Farm system":"Bewirtschaftungsart","Farm system and farm type suggested to retailers when forwarding offer to farmers.":"Bewirtschaftungsarten und Betriebszweige, die den Lagerhäusern für die Weiterleitung des Angebots an Landwirte empfohlen werden.","Farm type filter":"Betriebszweige-Filter","Farm types":"Betriebszweige","Farm types:":"Betriebszweige:","FarmHedge <i>for agribusinesses</i>":"Farmhedge <i>für Agrarunternehmen</i>","FarmHedge order ID":"Farmhedge Bestellnummer","FarmHedge payments are disabled.":"FarmHedge (in App) Zahlungen sind deaktiviert.","FarmHedge payments are enabled":"FarmHedge (in App) Zahlungen sind aktiviert","FarmHedge payments to allow your customers to pay with their credit/debit card.":"FarmHedge (in App) Zahlung erlaubt Ihren Kunden mit ihrer Kredit- oder Debitkarte auf der FarmHedge-App zu bezahlen.","FarmHedge subscription upgrade":"FarmHedge Abonnement Upgrade","FarmHedge supription package:":"FarmHedge Abonnement:","Farmer orders":"Bestellung von Landwirt","Farmers offer ends":"Angebot an Landwirte endet","Farmers offer is not active yet":"Angebot an Landwirte ist noch nicht aktiv","Farmers offers":"Angebot an Landwirte","Field is required":"Bitte füllen Sie das Feld aus","Field must be a positive value":"Wert muss einer positiven Zahl entsprechen","File URL":"URL der Datei","File URL:":"URL der Datei:","File name":"Dateiname","File name:":"Dateiname:","Filter requests for:":"Anfragen filtern nach:","Filters":"Filter","First":"Erste","First Name":"Vorname","For details, go to the \"Orders\" page from the main menu.":"Für Details, klicken Sie auf “Bestellungen” im Hauptmenü.","For help, please contact":"Um Hilfe zu erhalten, kontaktieren Sie bitte","For questions or help, please contact":"Um Hilfe zu erhalten, kontaktieren Sie bitte","For:":"Für:","Foresty":"Forst","Forgot password":"Passwort vergessen","Forgot your password?":"Passwort vergessen?","Forward offer to farmers":"An Landwirte weiterleiten","Forward this order to coworkers who do not have a FarmHedge account.<br>They will receive a link protected by a pincode. The information will be accessible for 2 weeks.":"Leiten Sie diese Bestellung an Kollegen weiter, die keinen FarmHedge Account haben. Diese werden einen Link erhalten, der durch einen Pincode geschützt ist. Der Link ist 2 Wochen lang gültig.","Forward to distributor":"An Zulieferer weiterleiten","Forward to farmers":"An Landwirte weiterleiten","Forwarded":"Weitergeleitet","From":"Ab","From <b>{{$ctrl.deal.supplier.name}}</b>":"Von <b>{{$ctrl.deal.supplier.name}}</b>","From distributor":"Vom Zulieferer","From: {{supplierName}}":"Von: {{supplierName}}","Fruit":"Obstbau","Generate invite":"Einladung erstellen","Getting started":"Beginnen","Go to farmers offer":"Angebot an Landwirte","Group":"Gruppe","Group discount":"Gemeinschaftsrabatt","Group discount ACTIVE":"Gemeinschaftsrabatt AKTIV","Group discount enabled":"Gemeinschaftsrabatt möglich","Group discount not active yet":"Gemeinschaftsrabatt noch nicht aktiv","Group name":"Gruppenname","Group name already exists":"Gruppenname existiert bereits","Group saved":"Gruppe gespeichert","Groups":"Gruppen","Hi":"Hallo","Hi, it’s {contactName} from {supplierName}. I'd like to invite you to FarmHedge to submit orders and send me product requests.":"Hallo, {contactName} lädt Sie ein, sich bei der kostenlosen FarmHedge App zu registrieren und spezielle Angebote vom {supplierName} zu erhalten.","Horticulture/gardening":"Gartenbau","Hours":"Stunden","How many units?":"Wieviele Einheiten?","How many?":"Wie viele?","I am":"Ich bin","I understand this is a legally binding transaction.":"Hiermit wird eine verbindliche Transaktion ausgelöst.","ID":"ID","If less units are sold, orders will be cancelled and famers will be notified.":"Sollten weniger Einheiten verkauft werden, werden die Buchungen automatisch storniert und die Landwirte benachrichtigt.","If you don't receive an email, and it's not in your spam folder this could mean you signed up with a different address.":"Wenn Sie keine E-Mail erhalten und sie nicht in Ihrem Spam-Ordner ist, könnte dies bedeuten, dass Sie sich mit einer anderen Adresse angemeldet haben.","If you press “OK”, this deal will be moved to \"Past deals\" and farmers will not be allowed to make any further bookings.":"Wenn Sie “OK” drücken, wird dieses Angebot in “Ausgelaufene Angebote” verschoben und Landwirte werden keine weiteren Buchungen mehr vornehmen.","Ignore":"Ignorieren","Image":"Bild","Import images":"Bilder importieren","Import product images":"Produktbilder importieren","Import products":"Produkte importieren","In shopping cart":"Im Einkaufswagen","Inactive suppliers":"Inaktiver Händler","Incl. VAT":"Inkl. USt","Include all":"Alle auswählen","Include attachments":"Anhänge weiterleiten","Include description":"Beschreibung weiterleiten","Include new customers":"Neue Kunden einschließen","Included":"Aufgenommen","Incoterms":"Incoterms","Invalid":"Ungültig","Invalid deal":"Ungültige Angebot","Invalid or expired registration link":"Ungültiger oder abgelaufener Registrierungslink","Invalid pincode":"Ungültiger Pincode","Invite customer to join FarmHedge":"Kunden einladen, FarmHedge zu nutzen","Invite customers":"Kunden einladen","Invite new Customers":"Neue Kunden einladen","Invites sent":"Einladungen gesendet","Items Available":"Angebotsmenge","Items Available:":"Angebotsmenge:","Items available":"Produkt verfügbar","Items available to farmers":"Angebotsmenge für Landwirte","LIVE":"LIVE","Language":"Sprache","Last":"Letzte","Last 30 days":"Letzten 30 Tagen","Last 7 days":"Letzten 7 Tagen","Last Name":"Familienname","Last offer":"Letztes Angebot","Last update":"Letzte Aktualisierung","Learn more about FarmHedge":"Erfahren Sie mehr über FarmHedge","Learn more about pricing and subscriptions":"Erfahren Sie mehr über unsere Kostenstruktur und Abonnements","Leave a message for your customer:":"Senden Sie eine Nachricht an den Kunden:","Less info":"Weniger Info","Link your customer permanently with a shop":"Verknüpfen Sie Ihren Kunden dauerhaft mit einem Standort","List of counties assigned to supplier:":"Liste der dem Händler zugeordneten PLZ:","List of users":"Liste der Benutzer","Live":"Live","Live offers for this user":"Live-Angebote für diesen Kunden","Loading":"Laden","Loading images..":"Bilder werden geladen..","Login":"Anmelden","Login on FarmHedge app":"In FarmHedge App einloggen","Logout":"Ausloggen","Logout?":"Abmelden?","Make products visible to customers (Public)":"Produkte für Kunden sichtbar machen (öffentlich)","Manage":"Verwalten","Margin":"Marge","Mark as completed":"Als erledigt markieren","Mark request as completed":"Anfrage als erledigt markieren","Max":"Max","Max for":"Maximum für","Maximum bookable":"Maximal","Maximum quantity bookable by a single user":"Maximalmenge pro Benutzer","Message":"Nachricht","Message for":"Nachricht an Kunden","Message for customers":"Nachricht an Kunden","Message from user":"Nachricht des Nutzers","Message length:":"Nachrichtenlänge:","Messages":"Nachrichten","Min":"Min","Minimum bookable":"Minimum","Minimum quantity bookable by a single user":"Mindestmenge pro Benutzer","Missing required email or password":"Benötigte E-Mail oder Passwort fehlt","Mobile preview: contact details":"Mobile Vorschau: Kontaktdaten","Mobile preview: price and discount":"Mobile Vorschau: Preis und Rabatte","Mobile preview: product name and image":"Mobile Vorschau: Produktname und Bild","Mobile preview: units available and distribution method":"Mobile Vorschau: verfügbare Einheiten und Liefermethoden","More info":"Mehr info","Most features will not be available after that date.":"Die meisten Funktionen werden nach diesem Datum nicht mehr für Sie verfügbar sein.","Multiple discount options available: flat discount, quantity-based or group discount.":"Verschiedene Rabatt-Optionen sind verfügbar: allgemeiner Rabatt, Mengenrabatt oder Gruppenrabatt.","N/A":"N/A","NEW":"NEU","Name":"Name","Need help?":"Brauchen Sie Hilfe?","New":"Neu","New crop offer":"Erzeugnisaufkauf","New customers":"Neue Kunden","New items available":"Neue Angebotsmenge verfügbar","New offer":"Neues Angebot","New offer end":"Neues Angebotsende","New order":"Neue Bestellung","New requests":"Neue Anfragen","New sale offer":"Betriebsmittelverkauf","New special offer":"Neues Sonderangebot","Next":"Nächste","No":"Nein","No accounts present":"Keine Konten vorhanden","No attachments":"Keine Anhänge","No customers available to show":"Es sind keine Kunden zum Anzeigen verfügbar","No description":"Keine Beschreibung","No end":"Kein Enddatum","No farmers found":"Keine Landwirte gefunden","No messages":"Keine Nachrichten","No offers available.":"Keine Angebote zur Verfügung.","No orders found.":"Keine Bestellungen gefunden.","No orders or reservations":"Keine Bestellungen oder Reservierungen","No pending orders":"Keine ausstehenden Bestellungen","No products found.":"Keine Produkte gefunden.","No reservations":"Keine Reservierungen","No zipcodes assigned to supplier":"Keine PLZ dem Lieferanten zugeordnet","Not visible to farmers yet.":"Noch nicht für Landwirte sichtbar.","Notes":"Notizen","Notification sent":"Benachrichtigung gesendet","Notify farmers":"Landwirte benachrichtigen","Notify farmers on their mobile phones":"Benachrichtigen Sie die Landwirte über ihre Mobiltelefone","OK":"OK","Offer deleted":"Angebot gelöscht","Offer description":"Angebotsbeschreibung","Offer draft created":"Angebotsvorlage erstellt","Offer end":"Angebot gültig bis","Offer ends":"Angebot gültig bis","Offer ends in":"Angebot endet in","Offer ends in:":"Angebot endet in:","Offer expired":"Angebot abgelaufen","Offer for {productName} extended":"Das “{productName}” wurde verlängert","Offer image":"Bild","Offer published":"Veröffentlichte Angebote","Offer saved":"Gespeichert","Offer sent":"Angebot gesendet","Offer start":"Angebot gültig ab","Offer starts":"Angebot gültig ab","Offers":"Angebote","Offers from your distributors.":"Angebote von Ihrem Zulieferer.","Offers only":"Nur Angebote","Ok":"Ok","One or more items are not valid. Please review the list below before going ahead.":"Eines oder mehrere Produkte sind ungültig. Bitte überprüfen Sie die untenstehende Liste bevor Sie fortfahren.","Only multiple of this can be booked":"Schrittgröße - Nur eine durch \"Schritt\" teilbare Anzahl kann gebucht werden","Open the FarmHedge app":"Öffnen Sie die FarmHedge App","Or":"Oder","Or google \"Farmhedge\" on your mobile":"Oder googlen Sie \"Farmhedge\" auf Ihrem Handy","Order":"Bestellung","Order ID":"Bestellnummer","Order date":"Bestelldatum","Order details":"Bestelldetails","Order forwarded":"Bestellung weitergeleitet","Order forwarded to distributor. For details, go to the \"Orders\" page from the main menu.":"Die Bestellung wurde an den Zulieferer weitergeleitet. Für mehr Informationen, klicken Sie bitte auf “Bestellungen” im Hauptmenü.","Order now":"Jetzt bestellen","Order placed":"Bestellung erfolgreich","Order placed successfully.":"Bestellung erfolgreich getätigt.","Order shared":"Bestellung geteilt","Order updated":"Bestellung aktualisiert","Ordered":"Bestellt","Orders":"Bestellungen","Organic":"Biologisch","Origin &amp; Year":"Herkunft &amp; Jahr","Original price":"Listenpreis","Original price:":"Listenpreis:","Our features:":"Unsere Funktionen:","Paid":"Bezahlt","Passcode is required.":"Pincode ist notwendig.","Password":"Passwort","Password is required":"Passwort ist notwendig","Password:":"Passwort:","Past":"Ausgelaufen","Payment:":"Bezahlverfahren:","Payments were enabled on:":"(In App) Bezahlung aktiviert am:","Pending":"Ausstehend","Pending invites":"Einladungen ausstehend","Pending only":"Nur ausstehend","Phone":"Telefonnummer","Phone number":"Telefonnummer","Phone number RA":"Tel. Aviso","Phone number already registered":"Telefonnummer bereits registriert","Pig":"Schweinemast","Piglet":"Ferkelaufzucht","Pincode":"Pincode","Please check your email for password reset instructions.":"Überprüfen Sie Ihren Posteingang für die nächsten Schritte.","Please complete the following ({{Fields.length}}) fields":"Bitte füllen Sie die folgenden Felder aus ({{Fields.length}})","Please do not press back or refresh the page.":"Bitte drücken Sie nicht auf zurück und aktualisieren Sie nicht die Seite.","Please donot press <i class=\"fa fa-arrow-circle-o-left\"></i> back or <i class=\"fa fa-refresh\"></i> refresh while image is uploading.":"Bitte drücken Sie nicht Zurück oder Aktualisieren, während das Bild hochgeladen wird.","Please explain to your customer why you are rejecting this request:":"Teilen Sie dem Kunden mit, warum die Anfrage abgelehnt wurde:","Please fill your details to accept the invite:":"Bitte registrieren Sie sich, um die Einladung anzunehmen:","Please note that the order details are not forwarded to the distributor. If you want this, please click on \"Forward to distributor\"":"Bitte beachten Sie, dass die Bestelldetails nicht via FarmHedge an den Zulieferer weitergeleitet werden. Sollten Sie eine Weiterleitung wünschen, klicken Sie bitte auf \"An Zulieferer weiterleiten\".","Please note: if a product with same ID or name already exists, the existing product data will be updated.":"Bitten beachten: wenn ein Produkt mit der selben ID bereits existiert, wird dieses überschrieben.","Potential new customers":"Potenzielle neue Kunden","Poultry":"Geflügel","Prev":"Vorherige","Preview on mobile":"Vorschau am Smartphone","Price":"Preis","Price changes every day":"Preis ändert sich jeden Tag","Price for":"Preis für","Price is substantially different from offer price":"Der Preis weicht deutlich vom Angebotspreis ab","Price updated":"Preis aktualisiert","Prices exclude VAT.":"Alle Preisangaben exkl. USt.","Pricing":"Kostenstruktur","Product":"Produkt","Product '{{vm.product.name || vm.product}}' does not exist.":"Produkt \"{{vm.product.name || vm.product}}\" ist nicht vorhanden.","Product ID":"Materialnummer","Product Id":"Materialnummer","Product created":"Produkt erstellt","Product deleted.":"Produkt gelöscht.","Product name":"Produktbezeichnung","Product name and a picture associated to it is displayed to farmers on the mobile app.":"Der Produktname und ein zugewiesenes Bild werden Landwirten in der mobilen App angezeigt.","Product type":"Produkttyp","Product types":"Produkt Kategorien","Product updated":"Produkt aktualisiert","Products":"Produkte","Profile Settings":"Profil","Progress":"Verkäufe","Publish":"Öffentlich","Publish on":"Öffentlich am","Purchase":"Kauf","Purchases":"Meine Käufe","Qty":"Menge","Quantity":"Menge","Quantity Limit":"Mengenbegrenzung","Question about your FarmHedge request":"Frage bezüglich Ihrer FarmHedge Anfrage","Reach new farmers":"Erreichen Sie neue Landwirte","Receive notifications":"Benachrichtigungen erhalten","Receive orders":"Bestellungen erhalten","Receive real-time requests":"Erhalten Sie Echtzeit-Anfragen","Refresh":"Aktualisieren","Registration date":"Registrierungsdatum","Reject order":"Bestellung ablehnen","Reject request":"Anfrage ablehnen","Rejected":"Abgelehnt","Remember me":"Benutzername merken","Remind me to update price":"Erinnere mich daran, den Preis zu aktualisieren","Remove":"Löschen","Remove attachment":"Anhang entfernen","Remove from cart":"Aus Einkaufswagen entfernen","Remove variant":"Variante entfernen","Report &amp; orders":"Buchungsbericht","Request Error: An error occurred while processing the request.":"Anfrage Fehler: Fehler beim Verarbeiten der Anforderung.","Request for":"Anfrage für","Requested":"Erfragt","Requested verification":"Verifizierung angefordert","Requests":"Anfragen","Reservation":"Reservierung","Reservation created":"Reservierung vorgenommen","Reservation ends in":"Reservierung endet in","Reservation time":"Zeit für Reservierung","Reservation updated":"Reservierung aktualisiert","Reserve":"Reservieren","Reserved":"Reserviert","Reserved amount":"Reservierte Menge","Reset":"Zurücksetzen","Reset Password":"Passwort zurücksetzen","Reset filters":"Filter zurücksetzen","Reset password":"Passwort zurücksetzen","Reset prices":"Preise zurücksetzen","Result":"Resultat","Retailer":"Händler","Retailers":"Händler","Review":"Prüfen","Review and publish":"Angebot veröffentlichen","SMS":"SMS","Sale":"Verkauf","Sale Price":"Angebotspreis","Sale offer":"Angebote","Sale price":"Angebotspreis","Sales":"Meine Verkäufe","Sample product":"Beispielprodukt","Save":"Änderungen speichern","Save 1 product":"1 Produkt speichern","Save and publish 1 product":"1 Produkt speichern und veröffentlichen","Save and publish {{$ctrl.validRowsCount}} products":"{{$ctrl.validRowsCount}} Produkte speichern und veröffentlichen","Save draft":"Entwurf speichern","Save {{$ctrl.validRowsCount}} products":"{{$ctrl.validRowsCount}} Produkte speichern","Scheduled":"Geplant","Search":"Suche","Search product catalog":"Produktkatalog durchsuchen","See attachment preview":"Anhangvorschau anzeigen","Select Target Suppliers":"Gewünschten Anbieter auswählen","Select all farmers in a particular area":"Wählen Sie alle Landwirte in einem bestimmten Gebiet aus","Select crop":"Bitte auswählen","Select farm type...":"Betriebszweig auswählen...","Select farmers":"Landwirte auswählen","Select farmers based on their farm type":"Wählen Sie Landwirte basierend auf ihrem Betriebszweig aus","Select file format":"Dateiformat wählen","Select file from your computer":"Datei von Ihrem Computer auswählen","Select product":"Produkt auswählen","Select standards":"Wählen Sie Normen","Sell":"Verkaufen","Seller":"Verkäufer","Seller:":"Verkäufer:","Send SMS and email to customers":"E-Mail und SMS an Kunden senden","Send SMS to customers":"Senden Sie eine SMS an Kunden","Send email to customers":"E-Mail an Kunden senden","Send offers on farm inputs":"Senden Sie Angebote für landwirtschaftliche Betriebsmittel","Send push notification to customers":"Senden Sie eine Push-Benachrichtigung an Ihre Kunden","Send us an email":"Senden Sie uns eine E-Mail","Sent":"Gesendet","Server Error: user authentication failed. Please report this to system administrator.":"Server-Fehler: Benutzerauthentifizierung fehlgeschlagen. Bitte melden Sie dies an Systemadministrator.","Set/Update offer image":"Bild hochladen / aktualisieren","Share":"Teilen","Share order":"Bestellung teilen","Share the following link with {{$ctrl.inviteData.phoneNumber}}":"Teilen Sie den folgenden Link mit {{$ctrl.inviteData.phoneNumber}}","Sheep":"Schaf","Shop":"Standort","Shops":"Standorte","Show rejected/invalid orders":"Abgelehnte und ungültige Bestellungen anzeigen","Show requests in your area submitted in the last":"Zeige Anfragen in Ihrer Region aus den letzten","Show results in the last":"Zeige Ergebnisse der letzten","Since":"Seit","Sold out":"Ausgebucht","Special offer until":"Sonderangebot bis","Specify custom discount based on quantity purchased.":"Der Rabatt für den Landwirt ist abhängig von der gekauften Menge. Der Händler definiert die jeweiligen Rabatt-Stufen.","Starts in:":"Beginnt in:","Starts now":"Beginnt jetzt","Status":"Status","Step":"Schritt","Step 1: Get FarmHedge on your smartphone":"Schritt 1: Holen Sie sich FarmHedge auf Ihr Smartphone","Step 2: Login on FarmHedge app":"Schritt 2: Melden Sie sich bei der FarmHedge App an","Stock":"Bestand","Stop forwarded offer to farmers":"Angebot abbrechen","Stop offer":"Angebot abbrechen","Streamline operations and reduce costs":"Rationalisieren Sie Abläufe und senken Sie Kosten","Street":"Straße","Subscription expiration date:":"Abonnement Ende:","Success":"Erfolg","Suckler":"Mutterkühe","Supplier":"Händler","System":"Bewirtschaftungsart","Target":"Target","Technic":"Technik","That's it!":"Fertig!","The easy, secure and private way to trade with your suppliers.":"Der einfache, sichere und persönliche Weg mit Ihrem Agrarhändler zu kommunizieren.","The following FarmHedge users asked to become your customer. You can accept or ignore their requests.":"Ignorieren","The new way to communicate with farmers":"Die neue Art der Kommunikation mit Landwirten","The number of units available and distribution methods will be showed to famers on the mobile app.":"Die Menge der verfügbaren Einheiten und die möglichen Liefermethoden werden den Landwirten in der mobilen App angezeigt.","The registration process takes only a few minutes.":"Der Registrierungsvorgang dauert nur wenige Minuten.","There are no offers from your distributors.":"Es liegen keine Angebote Ihres Zulieferers vor.","These offers are not active anymore. Most recent offers are on top.":"Diese Angebote sind nicht mehr aktiv. Die letzten Angebote sind zuerst gereiht.","This Month":"Aktueller Monat","This browser does not support the import function.":"Dieser Browser unterstützt nicht die Import Funktion.","This deal does not exist anymore.":"Dieses Angebot existiert nicht mehr.","This is the notification text.":"Dies ist der Benachrichtigungstext.","This item is already in your shopping cart":"Dieses Produkt ist bereits in Ihrem Einkaufswagen","This means that your customers can pay on the FarmHedge app using their credit or debit card.":"Das bedeutet, dass Ihre Kunden mit ihrer Kredit- oder Debitkarte auf der FarmHedge-App bezahlen können.","This window will auto-close once the image upload completes.":"Dieses Fenster wird automatisch geschlossen, sobald das Bild hochgeladen wurde.","Today":"Heute","Tonne":"Tonnen","Total":"Gesamt","Total price":"Gesamtpreis","Transaction saved to \"Orders\" page":"Transaktion wurde unter “Bestellungen” gespeichert","Type":"Art","Unauthorized access":"Nicht autorisierter Zugriff","Unauthorized: invalid username or password.":"Ungültiger Benutzername oder Passwort.","Unit":"Einheit","Unit price":"Preis pro Einheit","Unit:":"Einheit:","Units":"Einheiten","Until":"Bis","Update":"Bearbeiten","Update due":"Aktualisierung fällig","Update needed":"Aktualisierung erforderlich","Update product":"Produkt aktualisieren","Update quantity available of forwarded offer to {{$ctrl.amountReserved}}":"Für weitergeleitete Angebote verfügbare Menge bearbeiten","Updated":"Aktualisiert am","Updated:":"Aktualisiert am:","Upgrade":"Upgrade","Upload":"Datei-Upload","Upload Profile image":"Profilbild hochladen","Upload failed. File must be a valid Excel or CSV file.":"Hochladen fehlgeschlagen. Die Datei muss eine gültige Excel oder CSV Datei sein.","Upload failed. File must be a valid PDF file.":"Hochladen fehlgeschlagen. Die Datei muss eine gültige PDF Datei sein.","Uploading...":"Lädt hoch…","Use these credentials:":"Verwenden Sie diese Anmeldeinformationen:","User":"Benutzer","User not authorized":"Nicht autorisierter Zugriff","Users":"Benutzer","Value is not valid":"Wert ist nicht gültig","Verified":"Verifiziert","Via SMS":"Via SMS","Via email":"Via E-Mail","View / Select farmers":"Anzeige / Landwirte auswählen","Want to know more?":"Möchten Sie mehr wissen?","Weeks":"Wochen","Welcome to":"Willkommen bei","Welcome to FarmHedge":"Willkommen bei FarmHedge","What is FarmHedge?":"Was ist FarmHedge?","Winegrowing":"Weinbau","Yes":"Ja","You did not submit a phone number. Continue anyway?":"Sie haben keine Nummer für die tel. Aviso angegeben. Trotzdem fortfahren?","You do not have permissions to view this deal.":"Sie sind nicht berechtigt, diesen Angebote anzuzeigen.","You will be asked to confirm the quantity delivered. Price per {unit} will not change.":"Sie werden aufgefordert, die gelieferte Menge zu bestätigen. Der Preis pro {unit} ändert sich nicht.","You will be notified on farmers bookings.":"Sie werden bei Buchungen von Landwirten benachrichtigt.","You will receive the funds directly on a bank account of your choice.":"Sie erhalten den Betrag direkt auf ein Bankkonto Ihrer Wahl.","You will receive the funds directly on the bank account specified during the registration process.":"Sie erhalten den Betrag direkt auf das während der Registrierung angegebene Bankkonto.","Your FarmHedge subscription has expired.":"Ihr FarmHedge Abonnement ist abgelaufen.","Your FarmHedge subscription will expire on {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}":"Ihr FarmHedge Abonnement läuft ab am {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}","Your TRIAL subscription will expire on {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}":"Ihr Testzugang läuft ab am {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}","Your message":"Ihre Nachricht","Zip code":"PLZ","affected":"betroffen","and {{vm.productTypes.length-2}} other":"und {{vm.productTypes.length-2}} andere","by {{gdDate}} (end of the deal).":"{{gdAmount}} Einheiten verkauft werden.","day":"Tag","days":"Tage","discount":"Rabatt","farmer(s) selected":"Landwirt(e) ausgewählt","for":"an","for:":"Für:","from":"ab","hour":"Stunde","hours":"Stunden","https://fh-data-1.s3.eu-west-1.amazonaws.com/1533808623752Screen%20Shot%202018-08-09%20at%2010.56.33.png":"https://fh-data-1.s3.eu-west-1.amazonaws.com/1533808704908Screen%20Shot%202018-08-09%20at%2010.56.39.png","if {{gdAmount}} units are sold":"wenn bis zum {{gdDate}} weitere","images uploaded":"Bilder hochgeladen","min.":"Min.","new this month":"neue diesen Monat","new this week":"neue diese Woche","order":"Bestellung","orders":"Bestellungen","pending":"Ausstehend","products imported":"Produkte importiert","reservation":"Reservierung","reservations":"Reservierung","selected":"ausgewählt","units":"Einheiten","until":"bis","week":"Woche","weeks":"Wochen","{{$ctrl.invitation.createdBy.name.first}}'s message:":"{{$ctrl.invitation.createdBy.name.first}}’s Nachricht:","{{group.name}} ({{group.users.length}} customers)":"{{group.name}} ({{group.users.length}} Kunden)","{{vm.lookup.distMethodsMap[vm.model.distribution]}} ends":"{{vm.lookup.distMethodsMap[vm.model.distribution]}} möglich bis","{{vm.lookup.distMethodsMap[vm.model.distribution]}} starts":"{{vm.lookup.distMethodsMap[vm.model.distribution]}} möglich ab","{{vm.orders.length}} order":"{{vm.orders.length}} Bestellung","{{vm.orders.length}} orders":"{{vm.orders.length}} Bestellungen","{{vm.pendingInvitesCount || 0}} pending invites":"{{vm.pendingInvitesCount || 0}} unbeantwortete Einladungen","{{vm.pendingInvitesCount}} pending invite":"{{vm.pendingInvitesCount}}  unbeantwortete Einladung"});
    gettextCatalog.setStrings('hu', {"(1 offer)":"(1 ajánlat)","(Only multiples of {{vm.model.dealSizeOptions.step}} can be booked)":"(Csak {{vm.model.dealSizeOptions.step}} többszöröse foglalható)","({{deals.length}} offers)":"({{deals.length}} ajánlatok)","* Field is required":"* A mező kitöltése kötelező","* Field not valid":"* A mező nem érvényes","* Must be greater than \"Step\"":"* Nagyobbnak kell lennie, mint a \"Lépés\"","* Value must be a real number":"* Az értéknek valós számnak kell lennie","* file size cannot exceed 4.0 MB":"* a fájl mérete nem haladhatja meg a 4.0 MB-t","* selected file must be an image file":"* a kiválasztott fájlnak kép fájlnak kell lennie","* value must not be greater than original price":"* az érték nem lehet nagyobb, mint az eredeti ár","* {{f.label}} is required":"* {{f.label}} szükséges","* {{f.label}} value is not valid":"* {{f.label}} érték nem érvényes","1 day":"1 nap","1 month":"1 hónap","1 week":"1 hét","8 characters length":"8 karakter hosszúság","<b>{{$ctrl.invitation.createdBy.nameFull}}</b> invited you to join FarmHedge.":"<b>{{$ctrl.invitation.createdBy.nameFull}}</b> meghívott, hogy csatlakozz a FarmHedge-hez.","A link like \"farmhedge.ie\" will be automatically added to the message.":"Egy link, mint például \"farmhedge.io” automatikusan hozzáadódik az üzenethez.","A lower-case letter (a, b, ...)":"Egy kisbetűs (a, b, ...)","A number (1, 2, ...)":"Egy szám (1, 2,...)","About your FarmHedge request":"A FarmHedge kéréséről","About {{$ctrl.invitation.supplier.name}}":" <b>{{$ctrl.invitation.supplier.name}}</b>ről","Accept invite":"Meghívás elfogadása","Accepted":"Elfogadva","Accepted invites":"Elfogadott meghívások","Account ID:":"Számlaazonosító:","Actions":"Opciók","Activate FarmHedge payments":"A FarmHedge-kifizetések aktiválása","Active":"Aktív","Add":"Hozzáad","Add all":"Az összes hozzáadása","Add attachment":"Melléklet hozzáadása","Add discount":"Kedvezmény hozzáadása","Add new":"Új hozzáadása","Add product":"Termék hozzáaadása","Add to cart":"Hozzáadás a kosárhoz","Added":"Hozzáadott","Added to shopping cart":"Hozzáadva a kosárhoz","Address":"Cím","Advanced":"Speciális","Agricultural Contractor":"Mezőgazdasági Vállalkozó","All Categories":"Összes kategória","All buy requests":"Minden vásárlási kérés","All farmers will receive {{gdDiscount | number:0}}% discount":"Minden gazdaság kap {{gdDiscount | number:0}}% kedvezményt,","All farmers will receive {{gdDiscount}}% discount":"Minden gazdaság kap {{gdDiscount}}% kedvezményt","All offers":"Minden ajánlat","All sell requests":"Minden eladási ajánlat","Already a customer?":"Már vásárolt?","Already existing customer":"Már vásárolt?","Always applied and independent on the quantity sold.":"Mindig alkalmazható, és független az eladott mennyiségtől.","Amount":"Összeg","An Error has occurred.":"Hiba történt.","An email was sent to":"Egy e-mailt küldtünk","An upper-case letter (A, B, ...)":"Egy nyomtatott nagybetűs  (A, B,...)","And much more!":"Valamint még sok más!","Any":"Bármilyen","Any type":"Bármilyen típusú","Applies if {{d.groupDiscount.quantityThreshold}} or more units are sold.":"Érvényes, ha  {{d.groupDiscount.quantityThreshold}} vagy annál több darabot adnak el.","Applies if {{qd.quantity}} or more units are sold.":"Érvényes, ha {{qd.quantity}} vagy annál több darabot adnak el.","Applies if {{qd1.quantity}} or more units are sold.":"Érvényes, ha {{qd1.quantity}} vagy annál több darabot adnak el.","Are you agribusiness?":"Ön agrárvállalkozó?","Are you shoure you want to disable FarmHedge payments?":"Biztos, hogy szeretné letiltani a FarmHedge kifizetéseket?","Are you sure you want to delete the selected deal?":"Biztos, hogy törölni akarja a kiválasztott ügyletet?","Are you sure?":"Biztos benne?","Are you sure? Customer will be notfied with an email.":"Biztos benne? Az ügyfélt e-mailben értesítjük.","Areas:":"Területek:","Ask farmers to sell their crop":"Kérje meg a gazdákat, hogy adják el a terményüket","Ask for price":"Kérje az árat","Associate customer to \"{{$ctrl.order.billingAddress.name}}\" for future orders.":"Vásárló társítása {{$ctrl.order.billingAddress.name}} jövőbeni rendelésekhez.","Attachment":"Mellékletek","Attachments":"Mellékletek","Available":"Elérhető","Back":"Vissza","Base discount":"Alap kedvezmény","Base discount plus an additional discount received by all farmers when the number units of sold is equal to 'Group size'.":"Alap kedvezmény, plusz minden gazda további kedvezményt kap, amikor az eladott egységek száma megegyezik a  'Csoport méretével'.","Beef":"Szarvasmarha","Billing Info":"Számlázási adatok","Billing address":"Számlázási cím","Billing info":"Számlázási adatok","Billing information":"Számlázási információk","Bookings":"Foglalások","Business name and your contacts can be optionally shared on the offer.":"Az üzlet neve, illetve a partnerei tetszés szerint megoszthatók az ajánlaton.","Buy":"Vásárlás","Buyer":"Vevő:","Buyer:":"Vevő:","By:":"Által","Cancel":"Mégse","Cancel offer":"Ajánlat törlése","Cancel reservation":"Foglalás törlése","Cancelled by farmer":"Törölve a gazda által","Card payment":"Kártyás fizetés","Card payment required at checkout":"Kártyás fizetés szükséges a pénztárnál","Category":"Kategória","Cereal":"Gabona","Change language":"Nyelv módosítása","Changes saved":"Módosítások mentve","City":"Város","Click \"Confirm\" to cancel reservation":"Kattintson a\" Megerősítés \" gombra a foglalás visszavonásához","Click \"Continue\" to review and confirm the offer details.":"Kattintson a \"Folytatás\" gombra az ajánlat részleteinek ellenőrzéséhez.","Click \"Save\" to make sure changes are not lost.":"Kattintson a \"Mentés\" gombra, hogy megbizonyosodjon arról, hogy a módosítások nem vesztek el.","Click on \"Create new offer\" to setup a new offer for your customers.":"Kattintson az “új ajánlat létrehozása” gombra, ha új ajánlatot szeretne beállítani az ügyfeleinek.","Click on \"Publish\" when you are happy for the offer details. Farmers will receive a notification on their mobile phones.":"Kattintson a “közzététel” gombra, ha elégedett az ajánlattal. A gazdálkodók erről a telefonjukon értesítést kapnak.","Click to change image":"Kattintson a kép módosításához","Click to choose an image":"Kép kiválasztásához kattintson","Clone offer":"Ajánlat másolása","Close":"Bezárás","Collection":"Áruátvétel","Collection Point":"Felvevő hely","Collection Points":"Felvevő helyek","Collection from:":"Áruátvétel kezdete:","Collection points":"Felvevő helyek","Collection until:":"Áruátvétel vége:","Coming soon":"Hamarosan.","Complete order":"Kész","Complete the information below to store the order information for future reference.":"Töltse ki az alábbi információkat, hogy tárolja a megrendelési információkat a jövőre.","Completed":"Kész","Confirm":"Megerősítés","Confirm Action":"Megerősítés","Confirm and Place order":"Megerősítés és rendelés","Contact":"Kapcsolat","Contact us today to renew your subscription and access all the features and information you need.":"Lépjen velünk kapcsolatba még ma, hogy megújítsa az előfizetését, és hozzáférjen minden funkcióhoz, valamint a szükséges információkhoz.","Continue":"Tovább","Conventional":"Hagyományos","Copy":"Másolás","Copy image (CTRL + C) and paste here using CTRL + V":"Másolja a képet (CTRL + C), majd illessze be ide a CTRL + V billentyűkombinációval","Counties":"Megye","Country":"Ország","County":"Megye","Create New":"Új létrehozása","Create an offer":"Ajánlat létrehozása","Create group \"{{$ctrl.newGroupName}}\"":"Csoport létrehozása {{$ctrl.newGroupName}}","Create product":"Termék létrehozása","Created":"Létrehozva","Created:":"Létrehozva:","Crop":"Termény","Crop Standards Configuration":"Termény Szabvány Konfiguráció","Crop deal":"Termény ügylet","Crop procurement":"Termény beszerzés","Crop quality":"A termény minősége","Crop type":"Termény típusa:","Current and past \"{{req.content[1]}}\" offers":"Aktuális és korábbi \"{{req.content[1]}}\" ajánlatok","Current items available":"Jelenleg elérhető termékek","Current offer end":"A jelenlegi ajánlat vége","Currently active offers.":"Jelenleg aktív ajánlatok.","Custom discount":"Egyedi kedvezmény","Customer":"Ügyfél","Customer ID":"Vevőazonosító","Customer Id":"Vevőazonosító","Customer data updated successfully":"Ügyfél adatok sikeresen frissítve ","Customer invites":"Vevő meghívások","Customer name":"Ügyfél neve","Customer price":"Ügyfél árak","Customer request":"Ügyfél kérése","Customers":"Ügyfelek","Dairy":"Tejtermelők","Date":"Dátum","Days":"Nap","Deal draft deleted successfully":"Ügylet vázlat sikeresen törölve","Deal end":"Ügylet vége","Deal end:":"Ügylet vége:","Deal start":"Ügylet kezdete","Deal start:":"Ügylet kezdete:","Delete draft":"Vázlat törlése","Delete product":"Termék törlése","Delete product?":"Törli a terméket?","Delivery":"Szállítás","Delivery Info":"Szállítási információ","Delivery address":"Szállítási cím","Delivery from:":"Szállítás kezdete:","Delivery locations":"Szállítási helyszínek","Delivery period":"Szállítási időszak","Delivery until:":"Szállítás vége:","Description":"Leírás","Discard unsaved changes?":"Törli a nem mentett változtatásokat?","Discount":"Árengedmény","Discount settings":"Árengedmény beállítások","Discount:":"Árengedmény:","Distribution Start date must be after the Booking Start date.":"Az áruelosztás kezdete csak a Foglalás  kezdete után lehet.","Distribution method":"Áruelosztás módja","Distributor":"Forgalmazó","Distributor offer connected":"Forgalmazó ajánlat elfogadva???","Distributor orders":"Forgalmazó megrendelések","Distributor price":"Forgalmazói ár","Distributors offers":"Forgalmazó ajánlatok","Do not forward description":"Ne küldje el a leírást","Do you already have the mobile app installed?":"Már telepítve van a mobil alkalmazás?","Do you have a supplier account?":"Van beszállítói számlája?","Do you want to clone this deal?":"Szeretné másolni ezt az ügyletet?","Do you want to create product \"{0}\"?":"Szeretné létrehozni a \"{0}\" terméket?","Download for Android":"Letöltés Androidra","Download for iOS":"Letöltés iOS-re","Draft created":"Vázlat létrehozva","Draft deleted":"Vázlat törölve","Drafts":"Vázlatok","Drag-and-drop here":"Húzza ide","E.g. +431111111, 02222222, 3333333":"Pl. +4311111, 0222222222, 3333333","E.g. 90":"Pl. 90","E.g. Concentrate feed":"Pl. koncentrált takarmányok","E.g. FCA":"Pl. FCA","E.g. Germany 2018":"Pl. Németország 2018","E.g. Liters":"Pl. liter","E.g. Protein 10%":"Pl. Fehérje 10%","E.g. Tonne":"Pl. Tonna","Easy to use":"Könnyen használható","Edit":"Szerkesztés","Edit filters and notifications":"Szűrők és értesítések szerkesztése","Edit reservation":"Foglalás szerkesztése","Email":"Email","Email already registered":"Már regisztrált e-mail cím ","Email is required":"E-mail cím szükséges","Email must be valid":"Az e-mail címnek érvényesnek kell lennie.","Email:":"Email:","Empty":"Üres","Ends in:":"Vége:","English":"English","Error while creating new deal":"Hiba történt az új ügylet létrehozásakor","Error while creating new offer":"Hiba történt az új ügylet létrehozásakor","Error while creating offer. Please try again.":"Hiba történt az ajánlat létrehozásakor. Kérjük próbálja újra.","Error while creating order. Please try again.":"Hiba történt a megrendelés létrehozásakor. Kérjük próbálja újra.","Error while creating reservation. Please try again.":"Hiba történt a foglalás létrehozásakor. Kérjük próbálja újra.","Excl. VAT":"ÁFA nélkül","Exclude all":"Összes törlése","Exclude from all offers":"Egyik ajánlatban sincs benne","Excluded":"Nincs benne","Excluded from all offers":"Egyik ajánlatban sincs benne","Existing":"Meglévő","Expired":"Lejárt","Expires on:":"Lejár:","Export":"Exportálás","Export all":"Összes exportálása","Export last {{$ctrl.slider.value}}":"Utolsó {{$ctrl.slider.value}} exportálása","Extend":"Meghosszabbít","Extend offer":"Ajánlat meghosszabbítása","Farm type filter":"Gazdaság típus szűrő","Farm types":"Gazdaság típusok","Farm types:":"Gazdaság típusok:","FarmHedge <i>for agribusinesses</i>":"FarmHedge <i>a agribusinesses</i>","FarmHedge order ID":"Rendelés azonosító","FarmHedge payments are disabled.":"A FarmHedge-kifizetéseket letiltották.","FarmHedge payments are enabled":"A FarmHedge-kifizetések engedélyezettek","FarmHedge payments to allow your customers to pay with their credit/debit card.":"FarmHedge fizetés lehetővé teszi az ügyfelek számára, hogy fizessenek a saját hitelkártyájukkal / bankkártyájukkal.","FarmHedge subscription upgrade":"FarmHedge előfizetési frissítés","FarmHedge supription package:":"FarmHedge előfizetési csomag:","Farmer Requests":"Ajánlatkérések a gazdáktól","Farmer orders":"Gazda megrendelések","Farmer will have to select one of these collection points.":"A farmernak a következő felvevő helyek közül kell választania.","Farmers offer ends":"Ügylet lejárata","Farmers offer is active":"A gazda ajánlata aktív","Farmers offer is not active yet":"A gazda ajánlata még nem aktív","Farmers offers":"Gazdák ajánlatai","Field is required":"A mező kitöltése kötelező","Field must be a positive value":"A mezőnek pozitív értéknek kell lennie","File URL":"Fájl URL","File URL:":"Fájl URL","File name":"Fájlnév","File name:":"Fájlnév:","Filter requests for:":"Szűrés a következőkre:","Filters":"Szűrők","First":"Első","First Name":"Keresztnév","For details, go to the \"Orders\" page from the main menu.":"A részletekért látogasson el a főmenü \"megrendelések\" oldalára.","For help, please contact":"Ha segítségre van szüksége, lépjen kapcsolatba","For questions or help, please contact":"Ha kérdése van, vagy segítségre van szüksége, kérjük, lépjen kapcsolatba","For:":"Mert","Foresty":"Erdészet","Forgot password":"Elfelejtett jelszó","Forgot your password?":"Elfelejtette jelszavát?","Forward offer to farmers":"Ajánlat továbbküldése a gazdáknak","Forward this order to coworkers who do not have a FarmHedge account.<br>They will receive a link protected by a pincode. The information will be accessible for 2 weeks.":"Továbbítsa ezt a megrendelést azoknak a munkatársaknak, akiknek nincs FarmHedge fiókjuk.< br>kapnak egy pinkóddal védett linket. Az információ 2 hétig lesz elérhető.","Forward to distributor":"Továbbküldés a forgalmazónak ","Forward to farmers":"Továbbküldés gazdáknak","Forwarded":"Továbbított","From <b>{{$ctrl.deal.supplier.name}}</b>":" <b>{{$ctrl.deal.supplier.name}}</b>től","From distributor":"A forgalmazótól","From: {{deal.supplier.name}}":"{{deal.supplier.name}} -től","From: {{match.model.supplier.name}}":" <b>{{match.model.supplier.name}}</b>től","From: {{supplierName}}":"{{supplierName}} től","Fruit":"Gyümölcs","Generate invite":"Meghívás generálása","German (Austria)":"Német (ausztriai)","German (Germany)":"Német (Németország)","Getting started":"Kezdés","Go to farmers offer":"Tovább a gazdák ajánlataira","Group":"Csoport","Group discount":"Csoportos kedvezmény","Group discount ACTIVE":"A csoportos kedvezmény AKTÍV","Group discount enabled":"Csoportos kedvezmény engedélyezve","Group discount not active yet":"A csoportos kedvezmény még nem aktív","Group name":"Csoport neve","Group name already exists":"Ez a csoport név már létezik","Group saved":"Csoport mentve","Group size":"Csoport mérete","Groups":"Csoportok","Has requested to be verified on: {{utils.getLocalizedDateAndTime(supplierCustomer.requestedVerificationAt)}}":"Ellenőrzés kérésének dátuma:{{utils.getLocalizedDateAndTime(supplierCustomer.requestedVerificationAt)}}","Hi":"Szia.","Hi, it’s {contactName} from {supplierName}. I'd like to invite you to FarmHedge to submit orders and send me product requests.":"Szia, itt {contactName} a {supplierName} - től. Szeretném meghívni Önöket a FarmHedge-be, hogy küldjék el a rendeléseket és küldjék el a termékkérelmeket.","Hide price to non-verified users":"Ár elrejtése a nem ellenőrzött felhasználók elől","Horticulture/gardening":"Kertészet","Hours":"Óra","How many units?":"Hány egység?","How many?":"Mennyiség","Hungarian":"Hungarian","I am":"Vagyok","I understand this is a legally binding transaction.":"Megértem, hogy ez egy jogilag kötelező erejű tranzakció.","ID":"Azonosító","If less units are sold, orders will be cancelled and famers will be notified.":"Ha kevesebb egységet értékesítenek, a megrendelések törlődnek, és a gazdák értesítést kapnak.","If you don't receive an email, and it's not in your spam folder this could mean you signed up with a different address.":"Ha nem kap e-mailt, és nincs benne a spam mappájában, ez azt jelentheti, hogy más címmel regisztrált.","If you press “OK”, this deal will be moved to \"Past deals\" and farmers will not be allowed to make any further bookings.":"Ha megnyomja az \"OK\" gombot, akkor ez az ügylet \"Korábbi ügylet\" lesz és a gazdák a továbbiakban nem fognak tudni foglalásokat tenni.","Image":"Kép","Import images":"Képek importálása","Import product images":"Termékképek importálása","Import products":"Termék importálása","In shopping cart":"Bevásárlókosárban","Inactive suppliers":"Inaktív beszállítók","Incl. VAT":"ÁFÁ-val","Include all":"Összes kijelölése","Include attachments":"Mellékletek felvétele","Include description":"Leírás hozzáadása","Include new customers":"Új ügyfelek felvétele","Included":"Tartalmazza","Incoterms":"Szállítási feltételek:","Invalid":"Érvénytelen","Invalid deal":"Érvénytelen üzlet","Invalid or expired registration link":"Érvénytelen vagy lejárt regisztrációs link","Invalid pincode":"Érvénytelen pinkód","Invite customer to join FarmHedge":"Új ügyfél felvétele a FarmHedge applikációba","Invite customers":"Ügyfél felvétele","Invite new Customers":"Új ügyfelek felvétele","Invites sent":"Meghívók elküldve","Items Available":"Elérhető termékek","Items Available:":"Elérhető termékek:","Items available":"Elérhető termékek","Items available to farmers":"Gazdák számára elérhető termékek","LIVE":"Aktív","Language":"Nyelv","Last":"Utolsó","Last 30 days":"Az elmúlt 30 nap","Last 7 days":"Az elmúlt 7 nap","Last Name":"Vezetéknév","Learn more about FarmHedge":"További információ a FarmHedge-ről","Learn more about pricing and subscriptions":"További információ az árakról és az előfizetésekről","Leave a message for your customer:":"Hagyjon üzenetet az ügyfelének.:","Less info":"Kevesebb információ","List of counties assigned to supplier:":"A beszállítóhoz kapcsolódó irányítószámok listája:","List of users":"Felhasználók listája","Live":"Aktív","Live Offers":"Aktív ajánlatok","Live offers for this user":"Aktív ajánlatok ennek a felhasználónak","Loading":"Betöltés","Loading images..":"Képek betöltése..","Login":"Bejelentkezés","Login on FarmHedge app":"Belépés a FarmHedge applikációba","Logout":"Kijelentkezés","Logout?":"Kijelentkezik?","Make products visible to customers (Public)":"A termékek láthatóvá tétele az ügyfelek számára (nyilvános)","Manage":"Módosítás","Margin":"Haszonkulcs","Margin is not showed to farmers":"Az árrést nem mutatják a gazdák számára","Mark as completed":"Megjelölés teljesítettként","Mark request as completed":"Megjelölés teljesítettként","Max":"Max.","Max for":"Max","Maximum bookable":"Maximális foglalható","Maximum quantity bookable by a single user":"Egyetlen felhasználó által lefoglalható maximális mennyiség","Message":"Üzenet","Message length:":"Üzenet hossza:","Messages":"Üzenetek","Min":"Min.","Minimum bookable":"Minimális foglalható","Minimum quantity bookable by a single user":"Egyetlen felhasználó által lefoglalható minimális mennyiség","Missing required email or password":"Hiányzó e-mail cím vagy jelszó","Mobile preview: contact details":"Mobil előnézet: kapcsolati adatok","Mobile preview: price and discount":"Mobil előnézet: ár és kedvezmény","Mobile preview: product name and image":"Mobil előnézet: termék név és kép","Mobile preview: units available and distribution method":"Mobil előnézet: elérhetőség és disztribúció módja","More info":"További információ","Most features will not be available after that date.":"A legtöbb funkció ezen időpont után nem érhető el.","Multiple discount options available: flat discount, quantity-based or group discount.":"Többféle kedvezmény opció elérhető: fix kedvezmény, mennyiség alapú, vagy csoportoknak szóló.","N/A":"Nincs adat","NEW":"ÚJ","Name":"Név","Need help?":"Segítségre van szüksége?","New":"Új","New crop offer":"Új termény ajánlat","New customers":"Új ügyfél","New items available":"Új termékek elérhetőek","New offer":"Új ajánlat","New offer end":"Új ajánlat vége","New order":"Új megrendelés","New requests":"Új kérés","New sale offer":"Új eladási ajánlat","Next":"Következő","No":"Nem","No accounts present":"Nincs jelen számla","No attachments":"Nincs melléklet","No customers available to show":"Nincs elérhető ügyfél","No description":"Nincs leírás","No end":"Nincs vége","No farmers found":"Nincs elérhető gazda","No messages":"Nincs üzenet","No offers available.":"Nincs elérhető ajánlat.","No orders found.":"Nem találtunk megrendelést.","No orders or reservations":"Nem találtunk megrendelést vagy foglalást","No pending orders":"Nincs függőben lévő megrendelés","No products found.":"Nincs elérhető termék","No reservations":"Nincs foglalás","No zipcodes assigned to supplier":"Nincs irányítószám megadva a beszállítónál","Not visible to farmers yet.":"A gazdák számára még nem látható.","Notes":"Jegyzetek","Notify farmers":"Gazdák értesítése","Notify farmers on their mobile phones":"A gazdák értesítése mobilon","OK":"OK","Offer deleted":"Ajánlat törölve","Offer description":"Leírás","Offer details":"Ajánlat részletei","Offer draft created":"Vázlat létrehozva","Offer end":"Ügylet lejárata","Offer ends":"Ügylet lejárata","Offer ends in":"Ügylet lejárata","Offer ends in:":"Ügylet lejárata","Offer image":"Ajánlat kép","Offer published":"Ajánlat közzétéve","Offer saved":"Ajánlat elmentve","Offer sent":"Ajánlat elküldve","Offer start":"Ügylet kezdete","Offer starts":"Ügylet kezdete","Offers":"Ajánlatok","Offers from your distributors.":"Ajánlatok a forgalmazóktól.","Ok":"Ok","One or more items are not valid. Please review the list below before going ahead.":"Egy vagy több elem nem érvényes. Kérjük, olvassa el az alábbi listát, mielőtt továbblép.","Only multiple of this can be booked":"Csak ennek többszöröse foglalható","Open the FarmHedge app":"Belépés a FarmHedge applikációba","Opt.":"Opt.","Options":"Opciók","Or":"Vagy","Or google \"Farmhedge\" on your mobile":"Vagy írja be a Farmhedge szót a telefonján googlebe","Order":"Megrendelés","Order ID":"Megrendelés AZONOSÍTÓ","Order date":"Rendelés időpontja:","Order details":"Rendelés részletei","Order forwarded":"Rendelés továbbítva","Order forwarded to distributor. For details, go to the \"Orders\" page from the main menu.":"Rendelés továbbítva a forgalmazónak. A részletekért látogasson el a főmenü \"megrendelések\" oldalára.","Order now":"Rendelés","Order placed":"Rendelés elküldve","Order placed successfully.":"Sikeres megrendelés.","Order shared":"Megosztott rendelés","Order type":"Rendelés típusa","Order updated":"Rendelés frissítve","Ordered":"Megrendelve","Ordered by:":"Megrendelés:","Orders":"Megrendelések","Organic":"Organikus","Origin &amp; Year":"Származás & Év","Original price":"Eredeti ár","Original price:":"Eredeti ár:","Our features:":"Jellemzőink:","Paid":"Fizetve","Passcode is required.":"Jelszó szükséges.","Password":"Jelszó","Password is required":"Jelszó szükséges","Password:":"Jelszó:","Past":"Múlt","Past Offers":"Korábbi ajánlatok","Payment required at checkout":"Kártyás fizetés szükséges a pénztárnál","Payment:":"Fizetés:","Payments were enabled on:":"A kifizetések engedélyezve voltak:","Pending":"Függőben","Pending invites":"Függőben lévő meghívások","Pending only":"Csak függőben lévő","Phone":"Telefon","Phone number":"Telefonszám","Phone number RA":"Telefonszám","Phone number already registered":"Ez a telefonszám már létezik","Pig":"Sertés","Piglet":"Sertés","Pincode":"Pinkód","Please check your email for password reset instructions.":"Kérjük ellenőrizze email fiókjában a jelszó megváltoztatására vonatkozó utasításokat.","Please complete the following ({{Fields.length}}) fields":"Kérjük, töltse ki az alábbi ({{Fields.length}}) mezőket","Please do not press back or refresh the page.":"Kérjük, ne nyomja meg a vissza gombot illetve ne frissítse az oldalt.","Please donot press <i class=\"fa fa-arrow-circle-o-left\"></i> back or <i class=\"fa fa-refresh\"></i> refresh while image is uploading.":"Kérem, ne nyomja meg az <a class=\"fa-fa-nyíl-kör-o-left\"></i>, vagy <class=\"fa-fa-refresh\"></i> frissítés lehetőséget, miközben a kép töltődik.","Please explain to your customer why you are rejecting this request:":"Kérjük, magyarázza el ügyfelének, hogy miért utasítja el ezt a kérelmet:","Please fill your details to accept the invite:":"Kérjük, töltse ki adatait a meghívás elfogadásához:","Please note that the order details are not forwarded to the distributor. If you want this, please click on \"Forward to distributor\"":"Felhívjuk figyelmét, hogy a rendelés részletei nem lettek elküldve a forgalmazónak. Ha ezt szeretné megtenni, kattintson a \"Továbbítás a forgalmazónak\" gombra.","Please note: if a product with same ID or name already exists, the existing product data will be updated.":"Kérjük, vegye figyelembe: ha egy termék már rendelkezik azonos azonosítóval vagy névvel, a meglévő termékadatok frissítésre kerülnek.","Poultry":"Baromfi","Prev":"Korábbi","Preview on mobile":"Mobil előnézet","Price":"Ár","Price for":"Ár","Price is substantially different from offer price":"Az ár jelentősen eltér az ajánlati ártól","Prices exclude VAT.":"Az árak az ÁFÁ-t nem tartalmazzák","Pricing":"Ár","Product":"Termék","Product '{{vm.product.name || vm.product}}' does not exist.":"Termék '{{vm.product.name || vm.product}}' nem létezik.","Product ID":"Termékazonosító","Product Id":"Termékazonosító","Product created":"Termék létrehozva","Product deleted.":"Termék törölve","Product name":"Termék neve","Product name and a picture associated to it is displayed to farmers on the mobile app.":"A termék nevét és egy hozzá tartozó képet a gazdák az applikációban látják.","Product name:":"Termék neve:","Product type":"Termék típusa","Product type:":"Termék típusa:","Product types":"Termék típusok","Product updated":"Termék frissítve","Products":"Termékek","Profile":"Profil","Profile Settings":"Profil beállítások","Progress":"Folyamat","Publish":"Közzététel","Publish on":"Közzététel dátuma","Purchase":"Vásárlás","Purchases":"Vásárlások","Qty":"Mennyiség","Quantity":"Mennyiség","Quantity Limit":"Mennyiség határ","Quantity available":"Rendelkezésre álló mennyiség","Quantity limit":"Mennyiség határ","Question about your FarmHedge request":"A FarmHedge kéréséről","Reach new farmers":"Új gazdák elérése","Receive notifications":"Értesítések fogadása","Receive orders":"Megrendelések fogadása","Receive real-time requests":"Valós idejű kérések fogadása","Refresh":"Frissítés","Registration date":"Regisztráció dátuma","Reject order":"Megrendelés elutasítása","Reject request":"Kérelem elutasítása","Rejected":"Elutasítva","Remember me":"Emlékezz rám.","Remove":"Eltávolítás","Remove attachment":"Melléklet eltávolítása","Remove from cart":"Eltávolítás a kosárból","Report &amp; orders":"Beszámoló & megrendelések","Request Error: An error occurred while processing the request.":"Lekérési hiba: Hiba történt a lekérés feldolgozása során.","Request for":"Kérés","Request selection of a collection point":"Áruátvevőhely kiválasztása","Request supplier customer Id":"Beszállító ügyfélazonosítója","Requested":"Lekérve","Requested by:":"Lekérve","Requested verification":"Ellenőrzés lekérve","Requests":"Ajánlatkérések","Reservation":"Foglalás","Reservation created":"Regisztráció dátuma","Reservation ends in":"Regisztráció vége","Reservation time":"Foglalási idő","Reservation updated":"Foglalás frissítve","Reserve":"Foglalás","Reserved":"Lefoglalva","Reserved amount":"Fenntartott összeg","Reset":"Visszaállítás","Reset Password":"Jelszó visszaállítása","Reset discount":"Kedvezmény törlése","Reset filters":"Szűrők visszaállítása","Reset password":"Jelszó visszaállítása","Reset prices":"Az árak alaphelyzetbe állítása","Result":"Eredmény","Retailer":"Kiskereskedő","Retailers":"Kiskereskedők","Review":"Ellenőrzés","Review and publish":"Ellenőrzés és közzététel","SMS":"SMS","Sale":"Eladási ügylet","Sale Price":"Eladási ár","Sale offer":"Eladási ügylet","Sale price":"Eladási ár","Sales":"Eladási ügylet","Sample product":"Minta termék","Save":"Mentés","Save 1 product":"1 termék mentése","Save and publish 1 product":"1 termék mentése és közzététele","Save and publish {{$ctrl.validRowsCount}} products":" {{$ctrl.validRowsCount}} termék mentése és közzététele","Save draft":"Vázlat mentése","Save {{$ctrl.validRowsCount}} products":"{{$ctrl.validRowsCount}} termékek mentése","Scheduled":"Tervezett","Search":"Keresés","Search product catalog":"Keresés a termékkatalógusban","Search products":"Termék keresése","See all":"Lásd az összes","See attachment preview":"Lásd a melléklet előnézetét","See special offers":"Lásd a különleges ajánlatokat","Select Target Suppliers":"Beszállítók kiválasztása","Select all farmers in a particular area":"Egy adott területen lévő összes gazda kiválasztása","Select crop":"Termény kiválasztása","Select farm type...":"Gazdaság típusának kiválasztása","Select farmers":"Farmerek kiválasztása","Select farmers based on their farm type":"Gazdák kiválasztása a gazdaság típusa alapján","Select file format":"Válassza ki a fájl formátumát","Select file from your computer":"Válassza ki a fájlt a számítógépről","Select standards":"Szabványok kiválasztása","Sell":"Eladás","Seller":"Eladó:","Seller:":"Eladó:","Send SMS and email to customers":"SMS és e-mail küldése az ügyfeleknek","Send SMS to customers":"SMS küldése az ügyfeleknek","Send an offer to {{request.createdBy.name.first}}":"{{request.createdBy.name.first}} azt mondja","Send email to customers":"Email küldése az ügyfeleknek","Send offer":"Ajánlat küldése","Send offers on farm inputs":"Ajánlatok küldése mezőgazdasági termékekre","Send us an email":"Küldjön nekünk e-mailt","Sent":"Elküldve","Server Error: user authentication failed. Please report this to system administrator.":"Szerveroldali hiba: sikertelen felhasználói azonosítás. Kérjük jelezze ezt a rendszergazdának.","Set/Update offer image":"Kép beállítása/frissítése az ügylethez","Settings updated":"Beállítások frissítve","Share":"Megosztás","Share order":"Rendelés megosztása","Share the following link with {{$ctrl.inviteData.phoneNumber}}":"Ossza meg a következő linket {{$ctrl.inviteData.phoneNumber}}","Sheep":"Juh","Shop":"Üzlet","Shopping cart":"Kosár","Shops":"Üzletek","Show rejected/invalid orders":"Elutasított / érvénytelen megbízások megjelenítése","Show requests in your area submitted in the last":"A körzetben leadott kérések megjelenítése az elmúlt","Show results in the last":"Találatok mutatása az elmúlt","Sold out":"Elfogyott","Special offers":"Különleges ajánlatok","Specify custom discount based on quantity purchased.":"Egyedi kedvezmény meghatározása a megvásárolt mennyiség alapján","Starts in:":"Kezdés","Starts now":"Kezdés most","Status":"Állapot","Step":"Lépés","Step 1: Get FarmHedge on your smartphone":"1. lépés: FarmHedge applikáció letöltése a telefonjára","Step 2: Login on FarmHedge app":"2. lépés: Belépés a FarmHedge applikációba","Stock":"Készlet","Stop forwarded offer to farmers":"Gazdáknak szóló továbbküldés leállítása","Stop offer":"Ajánlat megállítása","Streamline operations and reduce costs":"Működés racionalizálás és költségcsökkentés","Street":"Utca","Subscription expiration date:":"Előfizetés lejárati dátuma:","Success":"Siker","Suckler":"Anyatehén","Supplier":"Beszállító ","System":"Rendszer","Target":"Cél","That's it!":"Ennyi!","The easy, secure and private way to trade with your suppliers.":"A könnyű, biztonságos és privát mód, hogy kereskedjen a beszállítóival.","The new way to communicate with farmers":"A gazdákkal történő kommunikáció új módja","The number of units available and distribution methods will be showed to famers on the mobile app.":"Az elérhető egységek száma és a szállítási módok láthatóak a gazdák applikációjában.","The registration process takes only a few minutes.":"A regisztrációs folyamat csak néhány percig tart.","There are no offers from your distributors.":"A forgalmazóktól nem érkezett ajánlat.","These offers are not active anymore. Most recent offers are on top.":"Ezek az ajánlatok már nem aktívak. A legújabb ajánlatokat felül találja.","This Month":"Ebben a hónapban","This browser does not support the import function.":"Ez a böngésző nem támogatja az import funkciót.","This deal does not exist anymore.":"Ez az ügylet már nem létezik.","This is the notification text.":"Ez az értesítés szövege.","This item is already in your shopping cart":"Ez a tétel már a kosárban van","This means that your customers can pay on the FarmHedge app using their credit or debit card.":"Ez azt jelenti, hogy az ügyfelek fizethetnek a FarmHedge app segítségével a hitelkártyájukkal vagy a bankkártyájukkal.","This window will auto-close once the image upload completes.":"Ez az ablak automatikusan bezáródik, ha a kép feltöltése befejeződött.","Today":"Ma","Tonne":"Tonna","Total":"Összesen","Total price":"Teljes ár","Transaction saved to \"Orders\" page":"A \"megrendelések\" oldalra mentett tranzakció","Type":"Típus","Unauthorized access":"Jogosulatlan hozzáférés","Unauthorized: invalid username or password.":"Jogosulatlan: érvénytelen felhasználónév vagy jelszó.","Unit":"Egység","Unit price":"Egységár","Unit:":"Egység:","Units":"Egységek","Units traded with farmers":"Gazdáknak eladott egységek","Until":"Vége","Update":"Frissítés","Update product":"A termék frissítése","Update quantity available of forwarded offer to {{$ctrl.amountReserved}}":"Elérhető mennyiség frissítése a továbbított ajánlatnál {{$ctrl.amountReserved}}","Updated":"Frissítve","Updated:":"Frissítve:","Upgrade":"Frissítés","Upload":"Feltöltés","Upload Profile image":"Profilkép feltöltése","Upload failed. File must be a valid Excel or CSV file.":"A feltöltés nem sikerült. A kiválasztott fájlnak excel vagy CSV fájlnak kell lennie","Upload failed. File must be a valid PDF file.":"A feltöltés nem sikerült. A kiválasztott fájlnak pdf fájlnak kell lennie","Uploading...":"Feltöltés","Use these credentials:":"Használja ezeket az azonosító adatokat:","User":"Felhasználó","User not authorized":"Nem engedélyezett felhasználó","Users":"Felhasználók","Value is not valid":"Érték nem érvényes","Verified":"Ellenőrzött","Via SMS":"SMS-ben","Via email":"E-mailben","View / Select farmers":"Gazdák megtekintése / kiválasztása","Want to know more?":"Többet szeretne tudni?","Welcome to":"Üdvözöljük ","Welcome to FarmHedge":"Üdvözöljük a FarmHedge applikációban","What is FarmHedge?":"Mi a FarmHedge?","What product did you buy?":"Milyen terméket vásárolt?","What product did you sell?":"Milyen terméket adott el?","When farmer books this deal:":"Amikor egy gazda lefoglalja ezt az ügyletet:","Winegrowing":"Borászat","Yes":"Igen","You did not submit a phone number. Continue anyway?":"Nem adott meg telefonszámot. Folytatja anélkül?","You do not have permissions to view this deal.":"Ön nem jogosult megtekinteni ezt az ügyletet.","You will be notified on farmers bookings.":"Értesülni fog a gazdák foglalásairól.","You will receive the funds directly on a bank account of your choice.":"A pénzt közvetlenül a választott bankszámláján kapja meg.","You will receive the funds directly on the bank account specified during the registration process.":"A pénzösszegeket közvetlenül a regisztrációs folyamat során megadott bankszámlán kapja meg.","Your FarmHedge subscription has expired.":"A FarmHedge előfizetése lejárt.","Your FarmHedge subscription will expire on {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}":"A FarmHedge előfizetés lejár {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}","Your TRIAL subscription will expire on {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}":"A próbaidőszak előfizetése lejár {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}","Your message":"Az Ön üzenete","Zip code":"Irányítószám","affected":"érintett","and {{vm.productTypes.length-2}} other":"és {{vm.productTypes.length-2}}más ","buy":"vásárlás","by {{gdDate}} (end of the deal).":" {{gdDate}} dátumig (ügylet vége).","day":"nap","days":"nap","discount":"árengedmény","farmer(s) selected":"kiválasztott gazda","for":"mert","for:":"mert","from":"kezdete","hour":"Óra","hours":"óra","https://fh-data-1.s3.eu-west-1.amazonaws.com/1533808623752Screen%20Shot%202018-08-09%20at%2010.56.33.png":"https://fh-data-1.s3.eu-west-1.amazonaws.com/1533808623752Screen%20Shot %202018-08-09%20at%2010.56.33.png","if {{gdAmount}} units are sold":"ha {{gdAmount}} darabot adnak el","images uploaded":"feltöltött képek","min.":"Min.","new this month":"új ebben a hónapban","new this week":"új ezen a héten","order":"megrendelés","orders":"megrendelések","pending":"Függőben","products imported":"Importált termékek","reservation":"foglalás","reservations":"foglalások","selected":"kiválasztva","sell":"eladás","unit":"egység","units":"egységek","until":"vége","week":"hét","weeks":"hét","{{$ctrl.invitation.createdBy.name.first}}'s message:":"{{$ctrl.invitation.createdBy.name.first}} azt mondja","{{group.name}} ({{group.users.length}} customers)":"{{group.name}} ({{group.users.length}} ügyfelek)","{{request.createdBy.name.first}} says":"{{request.createdBy.name.first}} azt mondja","{{vm.lookup.distMethodsMap[vm.model.distribution]}} ends":"{{vm.lookup.distMethodsMap[vm.model.distribution]}} véget ér","{{vm.lookup.distMethodsMap[vm.model.distribution]}} starts":"{{vm.lookup.distMethodsMap[vm.model.distribution]}} kezdődik","{{vm.orders.length}} order":"{{vm.orders.length}} rendelés","{{vm.orders.length}} orders":"{{vm.orders.length}} rendelések","{{vm.pendingInvitesCount || 0}} pending invites":"{{vm.pendingInvitesCount || 0}} függőben lévő meghívók","{{vm.pendingInvitesCount}} pending invite":"{{vm.pendingInvitesCount}} függőben lévő meghívás"});
    gettextCatalog.setStrings('uk_UA', {"(1 offer)":"(1 пропозиція)","(Only multiples of {{vm.model.dealSizeOptions.step}} can be booked)":"(Тільки кратні {{vm.model.dealSizeOptions.step}} можна забронювати)","({{deals.length}} offers)":"({{deals.length}} пропозиції)","* Field is required":"* Поле обов'язково для заповнення","* Field not valid":"* Недійсне поле","* Value must be a real number":"* Значення має бути дійсним числом","* file size cannot exceed 4.0 MB":"* розмір файлу не може перевищувати 4,0 МБ","* selected file must be an image file":"* вибраний файл повинен бути файлом зображення","* value must not be greater than original price":"* значення не повинно перевищувати початкову ціну","* {{f.label}} is required":"* {{f.label}} обов’язковий","* {{f.label}} value is not valid":"* {{f.label}} значення недійсне","1 attachment":"1 вкладення","1 day":"1 день","1 month":"1 місяць","1 offer":"1 пропозиція","1 product":"1 товар","1 week":"1 тиждень","8 characters length":"Довжина 8 символів","<b>Accept</b> {name} as a new customer?":"<b>Прийняти</b> {name} як новий клієнт?","<b>Ignore</b> {name}'s request to become a customer?":"<b>Ігнорувати</b> {name} ' запит на те, щоб стати клієнтом?","<b>{{$ctrl.invitation.createdBy.nameFull}}</b> invited you to join FarmHedge.":"<b>Користувач {{$ctrl.invitation.createdBy.nameFull}}</b> запросив вас приєднатися до FarmHedge.","<b>{{vm.productPublicCount}}</b> products visible to customers":"<b>{{vm.productPublicCount}}</b> продукти, видимі клієнтам","A link like \"https://farmhedge.ie\" will be automatically added to the message.":"Посилання на зразок \"https://farmhedge.ie\" буде автоматично додано до повідомлення..","A lower-case letter (a, b, ...)":"Мала літера (a, b, ...)","A number (1, 2, ...)":"Номер (1, 2, ...)","About your FarmHedge request":"Про ваш запит FarmHedge","About {{$ctrl.invitation.supplier.name}}":"Про {{$ctrl.invitation.supplier.name}}","Accept customer":"Прийняти клієнта","Accept invite":"Прийняти запрошення","Accepted":"Прийнято","Accepted invites":"Приймаються запрошення","Account ID:":"ID аккаунта:","Accounts":"Облікові записи","Actions":"Дії","Activate FarmHedge payments":"Активуйте FarmHedge платежі","Active":"Діючий","Add":"Додати","Add all":"Додати все","Add all products you want to buy to the shopping cart.":"Додайте всі товари, які хочете придбати, до кошика для покупок.","Add attachment":"Додайте вкладення","Add category, type, treatment, pallet":"Додати категорію, тип, протруювання, піддон","Add customers":"Додайте клієнтів","Add discount":"Додайте знижку","Add group":"Додати групу","Add multiple entries":"Додайте кілька записів","Add multiple phone numbers separated by comma and then click \"Add all\".":"Додайте кілька телефонних номерів, розділених комами, а потім натисніть \"Додати всі\".","Add new":"Додати новий","Add one more":"Додайте ще одну","Add to cart":"Додати в кошик","Add variant":"Додати варіант","Added to cart":"Додано в кошик","Added to shopping cart":"Додано в кошик","Additional variants":"Додаткові варіанти","Address":"Адреса","Addresses":"Адреси","Agricultural Contractor":"Сільськогосподарський підрядник","All farmers will receive {{gdDiscount | number:0}}% discount":"Усі господарства отримають {{gdDiscount | number:0}}% знижку","All products deleted":"Усі продукти видалено","All the information you need about the order is here.":"Вся необхідна інформація про замовлення знаходиться тут.","Already a customer?":"Вже клієнт?","Already existing customer":"Вже існуючий клієнт","Always applied and independent on the quantity sold.":"Завжди застосовується та не залежить від проданої кількості.","Always available to customers":"Завжди доступний для клієнтів","Amount":"Сума","An Error has occurred.":"Сталася помилка.","An email was sent to":"Електронний лист надіслано на","An upper-case letter (A, B, ...)":"Прописною буквою (A, B, ...)","And much more!":"І набагато більше!","Any":"Будь-який","Any type":"Будь-який тип","Are you agribusiness?":"Are you agribusiness?","Are you shoure you want to disable FarmHedge payments?":"Ви бажаєте відключити  FarmHedge платежі?","Are you sure you want to delete the selected deal?":"Ви впевнені, що хочете видалити вибрану угоду?","Areas:":"Області:","Ask farmers to sell their crop":"Попросіть господарства продати свій урожай","Associate customer to \"{{$ctrl.order.billingAddress.name}}\" for future orders.":"Зв'язати клієнта з \"{$ctrl.order.billingAddress.name}}\" для майбутніх замовлень.","Attachment":"Вкладення","Attachments":"Вкладення","Available":"Доступно","Available from":"Доступний від","Available to all traders.":"Доступно для всіх трейдерів.","Available to customers":"Доступно для клієнтів","Available to customers:":"Доступно для клієнтів:","Back":"Назад","Base discount":"Базова знижка","Beef":"Яловичина","Billing Info":"Платіжна інформація","Billing address":"Платіжна адреса","Billing info":"Платіжна інформація","Billing information":"Платіжна інформація","Bookings":"Бронювання","Business name and your contacts can be optionally shared on the offer.":"Назва компанії та ваші контакти можна необов’язково надати в пропозиції.","Buy":"Купити","Buyer":"Покупець","Buyer:":"Покупець:","By:":"Від:","Cancel":"Скасувати","Cancel offer":"Скасувати пропозицію","Cancel request":"Скасувати запит","Cancel reservation":"Скасувати бронювання","Cancelled":"Скасовано","Cancelled by farmer":"Скасовано господарством","Card payment":"Оплата карткою","Cereal":"Зернові культури","Change language":"Змінити мову","Changes saved":"Зміни збережено","Checkout":"Перевірити","City":"Місто","Claear cart":"Очистити кошик","Clear":"Очистити","Clear cart":"Очистити кошик","Click \"Confirm\" to cancel reservation":"Натисніть \"Підтвердити\", щоб скасувати бронювання","Click \"Confirm\" to remove from cart":"Натисніть \"Підтвердити\", щоб видалити з кошика","Click \"Continue\" to review and confirm the offer details.":"Натисніть \"Продовжити\", щоб переглянути та підтвердити деталі пропозиції.","Click \"Save\" to make sure changes are not lost.":"Натисніть \"Зберегти\", щоб переконатися, що зміни не втрачені.","Click on \"Create new offer\" to setup a new offer for your customers.":"Натисніть \"Створити нову пропозицію\", щоб налаштувати нову пропозицію для своїх клієнтів.","Click on \"Publish\" when you are happy for the offer details. Farmers will receive a notification on their mobile phones.":"Натисніть \"Опублікувати\", коли вас задовільнить інформація про пропозицію. Господарства отримають повідомлення на свої мобільні телефони.","Click on one of the orders to display the order details.":"Клацніть на одне із замовлень, щоб відобразити деталі замовлення.","Click to change image":"Клацніть, щоб змінити зображення","Click to choose an image":"Клацніть, щоб вибрати зображення","Clone offer":"Клонувати пропозицію","Close":"Закрити","Collection":"Колекція","Collection Point":"Пункт збору","Collection Points":"Пункти збору","Collection points":"Пункти збору","Coming soon":"Незабаром","Complete order":"Завершити замовлення","Complete the information below to store the order information for future reference.":"Заповніть інформацію нижче, щоб зберегти інформацію про замовлення для подальшого використання.","Completed":"Завершено","Confirm":"Підтвердьте","Confirm Action":"Підтвердити дію","Confirm and Place order":"Підтвердьте та зробіть замовлення","Contact":"Зв'язок","Contact us today to renew your subscription and access all the features and information you need.":"Зв’яжіться з нами сьогодні, щоб поновити передплату та отримати доступ до всіх функцій та інформації, які вам потрібні.","Continue":"Продовжити","Conventional":"Звичайний","Copy":"Копіювати","Copy image (CTRL + C) and paste here using CTRL + V":"Скопіюйте зображення (CTRL + C) і вставте сюди, використовуючи CTRL + V","Copy product":"Копіювати продукт","Counties":"Райони","Country":"Країна","Create New":"Створити нову","Create an offer":"Створіть пропозицію","Create group \"{{$ctrl.newGroupName}}\"":"Створити групу \"{{$ctrl.newGroupName}}\"","Create new offer":"Створіть нову пропозицію","Create product":"Створити продукт","Created":"Створено","Created:":"Створено:","Crop":"Урожай","Crop Standards Configuration":"Конфігурація стандартів врожаю","Crop deal":"Угода щодо врожаю","Crop procurement":"Заготівля врожаю","Crop quality":"Якість врожаю","Crop type":"Тип врожаю","Current and past \"{{req.content[1]}}\" offers":"Поточні та минулі \"{{req.content[1]}}\" пропозиції","Current items available":"Поточні доступні позиції","Current offer end":"Поточна пропозиція закінчується","Currently active offers.":"В даний час діючі пропозиції.","Custom discount":"Спеціальна знижка","Customer":"Клієнт","Customer ID":"Ідентифікатор клієнта","Customer Id":"Ідентифікатор клієнта","Customer data updated successfully":"Дані клієнтів успішно оновлені","Customer invites":"Клієнт запрошує","Customer name":"Ім'я клієнта","Customer price":"Клієнтська ціна","Customer request":"Запит клієнта","Customers":"Клієнти","Customers must confirm quantity delivered":"Клієнти повинні підтвердити доставлену кількість","Dairy":"Молочні продукти","Date":"Дата","Days":"Днів","Deal draft deleted successfully":"Чернетку угоди успішно видалено","Deal end":"Кінець угоди","Deal start":"Початок угоди","Decimal digits":"Десяткові цифри","Delete all":"Видалити все","Delete draft":"Видалити чернетку","Delete product":"Видалити продукт","Delete product?":"Видалити продукт?","Delivered":"Доставлено","Delivery":"Доставка","Delivery Info":"Інформація про доставку","Delivery address":"Адреса доставки","Delivery locations":"Місця доставки","Delivery period":"Термін доставки","Description":"Опис","Details":"Деталі","Different shopping carts will open automatically for products from different suppliers.":"Різні кошики для покупок автоматично відкриваються для товарів різних постачальників.","Discard unsaved changes?":"Відхилити незбережені зміни?","Discount":"Знижка","Discount (%)":"Знижка (%)","Discount / {{ds.customUnit}}":"Знижка / {{ds.customUnit}}","Distribution":"Розподіл","Distribution Start date must be after the Booking Start date.":"Дата початку розподілу повинна бути після дати початку бронювання.","Distribution method":"Метод розподілу","Distributor":"Розповсюджувач","Distributor orders":"Замовлення дистриб’ютора","Distributor price":"Ціна дистриб’ютора","Distributors":"Розповсюджувачі","Distributors offers":"Пропозиції дистриб’юторів","Do not forward description":"Не пересилайте опис","Do you already have the mobile app installed?":"У вас вже встановлений мобільний додаток?","Do you have a supplier account?":"У вас є обліковий запис постачальника?","Do you want to clone this deal?":"Ви хочете клонувати цю угоду?","Do you want to create product \"{0}\"?":"Ви хочете створити продукт \"{0}\"?","Done":"Готово","Download PDF Manual":"Завантажити керівництво в форматі PDF","Download for Android":"Завантажити для Android","Download for iOS":"Завантажити для iOS","Draft":"Чернетка","Draft created":"Чернетку створено","Draft deleted":"Чернетку видалено","Drafts":"Чернетки","Drag-and-drop here":"Перетягніть сюди","Duplicate product":"Продукт-копія","E.g. +431111111, 02222222, 3333333":"Наприклад, +431111111, 02222222, 3333333","E.g. Concentrate feed":"Наприклад, Концентрат корму","E.g. FCA":"Наприклад, FCA","E.g. Germany 2018":"Наприклад, Німеччина 2018","E.g. Liters":"Наприклад, Літри","E.g. Protein 10%":"Наприклад, Білок 10%","E.g. Tonne":"Наприклад, Тонн","Easy to use":"Простий у використанні","Edit":"Редагувати","Edit filters and notifications":"Редагувати фільтри і сповіщення","Edit product":"Редагувати продукт","Edit reservation":"Редагувати бронювання","Email":"Електронна пошта","Email already registered":"Електронна адреса вже зареєстрована","Email is required":"Електронна пошта обов'язкова","Email must be valid":"Електронна адреса повинна бути дійсною","Email:":"Електронна пошта:","End":"Кінець","Ends":"Закінчується","Ends in:":"Закінчується:","Enter a billing address and a delivery address for delivery. You can also select these addresses automatically from the address book stored in your profile.":"Введіть адресу виставлення рахунку та адресу доставки для доставки. Ви також можете автоматично вибрати ці адреси з адресної книги, що зберігається у вашому профілі.","Error while creating new deal":"Помилка під час створення нової угоди","Error while creating offer. Please try again.":"Помилка під час створення пропозиції. Будь ласка спробуйте ще раз.","Error while creating order. Please try again.":"Помилка під час створення замовлення. Будь ласка спробуйте ще раз.","Error while creating reservation. Please try again.":"Помилка під час створення бронювання. Будь ласка спробуйте ще раз.","Error while sending request. Please try again.":"Помилка під час надсилання запиту. Будь ласка спробуйте ще раз.","Examples":"Приклади","Excl. VAT":"Без ПДВ","Exclude all":"Виключити всіх","Exclude from all offers":"Виключити з усіх пропозицій","Excluded":"Виключено","Excluded from all offers":"Виключено з усіх пропозицій","Existing":"Існуючі","Expired":"Термін дії закінчився","Expires on:":"Термін дії закінчується в:","Export":"Експорт","Export Orders":"Експортні замовлення","Export all":"Експортувати все","Export last {{$ctrl.slider.value}}":"Експортувати в останню чергу {{$ctrl.slider.value}}","Extend":"Розширити","Extend offer":"Розширити пропозицію","Farm system":"Господарська система","Farm system and farm type suggested to retailers when forwarding offer to farmers.":"Система фермерських господарств та тип фермерських господарств, що пропонуються роздрібним продавцям при передачі пропозиції господарствам.","Farm type filter":"Фільтр типу ферми","Farm types":"Галузь господарства","Farm types:":"Галузь господарства:","FarmHedge <i>for agribusinesses</i>":"FarmHedge <i>for agribusinesses</i>","FarmHedge ID":"FarmHedge ID","FarmHedge order ID":"Ідентифікатор замовлення FarmHedge","FarmHedge payments are disabled.":"Виплати FarmHedge вимкнено.","FarmHedge payments are enabled":"Платежі FarmHedge увімкнено","FarmHedge payments to allow your customers to pay with their credit/debit card.":"Платежі FarmHedge, що дозволяють вашим клієнтам розплачуватися кредитною / дебетовою карткою.","FarmHedge subscription upgrade":"Оновлення підписки FarmHedge","FarmHedge supription package:":"Додатковий пакет FarmHedge:","FarmHedge will no longer support Internet Explorer starting from the 30th of November 2020.":"FarmHedge більше не підтримуватиме Internet Explorer з 30 листопада 2020 року.","Farmer orders":"Замовлення господарства","Farmers offer ends":"Пропозиція господарствам закінчується","Farmers offer is not active yet":"Пропозиція фермерів ще не активна","Farmers offers":"Фермери пропонують","Field is required":"Поле обов'язково для заповнення","Field must be a positive value":"Поле має мати додатне значення","File URL":"URL-адреса файлу","File URL:":"URL-адреса файлу:","File name":"Назва файлу","File name:":"Назва файлу:","Filter requests for:":"Фільтрувати запити для:","Filters":"Фільтри","First":"Спочатку","First Name":"Ім'я","First name":"Ім'я","For details, go to the \"Orders\" page from the main menu.":"Для отримання детальної інформації перейдіть на сторінку \"Замовлення\" в головному меню.","For details, go to the \"Requests\" page.":"Для отримання детальної інформації перейдіть на сторінку \"Запити\".","For help, please contact":"За допомогою звертайтесь","For questions or help, please contact":"За запитаннями або допомогою звертайтесь","For:":"Для:","Foresty":"Лісове господарство","Forgot password":"Забули пароль","Forgot your password?":"Забули свій пароль?","Forward offer to farmers":"Форварна пропозиція господарствам","Forward this order to coworkers who do not have a FarmHedge account.<br>They will receive a link protected by a pincode. The information will be accessible for 2 weeks.":"Переслати це замовлення колегам, які не мають облікового запису FarmHedge.<br>Вони отримають посилання, захищене пін-кодом. Інформація буде доступна протягом 2 тижнів.","Forward to distributor":"Переслати дистриб'ютору","Forward to farmers":"Переслати господарству","Forwarded":"Перенаправлено","From":"Від","From <b>{{$ctrl.deal.supplier.name}}</b>":"Від<b>{{$ctrl.deal.supplier.name}}</b>","From distributor":"Від дистрибьютора","From: {{supplierName}}":"Від: {{supplierName}}","Fruit":"Фрукт","Generate invite":"Створити запрошення","Getting started":"Починаємо","Go to \"Offers sent\"":"Go to \"Offers sent\"","Go to farmers offer":"Перейти до пропозиції господарств","Go to offer details":"Перейдіть, щоб запропонувати деталі","Go to orders page":"Перейдіть на сторінку замовлень","Group":"Група","Group discount":"Групова знижка","Group name":"Назва групи","Group name already exists":"Назва групи вже існує","Group saved":"Групу збережено","Groups":"Groups","Here you can either use the search function or scroll through the list.":"Тут ви можете скористатися функцією пошуку або прокрутити список.","Here you can see current offers, planned offers, received requests and open orders.":"Тут ви можете побачити поточні пропозиції, заплановані пропозиції, отримані запити та відкриті замовлення.","Hi":"Привіт","Hi, it’s {contactName} from {supplierName}. I'd like to invite you to FarmHedge to submit orders and send me product requests.":"Привіт, це {contactName} від {supplierName}. Я хотів би запросити вас до FarmHedge, щоб подавати замовлення та надсилати мені запити на товари.","Horticulture/gardening":"Садівництво","Hours":"Годин","How many units?":"Скільки одиниць?","How many?":"Скільки?","I am":"Я","I understand this is a legally binding transaction.":"Я розумію, що це юридично обов’язкова операція.","ID":"Ідентифікатор","If less units are sold, orders will be cancelled and famers will be notified.":"Якщо продано менше одиниць, замовлення буде скасовано, а фермери отримають повідомлення.","If you don't receive an email, and it's not in your spam folder this could mean you signed up with a different address.":"Якщо ви не отримаєте електронного листа і його немає у вашій папці зі спамом, це може означати, що ви зареєструвались за іншою адресою.","If you need our help, you can contact us directly via email from the dashboard.":"Якщо вам потрібна наша допомога, ви можете зв’язатися з нами безпосередньо електронною поштою з інформаційної панелі.","If you press “OK”, this deal will be moved to \"Past deals\" and farmers will not be allowed to make any further bookings.":"Якщо натиснути “OK”, ця угода буде переміщена до розділу “Минулі угоди”, і фермерам не буде дозволено робити подальші бронювання.","Ignore":"Ігнорувати","Image":"Зображення","Import images":"Імпортувати зображення","Import product images":"Імпортуйте зображення товару","Import products":"Імпорт продукції","In cart":"У кошику","In shopping cart":"У кошику для покупок","Inactive suppliers":"Неактивні постачальники","Incl. VAT":"Вкл. ПДВ","Include all":"Включити всіх","Include attachments":"Додайте вкладення","Include description":"Включіть опис","Include new customers":"Залучити нових клієнтів","Included":"Включено","Incoterms":"Інкотермс","Invalid":"Недійсний","Invalid deal":"Недійсна угода","Invalid or expired registration link":"Недійсне або закінчилося термін реєстрації посилання","Invalid pincode":"Недійсний пін-код","Invite customer to join FarmHedge":"Запросіть клієнта приєднатися до FarmHedge","Invite customers":"Запросіть клієнтів","Invite new Customers":"Залучити нових клієнтів","Invites sent":"Запрошення надіслано","Item updated":"Елемент оновлено","Items Available":"Доступні позиції","Items available":"Доступні позиції","Items available to farmers":"Позиції, доступні господарствам","Keep the important stuff under control.":"Тримайте важливі речі під контролем.","LIVE":"Наживо","Language":"Мова","Last":"Останній","Last 30 days":"Останні 30 днів","Last 7 days":"Останні 7 днів","Last Name":"Прізвище","Last name":"Прізвище","Last offer":"Остання пропозиція","Last order":"Останнє замовлення","Last update":"Останнє оновлення","Learn more about FarmHedge":"Дізнайтеся більше про FarmHedge","Learn more about pricing and subscriptions":"Дізнайтеся більше про ціни та підписки","Leave a message for your customer:":"Залиште повідомлення для вашого клієнта:","Less info":"Менше інформації","Link your customer permanently with a shop":"Зв'яжіть свого покупця з магазином на постійній основі","List of counties assigned to supplier:":"Список країн, закріплених за постачальником:","List of users":"Список користувачів","Live":"Наживо","Live offers for this user":"Активні пропозиції для цього користувача","Loading":"Завантаження","Loading images..":"Завантаження зображень ..","Login":"Логін","Login on FarmHedge app":"Увійдіть у програму FarmHedge","Logout":"Вийти","Logout?":"Вийти?","Make products visible to customers (Public)":"Зробіть товари видимими для клієнтів (для всіх)","Manage":"Управління","Margin":"Запас","Margin is not showed to customers":"Націнка не показується клієнтам","Mark as completed":"Позначити як виконану","Mark request as completed":"Позначити запит як виконаний","Max":"Макс","Max for":"Максимум для","Maximum bookable":"Максимальне бронювання","Maximum quantity bookable by a single user":"Максимальна кількість, яку можна замовити одним користувачем","Message":"Повідомлення","Message for":"Повідомлення для","Message for customer":"Повідомлення для замовника","Message for customers":"Повідомлення для клієнтів","Message from user":"Повідомлення від користувача","Message length:":"Довжина повідомлення:","Messages":"Повідомлення","Min":"Мін","Minimum bookable":"Мінімальне бронювання","Minimum quantity bookable by a single user":"Мінімальна кількість, яку можна замовити одним користувачем","Missing required email or password":"Відсутня необхідна електронна адреса чи пароль","Mobile preview: contact details":"Мобільний попередній перегляд: контактні дані","Mobile preview: price and discount":"Мобільний попередній перегляд: ціна та знижка","Mobile preview: product name and image":"Мобільний попередній перегляд: назва продукту та зображення","Mobile preview: units available and distribution method":"Мобільний попередній перегляд: доступні одиниці та спосіб розподілу","More info":"Більше інформації","Most features will not be available after that date.":"Більшість функцій будуть недоступні після цієї дати.","Multiple discount options available: flat discount, quantity-based or group discount.":"Доступні кілька варіантів знижок: фіксована знижка, знижка на основі кількості або групова знижка.","N/A":"Нема данних","NEW":"N/A","Name":"Ім'я","Need help?":"Потрібна допомога?","New":"Новий","New crop offer":"Пропозиція нового врожаю","New customers":"New customers","New items available":"Доступні новинки","New offer":"Нова пропозиція","New offer end":"Нова пропозиція закінчується","New order":"Нове замовлення","New order to {{distributorDeal.supplier.name}}":"Нове замовлення на {{distributorDeal.supplier.name}}","New product":"New product","New request":"Новий запит","New requests":"New requests","New sale offer":"Нова пропозиція продажу","New special offer":"Нова спеціальна пропозиція","Next":"Далі","No":"Немає","No accounts present":"No accounts present","No attachments":"Без вкладень","No customers available to show":"Немає клієнтів, доступних для показу","No description":"Без опису","No end":"Немає кінця","No farmers found":"Жодних господарств не знайдено","No messages":"Повідомлень немає","No offers available.":"Пропозицій немає.","No orders":"Ніяких замовлень","No orders found.":"Замовлень не знайдено.","No orders or reservations":"Ніяких замовлень та бронювань","No pending orders":"Немає очікуваних замовлень","No products found.":"Не знайдено товарів.","No requests found.":"Запитів не знайдено.","No reservations":"Без застережень","No results found for \"{{$ctrl.filters.searchText}}\".":"Нічого не знайдено \"{{$ctrl.filters.searchText}}\".","No results found for \"{{$ctrl.searchText}}\".":"Не знайдено результатів для \"{{$ctrl.searchText}}\".","No results found.":"Не знайдено результатів.","No shops":"Ніяких магазинів","No zipcodes assigned to supplier":"Поштові індекси постачальнику не присвоєні","Not visible to farmers yet.":"Ще не помітний для фермерів.","Notes":"Деталі","Notification sent":"Повідомлення надіслано","Notify customer":"Повідомити клієнта","Notify customers":"Повідомити клієнтів","Notify farmers":"Повідомити господарства","Notify farmers on their mobile phones":"Повідомте господарства на їх мобільні телефони","Number of items":"Кількість предметів","OK":"OK","Offer":"Пропозиція","Offer deleted":"Пропозицію видалено","Offer description":"Offer description","Offer details":"Деталі пропозиції","Offer draft created":"Проект пропозиції створений","Offer end":"Кінець пропозиції","Offer ends":"Пропозиція закінчується","Offer ends in":"Пропозиція закінчується через","Offer ends in:":"Пропозиція закінчується через:","Offer epired":"Термін дії пропозиції закінчується","Offer expired":"Термін дії пропозиції закінчився","Offer extended":"Пропозицію продовжено","Offer for {productName} extended":"Пропозиція для {productName} продовжена","Offer image":"Зображення пропозиції","Offer published":"Пропозиція опублікована","Offer saved":"Пропозиція збережена","Offer sent":"Пропозиція надіслана","Offer start":"Початок пропозиції","Offer starts":"Починається пропозиція","Offer stopped":"Пропозицію зупинено","Offers":"Пропозиції","Offers from your distributors.":"Пропозиції від ваших дистриб'юторів.","Offers only":"Лише пропозиції","Offers received":"Отримані пропозиції","Offers sent":"Пропозиції надіслані","Ok":"Ok","On request":"За запитом","On the left hand side you can set which dealers you want to see offers from.":"Ліворуч ви можете встановити, від яких дилерів ви хочете бачити пропозиції.","On the right side you set who should receive this offer. You can also set different prices for different recipients.":"Праворуч ви встановлюєте, хто повинен отримувати цю пропозицію. Ви також можете встановити різні ціни для різних одержувачів.","One or more items are not valid. Please review the list below before going ahead.":"Один або кілька предметів недійсні. Будь ласка, перегляньте наведений нижче список, перш ніж продовжувати.","Only multiple of this can be booked":"Можна забронювати лише кілька із них","Only new customers will receive this message":"Лише нові клієнти отримають це повідомлення","Open order details":"Відкрити деталі замовлення","Open the FarmHedge app":"Відкрийте додаток FarmHedge","Or":"Or","Or google \"Farmhedge\" on your mobile":"Або пошукайте в Google \"Farmhedge\" на своєму мобільному телефоні","Order":"Замовлення","Order ID":"Ідентифікатор замовлення","Order date":"Дата замовлення","Order details":"Деталі замовлення","Order forwarded":"Order forwarded","Order forwarded to distributor. For details, go to the \"Orders\" page from the main menu.":"Замовлення пересилається дистриб'ютору. Для отримання детальної інформації перейдіть на сторінку \"Замовлення\" в головному меню.","Order now":"Замовити зараз","Order placed":"Замовлення зроблено","Order placed successfully.":"Замовлення зроблено успішно.","Order shared":"Замовлення поширено","Order updated":"Замовлення оновлено","Ordered":"Впорядковано","Orders":"Замовлення","Orders details":"Деталі замовлення","Organic":"Органічний","Origin &amp; Year":"Походження &amp; Рік","Original price":"Оригінальна ціна","Our features:":"Наші особливості:","Page":"Сторінка","Paid":"Сплачений","Passcode is required.":"Необхідний пароль.","Password":"Пароль","Password is required":"Потрібен пароль","Password:":"Пароль:","Past":"Минулий","Payments were enabled on:":"Payments were enabled on:","Pending":"В очікуванні","Pending invites":"Запрошення, що очікують на розгляд","Pending only":"Тільки в очікуванні","Phone":"Телефон","Phone number":"Номер телефону","Phone number RA":"Номер телефону RA","Phone number already registered":"Номер телефону вже зареєстрований","Pig":"Свиня","Piglet":"Порося","Pincode":"Пін-код","Please check your email for password reset instructions.":"Будь ласка, перевірте свою електронну адресу для отримання інструкцій щодо скидання пароля.","Please complete the following ({{Fields.length}}) fields":"Будь ласка, заповніть наступні ({{Fields.length}}) поля","Please do not press back or refresh the page.":"Не натискайте назад і не оновлюйте сторінку.","Please donot press <i class=\"fa fa-arrow-circle-o-left\"></i> back or <i class=\"fa fa-refresh\"></i> refresh while image is uploading.":"Будь ласка, нетискайте <i class=\"fa fa-arrow-circle-o-left\"></i> назад <i class=\"fa fa-refresh\"></i> або оновлюйте зображення під час завантаження зображення.","Please explain to your customer why you are rejecting this request:":"Будь ласка, поясніть своєму клієнту, чому ви відхиляєте цей запит:","Please fill your details to accept the invite:":"Будь ласка, заповніть свої дані, щоб прийняти запрошення:","Please note that the order details are not forwarded to the distributor. If you want this, please click on \"Forward to distributor\"":"Please note that the order details are not forwarded to the distributor. If you want this, please click on \"Forward to distributor\"","Please note: if a product with same ID or name already exists, the existing product data will be updated.":"Please note: if a product with same ID or name already exists, the existing product data will be updated.","Please select a variant":"Виберіть варіант","Please use one of these browsers:":"Будь ласка, використовуйте один із таких браузерів:","Potential new customers":"Потенційні нові клієнти","Poultry":"Птиця","Prev":"Попередня","Preview on mobile":"Попередній перегляд на мобільному","Price":"Ціна","Price / {{ds.customUnit}}":"Ціна / {{ds.customUnit}}","Price as agreed":"Ціна за домовленістю","Price changes every day":"Ціна змінюється щодня","Price for":"Ціна за","Price is substantially different from offer price":"Ціна істотно відрізняється від ціни пропозиції","Price settings":"Налаштування ціни","Price updated":"Ціна оновлена","Prices exclude VAT.":"Ціни без ПДВ.","Pricing":"Ціноутворення","Product":"Продукт","Product '{{vm.product.name || vm.product}}' does not exist.":"Продукт '{{vm.product.name || vm.product}}' не існує.","Product ID":"Ідентифікатор товару","Product Id":"Ідентифікатор товару","Product attributes":"Атрибути товару","Product copy created":"Копію продукту створено","Product created":"Продукт створений","Product deleted.":"Продукт видалено.","Product name":"Назва продукту","Product name and a picture associated to it is displayed to farmers on the mobile app.":"Назва товару та пов’язане з ним зображення відображається фермерам у мобільному додатку.","Product type":"Тип товару","Product types":"Види продукції","Product updated":"Продукт оновлений","Product/Category":"Категорія/Продукт","Products":"Продукти","Profile Settings":"Налаштування профілю","Progress":"Прогрес","Publish":"Опублікувати","Publish on":"Опублікувати на","Purchase":"Покупка","Purchases":"Покупки","Qty":"Кількість","Quantity":"Кількість","Quantity Limit":"Обмеження кількості","Question about your FarmHedge request":"Питання щодо вашого запиту FarmHedge","Reach new farmers":"Зверніться до нових господарств","Receive notifications":"Отримувати повідомлення","Receive orders":"Отримувати замовлення","Receive real-time requests":"Receive real-time requests","Received":"Отримано","Recipient":"Одержувач","Refresh":"Оновити","Registration date":"Дата Реєстрації","Reject order":"Відхилити замовлення","Reject request":"Відхилити запит","Rejected":"Відхилено","Remember me":"Запам'ятати мене","Remind me to update price":"Нагадати мені, щоб оновити ціну","Remove":"Видалити","Remove attachment":"Зніміть вкладення","Remove from cart":"Видалити з кошика","Remove variant":"Вилучити варіант","Report &amp; orders":"Звіт &amp; замовлень","Request Error: An error occurred while processing the request.":"Помилка запиту: Під час обробки запиту сталася помилка.","Request created by":"Запит створений","Request for":"Запит щодо","Request sent":"Запит надіслано","Request type":"Тип запиту","Requested":"Запитується","Requested verification":"Запитана перевірка","Requests":"Запити","Reservation":"Бронювання","Reservation created":"Бронювання створено","Reservation ends in":"Бронювання закінчується в","Reservation time":"Час бронювання","Reservation updated":"Бронювання оновлено","Reserve":"Резервувати","Reserved":"Зарезервований","Reserved amount":"Зарезервована сума","Reset":"Скинути","Reset Password":"Скинути пароль","Reset filters":"Скинути фільтри","Reset password":"Скинути пароль","Reset prices":"Скинути ціни","Result":"Result","Resume":"Резюме","Retailer":"Роздрібний торговець","Retailers":"Роздрібні торговці","Review":"Огляд","Review and publish":"Перегляньте та опублікуйте","SMS":"SMS","Sale":"Продаж","Sale Price":"Ціна продажу","Sale offer":"Пропозиція продажу","Sale price":"Ціна продажу","Sales":"Продажі","Sample product":"Зразок товару","Save":"Зберегти","Save 1 product":"Зберегти 1 товар","Save and publish 1 product":"Збережіть та опублікуйте 1 продукт","Save and publish {{$ctrl.validRowsCount}} products":"Збережіть та опублікуйте {{$ctrl.validRowsCount}} продукт","Save and send notification":"Збережіть і надішліть сповіщення","Save draft":"Зберегти чернетку","Save {{$ctrl.validRowsCount}} products":"Зберегти {{$ctrl.validRowsCount}} продукт","Scheduled":"Заплановане","Search":"Пошук","Search product catalog":"Шукати в каталозі товарів","See attachment preview":"Див. Попередній перегляд вкладення","See customers":"Побачити клієнтів","See offer":"Подивитися пропозицію","Select":"Обрати","Select Target Suppliers":"Виберіть цільових постачальників","Select all farmers in a particular area":"Виберіть усі господарства у певній місцевості","Select crop":"Виберіть культуру","Select farm type...":"Виберіть тип господарства ...","Select farmers":"Виберіть господарства","Select farmers based on their farm type":"Вибирайте фермерів на основі типу ферми","Select file format":"Виберіть формат файлу","Select file from your computer":"Виберіть файл із комп’ютера","Select product":"Виберіть товар","Select quantity":"Виберіть кількість","Select standards":"Виберіть стандарти","Select traders":"Виберіть торговців","Sell":"Продати","Seller":"Продавець","Seller:":"Продавець:","Send SMS and email to customers":"Надішліть SMS та електронну пошту клієнтам","Send SMS to customers":"Надішліть SMS клієнтам","Send a request":"Надішліть запит","Send a request for \"{{$ctrl.filters.searchText}}\"":"Надішліть запит на \"{{$ctrl.filters.searchText}}\"","Send a request for \"{{$ctrl.searchText}}\"":"Надішліть запит на \"{{$ctrl.searchText}}\"","Send an offer":"Надішліть пропозицію","Send email to customers":"Надішліть електронну пошту клієнтам","Send generic request":"Надіслати загальний запит","Send new request":"Надіслати новий запит","Send offers on farm inputs":"Надсилайте пропозиції на вкладені ресурси","Send push notification to customers":"Надіслати push-повідомлення клієнтам","Send request":"Надіслати запит","Send request to":"Надіслати запит на","Send us an email":"Надішліть нам електронний лист","Sent":"Надісланий","Server Error: user authentication failed. Please report this to system administrator.":"Помилка сервера: помилка автентифікації користувача. Повідомте про це системному адміністратору.","Set/Update offer image":"Встановити/оновити зображення пропозиції","Share":"Поділитися","Share order":"Поділитися замовленням","Share the following link with {{$ctrl.inviteData.phoneNumber}}":"Поділіться наступним посиланням з {{$ctrl.inviteData.phoneNumber}}","Sheep":"Вівці","Shop":"Магазин","Shopping cart empty":"Кошик порожній","Shops":"Магазини","Show all":"Показати все","Show me the checkout":"Покажи мені касу","Show rejected/invalid orders":"Показати відхилені/недійсні замовлення","Show requests in your area submitted in the last":"Показати запити у вашому районі, подані в останньому","Show results in the last":"Показати результати в останньому","Since":"Оскільки","Sold out":"Продано","Special offer until":"Спеціальна пропозиція до","Specify custom discount based on quantity purchased.":"Вкажіть спеціальну знижку на основі придбаної кількості.","Start":"Почніть","Start typing...":"Почніть друкувати ...","Starts":"Починається","Starts in:":"Починається з:","Starts now":"Починається зараз","Status":"Статус","Step":"Крок","Step 1: Get FarmHedge on your smartphone":"Крок 1: Завантажте FarmHedge на свій смартфон","Step 2: Login on FarmHedge app":"Крок 2: Увійдіть у програму FarmHedge","Stock":"Запас","Stock price":"Ціна","Stop forwarded offer to farmers":"Зупинити перенаправлення пропозицію господарствам","Stop offer":"Зупинити пропозицію","Streamline operations and reduce costs":"Впорядкуйте операції та зменшіть витрати","Street":"Вул","Subscription expiration date:":"Термін дії підписки:","Success":"Успіх","Suckler":"Теля","Supplier":"Постачальник","System":"Система","Target":"Мета","Technic":"Техніка","That's it!":"Це воно!","The easy, secure and private way to trade with your suppliers.":"Простий, безпечний та приватний спосіб торгівлі зі своїми постачальниками.","The following FarmHedge users asked to become your customer. You can accept or ignore their requests.":"Наступні користувачі FarmHedge попросили стати вашим клієнтом. Ви можете прийняти або проігнорувати їхні запити.","The new way to communicate with farmers":"Новий спосіб спілкування з господарствами","The number of units available and distribution methods will be showed to famers on the mobile app.":"Кількість доступних одиниць та способи розподілу буде показано учасникам мобільного додатка.","The registration process takes only a few minutes.":"Процес реєстрації займає лише кілька хвилин.","There are active reservations on this offer":"На цю пропозицію активні бронювання","There are no offers from your distributors.":"Пропозицій від ваших дистриб’юторів немає.","These offers are not active anymore. Most recent offers are on top.":"These offers are not active anymore. Most recent offers are on top.","This browser does not support the import function.":"Цей браузер не підтримує функцію імпорту.","This deal does not exist anymore.":"Ця угода вже не існує.","This is the notification text.":"Це текст сповіщення.","This item is already in your shopping cart":"Цей товар вже є у вашому кошику для покупок","This means that your customers can pay on the FarmHedge app using their credit or debit card.":"Це означає, що ваші клієнти можуть платити через програму FarmHedge за допомогою своєї кредитної або дебетової картки.","This window will auto-close once the image upload completes.":"Це вікно автоматично закриється після завершення завантаження зображення.","To create a new time-limited offer, click the green button.":"Щоб створити нову пропозицію, обмежену часом, натисніть зелену кнопку.","Today":"Сьогодні","Tonne":"Тонн","Total":"Всього","Total discount":"Загальна знижка","Total price":"Загальна сума","Trader":"Трейдер","Traders":"Трейдери","Transaction saved to \"Orders\" page":"Транзакцію збережено на сторінці \"Замовлення\"","Tutorial":"Керівництво","Type":"Тип","Unauthorized access":"Несанкціонований доступ","Unauthorized: invalid username or password.":"Несанкціоновано: недійсне ім’я користувача чи пароль.","Unit":"Одиниця","Unit price":"Ціна за одиницю","Units":"Одиниці","Unlimited":"Необмежений","Until":"Доки","Update":"Оновлення","Update due":"Термін оновлення","Update needed":"Потрібне оновлення","Update product":"Оновити продукт","Update quantity available of forwarded offer to {{$ctrl.amountReserved}}":"Оновити кількість, доступну для переадресованій пропозиції, до {{$ctrl.amountЗареєтивлений}}","Updated":"Оновлено","Updated:":"Оновлено:","Upgrade":"Модернізація","Upload":"Завантажити","Upload Profile image":"Завантажити зображення профілю","Upload failed. File must be a valid Excel or CSV file.":"Помилка завантаження. Файл повинен бути дійсним файлом Excel або CSV.","Upload failed. File must be a valid PDF file.":"Помилка завантаження. Файл повинен бути дійсним файлом PDF.","Uploading...":"Завантаження ...","Use these credentials:":"Використовуйте ці облікові дані:","User":"Користувач","User not authorized":"Користувач не авторизований","User profile":"Профіль користувача","VAT":"ПДВ","VAT number":"ІПН","Value is not valid":"Значення недійсне","Variants":"Варіанти","Verified":"Перевірено","Via SMS":"За допомогою SMS","Via email":"За допомогою електронної пошти","View / Select farmers":"Переглянути / вибрати фермерів","Want to know more?":"Хочете знати більше?","Weeks":"Тижні","Welcome to":"Ласкаво просимо до","Welcome to FarmHedge":"Ласкаво просимо до FarmHedge","What is FarmHedge?":"Що таке FarmHedge?","When you receive an order from a customer, you will be notified by email.":"Коли ви отримаєте замовлення від клієнта, ви отримаєте сповіщення електронною поштою.","Winegrowing":"Виноробство","Yes":"Так","You access this page at any time by clicking on the FarmHedge icon in the upper left corner.":"Ви можете отримати доступ до цієї сторінки в будь-який час, натиснувши піктограму FarmHedge у верхньому лівому куті.","You can also click through a short tutorial of the FarmHedge platform.":"Ви також можете натиснути короткий посібник платформи FarmHedge.","You can also send the order details by email.":"Ви також можете надіслати деталі замовлення електронною поштою.","You can attach a message to the order for your supplier.":"You can attach a message to the order for your supplier.","You can export all your orders for integration with other software.":"Ви можете експортувати всі свої замовлення для інтеграції з іншим програмним забезпеченням.","You can reject or complete an order.":"Ви можете відхилити або виконати замовлення.","You can review the details and publish the offer. After that you can start receiving orders.":"Ви можете переглянути деталі та опублікувати пропозицію. Після цього можна при починати отримувати замовлення.","You can review the order and modify quantities.":"Ви можете переглянути замовлення та змінити кількості.","You can set the product":"Ви можете встановити виріб","You did not submit a phone number. Continue anyway?":"Ви не вказали номер телефону. Продовжити в любому випадку?","You do not have permissions to view this deal.":"У вас немає дозволу на перегляд цієї угоди.","You will be asked to confirm the quantity delivered. Price per {unit} will not change.":"Вас попросять підтвердити доставлену кількість. Ціна за {unit} не зміниться.","You will be notified on farmers bookings.":"Ви отримаєте повідомлення про бронювання господарствами.","You will receive the funds directly on a bank account of your choice.":"Ви отримаєте кошти безпосередньо на обраний вами банківський рахунок.","You will receive the funds directly on the bank account specified during the registration process.":"Ви отримаєте кошти безпосередньо на банківський рахунок, зазначений у процесі реєстрації.","Your FarmHedge subscription has expired.":"Термін дії підписки на FarmHedge закінчився.","Your FarmHedge subscription will expire on {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}":"Термін дії передплати FarmHedge минає {{$ctrl.utils.getЛокалізований дані($ctrl.utils.getSubscriptionExpiresAt())}}","Your TRIAL subscription will expire on {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}":"Термін дії ознайомлювальної передплати минає {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}}","Your message":"Ваше повідомлення","Your products":"Ваша продукція","Your request":"Ваш запит","Zip code":"Індекс","Zipcode":"Індекс","affected":"постраждалий","and {{vm.productTypes.length-2}} other":"та{{vm.productTypes.length-2}} інші","by {{gdDate}} (end of the deal).":"від {{gdDate}} (end of the deal).","customers":"клієнти","dashboard":"панель приладів","day":"день","days":"днів","deals":"угоди","deals/requests":"угоди/запити","delivery method and many other settings from scratch":"спосіб доставки та багато інших налаштувань з нуля","discount":"знижка","duration of the offer":"тривалість пропозиції","farmer(s) selected":"господарство(а) обране","for":"для","for:":"для:","from":"від","hour":"година","hours":"годин","https://fh-data-1.s3.eu-west-1.amazonaws.com/1533808623752Screen%20Shot%202018-08-09%20at%2010.56.33.png":"https://fh-data-1.s3.eu-west-1.amazonaws.com/1533808623752Screen%20Shot%202018-08-09%20at%2010.56.33.png","if {{gdAmount}} units are sold":"якщо {{gdAmount}} продаються одиниці","images uploaded":"завантажені зображення","item":"пункт","items":"пункти","min.":"мін.","months":"місяці","new this month":"новинка цього місяця","new this week":"новинка на цьому тижні","offers/received":"пропозиції/отримані","order":"замовлення","orders":"замовлення","pending":"в очікуванні","products":"продукти","products imported":"продукти імпортовані","profile":"профіль","reservation":"бронювання","reservations":"бронювання","selected":"вибране","units":"одиниці","until":"доки","variants":"варіанти","week":"тиждень","weeks":"тижні","{{$ctrl.invitation.createdBy.name.first}}'s message:":"{{$ctrl.invitation.createdBy.name.first}}'s повідомлення:","{{deal.attachments.length}} attachments":"{{deal.attachments.length}} вкладення","{{group.name}} ({{group.users.length}} customers)":"{{group.name}} ({{group.users.length}} клієнти)","{{supplier.stats.offersCount}} offers":"{{supplier.stats.offersCount}} пропозиції","{{supplier.stats.productsCount}} products":"{{supplier.stats.productsCount}} продукти","{{vm.lookup.distMethodsMap[vm.model.distribution]}} ends":"{{vm.lookup.distMethodsMap[vm.model.distribution]}} закінчується","{{vm.lookup.distMethodsMap[vm.model.distribution]}} starts":"{{vm.lookup.distMethodsMap[vm.model.distribution]}} починається","{{vm.orders.length}} order":"{{vm.orders.length}} замовлення","{{vm.orders.length}} orders":"{{vm.orders.length}} замовлення","{{vm.pendingInvitesCount || 0}} pending invites":"{{vm.pendingInvitesCount || 0}} запрошення, що очікують","{{vm.pendingInvitesCount}} pending invite":"{{vm.pendingInvitesCount}} запрошення в очікуванні"});
/* jshint +W100 */
}]);
(function () {
    'use strict';

    angular.module('app').run(runBlock);

    /** @ngInject */
    function runBlock(
        $rootScope,
        $state,
        $stateParams,
        $location,
        $window,
        $templateCache,
        $log,
        AuthFactory,
        gettextCatalog,
        API_CONFIG) {

        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;

        $templateCache.put('searchbox.tpl.html', '<input id="pac-input" class="pac-controls col-md-6 mt-10 h6" type="text" placeholder="{{\'Search\'|translate}}">');
        $templateCache.put('window.tpl.html', '<div ng-controller="WindowCtrl" ng-init="showPlaceDetails(parameter)">{{place.name}}</div>');

        // GLOBAL APP SCOPE
        $rootScope.app = {
            name: 'FarmHedge Portal',
            author: 'bfrola@farmhedge.io, minhas.hafeez@gmail.com',
            description: 'FarmHedge Portal',
            version: '1.0',
            year: ((new Date()).getFullYear()),
            isMobile: (function () {
                var check = false;
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    check = true;
                }
                return check;
            })(),
            pageTitle: 'Farm Hedge',
            CurrentModal: null,
            layout: {
                isNavbarFixed: true,
                isSidebarFixed: true,
                isSidebarClosed: false,
                isFooterFixed: false,
                theme: 'theme-6',
                logo: 'assets/img/logo.png'
            },
            DateFormat: 'ddd, DD MMM YYYY hh:mm',
            Mask: true,
            MaskLabel: null,
            ToasterOpts: {
                'time-out': { 'toast-success': 2500, 'toast-warning': 3000, 'toast-error': 4500 },
                'position-class': 'toast-top-right',
                'close-button': true
            },
            Auth: {}
        };

        $rootScope.user = {
            name: 'Bernardino Frola',
            job: 'Project Manager'
        };

        function forceSSL() {
            if (API_CONFIG.env === 'LOCAL') {
                return;
            }
            if ($location.protocol() === 'https') {
                return;
            }
            $window.location.href = $location.absUrl().replace('http', 'https');
        }

        // Redirect access to farmhedge-customer.herokuap.com to rwa.farmhedge.at
        function redirectFromHerokuApp() {
            if ($location.host() === 'farmhedge-staging-customer.herokuapp.com') {
                $window.location.href = $location.absUrl().replace('farmhedge-staging-customer.herokuapp.com', 'rwa-staging.farmhedge.at');
                return;
            }
            if ($location.host() === 'farmhedge-customer.herokuapp.com') {
                $window.location.href = $location.absUrl().replace('farmhedge-customer.herokuapp.com', 'rwa.farmhedge.at');
                return;
            }
        }

        function loadPageTranslations() {
            gettextCatalog.getString('dashboard');
            gettextCatalog.getString('deals/requests');
            gettextCatalog.getString('products');
            gettextCatalog.getString('offers/received');
            gettextCatalog.getString('deals');
            gettextCatalog.getString('orders');
            gettextCatalog.getString('customers');
            gettextCatalog.getString('profile');
        }

        $rootScope.$on("$locationChangeSuccess", function () { 
            document.title = location.pathname ? ('FarmHedge - ' + gettextCatalog.getString(location.pathname.slice(1))) : 'FarmHedge';
        });

        redirectFromHerokuApp();
        forceSSL();
        loadPageTranslations();
    }

})();

(function() {
  'use strict';

  angular.module('app').config(routerConfig);

  function routerConfig($stateProvider, $urlRouterProvider, $localStorageProvider, API_CONFIG) {

      $localStorageProvider.setKeyPrefix(API_CONFIG.tokenPrefix);

      // Any unmatched URL, gets redirected to /app/dashboard
      $urlRouterProvider.otherwise("/");

      $stateProvider
      .state('show', {
          url: "/show/:id",
          component: 'show',
          skipAuthorization: true
      })
      .state('home', {
          url: "/",
          component: 'home',
          skipAuthorization: true
      })
      .state('app', {
          url: "?supplier",
          templateUrl: 'app/shared/app.html',
          templateProvider: function($templateCache) {
              return $templateCache.get("app/shared/app.html");
          },
          abstract: true,
          resolve : { currentUser : VerifyUser }
      });

      function VerifyUser($state, HttpService, AuthFactory) {
            console.log('Started user verification process'); // eslint-disable-line
            AuthFactory.initUser().then(function(user) {
                return user;
            }, function() {
                $state.go('login');
            });
      }
  }

})();

/**
 * Created by Hafeez Rehman on 04/11/2017.
 */
(function() {

    'use strict';

    angular
        .module("app.patch", [
            'ngSanitize',
            'ui.router',
            'ui.bootstrap',
            'ngStorage',
            'angular-jwt',
            'ngMessages',
            'nemLogging',
            'pascalprecht.translate',
            'tmh.dynamicLocale',
            'angular-jwt',
            'vcRecaptcha',
            'toastr',
            'angular-loading-bar',
            'ngScrollbars',
            'cp.ngConfirm',
            'uiGmapgoogle-maps',
            'gettext',
            'ae-datetimepicker',
            'ngImage',
            'ngFileUpload',
            'ng-currency',
            'ui.select',
            'angular.chips',
            'rzModule'
        ]);
})();
(function() {
  'use strict';

  var app = angular.module('app');

  var apiPrefix;
  var apiEnv;

  if (document.domain.indexOf('localhost') >= 0 || document.domain.indexOf('192.168') >= 0) {
    apiPrefix = 'https://farmhedge-staging-api.herokuapp.com';
    apiEnv = 'LOCAL';
  }
  else if (document.domain.indexOf('staging') >= 0) {
    //apiPrefix = 'https://farmhedge-staging-api.herokuapp.com';
    apiPrefix = 'https://farmhedge-api-v2-staging-5e37369f756e.herokuapp.com';
    apiEnv = 'STAGING';
  }
  else if (document.domain.indexOf('beta') >= 0) {
    apiPrefix = 'https://farmhedge-api.herokuapp.com';
    apiEnv = 'BETA';
  }
  else if (document.domain.indexOf('portal.ufeeds') >= 0) {
    apiPrefix = 'https://uf.api.farmhedge.io';
    apiEnv = 'PRODUCTION';
  }
  else {
    apiPrefix = 'https://farmhedge-api.herokuapp.com';
    apiEnv = 'PRODUCTION';
  }


  var COUNTRIES = {
    IE: 'ireland',
    AT: 'austria',
    DE: 'germany',
    GB: 'gb',
    HU: 'hu',
    US: 'us',
    NZ: 'nz',
    HR: 'hr',
    SK: 'sk',
    SI: 'si',
    CZ: 'cz',
    RO: 'ro',
    RS: 'rs',
    UA: 'ua',
  };

  var LOCALES = [
    { code: 'en-GB', label: 'English (Ireland/UK)' },
    { code: 'en-US', label: 'English (US)' },
    { code: 'de-AT', label: 'German (Austria)' },
    { code: 'de-DE', label: 'German (Germany)' },
    { code: 'hu', label: 'Hungarian' },
    { code: 'hr', label: 'Croatian' },
    { code: 'sk', label: 'Slovakian' },
    { code: 'sl', label: 'Slovenian' },
    { code: 'cs', label: 'Czech' },
    { code: 'ro', label: 'Romanian' },
    { code: 'sr', label: 'Serbian' },
    { code: 'uk-UA', label: 'Ukranian' },
  ];

  var countries_data = [
    { id: COUNTRIES.AT, text: '🇦🇹 Austria', lat: 47.5162, lon: 14.5501, phonePrefix: '+43', flag: '🇦🇹', locale: 'de_AT' },
    { id: COUNTRIES.HR, text: '🇭🇷 Croatia', lat: 45.1000, lon: 15.2000, phonePrefix: '+385', flag: '🇭🇷', locale: 'hr_HR' },
    { id: COUNTRIES.CZ, text: '🇨🇿 Czech Republic', lat: 49.8175, lon: 15.4730, phonePrefix: '+420', flag: '🇨🇿', locale: 'cs_CZ' },
    { id: COUNTRIES.DE, text: '🇩🇪 Germany', lat: 51.1657, lon: 10.4515, phonePrefix: '+49', flag: '🇩🇪', locale: 'de_DE' },
    { id: COUNTRIES.HU, text: '🇭🇺 Hungary', lat: 47.0602, lon: 19.4237, phonePrefix: '+36', flag: '🇭🇺', locale: 'hu_HU' },
    { id: COUNTRIES.IE, text: '🇮🇪 Ireland', lat: 53.1424, lon: -7.6921, phonePrefix: '+353', flag: '🇮🇪', locale: 'en_IE' },
    { id: COUNTRIES.NZ, text: '🇳🇿 New Zealand', lat: -36.8484, lon: 174.7633, phonePrefix: '+64', flag: '🇳🇿', locale: 'en_NZ' },
    { id: COUNTRIES.RO, text: '🇷🇴 Romania', lat: 45.9432, lon: 24.9668, phonePrefix: '+40', flag: '🇷🇴', locale: 'ro_RO' },
    { id: COUNTRIES.RS, text: '🇷🇸 Serbia', lat: 44.0165, lon: 21.0059, phonePrefix: '+381', flag: '🇷🇸', locale: 'sr_RS' },
    { id: COUNTRIES.SK, text: '🇸🇰 Slovakia', lat: 48.6690, lon: 19.6990, phonePrefix: '+421', flag: '🇸🇰', locale: 'sk_SK' },
    { id: COUNTRIES.SK, text: '🇸🇮 Slovenia', lat: 46.1512, lon: 14.9955, phonePrefix: '+386', flag: '🇸🇮', locale: 'sl_SI' },
    { id: COUNTRIES.GB, text: '🇬🇧 United Kingdom', lat: 54.5560, lon: -2.4836, phonePrefix: '+44', flag: '🇬🇧', locale: 'en_GB' },
    { id: COUNTRIES.US, text: '🇺🇸 United States', lat: 37.0902, lon: -95.7129, phonePrefix: '+1', flag: '🇺🇸', locale: 'en_US' },
    { id: COUNTRIES.UA, text: '🇺🇦 Ukraine', lat: 48.3794, lon: 31.1656, phonePrefix: '+380', flag: '🇺🇦', locale: 'uk_UA' },

    // { id: COUNTRIES.XXX, text: 'XXX', lat: 0.0000, lon: 0.0000, phonePrefix: '+XXX', flag: 'XXX', locale: 'XX_XXX' },
  ];
  var countryToCoordinatesMap = {};
  countries_data.forEach(function(c) {
    countryToCoordinatesMap[c.id] = [c.lon, c.lat];
  });

  var stripe = {
    CONNECT_CLIENT_ID: (apiEnv === 'PRODUCTION') ? 'ca_FOo6UDqlr5LzwX8USPN4GzXhePIQGetF' : 'ca_FOo6tZkrRR6vhzhC4nh4drvxun1zhsiT'
  }

  app.constant('API_CONFIG', {
    apiPrefix: apiPrefix + '/v1/',
    tokenPrefix: 'fhloc-',
    requestTimeout: 15,
    env: apiEnv
  });

  app.constant('APP_CAPTCHA_CONFIG', {
    key: "6LdPBI4UAAAAAJ24P1W94m7x6njdMeCdf5Bu51oG"
  });

  app.constant('AUTH EVENTS', {
    bad_request: 400,
    not_authorized: 401,
    not_allowed: 403,
    not_found: 404,
    server_error: 500,
    bad_gateway: 502
  });

  app.constant('GOOGLE_API_KEY', 'AIzaSyCYXbztKeX055bFcC1gdhgIPWM-sgIQK68');

  // -----------------------------

  app.constant('CONSTANTS', {
    COUNTRIES: COUNTRIES,
    COUNTRIES_DATA: countries_data,
    LOCALES: LOCALES,
    STRIPE: stripe,
    USER_ROLES: {
      USER: 'USER',
      COMMERCIAL_PARTNER: 'COMMERCIAL PARTNER',
    },
    REQUEST_STATUS: {
      PENDING: 'PENDING',
      ACKNOWLEDGED: 'ACKNOWLEDGED',
      RESPONDED: 'RESPONDED',
      FULFILLED: 'FULFILLED',
      CANCELLED: 'CANCELLED',
      REJECTED: 'REJECTED'
    },
    LS_ENTRIES: {
      SHOPPING_CART: 'LS_SHOPPING_CART',
      OFFERS_RECEIVED_FITLER: 'LS_OFFERS_RECEIVED_FITLER'
    },
    DISTRIBUTION_METHODS: {
      DELIVERY: 'delivery',
      COLLECTION: 'collection',
    }
  });

  app.constant('DEAL_STATUS', {
    ACTIVE: 'ACTIVE',
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    FULFILLED: 'FULFILLED',
    EXPIRED: 'EXPIRED'
  });

  app.constant('DEAL_TARGET', {
    DEFAULT: 'DEFAULT',
    NEW_USERS: 'NEW_USERS',
    SUPPLIERS: 'SUPPLIERS',
  });

  app.constant('SUPPLIER_TYPE', {
    COORDINATOR: 'COORDINATOR'
  });

  app.constant('DEAL_CATEGORY', {
    CROP: 'CROP',
    DEAL: 'DEAL'
  });

  app.constant('DEAL_CONSTANTS', {
    DEFAULT_IMAGE: 'https://fh-data-1.s3.eu-west-1.amazonaws.com/1549910391272default_offer_image.png',
    DATE_FORMAT: 'ddd, DD MMM YYYY HH:mm:ss ZZ',
    DEAL_LENGTH_DAYS: 1,
    DELIVERY_START_AFTER_DAYS: 7,
    DELIVERY_LENGTH_DAYS: 14,
    INTIAL_COORDINATES: countryToCoordinatesMap,
    DEAL_SIZE_INFINITE: 9999999
  });

  app.constant('ORDER_STATUS', {
    RESERVED: 'RESERVED',
    PENDING: 'PENDING',
    DELIVERED: 'DELIVERED',
    VIEWED: 'VIEWED', // TODO: remove VIEWED state
    PAID: 'PAID',
    COMPLETED: 'COMPLETED',
    FORWARDED: 'FORWARDED',
    INVALID: 'INVALID',
    CANCELLED: 'CANCELLED',
    REJECTED: 'REJECTED',
  });

  app.constant('FEATURE_FLAGS', {
    BY_COUNTRY: {
      DEAL_USERS_GROUP_VIEW: [COUNTRIES.IE, COUNTRIES.GB, COUNTRIES.US, COUNTRIES.NZ, COUNTRIES.AT, COUNTRIES.DE],
      DEAL_USERS_GROUP_EDIT: null,
      CROP_PROCUREMENT: [COUNTRIES.AT, COUNTRIES.DE, COUNTRIES.HU, COUNTRIES.GB, COUNTRIES.US, COUNTRIES.NZ],
      CUSTOMERS_SPECIFIC_ID: [COUNTRIES.AT, COUNTRIES.DE],
      RETAILERS_EDIT: [COUNTRIES.IE, COUNTRIES.GB, COUNTRIES.HU, COUNTRIES.US, COUNTRIES.NZ],
      BILLING_INFO: [COUNTRIES.IE],
      DEAL_MAP_CIRCLE: [COUNTRIES.AT],
      INVITE_CUSTOMERS_SMS: [COUNTRIES.IE, COUNTRIES.GB, COUNTRIES.HU, COUNTRIES.US, COUNTRIES.NZ],
      HEADER_HIDE_OFFERS: [COUNTRIES.GB],
      PRODUCTS_ALLOW_FREE_TEXT: [COUNTRIES.GB],
    },
    BY_PACKAGE: {
      PROFILE_SAVE: [],
    }
  });

  app.constant('PRODUCT_TYPES', {
    IE: [
      'Agri Diesel',
      'Animal Feed',
      'Concentrate',
      'Bulk Concentrate',
      'Fodder',
      'Animal Health',
      'Breeding & Reproduction',
      'Fly & Lice Control',
      'Fluke & Worm control',
      'Hoff & Wound care',
      'Colostrum',
      'Vaccines',
      'Vitamins & Minerals',
      'Farm Hardware & Equipment',
      'Drinkers, Feeders & Footbaths',
      'Farm Yard Accessories',
      'Fencing & gates',
      'Drainage, Water Fittings & Piping',
      'Farm Insurance',
      'Fertilisers & Seeds',
      'Fertilisers',
      'Grassland Herbicides',
      'Grassland Seeds',
      'Housing & Hygiene',
      'Cubicle lime',
      'Dairy detergents',
      'Bedding',
      'Machinery Parts & Agri Spares',
      'Grass Parts',
      'Plough & Cultivation',
      'PTO',
      'Slurry',
      'Sprayer Equipment',
      'Tractor & Trailer Accessories',
      'Tractor parts',
    ],
    DE: [
      'Baustoffe',
      'BIO',
      'BIO - Dünger & Pflanzenhilfsstoffe',
      'BIO - Pflanzenschutzmittel',
      'BIO - Sonstige',
      'Dünger',
      'Dünger - N-Einzeldünger',
      'Dünger - N-Flüssigdünger',
      'Dünger - Stabilisierte N-Dünger',
      'Dünger - N+S Dünger',
      'Dünger - NP-Dünger',
      'Dünger - NPK-Dünger',
      'Dünger - P-Einzeldünger',
      'Dünger - PK-Dünger',
      'Dünger - Kalidünger',
      'Dünger - Kalke',
      'Dünger - Blattdünger',
      'Futtermittel',
      'Futtermittel - Kraftfutter',
      'Futtermittel - Mineralfutter',
      'Futtermittel - Ergänzungsfutter',
      'Futtermittel - Hygieneprodukte',
      'Pflanzenschutz',
      'Pflanzenschutz - Getreide',
      'Pflanzenschutz - Raps',
      'Pflanzenschutz - Mais',
      'Pflanzenschutz - Zuckerrüben',
      'Pflanzenschutz - Kartoffeln',
      'Pflanzenschutz - Leguminosen',
      'Pflanzenschutz - Sonderkulturen',
      'Pflanzenschutz - Grünland',
      'Pflanzenschutz - Sonstige Mittel',
      'Saatgut',
      'Saatgut - Kartoffeln',
      'Saatgut - Leguminosen',
      'Saatgut - Ölfrüchte',
      'Saatgut - Sommergetreide',
      'Saatgut - Wintergetreide',
      'Saatgut - Saatmais',
      'Saatgut - Grünland & Ackerfutter & Zwischenfrüchte',
      'Technik',
      'Technik - Schmierstoffe',
      'Technik - Schmierstoffe - Schmieröle/-fette',
      'Technik - Schmierstoffe - Schmieröle/-fette',
      'Technik - Schmierstoffe - Schutz-, Reinigungs- & Pflegeprodukte',
      'Technik - Schmierstoffe - Spezialflüssigkeiten, Zusätze',
      'Technik - Ersatzteile',
      'Technik - Ersatzteile - PKW',
      'Technik - Ersatzteile - LKW',
      'Technik - Ersatzteile - Zugmaschinen',
      'Technik - Ersatzteile - Erntemaschinen',
      'Technik - Ersatzteile - Garten&Kommunal',
      'Technik - Ersatzteile - Zweirad',
      'Technik - Reifen',
      'Technik - Reifen - PKW',
      'Technik - Reifen - LKW',
      'Technik - Reifen - Landwirtschaft',
      'Technik - Reifen - Zweirad',
      'Technik - Zubehör',
      'Sonstiges',
      'Energie',
      'Energie - Treibstoffe',
      'Energie - Heizöl',
    ],
    HU: [
      'Magok',
      'Magok - Burgonya',
      'Magok - Hüvelyesek',
      'Magok - Olajos növények',
      'Magok - Nyári gabona',
      'Magok - Téli takarmányok',
      'Magok - Magkukorica',
      'Magok - Legelő és szántóföldi termények',
      'Növényvédelem',
      'Növényvédelem - Gyomirtószer',
      'Növényvédelem - Gombaölőszer',
      'Növényvédelem - Növekedés szabályzó',
      'Növényvédelem - Rovarölőszer',
      'Növényvédelem - habzásgátló anyag',
      'Növényvédelem - Csigairtó',
      'Növényvédelem - Nedvesítő anyag',
      'Növényvédelem - Rágcsálóirtó',
      'Növényvédelem - Tisztító spray',
      'Növényvédelem - Vadkár megelőzés',
      'Növényvédelem - Teljes gyomirtószer',
      'Növényvédelem - Gabona',
      'Műtrágya',
      'Műtrágya - N Egy hatóanyagú műtrágya',
      'Műtrágya - Folyékony műtrágya',
      'Műtrágya - Stabilizált műtrágya',
      'Műtrágya - N S műtrágya',
      'Műtrágya - NP műtrágya',
      'Műtrágya - NPK műtrágya',
      'Műtrágya - P egy hatóanyagú műtrágya',
      'Műtrágya - PK műtrágya',
      'Műtrágya - Kálium műtrágya',
      'Műtrágya - Lemosó',
      'Műtrágya - Levéltrágya',
      'Állati takarmány',
      'Állati takarmány - Tápkoncentrátum',
      'Állati takarmány - Ásványi anyag',
      'Állati takarmány - Táp kiegészítő',
      'Állati takarmány - Higiéniai termékek',
      'Technika',
      'Technika - Kenőanyagok',
      'Technika - Alkatrészek',
      'Technika - Kerekek',
      'Technika - Alkatrészek',
      'Takarmányok'
    ]
  });

  app.constant('REQUEST_TYPES', {
    IE: [
      'Agri Diesel',
      'Animal Feed',
      'Bulk Concentrate',
      'Animal Health',
      'Farm Hardware & Equipment',
      'Farm Insurance',
      'Fertilisers & Seeds',
      'Grass Seeds',
      'Housing & Hygiene',
      'Machinery Parts & Agri Spares',
    ],
    DE: [
      'BIO',
      'Saatgut',
      'Pflanzenschutz',
      'Dünger',
      'Futtermittel',
      'Technik',
      'BIO - Dünger & Pflanzenhilfsstoffe',
      'BIO - Pflanzenschutzmittel',
      'BIO - Sonstige',
    ],
    HU: [
      // TODO: complete from translations
    ]
  });

  app.constant('PRODUCT_UNITS', {
    IE: [
      'Unit',
      'Tonne',
      'Litre',
      'Kg',
      'Canister',
      'Canister XX Litre',
      'Bottle',
      'Bottle XX Litre',
      'Container',
      'Container XX Kg',
      'Acre',
      'Hectare'
    ],
    DE: [
      'Stück',
      'Tonnen',
      'Liter',
      'Kg',
      'dt',
      'Kanister',
      'Kanister XX Liter',
      'Gebinde',
      'Gebinde XX Kg',
      'Hektar (ha)',
    ],
    HU: [
      'Egység',
      'Tonna',
      'Kg',
      'Liter',
    ]
  });

})();

(function() {
  'use strict';

  var app = angular.module('app');

  angular.module('app').config(configBlock);

  /** @ngInject */
  function configBlock(
      $locationProvider,
      $controllerProvider,
      $compileProvider,
      $httpProvider,
      $filterProvider,
      $provide,
      $logProvider,
      tmhDynamicLocaleProvider,
      ScrollBarsProvider,
      toastrConfig,
      jwtOptionsProvider) {

      // cfpLoadingBarProvider, $stateProvider, $urlRouterProvider, , $ocLazyLoadProvider,  ScrollBarsProvider, $localStorageProvider

      /* ---- HTTP Request & Response Interceptors ---- */
      jwtOptionsProvider.config({
          tokenGetter: ['$http', 'AuthFactory', function($http, AuthFactory){
              return AuthFactory.getToken();
          }],
          whiteListedDomains: function(API_CONFIG){
              return API_CONFIG.apiPrefix;
          }
      });

      $httpProvider.interceptors.push('APIInterceptor');
      $httpProvider.interceptors.push('jwtInterceptor');

      app.controller  = $controllerProvider.register;
      app.directive   = $compileProvider.directive;
      app.filter      = $filterProvider.register;
      app.factory     = $provide.factory;
      app.service     = $provide.service;
      app.constant    = $provide.constant;
      app.value       = $provide.value;

      /** ------ Local Storage Config for NGStorage lib ------ */
      $locationProvider.html5Mode(true);
      $logProvider.debugEnabled(true);

      tmhDynamicLocaleProvider
          .localeLocationPattern('/bower_components/angular-i18n/angular-locale_{{locale}}.js')
          .defaultLocale('en');

      ScrollBarsProvider.defaults = {
          scrollButtons: {
              scrollAmount: 'auto',
              enable: false
          },
          advanced: { autoExpandHorizontalScroll: true },
          scrollInertia: 600,
          axis: 'y',
          theme: 'dark-thick',
          autoHideScrollbar: false,
          updateOnContentResize: true,
          contentTouchScroll: 300
      };

      angular.extend(toastrConfig, {
          containerId: 'toast-container',
          newestOnTop: true,
          positionClass: 'toast-bottom-left',
          target: 'body'
      });

      $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|sms|tel):/);
  }

})();


/* Angular-Loading-Bar Configuration */
(function(){
    angular.module('app').config(['cfpLoadingBarProvider', '$qProvider', function (cfpLoadingBarProvider, $qProvider) {
        cfpLoadingBarProvider.includeBar = true;
        cfpLoadingBarProvider.includeSpinner = false;
        cfpLoadingBarProvider.spinnerTemplate = '<div id="loading-mask"><div id="loading-bar-spinner"><div class="spinner-icon"></div></div></div>';

        $qProvider.errorOnUnhandledRejections(false);
    }]);
})();

angular.module('app').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.view.html','<!-- scrollToTop --><!-- ================ --><div class="scrollToTop circle"><i class=icon-up-open-big></i></div><!-- page wrapper start --><!-- ================ --><div class=page-wrapper><!-- header-container start --><div id=header class=header-container><!-- header start --><!-- classes:  --><!-- ================ --><header class="header pv-20 clearfix"><div class=container><div class=row><div class=col-md-4><!-- header-first start --><!-- ================ --><div class="header-first clearfix"><!-- logo --><div id=logo class="logo d-flex justify-content-center justify-content-md-start"><a href=http://farmhedge.ie><img id=logo_img src=app/shared/images/fh_logo2018_black.png width=200 alt="The Project"></a></div><!-- name-and-slogan --><div class="site-slogan text-center-xs"></div></div><!-- header-first end --></div><div class="col-md-8 text-right"><span class=pr-20 translate>Already a customer?</span> <a ui-sref=login class="btn btn-info btn-user btn-animated"><span translate>Login</span> <i class="fa fa-user pl-20"></i></a></div></div></div></header><!-- header end --></div><!-- header-container end --><!-- banner start --><!-- ================ --><div ng-if=false id=banner class="banner dark-translucent-bg padding-bottom-clear" style="background-image:url(\'app/shared/images/landing-page-banner.jpg\')"><!-- section start --><!-- ================ --><div class=container><div class="row justify-content-lg-center"><div class="col-lg-8 text-center space-bottom"><div class="title large_white" translate>FarmHedge <i>for agribusinesses</i></div><div class=separator></div></div></div><div class="row mb-20"><div class=col-lg-4><div class=feature-box-2 data-animation-effect=fadeInDownSmall data-effect-delay=200><span class="icon default-bg small"><i class="fa fa-handshake-o"></i></span><div class=body><h4 class=title translate>Reach new farmers</h4><!-- <p>Inventore dolores aut laboriosam cum consequuntur delectus sequi lorem ipsum dolor sit amet, consectetur.</p> --></div></div></div><div class=col-lg-4><div class=feature-box-2 data-animation-effect=fadeInDownSmall data-effect-delay=150><span class="icon default-bg small"><i class="fa fa-group"></i></span><div class=body><h4 class=title translate>Streamline operations and reduce costs</h4><!-- <p>Iure sequi unde hic. Sapiente quaerat sequi inventore veritatis cumque lorem ipsum dolor sit amet, consectetur.</p> --></div></div></div><div class=col-lg-4><div class=feature-box-2 data-animation-effect=fadeInDownSmall data-effect-delay=100><span class="icon default-bg small"><i class="fa fa-heart"></i></span><div class=body><h4 class=title translate>Easy to use</h4><!-- <p>Voluptatem ad provident non repudiandae beatae cupiditate amet reiciendis lorem dolor consectetur.</p> --></div></div></div></div></div><!-- section end --><!-- section start --><!-- ================ --><div class="pv-40 dark-translucent-bg"><div class=container><div class=row><div class="col-md-12 text-center"><h4 translate>The new way to communicate with farmers</h4></div><div class="col-md-12 text-center mt-10"><div translate>Want to know more?</div><a href=mailto:support@farmhedge.io class="btn btn-lg btn-info btn-animated"><span translate>Send us an email</span> <i class="fa fa-envelope pl-20"></i></a></div></div></div></div><!-- section end --></div><!-- banner end --><!-- main-container start --><!-- ================ --><section class=main-container><div class=container><div class="row justify-content-lg-center" ng-if=false><div class="col-lg-8 text-center space-bottom"><h4 class=title translate>Our features:</h4><div class=separator></div></div></div><div class="row mb-20"><!-- main start --><!-- ================ --><div class="main col-md-12"><div class=row><div class="col-lg-8 order-lg-2"><img class=pv-30 src=app/shared/images/fh_home_explain.png alt=""></div><div class="col-lg-4 order-lg-1"><h2 class=mt-4></h2><ul class=list-icons><li><i class="fa fa-map-marker"></i> <span translate>Select all farmers in a particular area</span></li><li><i class="fa fa-dollar"></i> <span translate>Send offers on farm inputs</span></li><li><i class="fa fa-leaf"></i> <span translate>Ask farmers to sell their crop</span></li><li><i class="fa fa-bell"></i> <span translate>Notify farmers on their mobile phones</span></li><li><i class="fa fa-commenting"></i> <span translate>Receive real-time requests</span></li><li><i class="fa fa-line-chart"></i> <span translate>And much more!</span></li></ul><br><br><div class=mt-50><h3 translate>Want to know more?</h3><a href=mailto:support@farmhedge.io class="btn btn-lg btn-info btn-animated"><span translate>Send us an email</span> <i class="fa fa-envelope pl-20"></i></a></div></div></div></div><!-- main end --></div></div></section><!-- main-container end --><!-- footer start (Add "dark" class to #footer in order to enable dark footer) --><!-- ================ --><footer id=footer class=clearfix><!-- .footer start --><!-- ================ --><div class=footer><div class=container><div class=footer-inner><div class="row justify-content-lg-center"><div class="col-lg-6 mb-20"><div class="footer-content text-center padding-ver-clear"><div class=logo-footer><img id=logo-footer class=mx-auto src=app/shared/images/fh_logo2018_black.png width=120 alt=""></div><div class=separator></div><p class="text-center margin-clear">\xA9 FarmHedge 2022</p></div></div></div></div></div></div><!-- .footer end --></footer><!-- footer end --></div><!-- page-wrapper end -->');
$templateCache.put('app/shared/app.html','<!-- scrollToTop --><!-- ================ --><!-- page wrapper start --><!-- ================ --><!-- header-container start --><div class=header-container data-ng-include=" \'app/shared/partials/header.html\' "></div><!-- header-container end --><div class=global-spinner><div class=spinner-mask></div><div class=spinner><img src=app/shared/images/anime/spinner_fh_1.gif alt=""> <span translate>Loading</span>..</div></div><!--<div us-spinner spinner-key="http-loading" class="http-spinner"></div>--><div id=page-start ui-view></div><!-- footer start (Add "dark" class to #footer in order to enable dark footer) --><!-- ================ --><footer id=footer class=clearfix ng-include=" \'app/shared/partials/footer.html\' "></footer><!-- footer end --><!-- page-wrapper end -->');
$templateCache.put('app/show/show.view.html','<meta name=apple-itunes-app content="app-id=1059744999"><!-- scrollToTop --><!-- ================ --><div class="scrollToTop circle"><i class=icon-up-open-big></i></div><!-- page wrapper start --><!-- ================ --><div class=page-wrapper><!-- header-container start --><div id=header class=header-container><!-- header start --><!-- classes:  --><!-- ================ --><header class="header pv-20 clearfix"><div class=container><div class=row><div class=col-md-4><!-- header-first start --><!-- ================ --><div class="header-first clearfix"><!-- logo --><div id=logo class="logo d-flex justify-content-center justify-content-md-start"><a href=http://farmhedge.io><img id=logo_img src=app/shared/images/logo_dark.png width=150 alt="The Project"></a></div><!-- name-and-slogan --><div class="site-slogan text-center-xs">{{ vm.dealId }}</div></div><!-- header-first end --></div><div class="col-md-8 text-right"><span class=pr-20 translate>Are you agribusiness?</span> <a ui-sref=login class="btn btn-info btn-user btn-animated"><span translate>Login</span> <i class="fa fa-user pl-20"></i></a></div></div></div></header><!-- header end --></div><!-- header-container end --><!-- banner start --><!-- ================ --><div id=banner class="banner dark-translucent-bg padding-bottom-clear" style="background-image:url(\'app/shared/images/landing-page-banner.jpg\')"><!-- section start --><!-- ================ --><div class=container>Hello 1</div><!-- section end --><!-- section start --><!-- ================ --><div class="pv-40 dark-translucent-bg">Hello 2</div><!-- section end --></div><!-- banner end --><!-- main-container start --><!-- ================ --><section class=main-container>Hello 3</section><!-- main-container end --><!-- footer start (Add "dark" class to #footer in order to enable dark footer) --><!-- ================ --><footer id=footer class=clearfix><!-- .footer start --><!-- ================ --><div class=footer><div class=container><div class=footer-inner><div class="row justify-content-lg-center"><div class="col-lg-6 mb-20"><div class="footer-content text-center padding-ver-clear"><div class=logo-footer><img id=logo-footer class=mx-auto src=app/shared/images/logo_dark.png width=120 alt=""></div><div class=separator></div><p class="text-center margin-clear">\xA9 FarmHedge 2022</p></div></div></div></div></div></div><!-- .footer end --></footer><!-- footer end --></div><!-- page-wrapper end -->');
$templateCache.put('app/modules/crop/crop.procurement.html','<section class="pv-30 clearfix"><div class=container><div class=row><div class="col-sm-3 col-lg-2 padding-hor-clear"><div class="image img-fluid deal-image" uib-tooltip="{{\'Click to change image\'|translate}}"><img ng-src={{vm.model.imageUrl}} ng-error-src=app/shared/images/fallback_image.png style="max-height: 90px" class=centered alt=""> <a ng-click=vm.setImage() class=overlay><i class="fa fa-pencil"></i></a></div></div><div class="col-sm-9 col-lg-10"><a ng-click=vm.deleteDeal() ng-if="vm.model.status === vm.DEAL_STATUS.DRAFT" class="btn btn-sm btn-sm-link pull-right" analytics-on=click analytics-event="Delete crop"><i class="fa fa-trash"></i> <span translate>Delete draft</span></a><h4 class=mt-2><img class=pr-10 style=float:left src=app/shared/images/crop_icon.png width=40> <span translate>Crop procurement</span>{{vm.model.product.name?\': \'+vm.model.product.name:\'\'}} <small ng-if=vm.model.vendorProductId>(<span translate>Product ID</span>: {{vm.model.vendorProductId}})</small></h4><span class=large_dark>{{vm.model.name}}</span><div><small translate>Created:</small>&nbsp; <small class=pr-20><i class="fa fa-calendar"></i> {{vm.utils.getLocalizedDateAndTime(vm.model.createdAt)}} <span ng-if=!vm.utils.isUserRegionalManager()><i class="fa fa-user"></i> {{vm.model.createdBy.name.first}} {{vm.model.createdBy.name.last}} </span><span ng-if=vm.utils.isUserRegionalManager()><i class="fa fa-user"></i> <span ng-if=!vm.createdBySelectVisible ng-click="vm.createdBySelectVisible = true">{{vm.model.createdBy.name.first}} {{vm.model.createdBy.name.last}} </span><span ng-if=vm.createdBySelectVisible><select ng-model=vm.model.createdBy><option ng-repeat="user in vm.createdByUserList" value={{user._id}}>{{user.name.first}} {{user.name.last}}</option></select></span></span></small><small translate>Updated:</small>&nbsp; <small><i class="fa fa-calendar"></i> {{vm.utils.getLocalizedDateAndTime(vm.model.updatedAt)}} <span ng-if=vm.model.updatedBy><i class="fa fa-user"></i> {{vm.model.updatedBy.name.first}} {{vm.model.updatedBy.name.last}}</span></small></div><button type=button ng-if=vm.model.requests.length class="btn btn-sm btn-info" ng-click=vm.viewRequestDetails() analytics-on=click analytics-event="View request for crop offer" analytics-value={{vm.model._id}}><i class="fa fa-bullhorn"></i> <span translate>Request for</span> <i>{{vm.model.requests[0].content[1]}}</i></button></div></div><div class=row><div class="card card-gray light-gray-bg col-md-12 mt-1"><div class=card-body><form name=vm.dealForm class="form row" novalidate autocomplete=off><div class="col-lg-6 col-md-12"><div class=row><div class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.cropType.$invalid }"><label for=cropType translate>Crop type</label><input class=form-control ng-if=!vm.isCropNameInCropList ng-model=vm.cropName disabled><select ng-if=vm.isCropNameInCropList type=text name=cropType ng-model=vm.cropName ng-change=vm.onCropSelect() ng-disabled=vm.isReadOnly() ng-options="c.label as (c.label + (c.vendorProductId ? (\' (\' + c.vendorProductId + \')\') : \'\')) for c in vm.cropsList" class=form-control id=cropType aria-describedby=cropType required><option value selected translate>Select crop</option></select></div><div class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.originAndYear.$invalid }"><label for=originAndYear translate>Origin &amp; Year</label><input type=text name=originAndYear ng-model=vm.model.customType class=form-control id=originAndYear aria-describedby=originAndYear ng-disabled=vm.isReadOnly() placeholder="{{\'E.g. Germany 2018\'|translate}}" required><div class=text-danger ng-messages=vm.dealForm.originAndYear.$error ng-if="vm.dealForm.$submitted && vm.dealForm.originAndYear.$invalid"><small class=form-control-feedback ng-message=required translate>* Field is required</small></div></div><div class="form-group col-md-12" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.cropQuality.$invalid }"><label for=cropQuality translate>Crop quality</label><a ng-if="vm.cropName && !vm.isReadOnly() && !vm.doesNotHaveQualityStandards && vm.isCropNameInCropList" ng-click=vm.onCropSelect() class="btn btn-sm btn-info text-white float-right mt-0 mb-0"><i class="fa fa-leaf"></i> <span translate>Select standards</span></a><textarea id=cropQuality name=cropQuality aria-describedby=cropQuality ng-model=vm.model.cropQuality class=form-control rows=2 placeholder="{{\'E.g. Protein 10%\'|translate}}" ng-disabled="vm.isReadOnly() || !vm.isCropNameInCropList"> </textarea><div class=text-danger ng-messages=vm.dealForm.cropQuality.$error ng-if="vm.dealForm.$submitted && vm.dealForm.cropQuality.$invalid"><small class=form-control-feedback ng-message=required translate>* Field is required</small></div></div><distributor-deal class="form-group col-md-12" deal=vm.model.distributorDeal></distributor-deal><div class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.customUnit.$invalid }"><label for=customUnit translate>Unit</label><div class=input-group><input type=text name=customUnit ng-model=vm.model.customUnit class=form-control id=customUnit aria-describedby=customUnit uib-typeahead="unit for unit in vm.lookup.units | filter: $viewValue" typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0 placeholder="{{\'E.g. Tonne\'|translate}}" required></div><div class=text-danger ng-messages=vm.dealForm.customUnit.$error ng-if="vm.dealForm.$submitted && vm.dealForm.customUnit.$invalid"><small class=form-control-feedback ng-message=required translate>* Field is required</small></div></div><div class="form-group col-md-6"><input-deal-size deal-size=vm.model.dealSize deal-size-options=vm.model.dealSizeOptions unit=vm.model.customUnit form=vm.dealForm is-sale=true></input-deal-size></div><div class="form-group col-md-6"><label for=benchmarkPrice><span translate>Price</span><span ng-if=vm.model.customUnit>&nbsp;/&nbsp;{{vm.model.customUnit}}</span></label><button type=button class="btn btn-sm p-1 m-0 float-right" ng-class="{\'btn-secondary\': !vm.allowPriceFreeText, \'btn-outline-success\': vm.allowPriceFreeText}" ng-click="vm.allowPriceFreeText = !vm.allowPriceFreeText"><span translate>Stock price</span></button><input-price deal=vm.model form=vm.dealForm allow-free-text=vm.allowPriceFreeText></input-price></div><div class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.incoterms.$invalid }"><label for=incoterms translate>Incoterms</label><div class="input-group input-typeahead"><input type=text id=incoterms name=incoterms id=incoterms ng-model=vm.model.paymentMethod uib-typeahead="inc for inc in vm.incoterms | filter: $viewValue" typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0 class=form-control placeholder="{{\'E.g. FCA\'|translate}}" required></div><div class=text-danger ng-messages=vm.dealForm.incoterms.$error ng-if="vm.dealForm.$submitted && vm.dealForm.incoterms.$invalid"><small class=form-control-feedback ng-message=required translate>* Field is required</small></div></div><div class=separator></div><div class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.bookingStart.$invalid }"><label for=deal_start translate>Offer starts</label><input-date-time value=vm.model.bookingStart icon="\'fa-play-circle\'" ng-disabled="vm.isReadOnly() || vm.utils.isSupplierDistributor()"></input-date-time><div class="small text-right text-info"><countdown caption="\'Starts in:\'|translate" date-time=vm.model.bookingStart hide-seconds=true alt-text="\'Starts now\'|translate"></countdown></div></div><div class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealLengthError }"><label for=deal_end translate>Offer ends</label><input-date-time value=vm.model.bookingEnd icon="\'fa-step-forward\'"></input-date-time><div class="small text-right text-info"><countdown caption="\'Ends in:\'|translate" date-time=vm.model.bookingEnd hide-seconds=true></countdown></div><div ng-if=vm.dealLengthError class="text-danger small"><!-- <span translate>End date must be after start date</span> --> <span translate>* Field not valid</span></div></div><div class="form-group col-md-6"><label for=distribution translate>Distribution method</label><div ng-if=vm.model.distribution><select ng-model=vm.model.distribution name=distribution id=distribution class=form-control ng-options="op.value as op.label for op in vm.lookup.distMethods" required></select></div><div ng-if=!vm.model.distribution><a ng-click="vm.model.distribution = \'delivery\'"><small><span translate>Add</span> <i class="fa fa-plus-square"></i></small></a></div></div><div class=col-md-6><div class=row ng-if="vm.model.distribution && !vm.dealsService.isDistributionCollection(vm.model)"><div class=col-12><label for=deliveryLocation><span translate>Delivery locations</span> ({{vm.model.collectionPoints.length}} / {{$root.app.Auth.User.supplier.collectionPoints.length}})</label></div><div class=col-12><a class="btn btn-md btn-info text-white m-0" ng-click=vm.manageDeliveryLocation()><i class="fa fa-truck"></i> <span translate>Manage</span></a></div></div></div><div ng-if=vm.model.distribution class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.deliveryStart.$invalid }"><i ng-if=vm.dealsService.isDistributionCollection(vm.model) class="text-info fa fa-home"></i> <i ng-if=!vm.dealsService.isDistributionCollection(vm.model) class="text-warning fa fa-truck"></i><label for=deliveryStart translate>{{vm.lookup.distMethodsMap[vm.model.distribution]}} starts</label><input-date-time id="\'deliveryStart\'" value=vm.model.deliveryStart hide-time=true></input-date-time><div class=text-danger ng-messages=vm.dealForm.deliveryStart.$error ng-if="vm.dealForm.$submitted && vm.dealForm.deliveryStart.$invalid"><small class="form-control-feedback col-12" ng-message=required translate>* Field is required</small> <small class="form-control-feedback col-12" ng-message=distEndBeforeStart translate>* Field not valid</small></div></div><div ng-if=vm.model.distribution class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.deliveryEnd.$invalid }"><i ng-if=vm.dealsService.isDistributionCollection(vm.model) class="text-info fa fa-home"></i> <i ng-if=!vm.dealsService.isDistributionCollection(vm.model) class="text-warning fa fa-truck"></i><label for=deliveryEnd translate>{{vm.lookup.distMethodsMap[vm.model.distribution]}} ends</label><input-date-time id="\'deliveryEnd\'" value=vm.model.deliveryEnd hide-time=true></input-date-time><div class=text-danger ng-messages=vm.dealForm.deliveryEnd.$error ng-if="vm.dealForm.$submitted && vm.dealForm.deliveryEnd.$invalid"><small class="form-control-feedback col-12" ng-message=required translate>* Field is required</small> <small class="form-control-feedback col-12" ng-message=distEndBeforeStart translate>* Field not valid</small></div></div><small class="col-md-12 text-danger" ng-if="vm.distDateValidator !== undefined && !vm.distDateValidator"><i class="fa fa-times-circle-o"></i> <span translate>Distribution Start date must be after the Booking Start date.</span></small><div ng-if=vm.utils.getSettings().isReservationEnabled class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.reservationTime.$invalid }"><label for=deal_size translate>Reservation time</label><div class=input-group><span class=input-group-addon translate>Hours</span> <input type=number id=reservationTime name=reservationTime ng-model=vm.model.allowModifyOrderHours class=form-control required></div><div class="small text-right text-muted"><span ng-if=!vm.model.allowModifyOrderHours>-- </span><span ng-if=vm.model.allowModifyOrderHours>{{vm.model.allowModifyOrderHours/24 | number:1}} <span translate>Days</span></span></div><div class=text-danger ng-messages=vm.dealForm.reservationTime.$error ng-if="vm.dealForm.$submitted && vm.dealForm.reservationTime.$invalid"><small class=form-control-feedback ng-message=required translate>* Field is required</small></div></div><div ng-if=vm.utils.getSettings().isReservationEnabled class="form-group col-md-6"></div><div class="form-group col-md-6"><label><span translate>Offer description</span></label><div><a ng-click=vm.updateDesc() ng-if=!vm.model.description><small><span translate>Add</span> <i class="fa fa-plus-square"></i></small></a></div><div><div ng-if=vm.model.description class=deal-desc ng-click=vm.updateDesc() ng-bind-html=vm.model.description></div></div></div><div class="form-group col-md-6"><label><span translate>Attachments</span> ({{vm.model.attachments.length || 0}})</label><div><div ng-repeat="attachment in vm.model.attachments"><a ng-click=vm.editAttachment($index) class="small text-primary"><i class="fa fa-paperclip"></i> {{attachment.name.slice(0, 20)}} <span ng-if="attachment.name.length > 20">...</span> </a><a ng-click=vm.removeAttachment($index) class="small text-warning">- <span translate>Remove</span></a></div></div><div class=mt-2><a ng-click=vm.addAttachment()><small><span translate>Add attachment</span> <i class="fa fa-plus-square"></i></small></a></div></div><!-- attachments --></div></div><div ng-if=vm.initialized id=container-target class="col-lg-6 col-md-12" ng-switch=vm.utils.isSupplierDistributor()><deal-map ng-switch-when=false radius-changed=vm.radiusFieldChanged() view-users=vm.viewUsers() reload-users=vm.reloadUsers() reset-filters=vm.resetFilters() map=vm.map search-box=vm.searchbox all-users-found=vm.allUsersFound users=vm.model.users target=vm.model.target radius=vm.model.radius system=vm.model.system farm-types=vm.model.farmTypes></deal-map><deal-suppliers ng-switch-when=true users=vm.model.users benchmark-price=vm.model.benchmarkPrice deal-size=vm.model.dealSize deal-size-options=vm.model.dealSizeOptions retail-prices=vm.model.retailPrices price-decimal-digits=vm.model.priceDecimalDigits system=vm.model.system farm-types=vm.model.farmTypes hide-farm-settings=vm.utils.getSettings().canSendOffers></deal-suppliers></div><!-- container-target --><div class=separator></div><div class="col-12 text-right"><button type=button ng-click=vm.safeDraft() ng-if="vm.model.status === vm.DEAL_STATUS.DRAFT" ng-disabled=!vm.modelChangedAfterSave class="btn btn-basic mr-4" analytics-on=click analytics-event="Save deal" analytics-value={{vm.model._id}}><i class="fa fa-save"></i> <span translate>Save draft</span></button> <button ng-click=vm.submit() class="btn btn-success" ng-disabled=vm.productDoesNotExist() analytics-on=click analytics-event="Start publish deal" analytics-value={{vm.model._id}}><i class="fa fa-check"></i> <span translate>Review</span></button></div></form></div></div></div></div></section><script type=text/ng-template id=typeahead.tpl.html><a tabindex="-1" class="typeahead-general p-1">\n        {{match.model}}\n    </a></script>');
$templateCache.put('app/modules/customers/customers.html','<!-- main-container start --><!-- ================ --><section class=main-container id=customers-wrapper><div class=container><div class=row><div class="col-12 invites-container" ng-class="{\'open\': vm.invitesMode }"><customers-invites ng-if=vm.invitesMode refresh-customers=vm.onPage()></customers-invites></div></div><div class=row><div class="col-md-6 col-12"><h3 class=page-title><span translate>Customers</span> ({{vm.paging.count}}) <button class="btn btn-sm btn-link" ng-click=vm.onPage()><span translate>Refresh</span></button></h3></div><div class="col-md-6 col-12 text-right"><div class="m-1 float-right" ng-if=vm.newEntriesThisMonthCount><small>{{vm.newEntriesThisMonthCount}} <span translate>new this month</span></small>.</div><div class="m-1 float-right" ng-if=vm.newEntriesThisWeekCount><small>{{vm.newEntriesThisWeekCount}} <span translate>new this week</span></small>.</div></div></div><div class=separator-2></div><div class="row mb-3"><div class=col-md-5><div class="form-group has-feedback"><input type=text class=form-control ng-model=vm.selectedName ng-change=vm.onPage() ng-model-options="{ debounce: 500 }" placeholder="{{\'Search\'|translate}}"> <i class="fa fa-search form-control-feedback"></i></div></div><div class="form-group col-md-3" ng-if=false><ui-select multiple ng-model=vm.selectedFarmTypes theme=bootstrap sortable on-select=vm.onPage() on-remove=vm.onPage() close-on-select=false style="width: 100%"><ui-select-match placeholder="{{\'Select farm type...\'|translate}}">{{$item.label}}</ui-select-match><ui-select-choices repeat="type as type in vm.lookup.farmTypes | propsFilter: {label: $select.search}"><div ng-bind-html="type.label | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group col-md-2" ng-if=false><select ng-model=vm.selectedSystem ng-change=vm.onPage() name=system id=system class="form-control form-control-md" ng-options="op.value as op.label for op in vm.lookup.systems" required></select></div><div class="form-group col-md-2" ng-if=false><label translate>Group</label><select ng-model=vm.selectedGroup ng-change=vm.onPage() name=group id=group class="form-control form-control-md"><option value=""><span translate>Any</span></option><option ng-repeat="group in vm.groupList" ng-value=group._id><span translate>{{group.name}} ({{group.users.length}} customers)</span></option></select></div><div class="col text-right pt-1" ng-if=vm.selectedName><button class="btn btn btn-sm btn-outline-warning btn-sm" ng-click=vm.reset() style=margin-top:0><i class="fa fa-undo"></i> <span translate>Reset</span></button></div><div class="col text-right p-0 pr-2" ng-if=!vm.selectedName><span ng-if=vm.invites.length class=text-right ng-click=vm.showPendingInvites()><button ng-if="vm.pendingInvitesCount === 1" class="btn btn-link btn-sm" translate>{{vm.pendingInvitesCount}} pending invite</button> <button ng-if="vm.pendingInvitesCount > 1" class="btn btn-link btn-sm" translate>{{vm.pendingInvitesCount || 0}} pending invites</button> </span><!-- <button ng-if="vm.utils.isUserRegionalManager() || vm.utils.isFeatureEnabled(\'INVITE_CUSTOMERS_SMS\')" ng-click="vm.inviteCustomers()" class="btn btn-dark btn-success btn m-1 col-md-4 col-12">\n                    <span translate>Invite customers</span>\n                </button> --> <button ng-click=vm.exportCustomers() class="btn btn-secondary m-0 hidden-md-down" ng-if=true><i class="fa fa-download"></i> <span translate>Export</span></button></div></div><ul class="list-group-table row"><li class="list-table-item-header row hidden-md-down"><div class="col col-md-4 row-clickable"><div ng-click="vm.sortUsers(\'name.last\')"><i class="fa {{vm.getSortClass(\'name.last\')}}"></i> <i class="fa fa-user"></i> <span translate>Customer</span></div></div><div class="col col-md-1 row-clickable"><div ng-click="vm.sortUsers(\'lastDealsAck\', -1)"><i class="fa {{vm.getSortClass(\'lastDealsAck\')}}"></i> <span translate>Active</span> <span class="chip text-info" ng-if="vm.utils.isBefore(\'2020/07/10\')" translate>NEW</span></div></div><div class="col col-md-1 row-clickable"><div ng-click="vm.sortUsers(\'address.zipcode\')"><i class="fa {{vm.getSortClass(\'address.zipcode\')}}"></i> <span translate>Zip code</span></div></div><div class="col col-md-2"><i class="fa fa-home"></i> <small translate>Shop</small> <small uib-tooltip="{{\'Link your customer permanently with a shop\'|translate}}" class="chip text-info" ng-if="vm.utils.isBefore(\'2020/03/01\')" translate>NEW</small></div><div class="col col-md-2"><small translate>Farm types</small></div><div class="col col-md-2 text-right row-clickable"><div ng-click="vm.sortUsers(\'becameCustomerAt\', -1)"><i class="fa {{vm.getSortClass(\'becameCustomerAt\')}}"></i> <span translate>Registration date</span></div></div></li><li class="list-table-item row row-highlighted-hover row-clickable" ng-repeat="c in vm.Customers" ng-click=vm.openUserDetailsModal(c) uib-tooltip={{c.supplierCustomers[0].notes}} ng-class="{\'text-disabled\': c.supplierCustomers[0].isExcluded}"><div class="col col-md-4 col-10"><img ng-src="{{c.imageUrl || \'app/shared/images/team-member.jpg\'}}" ng-error-src=app/shared/images/team-member.jpg alt="" class="float-left mr-3" width=40><div ng-if=c.supplierCustomers[0].isVerified style="float: left" class=mr-2><i class="fa fa-check-square text-success" style=font-size:40px></i></div><div ng-if="c.supplierCustomers[0].hasRequestedVerification && !c.supplierCustomers[0].isVerified && !c.supplierCustomers[0].isExcluded" style="float: left" class=mr-2><i class="fa fa-bell text-warning" style=font-size:40px uib-tooltip="{{\'Requested verification\'|translate}}"></i></div><div><button ng-if=c.hasRegisteredRecently class="btn btn btn-outline-success btn-sm m-0" translate>New</button> <strong>{{c.name.first}} {{c.name.last}}</strong> <i ng-if=c.supplierCustomers[0].notes class="fa fa-comment"></i> <i ng-if="vm.utils.isUserRegionalManager() && c.pushId" class="fa fa-bell"></i></div><div ng-if=vm.customerIdLabel>{{vm.customerIdLabel}}: {{c.supplierCustomers[0].customerId || c.customerId || \'---\'}}</div></div><div class="col col-md-1 col-2"><i ng-if=c.isActiveToday class=text-success translate>Today</i> <i ng-if=c.isActiveWeekly class=text-warning translate>Last 7 days</i> <i ng-if=c.isActiveMonthly class=text-muted translate>Last 30 days</i></div><div class="col col-md-1 col-2" style="text-transform: capitalize">{{c.address.zipcode}}</div><div class="col col-md-2 col-12">{{c.supplierCustomers[0].collectionPointName}}</div><div class="col col-md-2 small"><div><span ng-repeat="f in c.farmTypes.slice(0, 3)">{{vm.lookup.farmTypesMap[f]}}<span ng-show=!$last>,&ensp;</span></span> <span ng-if="c.farmTypes.length > 3">&nbsp;+{{c.farmTypes.length-2}}</span></div><span ng-if=c.system>({{vm.lookup.systemsMap[c.system]}})</span></div><div class="col col-md-2 col-12 text-right">{{vm.utils.getLocalizedDateAndTime(c.suppliersLastChangedAt || c.createdAt)}}</div><div class="col col-12 text-right" ng-if="!c.supplierCustomers[0].isExcluded && c.groups.length"><span ng-repeat="g in c.groups track by $index" class="chip text-white" ng-style="{\'background-color\': g.color}">{{g.name.charAt(0).toUpperCase() + g.name.substr(1)}}</span></div></li><li class=no-result ng-if=!vm.Customers.length><div class="col col-md-10"><i class="fa fa-info-circle"></i> <span translate>No customers available to show</span></div></li></ul><br><div ng-if=vm.paging class="text-center space-top row"><div uib-pagination class=pagination-sm first-text="{{\'First\'|translate}}" previous-text="{{\'Prev\'|translate}}" next-text="{{\'Next\'|translate}}" last-text="{{\'Last\'|translate}}" ng-change=vm.onPage() total-items=vm.paging.count ng-model=vm.paging.current max-size=vm.paging.maxSize items-per-page=vm.paging.itemsPerPage boundary-link-numbers=true></div></div></div></section><!-- main-container end --><div class=separator-2></div>');
$templateCache.put('app/modules/dashboard/dashboard.html','<!-- main-container start --><!-- ================ --><section class=main-container id=dashboard-wrapper><div class=container><div class=row><div class=col-12><h3 class=page-title><span translate>Welcome to FarmHedge</span>, {{$parent.app.Auth.User.name.first}}</h3></div></div><div class=separator-2></div><div class="m-20 alert alert-warning" ng-if=vm.newDashboardUrl><h4>You are being redirected to the newer version of this Dashboard...</h4><div>Target URL:<br>{{vm.newDashboardUrl}}</div><div class=mt-10><button type=button class="btn btn-warning btn-lg" ng-click=vm.redirectToNewDashboardUrl()>Click here to continue</button></div></div><div class="row mb-20" ng-if=!vm.newDashboardUrl><div id=dashboard-overview class=col-md-6><div class="widget col-12" ng-if=false><div class=inner><div class=title><h5><i class="fa fa-list-ul"></i> <span translate>Bookings</span></h5></div><div class="content row"><div class="content-item col-md-4"><a class="btn btn-secondary text-success" ui-sref="app.deals.list({ type: \'ACTIVE\' })"><span class=value>{{vm.stats.bookings.count}}</span> <span class=label><i class="fa fa-hourglass-3"></i> Pending</span></a></div></div></div></div><div id=dashboard-shortcuts class="widget col-12" ng-if=!$parent.app.Auth.User.supplier.type><div class=inner><div class=title><h5><i class="fa fa-user-circle"></i> <span translate>Customers</span></h5></div><div class="content row"><div class="content-item col-6" ng-if=vm.stats.users.new><button class="btn btn-secondary text-success" ui-sref=app.customers.list><span class=value>{{vm.stats.users.new}}</span> <span class=label><i class="fa fa-user"></i> <span translate>New customers</span></span></button></div><div class="content-item col-6" ng-if=!vm.stats.users.new><button class="btn btn-secondary text-muted" ui-sref=app.customers.list><span class=value>{{vm.stats.users.count}}</span> <span class=label><i class="fa fa-user"></i> <span translate>Customers</span></span></button></div><div class="content-item col-6"><button class="btn btn-secondary text-muted" ui-sref=app.deals.request><span class=value>{{vm.stats.requests.new.count}}</span> <span class=label><i class="fa fa-bullhorn"></i> <span translate>New requests</span></span></button></div><div class="content-item col-6"><button class="btn btn-secondary text-muted" ui-sref="app.customers.list({ showInvites: true })"><span class=value>{{vm.stats.invites.accepted.new}}</span> <span class=label><i class="fa fa-check-square-o"></i> <span translate>Accepted invites</span></span></button></div><div class="content-item col-6"><button class="btn btn-secondary text-warning" ui-sref="app.customers.list({ showInvites: true })"><span class=value>{{vm.stats.invites.pending}}</span> <span class=label><i class="fa fa-comment"></i> <span translate>Pending invites</span></span></button></div><!-- Invite customers disabled --><!-- <div class="content-item col-md-12" ng-if="false">\n                                <button class="btn btn-success" type="button" id="createNewDraftButton" \n                                     ui-sref="app.customers.list({ inviteCustomers: true })">\n                                    <i class="fa fa-comment"></i>\n                                    <span translate>Invite customers</span>\n                                </button>\n                            </div> --></div></div></div><div class="widget col-12"><div class=inner><div class=title><h5><i class="fa fa-tags"></i> <span translate>Offers</span></h5></div><div class="content row"><div class="content-item col-6"><button class="btn btn-secondary text-success" ui-sref="app.deals.list({ type: \'ACTIVE\' })"><span class=value>{{vm.stats.deals.live.count || 0}}</span> <span class=label><i class="fa fa-play-circle-o"></i> <span translate>Live</span></span></button></div><div class="content-item col-6"><button class="btn btn-secondary text-warning box" ui-sref="app.deals.list({ type: \'ACTIVE\' })"><span class=value>{{vm.stats.deals.scheduled.count || 0}}</span> <span class=label><i class="fa fa-calendar"></i> <span translate>Scheduled</span></span></button></div><div class="content-item col-md-12"><button ng-if=!vm.hasMultipleChoiceCreateNew() class="btn btn-success p-3 mt-0 ml-0" type=button ng-click=vm.createOffer()><i class="fa fa-plus-circle pr-10"></i> <span>Create new offer</span></button><div class="btn-group dropdown col-12 m-0 p-0" ng-if=vm.hasMultipleChoiceCreateNew()><button class="btn btn-success p-3 mt-0 dropdown-toggle" type=button id=createNewDraftButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fa fa-plus-circle pr-10"></i> <span translate>Create New</span></button><div class="dropdown-menu dropdown-menu-right" aria-labelledby=createNewDraftButton><a id=createNewSaleOfferButton class="dropdown-item text-sale-offer" ng-click=vm.createNewSaleOffer() analytics-on=click analytics-event="Create deal"><i class="fa fa-shopping-cart pr-10"></i> <span translate>New sale offer</span></a> <a id=createNewCropOfferButton class="dropdown-item text-crop-offer" ng-click=vm.createNewCropOffer() analytics-on=click analytics-event="Create crop"><i class="fa fa-leaf pr-10"></i> <span translate>New crop offer</span></a></div></div></div></div></div></div><div class="widget col-12"><div class=inner><div class=title><h5><i class="fa fa-list"></i> <span translate>Orders</span></h5></div><div class="content row"><div class="content-item col-6"><button class="btn btn-secondary text-muted" ui-sref=app.orders><span class=value>{{vm.stats.orders.new.count}}</span> <span class=label><i class="fa fa-exclamation-circle"></i> <span translate>New</span></span></button></div></div></div></div></div><div class="col-sm-12 col-md-6"><div class="widget col-12"><div class=inner><div class=title><h5><i class="fa fa-rocket"></i> <span translate>Getting started</span></h5></div><div class="content text-left"><div ng-if=vm.utils.getSettings().isInternational><div><button class="btn btn-link" ng-click=vm.startIntro()><i class="fa fa-info-circle"></i> <span translate>Tutorial</span></button><ul><li><button class="btn btn-link btn-sm mb-0 mt-0" ui-sref="app.deals.list({ type: \'ACTIVE\', startIntro: true })"><span translate>Offers sent</span></button></li><li><button class="btn btn-link btn-sm mb-0 mt-0" ui-sref="app.orders({startIntro: true})"><span translate>Orders</span></button></li><li><button class="btn btn-link btn-sm mb-0 mt-0" ui-sref="app.offers.received({startIntro: true})"><span translate>Offers received</span></button></li></ul></div><div id=dashboard-tutorial><div ng-if=!vm.isLangDe()><a class="btn btn-link" href=https://fh-attachments.s3.eu-west-1.amazonaws.com/1600356918131_Manual_CEE_EN_-_Sep_2020.pdf target=_blank><i class="fa fa-file"></i> <span translate>Download PDF Manual</span></a><div><iframe src="https://docs.google.com/presentation/d/e/2PACX-1vQTOTY2tdUogEU4HTYM47uZdm90IG7uSMM_JNysx6EwIw9juTEPuAFXvcJBEses_J7pZD9yLWGTVdue/embed?start=false&loop=false&delayms=3000" frameborder=0 width=100% height=300 allowfullscreen mozallowfullscreen=true webkitallowfullscreen=true></iframe></div></div><div ng-if=vm.isLangDe()><a class="btn btn-link" href=https://fh-attachments.s3.eu-west-1.amazonaws.com/1600422146634_Manual_CEE_DE_-_Sep_2020.pdf target=_blank><i class="fa fa-file"></i> <span translate>Download PDF Manual</span></a><div><iframe src="https://docs.google.com/presentation/d/e/2PACX-1vSxMb2eTmEsTZXHmTLr7MNqx4A2Eofy-i5lTXZ5G-W8cgi1zS7kAsPFwhuyMGbVEj6TzHzn9p2EWthV/embed?start=true&loop=true&delayms=3000" frameborder=0 width=100% height=300 allowfullscreen mozallowfullscreen=true webkitallowfullscreen=true></iframe></div></div></div></div><div ng-if=!vm.utils.getSettings().isInternational id=dashboard-tutorial><slider slides=vm.slides></slider></div></div></div></div><div class="widget col-12"><div class=inner><div class=title><h5><i class="fa fa-question-circle"></i> <span translate>Need help?</span></h5></div><div id=dashboard-support class=content><a href=mailto:support@farmhedge.ie>support@farmhedge.ie</a></div></div></div></div></div><div class=separator-2></div></div></section><!-- main-container end -->');
$templateCache.put('app/modules/retailers/retailers.html','<!-- main-container start --><!-- ================ --><section class=main-container id=customers-wrapper><div class=container><ul class="list-group-table row"><li class="list-table-item-header row"><div class="col col-md-5"><small ng-if=vm.utils.getSettings().canReceiveOffers translate>Trader</small> <small ng-if=!vm.utils.getSettings().canReceiveOffers translate>Retailer</small></div><div class="col col-md-4"><span translate>Accounts</span></div><!-- <div class="col col-md-3">\n                    <span translate>Pending invites</span>\n                    <button class="btn btn-outline-primary btn-sm" ng-click="vm.showPendingInvites()" translate>See all</button>\n                </div> --></li><li class="list-table-item row row-highlighted-hover p-3" ng-repeat="retailer in vm.retailers"><div class="col col-md-1"><img ng-src="{{retailer.imageUrl || \'./app/shared/images/default-no-image.jpg\'}}" class="float-left mr-3" width=80></div><div class="col col-md-4"><h5>{{retailer.name}}</h5></div><div class="col col-md-4"><div ng-if=!retailer.accounts.length><span translate>No accounts present</span></div><div ng-repeat="account in retailer.accounts" class="p-1 row"><div class="col-2 p-0 m-0"><img ng-src="{{account.imageUrl || \'app/shared/images/team-member.jpg\'}}" alt="" class="float-left mr-3" width=30></div><div class="col-10 pl-0">{{account.name.first}} {{account.name.last}}</div></div></div><div class="col col-md-3"><div ng-repeat="invite in retailer.invites.pending" class=p-1><a href=https://{{invite.urlShort}} target=_blank><i class="fa fa-chevron-right"></i> <span ng-if=invite.email>{{invite.email}}</span> <span ng-if="invite.email && invite.phoneNumber">/</span> <span ng-if=invite.phoneNumber>{{invite.phoneNumber}}</span></a></div><div class=mt-2 ng-if="vm.utils.isFeatureEnabled(\'RETAILERS_EDIT\')"><button class="btn btn-outline-success btn-small ml-0 mt-0 mr-0" ng-click=vm.inviteRetailer(retailer) translate>Invite customers</button></div></div></li></ul></div></section><!-- main-container end -->');
$templateCache.put('app/modules/subscription/subscription-alert.tpl.html','<div class="alert m-0 pb-0 text-center" ng-if=$ctrl.utils.isUpgradeInfoVisible() ng-class="{\'alert-danger\': $ctrl.utils.isSubscriptionExpired(), \'alert-warning\': !$ctrl.utils.isSubscriptionExpired()}" style="cursor: pointer" upgrade-button><i class="fa fa-exclamation-triangle"></i> <span ng-if="$ctrl.utils.isSubscriptionTrial() && !$ctrl.utils.isSubscriptionExpired()" translate>Your TRIAL subscription will expire on {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}} </span><span ng-if="!$ctrl.utils.isSubscriptionTrial() && $ctrl.utils.isSubscriptionExpiringSoon() && !$ctrl.utils.isSubscriptionExpired()" translate>Your FarmHedge subscription will expire on {{$ctrl.utils.getLocalizedDate($ctrl.utils.getSubscriptionExpiresAt())}} </span><span ng-if="$ctrl.utils.getSubsciptionExpiresInDays() > 1">(in {{$ctrl.utils.getSubsciptionExpiresInDays()}} days).</span> <span ng-if="$ctrl.utils.getSubsciptionExpiresInDays() === 1">(tomorrow).</span> <span ng-if="$ctrl.utils.getSubsciptionExpiresInDays() === 0">(today).</span> <span ng-if=!$ctrl.utils.isSubscriptionExpired() translate>Most features will not be available after that date. </span><span ng-if=$ctrl.utils.isSubscriptionExpired() translate>Your FarmHedge subscription has expired.</span><div><button class="btn btn-success btn-link p-0 mt-0" translate>Learn more about pricing and subscriptions</button></div></div>');
$templateCache.put('app/modules/subscription/subscription-upgrade.tpl.html','<div class=m-4><div class=text-center ng-if=utils.getSubscriptionPackage()><span translate>FarmHedge supription package:</span>&nbsp;<b>{{utils.getSubscriptionPackage()}}</b></div><div class=text-center><span translate>Subscription expiration date:</span>&nbsp;<b>{{utils.getLocalizedDate(utils.getSubscriptionExpiresAt())}}</b></div><div class="text-center text-dangermb-10" ng-if=utils.isSubscriptionExpired()><i class="fa fa-exclamation-triangle"></i> <strong translate>Your FarmHedge subscription has expired.</strong></div><div class="text-center mt-10"><strong translate>Contact us today to renew your subscription and access all the features and information you need.</strong></div><div class="row mt-4 mb-4"><h4 class="text-center col-md-6 text-info"><i class="fa fa-envelope"></i> <a href=mailto:support@farmhedge.io>support@farmhedge.io</a></h4><h4 class="text-center col-md-6 text-info"><!-- <i class="fa fa-phone"></i> <a href="sms:">+353 86 049 5252</a><br> --> <i class="fa fa-phone"></i> <a href=sms:>+353 86 049 5252</a><br></h4><br><br><br></div><div class=text-center ng-if=false><h3 class=text-center translate>Pricing</h3><small translate>Prices exclude VAT.</small></div><div ng-if=false class="pricing-tables stripped hc-element-invisible animated hc-element-visible fadeInUpSmall" data-animation-effect=fadeInUpSmall data-effect-delay=0><div class="row grid-space-0"><!-- pricing table start --><!-- ================ --><div class="col-md-6 plan stripped" ng-if=false><div class="header dark-bg"><h3>Basic</h3><div class=price><span>\u20AC 34.00</span> <small style="font-size: 12px">/ month</small></div></div><ul><li>Publish limited offers</li><li>Process orders</li><li>Receive offers from disributors</li><!-- <li><a href="#" class="btn btn-dark btn-animated">Tal <i class="fa fa-user"></i></a></li> --></ul></div><!-- pricing table end --><!-- pricing table start --><!-- ================ --><div class="push-md-3 col-md-6 plan stripped best-value"><div class="header default-bg"><h3>Pro</h3><div class=price><span>\u20AC 49.00</span> <small style="font-size: 12px">/ month</small></div></div><ul><li><i class="fa fa-check"></i> See farmers inforamtion</li><li><i class="fa fa-check"></i> Receive farmers notifications</li><li><i class="fa fa-check"></i> Access farmers requests</li><li><i class="fa fa-check"></i> Publish unlimited offers</li><li><i class="fa fa-check"></i> Manage customer base</li><!-- <li><a href="#" class="btn btn-dark btn-animated">Talk to sales <i class="fa fa-user"></i></a></li> --></ul></div><!-- pricing table end --></div></div></div>');
$templateCache.put('app/shared/partials/footer.html','<!-- .footer start --><!-- ================ --><div class=footer></div><!-- .footer end --><!-- .subfooter start --><!-- ================ --><div class=subfooter><div class=container><div ng-if="apiEnv !== \'PRODUCTION\'" class="alert alert-warning text-warning m-1 p-2 text-center"><b>Environment: {{apiEnv}}</b></div><div class=subfooter-inner><div class=row><div class=col-md-5><span>\xA9 FarmHedge 2022</span></div><div class=col-md-4><ul class=list-icons><li><i class="fa fa-map-marker pr-2 text-default"></i>Spanchill, Ennis, Ireland</li><li><a href=mailto:support@farmhedge.io><i class="fa fa-envelope-o pr-2"></i>support@farmhedge.io</a></li></ul></div><div class=col-lg-3><div class="footer-content mt-0 pt-0"><ul class="social-links circle animated-effect-1 mt-0"><li class=facebook><a target=_blank href=https://www.facebook.com/farmhedge/ ><i class="fa fa-facebook"></i></a></li><li class=twitter><a target=_blank href="https://twitter.com/farm_hedge?lang=en"><i class="fa fa-twitter"></i></a></li><li class=linkedin><a target=_blank href=https://www.linkedin.com/company/farmhedge><i class="fa fa-linkedin"></i></a></li></ul></div></div></div></div></div></div><!-- .subfooter end -->');
$templateCache.put('app/shared/partials/header.html','<header class="header dark fixed fixed-desktop clearfix"><div class=container><div class=row><div class="col-md-3 hidden-md-down m-0 p-0"><div class="header-first clearfix"><div class="row p-0 m-0"><div class="col-2 p-0" ng-if=app.Auth.User.supplier.imageUrl><img id=logo_img ng-src={{app.Auth.User.supplier.imageUrl}} width=130 alt=FarmHedge></div><div class="col-10 m-0 pr-0 pl-2"><div id=header-logo class=logo><a ui-sref=app.dashboard><img id=logo_img src=app/shared/images/fh_logo2018_white.png width=130 alt=FarmHedge></a></div><span ng-if="utils.isUserRegionalManager() && isSelectSupplierEnabled && !!app.Auth.User.suppliersManaged.length"><select class="form-control header-supplier-select" ng-model=selectedSupplier ng-change=switchSupplier(selectedSupplier) ng-options="s._id as s.label group by s.areaLabel for s in app.Auth.User.suppliersManaged | orderBy:[\'areaLabel\', \'name\']"></select></span><small style="font-size: 75%" ng-if="!utils.isUserRegionalManager() || !isSelectSupplierEnabled" ng-click=showSupplierMenu()>{{app.Auth.User.supplier.name.replace(\'Lagerhaus\', \'LH\')}}</small></div></div></div></div><div class="col-lg-9 ml-auto pl-0 pr-0"><div class="header-second clearfix"><div class="main-navigation main-navigation--mega-menu"><nav class="navbar navbar-toggleable-sm navbar-light p-0"><div class="navbar-brand clearfix hidden-md-up pl-2"><div class="col-2 p-0 pull-left pr-2" ng-if=app.Auth.User.supplier.imageUrl><img id=logo_img ng-src={{app.Auth.User.supplier.imageUrl}} width=130 alt=FarmHedge></div><div id=header-logo-mobile class=logo><a ui-sref=app.dashboard><img id=logo-img-mobile src=app/shared/images/fh_logo2018_white.png width=110 alt=FarmHedge></a><div class=text-white><span ng-if="utils.isUserRegionalManager() && isSelectSupplierEnabled && !!app.Auth.User.suppliersManaged.length"><select class="form-control header-supplier-select" ng-model=selectedSupplier ng-change=switchSupplier(selectedSupplier) ng-options="s._id as s.name group by s.areaLabel for s in app.Auth.User.suppliersManaged | orderBy:[\'areaLabel\', \'name\']"></select></span><small style="font-size: 75%" ng-if="!utils.isUserRegionalManager() || !isSelectSupplierEnabled" ng-click=showSupplierMenu()>{{app.Auth.User.supplier.name.replace(\'Lagerhaus\', \'LH\')}}</small></div></div></div><button class="navbar-toggler navbar-toggler-right" type=button data-toggle=collapse data-target=#navbar-collapse-1 aria-controls=navbar-collapse-1 aria-expanded=false aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div class="collapse navbar-collapse" id=navbar-collapse-1><!-- main-menu --><ul id=header-buttons-container class="navbar-nav ml-md-auto m-0 p-0"><li class="nav-item dropdown text-center" style="min-width: 100px" ng-if=utils.getSettings().canReceiveRequests><a ui-sref=app.deals.request class="fh-nav-link nav-link p-2" ui-sref-active=active aria-expanded=false analytics-on=click analytics-event="Header requests"><div class=nav-item-icon><i class="fa fa-bullhorn"></i></div><small translate>Requests</small><div class=badge-notify-wrapper><span class="badge-notify badge-request" ng-if=$parent.app.Stats.requests.new.count>{{$parent.app.Stats.requests.new.count}}</span></div></a></li><li class="nav-item dropdown text-center" style="min-width: 100px" ng-if=utils.getSettings().canSendOffers><a ui-sref=app.products class="fh-nav-link nav-link p-2" ui-sref-active=active analytics-on=click analytics-event="Header retailers"><div class=nav-item-icon><i class="fa fa-cubes"></i></div><small translate>Products</small><div class=badge-notify-wrapper><span class="badge-notify badge-products" ng-if=$parent.app.Stats.products.public>{{$parent.app.Stats.products.public}}</span></div></a></li><li class="nav-item dropdown text-center" style="min-width: 100px" ng-if=utils.getSettings().canReceiveOffers><a ui-sref=app.offers.received class="fh-nav-link nav-link p-2" ui-sref-active=active aria-expanded=false analytics-on=click analytics-event="Header incoming offers"><div class=nav-item-icon><i class="fa fa-arrow-circle-down"></i></div><small translate>Offers received</small><div class=badge-notify-wrapper><span class="badge-notify badge-offers-received" ng-if=$parent.app.Stats.offers.new>{{$parent.app.Stats.offers.new}}</span></div></a></li><li class="nav-item dropdown text-center" style="min-width: 100px" ng-if=utils.getSettings().canSendOffers><a class="fh-nav-link nav-link p-2" id=deals ui-sref-active=active ui-sref=app.deals.list aria-haspopup=true aria-expanded=false><div class=nav-item-icon><i class="fa fa-play-circle-o pr-2"></i></div><small ng-if=!utils.isSupplierDistributor() translate>Farmers offers</small> <small ng-if=utils.isSupplierDistributor() translate>Offers sent</small><div class=badge-notify-wrapper><span class=badge-notify ng-if=$parent.app.Stats.deals.live.count>{{$parent.app.Stats.deals.live.count}}</span></div></a></li><li class="nav-item text-center" style="min-width: 100px"><a class="fh-nav-link nav-link p-2" id=orders ui-sref=app.orders ui-sref-active=active aria-haspopup=true aria-expanded=false><div class=nav-item-icon><i class="fa fa-list pr-2"></i></div><small translate>Orders</small><div class=badge-notify-wrapper><span class="badge-notify badge-incoming" ng-if=$parent.app.Stats.orders.new.count>{{$parent.app.Stats.orders.new.count}}</span></div></a></li><li class="nav-item dropdown text-center" style="min-width: 100px" ng-if=!utils.isSupplierDistributor()><a ui-sref=app.customers.list class="fh-nav-link nav-link p-2" ui-sref-active=active analytics-on=click analytics-event="Header customers"><div class=nav-item-icon><i class="fa fa-users"></i></div><small translate>Customers</small><div class=badge-notify-wrapper><span class="badge-notify badge-customers" ng-if=$parent.app.Stats.users.new>{{$parent.app.Stats.users.new || $parent.app.Stats.invites.accepted.new}}</span></div></a></li><li class="nav-item dropdown text-center" style="min-width: 100px" ng-if="utils.getSettings().canSendOffers && utils.isSupplierDistributor()"><a ui-sref=app.retailers class="fh-nav-link nav-link p-2" ui-sref-active=active analytics-on=click analytics-event="Header retailers"><div class=nav-item-icon><i class="fa fa-exchange"></i></div><small ng-if=utils.getSettings().canReceiveOffers translate>Traders</small> <small ng-if=!utils.getSettings().canReceiveOffers translate>Retailers</small></a></li><li id=header-user-button class="nav-item dropdown text-center" style="min-width: 100px"><a href=# class="fh-nav-link nav-link dropdown-toggle p-2" id=profile ui-sref=app.dashboard ui-sref-active=active aria-haspopup=true aria-expanded=false><div class=nav-item-icon><i class="fa fa-user pr-2"></i></div><small>{{app.Auth.User.fullName}}</small></a><ul class="dropdown-menu dropdown-menu-right" aria-labelledby=profile><li><a ui-sref=app.dashboard analytics-on=click analytics-event="Hearer dashboard menu"><span class="fa fa-home pr-2"></span> <span>Dashboard</span></a></li><li><a ui-sref=app.profile.main analytics-on=click analytics-event="Header profile"><span class="fa fa-gear pr-2"></span> <span translate>Profile Settings</span></a></li><li><div class=dropdown-divider></div></li><li><a ng-click=logout() analytics-on=click analytics-event="Header logout" href=#><span class="fa fa-power-off pr-2"></span> <span translate>Logout</span></a></li></ul></li><li class="nav-item mega-menu mega-menu--wide text-center" analytics-on=click analytics-event="Header upgrade" style="min-width: 100px" ng-if=utils.isUpgradeInfoVisible()><button class="btn btn-success p-3 ml-3" upgrade-button translate>Upgrade</button></li></ul><!-- main-menu end --></div></nav></div><!-- main-navigation end --></div><!-- header-second end --></div></div></div></header><div ng-if=isInternetExplorer class="alert alert-danger alert-icon text-center mr-5 ml-5"><i class="fa fa-warning"></i><div><b translate>FarmHedge will no longer support Internet Explorer starting from the 30th of November 2020.</b></div><div><span translate>Please use one of these browsers:</span>&nbsp; <a target=_blank href=https://www.microsoft.com/edge>Microsoft Edge</a>, <a target=_blank href=https://www.mozilla.org/firefox/new>Firefox</a>, <a target=_blank href=https://www.google.com/chrome>Google Chrome</a>.</div></div><div class="alert alert-warning m-0 pb-0 text-center alert-warning\'" style="cursor: pointer" ng-click=goToNewDashboard()><div>Es ist ein neues Dashboard verf\xFCgbar</div><div><button class="btn btn-success btn-link p-0 mt-0" translate>Gehen Sie zum neuen Dashboard</button></div></div><!-- header end -->');
$templateCache.put('app/app-commons/directives/pass-strength/pass-strength.tpl.html','<div class=ps-wrapper><ul class=pass-strength><li ng-class="{\'valid\': strength.lower }"><i class="fa {{strength.lower? \'fa-check-circle\':\'fa-times-circle\'}}"></i> <span>Passed lower case character test</span></li><li ng-class="{\'valid\': strength.capital }"><i class="fa {{strength.capital? \'fa-check-circle\':\'fa-times-circle\'}}"></i> <span>Passed capital letter test</span></li><li ng-class="{\'valid\': strength.number }"><i class="fa {{strength.number? \'fa-check-circle\':\'fa-times-circle\'}}"></i> <span>Passed number test</span></li><li ng-class="{\'valid\': strength.special }"><i class="fa {{strength.special? \'fa-check-circle\':\'fa-times-circle\'}}"></i> <span>Passed special character test</span></li></ul></div>');
$templateCache.put('app/app-commons/components/countdown/countdown.html','<span ng-if=$ctrl.timeDiff><span class="mt-0 pt-0" ng-class="{\'text-danger font-weight-bold\': $ctrl.timeDiff.days < 1 && $ctrl.timeDiff.hours < 3, \'text-warning font-weight-bold\': $ctrl.timeDiff.days < 1 && $ctrl.timeDiff.hours >= 3}"><span ng-if=$ctrl.icon class="fa {{$ctrl.icon}}"></span> <span ng-if=$ctrl.caption>{{$ctrl.caption}}</span> <span ng-if="$ctrl.timeDiff.months > 1">{{$ctrl.timeDiff.months}} <span translate>months</span> </span><span ng-if="$ctrl.timeDiff.months <= 1 && $ctrl.timeDiff.days > 1">{{$ctrl.timeDiff.days}} <span translate>days</span> </span><span ng-if="$ctrl.timeDiff.months <= 1 && $ctrl.timeDiff.days === 1 && $ctrl.timeDiff.hours">1 <span translate>day</span> </span><span ng-if="$ctrl.timeDiff.months <= 1 && $ctrl.timeDiff.days === 1 && !$ctrl.timeDiff.hours">24 <span translate>hours</span> </span><span ng-if="$ctrl.timeDiff.months <= 1 && $ctrl.timeDiff.days <= 1 && $ctrl.timeDiff.hours === 1">1 <span translate>hour</span> </span><span ng-if="$ctrl.timeDiff.months <= 1 && $ctrl.timeDiff.days <= 1 && $ctrl.timeDiff.hours > 1">{{$ctrl.timeDiff.hours}} <span translate>hours</span> </span><span ng-if="$ctrl.timeDiff.months <= 1 && $ctrl.timeDiff.days < 1 && $ctrl.timeDiff.hours < 3 && !$ctrl.hideMinutes">{{$ctrl.timeDiff.minutes}} <span translate>min.</span><!-- FIXME: Performance issue with keeping track of seconds in Incoming Page. --><!-- <span ng-if="!$ctrl.hideSeconds">\n                {{$ctrl.timeDiff.seconds}} <span translate>sec.</span>\n            </span> --> </span></span></span><span ng-if="!$ctrl.timeDiff && $ctrl.altText"><span>{{$ctrl.altText}}</span></span>');
$templateCache.put('app/app-commons/components/customer-edit/customer-edit.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-user"></i> <span paid-feature=PRO>{{userData.name.first}} {{userData.name.last}}</span></h4><span ng-if=utils.isUserRegionalManager() class="p-1 small alert-warning">{{userData._id}}</span> <button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button></div><div class=modal-body><div class=row><div class=col-lg-6><div class="row mb-10"><div class=col-4><span translate>Status</span></div><div class=col-8 ng-if=!supplierCustomer.isExcluded><span class=text-positive translate>Active</span> <button class="btn btn-outline-danger btn-sm m-0 float-right" ng-click="supplierCustomer.isExcluded = true" translate>Exclude from all offers</button></div><div class=col-8 ng-if=supplierCustomer.isExcluded><i class="fa fa-exclamation-triangle text-danger"></i> <span class=text-danger translate>Excluded from all offers</span> <button class="btn btn-outline-dark btn-sm m-0 float-right" ng-click="supplierCustomer.isExcluded = false" translate>Cancel</button></div></div></div></div><div class=row><div class=col-lg-6><div class="row mb-10 mt-4"><div class=col-4><span translate>Email</span></div><div class=col-8><input type=text class=form-control ng-model=userData.email></div></div><div class="row mb-10"><div class=col-4><span translate>Phone number</span></div><div class=col-8><input type=text class=form-control ng-model=userData.phoneNumber></div></div><form autocomplete=off><div class="row mb-10"><div class=col-4><span translate>Address</span></div><div class=col-8><input type=text class=form-control ng-model=userData.address.street></div></div><div class="row mb-10"><div class=col-4><span translate>City</span></div><div class=col-8><input type=text class=form-control ng-model=userData.address.city></div></div><div class="row mb-10"><div class=col-4><span translate>Zip code</span></div><div class=col-8><input type=text class=form-control ng-model=userData.address.zipcode></div></div><div class="col-12 separator-2 mb-2"></div><div class="row mb-10 mb-2"><div class=col-4><span translate>Notes</span></div><div class=col-8><textarea rows=2 class=form-control ng-model=supplierCustomer.notes></textarea></div></div></form></div><div class=col-lg-6><form autocomplete=off><div class="row mb-10" ng-if=customerIdLabel><div class=col-4><label for=customerId>{{customerIdLabel}}</label></div><div class=col-8><input type=text id=customerId name=customerId class=form-control ng-model=supplierCustomer.customerId autocomplete=false></div></div><div class=row><div class=col-4><span translate>Shop</span><br><small uib-tooltip="{{\'Link your customer permanently with a shop\'|translate}}" class="chip text-info" ng-if="utils.isBefore(\'2020/04/10\')" translate>NEW</small></div><div class=col-8><input type=text id=colelctionPoint class=form-control name=customColelctionPoint data-ng-model=supplierCustomer.collectionPointName placeholder="{{\'Name\'|translate}}" uib-typeahead="opt.name as (opt.name + \'<br><small>\' + opt.address + \'</small>\') for opt in shops | filter: $viewValue" typeahead-on-select=setShopData($item) typeahead-show-hint-on-focus=all typeahead-min-length=0 typeahead-editable=false autocomplete=off></div></div><div class="separator-2 mt-2 mb-2"></div><div class="row mb-10"><div class=col-12><strong translate>Groups</strong> <a ng-click=promptCreateNewGroup() ng-if="$ctrl.newGroupName.trim() && !addGroupMode" class="m-0 p-0 btn btn-icon my-0 pull-right text-success"><i class="fa fa-plus-circle"></i> <span translate>Create group "{{$ctrl.newGroupName}}"</span></a></div><div class=col-12 ng-if=!addGroupMode><chips ng-model=userData.groups><chip-tmpl><div class="default-chip group-chip" ng-style="{\'background-color\': chip.color }">{{chip.name}} <span class="fa fa-times-circle" remove-chip></span></div></chip-tmpl><input ng-model-control ng-model=selectedGroup id=groupName ng-change=groupNameChanged() uib-typeahead="group as group.name for group in filteredGroups() | filter: { name: $viewValue }" typeahead-on-select=resetNewGroupName() typeahead-show-hint-on-focus=all typeahead-min-length=0 autocomplete=off placeholder="{{\'Add group\'|translate}}"></chips></div><div class="row col-12" ng-if=addGroupMode><div class="col-12 input-group" ng-class="{\'has-error\': !newGrpValid }"><span class=input-group-btn><button ng-click=cancelNewGroup() class="btn btn-warning m-0"><i class="fa fa-times-circle"></i></button> </span><input id=newGroup type=text class=form-control placeholder="New Group Name" ng-model=$ctrl.newGroupName disabled> <span class=input-group-btn><button ng-click=createNewGroup() class="btn btn-success text-white m-0"><i class="fa fa-check"></i></button></span></div><div class=col-12 ng-if=!newGrpValid><p class="full-width error-message text-danger"><i class="fa fa-times-circle"></i> Group name not valid or already exists.</p></div></div></div><div class="row mt-5"><div class=col-4><label translate>Farm types</label></div><div class=col-8><label><span ng-repeat="f in userData.farmTypes">{{lookup.farmTypesMap[f]}}<span ng-show=!$last>,&ensp;</span></span></label></div></div><div class=row><div class=col-4 style="overflow: hidden"><label translate>Farm system</label></div><div class=col-8><label>{{userData.system ? lookup.systemsMap[userData.system] : \'---\'}}</label></div></div></form></div></div><div class="col-12 separator-2 mb-2"></div><div class=row><div class=col-6><button type=button ng-click=cancel() class="btn btn-dark col-8"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button type=button ng-click=ok() class="btn btn-success col-12" data-dismiss=modal paid-feature=PRO><i class="fa fa-check"></i> <span translate>Save</span></button></div></div></div>');
$templateCache.put('app/app-commons/components/deal-discount-options/deal-discount-options.tpl.html','<!-- TODO: delete, moved to shared folder --><div class=modal-header><h4 class=modal-title><i class="fa fa-tags"></i> <span translate>Price settings</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class=modal-body><form name=ds.form class="form mt-0 pt-0" novalidate autocomplete=off><div class="row mb-4"><label class="col-lg-3 col-sm-6 text-right pt-2"><span translate>Price</span><span ng-if=ds.customUnit>&nbsp;/&nbsp;{{ds.customUnit}}</span></label><div class="col-lg-4 col-sm-6 input-group"><input-price deal=ds form=ds.form price-changed=benchmarkPriceChanged allow-price-on-request=ds.allowPriceOnRequest></input-price></div></div><div ng-if="ds.benchmarkPrice && !$ctrl.utils.isSupplierDistributor()"><div class="small mb-1"><span translate>Specify custom discount based on quantity purchased.</span></div><table class="table deal-discount-table" cellspacing=0 cellpadding=0><thead><tr><th><span translate>Quantity</span> ({{ds.customUnit}})</th><th translate>Price / {{ds.customUnit}}</th><th translate>Discount / {{ds.customUnit}}</th><th width=15% translate>Discount (%)</th><th class=hidden-md-down translate>Total discount</th><th class=hidden-md-down translate>Total price</th><th></th></tr></thead><tbody><tr ng-repeat="qd in ds.quantityDiscounts"><td style="max-width: 150px"><input type=number ng-model=qd.quantity class=form-control name=dsQuantity{{$index}} ng-change=qdQuantityChanged(qd) ng-blur="qdQuantityChanged(qd, true, $index)" ng-disabled="$index === 0" required></td><td><div class=input-group><input type=text class="form-control pl-0 pr-1 text-right" ng-model=qd.price ng-change="qdPriceChanged(qd, $index)" fraction="{{ds.priceDecimalDigits || 0}}" ng-currency currency-symbol="" required> <span class="input-group-addon hidden-md-down">{{$root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}}</span></div></td><td><div class=input-group><input type=text class="form-control pl-0 pr-1 text-right" ng-model=qd.discountPrice ng-change=qdDiscountPriceChanged(qd) fraction="{{ds.priceDecimalDigits || 0}}" ng-currency currency-symbol="" required> <span class="input-group-addon hidden-md-down">{{$root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}}</span></div></td><td><div class=input-group><input type=number ng-model=qd.discount class="form-control pl-1 pr-0 text-right" ng-change=qdDiscountChanged(qd) aria-describedby=size name=dsDiscount{{$index}} min=0 max=100></div></td><td class=hidden-md-down><div class=input-group><input type=text class="form-control pl-0 pr-1 text-right" ng-model=qd.discountTotal ng-change=qdDiscountTotalChanged(qd) ng-currency currency-symbol="" required> <span class="input-group-addon hidden-md-down">{{$root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}}</span></div></td><td class=hidden-md-down><div class="text-right small"><div ng-if="qd.discount > 0.0001"><s class=small>{{qd.priceTotal | currency: $root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}}</s><div>{{qd.priceTotalDiscounted | currency: $root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}}</div></div><div ng-if="qd.discount <= 0.0001" class=pt-2>{{qd.priceTotalDiscounted | currency: $root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}}</div></div></td><td><button type=button ng-if="$index !== 0" class="btn btn-sm fa fa-trash text-danger" ng-click=removeRow($index)></button></td></tr></tbody></table><div class="row mt-3 mb-3 pl-20 font-weight-bold"><div class="col-4 px-1"></div><div class="col-7 px-1"><button type=button class="btn btn btn-secondary m-0" style="width: 100%" ng-click=addRow()><i class="fa fa-plus"></i> <span translate>Add discount</span></button></div></div></div><div ng-if=$ctrl.utils.isSupplierDistributor()><deal-suppliers users=ds.retailPricesUsers benchmark-price=ds.benchmarkPrice deal-size=ds.dealSize deal-size-options=ds.dealSizeOptions retail-prices=ds.retailPrices price-decimal-digits=ds.priceDecimalDigits hide-farm-settings=true hide-quantities=true hide-images=true hide-accounts=true hide-quantities=true></deal-suppliers></div></form><div class="separator-2 mt-5"></div><div class=row><div class=col-6><button type=button ng-click=cancel() class="btn btn-dark col-lg-8"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button type=button ng-click=ok() class="btn btn-success col-lg-8" data-dismiss=modal ng-disabled=ds.form.$invalid><i class="fa fa-save"></i> <span translate>Ok</span></button></div></div></div>');
$templateCache.put('app/app-commons/components/deal-details-directive/deal-details-directive.tpl.html','<div><div class="card-block col-12 mb-2" style="padding-bottom: 0"><div class="col-md-12 padding-hor-clear padding-ver-clear p-10"><div class=row><div class=col-md-9><div ng-if="$ctrl.utils.isSupplierDistributor() && $ctrl.canOpenReport()" class=mb-5><h6><i class="fa fa-user"></i> <span translate>Customers</span></h6><div class="separator mt-1 mb-1"></div><div class="deal-supplier-row row" ng-repeat="retailer in $ctrl.deal.targetRetailers | orderBy:\'name\'"><div class=col-sm-2><img ng-src={{retailer.imageUrl}} alt=""></div><div class="col-md-10 row p-0 m-0"><div class="col-12 p-0 m-0"><strong>{{retailer.name.replace(\'Lagerhaus\', \'LH\')}}</strong></div><div class="col-12 row p-0 m-0"><div class="col-sm-4 m-0 pl-0 pr-0 pt-1"><div class="small clearfix text-muted" ng-repeat="account in retailer.accounts"><img ng-src="{{account.imageUrl || \'app/shared/images/team-member.jpg\'}}" alt="" class="float-left mr-1" width=15> {{account.name.first}} {{account.name.last}}</div></div><div class=col-sm-2 ng-class="{\'text-warning\': $ctrl.hasDifferentPrice(retailer)}">{{$ctrl.utils.getLocalizedCurrency(retailer.rrp || $ctrl.deal.benchmarkPrice)}}</div><div class=col-sm-3><span ng-if=retailer.amountReserved class=text-warning><span translate>Reserved</span>:&nbsp; {{retailer.amountReserved || 0}}<br><countdown class=small caption="\'For:\'|translate" date-time=retailer.modifyTimeExpiresAt></countdown></span></div><div class=col-sm-3><div ng-class="{\'text-success\': retailer.amount}"><i class="fa fa-check-square"></i> <span translate>Ordered</span>:&nbsp; {{retailer.amount || 0}}</div><div class=mb-1 ng-if="retailer.dealSize || $ctrl.deal.dealSizeOptions.max"><span translate>Max</span>:&nbsp; {{retailer.dealSize || $ctrl.deal.dealSizeOptions.max}}</div></div></div></div><div class="separator mt-1 mb-1"></div></div><div class="text-warning mt-1" ng-if=!$ctrl.deal.targetRetailers.length><i class="fa fa-times-circle"></i> <span translate>No orders or reservations</span></div><div class=p-2 ng-if="!$ctrl.isExpandedTargetRetailers && $ctrl.deal.inactiveRetailersNames.length"><div class="small text-muted"><span translate>Inactive suppliers</span>:</div><span class="chip text-grey" ng-repeat="retailer in $ctrl.deal.inactiveRetailersNames | orderBy:\'name\'">{{retailer.replace(\'Lagerhaus\', \'LH\')}}</span><div><button type=button class="col-6 btn btn-outline-info btn-sm" ng-click=$ctrl.toggleExpandedTargetRetailers()><i class="fa fa-chevron-circle-down"></i> <span translate>Show all</span></button></div></div></div><div ng-if="!$ctrl.utils.isSupplierDistributor() && $ctrl.canOpenReport()" class="mt-1 mb-5 row"><div class=col-lg-6><h6><i class="fa fa-users"></i> <span translate>Customers</span></h6><div class=mb-3><button type=button class="col-12 btn btn-outline-info btn-animated m-0" ng-click=$ctrl.viewUsers()><span translate>See customers</span> ({{$ctrl.deal.users.length}}) <i class="fa fa-users"></i></button></div><div ng-if=$ctrl.deal.farmTypes.length class=mb-1><span translate>Farm types</span>:<div><span class="chip pb-0" ng-repeat="chip in $ctrl.deal.farmTypes">{{$ctrl.farmTypesMap[chip]}}</span></div></div><div ng-if=$ctrl.deal.system class=mb-1><span translate>Farm system</span>:&nbsp; <span class="chip pb-0">{{$ctrl.systemsMap[$ctrl.deal.system]}}</span></div></div><div class=col-lg-6 ng-if="$ctrl.deal.individualDiscount || $ctrl.deal.clearanceDiscount"><h6><i class="fa fa-tag"></i> <span translate>Discount</span></h6><div class=mb-2><span translate>Original price</span>:&nbsp; <b>{{$ctrl.utils.getLocalizedCurrency($ctrl.deal.benchmarkPrice, $ctrl.deal.priceDecimalDigits)}}</b> <small>/ {{$ctrl.deal.customUnit}}</small></div><div ng-if=!$ctrl.deal.quantityDiscounts.length><span translate>Discount</span>:&nbsp;<b>{{$ctrl.deal.individualDiscount | number:1}}%</b></div><table ng-if=$ctrl.deal.quantityDiscounts.length class="table table-striped"><thead><tr><th translate>Quantity</th><th translate>Discount</th><th><span translate>Price</span>&nbsp;<small>/ {{$ctrl.deal.customUnit}}</small></th></tr></thead><tbody><tr ng-repeat="qd in $ctrl.deal.quantityDiscounts"><td>{{qd.quantity}}+</td><td>{{qd.discount | number:1}}%</td><td>{{$ctrl.utils.getLocalizedCurrency($ctrl.deal.benchmarkPrice-$ctrl.deal.benchmarkPrice*qd.discount/100)}}</td></tr></tbody></table></div></div><div class=mb-5 ng-if=$ctrl.deal.variants.length><h6><i class="fa fa-sitemap"></i> <span translate>Additional variants</span></h6><div class=row><div class="col-lg-3 col-md-6" ng-repeat="v in $ctrl.deal.variants"><div class="col-12 small"><b>{{v.productName}}</b><br>{{$ctrl.utils.getLocalizedCurrency(v.benchmarkPrice, $ctrl.deal.priceDecimalDigits)}}</div></div></div></div><div class=mb-5 ng-if=$ctrl.isCategoryCrop(d)><h6><i class="fa fa-leaf"></i> <span translate>Crop quality</span></h6><div><span class="chip pb-0" ng-repeat="chip in $ctrl.deal.cropQuality.split(\'; \')">{{chip}}</span></div></div><div class="row mb-5"><div class=col-md-6><h6><i class="fa fa-calendar"></i> <span translate>Offer</span></h6><ul><li><span translate>Starts</span>: {{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.bookingStart)}}</li><li class=font-weight-bold><span translate>Ends</span>: {{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.bookingEnd)}}</li></ul></div><div ng-if=$ctrl.deal.distribution class=col-md-6><h6><span ng-if=$ctrl.dealsService.isDistributionDelivery($ctrl.deal)><i class="fa fa-truck"></i> <span translate>Delivery</span> </span><span ng-if=!$ctrl.dealsService.isDistributionDelivery($ctrl.deal)><i class="fa fa-home"></i> <span translate>Collection</span></span></h6><ul><li><span translate>Starts</span>: {{$ctrl.utils.getLocalizedDate($ctrl.deal.deliveryStart)}}</li><li><span translate>Ends</span>: {{$ctrl.utils.getLocalizedDate($ctrl.deal.deliveryEnd)}}</li></ul></div></div></div><div class=col-md-3><h6 class="text-center mr-5"><span translate>Actions</span></h6><div><div ng-if=$ctrl.canOpenReport(d)><button type=button class="col-12 btn btn-outline-info btn-animated" ui-sref="app.deals.report({id: $ctrl.deal._id})"><i class="fa fa-file-text"></i> <span translate>Report &amp; orders</span></button></div><div ng-if=$ctrl.isTypeActive(d)><button type=button class="col-12 btn btn-secondary btn-animated" ng-click=$ctrl.goToEditIfDraft(d)><i class="fa fa-edit"></i> <span translate>Edit</span></button></div><div><button type=button class="col-12 btn btn-secondary btn-animated" ng-click=$ctrl.cloneDeal(d)><i class="fa fa-copy"></i> <span translate>Clone offer</span></button></div><div ng-if="!$ctrl.isTypeDraft() && !$ctrl.dealsService.isBookingStartInTheFuture(d) && $ctrl.utils.isSupplierDistributor()"><div class=separator></div><button type=button class="col-12 btn btn-secondary btn-animated" ng-click=$ctrl.extendDeal(d)><span ng-if=$ctrl.isTypeActive()><i class="fa fa-plus-circle"></i> <span translate>Extend</span> </span><span ng-if=!$ctrl.isTypeActive()><i class="fa fa-play"></i> <span translate>Resume</span></span></button></div><div ng-if=$ctrl.canStopOffer(d)><div class=separator></div><button type=button class="col-12 btn btn-warning btn-animated mt-2" ng-click=$ctrl.askToDeleteDeal(d)><i class="fa fa-stop-circle"></i> <span translate>Stop offer</span></button></div><div ng-if="$ctrl.isTypeActive() && $ctrl.dealsService.isBookingStartInTheFuture(d)"><div class=separator></div><button type=button class="col-12 btn btn-warning btn-animated" ng-click=$ctrl.askToDeleteDeal(d)><i class="fa fa-times"></i> <span translate>Cancel offer</span></button></div><div ng-if=$ctrl.isTypeDraft()><div class=separator></div><button type=button class="col-12 btn btn-warning btn-animated" ng-click=$ctrl.askToDeleteDeal(d)><i class="fa fa-trash-o"></i> <span translate>Delete draft</span></button></div></div></div></div></div><div class="row mb-5" ng-if=false><div class="col-12 p-0 m-0"><div class="separator-2 mt-10"></div><div class="col-sm-12 row"><div class=col-4><span translate>Deal start</span>:</div><span class=col-8><span>{{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.bookingStart)}}</span></span></div><div class="col-sm-12 row"><div class=col-4><span translate>Deal end</span>:</div><span class=col-8><strong>{{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.bookingEnd)}}</strong></span></div><div class="col-sm-12 row"><div class=col-4><span ng-if="$ctrl.deal.distribution === \'delivery\'"><span translate>Delivery</span></span> <span ng-if="$ctrl.deal.distribution === \'collection\'"><span translate>Collection</span></span> <span translate>from</span>:</div><div class=col-8><span>{{$ctrl.utils.getLocalizedDate($ctrl.deal.deliveryStart)}}</span></div></div><div class="col-sm-12 row"><div class=col-4><span ng-if="$ctrl.deal.distribution === \'delivery\'"><span translate>Delivery</span></span> <span ng-if="$ctrl.deal.distribution === \'collection\'"><span translate>Collection</span></span> <span translate>until</span>:</div><div class=col-8><span>{{$ctrl.utils.getLocalizedDate($ctrl.deal.deliveryEnd)}}</span></div></div><div class="separator-2 mt-10"></div><div class="col-sm-12 row mt-10"><div class=col-4><small translate>Created</small>:</div><small class=col-8><i class="fa fa-calendar"></i> {{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.createdAt)}} <span ng-if=$ctrl.deal.createdBy><i class="fa fa-user"></i> {{$ctrl.deal.createdBy.name.first}} {{$ctrl.deal.createdBy.name.last}}</span></small></div><div class="col-sm-12 row"><div class=col-4><small translate>Updated</small>:</div><small class=col-8><i class="fa fa-calendar"></i> {{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.updatedAt)}} <span ng-if=$ctrl.deal.updatedBy><i class="fa fa-user"></i> {{$ctrl.deal.updatedBy.name.first}} {{$ctrl.deal.updatedBy.name.last}}</span></small></div></div></div></div></div>');
$templateCache.put('app/app-commons/components/deal-details-directive/deal-stop-prompt.tpl.html','<div class="mt-2 mb-4 p-2"><div ng-if=$ctrl.isReservationsWarningEnabled class="alert alert-danger mt-0"><span translate>There are active reservations on this offer</span></div><div class=mb-3><input type=checkbox id=sendEmail ng-model=$ctrl.isMessageEnabled class=switch-input><label for=sendEmail class="switch-label text-left"><i class="fa fa-envelope"></i> <span translate>Notify customers</span></label></div><div class=mb-1 ng-if=$ctrl.isMessageEnabled ng-class="{\'has-error\': !$ctrl.messageText }"><input type=text class=form-control ng-model=$ctrl.messageText placeholder="{{\'Message for customer\' | translate}}"></div><br></div>');
$templateCache.put('app/app-commons/components/deal-quantity-selector/deal-quantity-selector.tpl.html','<div><div class=row><div class="col-3 text-center"><button type=button class="btn btn-info fa fa-minus m-0" style=width:100% ng-click=$ctrl.decreaseQuantity()></button></div><div class=col-6><input class=form-control autocomplete=off autofocus type=number class=form-control ng-model=$ctrl.selectedQuantity></div><div class="col-3 text-center"><button type=button class="btn btn-info fa fa-plus m-0" style=width:100% ng-click=$ctrl.increaseQuantity()></button></div></div></div>');
$templateCache.put('app/app-commons/components/dialog-wrapper/dialog-wrapper.html','<div class="dialog-wrapper {{$ctrl.size}}"><div class=dialog-backdrop ng-click=$ctrl.onCancel()></div><div class="dialog {{$ctrl.size}}"><div class=dialog-content esc-key=$ctrl.onCancel() style="color: #fff"><div class=dialog-header><md-button type=button class=md-accent md-no-ink="" ng-click=$ctrl.onCancel() translate=BTN_CANCEL>Cancel</md-button><h5 class=header-title>{{$ctrl.title}}</h5><md-button type=button layout-align="center end" class=md-accent md-no-ink="" ng-disabled=$ctrl.form.$invalid ng-click=$ctrl.onReady()>Ready</md-button></div><div class="dialog-body ng-scrollbar-container" ng-scrollbars ng-style="{\'max-height\': $ctrl.maxHeight }"><ui-view class=row></ui-view></div><div class=dialog-footer><md-button type=button class=md-accent md-no-ink="" ng-click=$ctrl.onDelete() ng-disabled=isDeleteDisabled ng-if=$ctrl.updateMode></md-button></div><div class=loading-mask ng-if=$ctrl.loading><div class=backdrop></div><md-progress-circular md-diameter=60></md-progress-circular></div></div></div></div>');
$templateCache.put('app/app-commons/components/distributor-deal/distributor-deal.html','<div ng-if=$ctrl.isInitialized><div class="alert alert-info m-0 pl-0 pr-0 pt-2 pb-2 row"><div class=col-9><!-- <h5 translate>Distributor offer connected</h5> --> <b><span translate>From distributor</span>: {{$ctrl.utils.getLocalizedCurrency($ctrl.deal.benchmarkPrice, $ctrl.deal.priceDecimalDigits)}} <span class=small>/ {{$ctrl.deal.customUnit}}</span></b></div><div class="col-3 text-right"><button type=button class="btn btn-sm btn-link p-0 m-0" ui-sref="app.offers.incoming({ id: $ctrl.deal._id })" translate>Details</button></div><!-- TODO: complete --><!-- <div class="col-1">\n            <button type="button" class="btn btn-link btn-icon fa fa-times p-1 m-0" ng-click="removeDistributorDeal()"></button>\n        </div> --><div class="col-md-6 col-sm-12"><div class=p-0 ng-if=$ctrl.deal.bookingEnd><div ng-if=$ctrl.deal.paymentMethod class=small><span ng-if=!$ctrl.deal.isVatIncluded translate>Excl. VAT</span> <span ng-if=$ctrl.deal.isVatIncluded translate>Incl. VAT</span> - <span translate>Incoterms</span>: {{$ctrl.deal.paymentMethod}}</div><countdown caption="\'Offer ends in:\'|translate" date-time=$ctrl.deal.bookingEnd hide-seconds=true></countdown><div class="mt-10 p-0" ng-if=$ctrl.deal.isExpired><span translate>Expired</span></div></div><div ng-if="$ctrl.deal.description && $ctrl.deal.description.length < 300"><span class=text-primary><sup><i class="fa fa-quote-left"></i></sup> <span class=incoming-offers-description ng-bind-html=$ctrl.deal.description></span> <sub><i class="fa fa-quote-right"></i></sub></span></div><div class=mt-2 ng-if=$ctrl.deal.deliveryStart><div><i class="text-warning fa fa-truck"></i> <span translate>Delivery period</span>:<br><div class=small>{{$ctrl.utils.getLocalizedDate($ctrl.deal.deliveryStart)}} - {{$ctrl.utils.getLocalizedDate($ctrl.deal.deliveryEnd)}}</div></div></div></div><div class="col-md-6 col-sm-12 text-right"><!-- <div class="">\n                <strong>\n                    {{$ctrl.utils.getLocalizedCurrency($ctrl.deal.benchmarkPrice, $ctrl.deal.priceDecimalDigits)}}\n                    <span class="small">/ {{$ctrl.deal.customUnit}}</span>\n                </strong>\n                <div ng-if="$ctrl.deal.paymentMethod" class="small">\n                    <span ng-if="!$ctrl.deal.isVatIncluded" translate>Excl. VAT</span>\n                    <span ng-if="$ctrl.deal.isVatIncluded" translate>Incl. VAT</span>\n                    <span translate>Incoterms</span>: {{$ctrl.deal.paymentMethod}}\n                </div>\n            </div> --><div ng-if=$ctrl.deal.userBooking class=small><span translate>Ordered</span>: {{$ctrl.deal.userBooking}} {{$ctrl.deal.customUnit}}</div><div ng-if=$ctrl.deal.reservationOrder class=mt-1><span translate>Reserved</span>: <b>{{$ctrl.deal.reservationOrder.amount}}</b> <small>{{$ctrl.deal.customUnit}}</small><br><countdown caption="\'for:\'|translate" date-time=$ctrl.deal.reservationOrder.modifyTimeExpiresAt hide-seconds=true></countdown></div><div ng-if=!$ctrl.deal.reservationOrder><span class=text-warning translate>No reservations</span></div></div></div></div>');
$templateCache.put('app/app-commons/components/export-customers/export-customers.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-envelope-square"></i> <span translate>Export</span></h4><button type=button ng-click=$ctrl.cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class="modal-body p-4"><form name=$ctrl.form role=form autocomplete=off class="mt-10 p-0"><label for=selFormat translate>How many?</label><div class=row><div class=col-md-12><rzslider rz-slider-model=$ctrl.slider.value rz-slider-options=$ctrl.slider.options></rzslider></div></div><div class="row p-2"><div class="col p-1"><label for=selFormat translate>Select file format</label><select id=selFormat class=form-control name=selFormat data-ng-model=$ctrl.fileFormat ng-options="option as option.name for option in $ctrl.fileFormats"></select></div></div><div class=separator></div><button type=button ng-click=$ctrl.ok() class="btn btn-success col-12" ng-disabled="$ctrl.isExporting || $ctrl.slider.value <= 0"><i class="fa fa-check"></i> <span ng-if="$ctrl.slider.value < $ctrl.resolve.modalData.count" translate>Export last {{$ctrl.slider.value}}</span> <span ng-if="$ctrl.slider.value === $ctrl.resolve.modalData.count" translate>Export all</span></button></form></div>');
$templateCache.put('app/app-commons/components/export-orders/export-orders.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-envelope-square"></i> <span translate>Export Orders</span></h4><button type=button ng-click=$ctrl.cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class="modal-body p-4"><form name=$ctrl.form role=form autocomplete=off class="mt-10 p-0"><label for=selFormat translate>How many?</label><div class=row><div class=col-md-12 ng-show=$ctrl.slider><rzslider rz-slider-model=$ctrl.slider.value rz-slider-options=$ctrl.slider.options></rzslider></div></div><div class="row p-2"><div class="col p-1"><label for=selFormat translate>Select file format</label><select id=selFormat class=form-control name=selFormat data-ng-model=$ctrl.fileFormat ng-options="option as option.name for option in $ctrl.fileFormats"></select></div></div><div class=separator></div><button type=button ng-click=$ctrl.ok() class="btn btn-success col-12" ng-disabled="$ctrl.isExporting || $ctrl.slider.value <= 0"><i class="fa fa-check"></i> <span ng-if="$ctrl.slider.value < $ctrl.resolve.modalData.count" translate>Export last {{$ctrl.slider.value}}</span> <span ng-if="$ctrl.slider.value === $ctrl.resolve.modalData.count" translate>Export all</span></button></form></div>');
$templateCache.put('app/app-commons/components/extend-deal/extend-deal.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-envelope-square"></i> <span translate>Extend offer </span>"{{$ctrl.deal.productName}}"</h4><button type=button ng-click=$ctrl.cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class=modal-body><div class=mb-2><ul class="nav nav-tabs style-4" role=tablist><li class=nav-item ng-repeat="type in $ctrl.types"><a class=nav-link role=tab data-toggle=tab ng-class="{\'active\': $ctrl.isTypeName(type.name) }" ng-click=$ctrl.setTypeName(type.name)><i class="fa fa fa-{{type.icon}} pr-2"></i> {{type.label}}</a></li></ul></div><form name=$ctrl.form role=form autocomplete=off class="m-0 p-1"><div ng-if=$ctrl.isTypeName($ctrl.typeNames.BOOKING_END) class=row><div class=col-lg-5><div class="m-0 p-0"><small translate>Current offer end</small>:<br><span>{{$ctrl.utils.getLocalizedDateAndTime($ctrl.bookingEndCurrent)}}</span></div><div class="ml-0 mt-3 p-0" ng-class="{\'has-error\': !$ctrl.isNewBookingEndValid() }"><small translate>New offer end</small><div class=form-group><input-date-time value=$ctrl.deal.bookingEnd icon="\'fa-calendar\'"></input-date-time></div></div></div></div><div ng-if=$ctrl.isTypeName($ctrl.typeNames.DEAL_SIZE) class=row><div class=col-lg-5><div class="m-0 p-0"><small translate>Current items available</small>: <span>{{$ctrl.dealSizeCurrent}}</span></div><div class="ml-0 mt-3 p-0"><small translate>New items available</small><input-deal-size deal-size=$ctrl.deal.dealSize deal-size-options=$ctrl.deal.dealSizeOptions unit=$ctrl.deal.customUnit form=$ctrl.form deal-size-required=!$ctrl.isSale is-sale=$ctrl.isSale step-readonly=true></input-deal-size></div></div><div class=col><div ng-if="$ctrl.initialized && $ctrl.utils.isSupplierDistributor()" style="max-height: 500px; overflow: scroll"><deal-suppliers users=$ctrl.deal.users benchmark-price=$ctrl.deal.benchmarkPrice deal-size=$ctrl.deal.dealSize deal-size-options=$ctrl.deal.dealSizeOptions retail-prices=$ctrl.deal.retailPrices price-decimal-digits=$ctrl.deal.priceDecimalDigits hide-accounts=true hide-prices=true hide-supplier-selection=true></deal-suppliers></div></div></div><div ng-if=$ctrl.isTypeName($ctrl.typeNames.RETAIL_PRICES) class=row><div class=col-lg-9><div style="max-height: 500px; overflow: scroll"><deal-suppliers users=$ctrl.deal.users benchmark-price=$ctrl.deal.benchmarkPrice deal-size=$ctrl.deal.dealSize deal-size-options=$ctrl.deal.dealSizeOptions retail-prices=$ctrl.deal.retailPrices price-decimal-digits=$ctrl.deal.priceDecimalDigits hide-accounts=true hide-farm-settings=true></deal-suppliers></div></div></div><div class="separator mt-2 mb-5"></div><div ng-class="{\'has-error\': $ctrl.form.$submitted && $ctrl.form.message.$invalid }" class=row><div class=col-lg-4><input type=checkbox id=notifyCustomers ng-model=$ctrl.notifyCustomers class=switch-input><label for=notifyCustomers class=switch-label><span translate>Message for customers</span></label></div><div class=col><input class=form-control rows=2 name=message ng-model=$ctrl.message ng-if=$ctrl.notifyCustomers required><div ng-if=$ctrl.isTypeName($ctrl.typeNames.RETAIL_PRICES) class=mt-1><b translate>Only new customers will receive this message</b></div></div></div><div class="separator mt-5"></div><div class=row><div class=col-6><button type=button ng-click=$ctrl.cancel() class="btn btn-dark col-8" analytics-on=click analytics-event="Cancel publish" analytics-value={{$ctrl.deal._id}}><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button type=button ng-click=$ctrl.ok() class="btn btn-success col-8" ng-disabled=$ctrl.isLoading><i class="fa fa-notifyCustomers"></i> <span translate>Extend offer</span></button></div></div></form></div>');
$templateCache.put('app/app-commons/components/fh-captcha/captcha.tpl.html','<div vc-recaptcha theme="\'light\'" key=$ctrl.key on-create=$ctrl.onCreate(widgetId) on-success=$ctrl.onResponse(response) on-expire=$ctrl.onExpire()></div>');
$templateCache.put('app/app-commons/components/input-date-time/input-date-time.html','<div class="row m-0 p-0"><div class="input-group m-0 pl-0 pr-1" ng-class="{\'col-8\': !$ctrl.hideTime, \'col-12\': $ctrl.hideTime}"><span ng-if=$ctrl.iconClass class=input-group-addon><i class="fa {{$ctrl.iconClass}} text-primary"></i> </span><input id={{$ctrl.dateId}} name={{$ctrl.dateId}} type=text class=form-control ng-model=dateTime.date ng-disabled="$ctrl.ngDisabled || $ctrl.loading" ng-change=$ctrl.onChange()></div><div class="col-4 row m-0 p-0" ng-if=!$ctrl.hideTime><input id={{$ctrl.timeId}} name={{$ctrl.dateId}} type=text class=form-control ng-model=dateTime.time ng-disabled="$ctrl.ngDisabled || $ctrl.loading" ng-change=$ctrl.onChange()></div></div>');
$templateCache.put('app/app-commons/components/input-deal-size-directive/advanced-options-prompt.tpl.html','<div class="mt-5 mb-5"><div class="form-group row"><div class=col-5><span translate>Minimum bookable</span> <small uib-tooltip="{{\'Minimum quantity bookable by a single user\'|translate}}" tooltip-placement=right class=text-muted><i class="fa fa-question-circle-o"></i></small></div><div class="col-7 input-group"><input type=number name=dealSizeMin ng-model=$ctrl.dealSizeOptionsNew.min class=form-control min=0.1 step=0.1> <span class=input-group-addon>{{$ctrl.unit}}</span></div></div><div class="form-group row"><div class=col-5><span translate>Maximum bookable</span> <small uib-tooltip="{{\'Maximum quantity bookable by a single user\'|translate}}" tooltip-placement=right class=text-muted><i class="fa fa-question-circle-o"></i></small></div><div class="col-7 input-group"><input type=number name=dealSizeMax ng-model=$ctrl.dealSizeOptionsNew.max class=form-control min=0.1 step=0.1> <span class=input-group-addon>{{$ctrl.unit}}</span></div></div><div><button type=button class="btn btn-sm btn-warning" ng-click=$ctrl.resetMinMax()><span translate>Reset</span></button></div><br><br></div>');
$templateCache.put('app/app-commons/components/input-deal-size-directive/input-deal-size-directive.tpl.html','<div class=form-group><label class="row mr-0" for=dealSize><span class=col-4 ng-click=vm.editDealSizeOptions() uib-tooltip="{{\'Only multiple of this can be booked\'|translate}}"><span translate>Step</span> </span><span class=col-8><span ng-if=!$ctrl.isSale translate>Stock</span> <span ng-if=$ctrl.isSale translate>Quantity</span> <button type=button ng-if="!$ctrl.dealSizeRequired && $ctrl.dealSize" ng-click=$ctrl.clearDealSize() class="btn btn-sm btn-icon fa fa-times pb-0 pt-0 pl-3 pr-3 mt-0 mb-0"></button></span></label><div class="row p-0 m-0"><div class="col-4 p-0 m-0" ng-class="{\'has-error\': $ctrl.form.dealSizeStep.$invalid }"><input type=number class="form-control pr-1" name=dealSizeStep ng-model=$ctrl.dealSizeOptions.step step=0.01 ng-blur=$ctrl.checkDealSizeOptions() ng-required=$ctrl.dealSizeRequired ng-readonly=$ctrl.stepReadonly></div><div class="input-group col-8 p-0 m-0" style="padding-left: 3px!important" ng-class="{\'has-error\': $ctrl.form.dealSize.$invalid }"><input type=number class="form-control pr-0" name=dealSize ng-model=$ctrl.dealSize step=0.01 placeholder={{$ctrl.dealSizePlaceholder}} ng-blur=$ctrl.checkDealSizeOptions() ng-required=$ctrl.dealSizeRequired> <span class="input-group-addon pr-1 pl-1" style="font-size: 0.9rem">{{$ctrl.unit}}</span></div></div><div><button type=button tabindex=-1 class="btn btn-sm btn-link m-0 pt-0 pb-0" ng-click=$ctrl.openAdvancedSetting() ng-class="{\'text-primary\': $ctrl.isMinMaxSet(), \'text-muted\': !$ctrl.isMinMaxSet()}"><i class="fa fa-edit"></i> <span translate>Min</span>: {{$ctrl.dealSizeOptions.min}} <span ng-if=$ctrl.dealSizeOptions.max><span translate>Max</span>: {{$ctrl.dealSizeOptions.max}}</span></button></div><div class=text-danger ng-messages=$ctrl.form.dealSize.$error><small class=form-control-feedback ng-message=required translate>* Field is required</small> <small class=form-control-feedback ng-message=minlength translate>* Value must be a real number</small></div></div>');
$templateCache.put('app/app-commons/components/input-price-directive/input-price-directive.tpl.html','<div class=form-group><div class=input-group ng-class="{\'has-error\': $ctrl.form.originalPrice.$invalid }" ng-if=!$ctrl.allowFreeText><span class=input-group-addon>{{$root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}}</span> <input type=text id=benchmarkPrice name=originalPrice ng-model=$ctrl.deal.benchmarkPrice ng-change=$ctrl.priceChanged() class=form-control aria-describedby=benchmarkPrice ng-currency currency-symbol="" fraction="{{$ctrl.deal.priceDecimalDigits || 2}}" ng-required=!$ctrl.allowPriceOnRequest placeholder={{$ctrl.placeholder}} ng-disabled=$ctrl.disabled></div><div ng-if=$ctrl.allowFreeText><input type=text id=benchmarkPrice name=originalPrice ng-model=$ctrl.deal.benchmarkPrice ng-change=$ctrl.priceChanged() class=form-control aria-describedby=benchmarkPrice ng-required=!$ctrl.allowPriceOnRequest placeholder={{$ctrl.placeholder}} ng-disabled=$ctrl.disabled></div><div class="row mt-1" ng-if="$ctrl.deal.benchmarkPrice && !$ctrl.allowFreeText"><div class=col-6><a ng-click=$ctrl.switchVatIncluded()><span ng-if=$ctrl.deal.isVatIncluded class=text-warning><span translate>Incl. VAT</span> <i class="fa fa-toggle-on"></i> </span><span ng-if=!$ctrl.deal.isVatIncluded class=text-success><span translate>Excl. VAT</span> <i class="fa fa-toggle-off"></i></span></a></div><div class="col-6 text-right" uib-tooltip="{{\'Decimal digits\'|translate}}" tooltip-placement=bottom><button type=button tabindex=-1 class="btn btn-sm btn-outline-secondary m-0 pt-0 pb-0" ng-click=$ctrl.dealsService.decreasePriceDecimalDigits($ctrl.deal)><i class="fa fa-minus"></i></button> <button type=button tabindex=-1 class="btn btn-sm btn-outline-secondary m-0 pt-0 pb-0" ng-click=$ctrl.dealsService.increasePriceDecimalDigits($ctrl.deal)><i class="fa fa-plus"></i></button></div></div></div>');
$templateCache.put('app/app-commons/components/invite-customers/invite-customers.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-envelope-square"></i> <span translate>Invite new Customers</span> ({{$ctrl.payload.invitees.length}})</h4><button type=button ng-click=$ctrl.cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class="modal-body p-4"><div class="p-2 row" ng-if=$ctrl.utils.isSupplierDistributor()><div class=col-1><img ng-src={{$ctrl.supplier.imageUrl}} alt="" class="float-left mr-3" width=50></div><div class="col p-1"><b>{{$ctrl.supplier.name}}</b></div></div><div class=p-2 ng-if="!$ctrl.utils.isSupplierDistributor() && $ctrl.addBulkMode"><div><label translate>Add multiple phone numbers separated by comma and then click "Add all".</label><textarea class=form-control rows=2 placeholder="{{\'E.g. +431111111, 02222222, 3333333\'|translate}}" data-ng-model=$ctrl.bulkPhoneNumbers>&nbsp;</textarea></div><div class="col-12 text-center"><button ng-click="$ctrl.addBulkMode = false;" class="btn btn-sm btn-outline-dark m-0"><span translate>Cancel</span></button> <button ng-click="$ctrl.bulkAddPhoneNumbers(); $ctrl.addBulkMode = false;" class="btn btn-sm btn-outline-primary m-0" ng-disabled=!$ctrl.bulkPhoneNumbers><i class="fa fa-plus-circle"></i> <span translate>Add all</span></button></div></div><form name=$ctrl.form role=form autocomplete=off class="m-0 p-0"><div class="row p-2" ng-if=!$ctrl.addBulkMode><div class=col-md-12 style="max-height: 250px; overflow: scroll"><div class="row p-0 m-0" ng-repeat="invitee in $ctrl.payload.invitees" ng-if=$ctrl.utils.isSupplierDistributor()><div class="col-8 px-1" ng-class="{\'has-error\': $ctrl.form[\'cont-\'+$index+\'-email\'].$invalid || invitee.existingCustomer }" ng-if=$ctrl.utils.isSupplierDistributor()><input name=cont-{{$index}}-email type=email class=form-control data-ng-model=invitee.email placeholder="{{\'Email\'|translate}}" required autofocus></div></div><div class="row p-0 mb-1" ng-repeat="invitee in $ctrl.payload.invitees" ng-if=!$ctrl.utils.isSupplierDistributor()><div class="col-1 p-2 hidden-md-down">{{$index + 1}}.</div><div class="px-1 col-lg-2 col-4"><select class="form-control m-0" style="text-align-last: right" ng-model=invitee.ext ng-options="c.phonePrefix as (c.phonePrefix) for c in $ctrl.countriesData"></select></div><div class="col-lg-4 col-6 px-1" ng-class="{\'has-error\': $ctrl.form[\'cont-\'+$index+\'-phone\'].$invalid || invitee.existingCustomer }"><input name=cont-{{$index}}-phone type=tel class=form-control data-ng-model=invitee.phoneNumber placeholder="{{\'Phone number\'|translate}}" minlength={{$ctrl.MIN_PHONE_NUMBER_LENGTH}} ng-model-options="{ debounce: 500 }" ng-change=$ctrl.checkPhoneNumber(invitee) required autofocus></div><div class="text-center list-del-btn col-1 pl-1"><button ng-click="$ctrl.removeItem(invitee, $index)" class="btn btn-link p-0"><i class="fa fa-times-circle text-danger"></i></button></div><div class="col-12 col-lg-3 pl-1 pt-0 pb-0 text-danger text-center small" ng-if=invitee.existingCustomer><span translate>Already existing customer</span> ({{invitee.existingCustomer.name.first}}&nbsp;{{invitee.existingCustomer.name.last}})</div></div></div><div class="col-12 text-right p-3" ng-if=!$ctrl.utils.isSupplierDistributor()><button ng-click=$ctrl.addItem() class="btn btn-outline-primary btn-sm m-0"><i class="fa fa-plus-circle"></i> <span translate>Add one more</span></button> <button ng-click="$ctrl.addBulkMode = true" class="btn btn-sm btn-outline-primary m-0 hidden-md-down"><i class="fa fa-list"></i> <span translate>Add multiple entries</span></button></div></div><div class="mt-3 mb-3"><div class=row ng-if=$ctrl.utils.isUserRegionalManager()><div class=col-md-6 ng-if=$ctrl.utils.isSupplierDistributor()><input type=checkbox id=sendEmail ng-model=$ctrl.payload.sendEmail class=switch-input ng-disabled="$ctrl.payload.invitees.length !== 1"><label for=sendEmail class=switch-label><i class="fa fa-envelope"></i> <span translate>Send email to customers</span></label></div><div class=col-md-6 ng-if=!$ctrl.utils.isSupplierDistributor()><input type=checkbox id=sendSms ng-model=$ctrl.payload.sendSms class=switch-input ng-disabled="$ctrl.payload.invitees.length !== 1"><label for=sendSms class=switch-label><i class="fa fa-comment"></i> <span translate>Send SMS to customers</span></label></div></div><div><label translate>Your message</label>:<textarea class="form-control text-info" data-ng-model=$ctrl.payload.message rows=4 maxlength=250 required></textarea><p class="small text-muted"><span translate>Message length:</span> <b>{{$ctrl.payload.message.length || 0}} / 250</b>. <span translate>A link like "https://farmhedge.ie" will be automatically added to the message.</span></p></div></div><div class="alert alert-info mt-3 mb-3" ng-if="!$ctrl.payload.sendSms && $ctrl.inviteData"><p><span translate>Share the following link with {{$ctrl.inviteData.phoneNumber}}</span></p><p><a href=https://{{$ctrl.inviteData.urlShort}} target=_blank>{{$ctrl.inviteData.urlShort}}</a></p></div><div class="row mt-2"><div class=col-6><button id=cancelButton type=button ng-click=$ctrl.cancel() class="btn btn-dark col-lg-8" analytics-on=click analytics-event="Cancel operation"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-lg-6 text-right"><button id=okButton type=button ng-click=$ctrl.ok() class="btn btn-success col-12" data-dismiss=modal ng-disabled="!$ctrl.getValidInviteesCount() || $ctrl.loading" analytics-on=click analytics-event="Invite customers"><i class="fa fa-check"></i> <span ng-if="$ctrl.payload.sendSms && !$ctrl.payload.sendEmail" translate>Send SMS to customers</span> <span ng-if="!$ctrl.payload.sendSms && $ctrl.payload.sendEmail" translate>Send email to customers</span> <span ng-if="!$ctrl.payload.sendSms && !$ctrl.payload.sendEmail" translate>Generate invite</span> <span ng-if="$ctrl.payload.sendSms && $ctrl.payload.sendEmail" translate>Send SMS and email to customers</span> ({{$ctrl.getValidInviteesCount()}})</button></div></div></form></div>');
$templateCache.put('app/app-commons/components/new-order/new-order-select-variant.tpl.html','<div class="row mr-2 pr-3 pl-3 pt-3" style="border-bottom: solid 1px lightgrey"><div class=col-md-1></div><div class="col-md-8 font-weight-bold" translate>Product</div><div class="col-md-3 font-weight-bold text-right"><span translate>Price</span> / {{variantCtrl.unit}}</div></div><div class="row row-clickable ml-2 mr-2 p-2" ng-click="variantCtrl.selectedVariant = v" style="border-bottom: solid 1px lightgrey" ng-repeat="v in variantCtrl.variants track by $index" ng-class="{\'row-selected\': variantCtrl.selectedVariant.product === v.product}"><div class="col-md-1 pt-2 pl-1"><i class="fa fa-check-circle text-success" ng-if="variantCtrl.selectedVariant.product === v.product" style="font-size: 200%"></i></div><div class=col-md-8>{{v.productName}}<br><small>{{v.vendorProductId}}</small></div><div class="col-md-3 text-right">{{v.benchmarkPrice | currency: variantCtrl.currencySymbol}}</div></div>');
$templateCache.put('app/app-commons/components/new-order/new-order.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-envelope-square"></i> <span translate>New order</span></h4><button type=button ng-click=$ctrl.cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class=modal-body><div class=col-md-12><form name=$ctrl.form role=form autocomplete=off class="m-0 p-0"><div class=row><div class=col-md-6><h5>{{$ctrl.selectedVariant.productName}}</h5><div ng-if=$ctrl.deal.selectedProduct.vendorProductId class="m-0 p-0"><span translate>Product ID</span>: {{ctrl.selectedVariant.vendorProductId}}</div><div>{{$ctrl.deal.customType}}</div><div><strong><span ng-if=$ctrl.dealsService.isCategoryCrop($ctrl.deal) translate>Buyer:</span> <span ng-if=!$ctrl.dealsService.isCategoryCrop($ctrl.deal) translate>Seller:</span> {{$ctrl.deal.supplier.name}}</strong></div><div class="m-0 p-0" ng-if=ctrl.deal.bookingEnd><countdown caption="\'Offer ends in:\'|translate" date-time=$ctrl.deal.bookingEnd></countdown><div class=small>{{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.bookingEnd)}}</div><div class="mt-10 p-0" ng-if=$ctrl.deal.isExpired><span translate>Expired</span></div></div><div class=mt-2 ng-if=$ctrl.deal.deliveryStart><div><i class="text-warning fa fa-truck"></i> <span translate>Delivery period</span></div><div>{{$ctrl.utils.getLocalizedDate($ctrl.deal.deliveryStart)}} - {{$ctrl.utils.getLocalizedDate($ctrl.deal.deliveryEnd)}}</div></div><div class=mt-2 ng-if=$ctrl.request class=text-info><i><span translate>Requested</span>: {{$ctrl.request.quantity}} {{$ctrl.deal.customUnit}}</i></div></div><div class=col-md-6 id=quantity><div class=mb-4><h5 translate>Distributor price</h5><h5 class=mb-0>{{$ctrl.utils.getLocalizedCurrency($ctrl.selectedVariant.benchmarkPrice, $ctrl.deal.priceDecimalDigits)}} <span class=small>/ {{$ctrl.deal.customUnit}}</span></h5><div><span ng-if=!$ctrl.deal.isVatIncluded translate>Excl. VAT</span> <span ng-if=$ctrl.deal.isVatIncluded><span translate>Incl. VAT</span><span ng-if=$ctrl.deal.vatRate>&nbsp;({{$ctrl.deal.vatRate*100|number:1}}%)</span> </span><span ng-if=$ctrl.deal.paymentMethod>- <span translate>Incoterms</span>: {{$ctrl.deal.paymentMethod}}</span></div></div><div class=row><div class=col-md-12><h5><span translate>Quantity</span> <span class=small>({{$ctrl.deal.customUnit}})</span></h5></div><div class="col-3 text-center"><button type=button class="btn btn-info fa fa-minus m-0" style=width:100% ng-click=$ctrl.decreaseAmount() ng-disabled=!$ctrl.canChangeAmount()></button></div><div class=col-6><input id=currentBooking name=currentBooking autocomplete=off autofocus type=number class=form-control formcontrolname=currentBookingInput ng-model=$ctrl.order.amount ng-blur=$ctrl.checkAmount() placeholder="{{gettextCatalog.getString(\'Quantity\')}}" class=form-control tabindex=1 ng-disabled=!$ctrl.canChangeAmount()></div><div class="col-3 text-center"><button type=button class="btn btn-info fa fa-plus m-0" style=width:100% ng-click=$ctrl.increaseAmount() ng-disabled=!$ctrl.canChangeAmount()></button></div></div><div class="small font-italic text-center" ng-if=$ctrl.canChangeAmount()><span ng-if="$ctrl.getMinAmount() !== 1" class=pr-2><span translate>Min</span>: {{$ctrl.getMinAmount()}}; </span><span ng-if="$ctrl.deal.dealSizeOptions.step !== 1" class=pr-2><span translate>Step</span>: {{$ctrl.deal.dealSizeOptions.step}}; </span><span ng-if="$ctrl.getMaxAmount() < 99999" class=pr-2><span translate>Max</span>: {{$ctrl.getMaxAmount()}};</span></div></div></div><div class="mt-2 separator-2"></div><div class="row mt-3"><div class=col-md-6><div><h5><i class="fa fa-book"></i> <span translate>Billing info</span></h5></div><div><div class=form-group ng-class="{\'has-error\': $ctrl.form.n1.$invalid && $ctrl.form.$submitted }"><label for=billAddress style="width: 100%"><span translate>Name</span> <a class="small btn btn-sm btn-link p-0 ml-3 mb-0 mt-0 text-muted pull-right" ng-click=$ctrl.copyCollectionPoint() ng-if="$ctrl.order.billingAddress.name && !$ctrl.dealsService.isCategoryCrop($ctrl.deal)"><small translate>Copy</small> <i class="fa fa-arrow-right"></i></a></label><input id=billAddress name=billingAddressName type=text class=form-control data-ng-model=$ctrl.order.billingAddress.name placeholder="{{\'Name\'|translate}}" uib-typeahead="opt as (opt.name + \'<br><small>\' + opt.address + \'</small>\') for opt in $ctrl.billingOpts | filter: $viewValue" typeahead-on-select=$ctrl.setBillingData($item) typeahead-show-hint-on-focus=all typeahead-min-length=0 tabindex=2 autocomplete=off required></div><div class=form-group ng-class="{\'has-error\': $ctrl.form.street1.$invalid && $ctrl.form.$submitted }"><label style="width: 100%"><span translate>Address</span> <a class="small btn btn-sm btn-link p-0 ml-3 mb-0 mt-0 text-muted pull-right" ng-click=$ctrl.copyBillingAddress() ng-if="$ctrl.order.billingAddress.street && !$ctrl.dealsService.isCategoryCrop($ctrl.deal)"><small translate>Copy</small> <i class="fa fa-arrow-right"></i></a></label><textarea name=street1 type=text class=form-control data-ng-model=$ctrl.order.billingAddress.street rows=2 placeholder="{{\'Street\'|translate}}" tabindex=3 autocomplete=off required>\n                            </textarea></div><div class=row><div class="form-group col-md-4" ng-class="{\'has-error\': $ctrl.form.zipcode1.$invalid && $ctrl.form.$submitted }"><input name=zipcode1 type=text class=form-control data-ng-model=$ctrl.order.billingAddress.zipcode placeholder="{{\'Zip code\'|translate}}" tabindex=4 autocomplete=off required></div><div class="form-group col-md-8" ng-class="{\'has-error\': $ctrl.form.city1.$invalid && $ctrl.form.$submitted }"><input name=city1 type=text class=form-control data-ng-model=$ctrl.order.billingAddress.city placeholder="{{\'City\'|translate}}" tabindex=5 autocomplete=off required></div></div></div></div><div class="col-md-6 m-0 p-0" ng-if=!$ctrl.dealsService.isCategoryCrop($ctrl.deal)><div class=col-md-12><h5><i class="fa fa-truck"></i> <span translate>Delivery Info</span></h5></div><div class=col-md-12><div class=row><div class="form-group col-md-6 pr-0" ng-class="{\'has-error\': $ctrl.form.n2.$invalid && $ctrl.form.$submitted }"><label translate>Name</label><input name=n2 type=text class=form-control data-ng-model=$ctrl.order.deliveryAddress.name placeholder="{{\'Name\'|translate}}" tabindex=6 autocomplete=off uib-typeahead="cust.fullName for cust in $ctrl.getCustomers($viewValue)" typeahead-loading=$ctrl.loadingCustomers typeahead-show-hint-on-focus=all typeahead-min-length=0 typeahead-template-url=customer-typeahead.tpl.html typeahead-on-select=$ctrl.customerSelected($item) required></div><div class="form-group col-md-6" ng-class="{\'has-error\': $ctrl.form.pn.$invalid && $ctrl.form.$submitted }"><label translate>Phone number RA</label><input name=pn type=text class=form-control data-ng-model=$ctrl.order.phoneNumber uib-typeahead="cust.phoneNumber for cust in $ctrl.getCustomers(null, $viewValue)" typeahead-loading=$ctrl.loadingCustomers typeahead-show-hint-on-focus=all typeahead-min-length=0 typeahead-template-url=customer-typeahead.tpl.html typeahead-on-select=$ctrl.customerSelected($item) placeholder="{{\'Phone number\'|translate}}" tabindex=6 autocomplete=off></div></div><div class=form-group ng-class="{\'has-error\': $ctrl.form.street2.$invalid && $ctrl.form.$submitted }"><label><span translate>Address</span></label><textarea name=street2 type=text class=form-control data-ng-model=$ctrl.order.deliveryAddress.street rows=2 placeholder="{{\'Street\'|translate}}" tabindex=7 autocomplete=off required>\n                            </textarea></div><div class=row><div class="form-group col-md-4 pr-0" ng-class="{\'has-error\': $ctrl.form.zipcode2.$invalid && $ctrl.form.$submitted }"><input name=zipcode2 type=text class=form-control data-ng-model=$ctrl.order.deliveryAddress.zipcode placeholder="{{\'Zip code\'|translate}}" tabindex=8 autocomplete=off required></div><div class="form-group col-md-8" ng-class="{\'has-error\': $ctrl.form.city2.$invalid && $ctrl.form.$submitted }"><input name=city2 type=text class=form-control data-ng-model=$ctrl.order.deliveryAddress.city placeholder="{{\'City\'|translate}}" tabindex=9 autocomplete=off required></div></div></div></div></div><div class="mt-2 mb-2 separator-2"></div><div class="mt-5 mb-5"><div class=row><div class=col-6><h6><i class="fa fa-comment"></i> <span translate>Message for</span> {{$ctrl.deal.supplier.name}}</h6><textarea name=notes ng-model=$ctrl.order.userNotes id=orderNotes class=form-control cols=200 rows=2 tabindex=10> </textarea></div><div class=col-6 ng-if=$ctrl.user><h6><i class="fa fa-comment"></i> <span translate>Message for</span> {{$ctrl.user.name.first}} {{$ctrl.user.name.last}}</h6><textarea name=notes ng-model=$ctrl.order.messageForCustomer id=orderNotes class=form-control cols=200 rows=2 tabindex=11> </textarea></div></div></div><div class=row><div class=col-md-8><input type=checkbox id=hasAgreedTerms ng-model=$ctrl.hasAgreedTerms class=switch-input ng-class="{\'text-danger\': !$ctrl.hasAgreedTerms }"><label for=hasAgreedTerms class=switch-label ng-class="{\'text-danger\': !$ctrl.hasAgreedTerms }"><span translate>I understand this is a legally binding transaction.</span></label></div><div class="col-md-4 text-right"><div class=font-weight-bold><div ng-if=$ctrl.order.amount>{{$ctrl.order.amount}} {{$ctrl.deal.customUnit}}</div><div ng-if=$ctrl.utils.isNumber($ctrl.selectedVariant.benchmarkPrice)><span translate>Total</span>: {{$ctrl.utils.getLocalizedCurrency($ctrl.selectedVariant.benchmarkPrice * $ctrl.order.amount)}}</div></div><div><span ng-if=!$ctrl.deal.isVatIncluded translate>Excl. VAT</span> <span ng-if=$ctrl.deal.isVatIncluded><span translate>Incl. VAT</span><span ng-if=$ctrl.deal.vatRate>&nbsp;({{$ctrl.deal.vatRate*100|number:1}}%)</span> </span><span ng-if=$ctrl.deal.paymentMethod>- <span translate>Incoterms</span>: {{$ctrl.deal.paymentMethod}}</span></div></div></div><div class=separator></div><div class=row><div class=col-6><button id=cancelButton type=button ng-click=$ctrl.cancel() class="btn btn-dark col-8" analytics-on=click analytics-event="Cancel operation"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button id=okButton type=button ng-click=$ctrl.ok() class="btn btn-success col-12" data-dismiss=modal analytics-on=click analytics-event="Confirm operation"><i class="fa fa-check"></i> <span translate>Confirm and Place order</span></button></div></div></form></div></div><script type=text/ng-template id=customer-typeahead.tpl.html><a class=" m-0 p-0">\n        <div><span ng-bind-html="match.model.fullName | uibTypeaheadHighlight:query"></span></div>\n        <div class="row small">\n            <div class="col push-1">\n                <div><span ng-bind-html="match.model.phoneNumber | uibTypeaheadHighlight:query"></span></div>\n                <div ng-if="match.model.supplierCustomers[0].collectionPointName">{{match.model.supplierCustomers[0].collectionPointName.replace(\'Lagerhaus\', \'LH\')}}</div>\n            </div>\n        </div>\n    </a></script>');
$templateCache.put('app/app-commons/components/new-request/new-request.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-comment"></i> <span translate>New request</span></h4><button type=button ng-click=$ctrl.cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class=modal-body><div class=col-md-12><form name=$ctrl.form role=form autocomplete=off class="m-0 p-0"><div class=mb-4 ng-class="{\'has-error\': !$ctrl.request.suppliers || !$ctrl.request.suppliers[0] }"><label><span translate>Send request to</span></label><div ng-if=$ctrl.suppliers><select class=form-control data-ng-model=$ctrl.request.suppliers[0] required ng-options="supplier._id as supplier.name for supplier in $ctrl.suppliers"></select></div></div><div class="row mb-4 pr-0 pl-0"><div class=col-md-4><label><span translate>Request type</span></label><select class=form-control data-ng-model=$ctrl.request.content[0] ng-options="rt as rt for rt in $ctrl.lookup.requestTypes"></select></div><div class=col-md-8><div class=mb-2 ng-if=$ctrl.request.product><label><span translate>Product</span></label><h4>{{$ctrl.request.product.name}}</h4><div class=small><ul><li>{{$ctrl.deal.customType}}</li><li ng-if=$ctrl.deal.vendorProductId><span translate>Product Id</span>: {{$ctrl.deal.vendorProductId}}</li><li ng-repeat="attr in $ctrl.deal.productAttributes">{{attr.label}}:&nbsp;{{attr.value}}</li></ul></div></div><div class=mb-4 ng-if=!$ctrl.request.product ng-class="{\'has-error\': !$ctrl.request.category }"><label><span translate>Product/Category</span></label><input type=text id=category name=category class=form-control ng-model=$ctrl.request.category aria-describedby=category uib-typeahead="type for type in $ctrl.lookup.categories | filter:$viewValue | limitTo:10" typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0 placeholder="{{\'Start typing...\'|translate}}" ng-change=$ctrl.categoryNameChanged() required></div></div></div><div class=mb-4 id=quantity><div class=row><div class=col-md-12><h5><span translate>Quantity</span><!-- <span ng-if="$ctrl.deal.customUnit" class="small">({{$ctrl.deal.customUnit}})</span> --></h5></div><div class="col-3 text-center"><button type=button class="btn btn-info fa fa-minus m-0" style=width:100% ng-click=$ctrl.decreaseAmount() ng-disabled=!$ctrl.canChangeAmount()></button></div><div class=col-6><input id=currentBooking name=currentBooking autocomplete=off autofocus type=number class=form-control formcontrolname=currentBookingInput ng-model=$ctrl.request.amount ng-blur=$ctrl.checkAmount() placeholder="{{gettextCatalog.getString(\'Quantity\')}}" class=form-control tabindex=1 ng-disabled=!$ctrl.canChangeAmount()></div><div class="col-3 text-center"><button type=button class="btn btn-info fa fa-plus m-0" style=width:100% ng-click=$ctrl.increaseAmount() ng-disabled=!$ctrl.canChangeAmount()></button></div></div><div class="small font-italic text-center" ng-if=$ctrl.canChangeAmount()><span ng-if="$ctrl.getMinAmount() !== 1" class=pr-2><span translate>Min</span>: {{$ctrl.getMinAmount()}}; </span><span ng-if="$ctrl.deal.dealSizeOptions.step !== 1" class=pr-2><span translate>Step</span>: {{$ctrl.deal.dealSizeOptions.step}}; </span><span ng-if="$ctrl.getMaxAmount() < 99999" class=pr-2><span translate>Max</span>: {{$ctrl.getMaxAmount()}};</span></div></div><div class="row mb-4 pr-0 pl-0"><div class=col-md-6><label><span translate>Unit</span></label><input type=text id=unit name=unit class=form-control ng-model=$ctrl.request.unit aria-describedby=unit uib-typeahead="unit for unit in $ctrl.lookup.units | filter:$viewValue" typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0 ng-change=$ctrl.categoryNameChanged() required></div><div class=col-md-6><label><span translate>Distribution</span></label><select class=form-control data-ng-model=$ctrl.request.distribution ng-options="dist.value as dist.label for dist in $ctrl.lookup.distributionMethods"></select></div></div><div class="row mt-1"><div class="col-12 mt-2"><h5><i class="fa fa-comment"></i> <span translate>Message</span></h5></div><div class="form-group col-md-12"><textarea name=message ng-model=$ctrl.request.message id=orderNotes class=form-control cols=200 rows=2 tabindex=10> </textarea></div></div><div class=separator></div><div class=row><div class=col-6><button id=cancelButton type=button ng-click=$ctrl.cancel() class="btn btn-dark col-8" analytics-on=click analytics-event="Cancel operation"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button id=okButton type=button ng-click=$ctrl.ok() class="btn btn-success col-12" data-dismiss=modal><i class="fa fa-check"></i> <span translate>Send request</span></button></div></div></form></div></div><script type=text/ng-template id=typeahead.tpl.html><a tabindex="-1" class="typeahead-general p-1">\n        {{match.model}}\n    </a></script>');
$templateCache.put('app/app-commons/components/order-details-directive/order-details-directive.tpl.html','<div class="container order panel-body"><div class=row ng-if=!$ctrl.childrenOrders><div class="col-lg-2 col-sm-6 pr-0 pt-2 pb-2"><img ng-src={{$ctrl.deal.imageUrl}} style="max-height: 50px"></div><div class="col-lg-10 col-sm-12"><h5 class="pb-0 mb-0">{{$ctrl.order.product.name || $ctrl.deal.productName}}</h5><div><span ng-if=$ctrl.dealsService.isCategoryCrop($ctrl.deal)><span class=font-weight-bold translate>Origin &amp; Year</span>:</span> {{$ctrl.deal.customType}}</div><div ng-if=$ctrl.deal.vendorProductId><span translate>Product Id</span>: {{$ctrl.order.product.vendorProductId}}</div><div class="small mt-2" ng-if=$ctrl.deal.productAttributes><div class=row><div ng-repeat="attr in $ctrl.deal.productAttributes" class="col-6 pr-0"><span class=text-muted>{{attr.label}}:</span>&nbsp;<b>{{attr.value}}</b></div></div></div></div></div><div id=order-details-container ng-if=$ctrl.childrenOrders><table class=table><thead><tr class=small><th width=30%><span translate>Product</span></th><th><span translate>Details</span></th><th class=text-right><span translate>Unit price</span></th><th class=text-right><span translate>Units</span></th><th class=text-right><span translate>Total price</span></th></tr></thead><tbody><tr ng-repeat="childOrder in $ctrl.childrenOrders"><td><div><b>{{childOrder.productName}}</b></div><div class=small><i>{{childOrder.customType}}</i></div><div class=small>{{childOrder.vendorProductId}}</div></td><td class=small><div ng-if=childOrder.paymentMethod><span translate>Incoterms</span>: <b>{{childOrder.paymentMethod}}</b></div><div ng-repeat="attr in childOrder.productAttributes"><span class=text-muted>{{attr.label}}:</span>&nbsp;<b>{{attr.value}}</b></div><div ng-repeat="attachment in childOrder.attachments"><a href={{attachment.url}} target=_blank download><i class="fa fa-paperclip"></i> {{attachment.name}}</a></div></td><td class=text-right><div ng-if=childOrder.unitPrice>{{$ctrl.utils.getLocalizedCurrency(childOrder.unitPrice || (childOrder.totalPrice / childOrder.amount), $ctrl.order.priceDecimalDigits || $ctrl.deal.priceDecimalDigits)}}<div class=small>/ {{childOrder.customUnit}}</div></div><div ng-if="!childOrder.unitPrice && childOrder.unitPriceText">{{childOrder.unitPriceText}}</div><div ng-if="!childOrder.unitPrice && !childOrder.unitPriceText"><span translate>Price as agreed</span></div></td><td class=text-right>{{childOrder.amount}}<div class=small>{{childOrder.customUnit}}</div></td><td class=text-right><div ng-if=childOrder.totalPrice>{{$ctrl.utils.getLocalizedCurrency(childOrder.totalPrice || (childOrder.amount * childOrder.unitPrice))}}<div><span ng-if=!childOrder.isVatIncluded class=small translate>Excl. VAT</span> <span ng-if=$childOrder.isVatIncluded class=small translate>Incl. VAT</span></div></div><div ng-if=!childOrder.totalPrice><span translate>Price as agreed</span></div></td></tr></tbody><tfoot ng-if="$ctrl.childrenOrders.length > 1"><tr><td colspan=4><span ng-if="$ctrl.childrenOrders.length === 1">1 <span translate>item</span><br></span><span ng-if="$ctrl.childrenOrders.length > 1">{{$ctrl.childrenOrders.length}} <span translate>items</span></span></td><td class=text-right><div ng-if="$ctrl.order.totalPrice || $ctrl.order.unitPrice"><span translate>Total</span>: <b>{{$ctrl.utils.getLocalizedCurrency($ctrl.order.totalPrice)}}</b></div></td></tr></tfoot></table></div><div class="row mt-2"><div class="col-lg-6 pr-0"><h5 class=order-section-header translate>Order details</h5><ul class=order-section-table><li><div class=row><div class="col-lg-5 font-weight-bold"><span ng-if=$ctrl.dealsService.isCategoryCrop($ctrl.deal)><span translate>Buyer</span></span> <span ng-if=!$ctrl.dealsService.isCategoryCrop($ctrl.deal)><span translate>Seller</span></span></div><div class=col-lg-7>{{$ctrl.order.supplier.name}}</div></div></li><li><div class=row><div class="col-lg-5 font-weight-bold" translate>Order ID</div><div class=col-lg-7>{{$ctrl.order.ref}}</div></div></li><li><div class=row><div class="col-lg-5 font-weight-bold" translate>Order date</div><div class=col-lg-7>{{$ctrl.utils.getLocalizedDateAndTime($ctrl.order.date)}}</div></div></li><!-- <li>\n                    <div class="row">\n                        <div class="col-lg-5 font-weight-bold" translate>Order type</div>\n                        <div class="col-lg-7" ng-if="!$ctrl.order.isPurchase" translate>Sale</div>\n                        <div class="col-lg-7" ng-if="$ctrl.order.isPurchase" translate>Purchase</div>\n                    </div>\n                </li> --><li ng-if=!$ctrl.childrenOrders><div class=row><div class="col-lg-5 font-weight-bold" translate>Price</div><div class=col-lg-7><div ng-if="">{{$ctrl.utils.getLocalizedCurrency($ctrl.order.unitPrice, $ctrl.order.priceDecimalDigits || $ctrl.deal.priceDecimalDigits)}}&nbsp;/&nbsp; {{$ctrl.dealsService.getUpdatedUnit($ctrl.deal.customUnit)}}</div></div></div></li><li ng-if=!$ctrl.childrenOrders><div class=row><div class="col-lg-5 font-weight-bold" translate>Quantity</div><div class=col-lg-7>{{$ctrl.order.amount}}</div></div></li><li ng-if=!$ctrl.childrenOrders><div class=row><div class="col-lg-5 font-weight-bold" translate>Total price</div><div class=col-lg-7><span>{{$ctrl.utils.getLocalizedCurrency($ctrl.order.totalPrice || ($ctrl.order.unitPrice * $ctrl.order.amount) || $ctrl.order.transactionAmount)}}</span><div><span ng-if=!$ctrl.deal.isVatIncluded class=small translate>Excl. VAT</span> <span ng-if=$ctrl.deal.isVatIncluded class=small translate>Incl. VAT</span></div></div></div></li></ul></div><div class=col-lg-6><h5 class=order-section-header><span translate>Customer</span> <span ng-if=$ctrl.dealsService.isCategoryCrop($ctrl.deal)>(<span translate>Seller</span>)</span> <span ng-if=!$ctrl.dealsService.isCategoryCrop($ctrl.deal)>(<span translate>Buyer</span>)</span></h5><ul class=order-section-table><li ng-if=$ctrl.order.retailer.name>{{$ctrl.order.retailer.name}}</li><li>&nbsp; <i class="fa fa-user"></i> {{$ctrl.order.user.name.first}} {{$ctrl.order.user.name.last}}</li><li>&nbsp; <i class="fa fa-envelope"></i> {{$ctrl.order.user.email}}</li><li ng-if=$ctrl.order.user.phoneNumber>&nbsp; <i class="fa fa-phone"></i> {{$ctrl.order.user.phoneNumber}}</li><li ng-if=!$ctrl.order.retailer><div class=row><div class="col-lg-5 font-weight-bold" translate>Customer ID</div><div class=col-lg-7>{{$ctrl.order.user.customerId || \'---\'}}</div></div></li><li ng-if=!$ctrl.order.retailer><div class=row><div class="col-lg-5 font-weight-bold" translate>VAT number</div><div class=col-lg-7>{{$ctrl.order.user.vatNumber || \'---\'}}</div></div></li><li class=mt-2 ng-if=$ctrl.order.userNotes><div class=row><div class="col-lg-12 font-weight-bold"><span translate>Notes</span>:</div><div class="col-lg-12 text-primary"><sup><i class="fa fa-quote-left"></i></sup> <span class=incoming-offers-description>{{$ctrl.order.userNotes}}</span> <sub><i class="fa fa-quote-right"></i></sub></div></div></li></ul></div></div><ul class=order-section-table ng-if=$ctrl.dealsService.isCategoryCrop($ctrl.deal)><li><div class=font-weight-bold><span translate>Crop quality</span></div><div>{{$ctrl.deal.cropQuality}}</div></li></ul><div class=row><div class="col-lg-6 pr-0"><h5 class=order-section-header><div ng-if=!$ctrl.dealsService.isDistributionCollection($ctrl.deal)><i class="fa fa-truck"></i> <span translate>Delivery</span></div><div ng-if=$ctrl.dealsService.isDistributionCollection($ctrl.deal)><i class="fa fa-home"></i> <span translate>Collection</span></div></h5><ul class="order-section-table mb-0 pb-0"><li ng-if=$ctrl.deal.deliveryStart><div class=row><div class="col-lg-5 font-weight-bold" translate>From</div><div class=col-lg-7>{{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.deliveryStart)}}</div></div></li><li ng-if=$ctrl.deal.deliveryEnd><div class=row><div class="col-lg-5 font-weight-bold" translate>Until</div><div class=col-lg-7>{{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.deliveryEnd)}}</div></div></li><li ng-if=$ctrl.deal.paymentMethod><div class=row><div class="col-lg-5 font-weight-bold" translate>Incoterms</div><div class=col-lg-7>{{$ctrl.deal.paymentMethod}}</div></div></li><li ng-if=$ctrl.order.phoneNumber><div class=row><div class="col-lg-5 font-weight-bold" translate>Phone number RA</div><div class=col-lg-7>{{$ctrl.order.phoneNumber}}</div></div></li></ul><ul class="order-section-table mb-0 pb-0" ng-if=$ctrl.dealsService.isCategoryCrop($ctrl.deal)><li><div class=row><div class="col-lg-12 font-weight-bold"><span translate>Delivery address</span>&nbsp;({{$ctrl.deal.collectionPoints.length}})</div><div class=col-lg-12 style="max-height: 100px; overflow: scroll"><div ng-repeat="deliveryLocation in $ctrl.deal.deliveryLocation.split(\'\\u2022 OR \\u2022\')">&#8226; {{deliveryLocation}}</div></div></div></li><li><div class=row><div class="col-lg-12 font-weight-bold" translate>Billing address</div><div class=col-lg-12><div ng-if=$ctrl.order.billingAddress.name>{{$ctrl.order.billingAddress.name}}</div><div>{{$ctrl.order.billingAddress.street}}</div><div>{{$ctrl.order.billingAddress.zipcode}} {{$ctrl.order.billingAddress.city}}</div></div></div></li></ul><div class="row mt-0" ng-if=!$ctrl.dealsService.isCategoryCrop($ctrl.deal)><div class=col-lg-6><ul class="order-section-table mb-0 pb-0"><li ng-if="!$ctrl.dealsService.isCategoryCrop($ctrl.deal) && !$ctrl.dealsService.isDistributionCollection($ctrl.deal) && $ctrl.order.deliveryAddress"><div class=row><div class="col-lg-12 font-weight-bold" translate>Delivery address</div><div class=col-lg-12 ng-if=!$ctrl.dealsService.isCategoryCrop($ctrl.deal)><div ng-if=$ctrl.order.deliveryAddress.name>{{$ctrl.order.deliveryAddress.name}}</div><div>{{$ctrl.order.deliveryAddress.street}}</div><div>{{$ctrl.order.deliveryAddress.zipcode}} {{$ctrl.order.deliveryAddress.city}}</div></div></div></li><li ng-if="!$ctrl.dealsService.isCategoryCrop($ctrl.deal) && $ctrl.dealsService.isDistributionCollection($ctrl.deal) && $ctrl.order.collectionPoints.length"><div class=row><div class="col-lg-12 font-weight-bold" translate>Collection Point</div><div class=col-lg-12><div ng-if=$ctrl.order.collectionPoints.length><span>{{$ctrl.order.collectionPoints[0].name}}</span><br><small>{{$ctrl.order.collectionPoints[0].address}}</small></div><span ng-if=!$ctrl.order.collectionPoints translate>N/A</span></div></div></li><li ng-if="!$ctrl.dealsService.isCategoryCrop($ctrl.deal) && $ctrl.dealsService.isDistributionCollection($ctrl.deal) && !$ctrl.order.collectionPoints.length && $ctrl.deal.collectionPoints.length"><div class=row><div class="col-lg-12 font-weight-bold"><span translate>Collection Points</span>&nbsp;({{$ctrl.deal.collectionPoints.length}})</div><div class=col-lg-12 style="max-height: 100px; overflow: scroll"><div ng-repeat="collectionPoint in $ctrl.deal.collectionPoints">&#8226; {{collectionPoint.name}}</div></div></div></li></ul></div><div class=col-lg-6><ul class=order-section-table><li><div class=row><div class="col-lg-12 font-weight-bold" translate>Billing address</div><div class=col-lg-12><div ng-if=$ctrl.order.billingAddress.name>{{$ctrl.order.billingAddress.name}}</div><div>{{$ctrl.order.billingAddress.street}}</div><div>{{$ctrl.order.billingAddress.zipcode}} {{$ctrl.order.billingAddress.city}}</div></div></div></li></ul></div></div></div><div class=col-lg-6><h5 class=order-section-header translate>Status</h5><ul class=order-section-table><li><div class=row><div class=col-lg-12><div ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.INVALID" class="p-1 text-center order-status invalid"><span translate>Invalid</span></div><div ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.PENDING" class="p-1 text-center order-status pending"><span translate>Pending</span></div><div ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.DELIVERED" class="p-1 text-center order-status completed"><span translate>Delivered</span></div><div ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.PAID" class="p-1 text-center order-status paid"><span translate>Paid</span></div><div ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.COMPLETED" class="p-1 text-center order-status completed"><span translate>Completed</span></div><div ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.FORWARDED" class="p-1 text-center order-status completed"><span translate>Forwarded</span></div><div ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.REJECTED" class="p-1 text-center order-status rejected"><span translate>Rejected</span></div></div></div></li><li><div class=row><div class="col-lg-5 font-weight-bold" translate>Updated</div><div class=col-lg-7>{{$ctrl.utils.getLocalizedDateAndTime($ctrl.order.updatedAt)}}</div></div></li><li class=mt-2 ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.FORWARDED && $ctrl.distributorDeal"><div class=font-weight-bold translate>Distributor</div>{{$ctrl.distributorDeal.supplier.name}}</li><li ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.FORWARDED && $ctrl.distributorDeal">&nbsp; <i class="fa fa-user"></i> {{$ctrl.distributorDeal.createdBy.name.first}} {{$ctrl.distributorDeal.createdBy.name.last}}</li><li ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.FORWARDED && $ctrl.distributorDeal && $ctrl.distributorDeal.createdBy.email">&nbsp; <i class="fa fa-envelope"></i> {{$ctrl.distributorDeal.createdBy.email}}</li><li ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.FORWARDED && $ctrl.distributorDeal && $ctrl.distributorDeal.createdBy.phoneNumber">&nbsp; <i class="fa fa-phone"></i> {{$ctrl.distributorDeal.createdBy.phoneNumber}}</li><li ng-if="$ctrl.order.status === $ctrl.ORDER_STATUS.FORWARDED && $ctrl.distributorDeal"><div class=row><div class="col-lg-5 font-weight-bold" translate>Incoterms</div><div class=col-lg-7>{{$ctrl.distributorDeal.paymentMethod}}</div></div></li></ul><!-- FIXME: similar code in request-details  --><h5 ng-if=$ctrl.order.messages.length class="order-section-header mt-4" translate>Messages</h5><div><div ng-repeat="message in $ctrl.order.messages | orderBy: \'createdAt\'" class=mb-1><div ng-if="request.isSentRequest ? message.isSupplier : !message.isSupplier" class=p-2 style="display:inline-block; background-color: whitesmoke; border-radius: 10px; margin-right: 30px"><div class="text-muted small"><b>{{message.createdBy.name.first}} {{message.createdBy.name.last}}</b></div><div class="text-muted small">{{utils.getLocalizedDate(message.createdAt)}}</div><div>{{message.text}}</div></div><div class=text-right><div ng-if="request.isSentRequest ? !message.isSupplier : message.isSupplier" class="text-white p-2" style="display:inline-block; background-color: #00b1b0; border-radius: 10px; margin-left: 30px"><div class="text-muted small"><b>{{message.createdBy.name.first}} {{message.createdBy.name.last}}</b></div><div class="text-muted small">{{utils.getLocalizedDate(message.createdAt)}}</div><div>{{message.text}}</div></div></div></div></div></div></div></div>');
$templateCache.put('app/app-commons/components/pending-invites/pending-invites.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-envelope-square"></i> <span translate>Customer invites</span> ({{$ctrl.pendingInvitesCount}} <span translate>pending</span>)</h4><button type=button ng-click=$ctrl.cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class=modal-body><div style="max-height: 50vh; overflow: scroll"><ul class="list-group-table row"><li class="list-table-item-header row hidden-sm-down"><div class="col col-md-3" translate>Sent</div><div class="col col-md-3" translate>Target</div><div class="col col-md-3" translate>Message</div><div class="col col-md-3" translate>Status</div></li><li class="list-table-item row row-highlighted-hover row-clickable" ng-class="{\'text-disabled\': !invite.acceptedBy && (!invite.isValid || invite.isExpired) }" ng-repeat="invite in $ctrl.invites"><div class="col-md-3 col-sm-6" ng-class="{\'text-disabled\': invite.isInvalid || invite.isExpired }"><div>{{$ctrl.utils.getLocalizedDate(invite.createdAt)}}</div><small>{{invite.createdBy.name.first}} {{invite.createdBy.name.last}}</small></div><div class="col-md-3 col-sm-6"><div ng-if=invite.email><i class="fa fa-envelope"></i>&nbsp;{{invite.email}}<!-- <div ng-if="emailSent"><i class="fa fa-check-square"></i>&nbsp;<span translate>Email sent</span></div> --></div><div ng-if=invite.phoneNumber><i class="fa fa-phone-square"></i>&nbsp;{{invite.phoneNumber}}<!-- <div ng-if="smsSent"><i class="fa fa-check-square"></i>&nbsp;<span translate>Sms sent</span></div> --></div></div><div class="col-md-3 col-sm-6"><div class=mb-2 ng-click="invite.isMessageExpanded = !invite.isMessageExpanded"><div class=small ng-if="invite.message && !invite.isMessageExpanded" style="max-width: 200px">{{invite.message.slice(0, 50)}}...</div><div class=small ng-if="invite.message && invite.isMessageExpanded" style="max-width: 200px">{{invite.message}}</div></div><a href=https://{{invite.urlShort}} target=_blank>{{invite.urlShort}}</a></div><div class="col-md-3 col-sm-6"><div ng-if=!invite.acceptedBy><div ng-if="invite.isValid && !invite.isExpired" class=text-warning><span translate>Pending</span><div class=small translate>Expires on:</div><div class=small>{{$ctrl.utils.getLocalizedDate(invite.expiresAt)}}</div></div><div ng-if=invite.isExpired class=text-danger><span><span translate>Expired</span><br>{{$ctrl.utils.getLocalizedDate(invite.expiresAt)}}</span></div><div ng-if="!invite.isValid && !invite.isExpired" class=text-danger><span translate>Invalid</span></div></div><div ng-if=invite.acceptedBy class=text-success><div><b><i class="fa fa-check-square"></i>&nbsp;<span translate>Accepted</span></b></div><div>By&nbsp;{{invite.acceptedBy.name.first}} {{invite.acceptedBy.name.last}}</div><div><small>{{$ctrl.utils.getLocalizedDateAndTime(invite.acceptedAt)}}</small></div></div></div></li></ul></div><div class="row space-top" ng-if=$ctrl.paging class=text-center><div class="col-md-12 col-lg-6"><ul uib-pagination class=pagination-sm first-text="{{\'First\'|translate}}" previous-text="{{\'Prev\'|translate}}" next-text="{{\'Next\'|translate}}" last-text="{{\'Last\'|translate}}" ng-change=$ctrl.onPage() total-items=$ctrl.paging.count ng-model=$ctrl.paging.current max-size=$ctrl.paging.maxSize items-per-page=$ctrl.paging.itemsPerPage boundary-link-numbers=true></ul></div></div></div>');
$templateCache.put('app/app-commons/components/product-attributes-edit/product-attributes-edit-prompt.tpl.html','<div class="mt-2 mb-4 p-2 mr-1" style="min-height: 300px"><div class="row mb-4 mr-1"><div class="col-4 text-right pt-1"><label translate>Load preset</label></div><div class=col-8><select class=form-control name=selectedPreset ng-model=$ctrl.selectedPreset ng-options="preset as preset.label for preset in $ctrl.attributePresets" ng-change=$ctrl.loadSelectedPreset()></select></div></div><div class="form-group has-feedback row" ng-repeat="attr in $ctrl.editedAttributes"><div class="col-6 pr-1" ng-class="{\'has-error\': !attr.label }"><input type=text ng-model=attr.label class="form-control has-error" ng-change=$ctrl.attributesChanged() uib-typeahead="valueOption for valueOption in $ctrl.labelOptions | filter:$viewValue | limitTo:10" typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0></div><div class="col-5 pl-0 pr-1" ng-class="{\'has-error\': !attr.value }"><input type=text ng-model=attr.value class=form-control ng-change=$ctrl.attributesChanged() uib-typeahead="valueOption for valueOption in attr.valueOptions | filter:$viewValue | limitTo:10" typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0></div><div class="col-1 pl-0 pr-2 text-center"><button class="btn btn-secondary m-0 pl-2 pr-2" ng-click=$ctrl.removeAttribute($index)><i class="fa fa-trash"></i></button></div></div><div class=text-right><button type=button class="btn btn-secondary" ng-click=$ctrl.addAttribute()><span translate>Add</span></button></div><br><br><br><br></div>');
$templateCache.put('app/app-commons/components/product-attributes-edit/product-attributes-edit.tpl.html','<div><div ng-if="!$ctrl.attributes || !$ctrl.attributes.length"><button type=button class="btn btn-sm btn-secondary" ng-click=$ctrl.editAttributes()><span translate>Add</span></button></div><div class="p-2 row-clickable small" ng-if="$ctrl.attributes && $ctrl.attributes.length" ng-click=$ctrl.editAttributes()><div ng-repeat="attr in $ctrl.attributes" class=pr-0 style="white-space: nowrap"><span class=text-muted>{{attr.label}}:</span>&nbsp;<b>{{attr.value}}</b></div></div></div>');
$templateCache.put('app/app-commons/components/richtext-editor/richtext-editor.html','<ng-quill-editor ng-model=$ctrl.ngModel required readonly save=html on-editor-created=$ctrl.editorCreated(editor) on-content-changed="$ctrl.contentChanged(editor, html, text, content)" on-selection-changed="$ctrl.selectionChanged(editor, range, oldRange, source)" min-length=25></ng-quill-editor>');
$templateCache.put('app/app-commons/components/select-product/select-product.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-envelope-square"></i> <span translate>New order</span></h4><button type=button ng-click=$ctrl.cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class="modal-body p-3"><div><div class=input-group><span class=input-group-addon><i class="fa fa-search"></i></span> <input class="form-control col-12" ng-model=$ctrl.searchText placeholder="{{\'Search\'|translate}}" ng-model-options="{ debounce: 500 }" ng-change=$ctrl.searchProducts()></div></div><div id=productListContainer style="height: 500px; overflow: scroll"><div ng-if="!$ctrl.products.length && !$ctrl.loading && $ctrl.searchText"><div class="row mt-3"><div class="col-md-4 pt-2 text-right"><label translate>Product Id</label></div><div class=col-md-8><input class=form-control type=text ng-model=$ctrl.newVendorProductId></div></div><div class="text-right mt-4"><button type=button class="btn btn-success mt-2 col-8" ng-click=$ctrl.createProduct()><span translate>Create product</span> "{{$ctrl.searchText}}"</button></div></div><div class="row m-2 row-clickable row-border" ng-repeat="prod in $ctrl.products track by $index" ng-click=$ctrl.selectProduct(prod)><div class="col-2 pt-2"><img ng-src="{{prod.imageUrls[0] || \'./app/shared/images/default-no-image.jpg\'}}" style="max-width: 100%; max-height: 40px; margin: 2px auto"></div><div class=col>{{prod.name}}<div class=row><div class=col-md-8><div class=small ng-if=prod.vendorProductId><span translate>Product ID</span>: {{prod.vendorProductId}}</div><div ng-if="prod.categoryName && prod.categoryName !== \'CROP\'"><i class=small>{{prod.categoryName}} <span ng-bind-html-unsafe="prod.categoryName | typeaheadHighlight:query"></span></i></div><div ng-if="prod.categoryName && prod.categoryName === \'CROP\'"><img style=float:left src=app/shared/images/crop_icon.png width=20> <small><i><span translate>Crop</span></i></small></div></div><div class="col-md-4 small"><div ng-if=prod.deals.sent.ongoing><span translate>Available to customers:</span> {{prod.deals.sent.ongoing.benchmarkPrice | currency: $root.app.Auth.User.supplier.currencySymbol}}</div><div ng-if=prod.deals.sent.latest.length><span translate>Last offer</span> <i class="fa fa-tag"></i> {{prod.deals.sent.latest[0].benchmarkPrice | currency: $root.app.Auth.User.supplier.currencySymbol}}</div></div></div></div></div></div><!-- productListContainer --></div><div class=modal-footer><button id=cancelButton type=button ng-click=$ctrl.cancel() class="btn btn-dark"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div>');
$templateCache.put('app/app-commons/components/status-badge/status-badge.html','<div ng-if=!$ctrl.statusData>{{$ctrl.status}}</div><div ng-if=$ctrl.statusData class="order-status {{$ctrl.statusData.cssClass}}"><span style="color: grey!important">{{$ctrl.statusData.label}}</span></div>');
$templateCache.put('app/app-commons/components/upload-attachment/upload-attachment.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-file-image-o"></i> <span translate>Attachment</span></h4><button type=button ng-click=$ctrl.cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class=modal-body><div class=col-md-12><!-- Tab panes --><form role=form name=Form.imgForm><div class="alert alert-icon alert-danger" ng-if="$ctrl.invalidFile && !$ctrl.uploading"><i class="fa fa-warning"></i> <span translate>Upload failed. File must be a valid PDF file.</span></div><div ng-if="!$ctrl.attachment.url && !$ctrl.uploading" class=mb-4><label for=input-select-file class="file_uploader btn btn-outline-success mb-2 p-4 m-0" style="width: 100%"><i class="fa fa-desktop"></i> <span translate>Select file from your computer</span> <input type=file id=input-select-file name=input-select-file ngf-select="onFileSelect($files, $event)" ngf-multiple=false ngf-accept="\'.pdf\'" accept=application/pdf></label><div class=file-paste-or-drop contenteditable=false ngf-model-options="{updateOn: \'change click drop dropUrl paste\', allowInvalid: false, debounce: 0}" ngf-drop="onFileSelect($files, $event)" ngf-multiple=false ngf-accept="\'.pdf\'" accept=application/pdf><i class="fa fa-clipboard p-3" style="font-size: 200%"></i><br><span translate>Drag-and-drop here</span><div><span translate>Or</span></div><div><span translate>Copy image (CTRL + C) and paste here using CTRL + V</span></div></div></div><div class=col-md-12 ng-if=$ctrl.uploading><p class="text-sm-center text-info margin--bottom-clear"><i class="fa fa-info-circle"></i> <span translate>Uploading...</span></p><p class="text-sm-center text-warning margin-top-clear"><span translate>Please do not press back or refresh the page.</span></p><div class="col-md-8 offset-2 padding-ver-clear"><img src=./app/shared/images/uploading.gif width=120 style="margin: 0 auto" alt=""></div><div class="progress style-1 col-md-8 offset-2"><span class=text></span><div class="progress-bar progress-bar-default" data-animate-width=90%><span class="label object-non-visible" data-animation-effect=fadeInLeftSmall data-effect-delay=1000>{{uploadProgress}}</span></div></div></div><div class=row ng-class="{\'has-error\': Form.imgForm.$submitted && !$ctrl.attachment.name }"><label class="col-lg-2 pt-2" translate>File name:</label><div class=col-lg-10><input type=text class=form-control ng-model=$ctrl.attachment.name placeholder="{{\'File name\'|translate}}" required></div></div><div class="mt-2 row" ng-class="{\'has-error\': Form.imgForm.$submitted && !$ctrl.attachment.url }"><label class="col-lg-2 pt-2" translate>File URL:</label><div class=col-lg-10><input type=url class=form-control ng-model=$ctrl.attachment.url placeholder="{{\'File URL\'|translate}}" required></div></div><div ng-if=$ctrl.attachment.url class=row><a class="push-md-2 col-lg-6 p-4" href={{$ctrl.attachment.url}} target=_blank><i class="fa fa-external-link"></i> <span translate>See attachment preview</span> </a><!-- <a class="col p-4 text-warning text-right" ng-click="$ctrl.attachment.url = \'\'">\n                    <i class="fa fa-refresh"></i>\n                    <span translate>Upload another file</span>\n                </a> --></div><div class="col-12 mt-4"><div class=separator-2></div><div class=row><div class=col-6><button type=button ng-click=$ctrl.cancel() class="btn btn-dark col-8"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button type=button ng-click=$ctrl.ok() class="btn btn-success col-8"><i class="fa fa-check-circle"></i> <span translate>Save</span></button></div></div></div></form></div></div>');
$templateCache.put('app/app-commons/components/upload-image/upload-image.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-file-image-o"></i> <span translate>Set/Update offer image</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class=modal-body><div class=col-md-12><ul class="nav nav-tabs style-4" role=tablist><li class=nav-item><a class="nav-link active" href=#img-exist role=tab data-toggle=tab title=images><i class="fa fa-list pr-1"></i> <span translate>Existing</span></a></li><li class=nav-item><a class=nav-link href=#upload role=tab data-toggle=tab title=video><i class="fa fa-cloud-upload pr-1"></i> <span translate>Upload</span></a></li></ul><!-- Tab panes --><div class="tab-content clear-style"><div class="tab-pane active" id=img-exist style="max-height: 600px" ng-scrollbars><div class=row><div ng-if=$ctrl.loading><h5 class=p-4 translate>Loading images..</h5></div><div class=col-sm-4 ng-repeat="imgUrl in $ctrl.imgUrlList track by $index"><div class="image-box shadow text-center mb-20"><div class="overlay-container overlay-visible"><img ng-src={{imgUrl}} ng-error-src=app/shared/images/fallback_image.png style="max-height: 150px; margin: 0 auto" alt=""> <a ng-click=selectImage(imgUrl) class=overlay-link><i class="fa fa-file-image-o"></i></a></div></div></div></div></div><div class=tab-pane id=upload><form role=form name=Form.imgForm ng-show=!uploading><div class="form-group col-md-12" ng-if=!filepreview ng-class="{\'has-error\': Form.imgForm.$submitted }"><label for=input-select-file class="file_uploader btn btn-outline-success mb-2 p-4" style="width: 100%"><i class="fa fa-desktop"></i> <span translate>Select file from your computer</span> <input type=file id=input-select-file name=input-select-file ngf-select="onFileSelect($files, $event)" ngf-multiple=false ngf-resize="{width:600, height:600}" ngf-accept="\'.png,.gif,.jpg,.jpeg\'" accept=image/*></label><div class=file-paste-or-drop contenteditable=false ngf-model-options="{updateOn: \'change click drop dropUrl paste\', allowInvalid: false, debounce: 0}" ngf-drop="onFileSelect($files, $event)" ngf-multiple=false ngf-resize="{width:600, height:600}" ngf-accept="\'.png,.gif,.jpg,.jpeg\'" accept=image/*><i class="fa fa-clipboard p-3" style="font-size: 200%"></i><br><span translate>Drag-and-drop here</span><div><span translate>Or</span></div><div><span translate>Copy image (CTRL + C) and paste here using CTRL + V</span></div></div></div><div ng-if=filepreview class=col-md-12 id=imgPreview><a ng-click=resetFile() class="text-danger btn-lg-link pull-right"><i class="fa fa-2x fa-times-circle-o"></i></a> <img ng-src={{filepreview}} class="img-responsive p-3" style="max-width: 300px; max-height: 300px"></div><div class=col-12><div class=separator-2></div><div class=row><div class=col-6><button type=button ng-click=cancel() class="btn btn-dark col-8"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button type=button ng-click=ok() class="btn btn-success col-8"><i class="fa fa-cloud-upload"></i> <span translate>Upload</span></button></div></div></div></form><div class=col-md-12 ng-if=uploading><p class="text-sm-center text-info margin--bottom-clear"><i class="fa fa-info-circle"></i> <span translate>Uploading...</span></p><p class="text-sm-center text-warning margin-top-clear"><span translate>Please do not press back or refresh the page.</span></p><div class="col-md-8 offset-2 padding-ver-clear"><img src=./app/shared/images/uploading.gif width=120 style="margin: 0 auto" alt=""></div><div class="progress style-1 col-md-8 offset-2"><span class=text></span><div class="progress-bar progress-bar-default" data-animate-width=90%><span class="label object-non-visible" data-animation-effect=fadeInLeftSmall data-effect-delay=1000>{{uploadProgress}}</span></div></div></div></div></div></div></div>');
$templateCache.put('app/modules/auth/invitation/invite.tpl.html','<div class=fullscreen-bg></div><div class=container ng-if="!$ctrl.promptAppDownload && $ctrl.invitation.expired"><div class=row><div class="col-12 invite-wrapper panel"><div class="panel-body text-center"><div id=logo class="logo text-center"><a href=index.html class="logo-font link-light"><img src=app/shared/images/fh_logo2018_black.png width=240 style="margin:20px auto" alt=""></a></div><h3 class=text-warning><i class="fa fa-exclamation-triangle"></i><br><span translate>Invalid or expired registration link</span></h3><hr><p></p><div translate>For help, please contact</div><a class="btn btn-link btn-info m-0" href=mailto:support@farmhedge.io>support@farmhedge.io</a><p></p><br><span class=pr-20 translate>Already a customer?</span> <a ui-sref=login class="btn btn-info btn-user btn-animated"><span translate>Login</span> <i class="fa fa-user pl-20"></i></a></div><hr><div class=panel-footer><p class="mt-20 text-center">\xA9 FarmHedge 2022</p></div></div></div></div><div class=container ng-if=$ctrl.promptAppDownload><div class=row><div class="col-12 invite-wrapper panel"><div class="panel-body text-center"><div id=logo class="logo text-center"><a href=index.html class="logo-font link-light"><img src=app/shared/images/fh_logo2018_black.png width=240 style="margin:20px auto" alt=""></a></div><h5><span translate>The easy, secure and private way to trade with your suppliers.</span></h5><div class="row mb-3"><div class="col-md-6 col-sm-12"><button type=button class="btn btn-info col-12 p-3" onclick="window.location = \'https://apps.apple.com/ie/app/farmhedge-dev/id1059744999\'" translate>Download for iOS</button></div><div class="col-md-6 col-sm-12"><button type=button class="btn btn-info col-12 p-3" onclick="window.location = \'https://play.google.com/store/apps/details?id=io.farmhedge\'" translate>Download for Android</button></div></div><div class=mt-3><span translate>Do you already have the mobile app installed?</span></div><div class="text-centre mb-5"><button type=button class="btn btn-success col-md-6 col-sm-12 p-3" ng-click=$ctrl.goToMobileApp() translate>Open the FarmHedge app</button></div><hr><div class=mt-5><div translate>What is FarmHedge?</div><a class="btn btn-outline-success col-md-6 col-sm-12 p-3" target=_blank href=https://farmhedge.io translate>Learn more about FarmHedge</a></div><hr><div class="mt-5 mb-5"><div translate>For questions or help, please contact</div><a class="btn btn-link btn-info m-0" href=mailto:support@farmhedge.io>support@farmhedge.io</a></div><hr><div class=mt-5><span class=pr-20 translate>Do you have a supplier account?</span> <a ui-sref=login class="btn btn-info btn-user btn-sm btn-animated"><span translate>Login</span> <i class="fa fa-user pl-20"></i></a></div></div><hr><div class=panel-footer><p class="mt-20 text-center">\xA9 FarmHedge 2022</p></div></div></div></div><div class=container ng-if="!$ctrl.invitation.expired && !$ctrl.promptAppDownload"><div class="row justify-content-center"><div class="col col-sm-10 col-md-8 invite-wrapper panel" ng-if=$ctrl.invitation.isValid><div class=panel-body><h5 class="title text-gray-dark text-center pb-0 mb-0" translate>Welcome to</h5><div id="logo mt-0 pt-0" class="logo text-center"><a href=index.html class="logo-font link-light"><img src=app/shared/images/fh_logo2018_black.png width=200 style="margin:0 auto" alt=""></a></div><div class=separator></div><div class="row ml-2 mr-2 mt-3"><div class="col-md-2 col-sm-2 p-2" ng-if=$ctrl.invitation.createdBy.imageUrl><div class=user-img style="margin: 0 auto"><img ng-src={{$ctrl.invitation.createdBy.imageUrl}} ng-error-src=app/shared/images/team-member.jpg class=centered alt=""></div></div><div class="col-md-8 col-sm-12 text-left pb-3"><span translate><b>{{$ctrl.invitation.createdBy.nameFull}}</b> invited you to join FarmHedge.</span><div><small>{{$ctrl.utils.getLocalizedDate($ctrl.invitation.createdAt)}}</small></div><div class=mt-1><span translate>Supplier</span>: <b>{{$ctrl.invitation.supplier.name}}</b></div><div class="text-primary mt-1" ng-if=$ctrl.invitation.message><div class=mt-2 translate>{{$ctrl.invitation.createdBy.name.first}}\'s message:</div><sup><i class="fa fa-quote-left"></i></sup> <i>{{$ctrl.invitation.message}}</i> <sub><i class="fa fa-quote-right"></i></sub></div></div><div class="col-md-2 col-sm-12 pl-2 pr-2"><div style="margin: 0 auto; max-width: 100px"><img ng-src={{$ctrl.invitation.supplier.imageUrl}} ng-error-src=app/shared/images/team-member.jpg class=centered alt=""></div></div></div><div class=separator></div><div ng-if=$ctrl.hideRegistrationForm><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.Phone.$touched && $ctrl.form.Phone.$invalid }"><label for=inputPhone class="col-md-3 col-lg-4 text-md-right control-label col-form-label" translate>Phone</label><div class="col-md-8 col-lg-6"><input type=text id=inputPhone name=Phone ng-model=$ctrl.user.phoneNumber ng-pattern=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$/ class=form-control disabled> <i class="fa fa-phone form-control-feedback pr-4"></i></div></div><div class="form-group row"><div class="push-lg-4 col-lg-6 push-md-3 col-md-8 col-sm-12 text-center"><button type=submit id=loginButton class="btn btn-group btn-success btn-lg btn-animated col-12" ng-disabled=$ctrl.loading ng-click=$ctrl.acceptInvite()><span translate>Accept invite</span> <i class="fa fa-check"></i></button><div ng-if=$ctrl.loading class="m-3 text-center text-white"><i class="fa fa-spinner"></i> <span translate>Loading</span>...</div></div></div></div><form ng-if=!$ctrl.hideRegistrationForm id=inviteForm name=$ctrl.form ng-submit=$ctrl.submitForm() class=form-horizontal novalidate autocomplete=off><p class=text-center translate>Please fill your details to accept the invite:</p><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.Email.$touched && $ctrl.form.Email.$invalid }"><label for=Email class="col-md-3 col-lg-4 text-md-right control-label col-form-label" translate>Email</label><div class="col-md-8 col-lg-6"><input type=email name=Email ng-model=$ctrl.user.email ng-disabled=$ctrl.user.isEmailDisabled ng-blur=$ctrl.checkEmailAndPhone() class=form-control id=inputEmail placeholder="{{\'Email\'|translate}}" required> <i class="fa fa-envelope form-control-feedback pr-4"></i></div></div><div class="push-md-3 col-md-8 push-lg-4 col-lg-6 text-danger" ng-messages=$ctrl.form.Email.$error ng-if="$ctrl.form.Email.$touched && $ctrl.form.Email.$error"><div class=form-control-feedback ng-message=required><i class="fa fa-asterisk"></i> <span translate>Field is required</span></div></div><div class="push-md-3 col-md-8 push-lg-4 col-lg-6 text-danger" ng-messages=$ctrl.form.Email.$error ng-if="$ctrl.form.Email.$touched && $ctrl.form.Email.$error"><div class=form-control-feedback ng-message=email><i class="fa fa-asterisk"></i> <span translate>Value is not valid</span></div></div><div class="push-md-3 col-md-8 push-lg-4 col-lg-6 text-danger" ng-messages=$ctrl.form.Email.$error ng-if="$ctrl.form.Email.$touched && $ctrl.form.Email.$error"><div class=form-control-feedback ng-message=alreadyregistered><i class="fa fa-asterisk"></i> <span translate>Email already registered</span><div><button type=button class="btn btn-info col-12 p-3" ng-click=$ctrl.goToMobileApp() translate>Login on FarmHedge app</button></div></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.Phone.$touched && $ctrl.form.Phone.$invalid }"><label for=Phone class="col-md-3 col-lg-4 text-md-right control-label col-form-label" translate>Phone</label><div class="col-md-8 col-lg-6"><input type=text id=Phone name=Phone ng-model=$ctrl.user.phoneNumber ng-pattern=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$/ class=form-control placeholder="{{\'Phone\'|translate}}" ng-disabled=$ctrl.user.isPhoneNumberDisabled> <i class="fa fa-phone form-control-feedback pr-4"></i></div></div><div class="push-md-3 col-md-8 push-lg-4 col-lg-6 text-danger" ng-messages=$ctrl.form.Phone.$error ng-if="$ctrl.form.Phone.$touched && $ctrl.form.Phone.$error"><div class=form-control-feedback ng-message=required><i class="fa fa-asterisk"></i> <span translate>Field is required</span></div></div><div class="push-md-3 col-md-8 push-lg-4 col-lg-6 text-danger" ng-messages=$ctrl.form.Phone.$error ng-if="$ctrl.form.Phone.$touched && $ctrl.form.Phone.$error"><div class=form-control-feedback ng-message=pattern><i class="fa fa-asterisk"></i> <span translate>Value is not valid</span></div></div><div class="push-md-3 col-md-8 push-lg-4 col-lg-6 text-danger" ng-messages=$ctrl.form.Phone.$error ng-if="$ctrl.form.Phone.$touched && $ctrl.form.Phone.$error"><div class=form-control-feedback ng-message=alreadyregistered><i class="fa fa-asterisk"></i> <span translate>Phone number already registered</span></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.FirstName.$touched && $ctrl.form.FirstName.$invalid }"><label for=inputFirstName class="col-md-3 col-lg-4 text-md-right control-label col-form-label" translate>First Name</label><div class="col-md-8 col-lg-6"><input type=text id=inputFirstName name=FirstName ng-model=$ctrl.user.name.first class=form-control placeholder="{{\'First Name\'|translate}}" required> <i class="fa fa-user form-control-feedback pr-4"></i></div></div><div class="push-md-3 col-md-8 push-lg-4 col-lg-6 text-danger" ng-messages=$ctrl.form.FirstName.$error ng-if="$ctrl.form.FirstName.$touched && $ctrl.form.FirstName.$error"><div class=form-control-feedback ng-message=required><i class="fa fa-asterisk"></i> <span translate>Field is required</span></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.LastName.$touched && $ctrl.form.LastName.$invalid }"><label for=inputLastName class="col-md-3 col-lg-4 text-md-right control-label col-form-label" translate>Last Name</label><div class="col-md-8 col-lg-6"><input type=text id=inputLastName name=LastName ng-model=$ctrl.user.name.last class=form-control placeholder="{{\'Last Name\'|translate}}" required> <i class="fa fa-user form-control-feedback pr-4"></i></div></div><div class="push-md-3 col-md-8 push-lg-4 col-lg-6 text-danger" ng-messages=$ctrl.form.LastName.$error ng-if="$ctrl.form.LastName.$touched && $ctrl.form.LastName.$error"><div class=form-control-feedback ng-message=required><i class="fa fa-asterisk"></i> <span translate>Field is required</span></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.Password.$touched && $ctrl.form.Password.$invalid }"><label for=inputPassword class="col-md-3 col-lg-4 text-md-right control-label col-form-label" translate>Password</label><div class="col-md-8 col-lg-6"><input type=password id=inputPassword name=Password ng-model=$ctrl.user.password class=form-control minlength=0 placeholder="{{\'Password\'|translate}}" ng-change=$ctrl.checkPassword() ng-focus=$ctrl.checkPassword() autocomplete=new-password show-password=showPassword autocomplete=off required> <a ng-click="showPassword = !showPassword"><i ng-if=!showPassword class="fa fa-eye form-control-feedback pr-4"></i> <i ng-if=!!showPassword class="fa fa-eye-slash form-control-feedback pr-4"></i></a></div></div><div class="push-md-3 col-md-8 push-lg-4 col-lg-6 text-danger" ng-messages=$ctrl.form.Password.$error ng-if="$ctrl.form.Password.$touched && $ctrl.form.Password.$error"><div ng-message=required class=form-control-feedback><i class="fa fa-asterisk"></i> <span translate>Field is required</span></div></div><div class="push-md-3 col-md-8 push-lg-4 col-lg-6 mb-20"><div class="mt-0 mb-0 pt-0 pb-0" style="font-size: 17px" ng-class="{\'text-danger\': $ctrl.form.Password.$error.minlength, \'text-success\': !$ctrl.form.Password.$error.nodigit}"><i ng-if=$ctrl.form.Password.$error.minlength class="fa fa-times-circle"></i> <i ng-if=!$ctrl.form.Password.$error.minlength class="fa fa-check-square"></i> <span translate>8 characters length</span></div><!-- <div>\n                            <i ng-if="$ctrl.form.Password.$error.noletterupper" class="fa fa-times-circle text-danger"></i> \n                            <i ng-if="!$ctrl.form.Password.$error.noletterupper" class="fa fa-check-square text-success"></i> \n                            <span translate>An upper-case letter (A, B, ...)</span>\n                        </div> --><!-- <div>\n                            <i ng-if="$ctrl.form.Password.$error.noletterlower" class="fa fa-times-circle text-danger"></i> \n                            <i ng-if="!$ctrl.form.Password.$error.noletterlower" class="fa fa-check-square text-success"></i> \n                            <span translate>A letter (a, b, ...)</span>\n                        </div> --><div class="mt-0 mb-0 pt-0 pb-0" style="font-size: 17px" ng-class="{\'text-danger\': $ctrl.form.Password.$error.noletter, \'text-success\': !$ctrl.form.Password.$error.noletter}"><i ng-if=$ctrl.form.Password.$error.noletter class="fa fa-times-circle"></i> <i ng-if=!$ctrl.form.Password.$error.noletter class="fa fa-check-square"></i> <span translate>A lower-case letter (a, b, ...)</span></div><div class="mt-0 mb-0 pt-0 pb-0" style="font-size: 17px" ng-class="{\'text-danger\': $ctrl.form.Password.$error.nodigit, \'text-success\': !$ctrl.form.Password.$error.nodigit}"><i ng-if=$ctrl.form.Password.$error.nodigit class="fa fa-times-circle"></i> <i ng-if=!$ctrl.form.Password.$error.nodigit class="fa fa-check-square"></i> <span translate>A number (1, 2, ...)</span></div></div><div class="form-group row"><div class="col-12 text-center"><button type=submit id=loginButton class="btn btn-group btn-success btn-lg btn-animated" ng-disabled=$ctrl.loading><span translate>Accept invite</span> <i class="fa fa-check"></i></button><div ng-if=$ctrl.loading class="m-3 text-center"><i class="fa fa-spinner"></i> <span translate>Loading</span>...</div></div></div></form></div><div class=m-5 ng-if=$ctrl.invitation.supplier.description><h5 translate>About {{$ctrl.invitation.supplier.name}}</h5>{{$ctrl.invitation.supplier.description}}</div><div class=panel-footer><p class="mt-5 text-center">\xA9 FarmHedge 2022</p></div></div></div><br><br><br><br><br></div>');
$templateCache.put('app/modules/auth/login/auth.login.view.html','<div class=fullscreen-bg></div><div class="pv-40 dark-translucent-bg login-wrapper"><div class=container><div class="row justify-content-center"><div class=col-auto><div data-animation-effect=fadeInDownSmall data-effect-delay=100><!-- logo --><div id=logo class="logo text-center"><a href=index.html class="logo-font link-light"><img src=app/shared/images/fh_logo2018_white.png width=200 style="margin:0 auto" alt=""></a></div><br><div class="form-block center-block p-30 light-gray-bg border-clear" ng-if=!vm.forgotPassMode><h3 class="title text-gray-dark" translate>Login</h3><div class="alert alert-icon alert-danger" role=alert ng-if=vm.error><i class="fa fa-times"></i> {{vm.error}}</div><form name=vm.form.login ng-submit=vm.doLogin() class=form-horizontal novalidate autocomplete=off><div class="col-md-8 push-3 text-danger" ng-messages=vm.form.login.Email.$error ng-if="vm.submitted && vm.form.login.Email.$error"><div class=form-control-feedback ng-message=required><i class="fa fa-asterisk"></i> <span translate>Email is required</span></div><div class=form-control-feedback ng-message=email><i class="fa fa-times"></i> <span translate>Email must be valid</span></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': vm.form.login.Email.$error && vm.submitted }"><label for=inputUserName class="col-md-3 text-md-right control-label col-form-label" translate>Email</label><div class=col-md-8><input type=email name=Email ng-model=vm.user.email class=form-control id=inputUserName placeholder="{{\'Email\'|translate}}" required> <i class="fa fa-user form-control-feedback pr-4"></i></div></div><div class="col-md-8 push-3 text-danger" ng-messages=vm.form.login.Password.$error ng-if="vm.submitted && vm.form.login.Password.$error"><div ng-message=required class=form-control-feedback><i class="fa fa-asterisk"></i> <span translate>Password is required</span></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': vm.form.login.Password.$error && vm.submitted}"><label for=inputPassword class="col-md-3 text-md-right control-label col-form-label" translate>Password</label><div class=col-md-8><input type=password name=Password ng-model=vm.user.password class=form-control id=inputPassword placeholder="{{\'Password\'|translate}}" required> <i class="fa fa-lock form-control-feedback pr-4"></i></div></div><div class="form-group row" ng-if=false><div class="col-md-8 col-lg-6 push-md-3"><fh-captcha captcha=vm.captcha></fh-captcha></div></div><div class="form-group row"><div class="ml-md-auto col-md-9"><div class=checkbox ng-if=false><label><input type=checkbox required> <span translate>Remember me</span></label></div><button type=submit id=loginButton class="btn btn-group btn-success btn-animated" ng-disabled=vm.loading analytics-on=click analytics-event="Login button"><span translate>Login</span> <i class="fa fa-user"></i></button><div ng-if=vm.loading class="m-1 text-muted"><i class="fa fa-spinner"></i> <span translate>Loading</span>...</div><ul class=space-top style="list-style: none"><li><a ng-click=vm.toggleForgotPassMode() analytics-on=click analytics-event="Forgot password link" translate>Forgot your password?</a></li></ul></div></div></form></div><div class="form-block center-block p-30 light-gray-bg border-clear" ng-if=vm.forgotPassMode ng-switch=vm.passResetSuccess><h3 class="title text-gray-dark text-center space-bottom" ng-switch-when=false translate>Forgot password</h3><form name=vm.form.passreset ng-submit=vm.requestPassReset() class=form-horizontal novalidate autocomplete=off ng-switch-when=false><div class="col-md-8 push-md-3 text-danger" ng-messages=vm.form.passreset.Email.$error ng-if="vm.submitted && vm.form.passreset.Email.$error"><div class=form-control-feedback ng-message=required><i class="fa fa-asterisk"></i> <span translate>Email is required</span></div><div class=form-control-feedback ng-message=email><i class="fa fa-times"></i> <span translate>Email must be valid</span></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': vm.form.passreset.Email.$error && vm.submitted }"><div class="col-md-8 push-md-2"><input type=email name=Email ng-model=vm.passResetObj.email class=form-control id=inputUserName placeholder="{{\'Email\'|translate}}" required> <i class="fa fa-envelope form-control-feedback pr-4"></i></div></div><div class="form-group row"><div class="col-md-6 push-md-2" ng-if=false><fh-captcha captcha=vm.captcha></fh-captcha></div></div><div class="form-group row"><div class="col-md-8 push-md-2"><img class=space-top ng-src={{vm.loadingImg}} width=32 ng-if="vm.submitted && vm.loading"> <button type=button ng-click=vm.toggleForgotPassMode() class="btn btn-group btn-dark btn-animated"><i class="fa fa-times"></i> <span translate>Cancel</span></button> <button type=submit id=passResetButton class="btn btn-group btn-success btn-animated pull-right" ng-if=!vm.loading analytics-on=click analytics-event="Forgot password confirm button" ng-disabled=!vm.passResetObj.email><i class="fa fa-check"></i> <span translate>Confirm</span></button></div></div></form><div class="row center-block" ng-switch-when=true><div class="col-12 p-30 light-gray-bg border-clear password-success-msg"><strong><i class="fa fa-envelope"></i> <span translate>Success</span></strong><div><span translate>Please check your email for password reset instructions.</span><div><small translate>If you don\'t receive an email, and it\'s not in your spam folder this could mean you signed up with a different address.</small></div></div><hr><p><button ng-click="vm.forgotPassMode=false" class="btn btn-sm btn-success"><i class="fa fa-user"></i> Goto Login</button></p></div></div></div><!-- .subfooter start --><!-- ================ --><p class="mt-20 text-center"><i class="fa fa-info-circle"></i> <a href="mailto:support@farmhedge.io?subject=Portal login help">support@farmhedge.io</a></p><p class="mt-20 text-center">\xA9 FarmHedge 2022</p><!-- .subfooter end --></div></div></div></div></div>');
$templateCache.put('app/modules/auth/password/password.tpl.html','<div class=fullscreen-bg></div><div class="pv-40 dark-translucent-bg login-wrapper"><div class=container><div class="row justify-content-center"><div class=col-auto><div data-animation-effect=fadeInDownSmall data-effect-delay=100><!-- logo --><div id=logo class="logo text-center"><a href=index.html class="logo-font link-light"><img src=app/shared/images/fh_logo2018_white.png width=200 style="margin:0 auto" alt=""></a></div><br><div class="form-block center-block p-30 light-gray-bg border-clear"><h4 class="title text-gray-dark text-center space-bottom" translate>Reset Password</h4><div class="alert alert-icon alert-danger" role=alert ng-if=$ctrl.error><i class="fa fa-times"></i> {{$ctrl.error}}</div><form name=$ctrl.form ng-submit=$ctrl.submit() class=form-horizontal novalidate autocomplete=off><div class="push-md-1 col-md-10 push-lg-2 col-lg-8 text-danger" ng-messages=$ctrl.form.Password.$error ng-if="$ctrl.submitted && $ctrl.form.Password.$error"><div ng-message=required class=form-control-feedback><i class="fa fa-times-circle-o"></i> <span translate>Password is required</span></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.$submitted && $ctrl.form.Password.$invalid }"><div class="push-md-1 col-md-10 push-lg-2 col-lg-8"><input type=password name=Password ng-model=$ctrl.password class=form-control minlength=0 placeholder="{{\'Password\'|translate}}" ng-change=$ctrl.checkPassword() ng-focus=$ctrl.checkPassword() autocomplete=new-password show-password=showPassword required> <a ng-click="showPassword = !showPassword"><i ng-if=!showPassword class="fa fa-eye form-control-feedback pr-4"></i> <i ng-if=!!showPassword class="fa fa-eye-slash form-control-feedback pr-4"></i></a></div></div><div class="push-md-1 col-md-10 push-lg-2 col-lg-8 mb-20"><div><i ng-if=$ctrl.form.Password.$error.minlength class="fa fa-times-circle text-danger"></i> <i ng-if=!$ctrl.form.Password.$error.minlength class="fa fa-check-square text-success"></i> <span translate>8 characters length</span></div><div><i ng-if=$ctrl.form.Password.$error.noletterupper class="fa fa-times-circle text-danger"></i> <i ng-if=!$ctrl.form.Password.$error.noletterupper class="fa fa-check-square text-success"></i> <span translate>An upper-case letter (A, B, ...)</span></div><div><i ng-if=$ctrl.form.Password.$error.noletterlower class="fa fa-times-circle text-danger"></i> <i ng-if=!$ctrl.form.Password.$error.noletterlower class="fa fa-check-square text-success"></i> <span translate>A lower-case letter (a, b, ...)</span></div><div><i ng-if=$ctrl.form.Password.$error.nodigit class="fa fa-times-circle text-danger"></i> <i ng-if=!$ctrl.form.Password.$error.nodigit class="fa fa-check-square text-success"></i> <span translate>A number (1, 2, ...)</span></div></div><div class="form-group row" ng-if=false><div class="push-md-1 col-md-10 push-lg-2 col-lg-8"><fh-captcha captcha=$ctrl.captcha></fh-captcha></div></div><div class="form-group row"><div class="push-md-1 col-md-10 push-lg-2 col-lg-8"><div ng-if="$ctrl.submitted && $ctrl.loading"><i class="fa fa-spinner"></i> <span translate>Loading</span>...</div><button type=button ui-sref=login class="btn btn-group btn-dark btn-animated"><i class="fa fa-times"></i> <span translate>Cancel</span></button> <button type=submit id=passResetButton class="btn btn-group btn-success btn-animated pull-right" ng-if=!vm.loading><i class="fa fa-check"></i> <span translate>Confirm</span></button></div></div></form></div><!-- .subfooter start --><!-- ================ --><p class="mt-20 text-center"><i class="fa fa-info-circle"></i> <a href="mailto:support@farmhedge.io?subject=Portal login help">support@farmhedge.io</a></p><p class="mt-20 text-center">\xA9 FarmHedge 2022</p><!-- .subfooter end --></div></div></div></div></div>');
$templateCache.put('app/modules/customers/invites/customer-invites.html','<div class="invites-wrapper mb-5" ng-if=$ctrl.Invites.length><h5><span translate>Potential new customers</span></h5><p class=small><span translate>The following FarmHedge users asked to become your customer. You can accept or ignore their requests.</span></p><ul class="list-group-table row ml-0 pl-2 pr-2"><li class="list-table-item-header col-md-12 hidden-md-down"><div class="col col-md-1"></div><div class="col col-md-3"><i class="fa fa-user"></i> <small translate>User</small></div><div class="col col-md-3"><small translate>Message from user</small></div><div class="col col-md-2 pl-0"><i class="fa fa-calendar"></i> <small translate>Date</small></div><div class="col col-md-3"></div></li><li class="list-table-item row mt-2 mb-2" ng-repeat="inv in $ctrl.Invites"><div class="col col-2 col-md-1 p-1"><img ng-src="{{inv.imageUrl || \'app/shared/images/team-member.jpg\'}}" ng-error-src=app/shared/images/team-member.jpg class=ml-2 width=30 alt=""></div><div class="col col-md-3 col-10"><b>{{inv.createdBy.name.first}} {{inv.createdBy.name.last}}</b><div class=small><span translate>From</span> {{inv.createdBy.address.zipcode}}</div></div><div class="col col-md-3 col-12 pr-2 pl-2 pt-1 text-primary"><sup><i class="fa fa-quote-left"></i></sup> {{inv.message}} <sub><i class="fa fa-quote-right"></i></sub></div><div class="col col-md-2 hidden-md-down">{{$ctrl.utils.getLocalizedDate(inv.createdAt)}}</div><div class="col col-md-3 col-12 text-right"><button class="btn btn-sm btn-secondary p-2" ng-click=$ctrl.ignore(inv)><i class="fa fa-times"></i> <span translate>Ignore</span></button> <button class="btn btn-sm btn-success p-2" ng-click=$ctrl.accept(inv)><i class="fa fa-check"></i> <span translate>Accept customer</span></button></div></li></ul></div>');
$templateCache.put('app/modules/dashboard/slider/slider.tpl.html','<div class="owl-carousel content-slider"><div class="overlay-container overlay-visible" ng-repeat="slide in ctrl.slides"><img ng-src={{slide.img}} title={{slide.title}} data-index=$index alt=""><div class="overlay-bottom hidden-xs"><div class=text><h3 class=title>{{slide.title}}</h3>{{slide.text}}</div></div><a href={{slide.img}} class="owl-carousel--popup-img overlay-link" title="image title"><i class="fa fa-plus-circle"></i></a></div></div>');
$templateCache.put('app/modules/deals/deal-list/deals.list.html','<section class=light-gray-bg><div class="container mt-20"><h5 class=pb-1><i class="fa fa-play-circle-o"></i> <span ng-if=vm.utils.isSupplierDistributor() translate>Offers sent</span> <span ng-if=!vm.utils.isSupplierDistributor()><span translate>Farmers offers</span></span> <button ng-if=vm.utils.getSettings().isInternational type=button class="btn btn-link btn-sm" ng-click=vm.startIntro()><i class="fa fa-info-circle"></i> <span translate>Tutorial</span></button></h5><div class=row><div class=col-md-9><ul class="nav nav-tabs style-4" role=tablist><li class=nav-item><a class=nav-link ng-class="{\'active\': vm.isTypeDraft() }" ng-click="vm.switchTo({ type: \'DRAFT\' })" role=tab data-toggle=tab><i class="fa fa fa-pencil pr-2"></i><span translate>Drafts</span></a></li><li class=nav-item><a class=nav-link ng-class="{\'active\': vm.isTypeActive() }" ng-click="vm.switchTo({ type: \'ACTIVE\' })" role=tab data-toggle=tab><i class="fa fa-play-circle-o pr-2"></i> <span translate>Live</span> ({{$root.app.Stats.deals.live.count}})</a></li><li class=nav-item><a class=nav-link ng-class="{\'active\': vm.isTypeExpired() }" ng-click="vm.switchTo({ type: \'EXPIRED\' })" role=tab data-toggle=tab><i class="fa fa-check-square-o pr-2"></i><span translate>Past</span></a></li></ul><div class=tab-content><div class="tab-pane fade" ng-class="{\'show active\': vm.isTypeDraft() }" id=drafts role=tabpanel><div style=float:left><span translate>Not visible to farmers yet.</span></div></div><div class="tab-pane fade" ng-class="{\'show active\': vm.isTypeActive() }" id=liveOffers role=tabpanel><div style=float:left><div class=badge-live style=float:left><img src=app/shared/images/deal_live.gif width=30> <span translate>LIVE</span></div><span translate>Currently active offers.</span> <button class="btn btn-sm btn-link" ng-click=vm.refresh() analytics-on=click analytics-event="Refresh list live"><span translate>Refresh</span></button></div></div><div class="tab-pane fade" ng-class="{\'show active\': vm.isTypeExpired() }" id=pastOffers role=tabpanel><div style=float:left><span translate>These offers are not active anymore. Most recent offers are on top.</span></div></div></div></div><div id=deals-list-create-button class="col text-right hidden-sm-down"><button ng-if=!vm.hasMultipleChoiceCreateNew() class="btn btn-success p-3 mt-0 ml-0" type=button ng-click=vm.createOffer()><i class="fa fa-plus-circle pr-10"></i> <span translate>Create new offer</span></button><div class="btn-group dropdown" ng-if=vm.hasMultipleChoiceCreateNew()><button class="btn btn-success p-3 mt-0 dropdown-toggle" type=button id=createNewDraftButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fa fa-plus-circle pr-10"></i> <span translate>Create New</span></button><div class="dropdown-menu dropdown-menu-right" aria-labelledby=createNewDraftButton><a id=createNewSaleOfferButton class="dropdown-item text-sale-offer" ng-click=vm.createNewSaleOffer() analytics-on=click analytics-event="Create deal"><i class="fa fa-shopping-cart pr-10"></i> <span translate>New sale offer</span></a> <a id=createNewCropOfferButton class="dropdown-item text-crop-offer" ng-click=vm.createNewCropOffer() analytics-on=click analytics-event="Create crop"><i class="fa fa-leaf pr-10"></i> <span translate>New crop offer</span></a></div></div></div></div><div class="alert alert-info text-center row-clickable mt-2 mb-0" ng-if="vm.isTypeActive() && vm.productPublicCount" ng-click=vm.goToProducts()><i class="fa fa-cubes"></i> <span translate><b>{{vm.productPublicCount}}</b> products visible to customers</span></div><div class=row><div class=col-lg-12><!-- <br /> --><!-- <div class="separator-2 mt-20"></div> --><div class="col-md-12 padding-hor-clear table-responsive mt-3" id=deals-table><table class="table table-hover"><thead><tr class=bold style="font-size: 90%"><th style="min-width: 40px"></th><th></th><th style="min-width: 230px" translate>Product</th><th class=pl-0><span translate>Sale price</span></th><th style="min-width: 70px"><i class="fa fa-user"></i></th><th style="min-width: 160px"><i class="fa fa-calendar"></i></th><th ng-if=vm.isTypeDraft()><span translate>Quantity</span></th><th ng-if=vm.isTypeActive()><i class="fa fa-tachometer"></i> <span translate>Progress</span></th><th ng-if=vm.isTypeExpired()><i class="fa fa-check-circle"></i> <span translate>Result</span></th><th><div ng-if=!vm.isTypeDraft()><i class="fa fa-list-ul"></i> <span translate>Orders</span></div></th></tr></thead><tbody data-ng-repeat="d in vm.deals"><tr class=row-clickable ng-click=vm.toggleRowExpanded(d) ng-class="{\'deal-list-row-selected\': vm.expandedRowId === d._id, \'text-muted\': vm.isTypeActive(d) && vm.dealsService.isBookingStartInTheFuture(d)}"><td class="p-10 m-0 pl-2 pr-2"><div class=mt-10><span ng-if=vm.isCategoryCrop(d) uib-tooltip="{{\'Crop deal\'|translate}}"><img style=float:left src=app/shared/images/crop_icon.png width=30> </span><span ng-if=!vm.isCategoryCrop(d) uib-tooltip="{{\'Sale offer\'|translate}}"><img style=float:left src=app/shared/images/deal_icon.png width=30></span></div></td><td class="pr-0 pl-0" style="width: 100px; height: 80px"><img style="min-height: 35px; max-height: 80px; max-width: 100px" ng-src="{{d.imageUrl ? d.imageUrl : vm.DEAL_CONSTANTS.DEFAULT_IMAGE}}" ng-error-src=app/shared/images/fallback_image.png alt=""></td><td class=pr-0 style="max-width: 250px"><div ng-if="vm.isTypeActive(d) && vm.dealsService.isBookingStartInTheFuture(d)" class=text-warning><i class="fa fa-play-circle"></i> <strong><span translate>Deal start</span>: {{vm.utils.getLocalizedDate(d.bookingStart)}}</strong></div><div><b>{{d.product.name}}</b> <i class="fa fa-bullhorn text-sale-offer" ng-if=d.requests.length uib-tooltip="{{\'Customer request\'|translate}}"></i></div><div ng-if=d.variants.length class=text-info>{{d.variants.length}} <span translate>Additional variants</span></div><div class=small><span>{{d.customType}}</span></div><div ng-if=d.distributorDeal class=text-sale-offer><i class="fa fa-arrow-circle-down"></i> <span translate>From distributor</span></div><div ng-if=d.vendorProductId><span class="small text-muted"><span translate>Product ID</span>:</span> {{d.vendorProductId}}</div></td><td class=pl-0><span ng-if=d.benchmarkPrice ng-switch=vm.utils.isNumber(d.benchmarkPrice)><span ng-switch-when=false>{{d.benchmarkPrice}}</span> <span ng-switch-when=true>{{vm.utils.getLocalizedCurrency(d.benchmarkPrice-d.benchmarkPrice*d.clearanceDiscount/100, d.priceDecimalDigits)}}</span> </span><span ng-if="d.benchmarkPrice && !vm.utils.isNumber(d.benchmarkPrice)"></span><div><small ng-if="!vm.isCategoryCrop(d) && (d.individualDiscount || d.clearanceDiscount)" class=text-muted><span translate>Discount</span>: <span ng-if="!vm.dealsService.isQuantityDiscountEnabled(d) && !vm.dealsService.isGroupDiscountEnabled(d)">{{d.individualDiscount|number:0}}%</span><div ng-if=vm.dealsService.isQuantityDiscountEnabled(d)><i class="fa fa-signal"></i> {{d.individualDiscount|number:0}}%&nbsp;~&nbsp;{{d.clearanceDiscount|number:0}}%</div></small></div><div class=small ng-if=d.payment.isRequired><i class="fa fa-credit-card"></i> <span translate>Card payment</span></div><div ng-if=d.paymentMethod class=small uib-tooltip="{{\'Incoterms\'|translate}}" tooltip-placement=bottom>{{d.paymentMethod}}</div></td><td><div ng-if=!vm.utils.isSupplierDistributor()>{{d.users.length}}</div><div ng-if=vm.utils.isSupplierDistributor()>{{d.retailPrices.length}}</div><small ng-if="d.target === vm.DEAL_TARGET.NEW_USERS" uib-tooltip="{{\'Include new customers\'|translate}}"><i class="fa fa-user-plus"></i></small><div class="small text-muted" ng-if="!vm.isTypeDraft() && !vm.utils.isSupplierDistributor()"><i class="fa fa-eye"></i> {{d.stats.views.total}}</div></td><td class=pl-0><div class=mb-3><div ng-if=d.isStopped><span class="chip text-warning" translate>Offer stopped</span></div><div><countdown caption="\'Ends in:\'|translate" date-time=d.bookingEnd></countdown></div><div class=small>{{vm.utils.getLocalizedDate(d.bookingEnd)}}</div><div ng-if="d.bookingEndDiff.days < 1 && !d.soldOut && vm.utils.isSupplierDistributor()"><button class="btn btn-outline-secondary text-muted btn-sm" ng-click=vm.extendDeal(d)><span translate>Extend</span>?</button></div></div><div class=small ng-if="d.distribution === \'collection\'" uib-tooltip="{{\'Collection\'|translate}}" tooltip-placement=bottom><i class="text-info fa fa-home"></i> {{vm.utils.getLocalizedDate(d.deliveryEnd)}}</div><div class=small ng-if="d.distribution === \'delivery\'" uib-tooltip="{{\'Delivery\'|translate}}" tooltip-placement=bottom><i class="text-warning fa fa-truck"></i> {{vm.utils.getLocalizedDate(d.deliveryEnd)}}</div></td><td ng-if=vm.isTypeDraft()><span ng-if=d.hasDealSize>{{d.dealSize}}</span> <small>{{d.customUnit}}</small><div class="small mt-2" ng-if="d.dealSizeOptions.step > 1"><span translate>Step</span>:&nbsp;{{d.dealSizeOptions.step}} <span ng-if=d.dealSizeOptions.max>- <span translate>Max</span>:&nbsp;{{d.dealSizeOptions.max}}</span></div></td><td ng-if=!vm.isTypeDraft()><div>{{(d.progress - (d.amountReserved || 0))}}<span ng-if=d.hasDealSize>&nbsp;/&nbsp;{{d.dealSize}}</span> <small>{{d.customUnit}}</small></div><div ng-if=d.hasDealSize class="progress style-1 mt-0 mb-1"><div class="progress-bar bg-success" role=progressbar aria-valuemin=0 aria-valuemax=100 style="width: {{100*(d.progress - (d.amountReserved || 0))/d.dealSize}}%"></div><div class="progress-bar bg-warning" role=progressbar aria-valuemin=0 aria-valuemax=100 style="width: {{100*(d.amountReserved || 0)/d.dealSize}}%"></div></div><div ng-if="vm.isTypeActive() && vm.utils.isSupplierDistributor()" class=small><span translate>Reserved</span>:&nbsp;{{d.amountReserved}}</div><div ng-if=d.hasDealSize><div ng-if=!d.soldOut class=small><span translate>Available</span>:&nbsp;{{d.dealSize - d.progress | number:0}}</div><div ng-if="d.soldOut && vm.isTypeActive()"><span class=text-warning translate>Sold out</span></div><div ng-if="d.soldOut && vm.isTypeDraft() && vm.utils.isSupplierDistributor()"><button class="btn btn-outline-secondary text-muted btn-sm" ng-click=vm.extendDeal(d)><span translate>Extend</span>?</button></div></div><div class="small mt-2" ng-if="d.dealSizeOptions.step > 1"><span translate>Step</span>:&nbsp;{{d.dealSizeOptions.step}} <span ng-if=d.dealSizeOptions.max>- <span translate>Max</span>:&nbsp;{{d.dealSizeOptions.max}}</span></div></td><td style="width: 150px"><div ng-if="vm.isTypeDraft() || (vm.isTypeActive() && vm.dealsService.isBookingStartInTheFuture(d))" ng-click=vm.goToEditIfDraft(d)><button class="btn btn-info"><i class="fa fa-edit"></i> <span translate>Edit</span></button></div><div ng-if=!vm.isTypeDraft() ui-sref="app.deals.report({id: d._id, order: \'all\'})"><div class="order-status invalid mb-1" ng-if="d.ordersCount[\'RESERVED\']">{{d.ordersCount[\'RESERVED\']}} <span ng-if="d.ordersCount[\'RESERVED\'] === 1" translate>reservation</span> <span ng-if="d.ordersCount[\'RESERVED\'] !== 1" translate>reservations</span></div><div class="order-status pending" ng-if="d.ordersCount[\'PENDING\']"><span translate>Pending</span><br>{{d.ordersCount[\'PENDING\']}} <span ng-if="d.ordersCount[\'PENDING\'] === 1" translate>order</span> <span ng-if="d.ordersCount[\'PENDING\'] !== 1" translate>orders</span></div><div class="order-status paid p-2" ng-if="d.ordersCount[\'PAID\'] && !d.ordersCount[\'PENDING\']">{{d.ordersCount[\'PAID\']}} <span ng-if="d.ordersCount[\'PAID\'] === 1" translate>order</span> <span ng-if="d.ordersCount[\'PAID\'] !== 1" translate>orders</span></div><div class="order-status completed" ng-if="d.ordersCount[\'COMPLETED\'] && !d.ordersCount[\'PENDING\'] && !d.ordersCount[\'PAID\']"><span translate>Completed</span><br>{{d.ordersCount[\'COMPLETED\']}} <span ng-if="d.ordersCount[\'COMPLETED\'] === 1" translate>order</span> <span ng-if="d.ordersCount[\'COMPLETED\'] !== 1" translate>orders</span></div></div></td></tr><tr class="deal-list-row-selected hidden-sm-down" style="background-color: white"><td colspan=9 class="pl-0 pr-0 pb-5 m-0" ng-if="vm.expandedRowId === d._id"><deal-details deal=d load-deals=vm.refresh></deal-details></td></tr></tbody></table><div ng-if=!vm.deals.length class=text-center translate>No offers available.</div><div class=row ng-if=vm.paging class=text-center><div class="col-md-12 col-lg-8"><ul uib-pagination class=pagination-sm first-text="{{\'First\'|translate}}" previous-text="{{\'Prev\'|translate}}" next-text="{{\'Next\'|translate}}" last-text="{{\'Last\'|translate}}" ng-change=vm.onPage() total-items=vm.paging.count ng-model=vm.paging.current max-size=vm.paging.maxSize items-per-page=vm.paging.itemsPerPage boundary-link-numbers=true boundary-links=true></ul></div></div></div></div></div></div></section>');
$templateCache.put('app/modules/deals/deal-map/deals.map.html','<!-- <div class="row mb-1">\n    <div class="col-1 pr-0">\n        <img class="pull-right" style="width: 60%;" src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png">\n    </div>\n    <small class="col-5 pl-0" translate> = Included</small>\n    <div class="col-1 pr-0">\n        <img class="pull-right" style="width: 60%;" src="http://maps.google.com/mapfiles/ms/icons/yellow-dot.png">\n    </div>\n    <small class="col-5 pl-0" translate> = Excluded</small>\n</div> --><ng-form><div class="form-group text-center"><ui-gmap-google-map ng-if=$ctrl.map center=$ctrl.map.center zoom=$ctrl.map.zoom dragging=$ctrl.map.dragging bounds=$ctrl.map.bounds events=$ctrl.map.events options=$ctrl.map.options pan=true control=$ctrl.map.control><ui-gmap-search-box options=$ctrl.searchBox.options template=$ctrl.searchBox.template events=$ctrl.searchBox.events position=$ctrl.searchBox.position></ui-gmap-search-box><ui-gmap-markers models=$ctrl.map.markers coords="\'self\'" icon="\'icon\'" click="\'onClicked\'" type="$ctrl.users.length > 30 ? \'cluster\' : \'\'" typeoptions="{\'gridSize\':50, \'minimumClusterSize\': 5}" events=$ctrl.markerEevents></ui-gmap-markers><ui-gmap-window show=window.show coords=window.coords idkey=window.place_id templateurl=window.templateurl templateparameter=window.templateparameter options=window.options closeclick=$ctrl.window.closeClick() ng-cloak></ui-gmap-window><ui-gmap-circle ng-if="$ctrl.utils.isFeatureEnabled(\'DEAL_MAP_CIRCLE\')" ng-repeat="c in $ctrl.map.circles track by c.id" center=c.center stroke=c.stroke fill=c.fill radius=c.radius events=c.events></ui-gmap-circle></ui-gmap-google-map></div><div class=row><!-- <div class="form-group col-md-6"  ng-class="{\'has-error\': radius.$invalid }">\n            <label for="radius" translate>Radius</label>\n            <div class="input-group">\n                <span class="input-group-addon"><i class="fa fa-km"></i></span>\n                <input type="number"\n                       name="radius"\n                       class="form-control"\n                       id="radius"\n                       data-ng-model="$ctrl.radius"\n                       aria-describedby="size"\n                       min="1"\n                       step="1"\n                       ng-disabled="$ctrl.target === $ctrl.DEAL_TARGET.NEW_USERS"\n                       required>\n            </div>\n        </div> --><div class="col-sm-12 col-md-6"><div class=form-group><label for=system translate>Farm system</label><select class=form-control name=system id=system ng-model=$ctrl.system ng-options="op.value as op.label for op in $ctrl.lookup.farmSystems"></select></div><div ng-if=$ctrl.allUsersFound.length><div>{{$ctrl.users.length}} / {{$ctrl.allUsersFound.length}} <span translate>farmer(s) selected</span></div><div><a class="btn btn-sm btn-info text-white" ng-click=$ctrl.viewUsers()><i class="fa fa-users"></i> <span translate>Select farmers</span></a></div></div><div ng-if=!$ctrl.allUsersFound.length><div><strong><span class=text-danger translate>No farmers found</span></strong></div><div><a type=button ng-click=$ctrl.resetFilters() class="btn btn-sm btn-warning"><span translate>Reset filters</span></a></div></div></div><div class="form-group col-md-6"><label translate>Farm type filter</label><i class="fa fa-question-circle" uib-tooltip="{{\'Select farmers based on their farm type\'|translate}}"></i><ui-select multiple ng-model=$ctrl.farmTypes theme=bootstrap ng-disabled=$ctrl.ftDisabled sortable close-on-select=false style="width: 100%"><ui-select-match placeholder="{{\'Select farm type...\'|translate}}">{{$item.label}}</ui-select-match><ui-select-choices repeat="type.value as type in $ctrl.lookup.farmTypes | propsFilter: {label: $select.search}"><div ng-bind-html="type.label | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></ng-form>');
$templateCache.put('app/modules/deals/deal-report/deals.report.html','<section class="white-bg pv-30 clearfix"><div class=container><h5><span translate>Offer details</span></h5><!-- TODO: merge with deal list row --><div class=table-responsive><table class="table mb-0"><thead><tr class=bold style="font-size: 90%"><th style="min-width: 40px"></th><th></th><th style="min-width: 230px" translate>Product</th><th class=pl-0><span translate>Sale price</span></th><th style="min-width: 70px"><i class="fa fa-user"></i></th><th style="min-width: 160px" class="text-left pl-0"><i class="fa fa-calendar"></i> <span translate>Offer end</span></th><th><i class="fa fa-check-circle"></i> <span translate>Progress</span></th></tr></thead><tbody><tr><td class="p-10 m-0 pl-2 pr-2"><div class=mt-10><span ng-if=vm.isCategoryCrop(d) uib-tooltip="{{\'Crop deal\'|translate}}"><img style=float:left src=app/shared/images/crop_icon.png width=30> </span><span ng-if=!vm.isCategoryCrop(d) uib-tooltip="{{\'Sale offer\'|translate}}"><img style=float:left src=app/shared/images/deal_icon.png width=30></span></div></td><td class="pr-0 pl-0" style="width: 100px; height: 80px"><img style="min-height: 35px; max-height: 80px; max-width: 100px" ng-src="{{vm.deal.imageUrl ? vm.deal.imageUrl : vm.DEAL_CONSTANTS.DEFAULT_IMAGE}}" ng-error-src=app/shared/images/fallback_image.png alt=""></td><td class=pr-0 style="max-width: 250px"><div ng-if="vm.isTypeActive(d) && vm.dealsService.isBookingStartInTheFuture(d)" class=text-warning><i class="fa fa-play-circle"></i> <strong><span translate>Deal start</span>: {{vm.utils.getLocalizedDate(vm.deal.bookingStart)}}</strong></div><div><b>{{vm.deal.product.name}}</b> <i class="fa fa-bullhorn text-sale-offer" ng-if=vm.deal.requests.length uib-tooltip="{{\'Customer request\'|translate}}"></i></div><div ng-if=vm.deal.variants.length class=text-info>{{vm.deal.variants.length}} <span translate>Additional variants</span></div><div class=small><span>{{vm.deal.customType}}</span></div><div ng-if=vm.deal.distributorDeal class=text-sale-offer><i class="fa fa-arrow-circle-down"></i> <span translate>From distributor</span></div><div ng-if=vm.deal.vendorProductId><span class="small text-muted"><span translate>Product ID</span>:</span> {{vm.deal.vendorProductId}}</div></td><td class=pl-0><span ng-if=vm.deal.benchmarkPrice ng-switch=vm.utils.isNumber(vm.deal.benchmarkPrice)><span ng-switch-when=" false">{{vm.deal.benchmarkPrice}}</span> <span ng-switch-when=true>{{vm.utils.getLocalizedCurrency(vm.deal.benchmarkPrice-vm.deal.benchmarkPrice*vm.deal.clearanceDiscount/100, vm.deal.priceDecimalDigits)}}</span> </span><span ng-if="vm.deal.benchmarkPrice && !vm.utils.isNumber(vm.deal.benchmarkPrice)"></span><div><small ng-if="!vm.isCategoryCrop(d) && (vm.deal.individualDiscount || vm.deal.clearanceDiscount)" class=text-muted><span translate>Discount</span>: <span ng-if=!vm.dealsService.isQuantityDiscountEnabled(d)>{{vm.deal.individualDiscount|number:0}}%</span><div ng-if=vm.dealsService.isQuantityDiscountEnabled(d)><i class="fa fa-signal"></i> {{vm.deal.individualDiscount|number:0}}%&nbsp;~&nbsp;{{vm.deal.clearanceDiscount|number:0}}%</div></small></div><div class=small ng-if=vm.deal.payment.isRequired><i class="fa fa-credit-card"></i> <span translate>Card payment</span></div><div ng-if=vm.deal.paymentMethod class=small uib-tooltip="{{\'Incoterms\'|translate}}" tooltip-placement=bottom>{{vm.deal.paymentMethod}}</div></td><td><div ng-if=!vm.utils.isSupplierDistributor()>{{vm.deal.users.length}}</div><div ng-if=vm.utils.isSupplierDistributor()>{{vm.deal.retailPrices.length}}</div><small ng-if="vm.deal.target === vm.DEAL_TARGET.NEW_USERS" uib-tooltip="{{\'Include new customers\'|translate}}"><i class="fa fa-user-plus"></i></small><div class="small text-muted" ng-if="!vm.isTypeDraft() && !vm.utils.isSupplierDistributor()"><i class="fa fa-eye"></i> {{vm.deal.stats.views.total}}</div></td><td class=pl-0><div class=mb-3><div><countdown caption="\'Ends in:\'|translate" date-time=vm.deal.bookingEnd></countdown></div><div class=small>{{vm.utils.getLocalizedDate(vm.deal.bookingEnd)}}</div><div ng-if="vm.deal.bookingEndDiff.days < 1 && !vm.deal.soldOut && vm.utils.isSupplierDistributor()"><button class="btn btn-outline-secondary text-muted btn-sm" ng-click=vm.extendDeal(d)><span translate>Extend</span>?</button></div></div><div class=small ng-if="vm.deal.distribution === \'collection\'" uib-tooltip="{{\'Collection\'|translate}}" tooltip-placement=bottom><i class="text-info fa fa-home"></i> {{vm.utils.getLocalizedDate(vm.deal.deliveryEnd)}}</div><div class=small ng-if="vm.deal.distribution === \'delivery\'" uib-tooltip="{{\'Delivery\'|translate}}" tooltip-placement=bottom><i class="text-warning fa fa-truck"></i> {{vm.utils.getLocalizedDate(vm.deal.deliveryEnd)}}</div></td><td ng-if=vm.isTypeDraft()><span ng-if=vm.deal.hasDealSize>{{vm.deal.dealSize}}</span> <small>{{vm.deal.customUnit}}</small></td><td ng-if=!vm.isTypeDraft()><div>{{(vm.deal.progress - (vm.deal.amountReserved || 0))}}<span ng-if=vm.deal.hasDealSize>&nbsp;/&nbsp;{{vm.deal.dealSize}}</span> <small>{{vm.deal.customUnit}}</small></div><div ng-if=vm.deal.hasDealSize class="progress style-1 mt-0 mb-1"><div class="progress-bar bg-success" role=progressbar aria-valuemin=0 aria-valuemax=100 style="width: {{100*(vm.deal.progress - (vm.deal.amountReserved || 0))/vm.deal.dealSize}}%"></div><div class="progress-bar bg-warning" role=progressbar aria-valuemin=0 aria-valuemax=100 style="width: {{100*(vm.deal.amountReserved || 0)/vm.deal.dealSize}}%"></div></div><div ng-if="vm.isTypeActive() && vm.utils.isSupplierDistributor()" class=small><span translate>Reserved</span>:&nbsp;{{vm.deal.amountReserved}}</div><div ng-if=vm.deal.hasDealSize><div ng-if=!vm.deal.soldOut class=small><span translate>Available</span>:&nbsp;{{vm.deal.dealSize - vm.deal.progress | number:0}}</div><div ng-if="vm.deal.soldOut && vm.isTypeActive()"><span class=text-warning translate>Sold out</span></div><div ng-if="vm.deal.soldOut && vm.isTypeDraft() && vm.utils.isSupplierDistributor()"><button class="btn btn-outline-secondary text-muted btn-sm" ng-click=vm.extendDeal(d)><span translate>Extend</span>?</button></div></div><div class="small mt-2" ng-if="vm.deal.dealSizeOptions.step > 1"><span translate>Step</span>:&nbsp;{{vm.deal.dealSizeOptions.step}} <span ng-if=vm.deal.dealSizeOptions.max>- <span translate>Max</span>:&nbsp;{{vm.deal.dealSizeOptions.max}}</span></div></td></tr></tbody></table></div><div ng-if=vm.deal><div ng-if=vm.dealsService.isActive(vm.deal) class="alert alert-success text-center mt-0 mb-3"><img style="display: inline" class=pl-10 src=app/shared/images/deal_live.gif width=30> <span translate>Live</span></div><div ng-if=!vm.dealsService.isActive(vm.deal) class="alert alert-warning text-center mt-0 mb-3"><span ng-if=!vm.deal.isStopped translate>Offer expired</span> <span ng-if=vm.deal.isStopped translate>Offer stopped</span></div></div><div ng-if=vm.deal class=card><deal-details deal=vm.deal load-deals=vm.refresh hide-report-button=true></deal-details><distributor-deal class="form-group col-md-12" deal=vm.deal.distributorDeal product=vm.deal.product></distributor-deal></div><div class="small float-right mt-5" ng-if=vm.invalidOrdersCount><input type=checkbox id=areInvalidOrdersVisible ng-change=vm.toggleInvalidOrders() ng-model=vm.areInvalidOrdersVisible class=switch-input><label for=areInvalidOrdersVisible class=switch-label><span translate>Show rejected/invalid orders</span> ({{vm.invalidOrdersCount}})</label></div><h4 class=mt-5 id=orders-section><span translate>Orders</span> ({{vm.orders.length}})</h4><div class="alert alert-warning alert-icon ml-5 mr-5" ng-if=!vm.orders.length><i class="fa fa-times-circle"></i> <span translate>No orders</span></div><div class="card card-gray col-12 mt-10" ng-if=vm.orders.length><div class="card-body p-20"><div class="row mb-1 p-2 hidden-sm-down"><div class=col-2><strong translate>Order ID</strong></div><div class=col-3><i class="fa fa-user"></i> <strong translate>Customer</strong></div><div class=col-2><strong translate>Unit price</strong></div><div class=col-1><strong translate>Qty</strong></div><div class=col-2><strong translate>Total</strong></div><div class="col-2 text-center"><strong translate>Status</strong></div></div><div ng-if=!vm.orders.length class=text-center><div class=order-pending><span translate>No pending orders</span></div></div><div class="row mb-1 p-2 row-clickable" ng-repeat="order in vm.orders" ng-click=vm.openOrderDetails(order) ng-class="{\'text-disabled\': vm.isOrderInvalid(order)}"><div class="col-md-2 col-sm-12">{{order.ref}}<div><small>{{vm.utils.getLocalizedDateAndTime(order.date)}}</small></div></div><div class="col-md-3 col-sm-12"><div ng-if="vm.utils.isSupplierDistributor() && order.retailer"><strong>{{order.retailer.name}}</strong></div>{{order.user.name.first}} {{order.user.name.last}}<div ng-if=!vm.utils.isSupplierDistributor()><small><span translate>Customer ID</span>: {{order.user.customerId || \'---\'}}</small></div></div><div class="col-md-2 col-sm-6"><div ng-if=order.unitPrice>{{vm.utils.getLocalizedCurrency(order.unitPrice, order.priceDecimalDigits)}}<div class=small>/&nbsp; <span ng-if=order.deal>{{vm.deal.customUnit}}</span> <span ng-if=!order.deal translate>Unit</span></div><div ng-if=order.discountPercent class="small text-warning">{{order.discountPercent | number:1}}% <span translate>discount</span></div></div><div ng-if="!order.unitPrice && order.unitPriceText">{{order.unitPriceText}}</div><div ng-if="!order.unitPrice && !order.unitPriceText" class=text-muted><span translate>Price as agreed</span></div><div ng-if=vm.deal.variants.length class=small>{{order.product.name}}</div></div><div class="col-md-1 col-sm-4"><small class=hidden-md-up><span translate>Qty</span>:</small> {{order.amount}}</div><div class="col-md-2 col-sm-12"><div ng-if="order.totalPrice || order.unitPrice">{{vm.utils.getLocalizedCurrency(order.totalPrice || order.unitPrice * order.amount)}}</div><div ng-if="!order.totalPrice && !order.unitPrice"><span translate>Price as agreed</span></div></div><div class="col-md-2 col-sm-12"><div ng-if=vm.isOrderInvalid(order) class="p-1 text-center order-status invalid"><span translate>Invalid</span></div><div ng-if="order.status === vm.ORDER_STATUS.PENDING" class="p-1 text-center order-status pending"><span translate>Pending</span></div><div ng-if="order.status === vm.ORDER_STATUS.DELIVERED" class="p-1 text-center order-status completed"><span translate>Delivered</span></div><div ng-if="order.status === vm.ORDER_STATUS.PAID" class="p-1 text-center order-status paid"><span translate>Paid</span></div><div ng-if="order.status === vm.ORDER_STATUS.COMPLETED" class="p-1 text-center order-status completed"><span translate>Completed</span></div><div ng-if="order.status === vm.ORDER_STATUS.FORWARDED" class="p-1 text-center order-status completed"><span translate>Forwarded</span></div><div ng-if="order.status === vm.ORDER_STATUS.REJECTED" class="p-1 text-center order-status rejected"><span translate>Rejected</span></div></div></div></div></div><div class="card card-gray col-12 mt-10" ng-if=vm.orders.length><div class="card-body p-20"><div class="row p-2"><div class="col-md-2 col-sm-12"><strong translate>Total</strong></div><div class="col-md-5 col-sm-12"><span ng-if="vm.orders.length === 1" translate>{{vm.orders.length}} order</span> <span ng-if="vm.orders.length !== 1" translate>{{vm.orders.length}} orders</span></div><div class="col-md-1 col-sm-12"><small class=hidden-md-up><span translate>Qty</span>:</small> {{vm.allOrdersQuantity | number:0}}</div><div class="col-md-2 col-sm-12" ng-if=vm.allOrdersAmount><small class=hidden-md-up><span translate>Amount</span>:</small> {{vm.utils.getLocalizedCurrency(vm.allOrdersAmount)}}</div></div></div></div></div></section>');
$templateCache.put('app/modules/deals/deal-request/deals.request.html','<section class=light-gray-bg><div class="container mt-20"><div class=row><h5 class=col-md-6><i class="fa fa-bullhorn"></i> <span translate>Requests</span> <button class="btn btn-sm btn-link" ng-click=$ctrl.onPage()><span translate>Refresh</span></button></h5><div class="col-md-6 text-right" ng-if=$ctrl.utils.getSettings().canSendRequests><button ng-if=!$ctrl.utils.isSupplierDistributor() type=button class="btn btn-outline-success btn-animated" ui-sref=app.offers.search><i class="fa fa-plus-circle"></i> <span translate>Send new request</span></button> <button ng-if=$ctrl.utils.isSupplierDistributor() type=button class="btn btn-outline-success btn-animated" ui-sref=app.offers.received><i class="fa fa-plus-circle"></i> <span translate>Send new request</span></button></div></div><div class=tab-content><div class=row><div class=col-lg-5 ng-if=$ctrl.utils.getSettings().canSendRequests><ul class="nav nav-tabs style-4" role=tablist><li class=nav-item><a class=nav-link ng-class="{\'active\': $ctrl.filters.role === $ctrl.FILTER_ROLES.DISTRIBUTOR }" ng-click="$ctrl.switchTo({ role: $ctrl.FILTER_ROLES.DISTRIBUTOR })" role=tab data-toggle=tab><span translate>Received</span> ({{$root.app.Stats.requests.new.count}})</a></li><li class=nav-item><a class=nav-link ng-class="{\'active\': $ctrl.filters.role === $ctrl.FILTER_ROLES.RETAILER }" ng-click="$ctrl.switchTo({ role: $ctrl.FILTER_ROLES.RETAILER })" role=tab data-toggle=tab><span translate>Sent</span></a></li></ul></div><div class=col-lg-5><ul class="nav nav-tabs style-4" role=tablist><li class=nav-item><a class=nav-link ng-class="{\'active\': $ctrl.filters.type === $ctrl.FILTER_TYPES.ANY }" ng-click="$ctrl.switchTo({ type: $ctrl.FILTER_TYPES.ANY })" role=tab data-toggle=tab><span translate>Any type</span></a></li><li class=nav-item><a class=nav-link ng-class="{\'active\': $ctrl.filters.type === $ctrl.FILTER_TYPES.PURCHASE }" ng-click="$ctrl.switchTo({ type: $ctrl.FILTER_TYPES.PURCHASE })" role=tab data-toggle=tab><i class="fa fa-shopping-cart"></i> <span translate>Buy</span></a></li><li class=nav-item><a class=nav-link ng-class="{\'active\': $ctrl.filters.type === $ctrl.FILTER_TYPES.SALE }" ng-click="$ctrl.switchTo({ type: $ctrl.FILTER_TYPES.SALE })" role=tab data-toggle=tab><i class="fa fa-money"></i> <span translate>Sell</span></a></li></ul></div><div class=col-lg-5 ng-if=!$ctrl.utils.getSettings().canSendRequests></div></div></div><div class=requests-container><div class="padding-hor-clear col-md-12 table-wrapper table-responsive mt-20"><table id=requestsTable class="table table-hover"><thead><tr class=bold style="font-size: 90%"><th class=text-center style="width: 150px" translate>Date</th><th class=hidden-md-down ng-if="$ctrl.filters.role === $ctrl.FILTER_ROLES.DISTRIBUTOR"><span translate>Customer</span></th><th class=hidden-md-down ng-if="$ctrl.filters.role === $ctrl.FILTER_ROLES.RETAILER"><span translate>Recipient</span></th><th class=hidden-md-down><span translate>Type</span></th><th class=hidden-md-down style="width: 80px"></th><th><span translate>Product</span></th><th><span translate>Quantity</span></th><th class=hidden-md-down></th><th><span translate>Status</span></th></tr></thead><tbody><tr class=row-clickable ng-click=$ctrl.openRequestModal(request._id); data-ng-repeat="request in $ctrl.requests" ng-class="{\'text-disabled\': request.isGreyedOut, \'row-highlighted row-selected\': $ctrl.selectedRequestId === request._id}"><td class=text-center><div ng-if=request.isRecent><span class="btn btn btn-outline-info btn-sm m-0" translate>New</span></div>{{$ctrl.utils.getLocalizedDate(request.createdAt)}}<div ng-if="$ctrl.filters.role === $ctrl.FILTER_ROLES.RETAILER" class=small>{{request.createdBy.name.first + \' \' + request.createdBy.name.last}}</div></td><td class=hidden-md-down ng-if="$ctrl.filters.role === $ctrl.FILTER_ROLES.DISTRIBUTOR"><div ng-if=!request.retailer><img ng-src="{{request.createdBy.imageUrl || \'./app/shared/images/default-no-image.jpg\'}}" class="float-left mr-3" width=30> {{request.createdBy.name.first + \' \' + request.createdBy.name.last}}</div><div ng-if=request.retailer><img ng-src="{{request.retailer.imageUrl || \'./app/shared/images/default-no-image.jpg\'}}" class="float-left mr-3" width=50><div>{{request.retailer.name}}</div><small>{{request.createdBy.name.first + \' \' + request.createdBy.name.last}}</small></div></td><td class=hidden-md-down ng-if="$ctrl.filters.role === $ctrl.FILTER_ROLES.RETAILER">{{request.suppliers[0].name}}</td><td class=hidden-md-down><span ng-if="request.categoryName === \'CROP\'" uib-tooltip="{{\'Crop deal\'|translate}}"><img style="margin: 0 auto" src=app/shared/images/crop_icon.png width=30> </span><span ng-if="request.categoryName === \'DEAL\'" uib-tooltip="{{\'Sale offer\'|translate}}"><img style="margin: 0 auto" src=app/shared/images/deal_icon.png width=30></span><div class="text-grey mt-1"><span ng-if=!request.isPurchase translate>Buy</span> <span ng-if=request.isPurchase translate>Sell</span></div></td><td class="hidden-md-down pr-0"><img ng-src="{{request.product.imageUrls[0] || request.imageUrl || \'./app/shared/images/default-no-image.jpg\'}}" class="float-left mt-1" width=100%></td><td style="max-width: 300px">{{request.productName}}<div class=small>{{request.customType}}</div></td><td>{{request.quantity || \'--\'}}<div class=small>{{request.unit}}</div></td><td class=hidden-md-down style="max-width: 150px"><div ng-if=request.distribution><i ng-if=request.isDistributionCollection class="fa fa-home"></i> <i ng-if=!request.isDistributionCollection class="fa fa-truck"></i> {{request.distribution}}</div><div ng-if=request.lastMessage class=small ng-class="{\'text-primary\': !request.isGreyedOut}"><i class="fa fa-comment"></i> {{request.lastMessage.length > 70 ? (request.lastMessage.slice(0, 70) + \'...\') : request.lastMessage}}</div></td><td><status-badge status=request.status></status-badge></td></tr></tbody></table><div ng-if=!$ctrl.requests.length class="alert alert-warning"><i class="fa fa-info-circle"></i> <span translate>No requests found.</span></div><div class=row ng-if=$ctrl.paging class=text-center><div class="col-md-12 col-lg-8"><ul uib-pagination class=pagination-sm first-text="{{\'First\'|translate}}" previous-text="{{\'Prev\'|translate}}" next-text="{{\'Next\'|translate}}" last-text="{{\'Last\'|translate}}" ng-change=$ctrl.onPage() total-items=$ctrl.paging.count ng-model=$ctrl.paging.current max-size=3 items-per-page=$ctrl.paging.itemsPerPage boundary-link-numbers=true></ul></div></div></div></div></div></section>');
$templateCache.put('app/modules/deals/deal-suppliers/deals.suppliers.html','<h4 class=deal-suppliers-title ng-if=!$ctrl.hideSupplierSelection ng-class="{\'text-danger\': $ctrl.getEnableSuppliersCount() === 0}"><span translate>Select Target Suppliers</span> ({{$ctrl.getEnableSuppliersCount()}} / {{$ctrl.targetSuppliers.length}})</h4><div class="row mb-2 mt-2" ng-if="!$ctrl.hideSupplierSelection && !$ctrl.hidePrices"><div class=col-md-4><button type=button class="btn btn-sm text-warning mt-0" ng-click=$ctrl.resetRetailPrices() translate>Reset prices</button></div><div class="col-md-8 text-right"><button type=button class="btn btn-sm btn-outline-dark mt-0" ng-click=$ctrl.excludeAll()><i class="fa fa-times"></i> <span translate>Exclude all</span></button> <button type=button class="btn btn-sm btn-outline-success mt-0" ng-click=$ctrl.includeAll()><i class="fa fa-check"></i> <span translate>Include all</span></button></div></div><div class="mb-2 mt-2 text-right" ng-if="!$ctrl.hideSupplierSelection && $ctrl.hidePrices"><button type=button class="btn btn-sm btn-outline-dark mt-0" ng-click=$ctrl.excludeAll()><i class="fa fa-times"></i> <span translate>Exclude all</span></button> <button type=button class="btn btn-sm btn-outline-success mt-0" ng-click=$ctrl.includeAll()><i class="fa fa-check"></i> <span translate>Include all</span></button></div><div class=deal-supplier-group><div class="deal-supplier-row row m-0" ng-repeat="supplier in $ctrl.targetSuppliers | orderBy:\'name\'" ng-class="{\'text-disabled\': !supplier.isEnabled }"><div class="col-1 p-0 m-0" ng-if=!$ctrl.hideImages><img ng-src={{supplier.imageUrl}} alt=""></div><div class="col-11 row p-0 m-0"><div class="col-12 row pr-0 pl-1 m-0"><div class="col-sm-7 ml-0 pl-0" ng-click=$ctrl.supplierClicked(supplier)><div class="p-0 mb-1"><strong>{{supplier.name.replace(\'Lagerhaus\', \'LH\')}}</strong></div><div class="small clearfix" ng-if=!$ctrl.hideAccounts ng-repeat="account in supplier.accounts track by account._id" ng-class="{\'text-muted\': supplier.isEnabled }"><img ng-src="{{account.imageUrl || \'app/shared/images/team-member.jpg\'}}" alt="" class="float-left mr-1" width=15> {{account.name.first + \' \' + account.name.last}}</div></div><div class="col pl-0 pr-0 text-right"><div ng-if=supplier.isEnabled><div ng-if=!$ctrl.hidePrices><button type=button ng-if=$ctrl.benchmarkPrice class="btn btn-secondary m-0 p-1" ng-click=$ctrl.promptRrp(supplier) ng-class="{\'btn-outline-warning\': $ctrl.hasDifferentPrice(supplier)}" style="color: black">{{$ctrl.utils.getLocalizedCurrency(supplier.rrp || $ctrl.benchmarkPrice, $ctrl.priceDecimalDigits)}}</button><div><span ng-if=$ctrl.hasDifferentPrice(supplier) class="text-warning pt-2 small"><span ng-if="supplier.rrpDiff > 0">+</span>{{$ctrl.utils.getLocalizedCurrency(supplier.rrpDiff, $ctrl.priceDecimalDigits)}} </span><i ng-if=$ctrl.hasLargelyDifferentPrice(supplier) class="fa fa-warning text-danger pt-1" uib-tooltip="{{\'Price is substantially different from offer price\'|translate}}"></i></div></div><div ng-if=!$ctrl.hideQuantities><button type=button class="btn btn-gray-transparent m-0 p-1" ng-click=$ctrl.promptDealSize(supplier) ng-class="{\'btn-outline-warning\': $ctrl.hasDifferentDealSize(supplier)}"><span ng-if="!supplier.dealSize && !$ctrl.dealSizeOptions.max && $ctrl.dealSize < 999999">{{ $ctrl.dealSize }}</span> <span ng-if="!supplier.dealSize && !$ctrl.dealSizeOptions.max && $ctrl.dealSize > 999999">&infin;</span> <span ng-if="supplier.dealSize || $ctrl.dealSizeOptions.max">{{ supplier.dealSize || $ctrl.dealSizeOptions.max}}</span> <span>max</span></button></div></div></div><div class="col-sm-2 text-right pl-0 pr-0" ng-if=!$ctrl.hideSupplierSelection><input type=checkbox id=supp-{{$index}} name={{f.name}} ng-change=$ctrl.storeSelectedAccounts() ng-model=supplier.isEnabled class=switch-input><label for=supp-{{$index}} class=switch-label>{{f.name}}</label></div></div></div></div><div class="row mt-4" ng-if="!$ctrl.hideSupplierSelection && !$ctrl.hideFarmSettings"><div class="col-sm-12 col-md-6"><div class=form-group><label for=system translate>Farm system</label><i class="fa fa-question-circle" uib-tooltip="{{\'Farm system and farm type suggested to retailers when forwarding offer to farmers.\'|translate}}"></i><select class=form-control name=system id=system ng-model=$ctrl.system ng-options="op.value as op.label for op in $ctrl.lookup.farmSystems"></select></div></div><div class="col-sm-12 col-md-6"><div class=form-group><label translate>Farm types</label><ui-select multiple ng-model=$ctrl.farmTypes theme=bootstrap ng-disabled=$ctrl.ftDisabled sortable close-on-select=false style="width: 100%"><ui-select-match placeholder="{{\'Select farm type...\'|translate}}">{{$item.label}}</ui-select-match><ui-select-choices repeat="type.value as type in $ctrl.lookup.farmTypes | propsFilter: {label: $select.search}"><div ng-bind-html="type.label | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div>');
$templateCache.put('app/modules/deals/deal-update/deals.update.html','<section class="pv-30 clearfix"><div class=container><div class=row><div class="col-sm-3 col-lg-2 padding-hor-clear"><div class="image img-fluid deal-image" uib-tooltip="{{\'Click to change image\'|translate}}"><img ng-src={{vm.model.imageUrl}} ng-error-src=app/shared/images/fallback_image.png style="max-height: 90px" class=centered alt=""> <a ng-click=vm.setImage() class=overlay><i class="fa fa-pencil"></i></a></div></div><div class="col-sm-9 col-lg-10"><a id=deleteDealButton ng-click=vm.deleteDeal() ng-if="vm.model.status === vm.DEAL_STATUS.DRAFT" class="btn btn-sm btn-sm-link pull-right text-danger" analytics-on=click analytics-event="Delete deal"><i class="fa fa-trash"></i> <span translate>Delete draft</span></a><h4 class=mt-2><img class=pr-10 style=float:left src=app/shared/images/deal_icon.png width=40> <span translate>New offer</span>{{vm.model.product.name ? \': \'+vm.model.product.name:\'\'}} <small ng-if=vm.model.vendorProductId>(<span translate>Product ID</span>: {{vm.model.vendorProductId}})</small> <button ng-if=vm.utils.getSettings().isInternational type=button class="btn btn-link btn-sm" ng-click=vm.startIntro()><i class="fa fa-info-circle"></i> <span translate>Tutorial</span></button></h4><span class=large_dark>{{vm.model.name}}</span><div><small translate>Created:</small>&nbsp; <small class=pr-20><i class="fa fa-calendar"></i> {{vm.utils.getLocalizedDateAndTime(vm.model.createdAt)}} <span ng-if=!vm.utils.isUserRegionalManager()><i class="fa fa-user"></i> {{vm.model.createdBy.name.first}} {{vm.model.createdBy.name.last}} </span><span ng-if=vm.utils.isUserRegionalManager()><i class="fa fa-user"></i> <span ng-if=!vm.createdBySelectVisible ng-click="vm.createdBySelectVisible = true">{{vm.model.createdBy.name.first}} {{vm.model.createdBy.name.last}} </span><span ng-if=vm.createdBySelectVisible><select ng-model=vm.model.createdBy><option ng-repeat="user in vm.createdByUserList" value={{user._id}}>{{user.name.first}} {{user.name.last}}</option></select></span></span></small><small translate>Updated:</small>&nbsp; <small><i class="fa fa-calendar"></i> {{vm.utils.getLocalizedDateAndTime(vm.model.updatedAt)}} <span ng-if=vm.model.updatedBy><i class="fa fa-user"></i> {{vm.model.updatedBy.name.first}} {{vm.model.updatedBy.name.last}}</span></small></div><div ng-if=vm.model.requests.length><button type=button class="btn btn-sm btn-info" ng-click=vm.viewRequestDetails() analytics-on=click analytics-event="View request for sale offer" analytics-value={{vm.model._id}}><i class="fa fa-bullhorn"></i> <span translate>Request for</span> <i>{{vm.model.requests[0].content[1]}}</i></button></div></div></div><div class=row><div class="card card-gray light-gray-bg col-md-12 mt-1"><div class=card-body><form name=vm.dealForm class="form row" novalidate autocomplete=off><div class="col-lg-6 col-md-12"><div class=row><div id=deal-update-product class="form-group col-md-12 typeahead" ng-class="{\'has-error\': (!vm.product || !vm.product._id) && vm.dealForm.$submitted }"><label for=deal_name translate>Product name</label><div class="input-group input-typeahead"><input type=text name=product id=product onclick=this.select(); ng-model=vm.product ng-model-options="{ debounce: 500 }" ng-blur=vm.restoreProduct() uib-typeahead="prod as prod.name for prod in vm.productsService.getFilteredProducts($viewValue)" typeahead-on-select=vm.selectProduct($item) typeahead-template-url=typeahead-product.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0 class=form-control ng-disabled=vm.dealsService.isActive(vm.model) required></div><div class=text-danger ng-messages=vm.dealForm.deal_name.$error ng-if="vm.dealForm.$submitted && vm.dealForm.$invalid"><small class=form-control-feedback ng-message=required translate>* Field is required</small></div><div ng-if=vm.productDoesNotExist() class="alert alert-icon col-12 alert-warning m-1"><i class="fa fa-warning"></i><div><span translate>Product \'{{vm.product.name || vm.product}}\' does not exist.</span></div><div class=mt-10><a ng-click=vm.cancelCreateProduct() class="btn btn-md btn-dark text-white"><span translate>Cancel</span> </a><a ng-click=vm.createProduct() class="btn btn-md btn-success text-white pull-right"><span translate>Create product</span></a></div></div></div><div class="col-md-8 form-group" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.custType.$invalid }"><label for=custType translate>Product type</label><input type=text name=custType ng-model=vm.model.customType class=form-control id=custType aria-describedby=customType uib-typeahead="type for type in vm.productTypes | filter:$viewValue" typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0 placeholder="{{\'E.g. Concentrate feed\'|translate}}" ng-change=vm.productTypeChanged() typeahead-on-select=vm.productTypeChanged() required><div class=text-danger ng-messages=vm.dealForm.custType.$error ng-if="vm.dealForm.$submitted && vm.dealForm.custType.$invalid"><small class=form-control-feedback ng-message=required translate>* Field is required</small></div></div><div class="form-group col-md-4"><label><span translate>Product ID</span></label><div class=input-group><input type=text id=deal_size name=vendorProductId ng-model=vm.model.vendorProductId class=form-control id=vendorProductId aria-describedby=vendorProductId></div></div><distributor-deal class="form-group col-md-12" deal=vm.model.distributorDeal product=vm.model.product></distributor-deal><div class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.customUnit.$invalid }"><label for=deal_size translate>Unit</label><div class=input-group><input type=text name=customUnit ng-model=vm.model.customUnit class=form-control id=customUnit aria-describedby=customUnit uib-typeahead="unit for unit in vm.lookup.units | filter: $viewValue" typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0 placeholder="{{\'E.g. Liters\'|translate}}" required></div><div class=text-danger ng-messages=vm.dealForm.customUnit.$error ng-if="vm.dealForm.$submitted && vm.dealForm.customUnit.$invalid"><small class=form-control-feedback ng-message=required translate>* Field is required</small></div></div><div class="form-group col-md-6"><input-deal-size deal-size=vm.model.dealSize deal-size-options=vm.model.dealSizeOptions unit=vm.model.customUnit form=vm.dealForm deal-size-required=true></input-deal-size></div><div id=deal-update-price class="col-12 m-0 p-0 row" ng-switch="vm.model.customType.toLowerCase() === \'bulk concentrate\'"><div class="form-group col-md-12 col-lg-6" ng-switch-when=true><label for=benchmarkPrice translate>Sale price</label><input name=benchmarkPrice type=text class=form-control ng-model=vm.model.benchmarkPrice></div><div class="form-group col-md-12 col-lg-6" ng-switch-when=false ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.originalPrice.$invalid }"><label for=benchmarkPrice><span ng-if=!vm.utils.isSupplierDistributor() translate>Original price</span> <span ng-if=vm.utils.isSupplierDistributor() translate>Price</span> <span ng-if=vm.model.customUnit>&nbsp;/&nbsp;{{vm.model.customUnit}}</span></label><input-price deal=vm.model form=vm.dealForm price-changed=vm.discountChange></input-price></div><div class="form-group col-md-6" ng-switch-when=false ng-if=!vm.utils.isSupplierDistributor() ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.salePrice.$invalid }"><label for=salePrice translate>Sale Price</label><a ng-click=vm.editDiscount() class="text-success float-right padding-ver-clear"><span>{{vm.model.individualDiscount || 0|number:0}}% </span><span ng-if=vm.dealsService.isQuantityDiscountEnabled(vm.model)>~&nbsp;{{vm.model.clearanceDiscount|number:0}}% </span><small translate>Discount</small> <i class="fa fa-pencil-square-o"></i></a><div ng-if=vm.dealsService.isQuantityDiscountEnabled(vm.model) ng-click=vm.editDiscount()><div class=input-group><span class=input-group-addon>{{$root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}}</span> <input type=text class=form-control value={{vm.getPriceWithQuantityDiscount()}} disabled></div></div><div class=input-group ng-if=vm.dealsService.isGroupDiscountEnabled(vm.model) ng-click=vm.editDiscount()><span class=input-group-addon>{{$root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}}</span> <input type=text class=form-control value="{{vm.utils.getSalePrice(vm.model.benchmarkPrice,vm.model.groupDiscount.value, vm.model.priceDecimalDigits)}}" disabled></div><div class=input-group ng-if="!vm.dealsService.isQuantityDiscountEnabled(vm.model) && !vm.dealsService.isGroupDiscountEnabled(vm.model)"><span class=input-group-addon>{{$root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}}</span> <input type=text id=salePrice name=salePrice ng-model=vm.salePrice ng-change=vm.salePriceChange() class=form-control aria-describedby=salePrice ng-currency currency-symbol="" fraction="{{vm.model.priceDecimalDigits || 2}}" required></div><div class=text-danger ng-messages=vm.dealForm.name.$error ng-if="vm.dealForm.$submitted && vm.dealForm.salePrice.$invalid"><small class=form-control-feedback translate>* Field is required</small> <small class=form-control-feedback ng-message=maxlength translate>* value must not be greater than original price</small></div><div class="small text-info text-right mt-1" ng-if=vm.model.distributorDeal uib-tooltip="{{\'Margin is not showed to customers\'|translate}}"><span translate>Distributor price</span>: {{vm.utils.getLocalizedCurrency(vm.model.distributorDeal.benchmarkPrice, vm.model.priceDecimalDigits)}}; <span translate>Margin</span>: <b>{{vm.getMargin() | number:1}}%</b> <i class="fa fa-info-circle"></i></div></div><!-- INCOTERMS --><div class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.incoterms.$invalid }" ng-if=vm.utils.isSupplierDistributor()><label for=incoterms translate>Incoterms</label><div class="input-group input-typeahead"><input type=text id=incoterms name=incoterms id=incoterms ng-model=vm.model.paymentMethod uib-typeahead="inc for inc in vm.incoterms | filter: $viewValue" typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0 class=form-control placeholder="{{\'E.g. FCA\'|translate}}"></div><div class=text-danger ng-messages=vm.dealForm.incoterms.$error ng-if="vm.dealForm.$submitted && vm.dealForm.incoterms.$invalid"><small class=form-control-feedback ng-message=required translate>* Field is required</small></div></div></div><div ng-if=vm.model.variants.length class="form-group col-md-12 mt-2"><h6><i class="fa fa-sitemap"></i> <span translate>Additional variants</span>: {{vm.model.variants.length}}</h6><div ng-repeat="v in vm.model.variants track by $index" class="row mb-1"><div class="col-md-1 pl-3 pt-2"><button type=button ng-click=vm.removeVariant($index) tabindex=-1 class="btn btn-link btn-lg text-warning p-0 m-0"><i class="fa fa-times-circle"></i></button></div><div class="col-md-7 pl-0">{{v.productName}}<br><small>{{v.vendorProductId}}</small><div class="small text-info" ng-if=vm.model.distributorDeal><span translate>Distributor price</span>: {{vm.utils.getLocalizedCurrency(vm.getDistributorVariantPrice(v), vm.model.priceDecimalDigits)}}</div></div><div class="col-md-4 pl-0"><div class=input-group ng-class="{\'has-error\': vm.dealForm[\'variantPrice\'+$index].$invalid }"><span class=input-group-addon>{{$root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}}</span> <input type=text ng-model=v.benchmarkPrice class=form-control name=variantPrice{{$index}} ng-currency currency-symbol="" fraction="{{vm.model.priceDecimalDigits || 2}}" required></div><div class="small text-info text-right mt-1" ng-if=vm.model.distributorDeal><span translate>Margin</span>: {{vm.getMargin(v) | number:1}}%</div></div></div></div><div ng-if="vm.product && (vm.utils.isSupplierDistributor() || vm.utils.isUserRegionalManager())" class="col-md-12 text-right"><a ng-click=vm.addVariant() class="text-muted padding-ver-clear"><i class="fa fa-plus-circle"></i> <span translate>Add variant</span></a></div><div class=separator></div><div class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.bookingStart.$invalid }"><label for=deal_start translate>Offer starts</label><input-date-time value=vm.model.bookingStart icon="\'fa-play-circle\'" ng-disabled="vm.isReadOnly() || vm.utils.isSupplierDistributor()"></input-date-time><div class="small text-right text-muted"><countdown caption="\'Starts in:\'|translate" date-time=vm.model.bookingStart hide-seconds=true alt-text="\'Starts now\'|translate"></countdown></div></div><div id=deal-update-duration class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealLengthError }"><label for=deal_end translate>Offer ends</label><input-date-time value=vm.model.bookingEnd icon="\'fa-step-forward\'"></input-date-time><div class="small text-right text-muted"><countdown caption="\'Ends in:\'|translate" date-time=vm.model.bookingEnd hide-seconds=true></countdown></div><div ng-if=vm.dealLengthError class="text-danger small"><!-- <span translate>End date must be after start date</span> --> <span translate>* Field not valid</span></div></div><div id=deal-update-delivery class="form-group col-md-6"><label for=distribution translate>Distribution method</label><select ng-model=vm.model.distribution name=distribution id=distribution class=form-control ng-options="op.value as op.label for op in vm.lookup.distMethods"></select></div><div class=col-md-6><div ng-if=vm.dealsService.isDistributionCollection(vm.model) class=row><div class=col-12><label for=distribution><span translate>Collection points</span> <small>({{vm.model.collectionPoints.length}} / {{$root.app.Auth.User.supplier.collectionPoints.length}} <span translate>selected</span>)</small></label></div><div class=col-12><a class="btn btn-md btn-info text-white m-0" ng-click=vm.manageCollection()><i class="fa fa-home"></i> <span translate>Manage</span></a></div></div></div><div ng-if=vm.model.distribution class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.deliveryStart.$invalid }"><i ng-if=vm.dealsService.isDistributionCollection(vm.model) class="text-info fa fa-home"></i> <i ng-if=!vm.dealsService.isDistributionCollection(vm.model) class="text-warning fa fa-truck"></i><label for=deliveryStart translate>{{vm.lookup.distMethodsMap[vm.model.distribution]}} starts</label><input-date-time id="\'deliveryStart\'" value=vm.model.deliveryStart hide-time=true></input-date-time><div class=text-danger ng-messages=vm.dealForm.deliveryStart.$error ng-if="vm.dealForm.$submitted && vm.dealForm.deliveryStart.$invalid"><small class="form-control-feedback col-12" ng-message=required translate>* Field is required</small> <small class="form-control-feedback col-12" ng-message=distEndBeforeStart translate>* Field not valid</small></div></div><div ng-if=vm.model.distribution class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.deliveryEnd.$invalid }"><i ng-if=vm.dealsService.isDistributionCollection(vm.model) class="text-info fa fa-home"></i> <i ng-if=!vm.dealsService.isDistributionCollection(vm.model) class="text-warning fa fa-truck"></i><label for=deliveryEnd translate>{{vm.lookup.distMethodsMap[vm.model.distribution]}} ends</label><input-date-time id="\'deliveryEnd\'" value=vm.model.deliveryEnd hide-time=true></input-date-time><div class=text-danger ng-messages=vm.dealForm.deliveryEnd.$error ng-if="vm.dealForm.$submitted && vm.dealForm.deliveryEnd.$invalid"><small class="form-control-feedback col-12" ng-message=required translate>* Field is required</small> <small class="form-control-feedback col-12" ng-message=distEndBeforeStart translate>* Field not valid</small></div></div><div ng-if=vm.utils.getSettings().isReservationEnabled class="form-group col-md-6" ng-class="{\'has-error\': vm.dealForm.$submitted && vm.dealForm.reservationTime.$invalid }"><label for=deal_size translate>Reservation time</label><div class=input-group><span class=input-group-addon translate>Hours</span> <input type=number id=reservationTime name=reservationTime ng-model=vm.model.allowModifyOrderHours class=form-control></div><div class="small text-right text-muted"><span ng-if=!vm.model.allowModifyOrderHours><span class=text-warning translate>No reservations</span> </span><span ng-if=vm.model.allowModifyOrderHours>{{vm.model.allowModifyOrderHours/24 | number:1}} <span translate>Days</span></span></div><div class=text-danger ng-messages=vm.dealForm.reservationTime.$error ng-if="vm.dealForm.$submitted && vm.dealForm.reservationTime.$invalid"><small class=form-control-feedback ng-message=required translate>* Field is required</small></div></div><div ng-if=vm.utils.getSettings().isReservationEnabled class="form-group col-md-6"></div><div class="form-group col-md-6"><label><span translate>Offer description</span></label><div><a ng-click=vm.updateDesc() ng-if=!vm.model.description><small><span translate>Add</span> <i class="fa fa-plus-square"></i></small></a></div><div><div ng-if=vm.model.description class=deal-desc ng-click=vm.updateDesc() ng-bind-html=vm.model.description></div></div></div><!-- description --><div class="form-group col-md-6"><label><span translate>Attachments</span> ({{vm.model.attachments.length || 0}})</label><div><div ng-repeat="attachment in vm.model.attachments"><a ng-click=vm.editAttachment($index) class="small text-primary"><i class="fa fa-paperclip"></i> {{attachment.name.slice(0, 20)}} <span ng-if="attachment.name.length > 20">...</span> </a><a ng-click=vm.removeAttachment($index) class="small text-warning">- <span translate>Remove</span></a></div></div><div class=mt-2><a ng-click=vm.addAttachment()><small><span translate>Add attachment</span> <i class="fa fa-plus-square"></i></small></a></div></div><!-- attachments --></div></div><div id=deal-update-target class="col-lg-6 col-md-12" ng-if=vm.initialized ng-switch=vm.utils.isSupplierDistributor()><deal-map ng-switch-when=false radius-changed=vm.radiusFieldChanged() view-users=vm.viewUsers() reload-users=vm.reloadUsers() reset-filters=vm.resetFilters() map=vm.map search-box=vm.searchbox all-users-found=vm.allUsersFound users=vm.model.users target=vm.model.target radius=vm.model.radius system=vm.model.system farm-types=vm.model.farmTypes></deal-map><deal-suppliers ng-switch-when=true users=vm.model.users benchmark-price=vm.model.benchmarkPrice deal-size=vm.model.dealSize deal-size-options=vm.model.dealSizeOptions retail-prices=vm.model.retailPrices price-decimal-digits=vm.model.priceDecimalDigits system=vm.model.system farm-types=vm.model.farmTypes hide-farm-settings=vm.utils.getSettings().canSendOffers></deal-suppliers></div><div class=separator></div><div class="col-12 text-right"><button type=button ng-click=vm.safeDraft() ng-if="vm.model.status === vm.DEAL_STATUS.DRAFT" ng-disabled=!vm.modelChangedAfterSave class="btn btn-basic mr-4" analytics-on=click analytics-event="Save deal" analytics-value={{vm.model._id}}><i class="fa fa-save"></i> <span translate>Save draft</span></button> <button id=deal-update-submit ng-click=vm.submit() class="btn btn-success" analytics-on=click analytics-event="Start publish deal" analytics-value={{vm.model._id}}><i class="fa fa-check"></i> <span translate>Review</span></button></div></form></div></div></div></div></section><script type=text/ng-template id=typeahead-product.tpl.html><a tabindex="-1" class="typeahead-general typeahead-product p-1">\n        <div class="row">\n            <div class="col-2">\n                <img ng-src="{{match.model.imageUrls[0] || \'./app/shared/images/default-no-image.jpg\'}}" \n                        style="max-width: 100%; max-height: 40px; margin: 2px auto;">\n            </div>\n            <div class="col">\n                {{match.model.name}}\n                <div class="row">\n                    <div class="col-md-8">\n                        <div class="small" ng-if="match.model.vendorProductId"><span translate>Product ID</span>: {{match.model.vendorProductId}}</div>\n                        <div ng-if="match.model.categoryName && match.model.categoryName !== \'CROP\'">\n                            <i class="small">\n                                {{match.model.categoryName}}\n                                <span ng-bind-html-unsafe="match.model.categoryName | typeaheadHighlight:query"></span>\n                            </i>\n                        </div>\n                        <div ng-if="match.model.categoryName && match.model.categoryName === \'CROP\'">\n                            <img style="float:left;" src="app/shared/images/crop_icon.png" width="20">\n                            <small><i><span translate>Crop</span></i></small>\n                        </div>\n                        <div class="small mt-2" ng-if="match.model.attributes">\n                            <div ng-repeat="attr in match.model.attributes">\n                                <span class="text-muted">{{attr.label}}:</span>&nbsp;<b>{{attr.value}}</b>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="col-md-4 small">\n                        <div ng-if="match.model.deals.sent.ongoing && match.model.deals.sent.ongoing.benchmarkPrice">\n                            <span translate>Available to customers:</span>\n                            {{match.model.deals.sent.ongoing.benchmarkPrice | currency: $root.app.Auth.User.supplier.currencySymbol}}\n                        </div>\n                        <div ng-if="match.model.deals.sent.latest.length">\n                            <span translate>Last offer</span> <i class="fa fa-tag"></i>\n                            {{match.model.deals.sent.latest[0].benchmarkPrice | currency: $root.app.Auth.User.supplier.currencySymbol}}\n                        </div>\n                    </div>\n                </div>\n\n               \n            </div>\n        </div>\n    </a></script><script type=text/ng-template id=typeahead.tpl.html><a tabindex="-1" class="typeahead-general p-1">\n        {{match.model}}\n    </a></script>');
$templateCache.put('app/modules/offers/incomingOffers/incoming.offers.tpl.html','<!-- BEING DEPRECATED SEP 2020 - Moving functionality to offers.received --><section class="light-gray-bg pv-30 clearfix"><div class=container><ul class="nav nav-tabs style-4" role=tablist><li class=nav-item><a class="nav-link active" role=tab data-toggle=tab><i class="fa fa fa-tag pr-1"></i> <span ng-if=!$ctrl.utils.isSupplierDistributor() translate>Distributors offers</span> <span ng-if=$ctrl.utils.isSupplierDistributor() translate>Offers received</span></a></li><li class=nav-item><a class=nav-link ng-click=$ctrl.tabClicked() role=tab data-toggle=tab><i class="fa fa-search pr-2"></i> <span translate>Search product catalog</span> <small class="small chip text-info mb-0 mt-0 pb-0 pt-0" ng-if="$ctrl.utils.isBefore(\'2020/05/10\')" translate>NEW</small></a></li></ul><h4 ng-if=false><i class="fa fa-tag"></i> <span translate>Offers from your distributors.</span> <button class="btn btn-sm btn-link" ng-click=$ctrl.refresh() analytics-on=click analytics-event="Refresh list"><span translate>Refresh</span></button><div class=float-right><button class="btn btn-info text-white" ui-sref=app.offers.search><i class="fa fa-search"></i> <span translate>Search product catalog</span> <small class="chip text-info mb-0 mt-0" ng-if="$ctrl.utils.isBefore(\'2020/05/10\')" translate>NEW</small></button></div></h4><div class="mt-2 mb-2"><button class="btn btn-sm btn-link" ng-click=$ctrl.refresh()><i class="fa fa-refresh"></i> <span translate>Refresh</span></button></div><div ng-if=!$ctrl.hasCategories><div class="alert alert-info p-3 text-center text-disabled" style="background-color: white; border-color: white" role=alert><i class="fa fa-times-circle m-3" style="font-size: 30px"></i><br><span translate>There are no offers from your distributors.</span></div></div><div ng-repeat="(supplierName, deals) in $ctrl.categorisedDeals"><h3 class=mt-4 ng-class="{\'text-disabled\': !deals.length, \'\': deals.length}"><span translate>From: {{supplierName}}</span> <span ng-if="deals.length === 1" class=small translate>(1 offer)</span> <span ng-if="deals.length > 1" class=small translate>({{deals.length}} offers)</span></h3><div ng-if="!deals || !deals.length"><div class="alert alert-info p-3 text-center text-disabled" style="background-color: white; border-color: white" role=alert><i class="fa fa-times-circle m-3" style="font-size: 30px"></i><br><span translate>No offers available.</span></div></div><div class=row ng-if="deals && deals.length"><div class=col-12><div class=row><div class="push-md-2 col-md-5"><span translate>Product</span></div><div class="col-md-7 text-right"><span translate>Distributor price</span></div></div></div><div class="card card-gray light-gray-bg col-12 offers-list-item" ng-repeat="deal in deals" ng-class="{\'offers-list-item-selected\': $ctrl.selectedDealId === deal._id}"><div class=row><div class="col-md-2 p-10 text-center"><div><img ng-src={{deal.imageUrl}} alt="" style="margin: 0 auto"></div><div ng-if=$ctrl.dealsService.isCategoryCrop(deal)><img class=offer-icon src=app/shared/images/crop_icon.png> <span translate>Sell</span></div><div ng-if=!$ctrl.dealsService.isCategoryCrop(deal)><img class=offer-icon src=app/shared/images/deal_icon.png> <span translate>Buy</span></div></div><div class=col-md-4><h5>{{deal.product.name}}</h5><div ng-if=deal.variants.length class=text-info>{{deal.variants.length}} <span translate>Additional variants</span></div><div ng-if=deal.vendorProductId class="m-0 p-0"><span translate>Product ID</span>: {{deal.vendorProductId}}</div><div>{{deal.customType}}</div><!-- <div class="text-info mb-2">\n                                <span translate>From: {{deal.supplier.name}}</span>\n                            </div> --><div class="mt-2 p-0"><countdown caption="\'Ends in:\'|translate" date-time=deal.bookingEnd></countdown><div class="mt-10 p-0 text-danger" ng-if=deal.isExpired><span translate>Expired</span></div><div class=small>{{$ctrl.utils.getLocalizedDateAndTime(deal.bookingEnd)}}</div></div><div class=mt-2><div ng-if=!$ctrl.dealsService.isDistributionDelivery(deal)><i class="text-warning fa fa-truck"></i> <span translate>Delivery</span>:</div><div ng-if=$ctrl.dealsService.isDistributionCollection(deal)><i class="text-warning fa fa-truck"></i> <span translate>Collection</span>:&nbsp;</div><div>{{$ctrl.utils.getLocalizedDate(deal.deliveryStart)}} - {{$ctrl.utils.getLocalizedDate(deal.deliveryEnd)}}</div></div><div class="mt-3 mb-3" ng-if=deal.attachments.length><div class=row ng-repeat="attachment in deal.attachments"><div class=col-1><i class="fa fa-paperclip" style="font-size: 150%"></i></div><div class=col-11><div><a href={{attachment.url}} target=_blank>{{attachment.name}}</a></div></div></div></div></div><!-- NEW --><div class="col-md-6 col-sm-12"><div class=row><div class="col-md-6 col-sm-12 text-right"><div ng-class="{\'text-danger\': !$ctrl.getAvailabilityForUser(deal) && !deal.reservationOrder }" paid-feature><span translate>Available</span>: <span ng-if="$ctrl.getAvailabilityForUser(deal) > 99999">&infin;</span> <span ng-if="$ctrl.getAvailabilityForUser(deal) < 99999">{{$ctrl.getAvailabilityForUser(deal)}}</span></div></div><div class="col-md-6 col-sm-12 text-right"><div class=mb-3 ng-if=!deal.isExpired><h5 class="mb-0 font-weight-bold" paid-feature>{{$ctrl.utils.getLocalizedCurrency(deal.benchmarkPrice, deal.priceDecimalDigits)}} <span class=small>/ {{deal.customUnit}}</span></h5><div><span ng-if=!deal.isVatIncluded translate>Excl. VAT</span> <span ng-if=deal.isVatIncluded><span translate>Incl. VAT</span><span ng-if=deal.vatRate>&nbsp;({{deal.vatRate*100|number:1}}%)</span></span> <span ng-if=deal.paymentMethod>- <span translate>Incoterms</span>: {{deal.paymentMethod}}</span></div></div></div></div><div class="row mt-2"><div class="col-md-6 col-sm-12 text-right pt-1 row-clickable" ng-click=$ctrl.goToOrders(deal)><span translate>Ordered</span>:&nbsp;<h5 class=d-inline>{{deal.userBooking || 0}}</h5><div class=small><a ng-if="deal.orders && deal.orders.length">{{deal.orders.length}} <span ng-if="deal.orders.length === 1" translate>order</span> <span ng-if="deal.orders.length > 1" translate>orders</span></a></div></div><div class="col-md-6 col-sm-12"><button class="btn btn-success p-3 m-0 col-12" ng-click=$ctrl.startOrder(deal) ng-disabled="deal.isExpired || $ctrl.reservationStarted || $ctrl.getAvailabilityForUser(deal) <= 0" paid-feature><i class="fa fa-check"></i>&nbsp; <span translate>New order</span></button></div></div><div class="row mt-3" ng-if=!deal.reservationOrder><div class="col-md-6 col-sm-12 text-right pt-1"><span class=text-warning translate>No reservations</span></div><div class="col-md-6 col-sm-12"><button class="btn btn-outline-success m-0 col-12" ng-click=$ctrl.startReservation(deal) ng-disabled="deal.isExpired || $ctrl.reservationStarted || $ctrl.getAvailabilityForUser(deal) <= 0" paid-feature><span translate>Reserve</span></button></div></div><div class="row mt-3" ng-if=deal.reservationOrder><div class="col-md-6 col-sm-12 text-right"><div class=text-success><i class="fa fa-check-circle"></i> <span translate>Reserved</span>:&nbsp;<h5 class=d-inline>{{deal.reservationOrder.amount}}</h5></div><div class=small><countdown caption="\'For:\'|translate" date-time=deal.reservationOrder.modifyTimeExpiresAt></countdown></div></div><div class="col-md-6 col-sm-12 pt-1"><button class="btn btn-outline-info m-0 col-12" ng-click=$ctrl.startReservation(deal)><i class="fa fa-edit"></i>&nbsp; <span translate>Edit reservation</span></button></div></div><div class="row mt-3" ng-if="deal.reservationOrder && !deal.retailerDealList.length"><div class="col-md-6 col-sm-12 text-right pt-1"><span class=text-warning translate>Farmers offer is not active yet</span></div><div class="col-md-6 col-sm-12"><button class="btn btn-outline-primary m-0 col-12" ng-click=$ctrl.forwardDeal(deal)><i class="fa fa-share"></i>&nbsp;<span translate>Forward to farmers</span></button></div></div><div class="row mt-3" ng-if="deal.reservationOrder && deal.retailerDealList.length"><div class="col-md-6 col-sm-12 text-right"></div><div class="col-md-6 col-sm-12 pt-1"><div class=text-center><span translate>Go to farmers offer</span></div><button class="btn btn-sm btn-outline-info ml-0 mr-0 mt-0 mb-2 col-12" ng-repeat="forwardedDeal in deal.retailerDealList" ng-click=$ctrl.openDeal(forwardedDeal) ng-class="{\'text-warning\': $ctrl.dealsService.isDraft(forwardedDeal)}"><div><small>{{forwardedDeal.product.name}}</small></div><span ng-if=!$ctrl.dealsService.isDraft(forwardedDeal)>{{forwardedDeal.progress}}/{{forwardedDeal.dealSize}} {{forwardedDeal.customUnit}}</span> <span ng-if=$ctrl.dealsService.isDraft(forwardedDeal) translate>Draft</span><br></button></div></div></div></div><div class="row mt-2"><div class="col-md-10 push-md-2"><div ng-if=deal.description class="text-primary incoming-offers-description" ng-class="{\'limited-height\': deal.description.length > 300 && !$ctrl.isDescriptionExtended[deal._id]}"><sup><i class="fa fa-quote-left"></i></sup> <span ng-bind-html=deal.description></span> <sub><i class="fa fa-quote-right"></i></sub></div><div ng-if="deal.description.length > 300"><div ng-if=!$ctrl.isDescriptionExtended[deal._id]><button ng-click="$ctrl.isDescriptionExtended[deal._id] = !$ctrl.isDescriptionExtended[deal._id]" class="btn bnt-link btn-sm"><i class="fa fa-angle-double-down"></i> <span translate>More info</span></button></div><div ng-if=$ctrl.isDescriptionExtended[deal._id]><button ng-click="$ctrl.isDescriptionExtended[deal._id] = !$ctrl.isDescriptionExtended[deal._id]" class="btn bnt-link btn-sm"><i class="fa fa-angle-double-up"></i> <span translate>Less info</span></button></div></div></div></div></div><!-- ng-repeat: deals --></div><!-- ng-repeat: categorisedDeals --></div><div class="alert alert-warning" ng-if=$ctrl.utils.isUserRegionalManager()><h4>Admin section</h4><label>Select user</label><select ng-model=$ctrl.onBehalfOfUser class=form-control ng-change=$ctrl.refresh()><option ng-repeat="user in $ctrl.supplierAccounts" value={{user._id}}>{{user.name.first}} {{user.name.last}}</option></select></div></div></section>');
$templateCache.put('app/modules/offers/received/offers.received.tpl.html','<section class="light-gray-bg pv-30 clearfix"><div class=container><div class="row mb-1"><div class=col-lg-3><h5><span translate>Offers received</span> <span class="small text-muted">({{$ctrl.paging.count || 0}})</span></h5><div class=float-right><button class="btn btn-sm btn-link mt-1" ng-click=$ctrl.refresh()><i class="fa fa-refresh"></i> <span translate>Refresh</span></button> <button type=button class="btn btn-link btn-sm hidden-md-down" ng-click=$ctrl.startIntro()><i class="fa fa-info-circle"></i> <span translate>Tutorial</span></button></div></div><div class=col-lg-9><div class=row ng-if="$ctrl.suppliers.length && !$ctrl.isLoading"><div class="col-md-5 col-9 pb-1"><div id=offers-received-search class="form-group has-feedback m-0"><input type=text id=searchText class=form-control ng-model=$ctrl.filters.searchText ng-change=$ctrl.searchTextChanged() ng-model-options="{ debounce: 500 }" placeholder="{{\'Search\'|translate}}" autocomplete=off> <i class="fa fa-search form-control-feedback"></i></div></div><div class="col-md-1 col-3 pr-0"><div class=text-muted style="line-height: 1.0rem"><small translate>Page</small><div>{{$ctrl.paging.current}} / {{($ctrl.paging.count / $ctrl.paging.itemsPerPage)+0.5 | number:0}}</div></div></div><div class="col-md-3 pb-1"><div class=small ng-if=$ctrl.areFiltersActive()><button class="btn btn-warning m-0" ng-click=$ctrl.clearFilters()><small translate>Reset filters</small></button></div></div><div class=col-md-3><div ng-if=$ctrl.utils.getSettings().canSendRequests><button class="btn btn-outline-info btn-animated m-0 col-12" ng-click=$ctrl.startRequest(deal) style="width: 100%"><span translate>Send request</span> <i class="fa fa-comment"></i></button></div></div></div></div></div><div class=row><div class="col-lg-3 hidden-lg-down"><div id=offers-received-suppliers class="card p-3" ng-if=$ctrl.suppliers.length><h5><i class="fa fa-exchange"></i> <span ng-if=!$ctrl.utils.isSupplierDistributor() translate>Distributors</span> <span ng-if=$ctrl.utils.isSupplierDistributor() translate>Traders</span></h5><div ng-repeat="supplier in $ctrl.suppliers"><input type=checkbox id=includeTrader_{{supplier._id}} ng-model=$ctrl.filters.suppliers[supplier._id] class=switch-input ng-model-options="{ debounce: 200 }" ng-change=$ctrl.supplierSelectionChanged()><label for=includeTrader_{{supplier._id}} class="switch-label switch-label-dark text-left mr-0 ml-0"><small>{{supplier.name}}</small><div class=small ng-if=!$ctrl.isLoading><span ng-if=!supplier.stats class=text-disabled>No offers/products</span> <span ng-if=supplier.stats.offersCount class=text-warning><span ng-if="supplier.stats.offersCount > 1" translate>{{supplier.stats.offersCount}} offers</span> <span ng-if="supplier.stats.offersCount === 1" translate>1 offer</span> </span><span ng-if="supplier.stats.offersCount && supplier.stats.productsCount">|</span> <span ng-if=supplier.stats.productsCount class=text-muted><span ng-if="supplier.stats.productsCount > 1" translate>{{supplier.stats.productsCount}} products</span> <span ng-if="supplier.stats.productsCount === 1" translate>1 product</span></span></div></label></div></div><div class="sticky-top pt-3 pb-3"><div id=offers-received-shopping-carts class="card p-3"><shopping-cart-list></shopping-cart-list></div></div></div><div class=col-xl-9><div class=col-12 ng-if="!$ctrl.deals.length && !$ctrl.isLoading"><div class="alert alert-warning"><span ng-if=!$ctrl.filters.searchText translate>No results found.</span> <span ng-if=$ctrl.filters.searchText translate>No results found for "{{$ctrl.filters.searchText}}".</span></div><div class=mt-3 ng-if=$ctrl.utils.getSettings().canSendRequests><button type=button class="btn btn-info btn-lg btn-animated" ng-click=$ctrl.startRequest()><i class="fa fa-comment"></i> <span ng-if=!$ctrl.filters.searchText translate>Send a request</span> <span ng-if=$ctrl.filters.searchText translate>Send a request for "{{$ctrl.filters.searchText}}"</span></button></div></div><div ng-repeat="deal in $ctrl.deals"><h3 ng-if="$index > 0 && $ctrl.deals[$index-1].isSpecialOffer && !deal.isSpecialOffer" class=mt-5><span translate>Products</span></h3><div class="card card-gray light-gray-bg col-12 offers-list-item row-clickable" ng-class="{\'offers-list-item-selected\': $ctrl.selectedDealId === deal._id}"><div class="mb-2 p-lg-0"><span><span ng-if=deal.isNew class="chip text-info" translate>New</span> </span><span class="chip text-muted">{{deal.supplier.name}}</span> <i class="fa fa-caret-right"></i> <span class="chip text-muted">{{deal.customType}}</span> <span ng-if=deal.isSpecialOffer class="float-right pt-2 pt-lg-0"><span ng-if=!deal.isExpired><b class=text-warning><i class="fa fa-tag"></i> <span translate>Offer</span> </b>|<countdown caption="\'Ends in:\'|translate" date-time=deal.bookingEnd></countdown></span><span class="mt-10 p-0 text-danger" ng-if=deal.isExpired><span translate>Offer epired</span></span></span></div><div class="row mt-1"><div class="col-md-2 col-6 hidden-md-down pt-1 pl-4 pr-4 text-center"><div style="min-height: 100px"><img ng-src="{{deal.imageUrl || \'./app/shared/images/default-no-image.jpg\'}}" alt="" style="margin: 0 auto"></div></div><div class="col-lg-5 col-md-6 pl-lg-0 pr-md-2 row-clickable" ng-click=$ctrl.showDetails(deal)><h5>{{deal.product.name}}<div ng-if=deal.variants.length class="text-info small">+{{deal.variants.length}} <span translate>variants</span></div><div class=small><div ng-if=deal.vendorProductId class="mt-1 small">{{deal.vendorProductId}}</div></div><div class="small mt-2" ng-if="deal.productAttributes && deal.productAttributes.length" style="border-left: solid 4px #EEE"><product-attributes-edit attributes=deal.productAttributes read-only=true></product-attributes-edit></div></h5><div ng-if="deal.distribution && deal.deliveryStart && deal.deliveryEnd"><span ng-if=$ctrl.dealsService.isDistributionDelivery(deal)><i class="fa fa-truck"></i> </span><span ng-if=$ctrl.dealsService.isDistributionCollection(deal)><i class="fa fa-truck"></i> </span><span>{{$ctrl.utils.getLocalizedDate(deal.deliveryStart)}} - {{$ctrl.utils.getLocalizedDate(deal.deliveryEnd)}}</span></div><div class=mt-2><div><div ng-if=deal.description class="text-primary incoming-offers-description"><div class=limited-height><span ng-bind-html=deal.description></span></div></div></div></div><button ng-if="deal.description.length > 150" class="btn btn-sm"><span translate>More info</span></button> <button ng-if=deal.attachments.length class="btn btn-sm"><span ng-if="deal.attachments.length > 1" translate>{{deal.attachments.length}} attachments</span> <span ng-if="deal.attachments.length === 1" translate>1 attachment</span></button></div><!-- NEW --><div class="col-lg-5 col-md-6 col-sm-12 pl-lg-0"><div class=row ng-if="!deal.isExpired && deal.benchmarkPrice"><div class="col-md-5 col-sm-12 text-right pl-md-0 pr-md-0"><div ng-if="$ctrl.getAvailabilityForUser(deal) < 99999" ng-class="{\'text-danger\': !$ctrl.getAvailabilityForUser(deal) && !deal.reservationOrder }"><span translate>Available</span>: <span ng-if="$ctrl.getAvailabilityForUser(deal) < 99999">{{$ctrl.getAvailabilityForUser(deal)}}</span></div></div><div class="col-md-7 col-sm-12 text-right"><div class=mb-3><h5 class="mb-0 font-weight-bold">{{$ctrl.utils.getLocalizedCurrency(deal.benchmarkPrice, deal.priceDecimalDigits)}} <span class=small>/ {{deal.customUnit}}</span></h5><div class=small><span ng-if=!deal.isVatIncluded translate>Excl. VAT</span> <span ng-if=deal.isVatIncluded translate>Incl. VAT</span> <span ng-if=deal.paymentMethod>- <span translate>Incoterms</span>: {{deal.paymentMethod}}</span></div></div></div></div><div class="row mt-2" ng-if=$ctrl.utils.getSettings().canSendRequests><div class="col-md-5 col-sm-12 text-right pl-md-0 pr-md-0 pt-2" ng-click=$ctrl.showDetails(deal)><div ng-if=deal.userRequested class=row-clickable><span translate>Requested</span>:&nbsp;<h5 class=d-inline>{{deal.userRequested || 0}}</h5></div></div><div class="col-md-7 col-sm-12"><button class="btn btn-outline-info btn-animated col-12 mt-0 mb-1" ng-click=$ctrl.startRequest(deal) paid-feature><span translate>Send request</span> <i class="fa fa-comment"></i></button></div></div><div class=row ng-if=deal.benchmarkPrice><div class="col-md-5 col-sm-12 text-right pl-md-0 pr-md-0" ng-click=$ctrl.showDetails(deal)><div ng-if=deal.lastOrder class=row-clickable><div class=small><span translate>Last order</span></div><div>{{deal.lastOrder.amount}} {{deal.customUnit}}</div><div class=small>{{$ctrl.utils.getLocalizedDate(deal.lastOrder.date)}}</div></div></div><div class="col-md-7 col-sm-12"><button class="btn btn-success btn-animated mt-0 mb-0 col-12" ng-click=$ctrl.startOrder(deal) ng-disabled="deal.isExpired || $ctrl.reservationStarted || $ctrl.getAvailabilityForUser(deal) <= 0"><span translate>New order</span> <i class="fa fa-check"></i></button><div id=offers-received-add-cart-row-{{$index}} ng-if=$ctrl.canBeAddedToCart(deal)><button ng-if=!$ctrl.isDealIdInCart(deal._id) class="btn btn-outline-success btn-animated mt-1 mb-0 col-12" ng-click=$ctrl.addToCart(deal) ng-disabled="deal.isExpired || $ctrl.reservationStarted || $ctrl.getAvailabilityForUser(deal) <= 0"><small translate>Add to cart</small> <i class="fa fa-cart-plus"></i></button> <button ng-if=$ctrl.isDealIdInCart(deal._id) class="btn btn-outline-info btn-animated mt-1 mb-0 col-12" ng-click=$ctrl.addToCart(deal) ng-disabled="deal.isExpired || $ctrl.reservationStarted || $ctrl.getAvailabilityForUser(deal) <= 0"><small translate>In cart</small> <i class="fa fa-shopping-cart"></i></button></div></div></div><div class="row mt-1" ng-if="$ctrl.utils.getSettings().canReserveOffers && deal.isSpecialOffer && !deal.reservationOrder && deal.benchmarkPrice && !deal.isExpired && deal.allowModifyOrderHours > 0"><div class="col-md-5 col-sm-12 text-right pl-md-0 pr-md-0 pt-2"><small class=text-warning translate>No reservations</small></div><div class="col-md-7 col-sm-12"><button class="btn btn-outline-success m-0 col-12" ng-click=$ctrl.startReservation(deal) ng-disabled="$ctrl.reservationStarted || $ctrl.getAvailabilityForUser(deal) <= 0" paid-feature><small translate>Reserve</small></button></div></div><div class="row mt-3" ng-if="deal.reservationOrder && !deal.isExpired"><div class="col-md-5 col-sm-12 text-right pl-md-0 pr-md-0"><div class=text-success><i class="fa fa-check-circle"></i> <small translate>Reserved</small>:&nbsp;<h5 class=d-inline>{{deal.reservationOrder.amount}}</h5></div><div class=small><countdown caption="\'For:\'|translate" date-time=deal.reservationOrder.modifyTimeExpiresAt></countdown></div></div><div class="col-md-7 col-sm-12 pt-1"><button class="btn btn-outline-info m-0 col-12" ng-click=$ctrl.startReservation(deal)><small translate>Edit reservation</small></button></div></div><div class="row mt-2" ng-if=$ctrl.canBeForwardedToFarmers(deal)><div class="col-md-5 col-sm-12 text-right pl-md-0 pr-md-0 pt-1" style="line-height: 0.8rem"><small ng-if=deal.isSpecialOffer class=text-warning translate>Farmers offer is not active yet</small></div><div class="col-md-7 col-sm-12"><button class="btn btn-outline-primary m-0 col-12" ng-click=$ctrl.forwardDeal(deal)><small translate>Forward to farmers</small></button></div></div><div class="row mt-1" ng-if="deal.reservationOrder && deal.retailerDealList.length"><div class="col-md-5 col-sm-12 text-right pl-md-0 pr-md-0"></div><div class="col-md-7 col-sm-12 pt-1"><div class=text-center><small translate>Go to farmers offer</small></div><button class="btn btn-sm btn-link ml-0 mr-0 mt-0 mb-2 col-12 p-0" ng-repeat="forwardedDeal in deal.retailerDealList" ng-click=$ctrl.openDeal(forwardedDeal) ng-class="{\'text-warning\': $ctrl.dealsService.isDraft(forwardedDeal)}"><div class=small><small>{{forwardedDeal.product.name}}</small></div><span ng-if=!$ctrl.dealsService.isDraft(forwardedDeal)>{{forwardedDeal.progress}}/{{forwardedDeal.dealSize}} {{forwardedDeal.customUnit}}</span> <span ng-if=$ctrl.dealsService.isDraft(forwardedDeal) translate>Draft</span><br></button></div></div></div></div></div></div><!-- ng-repeat: deals --><div class=row ng-if="$ctrl.paging && $ctrl.deals.length" class=text-center><div class="col-md-12 col-lg-8"><ul uib-pagination class=pagination-sm first-text="{{\'First\'|translate}}" previous-text="{{\'Prev\'|translate}}" next-text="{{\'Next\'|translate}}" last-text="{{\'Last\'|translate}}" ng-change=$ctrl.onPage() total-items=$ctrl.paging.count ng-model=$ctrl.paging.current max-size=3 items-per-page=$ctrl.paging.itemsPerPage boundary-link-numbers=true></ul></div></div></div></div></div></section>');
$templateCache.put('app/modules/offers/search/search.offers.tpl.html','<section class="light-gray-bg pv-30 clearfix"><div class=container><div class=row><div class=col-md-6><ul class="nav nav-tabs style-4" role=tablist><li class=nav-item><a class=nav-link ng-click=$ctrl.tabClicked() role=tab data-toggle=tab><i class="fa fa fa-tag pr-1"></i> <span ng-if=!$ctrl.utils.isSupplierDistributor() translate>Distributors offers</span> <span ng-if=$ctrl.utils.isSupplierDistributor() translate>Offers received</span></a></li><li class=nav-item><a class="nav-link active" role=tab data-toggle=tab><i class="fa fa-search pr-2"></i> <span translate>Search product catalog</span> <small class="small chip text-info mb-0 mt-0 pb-0 pt-0" ng-if="$ctrl.utils.isBefore(\'2020/05/10\')" translate>NEW</small></a></li></ul></div><div class="col-md-6 text-right" ng-if="$ctrl.utils.getSettings().canSendRequests && $ctrl.searchResult.length"><button type=button class="btn btn-outline-info btn-animated" ng-click=$ctrl.newRequest()><i class="fa fa-comment"></i> <span translate>Send generic request</span></button></div></div><div class=row><div class=col-md-6><div class="form-group has-feedback"><input type=text id=searchText class=form-control ng-model=$ctrl.searchText ng-change=$ctrl.onPage() ng-model-options="{ debounce: 500 }" placeholder="{{\'Search\'|translate}}"> <i class="fa fa-search form-control-feedback"></i></div></div><div class=col-md-2 ng-if=$ctrl.searchText><button class="btn btn-outline-warning btn-icon m-0" ng-click=$ctrl.resetSearchText()><i class="fa fa-times"></i></button></div></div><div class="row masonry-grid-fitrows grid-space-20"><div class=col-12 ng-if="!$ctrl.searchResult.length && !$ctrl.isLoading"><div class="alert alert-warning"><span ng-if=!$ctrl.searchText translate>No results found.</span> <span ng-if=$ctrl.searchText translate>No results found for "{{$ctrl.searchText}}".</span></div><div class=mt-3><button type=button class="btn btn-info btn-lg btn-animated" ng-click=$ctrl.newRequest()><i class="fa fa-comment"></i> <span ng-if=!$ctrl.searchText translate>Send a request</span> <span ng-if=$ctrl.searchText translate>Send a request for "{{$ctrl.searchText}}"</span></button></div></div><div class="col-lg-4 col-md-6 masonry-grid-item" ng-repeat="deal in $ctrl.searchResult"><div class="listing-item white-bg bordered mb-20" style="border-radius: 10px"><div class="small pr-3 pl-3 pt-2"><div>{{deal.supplier.name}}</div><span ng-repeat="cat in deal.customType.split(\' - \').slice(0,2)"><a href=javascript:;; class=text-muted ng-click=$ctrl.searchCategory(cat)>{{cat}}</a> <i ng-if=!$last class="fa fa-caret-right text-disabled"></i></span></div><div class="overlay-container m-2 img-full-width-bg row-clickable" ng-click=$ctrl.showDetails(deal) ng-style="{ \'background-image\': \'url(\' + (deal.imageUrl || \'./app/shared/images/default-no-image.jpg\') + \')\'}"><!-- <img ng-src="{{deal.imageUrl || \'./app/shared/images/default-no-image.jpg\'}}"\n                            style="max-height: 110px; margin: 0 auto;"\n                            onerror="this.src = \'./app/shared/images/default-no-image.jpg\'"> --></div><div class=body><div style="min-height: 80px"><div class="btn-group dropdown float-right"><button class="btn btn-sm dropdown-toggle" type=button id=productOptions data-toggle=dropdown aria-haspopup=true aria-expanded=false></button><div class=dropdown-menu aria-labelledby=productOptions><a id=createNewSaleOfferButton class=dropdown-item ng-click=$ctrl.copyProduct(deal) analytics-on=click analytics-event="Create deal"><span translate>Copy product</span></a></div></div><h3 class=row-clickable ng-click=$ctrl.showDetails(deal)>{{deal.product.name}}<div class=small>{{deal.vendorProductId}}</div>{{deal.status}}</h3><div class=mt-3 ng-if=deal.attachments.length><div ng-repeat="attachment in deal.attachments"><i class="fa fa-paperclip" style="font-size: 120%"></i> <a href={{attachment.url}} target=_blank>{{attachment.name}}</a></div></div></div><div style="min-height: 45px" class="row row-clickable" ng-click=$ctrl.showDetails(deal)><div class=col-1><div ng-if=$ctrl.dealsService.isDistributionDelivery(deal)><i class="text-warning fa fa-truck"></i></div><div ng-if=$ctrl.dealsService.isDistributionCollection(deal)><i class="text-warning fa fa-home"></i></div></div><div ng-if=deal.benchmarkPrice class="col pt-1"><div class="clearfix text-right"><div class=font-weight-bold>{{$ctrl.utils.getLocalizedCurrency(deal.benchmarkPrice, deal.priceDecimalDigits)}} <span class=small>/ {{deal.customUnit}}</span></div><div class=small><span ng-if=!deal.isVatIncluded translate>Excl. VAT</span> <span ng-if=deal.isVatIncluded translate>Incl. VAT</span> <span ng-if=deal.paymentMethod>- <span translate>Incoterms</span>: {{deal.paymentMethod}}</span></div></div></div></div><button ng-if=deal.benchmarkPrice class="btn btn-outline-success btn-animated m-1" ng-click=$ctrl.newOrder(deal) style="width: 100%"><span translate>Order now</span> <i class="fa fa-check-circle"></i></button><div ng-if="$ctrl.utils.getSettings().canSendRequests && !deal.benchmarkPrice"><button class="btn btn-outline-info btn-animated m-1" ng-click=$ctrl.newRequest(deal) style="width: 100%"><span translate>Send request</span> <i class="fa fa-comment"></i></button></div></div></div></div></div></div></section>');
$templateCache.put('app/modules/offers/templates/forward-offer.tpl.html','<div class="pl-2 pr-2" style="min-height: 300px"><h5>{{$ctrl.forwardedDeal.product.name}}</h5><div class="mt-2 mb-4" ng-if=$ctrl.productVariants ng-class="{\'has-error\': !$ctrl.forwardedDeal.product}"><span translate>Additional variants</span>:<div ng-repeat="variant in $ctrl.productVariants" class=form-control><input type=checkbox id=forwardVariant{{$index}} ng-model=variant.isIncluded class="switch-input text-left"><label for=forwardVariant{{$index}} class="switch-label pt-0 pb-0 mt-0 mb-0"><span class=small>{{variant.productName}}</span></label></div></div><div class=row><div class=col-lg-6><div><label><span translate>Farmers offer ends</span></label><input-date-time value=$ctrl.forwardedDeal.bookingEnd icon="\'fa-step-forward\'"></input-date-time></div><div class=small><countdown caption="\'Ends in:\'|translate" date-time=$ctrl.forwardedDeal.bookingEnd hide-seconds=true></countdown></div></div><div class=col-lg-6><div ng-if=$ctrl.deal.reservationOrder class=pt-4><span translate>Reserved</span>: {{$ctrl.deal.reservationOrder.amount}} {{$ctrl.deal.customUnit}}<div><span translate>Until</span>: {{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.reservationOrder.modifyTimeExpiresAt)}}</div></div></div></div><div class="mt-3 row"><div class=col-lg-6><label><span translate>Items available to farmers</span></label><input-deal-size deal-size=$ctrl.forwardedDeal.dealSize deal-size-options=$ctrl.forwardedDeal.dealSizeOptions unit=$ctrl.forwardedDeal.customUnit deal-size-required=true></input-deal-size></div><div class=col-lg-6 ng-if=$ctrl.forwardedDeal.attachments.length><label><i class="fa fa-paperclip"></i>&nbsp;<span translate>Include attachments</span></label><div ng-repeat="attachment in $ctrl.forwardedDeal.attachments"><input type=checkbox id=forwardAttachment{{$index}} ng-model=attachment.isIncluded class=switch-input><label for=forwardAttachment{{$index}} class="switch-label pt-0 pb-0 mt-0 mb-0"><span class=small>{{attachment.name}}</span></label></div></div></div><div class=mt-3 ng-if=$ctrl.forwardedDeal.description><div><label><span translate>Include description</span><br><a class="text-warning small" translate ng-click="$ctrl.forwardedDeal.description = \'\'">Do not forward description</a></label></div><rich-text-editor ng-model=$ctrl.forwardedDeal.description style="max-height: 200px"></rich-text-editor></div><div class="mt-3 small text-muted"><span translate>Click "Continue" to review and confirm the offer details.</span></div><br><br></div>');
$templateCache.put('app/modules/offers/templates/new-order-confirmation.tpl.html','<div class="pl-3 pr-3"><div class=mb-3><span translate>Order placed successfully.</span></div><div></div><div><div ng-if=$order.onBehalfOfUser><input type=checkbox id=shouldStoreShopAssociation ng-model=$ctrl.shouldStoreShopAssociation class=switch-input><label for=shouldStoreShopAssociation class=switch-label><span translate>Associate customer to "{{$ctrl.order.billingAddress.name}}" for future orders.</span></label></div><div ng-if=!$order.onBehalfOfUser><div><input type=checkbox id=shouldSendInvite ng-model=$ctrl.shouldSendInvite class=switch-input><label for=shouldSendInvite class=switch-label><span translate>Invite customer to join FarmHedge</span></label></div><div ng-if=$ctrl.shouldSendInvite><div><input type=text class=form-control ng-model=$ctrl.order.phoneNumber readonly></div><div class=mt-1><span translate>Message</span></div><div><textarea ng-model=$ctrl.inviteMessage id=message class=form-control cols=200 rows=2>\n                    </textarea></div></div></div></div><div class="separator-2 m-4"></div></div>');
$templateCache.put('app/modules/offers/templates/offer-details.tpl.html','<div class="pl-2 pr-2" style="min-height: 300px"><div class=row><div class=col-lg-6><ul><li>{{$ctrl.deal.supplier.name}}</li><li>{{$ctrl.deal.customType}}</li><li ng-if=$ctrl.deal.vendorProductId><span translate>Product Id</span>: {{$ctrl.deal.vendorProductId}}</li><li ng-if=$ctrl.deal.paymentMethod><span translate>Incoterms</span>: {{$ctrl.deal.paymentMethod}}</li><li ng-if=$ctrl.utils.isUserRegionalManager() class=text-warning>ID: {{$ctrl.deal._id}}</li></ul></div><div class=col-lg-6 ng-if=$ctrl.deal.productAttributes.length><ul><li ng-repeat="attr in $ctrl.deal.productAttributes">{{attr.label}}:&nbsp;{{attr.value}}</li></ul></div></div><div ng-if=$ctrl.deal.variants.length class=mt-5><h4><span translate>Variants</span></h4><table class="table table-striped m-0 p-0"><thead><tr><th class="pl-1 pr-0" translate>Product name</th><th class="pl-1 pr-0" translate>ID</th><th class="pl-1 pr-1 text-right"><span translate>Price</span> / {{$ctrl.deal.customUnit}}</th></tr></thead><tbody><tr><td class="pl-1 pr-0">{{$ctrl.deal.productName || $ctrl.deal.product.name}}</td><td class="pl-1 pr-0">{{$ctrl.deal.vendorProductId}}</td><td class="pl-1 pr-1 text-right">{{$ctrl.utils.getLocalizedCurrency($ctrl.deal.benchmarkPrice, $ctrl.deal.priceDecimalDigits)}}</td></tr><tr ng-repeat="variant in $ctrl.deal.variants"><td class="pl-1 pr-0">{{variant.productName}}</td><td class="pl-1 pr-0">{{variant.vendorProductId}}</td><td class="pr-1 text-right">{{$ctrl.utils.getLocalizedCurrency(variant.benchmarkPrice, $ctrl.deal.priceDecimalDigits)}}</td></tr></tbody></table></div><div class="row mt-4"><div ng-if=$ctrl.deal.isSpecialOffer class=col-md-6><h4><i class="fa fa-tag"></i> <span translate>Offer</span></h4><ul><li><span translate>Starts</span>: {{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.bookingStart)}}</li><li class=font-weight-bold><span translate>Ends</span>: {{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.bookingEnd)}}</li></ul></div><div ng-if="$ctrl.deal.distribution && ($ctrl.deal.deliveryStart || $ctrl.deal.deliveryEnd)" class=col-md-6><h4><span ng-if=$ctrl.dealsService.isDistributionDelivery($ctrl.deal)><i class="fa fa-truck"></i> <span translate>Delivery</span> </span><span ng-if=!$ctrl.dealsService.isDistributionDelivery($ctrl.deal)><i class="fa fa-home"></i> <span translate>Collection</span></span></h4><ul><li><span translate>Starts</span>: {{$ctrl.utils.getLocalizedDate($ctrl.deal.deliveryStart)}}</li><li><span translate>Ends</span>: {{$ctrl.utils.getLocalizedDate($ctrl.deal.deliveryEnd)}}</li></ul></div></div><div class="row mt-5"><div ng-if=$ctrl.deal.description class=col-md-6><h4><i class="fa fa-info-circle"></i> <span translate>Description</span></h4><span ng-bind-html=$ctrl.deal.description></span></div><div ng-if=$ctrl.deal.attachments.length class=col-md-6><h4><i class="fa fa-paperclip"></i> <span translate>Attachments</span></h4><ul><li ng-repeat="attachment in $ctrl.deal.attachments"><a href={{attachment.url}} target=_blank>{{attachment.name}}</a></li></ul></div></div><div class=mt-5 ng-if=$ctrl.deal.orders.length><h4><span translate>Orders</span></h4><table class="table table-striped m-0 p-0"><thead><tr><th class="pl-1 pr-0" translate>Date</th><th class="pl-1 pr-0" translate>Quantity</th><th class="pl-1 pr-1 text-right"><span translate>Total</span></th></tr></thead><tbody><tr ng-repeat="order in $ctrl.deal.orders"><td class="pl-1 pr-0">{{$ctrl.utils.getLocalizedDate(order.date)}}</td><td class="pl-1 pr-0">{{order.amount}} <small>{{$ctrl.deal.customUnit}}</small></td><td class="pr-1 text-right"><div ng-if="order.totalPrice || order.unitPrice">{{$ctrl.utils.getLocalizedCurrency(order.totalPrice || order.unitPrice * order.amount)}}</div><div ng-if="!order.totalPrice && !order.unitPrice"><span translate>Price as agreed</span></div></td></tr></tbody><tfoot><tr><th class="pl-1 pr-0"><span translate>Total</span></th><th class="pl-1 pr-0">{{$ctrl.deal.userBooking}} <small>{{$ctrl.deal.customUnit}}</small></th></tr></tfoot></table></div></div>');
$templateCache.put('app/modules/offers/templates/reservation.tpl.html','<div class="pl-3 pr-3"><div><span translate>From <b>{{$ctrl.deal.supplier.name}}</b></span></div><div ng-if=$ctrl.deal.vendorProductId><span translate>Product Id</span>: {{$ctrl.deal.vendorProductId}}</div><div><span translate>Unit price</span>: <span class=font-weight-bold>{{$ctrl.utils.getLocalizedCurrency($ctrl.deal.benchmarkPrice)}}</span> / <small>{{$ctrl.deal.customUnit}}</small></div><div class="mt-3 mb-3 font-italic text-center" ng-if="$ctrl.deal.allowModifyOrderHours && $ctrl.deal.reservationOrder"><div class="mt-0 pt-0 mb-10" ng-if=$ctrl.deal.reservationOrder><span translate>Reservation ends in</span>:<br><countdown date-time=$ctrl.deal.reservationOrder.modifyTimeExpiresAt></countdown></div></div><div class="mt-10 mb-10"><span translate>Reserved amount</span>:</div><div class=row><div class="col-3 text-center"><button type=button class="btn btn-info fa fa-minus m-0" style=width:100% ng-click=$ctrl.decreaseAmountReserved()></button></div><div class=col-6><input id=currentBooking name=currentBooking autocomplete=off autofocus type=number class=form-control formcontrolname=currentBookingInput ng-model=$ctrl.amountReserved ng-blur=$ctrl.checkAmountReserved() placeholder="{{gettextCatalog.getString(\'Quantity\')}}" class=form-control tabindex=1></div><div class="col-3 text-center"><button type=button class="btn btn-info fa fa-plus m-0" style=width:100% ng-click=$ctrl.increaseAmountReserved()></button></div></div><div class="small font-italic text-center"><span ng-if="$ctrl.deal.dealSizeOptions.step !== 1" class=pr-2><span translate>Step</span>: {{$ctrl.deal.dealSizeOptions.step}}; </span><span ng-if="$ctrl.maxAmountReserved < 99999" class=pr-2><span translate>Max</span>: {{$ctrl.maxAmountReserved}};</span></div><div class="mt-2 text-warning text-center font-weight-bold" ng-if=!$ctrl.deal.reservationOrder><span translate>Reservation time</span>:&nbsp; <span>{{$ctrl.deal.allowModifyOrderHours}}</span> <span ng-if="$ctrl.deal.allowModifyOrderHours === 1" translate>hour</span> <span ng-if="$ctrl.deal.allowModifyOrderHours !== 1" translate>hours</span></div><div class=mt-3 ng-if="$ctrl.deal.reservationOrder && $ctrl.amountReserved > 0"><button class="btn btn-outline-danger btn-sm mb-0 col-12" ng-click="$ctrl.amountReserved = 0"><i class="fa fa-times-circle"></i>&nbsp; <span translate>Cancel reservation</span></button></div><div ng-if="$ctrl.deal.reservationOrder && $ctrl.amountReserved <= 0" class="alert alert-danger text-center"><span translate>Click "Confirm" to cancel reservation</span></div><div class=mt-3 ng-if="$ctrl.deal.reservationOrder && $ctrl.hasRetailerDealLive($ctrl.deal)" class="mt-2 mb-2"><input type=checkbox id=isRetailerDealAffected ng-model=$ctrl.isRetailerDealAffected class=switch-input><label for=isRetailerDealAffected class=switch-label><span ng-if="$ctrl.amountReserved > 0" translate>Update quantity available of forwarded offer to {{$ctrl.amountReserved}}</span> <span ng-if="$ctrl.amountReserved <= 0" translate>Stop forwarded offer to farmers</span></label></div><div class="separator-2 m-4"></div></div>');
$templateCache.put('app/modules/order/order-details-modal/order-action-prompt.tpl.html','<div class="mt-2 mb-4 p-2"><div ng-if="utils.getSettings().tradeWithFarmers && $ctrl.status === ORDER_STATUS.COMPLETED && deal.distributorDeal" class="alert alert-warning mt-0"><span translate>Please note that the order details are not forwarded to the distributor. If you want this, please click on "Forward to distributor"</span></div><div class=mb-3><input type=checkbox id=sendEmail ng-model=$ctrl.isMessageEnabled class=switch-input><label for=sendEmail class="switch-label text-left"><i class="fa fa-envelope"></i> <span translate>Notify customer</span></label></div><div class=mb-1 ng-if=$ctrl.isMessageEnabled><textarea class=form-control row=2 data-ng-model=$ctrl.messageText placeholder="{{\'Message for customer\' | translate}}">&nbsp;</textarea></div><br></div>');
$templateCache.put('app/modules/order/order-details-modal/order-details-modal.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-list"></i> <span translate>Order</span> {{order.ref}} <span class="alert alert-warning small p-1 m-0 font-weight-bold" ng-if=utils.isUserRegionalManager()>{{order._id}}</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button></div><div class=modal-body><order-details order=order deal=deal distributor-deal=deal.distributorDeal></order-details><div id=order-details-control class="row mt-4"><div class="p-2 col-md-4 col-sm-12"><div class=text-right ng-if="!order.isRetailerOrder && order.status === ORDER_STATUS.PENDING && deal.distributorDeal"><button ng-click=markAs(ORDER_STATUS.COMPLETED) class="btn btn-outline-success m-0"><i class="fa fa-check"></i> <span translate>Mark as completed</span></button></div></div><div ng-if="!order.isRetailerOrder && order.status === ORDER_STATUS.PENDING && !deal.distributorDeal" class="p-2 col-md-4 col-sm-12"><button ng-click=markAs(ORDER_STATUS.COMPLETED) class="btn btn-success m-0 col-10"><i class="fa fa-check"></i> <span translate>Mark as completed</span></button></div><div ng-if="!order.isRetailerOrder && order.status === ORDER_STATUS.PENDING && deal.distributorDeal" class="p-2 col-md-4 col-sm-12"><button ng-click=markAs(ORDER_STATUS.FORWARDED) class="btn btn-success m-0 col-12"><i class="fa fa-check"></i> <span translate>Forward to distributor</span></button></div><div ng-if="!order.isRetailerOrder && order.status === ORDER_STATUS.PENDING" class="p-2 col-md-4 col-sm-12"><button ng-click=markAs(ORDER_STATUS.REJECTED) class="btn btn-danger m-0 col-10" analytics-on=click analytics-event="Order rejected" analytics-value={{order._id}}><i class="fa fa-times"></i> <span translate>Reject order</span></button></div></div><div class=row><div class=col-md-12><hr></div><div class=col-3><button ng-click=cancel() class="btn btn-dark"><i class="fa fa-times"></i> <span translate>Close</span></button></div><div class="col-9 text-right"><span ng-if=showDealLink><button class="btn btn-outline-info" ui-sref="app.deals.report({id: order.deal._id})" ng-click=cancel()><i class="fa fa-list"></i> <span translate>Go to offer details</span></button> </span><span id=order-details-share ng-if=utils.getSettings().canShareOrders><button ng-click=shareOrder() class="btn btn-info ml-4" style="min-width: 200px" ng-disabled="loading || isLegacyOrderObject"><i class="fa fa-share-alt"></i> <span translate>Share</span></button></span></div></div></div>');
$templateCache.put('app/modules/order/order-modal-external/order-modal-external.tpl.html','<!-- TODO: rename to order-details-external --><div class="container order" ng-if=$ctrl.validated><div class=row><div class="col-xs-12 push-md-1 col-md-10 push-lg-2 col-lg-8 invite-wrapper panel"><div id=logo class="logo text-center"><img src=app/shared/images/fh_logo2018_black.png width=240 style="margin:20px auto" alt=""><h5><i class="fa fa-list"></i> <span translate>Order</span> {{$ctrl.order.ref}}</h5></div><hr><order-details order=$ctrl.order deal=$ctrl.deal distributor-deal=$ctrl.distributorDeal></order-details><hr><div class="panel-footer text-center"><p><span class=pr-20 translate>Already a customer?</span> <a ui-sref=login class="btn btn-info btn-user btn-animated"><span translate>Login</span> <i class="fa fa-user pl-20"></i></a></p><p></p><div translate>For help, please contact</div><a class="btn btn-link btn-info m-0" href=mailto:support@farmhedge.io>support@farmhedge.io</a><p></p></div></div></div><br><br><br></div>');
$templateCache.put('app/modules/order/orders/orders-view.tpl.html','<section class=light-gray-bg><div class="container mt-20"><h5 class=pb-1><i class="fa fa-list"></i> <span translate>Orders</span> <button class="btn btn-sm btn-link" ng-click=$ctrl.onPage()><i class="fa fa-refresh"></i> <span translate>Refresh</span></button> <button ng-if=$ctrl.utils.getSettings().isInternational type=button class="btn btn-link btn-sm" ng-click=$ctrl.startIntro()><i class="fa fa-info-circle"></i> <span translate>Tutorial</span></button></h5><div class=tab-content><div class=row><div class="col-lg-3 pr-0 pl-0" ng-if=$ctrl.utils.getSettings().canReceiveOffers><ul id=order-list-tabs class="nav nav-tabs style-4" role=tablist><li class=nav-item><a id=top class=nav-link ng-class="{\'active\': $ctrl.filters.role === $ctrl.ORDER_ROLES.DISTRIBUTOR }" ng-click="$ctrl.switchTo({ role: $ctrl.ORDER_ROLES.DISTRIBUTOR })" role=tab data-toggle=tab><span ng-if=!$ctrl.utils.isSupplierDistributor() translate>Farmer orders</span> <span ng-if=$ctrl.utils.isSupplierDistributor() translate>Received</span> ({{$root.app.Stats.orders.new.count}})</a></li><li class=nav-item><a class=nav-link ng-class="{\'active\': $ctrl.filters.role === $ctrl.ORDER_ROLES.RETAILER }" ng-click="$ctrl.switchTo({ role: $ctrl.ORDER_ROLES.RETAILER })" role=tab data-toggle=tab><span ng-if=!$ctrl.utils.isSupplierDistributor() translate>Distributor orders</span> <span ng-if=$ctrl.utils.isSupplierDistributor() translate>Sent</span></a></li></ul></div><div class=col-lg-5><ul class="nav nav-tabs style-4" role=tablist><li class=nav-item><a class=nav-link ng-class="{\'active\': $ctrl.filters.type === $ctrl.ORDER_TYPES.ANY }" ng-click="$ctrl.switchTo({ type: $ctrl.ORDER_TYPES.ANY })" role=tab data-toggle=tab><i class=pr-2></i> <span translate>Any type</span></a></li><li class=nav-item><a class=nav-link ng-class="{\'active\': $ctrl.filters.type === $ctrl.ORDER_TYPES.PURCHASE }" ng-click="$ctrl.switchTo({ type: $ctrl.ORDER_TYPES.PURCHASE })" role=tab data-toggle=tab><i class="fa fa-shopping-cart pr-2"></i> <span translate>Purchases</span></a></li><li class=nav-item><a class=nav-link ng-class="{\'active\': $ctrl.filters.type === $ctrl.ORDER_TYPES.SALE }" ng-click="$ctrl.switchTo({ type: $ctrl.ORDER_TYPES.SALE })" role=tab data-toggle=tab><i class="fa fa-money pr-2"></i> <span translate>Sales</span></a></li></ul></div><div class=col-lg-3 ng-if=!$ctrl.utils.getSettings().canReceiveOffers></div><div class="col-lg-4 pr-0 row pr-0"><div class="col-5 pr-0" ng-if=$ctrl.filters.dateTo><input-date-time value=$ctrl.filters.dateFrom hide-time=true icon="\'none\'" on-change=$ctrl.filterDateChanged()></input-date-time></div><div class="col-5 pr-0" ng-if=$ctrl.filters.dateTo><input-date-time value=$ctrl.filters.dateTo hide-time=true icon="\'none\'" on-change=$ctrl.filterDateChanged()></input-date-time></div><div class="col text-right pl-1 pr-0"><button class="btn btn-link pl-1 pr-1 pt-2 m-0" ng-click=$ctrl.toggleDate()><i ng-if=!$ctrl.filters.dateTo class="fa fa-calendar"></i> <i ng-if=$ctrl.filters.dateTo class="fa fa-times-circle"></i></button></div></div></div><div id=order-list-filters class=row><div class="col-lg-1 pr-0 pt-2 pb-1"><i class="fa fa-filter" style="margin: auto 0"></i> <span translate>Filters</span></div><div class="col-6 col-lg-2 pr-0 mr-0 pb-1"><input type=text id=orderFilter class=form-control ng-model=$ctrl.filters.ref placeholder="{{\'Order ID\'|translate}}" ng-change=$ctrl.refChanged() ng-model-options="{ debounce: 300 }"></div><div class="col-lg-3 col-6 pr-0 mr-0 pb-1"><input ng-if="!$ctrl.utils.isSupplierDistributor() && $ctrl.filters.role === $ctrl.ORDER_ROLES.DISTRIBUTOR" type=text id=custFilter uib-typeahead="cust.full for cust in $ctrl.getCustomers($viewValue)" typeahead-loading=$ctrl.loadingCustomers typeahead-show-hint-on-focus=all typeahead-min-length=0 typeahead-template-url=customer-typeahead.tpl.html typeahead-on-select=$ctrl.customerSelected($item) typeahead-select-on-exact=true ng-change=$ctrl.checkSelectionCustomer($item) data-ng-model=$ctrl.userName class=form-control placeholder="{{\'Customer\'|translate}}" autocomplete=off> <input ng-if="$ctrl.utils.isSupplierDistributor() && $ctrl.filters.role === $ctrl.ORDER_ROLES.DISTRIBUTOR" type=text id=retailerFilter uib-typeahead="retailer.name for retailer in $ctrl.getRetailers($viewValue)" typeahead-loading=$ctrl.loadingRetailers typeahead-show-hint-on-focus=all typeahead-min-length=0 typeahead-template-url=retailer-typeahead.tpl.html typeahead-on-select=$ctrl.onSelectRetailer($item) typeahead-select-on-exact=true ng-change=$ctrl.checkSelectionRetailer($item) data-ng-model=$ctrl.retailerName class=form-control placeholder="{{\'Customer\'|translate}}" autocomplete=off></div><div class="col-lg-3 pr-0 mr-0"><input ng-if="$ctrl.filters.role === $ctrl.ORDER_ROLES.DISTRIBUTOR" type=text type=text id=productFilter typeahead-loading=$ctrl.loadingProducts uib-typeahead="prod as prod.name for prod in $ctrl.productsService.getFilteredProducts($viewValue, 5)" typeahead-on-select=$ctrl.productSelected($item) typeahead-template-url=typeahead-product.tpl.html typeahead-show-hint-on-focus=all typeahead-select-on-exact=true typeahead-min-length=0 data-ng-model=$ctrl.productName ng-change=$ctrl.checkSelectionProduct() class=form-control placeholder="{{\'Product\'|translate}}" autocomplete=off></div><div class="col-lg-3 text-right"><input type=checkbox id=hideComp ng-model=$ctrl.filters.hideCompleted ng-change=$ctrl.toggleHideCompleted() class=switch-input><label for=hideComp class=switch-label><span translate>Pending only</span></label></div></div><div class="row mt-3" ng-if=$ctrl.hasFilters()><div class=col-4><button class="btn btn-warning btn-sm" ng-click=$ctrl.resetFilters()><i class="fa fa-undo"></i> <span translate>Reset filters</span></button></div><div class="col-8 text-right" ng-if="$ctrl.stats && $ctrl.hasFilters()">{{$ctrl.paging.count}} <span translate>Orders</span> | {{$ctrl.stats.amount}} <span translate>units</span> | <span translate>Total</span>: {{$ctrl.utils.getLocalizedCurrency($ctrl.stats.totalPrice)}}</div></div><div class=row><div class="padding-hor-clear col-md-12 table-wrapper table-responsive mt-20"><table id=ordersTable class="table table-hover"><thead><tr class=bold style="font-size: 90%"><th class=hidden-md-down></th><th class=hidden-md-down></th><th style="min-width: 200px" translate>Order</th><th ng-if="$ctrl.filters.role === $ctrl.ORDER_ROLES.DISTRIBUTOR"><i class="fa fa-user"></i>&nbsp;<span translate>Customer</span></th><th ng-if="$ctrl.filters.role !== $ctrl.ORDER_ROLES.DISTRIBUTOR"><i class="fa fa-arrow-circle-down"></i>&nbsp; <span ng-if=!$ctrl.utils.isSupplierDistributor() translate>Trader</span> <span ng-if=$ctrl.utils.isSupplierDistributor() translate>Distributor</span></th><th class=text-right translate>Unit price</th><th class="pl-0 text-right"><span translate>Units</span></th><th class=text-right><span translate>Total</span></th><th><span translate>Status</span></th></tr></thead><tbody><tr id=order-list-row-{{$index}} class=row-clickable ng-click=$ctrl.selectOrder(order) data-ng-repeat="order in $ctrl.orders" ng-class="{\'text-disabled\': order.status === $ctrl.ORDER_STATUS.REJECTED, \'row-selected\': order._id === $ctrl.selectedOrderId }"><td class="text-center hidden-md-down"><span ng-if=order.isCrop><img style="margin: 0 auto" src=app/shared/images/crop_icon.png width=30> </span><span ng-if=!order.isCrop><img style="margin: 0 auto" src=app/shared/images/deal_icon.png width=30></span><div class="text-grey mt-1"><span ng-if=!order.isPurchase translate>Sale</span> <span ng-if=order.isPurchase translate>Purchase</span></div></td><td class=hidden-md-down><img ng-if=order.deal ng-src={{order.deal.imageUrl}} width=50> <i class="fa fa-bullhorn text-sale-offer" style="font-size: 30px" ng-if=order.request uib-tooltip="{{\'Customer request\'|translate}}"></i></td><td style="max-width: 300px"><div ng-if=!order.childrenOrders.length><div ng-if=!order.request><strong>{{order.productName}}</strong></div><div ng-if=order.request><strong>{{order.request.content.slice(1).join(\' | \')}}</strong></div></div><div ng-if=order.childrenOrders.length class=small><b>{{order.childrenProductNames}}</b></div><div>{{order.ref}}</div><div class=mt-0><small>{{$ctrl.utils.getLocalizedDateAndTime(order.date)}}</small></div></td><td><div ng-if="order.retailer && $ctrl.filters.role === $ctrl.ORDER_ROLES.DISTRIBUTOR"><b>{{order.retailer.name}}</b><br>{{order.user.name.first}} {{order.user.name.last}}<div ng-if=order.deliveryAddress.name class="text-muted small" style="clear: both"><i class="fa fa-truck text-warning"></i> <span>{{order.deliveryAddress.name}}</span></div></div><div ng-if="order.retailer && $ctrl.filters.role !== $ctrl.ORDER_ROLES.DISTRIBUTOR" class=row><div class="col-2 p-0"><img class="pt-1 pr-1" ng-src={{order.supplier.imageUrl}} width=40></div><div class="col p-0 text-info">{{order.supplier.name}}<div ng-if=order.deliveryAddress.name class="text-muted small" style="clear: both"><i class="fa fa-truck text-warning"></i> <span>{{order.deliveryAddress.name}}</span></div></div></div><div ng-if=!order.retailer>{{order.user.name.first}} {{order.user.name.last}}<div ng-if=order.deal.distributorDeal class=text-sale-offer><i class="fa fa-arrow-circle-down"></i> <span translate>From distributor</span></div></div></td><td ng-if=!order.childrenOrders.length class=text-right><div ng-if=order.unitPrice>{{$ctrl.utils.getLocalizedCurrency(order.unitPrice, order.priceDecimalDigits)}}<div class=small>/&nbsp; <span ng-if=order.deal>{{order.deal.customUnit}}</span> <span ng-if=!order.deal translate>Unit</span></div><div ng-if=order.discountPercent class="small text-warning">{{order.discountPercent | number:1}}% <span translate>discount</span></div></div><div ng-if="!order.unitPrice && order.unitPriceText">{{order.unitPriceText}}</div><div ng-if="!order.unitPrice && !order.unitPriceText" class=text-muted><span translate>Price as agreed</span></div></td><td ng-if=!order.childrenOrders.length class=text-right>{{order.amount}}<div class=small><span ng-if=order.deal>{{order.deal.customUnit}}</span> <span ng-if=!order.deal translate>Units</span></div></td><td ng-if=order.childrenOrders.length colspan=2 class=text-right><div ng-if=order.childrenOrders.length><h5>{{order.childrenOrders.length}} <span class=small translate>items</span></h5></div></td><td class=text-right><div ng-if="order.totalPrice || order.unitPrice">{{$ctrl.utils.getLocalizedCurrency(order.totalPrice || order.unitPrice * order.amount)}}</div><div ng-if="!order.totalPrice && !order.unitPrice"><span translate>Price as agreed</span></div></td><td><div class="order-status pending" ng-if="!order.status || order.status === $ctrl.ORDER_STATUS.PENDING || order.status === $ctrl.ORDER_STATUS.VIEWED"><span translate>Pending</span></div><div class="order-status paid" ng-if="order.status === $ctrl.ORDER_STATUS.PAID"><span translate>Paid</span></div><div class="order-status completed" ng-if="order.status === $ctrl.ORDER_STATUS.DELIVERED"><span translate>Delivered</span></div><div class="order-status completed" ng-if="order.status === $ctrl.ORDER_STATUS.COMPLETED"><span translate>Completed</span></div><div class="order-status completed" ng-if="order.status === $ctrl.ORDER_STATUS.FORWARDED"><span translate>Forwarded</span></div><div class="order-status invalid" ng-if="order.status === $ctrl.ORDER_STATUS.INVALID"><span translate>Invalid</span></div><div class="order-status invalid" ng-if="order.status === $ctrl.ORDER_STATUS.RESERVED"><span translate>Reserved</span></div><div class="order-status rejected" ng-if="order.status === $ctrl.ORDER_STATUS.REJECTED"><span translate>Rejected</span></div></td></tr></tbody></table><div ng-if=!$ctrl.orders.length class="alert alert-warning"><i class="fa fa-info-circle"></i> <span translate>No orders found.</span></div><div class=row ng-if=$ctrl.paging class=text-center><div class="col-md-12 col-lg-8"><ul uib-pagination class=pagination-sm first-text="{{\'First\'|translate}}" previous-text="{{\'Prev\'|translate}}" next-text="{{\'Next\'|translate}}" last-text="{{\'Last\'|translate}}" ng-change=$ctrl.onPage() total-items=$ctrl.paging.count ng-model=$ctrl.paging.current max-size=3 items-per-page=$ctrl.paging.itemsPerPage boundary-link-numbers=true></ul></div><div id=order-list-export class="col-md-2 col-lg-4 text-right hidden-sm-down"><button class="btn btn-secondary" ng-click=$ctrl.exportOrders()><i class="fa fa-download"></i> Export</button></div></div></div></div></div></div></section><script type=text/ng-template id=customer-typeahead.tpl.html><a>\n        <i class="fa fa-user-circle-o"></i>\n        <span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span>\n    </a></script><script type=text/ng-template id=retailer-typeahead.tpl.html><a>\n        <span ng-bind-html="match.model.name | uibTypeaheadHighlight:query"></span>\n        <div class="small" ng-repeat="account in match.model.accounts">\n            <i class="fa fa-user-circle-o"></i>\n            <span ng-bind-html="(account.name.first + \' \' + account.name.last) | uibTypeaheadHighlight:query"></span>\n        </div>\n    </a></script><script type=text/ng-template id=typeahead-product.tpl.html><a tabindex="-1" class="typeahead-general typeahead-product p-1">\n        {{match.model.name}}\n        <div class="small" ng-if="match.model.vendorProductId"><span translate>Product ID</span>: {{match.model.vendorProductId}}</div>\n        <div ng-if="match.model.categoryName && match.model.categoryName !== \'CROP\'">\n            <i class="small">\n                {{match.model.categoryName}}\n                <span ng-bind-html-unsafe="match.model.categoryName | typeaheadHighlight:query"></span>\n            </i>\n        </div>\n        <div ng-if="match.model.categoryName && match.model.categoryName === \'CROP\'">\n            <img style="float:left;" src="app/shared/images/crop_icon.png" width="20">\n            <small><i><span translate>Crop</span></i></small>\n        </div>\n    </a></script>');
$templateCache.put('app/modules/order/templates/passcode.html','<div><img class=mb-5 id=logo_img src=app/shared/images/fh_logo2018_white.png width=130 alt=FarmHedge></div><form name=passcodeForm class="form-horizontal passcode-form" autocomplete=off><div class=form-group><label for=txtPasscode translate>Pincode</label><input type=password autocomplete=off name=passcode id=txtPasscode class=form-control><p class=pass-error><i class="fa fa-times-circle"></i> <span class=error-text>Password is required</span></p></div><div ng-if=invalidPasscode class="alert alert-danger"><p><span translate>Invalid pincode</span></p></div></form>');
$templateCache.put('app/modules/product/products/products-list.tpl.html','<section class=light-gray-bg><div class="container mt-20"><div class=tab-content><div class=row><div class="col-lg-5 pr-0 pt-2"><h5><span translate>Your products</span> ({{$ctrl.paging.totalItems}}) <small>({{$ctrl.countPublic}}&nbsp;<span translate>Available to customers</span>)</small></h5></div></div><div class=row><div class="col-lg-4 text-right"><div class=input-group><span class=input-group-addon><i class="fa fa-search"></i></span> <input type=text class=form-control ng-model=$ctrl.filters.searchText ng-model-options="{ debounce: 500 }" ng-change=$ctrl.searchTextChanged() placeholder="{{\'Search\'|translate}}"></div></div><div class="col-lg-2 p-0"><button class="btn btn-warning m-0" ng-if=$ctrl.hasFilters() ng-click=$ctrl.resetFilters()><i class="fa fa-undo"></i> <span translate>Reset filters</span></button></div><div class="col text-right"><button ng-click=$ctrl.addNew() class="btn btn-outline-success btn-animated m-0"><i class="fa fa-plus-circle"></i> <span translate>New product</span></button></div></div><div class=row><div class="padding-hor-clear col-md-12 table-wrapper mt-20 table-responsive" style="min-height: 600px"><table class="table table-hover"><thead><tr class=bold style="font-size: 90%"><th translate>Image</th><th translate>Attachment</th><th style="min-width: 200px" translate>Product</th><th translate>Details</th><th style="min-width: 50px" class=text-center translate>Available to customers</th><th style="min-width: 100px" translate>Offers</th><th style="min-width: 50px" translate>Stock</th><th style="min-width: 50px" translate></th></tr></thead><tbody><tr data-ng-repeat="prod in $ctrl.products" class=row-clickable ng-class="{\'row-selected row-highlighted\': $ctrl.selectedProductId === prod._id}"><td class="text-left pl-0 pr-0"><div class=img-edit><div ng-if=prod.isOwned class=mask ng-click=$ctrl.editProductImage(prod)><i class="fa fa-pencil"></i></div><img ng-src="{{prod.imageUrls[0] || \'app/shared/images/default-no-image.jpg\'}}" style="max-height: 45px; max-width: 100px; margin: 0 auto"></div></td><td class=text-center><button class="btn btn-secondary m-0" ng-if=!prod.attachments.length ng-click=$ctrl.addAttachment(prod)><i class="fa fa-paperclip text-disabled" style="font-size: 1.5rem"></i></button> <button class="btn btn-secondary m-0" ng-if=prod.attachments.length ng-click="$ctrl.editAttachment(prod, 0)"><i class="fa fa-paperclip font-weight-bold text-primary" style="font-size: 1.5rem"></i></button></td><td class="pl-0 pr-0" ng-click=$ctrl.editProduct(prod) style="max-width: 200px">{{prod.name}}<div class=small><i>{{prod.categoryName}}</i></div><div ng-if=prod.vendorProductId class=small><span translate>Product Id</span>:&nbsp;{{prod.vendorProductId}}</div></td><td class="pr-0 pb-0 small" ng-click=$ctrl.editProduct(prod)><div ng-if=prod.attributes><div ng-repeat="attr in prod.attributes">{{attr.label}}:&nbsp;{{attr.value}}</div></div></td><td class="pt-2 text-center"><div ng-if="prod.isPublic && prod.deals.sent.ongoing"><a class="btn col-12 p-2 btn-outline-success text-success mt-1" ng-click=$ctrl.editPrice(prod) ng-if=$ctrl.utils.isNumber(prod.deals.sent.ongoing.benchmarkPrice)><span ng-if=!prod.deals.sent.ongoing.retailPrices.length>{{$ctrl.utils.getLocalizedCurrency(prod.deals.sent.ongoing.benchmarkPrice, prod.deals.sent.ongoing.priceDecimalDigits)}} </span><span ng-if=prod.deals.sent.ongoing.retailPrices.length>{{$ctrl.dealsService.getRetailerPricesRange(prod.deals.sent.ongoing)}} <span class=text-disabled><i class="fa fa-user"></i> {{prod.deals.sent.ongoing.retailPrices.length}}</span></span><div ng-if="prod.deals.sent.ongoing.priceDynamic.isEnabled && !$ctrl.isPriceStale(prod)"><countdown date-time=prod.deals.sent.ongoing.priceDynamic.nextUpdateAt hide-seconds=true icon="\'fa-bolt\'"></countdown></div><div ng-if="prod.deals.sent.ongoing.priceDynamic.isEnabled && $ctrl.isPriceStale(prod)" class=text-danger><i class="fa fa-exclamation-triangle"></i> <span translate>Update needed</span><div class=small><span translate>Since</span>: {{$ctrl.utils.getLocalizedDateAndTime(prod.deals.sent.ongoing.priceDynamic.nextUpdateAt)}}</div></div></a><a class="btn col-12 p-2 btn-outline-success mt-1 text-muted" ng-click=$ctrl.editPrice(prod) ng-if=!prod.deals.sent.ongoing.benchmarkPrice><span translate>On request</span> <span ng-if="prod.deals.sent.ongoing.retailPrices.length && prod.deals.sent.ongoing.retailPrices.length < $ctrl.allTradersCount"><i class="fa fa-user"></i> {{prod.deals.sent.ongoing.retailPrices.length}}</span></a><div class="text-muted mb-2" ng-if="prod.deals.sent.ongoing.individualDiscount > 0 || prod.deals.sent.ongoing.clearanceDiscount > 0" ng-click=$ctrl.editPrice(prod)><span>{{prod.deals.sent.ongoing.individualDiscount || 0|number:1}}% </span><span ng-if=$ctrl.dealsService.isQuantityDiscountEnabled(prod.deals.sent.ongoing)>~&nbsp;{{prod.deals.sent.ongoing.clearanceDiscount|number:1}}% </span><small translate>Discount</small></div><div ng-if=prod.deals.sent.ongoing.users.length><i class="fa fa-user"></i> {{prod.deals.sent.ongoing.users.length}}</div><div ng-if="prod.deals.sent.ongoing.target === \'NEW_USERS\' && prod.deals.sent.ongoing.userGroups.length"><span ng-repeat="g in prod.deals.sent.ongoing.userGroups track by $index" class="chip text-white" ng-style="{\'background-color\': g.color}">{{g.name.charAt(0).toUpperCase() + g.name.substr(1)}}</span></div><div class="text-muted small"><i ng-if=!$ctrl.dealsService.isDistributionCollection(prod.deals.sent.ongoing) class="fa fa-truck"></i> <i ng-if=$ctrl.dealsService.isDistributionCollection(prod.deals.sent.ongoing) class="fa fa-home"></i> {{prod.deals.sent.ongoing.distributionOptions.start}} - {{prod.deals.sent.ongoing.distributionOptions.end}} {{prod.deals.sent.ongoing.distributionOptions.timeUnit}}</div></div><div ng-if="!prod.isPublic || !prod.deals.sent.ongoing"><span class="small text-disabled" translate>Offers only</span></div></td><td class=text-right><div ng-if=prod.deals.sent.latest.length ng-repeat="deal in prod.deals.sent.latest"><a ng-if=$ctrl.dealsService.isActive(deal) class="btn btn-sm btn-secondary text-warning" uib-tooltip="{{\'Special offer until\'|translate}} {{$ctrl.utils.getLocalizedDate(deal.bookingEnd)}}" ui-sref="app.deals.list({ dealId: deal._id })"><i class="fa fa-tag"></i> <span ng-if=deal.benchmarkPrice ng-switch=$ctrl.utils.isNumber(deal.benchmarkPrice)><span ng-switch-when=false>{{deal.benchmarkPrice}}</span> <span ng-switch-when=true>{{$ctrl.utils.getLocalizedCurrency($ctrl.utils.getSalePrice(deal.benchmarkPrice, deal.individualDiscount), deal.priceDecimalDigits)}}</span> </span>&nbsp;/&nbsp;{{prod.unit}}<div class="small text-right"><span>{{deal.progress || 0}}<span ng-if="deal.dealSize < 999999">/{{deal.dealSize}}</span></span></div></a></div></td><td ng-click=$ctrl.editProduct(prod)><div ng-if="prod.stockQuantity && prod.stockQuantity < 99999">{{prod.stockQuantity | number:0}}</div><div ng-if="!prod.stockQuantity || prod.stockQuantity > 99999">&infin;</div><div class=small>{{prod.unit}}</div></td><td><div ng-if=prod.isOwned><div class=btn-group><button class="btn btn-secondary btn-md p-3 mt-0 dropdown-toggle" type=button id=createNewDraftButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class="text-muted small" translate>Actions</span></button><div class="dropdown-menu dropdown-menu-right"><a class="btn btn-sm dropdown-item text-sale-offer text-primary" ng-click=$ctrl.editProduct(prod)><i class="fa fa-edit"></i> <span translate>Edit product</span> </a><a class="btn btn-sm dropdown-item text-sale-offer text-primary" ng-click=$ctrl.duplicateProduct(prod)><i class="fa fa-copy"></i> <span translate>Duplicate product</span> </a><a class="btn btn-sm dropdown-item text-sale-offer text-success mt-3" ng-if=$ctrl.utils.supplierHasProductTypeBuy() ng-click=$ctrl.createNewSaleOffer(prod)><i class="fa fa fa-shopping-cart"></i> <span translate>New sale offer</span> </a><a class="btn btn-sm dropdown-item text-sale-offer text-success mt-3" ng-if=$ctrl.utils.supplierHasProductTypeSell() ng-click=$ctrl.createNewCropOffer(prod)><i class="fa fa-leaf"></i> <span translate>New crop offer</span> </a><a class="btn btn-sm dropdown-item text-sale-offer text-warning" ng-if=prod.attachments.length ng-click=$ctrl.removeAttachment(prod)><i class="fa fa-paperclip"></i> <span translate>Remove attachment</span> </a><a class="btn btn-sm dropdown-item text-sale-offer text-danger mt-3" ng-click="$ctrl.deleteProduct(prod, 0)"><i class="fa fa-trash"></i> <span translate>Delete product</span></a></div></div></div></td></tr></tbody></table><div ng-if=!$ctrl.products.length class="alert alert-warning"><i class="fa fa-info-circle"></i> <span translate>No products found.</span></div></div><div class=col-md-12><ul uib-pagination class=pagination-sm first-text="{{\'First\'|translate}}" previous-text="{{\'Prev\'|translate}}" next-text="{{\'Next\'|translate}}" last-text="{{\'Last\'|translate}}" ng-change=$ctrl.onPage() total-items=$ctrl.paging.totalItems ng-model=$ctrl.paging.current max-size=$ctrl.paging.maxSize items-per-page=$ctrl.paging.itemsPerPage boundary-link-numbers=true boundary-links=true></ul></div></div></div><div class="alert alert-warning" ng-if=$ctrl.utils.isUserRegionalManager()><h6>Admin section</h6><div><button type=button ng-if=$ctrl.utils.isUserRegionalManager() ng-click=$ctrl.importProducts() class="btn btn-sm btn-info"><i class="fa fa-upload"></i> <span translate>Import products</span></button> <button type=button ng-if=$ctrl.utils.isUserRegionalManager() ng-click=$ctrl.importImages() class="btn btn-sm btn-outline-info"><i class="fa fa-image"></i> <span translate>Import images</span></button> <button type=button class="btn btn-sm btn-outline-danger float-right" ng-click=$ctrl.deleteAllProducts()>Delete all products</button></div></div></div></section>');
$templateCache.put('app/modules/profile/billingInfo/billing-info.tpl.html','<div class="container-fluid billing-info"><div class="row billing-info"><div class="tab-heading col-12"><h4 style="width: 100%"><span translate>Billing information</span></h4></div><div class="col-12 mb-10"><div class=row><div class=col-12><div ng-if=!$ctrl.billing.isEnabled><p class="alert alert-warning" role=alert><strong translate>FarmHedge payments are disabled.</strong></p><p><span translate>FarmHedge payments to allow your customers to pay with their credit/debit card.</span></p><p><span translate>You will receive the funds directly on a bank account of your choice.</span></p><p class="col-xs-12 col-md-6 col-lg-3"><button ng-click=$ctrl.connect() class="btn btn-info"><span translate>Activate FarmHedge payments</span></button></p><p><span translate>The registration process takes only a few minutes.</span></p></div><div class=row ng-if=$ctrl.billing.isEnabled><div class=col-12><div><h5 class="alert alert-success" translate>FarmHedge payments are enabled</h5><p><span translate>This means that your customers can pay on the FarmHedge app using their credit or debit card.</span></p><p><span translate>You will receive the funds directly on the bank account specified during the registration process.</span></p><p><ul><li><span translate>Payments were enabled on: </span>&nbsp;{{$ctrl.utils.getLocalizedDateAndTime($ctrl.billing.enabledAt)}}</li><li><span translate>Account ID: </span>&nbsp;{{$ctrl.billing.stripeUserId}}</li></ul></p><p ng-if=ctrl.billing.enabledBy.name.first><span translate>By: </span>&nbsp;{{$ctrl.billing.enabledBy.name.first + \' \' + $ctrl.billing.enabledBy.name.last}}</p><div class=row><div class=col-12><a ng-click=$ctrl.disconnect() class="btn btn-md btn-secondary text-danger">Disable payments</a></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/modules/profile/collection.points/collection-point-edit-prompt.tpl.html','<div class="mt-2 mb-4 p-2"><div class="form-group has-feedback"><label translate>Name</label><div><input type=text ng-model=cp.name class=form-control></div></div><div class="form-group has-feedback"><label translate>Email</label><div><input type=text ng-model=cp.email class=form-control></div></div><div class="form-group has-feedback"><label translate>Address</label><div class="row mb-1"><div class=col-md-12><input type=text class=form-control placeholder="{{\'Street\'|translate}}" ng-model=cp.addressDetails.street></div></div><div class=row><div class="col-md-4 pr-0"><input type=text class=form-control placeholder="{{\'Zip code\'|translate}}" ng-model=cp.addressDetails.zipcode></div><div class="col-md-8 pl-1"><input type=text class=form-control placeholder="{{\'City\'|translate}}" ng-model=cp.addressDetails.city></div></div></div><br></div>');
$templateCache.put('app/modules/profile/collection.points/collection.points.tpl.html','<div class=container-fluid><div class=row><div class="tab-heading col-12"><h4 style="width: 100%"><i class="fa fa-map-marker"></i> <span translate>Shops</span> ({{$ctrl.cpList.length}}) <button class="btn btn-success btn-animated pull-right" ng-click=$ctrl.addRow() ng-disabled=!$ctrl.canAddRow()><span translate>Add</span> <i class="fa fa-plus"></i></button></h4></div><div class="col-12 mb-10"><div class="alert alert-warning" ng-if=!$ctrl.cpList.length><span translate>No shops</span></div><table class="table table-striped" ng-if=$ctrl.cpList.length><thead><tr><th translate>Name</th><th translate>Email</th><th translate>Address</th><th></th></tr></thead><tbody><tr ng-repeat="cp in $ctrl.cpList" class=row-clickable ng-class="{\'row-removed text-danger\': cp.isDeleted}"><td ng-click=$ctrl.editRow(cp)>{{cp.name}}</td><td ng-click=$ctrl.editRow(cp)>{{cp.email || \'---\'}}</td><td ng-click=$ctrl.editRow(cp)>{{cp.address || \'---\'}}</td><td><button ng-if=!cp.isDeleted class="btn btn-icon fa fa-trash m-0" ng-click=$ctrl.removeRow(cp)></button> <button ng-if=cp.isDeleted class="btn btn-icon fa fa-undo m-0" ng-click=$ctrl.restoreRow(cp)></button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/modules/profile/profile/profile.view.html','<!-- main-container start --><!-- ================ --><section class=main-container><div class=container><div class=row><!-- main start --><!-- ================ --><div class="main col-12"><!-- page-title start --><!-- ================ --><div class="row mb-4"><div class="col-lg-3 col-4 col-lg-2 pt-1"><div class="profile-img img-edit"><div class=mask ng-click=vm.updateImage()><i class="fa fa-pencil"></i></div><img style="height: 100px" ng-src="{{vm.user.supplier.imageUrl || \'app/shared/images/default-no-image.jpg\'}}"></div></div><div class="col-lg-5 col-8"><h4 class=page-title>{{vm.user.supplier.name}}</h4><p><span translate>Country</span>: <b>{{vm.user.supplier.area}}</b></p><p ng-if=vm.user.supplier.subscriptionPackage class="mb-0 pt-0 small"><span translate>FarmHedge supription package:</span>&nbsp;<b>{{vm.user.supplier.subscriptionPackage}}</b></p><p ng-if=vm.user.supplier.subscriptionExpiresAt class="mt-0 pt-0 small"><span translate>Subscription expiration date:</span>&nbsp;<b>{{vm.utils.getLocalizedDate(vm.user.supplier.subscriptionExpiresAt)}}</b></p></div><div class="col-lg-4 col-12 m-0 p-3" ng-if=vm.hasUnsavedChanges><div class="alert alert-warning alert-icon m-0"><i class="fa fa-warning"></i> <span translate>Click "Save" to make sure changes are not lost.</span></div></div></div><!-- page-title end --><div class=row><div class=col><ul class="nav nav-tabs style-1" role=tablist><li class=nav-item><a class=nav-link ng-click="vm.setTab(\'userInfo\')" role=tab ng-class="{\'active\': vm.currentTab === \'userInfo\'}" data-toggle=tab><i class="fa fa-user pr-2"></i><span translate>User profile</span></a></li><li class=nav-item ng-if=vm.utils.getSettings().tradeWithFarmers><a class=nav-link ng-click="vm.setTab(\'zipCodes\')" role=tab ng-class="{\'active\': vm.currentTab === \'zipCodes\'}" data-toggle=tab><i class="fa fa-map-marker pr-2"></i><span translate>Counties</span></a></li><li class=nav-item><a class=nav-link ng-click="vm.setTab(\'collectionPoints\')" role=tab ng-class="{\'active\': vm.currentTab === \'collectionPoints\'}" data-toggle=tab><i class="fa fa-home pr-2"></i><span translate>Shops</span> / <span translate>Addresses</span></a></li><li class=nav-item ng-if="vm.utils.isFeatureEnabled(\'BILLING_INFO\')"><a class=nav-link ng-click="vm.setTab(\'billing\')" role=tab ng-class="{\'active\': vm.currentTab === \'billing\'}" data-toggle=tab><i class="fa fa-credit-card pr-2"></i><span translate>Billing Info</span></a></li></ul><div class=tab-content><div class="tab-pane fade show" ng-class="{\'active\': vm.currentTab === \'userInfo\'}" id=userInfo role=tabpanel><div class=container-fluid><div class="row mb-3"><div class="col-lg-1 col-3"><div class="user-img img-edit"><div class=mask ng-click=vm.updateUserImg()><i class="fa fa-pencil"></i></div><img ng-src="{{vm.user.imageUrl || vm.userData.imageUrl || \'app/shared/images/team-member.jpg\'}}" ng-error-src=app/shared/images/team-member.jpg class=centered alt=""></div></div><div class="col-lg-6 col pt-2"><h4><span translate>User</span>: {{vm.user.name.first}} {{vm.user.name.last}}</h4></div></div><user-info></user-info></div></div><div class="tab-pane fade show" ng-class="{\'active\': vm.currentTab === \'zipCodes\'}" id=zipCodes role=tabpanel><zip-codes country=vm.user.supplier.area zip-list=vm.zipCodes zip-map=vm.zipCodesMap></zip-codes></div><div class="tab-pane fade show" ng-class="{\'active\': vm.currentTab === \'collectionPoints\'}" id=collectionPoints role=tabpanel><collection-points cp-list=vm.collectionPoints></collection-points></div><div class="tab-pane fade show" ng-class="{\'active\': vm.currentTab === \'retailers\'}" id=retailers role=tabpanel><h5 class="col-12 alert alert-info alert-icon"><i class="fa fa-question-circle-o"></i> <span translate>Coming soon</span></h5></div><div class="tab-pane fade show" ng-class="{\'active\': vm.currentTab === \'billing\'}" id=billing role=tabpanel><billing-info billing=vm.user.supplier.billing></billing-info></div></div></div></div><div class=separator></div><div class="row mt-10"><div class="col-6 m-0"></div><div class="col-md-6 p-3 text-right"><button ng-click=vm.submit() class="btn btn-md btn-success col-8 p-3" ng-disabled=!vm.hasUnsavedChanges><span translate>Save</span> <i class="fa fa-check"></i></button></div></div></div><!-- main end --></div></div></section><!-- main-container end -->');
$templateCache.put('app/modules/profile/userInfo/change-password.tpl.html','<div class="row password-form"><div class="col-md-12 col-lg-12"><p class=password-help ng-if=!passForm.$submitted><i class="fa fa-question-circle-o"></i> Password should be minimum 8 Characters including at least one Captial Letter, One number and one symbol.</p></div><div class="col-md-12 col-lg-12"><form class=form-horizontal name=passForm novalidate><div class="form-group row"><label for=currentPassword class="col-md-4 text-md-right control-label col-form-label">Current Password</label><div class="col-md-8 col-lg-7"><input type=password name=CurrentPass ng-model=payload.current class=form-control id=currentPassword placeholder="Current Password" show-password=showCurrPass required> <a class=pass-show ng-click="showCurrPass = !showCurrPass"><i ng-if=!showCurrPass class="fa fa-eye form-control-feedback pr-4"></i> <i ng-if=!!showCurrPass class="fa fa-eye-slash form-control-feedback pr-4"></i></a></div><div class="col-md-8 push-md-4 col-lg-7" ng-messages=passForm.CurrentPass.$error ng-if="passForm.$submitted && passForm.CurrentPass.$invalid"><p ng-message=required class=error-message><i class="fa fa-times"></i> current password is required</p></div></div><div class="form-group row"><label for=newPassword class="col-md-4 text-md-right control-label col-form-label">New Password</label><div class="col-md-8 col-lg-7"><input type=password name=NewPassword ng-model=payload.newpass class=form-control id=newPassword placeholder="New Password" show-password=showNewPass required> <a class=pass-show ng-click="showNewPass = !showNewPass"><i ng-if=!showNewPass class="fa fa-eye form-control-feedback pr-4"></i> <i ng-if=!!showNewPass class="fa fa-eye-slash form-control-feedback pr-4"></i></a></div><div class="col-md-8 push-md-4 col-lg-7 password-strength"><div class=ps-wrapper><ul class=pass-strength ng-if="payload.newpass && passForm.$submitted && passForm.NewPassword.$invalid" ng-messages=passForm.NewPassword.$error><li ng-class="{\'valid\': !passForm.NewPassword.$error.length }"><i class="fa {{passForm.NewPassword.$error.length? \'fa-check-circle\':\'fa-times-circle\'}}"></i> <span>must be minimum 8 characters</span></li><li ng-class="{\'valid\': !passForm.NewPassword.$error.lower }"><i class="fa {{passForm.NewPassword.$error.lower? \'fa-check-circle\':\'fa-times-circle\'}}"></i> <span>must contain one lowercase character</span></li><li ng-class="{\'valid\': !passForm.NewPassword.$error.capital }"><i class="fa {{passForm.NewPassword.$error.capital? \'fa-check-circle\':\'fa-times-circle\'}}"></i> <span>must contain one capital character</span></li><li ng-class="{\'valid\': !passForm.NewPassword.$error.number }"><i class="fa {{passForm.NewPassword.$error.number? \'fa-check-circle\':\'fa-times-circle\'}}"></i> <span>must contain one number</span></li><li ng-class="{\'valid\': !passForm.NewPassword.$error.special }"><i class="fa {{passForm.NewPassword.$error.special? \'fa-check-circle\':\'fa-times-circle\'}}"></i> <span>must contain one special character</span></li></ul></div></div></div><div class="form-group row"><label for=confirmPassword class="col-md-4 text-md-right control-label col-form-label">Confirm Password</label><div class="col-md-8 col-lg-7"><input type=password name=ConfirmPass ng-model=payload.confirm equal-with=payload.newpass class=form-control id=confirmPassword placeholder="Confirm Password" show-password=showConfPass required> <a class=pass-show ng-click="showConfPass = !showConfPass"><i ng-if=!showConfPass class="fa fa-eye form-control-feedback pr-4"></i> <i ng-if=!!showConfPass class="fa fa-eye-slash form-control-feedback pr-4"></i></a></div><div class="col-md-8 push-4 col-lg-7" ng-messages=passForm.ConfirmPass.$error ng-if="passForm.$submitted && passForm.ConfirmPass.$invalid"><p ng-message=required class=error-message><i class="fa fa-times"></i> confirm password is required</p><p ng-message=equalWith class=error-message><i class="fa fa-times"></i> confirm password did not match</p><p></div></div></form></div></div><hr class=hr1>');
$templateCache.put('app/modules/profile/userInfo/user.info.tpl.html','<div class="row spacer15 pt-2"><div class=col-12><div class="col-12 info-item"><div class=row><div class="col-lg-9 col-12"><i class="fa fa-globe"></i> <span class=font-weight-bold translate>Language</span>: <span>{{$ctrl.getCurrentLocaleInfo()}}</span><div class=small><span translate>Examples</span>: {{$ctrl.utils.getLocalizedDate($ctrl.exampleDate)}} | {{$ctrl.utils.getLocalizedDateAndTime($ctrl.exampleDate)}} | {{$ctrl.utils.getLocalizedCurrency(1530920.55)}}</div></div><div class="btn-group dark col-lg-3 col-12 p-0"><button type=button class="btn btn-gray dropdown-toggle dropdown-toggle-split col-12 m-2" data-toggle=dropdown aria-haspopup=true aria-expanded=false aria-labelledby=language><span translate>Change language</span></button><div class="dropdown-menu dropdown-menu-right"><a ng-repeat="locale in $ctrl.locales" ng-click=$ctrl.switchLanguage(locale.code) class="dropdown-item language-link">{{locale.label}}</a></div></div></div></div><div class="col-12 info-item"><i class="fa fa-envelope"></i> <span class=font-weight-bold translate>Email</span>: {{$ctrl.user.email}}<!-- <a class="btn btn-sm btn-dark text-white" ng-click="$ctrl.updatePassword()"><i class="fa fa-key"></i> <span translate>Update</span></a> --></div><div class="col-12 info-item"><i class="fa fa-phone"></i> <span class=font-weight-bold translate>Phone</span>: {{$ctrl.user.phoneNumber}}<!-- <a class="btn btn-sm btn-dark text-white" ng-click="$ctrl.updatePassword()"><i class="fa fa-key"></i> <span translate>Update</span></a> --></div><div class="col-12 info-item"><div class=row><div class="col-lg-9 col-12"><i class="fa fa-lock"></i> <span class=font-weight-bold translate>Password</span></div><div class="col-lg-3 col-12"><a class="btn btn-gray col-12" ng-click=$ctrl.updatePassword()><span translate>Reset password</span></a></div></div></div></div></div>');
$templateCache.put('app/modules/profile/zipcode/zipcode.tpl.html','<div class=container-fluid><div class=row><div class="tab-heading col-12"><h4><i class="fa fa-map-marker"></i> <span translate>Counties</span> ({{$ctrl.zipList.length}})</h4></div><div class="col-xs-12 col-md-6"><p ng-if=!$ctrl.zipList.length translate>No zipcodes assigned to supplier</p><p ng-if=$ctrl.zipList.length></p><div class=row ng-if=$ctrl.zipList.length><div class=col-12><p translate>List of counties assigned to supplier:</p><hr class=col-12></div><div class="col-12 col-lg-8"><ul class=list-group-editable><li ng-repeat="zipCode in $ctrl.zipList | orderBy:\'toString()\'"><div class=label ng-class="{\'row-removed\': $ctrl.removedMap[zipCode], \'text-success\': $ctrl.newMap[zipCode] }"><span ng-if=!$ctrl.zipMap[zipCode]>{{zipCode}} </span><span ng-if=$ctrl.zipMap[zipCode]>{{$ctrl.zipMap[zipCode]}} </span><i ng-if=$ctrl.newMap[zipCode] class="fa fa-hourglass-3"></i></div><div class="controls pull-right" ng-if=$ctrl.utils.isUserRegionalManager()><a class="btn btn-link" ng-if=!$ctrl.removedMap[zipCode] ng-click=$ctrl.removeZipCode(zipCode) analytics-on=click analytics-event="Delete zip code" analytics-value={{zipCode}}><i class="fa fa-trash ql-color-red"></i></a> <a class="btn btn-link" ng-if=$ctrl.removedMap[zipCode] ng-click=$ctrl.restoreZipCode(zipCode) analytics-on=click analytics-event="Restore zip code" analytics-value={{zipCode}}><i class="fa fa-undo ql-color-red"></i></a></div></li></ul></div></div></div><div class="col-sm-12 col-md-6" ng-if=$ctrl.utils.isUserRegionalManager()><form class="navbar-form pull-right col-9" ng-submit=$ctrl.addNewZipCode() autocomplete=off><div class="input-group custom-addon zip-typeahead"><input type=text id=inputZipCode class=form-control placeholder="{{\'Zip code\'|translate}}" name=srch-term ng-model=$ctrl.newZipCode typeahead-on-select=$ctrl.addNewZipCode($item) typeahead-template-url=zip.typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=1 uib-typeahead="zipCode as zipCode.label for zipCode in $ctrl.fetchZipCodes($viewValue)"><div class=input-group-btn><button class="btn btn-primary" type=submit ng-disabled="!$ctrl.newZipCode || $ctrl.newZipCode.trim().length === 0" analytics-on=click analytics-event="Add zip code" analytics-value={{$ctrl.newZipCode}}><i class="fa fa-plus-circle"></i></button></div></div></form></div></div><!--<div class="row">--><!--<form class="form-inline col-12" ng-submit="$ctrl.addNewZipCode()" autocomplete="off">--><!--<label class="sr-only" for="inputZipCode">Username</label>--><!--<div class="input-group input-typeahead mb-2 mr-sm-2 mb-sm-0">--><!--<input type="text"--><!--id="inputZipCode"--><!--ng-model="$ctrl.newZipCode"--><!--typeahead-on-select="$ctrl.addNewZipCode($item)"--><!--uib-typeahead="zipCode as zipCode.label for zipCode in $ctrl.fetchZipCodes($viewValue)"--><!--class="form-control">--><!--</div>--><!--<button type="submit"--><!--class="btn btn-primary"--><!--ng-disabled="!$ctrl.newZipCode || $ctrl.newZipCode.trim().length === 0"--><!--analytics-on="click"--><!--analytics-event="Add zip code"--><!--analytics-value="{{$ctrl.newZipCode}}"> <i class="fa fa-plus"></i> <span translate>Add</span>--><!--</button>--><!--</form>--><!--</div>--></div><script type=text/ng-template id=zip.typeahead.tpl.html><a>\n        <i class="fa fa-map-pin"></i>\n        <span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span>\n    </a></script>');
$templateCache.put('app/modules/shopping-cart/checkout/shopping-cart-checkout.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-check-square"></i> <span translate>New order</span></h4><button type=button ng-click=$ctrl.cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class=modal-body><div class=col-md-12><div class="row mb-2"><div class="col-1 pr-0"><img ng-src={{$ctrl.cart.supplier.imageUrl}}></div><div class="col pt-1"><h4>{{$ctrl.cart.supplier.name}}</h4></div></div><table id=checkout-items class="table mb-4" cellspacing=5 cellpadding=5><thead><tr><th><span translate>Product</span></th><th><span translate>Details</span></th><th class=text-right><span translate>Unit price</span></th><th class=text-right><span translate>Units</span></th><th class=text-right><span translate>Total</span></th></tr></thead><tbody><tr ng-repeat="item in $ctrl.cart.items" class=row-clickable ng-click="$ctrl.editCartItem(item, $index)"><td width=30%>{{item.productName || item.deal.productName || item.deal.product.name}}<div class=small><i>{{item.deal.customType}}</i></div><div ng-if=prod.vendorProductId class=small><span translate>Product Id</span>:&nbsp;{{item.vendorProductId || item.deal.vendorProductId}}</div></td><td class=small><div ng-if=item.deal.paymentMethod><span translate>Incoterms</span>: <b>{{item.deal.paymentMethod}}</b></div><div ng-if=item.deal.productAttributes><div ng-repeat="attr in item.deal.productAttributes">{{attr.label}}:&nbsp;{{attr.value}}</div></div><div ng-repeat="attachment in item.attachments"><a href={{attachment.url}} target=_blank download><i class="fa fa-paperclip"></i> {{attachment.name}}</a></div></td><td class=text-right><div ng-if=item.unitPrice>{{$ctrl.utils.getLocalizedCurrency(item.unitPrice)}}</div><div class=small>/ {{item.deal.customUnit}}</div></td><td class=text-right>{{item.quantity}}</td><td class=text-right><div ng-if=item.totalPrice>{{$ctrl.utils.getLocalizedCurrency(item.totalPrice)}}</div><div><span ng-if=!item.deal.isVatIncluded class=small translate>Excl. VAT</span> <span ng-if=item.deal.isVatIncluded class=small translate>Incl. VAT</span></div></td></tr><!-- forEach item --></tbody></table><form name=$ctrl.form role=form autocomplete=off class="m-0 p-0"><div id=checkout-addresses class="row mt-3"><div class=col-md-6><div><h5><i class="fa fa-book"></i> <span translate>Billing info</span></h5></div><div><div class=form-group ng-class="{\'has-error\': $ctrl.form.n1.$invalid && $ctrl.form.$submitted }"><label for=billAddress style="width: 100%"><span translate>Name</span> <a class="small btn btn-sm btn-link p-0 ml-3 mb-0 mt-0 text-muted pull-right" ng-click=$ctrl.copyCollectionPoint() ng-if="$ctrl.order.billingAddress.name && !$ctrl.dealsService.isCategoryCrop($ctrl.deal)"><small translate>Copy</small> <i class="fa fa-arrow-right"></i></a></label><input id=billAddress name=billingAddressName type=search class=form-control data-ng-model=$ctrl.order.billingAddress.name placeholder="{{\'Name\'|translate}}" uib-typeahead="opt as (opt.name + \'<br><small>\' + opt.address + \'</small>\') for opt in $ctrl.billingOpts | filter: $viewValue" typeahead-on-select=$ctrl.setBillingData($item) typeahead-show-hint-on-focus=all typeahead-min-length=0 tabindex=2 autocomplete=off required></div><div class=form-group ng-class="{\'has-error\': $ctrl.form.street1.$invalid && $ctrl.form.$submitted }"><label style="width: 100%"><span translate>Address</span> <a class="small btn btn-sm btn-link p-0 ml-3 mb-0 mt-0 text-muted pull-right" ng-click=$ctrl.copyBillingAddress() ng-if="$ctrl.order.billingAddress.street && !$ctrl.dealsService.isCategoryCrop($ctrl.deal)"><small translate>Copy</small> <i class="fa fa-arrow-right"></i></a></label><textarea name=street1 type=text class=form-control data-ng-model=$ctrl.order.billingAddress.street rows=2 placeholder="{{\'Street\'|translate}}" tabindex=3 autocomplete=off required>\n                            </textarea></div><div class=row><div class="form-group col-md-4" ng-class="{\'has-error\': $ctrl.form.zipcode1.$invalid && $ctrl.form.$submitted }"><input name=zipcode1 type=text class=form-control data-ng-model=$ctrl.order.billingAddress.zipcode placeholder="{{\'Zip code\'|translate}}" tabindex=4 autocomplete=off required></div><div class="form-group col-md-8" ng-class="{\'has-error\': $ctrl.form.city1.$invalid && $ctrl.form.$submitted }"><input name=city1 type=text class=form-control data-ng-model=$ctrl.order.billingAddress.city placeholder="{{\'City\'|translate}}" tabindex=5 autocomplete=off required></div></div></div></div><div class="col-md-6 m-0 p-0" ng-if=!$ctrl.dealsService.isCategoryCrop($ctrl.deal)><div class=col-md-12><h5><i class="fa fa-truck"></i> <span translate>Delivery Info</span></h5></div><div class=col-md-12><div class=row><div class="form-group col-md-6 pr-0" ng-class="{\'has-error\': $ctrl.form.n2.$invalid && $ctrl.form.$submitted }"><label translate>Name</label><input name=n2 type=text class=form-control data-ng-model=$ctrl.order.deliveryAddress.name placeholder="{{\'Name\'|translate}}" tabindex=6 autocomplete=off uib-typeahead="cust.fullName for cust in $ctrl.getCustomers($viewValue)" typeahead-loading=$ctrl.loadingCustomers typeahead-show-hint-on-focus=all typeahead-min-length=0 typeahead-template-url=customer-typeahead.tpl.html typeahead-on-select=$ctrl.customerSelected($item) required></div><div class="form-group col-md-6" ng-class="{\'has-error\': $ctrl.form.pn.$invalid && $ctrl.form.$submitted }"><label translate>Phone number RA</label><input name=pn type=text class=form-control data-ng-model=$ctrl.order.phoneNumber uib-typeahead="cust.phoneNumber for cust in $ctrl.getCustomers(null, $viewValue)" typeahead-loading=$ctrl.loadingCustomers typeahead-show-hint-on-focus=all typeahead-min-length=0 typeahead-template-url=customer-typeahead.tpl.html typeahead-on-select=$ctrl.customerSelected($item) placeholder="{{\'Phone number\'|translate}}" tabindex=6 autocomplete=off></div></div><div class=form-group ng-class="{\'has-error\': $ctrl.form.street2.$invalid && $ctrl.form.$submitted }"><label><span translate>Address</span></label><textarea name=street2 type=text class=form-control data-ng-model=$ctrl.order.deliveryAddress.street rows=2 placeholder="{{\'Street\'|translate}}" tabindex=7 autocomplete=off required>\n                            </textarea></div><div class=row><div class="form-group col-md-4 pr-0" ng-class="{\'has-error\': $ctrl.form.zipcode2.$invalid && $ctrl.form.$submitted }"><input name=zipcode2 type=text class=form-control data-ng-model=$ctrl.order.deliveryAddress.zipcode placeholder="{{\'Zip code\'|translate}}" tabindex=8 autocomplete=off required></div><div class="form-group col-md-8" ng-class="{\'has-error\': $ctrl.form.city2.$invalid && $ctrl.form.$submitted }"><input name=city2 type=text class=form-control data-ng-model=$ctrl.order.deliveryAddress.city placeholder="{{\'City\'|translate}}" tabindex=9 autocomplete=off required></div></div></div></div></div><div class="mt-2 mb-2 separator-2"></div><div class="mt-5 mb-5"><div id=checkout-message class=row><div class=col-6><h6><i class="fa fa-comment"></i> <span translate>Message for</span> {{$ctrl.cart.supplier.name}}</h6><textarea name=notes ng-model=$ctrl.order.userNotes id=orderNotes class=form-control cols=200 rows=2 tabindex=10> </textarea></div><div class=col-6 ng-if=$ctrl.user><h6><i class="fa fa-comment"></i> <span translate>Message for</span> {{$ctrl.user.name.first}} {{$ctrl.user.name.last}}</h6><textarea name=notes ng-model=$ctrl.order.messageForCustomer id=orderNotes class=form-control cols=200 rows=2 tabindex=11> </textarea></div></div></div><div class=row><div class=col-md-8><input type=checkbox id=hasAgreedTerms ng-model=$ctrl.hasAgreedTerms class=switch-input ng-class="{\'text-danger\': !$ctrl.hasAgreedTerms }"><label for=hasAgreedTerms class=switch-label ng-class="{\'text-danger\': !$ctrl.hasAgreedTerms }"><span translate>I understand this is a legally binding transaction.</span></label></div><div class="col-md-4 text-right"><div><span ng-if="$ctrl.cart.items.length === 1">1 <span translate>item</span><br></span><span ng-if="$ctrl.cart.items.length > 1">{{$ctrl.cart.items.length}} <span translate>items</span></span></div><div class=font-weight-bold><span translate>Total</span>: {{$ctrl.utils.getLocalizedCurrency($ctrl.cart.totalPrice)}}</div></div></div><div class=separator></div><div class=row><div class=col-6><button id=cancelButton type=button ng-click=$ctrl.cancel() class="btn btn-dark col-8" analytics-on=click analytics-event="Cancel operation"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button id=okButton type=button ng-click=$ctrl.ok() class="btn btn-success col-12" data-dismiss=modal analytics-on=click analytics-event="Confirm operation"><i class="fa fa-check"></i> <span translate>Confirm and Place order</span></button></div></div></form></div></div><script type=text/ng-template id=customer-typeahead.tpl.html><a class=" m-0 p-0">\n        <div><span ng-bind-html="match.model.fullName | uibTypeaheadHighlight:query"></span></div>\n        <div class="row small">\n            <div class="col push-1">\n                <div><span ng-bind-html="match.model.phoneNumber | uibTypeaheadHighlight:query"></span></div>\n                <div ng-if="match.model.supplierCustomers[0].collectionPointName">{{match.model.supplierCustomers[0].collectionPointName.replace(\'Lagerhaus\', \'LH\')}}</div>\n            </div>\n        </div>\n    </a></script>');
$templateCache.put('app/modules/shopping-cart/list/shopping-cart-edit-item.tpl.html','<div class=pb-3><div ng-if=vm.isVariantSelelectionNeeded><div><span translate>Please select a variant</span></div><table class="table m-0 p-0"><thead><tr><th class="pl-1 pr-0" translate>Product</th><th class="pl-1 pr-1 text-right"><span translate>Price</span></th></tr></thead><tbody><tr class=row-clickable ng-click=selectVariant()><td class="pl-2 pr-0">{{item.deal.productName || item.deal.product.name}}<div class=small ng-if=item.deal.vendorProductId>{{item.deal.vendorProductId}}</div></td><td class="pl-1 pr-1 text-right">{{utils.getLocalizedCurrency(item.deal.benchmarkPrice, item.deal.priceDecimalDigits)}}<div class=small>/ {{item.deal.customUnit}}</div></td></tr><tr class=row-clickable ng-repeat="variant in item.deal.variants" ng-click=selectVariant(variant)><td class="pl-1 pr-0">{{variant.productName}}<div class=small ng-if=variant.vendorProductId>{{variant.vendorProductId}}</div></td><td class="pr-2 text-right">{{utils.getLocalizedCurrency(variant.benchmarkPrice, item.deal.priceDecimalDigits)}}<div class=small>/ {{item.deal.customUnit}}</div></td></tr></tbody></table></div><div ng-if=!vm.isVariantSelelectionNeeded><div class="row mt-3"><div class="col-12 font-weight-bold"><span ng-if=!vm.selectedVariant>{{item.deal.productName || item.deal.product.name}}</span> <span ng-if=vm.selectedVariant>{{vm.selectedVariant.productName}}</span></div><div class=col-6><div class=small><span ng-if=!vm.selectedVariant>{{item.deal.vendorProductId}}</span> <span ng-if=vm.selectedVariant>{{vm.selectedVariant.vendorProductId}}</span></div><div class=small>{{item.deal.customType}}</div></div><div class="col-6 small pl-0"><div ng-repeat="attr in item.deal.productAttributes">{{attr.label}}:&nbsp;<b>{{attr.value}}</b></div></div></div><div ng-if=item.deal.benchmarkPrice><span translate>Unit price</span>: <span ng-if=!vm.selectedVariant class=font-weight-bold>{{utils.getLocalizedCurrency(item.deal.benchmarkPrice)}}</span> <span ng-if=vm.selectedVariant class=font-weight-bold>{{utils.getLocalizedCurrency(vm.selectedVariant.benchmarkPrice)}}</span> / <small>{{item.deal.customUnit}}</small></div><div class="mt-3 mb-2"><span translate>Quantity</span> ({{item.deal.customUnit}})</div><div><deal-quantity-selector deal=item.deal selected-quantity=vm.selectedQUantity></deal-quantity-selector></div><div class="small font-italic text-center" ng-if=item.deal.dealSizeOption><span ng-if="item.deal.dealSizeOptions.step !== 1" class=pr-2><span translate>Step</span>: {{item.deal.dealSizeOptions.step}}; </span><span ng-if="maxAmountReserved < 99999" class=pr-2><span translate>Max</span>: {{maxAmountReserved}};</span></div><div class=mt-3 ng-if="!item.isNew && vm.selectedQUantity"><button class="btn btn-outline-danger btn-sm mb-0 col-12" ng-click=setQuantityToZero()><i class="fa fa-times-circle"></i>&nbsp; <span translate>Remove from cart</span></button></div><div ng-if="!item.isNew && vm.selectedQUantity <= 0" class="alert alert-danger text-center"><span translate>Click "Confirm" to remove from cart</span></div></div></div>');
$templateCache.put('app/modules/shopping-cart/list/shopping-cart-list.tpl.html','<div ng-if=!$ctrl.list.length class=small><span translate>Shopping cart empty</span></div><div ng-if=$ctrl.list.length class="shopping-cart-container small"><div ng-repeat="cart in $ctrl.list" ng-class="{\'mb-5\': !$last}"><div class="mb-2 font-weight-bold"><i class="fa fa-shopping-cart"></i> {{cart.supplier.name}}</div><table class="table shopping-cart-table mb-2" cellspacing=0 cellpadding=0><tbody><tr ng-repeat="item in cart.items" class=row-clickable ng-click="$ctrl.editItem(cart, item, $parent.$index, $index)"><td width=70%>{{item.deal.productName || item.deal.product.name}} <i ng-if=item.isLastAdded class="fa fa-circle text-info"></i><div class=small><!-- <span ng-repeat="attr in item.deal.productAttributes">{{attr.value}}; </span> --> {{item.deal.customType}}</div></td><td class=text-right><div ng-if=item.deal.benchmarkPrice>{{$ctrl.utils.getLocalizedCurrency(item.deal.benchmarkPrice)}}</div><div>{{item.quantity}} <span class=small>{{item.deal.customUnit}}</span></div></td></tr><!-- forEach item --></tbody><tfoot><tr class=font-weight-bold><td><span translate>Total</span></td><td class=text-right>{{$ctrl.utils.getLocalizedCurrency(cart.totalPrice)}}</td></tr></tfoot></table><div class=text-right><div class=row><div class=col-5><button type=button class="btn btn-sm btn-secondary mt-0 mb-0 col-12" ng-click="$ctrl.clearCart(cart, $index)"><span translate>Clear</span></button></div><div class="col-7 pl-0"><button type=button class="btn btn-sm btn-outline-success mt-0 mb-0 col-12" ng-click="$ctrl.checkout(cart, $index)"><span translate>Checkout</span></button></div></div></div></div><!-- forEach cart --></div>');
$templateCache.put('app/shared/templates/modals/collection-points.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-home"></i> <span ng-if=!isCategoryCrop translate>Collection Points</span> <span ng-if=isCategoryCrop translate>Delivery locations</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button></div><div class=modal-body><div ng-if=collectionPoints.length class=text-right><button class="btn btn-md btn-outline-success btn-sm" ng-click=toggleActivationForAll(true)><i class="fa fa-check"></i> <span translate>Include all</span></button> <button class="btn btn-md btn-secondary btn-sm" ng-click=toggleActivationForAll(false)><i class="fa fa-times"></i> <span translate>Exclude all</span></button></div><div class=row><div class=col-12 style="max-height: 40vh" ng-scrollbars><div class="ml-10 pl-3 pr-3"><ul class="list-group-table row"><li class="list-table-item-header row"><div class=col-md-4><strong translate>Name</strong></div><div class=col-md-7><strong translate>Address</strong></div><div class=col-md-1></div></li><li class="list-table-item row row-highlighted-hover row-clickable" ng-repeat="col in collectionPoints" ng-click=toggleActivation(col) ng-class="{\'text-disabled\': !col.active }"><div class=col-md-4>{{col.name}}</div><div class="col-md-7 pl-0">{{col.address}}</div><div class="col-md-1 pl-0" ng-if=!isTargetNewUsers><a ng-if=col.active><i class="fa fa-toggle-on fa-2x text-success"></i> </a><a ng-if=!col.active><i class="fa fa-toggle-off fa-2x text-muted"></i></a></div></li></ul></div><div class=mt-10><div><a class="btn btn-md btn-info" ng-click="vm.showHowToAddCollectionPoints = true"><span translate>Add new</span></a><div class=text-right ng-if=vm.showHowToAddCollectionPoints><img name="Profile EN" style="width: 400px; float: right" ng-src="{{\'https://fh-data-1.s3.eu-west-1.amazonaws.com/1533808623752Screen%20Shot%202018-08-09%20at%2010.56.33.png\' | translate}}"></div></div></div></div><div class=separator></div></div><div class=row><div class=col-6><button type=button ng-click=cancel() class="btn btn-dark col-8"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button type=button ng-click=ok() class="btn btn-success col-8" data-dismiss=modal><i class="fa fa-check"></i> <span translate>Ok</span></button></div></div></div>');
$templateCache.put('app/shared/templates/modals/confirmation.tpl.html','<div class=modal-header><h5 class=modal-title id=myModalLabel><i class="fa fa-question-circle"></i> <span translate>Confirm Action</span></h5></div><div class=modal-body><p>{{vm.question}}</p><div class=separator-2></div><div class=row><div class=col-6><button id=cancelButton type=button ng-click=cancel() class="btn btn-dark col-8" analytics-on=click analytics-event="Cancel operation"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button id=okButton type=button ng-click=ok() class="btn btn-success col-8" data-dismiss=modal analytics-on=click analytics-event="Confirm operation"><i class="fa fa-check"></i> <span translate>Ok</span></button></div></div></div>');
$templateCache.put('app/shared/templates/modals/crop-config.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-leaf"></i> <span translate>Crop Standards Configuration</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button></div><div class=modal-body><div class=row><div class=col-md-12><h4>{{Selected.label}}</h4><small translate>Please complete the following ({{Fields.length}}) fields</small></div></div><form name=form.cropStandard class="form row" novalidate autocomplete=off><div class="form-group col-md-6 col-lg-4" ng-repeat="f in Fields" ng-class="{\'has-error\': form.cropStandard.$submitted && form.cropStandard[f.label].$invalid }"><label for=tb_{{$index}}>{{f.label}}</label><div class=input-group><span ng-if=f.limit class=input-group-addon>{{f.limit}}</span> <input ng-if="f.type === \'text\'" type=text name={{f.label}} ng-change=vm.computeDisc() ng-model=f.value class=form-control id=tb_{{$index}} aria-describedby=emailHelp ng-required=f.required> <input ng-if="f.type !== \'text\'" type=number name={{f.label}} ng-change=vm.computeDisc() ng-model=f.value class=form-control id=tb_{{$index}} aria-describedby=emailHelp min=0 ng-pattern=/^[0-9]+(\\.[0-9]{1,2})?$/ step=0.01 ng-required=f.required> <span ng-if=f.unit class=input-group-addon>{{f.unit}}</span></div><div class=text-danger ng-messages=form.cropStandard[f.label].$error ng-if="form.cropStandard.$submitted && form.cropStandard[f.label].$invalid"><small class=form-control-feedback ng-message=required translate>* {{f.label}} is required</small> <small class=form-control-feedback ng-message=min translate>* {{f.label}} value is not valid</small></div></div><div class=separator-2></div><div class="col-12 row"><div class=col-6><button id=cancelButton type=button ng-click=cancel() class="btn btn-dark col-8"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button id=okButton type=button ng-click=ok() class="btn btn-success col-8" data-dismiss=modal><i class="fa fa-check"></i> <span translate>Ok</span></button></div></div></form></div>');
$templateCache.put('app/shared/templates/modals/deal-confirm.tpl.html','<div class=modal-header><h5 class=modal-title id=myModalLabel><i class="fa fa-question-circle"></i> <span translate>Review and publish</span></h5></div><div class=modal-body><div class=row><div class="col-lg-3 hidden-md-down pl-10 pr-0"><div><span translate>Offer image</span><i class="fa fa-arrow-alt-circle-down"></i></div><img ng-src="{{vm.model.imageUrl ? vm.model.imageUrl : vm.model.supplier.imageUrl}}" alt=""><div><div class=mb-10><span translate>Contact</span>:</div><div><div><small><i class="fa fa-envelope"></i> {{vm.model.createdBy.email}}</small></div><div><small><i class="fa fa-phone"></i> {{vm.model.createdBy.phoneNumber}}</small></div></div><div class="separator-2 mt-10"></div><div class=mb-10 ng-if=vm.model.attachments.length><div><span translate>Attachments</span> ({{vm.model.attachments.length}})</div><div ng-repeat="attachment in vm.model.attachments"><a class=small href={{attachment.url}} target=_blank><i class="fa fa-paperclip"></i> {{attachment.name}}</a></div><div class="separator-2 mt-10"></div></div><div class=mb-10 ng-if=!vm.model.attachments.length><span class=text-warning translate>No attachments</span></div><div class=mb-10 ng-if=vm.model.description><div><span translate>Description</span></div><div ng-bind-html=vm.model.description style="font-size: 10px; max-height: 200px; overflow: scroll"></div></div><div class=mb-10 ng-if=!vm.model.description><span class=text-warning translate>No description</span></div></div></div><div class="col-lg-9 col-12 pr-10 pl-10"><div class="col-sm-12 row mb-10"><div class=col-12><div ng-if=!vm.service.isCategoryCrop(vm.model)><img class=pr-10 style=float:left src=app/shared/images/deal_icon.png width=30> <span translate>New offer</span>: <strong>{{vm.model.product.name}}</strong></div><div ng-if=vm.service.isCategoryCrop(vm.model)><img class=pr-10 style=float:left src=app/shared/images/crop_icon.png width=30> <span translate>Crop procurement</span>: <strong>{{vm.model.product.name}}</strong></div></div><div class=col-12>{{vm.model.customType}}</div></div><div class="col-sm-12 row" ng-if=!vm.service.isCategoryCrop(vm.model)><div class=col-4><span translate>Items Available</span>:</div><div class=col-8>{{vm.model.dealSize}} <span ng-if="vm.model.dealSizeOptions.min > 1 || vm.model.dealSizeOptions.step > 1"><small translate>(Only multiples of {{vm.model.dealSizeOptions.step}} can be booked)</small></span></div></div><div class="col-sm-12 row" ng-if=vm.service.isCategoryCrop(vm.model)><div class=col-4><span translate>Quantity Limit</span>:</div><div class=col-8 ng-if="vm.model.dealSize < 999999">{{vm.model.dealSize}} <span ng-if="vm.model.dealSizeOptions.min > 1 || vm.model.dealSizeOptions.step > 1"><small translate>(Only multiples of {{vm.model.dealSizeOptions.step}} can be booked)</small></span></div><div class=col-8 ng-if="vm.model.dealSize >= 999999">&infin; <span ng-if="vm.model.dealSizeOptions.min > 1 || vm.model.dealSizeOptions.step > 1"><small translate>(Only multiples of {{vm.model.dealSizeOptions.step}} can be booked)</small></span></div></div><div class="col-sm-12 row"><div class=col-4><span translate>Price</span>:</div><div class=col-8><div ng-if=!vm.utils.isNumber(vm.model.benchmarkPrice)>{{vm.model.benchmarkPrice}} <small>/ {{vm.model.customUnit}}</small></div><div ng-if=vm.utils.isNumber(vm.model.benchmarkPrice)><div><small ng-if="vm.model.individualDiscount > 0.5 && !vm.service.isCategoryCrop(vm.model)"><del>{{vm.utils.getLocalizedCurrency(vm.model.benchmarkPrice)}}</del></small> {{vm.utils.getLocalizedCurrency(vm.model.benchmarkPrice-vm.model.benchmarkPrice*vm.model.individualDiscount/100)}} <span ng-if="vm.model.individualDiscount < vm.model.clearanceDiscount - 0.5">~ {{vm.utils.getLocalizedCurrency(vm.model.benchmarkPrice-vm.model.benchmarkPrice*vm.model.clearanceDiscount/100)}} </span><small>/ {{vm.model.customUnit}}</small></div><div class=text-muted><small ng-if=vm.model.isVatIncluded translate>Incl. VAT</small> <small ng-if=!vm.model.isVatIncluded translate>Excl. VAT</small></div></div></div></div><div class="col-sm-12 row" ng-if=vm.service.isCategoryCrop(vm.model)><div class=col-4><span translate>Crop quality</span>:</div><div class=col-8><small>{{vm.model.cropQuality}}</small></div></div><div class="col-sm-12 row" ng-if="!vm.service.isCategoryCrop(vm.model) && !vm.service.isGroupDiscountEnabled(vm.model)"><div class=col-4><span translate>Base discount</span>:</div><div class=col-8 ng-if=vm.model.individualDiscount>{{vm.model.individualDiscount|number:0}}% -- <small translate>Always applied and independent on the quantity sold.</small></div><div class=col-8 ng-if=!vm.model.individualDiscount>--</div></div><div class="col-sm-12 row" ng-if=vm.service.isQuantityDiscountEnabled(vm.model)><div class=col-4><span translate>Custom discount</span>:</div><div class="col-8 mb-10"><div class=row><div class=col-3><strong translate>Quantity</strong></div><div class=col-3><strong translate>Discount</strong></div><div class=col-3><strong translate>Price</strong></div></div><div class=row ng-repeat="qd in vm.model.quantityDiscounts"><div class=col-3>{{qd.quantity}}+</div><div class=col-3>{{qd.discount|number:0}}%</div><div class=col-3>{{vm.utils.getLocalizedCurrency(vm.model.benchmarkPrice-vm.model.benchmarkPrice*qd.discount/100)}}</div></div></div></div><div class=col-md-12><div class="alert alert-icon alert-info mt-0" ng-click=vm.editDiscount() ng-if=vm.service.isGroupDiscountEnabled(vm.model)><i class="fa fa-users"></i> <strong translate>Group discount</strong>:<div>{{gdAmount=vm.model.groupDiscount.quantityThreshold;gdDiscount=vm.model.groupDiscount.value;gdDate=vm.utils.getLocalizedDate(vm.model.bookingEnd);\'\'}}<!-- Weird behaviour if more than "{{}}" are in the same translated block --> <span translate>All farmers will receive {{gdDiscount | number:0}}% discount</span> <span translate>if {{gdAmount}} units are sold</span> <span translate>by {{gdDate}} (end of the deal).</span><br><small translate>If less units are sold, orders will be cancelled and famers will be notified.</small></div></div></div><div class="separator-2 mt-10"></div><div class="col-sm-12 row"><div class=col-4><span translate>Customers</span>:</div><span class=col-8><a class="btn btn-sm btn-info m-0 text-white" ng-click=viewUsers()>{{vm.model.users.length}} <span ng-if="vm.model.target === vm.DEAL_TARGET.NEW_USERS">+</span> <span translate>affected</span></a></span></div><div class="col-sm-12 row"><div class="col-4 pr-0"><small translate>Include new customers</small>:</div><span class=col-8><strong ng-if="vm.model.target === vm.DEAL_TARGET.NEW_USERS" translate>Yes</strong> <strong ng-if="vm.model.target !== vm.DEAL_TARGET.NEW_USERS" translate>No</strong></span></div><div class="col-sm-12 row"><div class=col-4><span translate>Farm types</span>:</div><span class=col-8 ng-if=vm.model.farmTypes.length><div class="chip pb-0" ng-repeat="chip in vm.model.farmTypes">{{vm.farmTypesMap[chip]}}</div></span><span class=col-8 ng-if=!vm.model.farmTypes.length><span translate>Any</span></span></div><div class="col-sm-12 row"><div class=col-4><span translate>Farm system</span>:</div><span class=col-8 ng-if=vm.model.system>{{vm.systemsMap[vm.model.system]}} </span><span class=col-8 ng-if=!vm.model.system><span translate>Any</span></span></div><div class="col-sm-12 row mt-10" ng-if=vm.utils.getSettings().isReservationEnabled><div class=col-4><label class=mt-2><span translate>Reservation time</span> <i class="fa fa-question-circle"></i></label></div><div class=col-8><label class=mt-2><span ng-if=!vm.model.allowModifyOrderHours><span class=text-warning translate>No reservations</span> </span><span ng-if=vm.model.allowModifyOrderHours>{{vm.model.allowModifyOrderHours}} <span translate>hours</span> ({{vm.model.allowModifyOrderHours/24 | number:1}} <span translate>days</span>)</span></label></div></div><div class="separator-2 mt-10"></div><div class="col-sm-12 row text-info" ng-if=vm.service.isActive(vm.model)><div class=col-4><span translate>Offer start</span>:</div><span class="col-4 font-weight-bold"><i class="fa fa-play-circle"></i> <strong translate>Live</strong></span></div><div class="col-sm-12 row" ng-if=!vm.service.isActive(vm.model)><div class=col-4><!-- <i class="fa fa-play-circle"></i> --> <span translate>Offer start</span>:</div><span class=col-8><strong ng-if=moment().isBefore(vm.model.bookingStart)>{{vm.utils.getLocalizedDateAndTime(vm.model.bookingStart)}}</strong><div><countdown caption="\'Starts in:\'|translate" date-time=vm.model.bookingStart hide-seconds=true alt-text="\'Starts now\'|translate"></countdown></div></span></div><div class="separator-2 mt-10"></div><div class="col-sm-12 row"><div class=col-4><!-- <i class="fa fa-stop-circle"></i> --> <span translate>Offer end</span>:</div><span class=col-8><span class=font-weight-bold>{{vm.utils.getLocalizedDateAndTime(vm.model.bookingEnd)}}</span><div><countdown caption="\'Ends in:\'|translate" date-time=vm.model.bookingEnd hide-seconds=true></countdown></div></span></div><div class="separator-2 mt-10"></div><div class="col-sm-12 row"><div class=col-4><span ng-if="vm.model.distribution === \'delivery\'"><i class="text-info fa fa-truck"></i> <span translate>Delivery</span></span> <span ng-if="vm.model.distribution === \'collection\'"><i class="text-info fa fa-home"></i> <span translate>Collection</span></span> <span translate>from</span>:</div><div class=col-8><span>{{vm.utils.getLocalizedDate(vm.model.deliveryStart)}}</span></div></div><div class="col-sm-12 row"><div class=col-4><span ng-if="vm.model.distribution === \'delivery\'"><i class="text-info fa fa-truck"></i> <span translate>Delivery</span></span> <span ng-if="vm.model.distribution === \'collection\'"><i class="text-info fa fa-home"></i> <span translate>Collection</span></span> <span translate>until</span>:</div><div class=col-8><span>{{vm.utils.getLocalizedDate(vm.model.deliveryEnd)}}</span></div></div><div class=separator></div></div></div><div class=row><div class=col-6><button type=button ng-click=cancel() class="btn btn-dark col-lg-8 col-12" analytics-on=click analytics-event="Cancel publish" analytics-value={{vm.model._id}}><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><!-- TODO: use paid-feature directive instead of isFeatureEnabled --><div class="col-6 text-right"><button ng-if="!vm.service.isBookingStartInTheFuture(vm.model) && !vm.service.isActive(vm.model) && !vm.service.isScheduled(vm.model)" type=button ng-click=ok() class="btn btn-success col-lg-8 col-12" data-dismiss=modal analytics-on=click analytics-event="Confirm publish" analytics-value={{vm.model._id}} paid-feature=PRO><i class="fa fa-check"></i> <span translate>Publish</span></button> <button ng-if="vm.service.isBookingStartInTheFuture(vm.model)  && !vm.service.isActive(vm.model) && !vm.service.isScheduled(vm.model)" type=button ng-click=ok() class="btn btn-success col-lg-8 col-12" data-dismiss=modal analytics-on=click analytics-event="Confirm schedule" analytics-value={{vm.model._id}} paid-feature=PRO><i class="fa fa-check"></i> <span translate>Publish on</span> {{vm.utils.getLocalizedDate(vm.model.bookingStart)}}</button> <button ng-if="vm.service.isActive(vm.model) || vm.service.isScheduled(vm.model)" type=button ng-click=ok() class="btn btn-success col-lg-8 col-12" data-dismiss=modal analytics-on=click analytics-event="Confirm update" analytics-value={{vm.model._id}} paid-feature=PRO><i class="fa fa-check"></i> <span translate>Update</span></button></div></div></div>');
$templateCache.put('app/shared/templates/modals/deal-image.tpl.html','<!-- ***************  TODO: DEPRECATED - REMOVE ***************  --><div class=modal-header><h4 class=modal-title><i class="fa fa-file-image-o"></i> <span translate>Set/Update offer image</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class=modal-body><div class=col-md-12><ul class="nav nav-pills" role=tablist><li class=nav-item><a class="nav-link active" href=#img-exist role=tab data-toggle=tab title=images><i class="fa fa-file-image-o pr-1"></i> <span translate>Existing</span></a></li><li class=nav-item><a class=nav-link href=#upload role=tab data-toggle=tab title=video><i class="fa fa-cloud-upload pr-1"></i> <span translate>Upload</span></a></li></ul><!-- Tab panes --><div class="tab-content clear-style"><div class="tab-pane active" id=img-exist style="max-height: 400px" ng-scrollbars><div class=row><div class=col-sm-3 ng-repeat="img in urlList"><div class="image-box shadow text-center mb-20"><div class="overlay-container overlay-visible"><img ng-src={{img.url}} ng-error-src=app/shared/images/fallback_image.png style="max-height: 90px; margin: 0 auto" alt=""> <a ng-click=selectImage(img) class=overlay-link><i class="fa fa-file-image-o"></i></a></div></div></div></div></div><div class=tab-pane id=upload><form role=form name=Form.imgForm ng-show=!uploading><div class="form-group col-md-12" ng-if=!filepreview ng-class="{\'has-error\': Form.imgForm.$submitted && !validateFile() }"><input type=file id=inputFile name=inputFile class=file_uploader placeholder="{{\'Click to choose an image\'|translate}}" ngf-select="onFileSelect($files, $event)" ng-model=selectedFile ngf-model-options="{updateOn: \'change drop dropUrl paste\', allowInvalid: false, debounce: 0}" ngf-drag-over-class="\'dragover\'" ngf-enable-firefox-paste=true ngf-multiple=false ngf-pattern="\'image/*\'" ngf-accept="\'.png,.gif,.jpg,.jpeg\'" ngf-resize="{width:1024, height:1024}"></div><div class=text-danger ng-if="Form.imgForm.$submitted && !formValid"><small class=form-control-feedback ng-if=validateFile().NoFile translate>* Field is required</small> <small class=form-control-feedback ng-if=!validateFile().Size translate>* file size cannot exceed 4.0 MB</small> <small class=form-control-feedback ng-if=!validateFile().Type translate>* selected file must be an image file</small></div></form></div><div ng-if=filepreview class=col-md-12 id=imgPreview><a ng-click=resetFile() class="text-danger btn-lg-link pull-right"><i class="fa fa-2x fa-times-circle-o"></i></a> <img ng-src={{filepreview}} class=img-responsive></div><div class=col-12><div class=separator-2></div><div class=row><div class=col-6><button type=button ng-click=cancel() class="btn btn-dark col-8"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button type=button ng-click=ok() class="btn btn-success col-8"><i class="fa fa-cloud-upload"></i> <span translate>Upload</span></button></div></div></div><div class=col-md-12 ng-if=uploading><p class="text-sm-center text-info margin--bottom-clear"><i class="fa fa-info-circle"></i> <span translate>This window will auto-close once the image upload completes.</span></p><p class="text-sm-center text-warning margin-top-clear"><span translate>Please donot press <i class="fa fa-arrow-circle-o-left"></i> back or <i class="fa fa-refresh"></i> refresh while image is uploading.</span></p><div class="col-md-8 offset-2 padding-ver-clear"><img src=./app/shared/images/uploading.gif width=120 style="margin: 0 auto" alt=""></div><div class="progress style-1 col-md-8 offset-2"><span class=text></span><div class="progress-bar progress-bar-default" data-animate-width=90%><span class="label object-non-visible" data-animation-effect=fadeInLeftSmall data-effect-delay=1000>{{uploadProgress}}</span></div></div></div></div></div></div>');
$templateCache.put('app/shared/templates/modals/deal-users.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-users"></i> <span translate>View / Select farmers</span> <small>({{selectedCount}} / {{users.length}})</small></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button></div><div class=modal-body><div class="row mr-3 mb-2"><div class="col-md-7 col-lg-7 text-left"><input type=checkbox id=isTargetNewUsers ng-model=isTargetNewUsers class=switch-input ng-change=toggleIncludeNewUsers() ng-disabled=readOnly><label for=isTargetNewUsers class=switch-label><i class="fa fa-user"></i> <span translate>Include new customers</span></label></div><div class="col-md-5 col-lg-5"><div class="form-group has-feedback input-search-sm"><input ng-model=userFilter class="form-control form-control-sm" placeholder="{{\'Search\'|translate}}" ng-model-options="{ debounce: 500 }" ng-change=onPage()> <i class="fa fa-search form-control-feedback"></i></div></div></div><div class="text-right mb-20" ng-if=!isTargetNewUsers><div class=row><div class="col-7 text-right" ng-if="utils.isFeatureEnabled(\'DEAL_USERS_GROUP_VIEW\') && !isSaveGroupVisible"><span translate>Group</span><select ng-model=vm.selectedGroup ng-change=loadUserGroup()><option ng-repeat="group in groupList" ng-value=group ng-disabled=readOnly><span>{{group.name}}</span></option><option value="">--</option></select></div><!-- TODO Waiting for translations --><!-- <div class="col-4" ng-if="utils.isFeatureEnabled(\'DEAL_USERS_GROUP_EDIT\') && isGroupModified">\n                <button class="btn btn-sm btn-success" ng-click="updateUserGroup()" ng-if="vm.selectedGroup"><span translate>Update group</span></button>\n                <button class="btn btn-sm btn-secondary" ng-click="promptSaveUserGroup()"><span translate>Create new</span></button>\n            </div>\n\n            <div class="col-12" ng-if="utils.isFeatureEnabled(\'DEAL_USERS_GROUP_EDIT\') && isSaveGroupVisible">\n                <input type="text" ng-model="vm.newGroupName" placeholder="{{\'Group name\'|translate}}">\n                <button class="btn btn-sm btn-dark" ng-click="cancelSaveGroup()"><span translate>Cancel</span></button>\n                <button class="btn btn-sm btn-success" ng-click="saveUserGroup()" ng-disabled="!vm.newGroupName"><span translate>Create</span></button>\n            </div> --><div class="col-md-5 text-right" ng-if="!readOnly && !isTargetNewUsers"><button class="btn btn-sm btn-dark" ng-click=setAllUsersExclusionState(true)><i class="fa fa-times"></i> <span translate>Exclude all</span></button> <button class="btn btn-sm btn-success" ng-click=setAllUsersExclusionState(false)><i class="fa fa-check"></i> <span translate>Include all</span></button></div></div></div><div class="ml-10 pl-20 pr-20"><ul class="list-group-table row" style="width: 99%"><li class="list-table-item-header row"><div class="col-3 row-clickable"><div ng-click="sortUsers(\'name.last\')"><i class="fa {{getSortClass(\'name.last\')}}"></i> <span translate>Name</span></div><div ng-click="sortUsers(\'customerId\')"><i class="fa {{getSortClass(\'customerId\')}}"></i> <small translate>Customer Id</small></div></div><div class="col-2 row-clickable" ng-click="sortUsers(\'lastDealsAck\', -1)"><i class="fa {{getSortClass(\'lastDealsAck\')}}"></i> <span translate>Active</span></div><div class=col-3><span translate>Groups</span></div><div class="col-3 row-clickable" ng-click="sortUsers(\'address.zipcode\')"><i class="fa {{getSortClass(\'address.zipcode\')}}"></i> <span translate>Zip code</span> &amp; <span translate>Shop</span></div><div class="col-1 row-clickable" ng-click=toggleViewSelectedOnly(); ng-class="{\'text-primary\': viewSelectedOnly}"><i ng-if=viewSelectedOnly class="fa fa-filter"></i> <span ng-if=!isTargetNewUsers translate>Included</span></div></li></ul></div><div class="ml-10 pl-20" style="min-height: 50vh"><ul class="list-group-table row" style="width: 99%"><li class="list-table-item row row-highlighted-hover" ng-repeat="u in currentPageUsers" ng-click="!readOnly && !isTargetNewUsers ? toggleUser(u) : \'\'" ng-class="{\'text-disabled\': u.isExcluded && !isTargetNewUsers, \'row-clickable\': !isTargetNewUsers}"><div class=col-3 style="min-height: 45px"><spam paid-feature>{{u.name.first + \' \' + u.name.last}}</spam><div ng-if="u.supplierCustomers[0].customerId || u.customerId"><small>{{customerIdLabel}}</small>: {{u.supplierCustomers[0].customerId || c.customerId}}</div><div ng-if=u.request class="alert alert-info p-2 m-0 small"><span translate>Requested</span>: <i>{{u.request.content.slice(1).join(\' - \')}}</i></div><div ng-if=u.supplierCustomers[0].isVerified ng-class="{\'text-success\': !u.isExcluded}"><i class="fa fa-check"></i> <span translate>Verified</span></div></div><div class="col-2 small"><i ng-if=u.isActiveToday ng-class="{\'text-crop-offer\': !u.isExcluded}" translate>Today</i> <i ng-if=u.isActiveWeekly ng-class="{\'text-warning\': !u.isExcluded}" translate>Last 7 days</i> <i ng-if=u.isActiveMonthly ng-class="{\'text-muted\': !u.isExcluded}" translate>Last 30 days</i> <i ng-if="readOnly && u.isActiveAfterBookingStart" class="fa fa-check-square" ng-class="{\'text-success\': !u.isExcluded}"></i></div><div class=col-3><!-- <small>{{u.farmTypesStr}}</small>\n                    <div class="small">{{u.system ? systemsMap[u.system] : \'---\'}}</div> --> <span ng-repeat="g in u.groups" class="chip text-white pt-0 pb-0 small mb-0" ng-style="{\'background-color\': u.isExcluded ? \'#CCC\' : g.color}">{{g.name.charAt(0).toUpperCase() + g.name.substr(1)}}</span></div><div class="col-3 pl-0 pr-0"><i ng-if=!u.address class="fa fa-warning text-warning"></i> <span ng-if=u.address>{{u.address.zipcode}}<div ng-if=u.supplierCustomers[0].collectionPointName><i>{{u.supplierCustomers[0].collectionPointName.replace(\'Lagerhaus\', \'LH\')}}</i></div></span></div><div class=col-1 ng-if=!isTargetNewUsers><a ng-if="!u.isExcluded || isTargetNewUsers"><i class="fa fa-toggle-on fa-2x text-success"></i> </a><a ng-if="u.isExcluded && !isTargetNewUsers"><i class="fa fa-toggle-off fa-2x text-muted"></i></a></div></li></ul></div><div><ul uib-pagination class=pagination-sm first-text="{{\'First\'|translate}}" previous-text="{{\'Prev\'|translate}}" next-text="{{\'Next\'|translate}}" last-text="{{\'Last\'|translate}}" ng-change=onPage() total-items=paging.totalItems ng-model=paging.current max-size=paging.maxSize items-per-page=paging.itemsPerPage boundary-link-numbers=true boundary-links=true></ul></div><div class=separator-2></div><div ng-if=readOnly><div class=col-6><button type=button ng-click=cancel() class="btn btn-dark col-8"><i class="fa fa-chevron-left"></i> <span translate>Back</span></button></div></div><div class=row ng-if=!readOnly><div class=col-6><button type=button ng-click=cancel() class="btn btn-dark col-8"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button type=button ng-click=ok() class="btn btn-success col-8" data-dismiss=modal><i class="fa fa-check"></i> <span translate>Ok</span></button></div></div></div>');
$templateCache.put('app/shared/templates/modals/error.tpl.html','<div class=modal-dialog role=document><div class=modal-content><div class=modal-body><p translate>An Error has occurred.</p></div><div class=modal-footer><button type=button class="btn btn-sm btn-default">Ok</button></div></div></div>');
$templateCache.put('app/shared/templates/modals/mobile-preview.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-mobile"></i> <span translate>Preview on mobile</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button></div><div class="modal-body text-center" style="max-height: 700px"><div class=row><div class=col-8><div class=row><div class="col-12 mt-20"><h2><i class="fa fa-download"></i></h2></div><div class=col-md-12><h4><span translate>Step 1: Get FarmHedge on your smartphone</span></h4></div><div class=col-md-12><a class="btn btn-primary" target=_blank href=http://farmhedge.io><i class="fa fa-download"></i> <span transalte>Download Farmhedge app</span></a><br><span translate>Or google "Farmhedge" on your mobile</span></div><div class="col-12 mt-20"><h2><i class="fa fa-unlock-alt"></i></h2></div><div class="col-md-12 mt-40"><h4><span translate>Step 2: Login on FarmHedge app</span></h4></div><div class=col-md-2></div><div class="col-md-10 mt-20 pt-50" style="text-align: left"><span translate>Use these credentials:</span><ul><li><span translate>Email:</span><br><h4>{{user.email}}</h4></li><li><span translate>Password:</span><br><h4>{{user.pwd}}</h4></li></ul></div><div class="col-12 mt-20"><h2><i class="fa fa-check"></i></h2></div><div class="col-md-12 mt-40 mb-20"><h4><span translate>That\'s it!</span></h4></div></div></div><div class="col-4 mt-20"><img src=app/shared/images/farmhedge_hand.png></div></div><div class=separator-2></div><div class=row><div class=col-12><button type=button ng-click=cancel() class="btn btn-dark col-8"><i class="fa fa-check"></i> <span translate>Continue</span></button></div></div></div>');
$templateCache.put('app/shared/templates/modals/notification.tpl.html','<div class=modal-dialog role=document><div class=modal-content><div class=modal-body><p translate>This is the notification text.</p></div><div class=modal-footer><button type=button class="btn btn-sm btn-default">Ok</button></div></div></div>');
$templateCache.put('app/shared/templates/modals/request-details.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-bullhorn"></i> <span ng-if=!request.isSentRequest translate>Customer request</span> <span ng-if=request.isSentRequest translate>Your request</span> <span class="p-1 small alert-warning" ng-if=utils.isUserRegionalManager()>{{request._id}}</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button></div><div class=modal-body><div class=row><div class="col-lg-8 col-md-12"><img style=float:left ng-if=!isCropRequest src=app/shared/images/deal_icon.png width=40 class=pr-10> <img style=float:left ng-if=isCropRequest src=app/shared/images/crop_icon.png width=40 class=pr-10><h4>{{request.content.slice(0, 2).join(\' - \')}}</h4></div><div class="col text-right"><i class="fa fa-calendar"></i> <span>{{utils.getLocalizedDateAndTime(request.createdAt)}}</span></div></div><div class="p-1 mt-3 mb-3 text-center"><div class=mb-2><status-badge status=request.status></status-badge></div><span ng-if="request.status === REQUEST_STATUS.RESPONDED" class=row-clickable ng-click=goToOffer()><div ng-if=request.latestDeal><span ng-if=!request.latestDeal.isExpired><b class=text-warning><i class="fa fa-tag"></i> <span translate>Offer</span> </b>| {{utils.getLocalizedCurrency(request.latestDeal.benchmarkPrice)}} |<countdown caption="\'Ends in:\'|translate" date-time=request.latestDeal.bookingEnd></countdown></span><span class="mt-10 p-0 text-danger" ng-if=request.latestDeal.isExpired><span translate>Offer epired</span></span></div></span><span ng-if="request.status === REQUEST_STATUS.FULFILLED" class=row-clickable ng-click=goToOrder()><div ng-if=request.orders.length><span translate>Order</span>: {{request.orders[0].ref}}</div></span><div ng-if=request.inShoppingCart class=text-primary><i class="fa fa-shopping-cart"></i> <span translate>In shopping cart</span></div></div><div class=row><div class="col-lg-6 col-md-12"><div class="card p-2 mt-3"><div class="text-center mb-3"><b translate>Details</b><div class="separator m-1 p-0"></div></div><div class=row><div class=col-3><img ng-if=request.product ng-src="{{request.product.imageUrls[0] || \'./app/shared/images/default-no-image.jpg\'}}" style="width: 100%"> <img ng-if=!request.product ng-src="{{request.imageUrl || \'./app/shared/images/default-no-image.jpg\'}}" style="width: 100%"></div><div class=col><h5>{{request.productName}}<div class=small>{{request.customType}}</div></h5><div ng-if=request.quantity><i class="fa fa-cubes"></i> {{request.quantity}} {{request.unit}}</div><div ng-if=request.distribution><i ng-if=request.isDistributionCollection class="fa fa-home"></i> <i ng-if=!request.isDistributionCollection class="fa fa-truck"></i> {{request.distribution}}</div><div ng-if=distributorDeal class=mt-3><div><span translate>Available from</span>: <b>{{distributorDeal.supplier.name}}</b></div><div ng-if=distributorDeal.vendorProductId><span translate>Product Id</span>: <b>{{distributorDeal.vendorProductId}}</b></div><span translate>Price</span>: <b>{{utils.getLocalizedCurrency(distributorDeal.benchmarkPrice)}}</b> / {{distributorDeal.customUnit}}</div><div ng-repeat="attribute in request.attributes"><div ng-if="attribute.type !== \'photo\'"><span class=small>{{attribute.label}}</span>: <span><b>{{attribute.value}}</b></span></div></div></div></div></div></div><!-- Product --><div class="col-lg-6 col-md-12"><div class="card p-2 mt-3" ng-if=!request.isSentRequest><div class="text-center mb-3"><b translate>Customer</b><div class="separator m-1 p-0"></div></div><div class=row><div class=col-3><div ng-if=!request.retailer><img ng-src="{{request.createdBy.imageUrl || \'./app/shared/images/default-no-image.jpg\'}}" style="width: 100%"></div><div ng-if=request.retailer><img ng-src="{{request.retailer.imageUrl || \'./app/shared/images/default-no-image.jpg\'}}" style="width: 100%"></div></div><div class=col><div ng-if=!request.retailer><h5>{{request.createdBy.name.first}} {{request.createdBy.name.last}}</h5><div><i class="fa fa-phone"></i> {{request.createdBy.phoneNumber}}</div><div class=mb-2><i class="fa fa-envelope"></i> <a class=text-muted target=_blank href="mailto:{{request.createdBy.email}}?subject={{mailSubject}}&body={{mailBody}}">{{request.createdBy.email}}</a></div><div ng-if=request.createdBy.customerId><i class="fa fa-user"></i> <span translate>Customer Id</span>: {{request.createdBy.customerId}}</div><div><i class="fa fa-map-marker"></i> <span translate>Zip code</span>: {{request.createdBy.address.zipcode}}</div></div><div ng-if=request.retailer><h5><div>{{request.retailer.name}}</div><small>{{request.createdBy.name.first}} {{request.createdBy.name.last}}</small></h5><div ng-if=request.createdBy.phoneNumber><i class="fa fa-phone"></i> {{request.createdBy.phoneNumber}}</div><div><i class="fa fa-envelope"></i> <a class=text-muted target=_blank href="mailto:{{request.createdBy.email}}?subject={{mailSubject}}&body={{mailBody}}">{{request.createdBy.email}}</a></div></div></div></div></div><div class="card p-2 mt-3" ng-if=request.isSentRequest><div class="text-center mb-3"><b translate>Recipient</b><div class="separator m-1 p-0"></div></div><div class=row><div class=col-3><img ng-src="{{request.suppliers[0].imageUrl || \'./app/shared/images/default-no-image.jpg\'}}" style="width: 100%"></div><div class=col><div><h5><div>{{request.suppliers[0].name}}</div></h5><div><div><span translate>Request created by</span>:</div>{{request.createdBy.name.first}} {{request.createdBy.name.last}}</div></div></div></div></div></div><!-- Customer / Recipient --></div><div class="row mt-3"><div class="col-lg-6 col-md-12"><div class="card p-2 mt-2"><div class="text-center mb-3"><b translate>Messages</b><div class="separator m-1 p-0"></div></div><div ng-if=!request.messages.length class="text-muted text-center"><span translate>No messages</span></div><div><div ng-repeat="message in request.messages | orderBy: \'createdAt\'" class=mb-1><div ng-if="request.isSentRequest ? message.isSupplier : !message.isSupplier" class=p-2 style="display:inline-block; background-color: whitesmoke; border-radius: 10px; margin-right: 30px"><div><small><b>{{message.createdBy.name.first}} {{message.createdBy.name.last}}</b></small></div><div class=small>{{utils.getLocalizedDate(message.createdAt)}}</div><div>{{message.text}}</div></div><div class=text-right><div ng-if="request.isSentRequest ? !message.isSupplier : message.isSupplier" class="text-white p-2" style="display:inline-block; background-color: #00b1b0; border-radius: 10px; margin-left: 30px"><div><small><b>{{message.createdBy.name.first}} {{message.createdBy.name.last}}</b></small></div><div class=small>{{utils.getLocalizedDate(message.createdAt)}}</div><div>{{message.text}}</div></div></div></div></div></div><!-- Messages --></div><div class="col-lg-6 col-md-12"><div class="card p-2 mt-2" ng-if="request.status !== REQUEST_STATUS.CANCELLED && !request.isSentRequest"><div class="text-center mb-3"><b translate>Actions</b><div class="separator m-1 p-0"></div></div><div ng-if=distributorDeal><button class="btn btn-success pt-3 pb-3" style="width: 100%" ng-click=sendDistributorOrder() ng-class="{\'btn-outline-success\': isPending, \'btn-outline-secondary\': !isPending }" ng-disabled=loading><i class="fa fa-shopping-cart"></i> <span translate>New order to {{distributorDeal.supplier.name}}</span></button></div><div><button class="btn pt-3 pb-3" style="width: 100%" ng-click=sendOffer() ng-class="{\'btn-outline-success\': isPending, \'btn-outline-secondary\': !isPending }" ng-disabled=loading><i class="fa fa-tag"></i> <span translate>Send an offer</span></button></div><div><button class="btn pt-3 pb-3" style="width: 100%" ng-click=createRequestOrder() ng-class="{\'btn-outline-primary\': isPending, \'btn-outline-secondary\': !isPending }" ng-disabled=loading><i class="fa fa-check"></i> <span translate>Mark as completed</span></button></div><div ng-if="!request.isCompleted && request.status !== REQUEST_STATUS.CANCELLED && request.status !== REQUEST_STATUS.REJECTED && request.status !== REQUEST_STATUS.FULFILLED"><button class=btn style="width: 100%" ng-click=rejectRequest() ng-class="{\'btn-outline-danger\': isPending, \'btn-outline-secondary\': !isPending }" ng-disabled=loading><i class="fa fa-times-circle"></i> <span translate>Reject request</span></button></div></div><!-- Actions (received) --><div class="card p-2 mt-2" ng-if="request.status !== REQUEST_STATUS.REJECTED && request.isSentRequest"><div class="text-center mb-3"><b translate>Actions</b><div class="separator m-1 p-0"></div></div><div ng-if="request.latestDeal && !request.latestDeal.isExpired"><button class="btn btn-success pt-3 pb-3" style="width: 100%" ng-click=goToOffer() ng-disabled=loading><i class="fa fa-tag"></i> <span translate>See offer</span></button></div><div ng-if="!request.isCompleted && request.status !== REQUEST_STATUS.CANCELLED && request.status !== REQUEST_STATUS.REJECTED && request.status !== REQUEST_STATUS.FULFILLED"><button class=btn style="width: 100%" ng-click=rejectRequest() ng-class="{\'btn-outline-danger\': isPending, \'btn-outline-secondary\': !isPending }" ng-disabled=loading><i class="fa fa-times-circle"></i> <span translate>Cancel request</span></button></div></div><!-- Actions (sent) --><div class="mt-20 alert alert-warning small" ng-if=utils.isUserRegionalManager()><div ng-click="vm.showAdminSection = !vm.showAdminSection"><strong>Admin section</strong></div><div ng-if=vm.showAdminSection><div>Request ID: {{request._id}}</div><div class=mt-20><button class="btn btn-warning btn-sm alert alert-warning p-0 m-0" ng-if=!request.isDeleted ng-click=deleteRequest()><i class="fa fa-times"></i> Delete request</button><div ng-if=request.isDeleted><span class=text-danger>Request deleted.</span> <button class="btn btn-warning btn-sm alert p-0 m-0" ng-click=restoreRequest()>Restore request</button></div></div></div></div><!-- Admin section --></div></div><!-- main-row --><div class=row><div class=col-md-12><hr></div><div class=col-6></div><div class="col-6 text-right"><button ng-click=cancel() class="btn btn-dark"><i class="fa fa-times"></i> <span translate>Close</span></button></div></div></div>');
$templateCache.put('app/shared/templates/modals/rich-text.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-file-text-o"></i> <span>{{title}}</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only>Close</span></button></div><div class="modal-body text-center"><div class=row><div class=col><form name=$ctrl.form class=richtext-form><div class="col-xs-12 form-group"><rich-text-editor ng-model=text required></rich-text-editor></div></form></div></div><div class=separator-2></div><div class=row><div class=col-6><button id=cancelButton type=button ng-click=cancel() class="btn btn-dark col-8" analytics-on=click><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button id=okButton type=button ng-click=ok() class="btn btn-success col-8" data-dismiss=modal analytics-on=click><i class="fa fa-check"></i> <span translate>Ok</span></button></div></div></div>');
$templateCache.put('app/shared/templates/prompts/share-order.tpl.html','<div><div class="alert alert-info mt-0" translate>Forward this order to coworkers who do not have a FarmHedge account.<br>They will receive a link protected by a pincode. The information will be accessible for 2 weeks.</div><div class=mt-2><label translate>Email</label>: <input type=text ng-model=sharedOrder.email class=form-control uib-typeahead="shop.email for shop in supplierShops | filter: $viewValue" typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0></div><div class=mt-2><label translate>Pincode</label>: <input type=text ng-model=sharedOrder.passcode class=form-control></div><br><br><br><br></div><script type=text/ng-template id=typeahead.tpl.html><a tabindex="-1" class="typeahead-general p-1">\n        {{match.model.email}}\n        <div class="small">\n            {{match.model.name}}<br>\n            <i>{{match.model.address}}</i>\n        </div>\n    </a></script>');
$templateCache.put('app/modules/deals/deal-request/templates/forward-request.tpl.html','<div class="pl-2 pr-2"><div><label><span ng-if=isCategoryCrop translate>Buyer:</span> <span ng-if=!isCategoryCrop translate>Seller:</span> {{distributorDeal.supplier.name}}</label></div><div><div class=form-group ng-class="{\'has-error\': $ctrl.form.$submitted && $ctrl.form.Name.$invalid }"><div><label for=prodName class=control-label translate>Product</label></div><div><input type=text name=Name ng-model=productName class=form-control id=prodName placeholder="{{\'Product name\'|translate}}" disabled required></div></div></div><div class="mt-3 row"><div class=col-lg-4><label><span translate>Quantity</span></label><div class="input-group ml-0 pl-0"><span class=input-group-addon><i class="fa fa-cubes"></i></span> <input class=form-control type=number ng-model=cartItem.quantity></div></div><div class=col-lg-4><label><span translate>Customer price</span></label><div class="input-group ml-0 pl-0"><span class=input-group-addon>{{currencySymbol || \'\u20AC\'}}</span> <input type=text class=form-control ng-model=cartItem.customerPrice></div></div><div class=col-lg-4 ng-if=distributorDeal.benchmarkPrice><label><span translate>Distributor price</span></label><div class="input-group ml-0 p-2">{{utils.getLocalizedCurrency(distributorDeal.benchmarkPrice)}} / {{distributorDeal.customUnit}}</div></div></div><div class=mt-3><div><label translate>Leave a message for your customer:</label></div><textarea class=form-control rows=2 ng-model=message></textarea></div><br><br><br></div>');
$templateCache.put('app/modules/deals/deal-request/templates/quick-offer.tpl.html','<div class="pl-2 pr-2"><div ng-if=shoppingCartItem class="alert alert-warning text-center mt-0"><span translate>This item is already in your shopping cart</span></div><div><div class=form-group ng-class="{\'has-error\': $ctrl.form.$submitted && $ctrl.form.Name.$invalid }"><div><label for=prodName class=control-label translate>Product</label></div><div><input type=text name=Name ng-model=productName class=form-control id=prodName placeholder="{{\'Product name\'|translate}}" disabled required></div></div></div><div class=row><div class=col-lg-4><div><label><span translate>Offer ends in</span></label><select class=form-control ng-model=deal.bookingSpan ng-change=updateDealDate()><option value=day translate>1 day</option><option value=week translate>1 week</option><option value=month translate>1 month</option><option value=year translate>No end</option></select></div></div><div class=col-lg-8 ng-if="deal.bookingSpan !== \'year\'"><label><span translate>Offer ends</span></label><div class=p-2>{{utils.getLocalizedDateAndTime(deal.bookingEnd)}}</div></div></div><div class="mt-3 row"><div class=col-lg-4><label><span translate>Items available</span></label><div class="input-group ml-0 pl-0"><span class=input-group-addon><i class="fa fa-cubes"></i></span> <input class=form-control type=number ng-model=deal.dealSize required></div></div><div class=col-lg-4><label><span translate>Unit price</span></label><div class="input-group ml-0 pl-0"><span class=input-group-addon>{{currencySymbol || \'\u20AC\'}}</span> <input type=text class=form-control ng-model=deal.benchmarkPrice ng-currency currency-symbol="" required></div></div><div class=col-lg-4 ng-if=distributorDeal.benchmarkPrice><label><span translate>Distributor price</span></label><div class="input-group ml-0 p-2">{{utils.getLocalizedCurrency(distributorDeal.benchmarkPrice)}} / {{distributorDeal.customUnit}}</div></div></div><div class=mt-3><div><label translate>Leave a message for your customer:</label></div><textarea class=form-control rows=2 ng-model=message></textarea></div><br><br><br></div>');
$templateCache.put('app/modules/product/products/product-edit-dialog/product-edit.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-product-hunt"></i> <span ng-if=$ctrl.isNew translate>Create product</span> <span ng-if=!$ctrl.isNew translate>Update product</span> <span ng-if=$ctrl.utils.isUserRegionalManager() class="p-1 small alert-warning">{{$ctrl.product._id}}</span></h4><button type=button ng-click=$ctrl.cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class="modal-body row mt-2 mb-3"><div class="col-lg-6 col-md-12"><form name=$ctrl.form role=form autocomplete=off class="m-0 p-0"><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.$submitted && $ctrl.form.Name.$invalid }"><label for=prodName class="col-md-3 col-lg-4 text-md-right control-label col-form-label"><span ng-if=!$ctrl.isCategoryCrop() translate>Name</span> <span ng-if=$ctrl.isCategoryCrop() translate>Crop type</span></label><div class=col-md-8><input type=text name=Name ng-model=$ctrl.product.name class=form-control id=prodName placeholder="{{\'Name\'|translate}}" required></div><div class="push-md-3 col-md-8 push-lg-4 text-danger" ng-messages=$ctrl.form.Name.$error ng-if="$ctrl.form.$submitted && $ctrl.form.Name.$error"><div class=error-message ng-message=required><i class="fa fa-times-circle"></i> <span translate>Field is required</span></div></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.$submitted && $ctrl.form.vendorProductId.$invalid }"><label for=vendorProductId class="col-md-3 col-lg-4 text-md-right control-label col-form-label" translate>ID</label><div class=col-md-8><input type=text name=vendorProductId ng-model=$ctrl.product.vendorProductId class=form-control id=vendorProductId placeholder="{{\'ID\'|translate}}"></div><div class="push-md-3 col-md-8 push-lg-4 text-danger" ng-messages=$ctrl.form.vendorProductId.$error ng-if="$ctrl.form.$submitted && $ctrl.form.vendorProductId.$error"><div class=error-message ng-message=required><i class="fa fa-times-circle"></i> <span translate>Field is required</span></div></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.$submitted && $ctrl.form.Category.$invalid }"><label for=category class="col-md-3 col-lg-4 text-md-right control-label col-form-label"><span ng-if=!$ctrl.isCategoryCrop() translate>Category</span> <span ng-if=$ctrl.isCategoryCrop() translate>Origin &amp; Year</span></label><div class=col-md-8><input type=text name=category ng-model=$ctrl.product.categoryName class=form-control id=custType aria-describedby=customType uib-typeahead="type for type in $ctrl.lookup.categories | filter:$viewValue" typeahead-on-select=$ctrl.categoryNameChanged() typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0 placeholder="{{\'E.g. Concentrate feed\'|translate}}" ng-change=$ctrl.categoryNameChanged()></div><div class="push-md-3 col-md-8 push-lg-4 text-danger" ng-messages=$ctrl.form.category.$error ng-if="$ctrl.form.$submitted && $ctrl.form.category.$error"><div class=error-message ng-message=required><i class="fa fa-times-circle"></i> <span translate>Field is required</span></div></div></div><div class="form-group has-feedback row" ng-if=$ctrl.utils.getSettings().customProductAttributes><label for=category class="col-md-3 col-lg-4 text-md-right control-label col-form-label"><span ng-if=$ctrl.isCategoryCrop() translate>Crop quality</span> <span ng-if=!$ctrl.isCategoryCrop() translate>Details</span></label><div class=col-md-8><product-attributes-edit attributes=$ctrl.product.attributes default-preset=$ctrl.product.name></product-attributes-edit></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.$submitted && $ctrl.form.unit.$invalid }"><label for=unit class="col-md-3 col-lg-4 text-md-right control-label col-form-label" translate>Unit</label><div class=col-md-8><input type=text name=unit id=unit aria-describedby=unit ng-model=$ctrl.product.unit class=form-control uib-typeahead="unit for unit in $ctrl.lookup.units | filter: $viewValue" typeahead-template-url=typeahead.tpl.html typeahead-show-hint-on-focus=all typeahead-min-length=0 placeholder="{{\'E.g. Liters\'|translate}}" required></div><div class="push-md-3 col-md-8 push-lg-4 text-danger" ng-messages=$ctrl.form.unit.$error ng-if="$ctrl.form.$submitted && $ctrl.form.unit.$error"><div class=error-message ng-message=required><i class="fa fa-times-circle"></i> <span translate>Field is required</span></div></div></div><div class="form-group has-feedback row" ng-class="{\'has-error\': $ctrl.form.$submitted && $ctrl.form.Stock.$invalid }"><label for=stock class="col-md-3 col-lg-4 text-md-right hidden-sm-down control-label col-form-label pt-4 mt-2" translate>Quantity</label><div class=col-md-8><input-deal-size deal-size-options=$ctrl.product.dealSizeOptions unit=$ctrl.product.unit form=$ctrl.formDeal deal-size=$ctrl.product.stockQuantity label-size="\'small\'" is-sale=$ctrl.isCategoryCrop()></input-deal-size></div><div class="push-md-3 col-md-8 push-lg-4 text-danger" ng-messages=$ctrl.form.Stock.$error ng-if="$ctrl.form.$submitted && $ctrl.form.Stock.$error"><div class=error-message ng-message=required><i class="fa fa-times-circle"></i> <span translate>Field is required</span></div><div class=error-message ng-message=min><i class="fa fa-times-circle"></i> <span translate>Field must be a positive value</span></div></div></div></form><form name=$ctrl.formDescription role=form autocomplete=off><div><div><label translate>Description</label></div><div><rich-text-editor class=product-description ng-model=$ctrl.product.description></rich-text-editor></div></div></form></div><div class="col-lg-6 col-md-12" ng-if=$ctrl.form.$valid><form name=$ctrl.formDeal role=form autocomplete=off class="m-0 p-0"><div class="form-group has-feedback"><input type=checkbox id=isPublic ng-model=$ctrl.product.isPublic class=switch-input ng-change=$ctrl.isPublicChanged()><label for=isPublic class=switch-label><span translate>Always available to customers</span></label></div><div ng-if=$ctrl.product.isPublic><div class="form-group has-feedback row mb-2 pb-0"><label for=price class="col-md-3 col-lg-4 text-md-right control-label col-form-label" translate>Price</label><div class=col-md-8><button class="btn btn-secondary col-12 m-0" ng-click=$ctrl.editDiscount()><span ng-if=$ctrl.deal.benchmarkPrice>{{$ctrl.dealsService.getRetailerPricesRange($ctrl.deal)}}</span> <span ng-if=!$ctrl.deal.benchmarkPrice translate>Set price</span></button></div></div><div class=text-right ng-if="$ctrl.utils.isNumber($ctrl.deal.benchmarkPrice) && !$ctrl.utils.isSupplierDistributor()"><a ng-click=$ctrl.editDiscount() class="text-success padding-ver-clear"><span>{{$ctrl.deal.individualDiscount || 0 |number:1}}% </span><span ng-if=$ctrl.dealsService.isQuantityDiscountEnabled($ctrl.deal)>~&nbsp;{{$ctrl.deal.clearanceDiscount |number:1}}% </span><small translate>Discount</small> <i class="fa fa-pencil-square-o"></i></a></div><div ng-if=$ctrl.isCategoryDiesel()><div class="separator mb-4"></div><div class="form-group has-feedback text-right pb-0 mb-0"><input type=checkbox id=priceDynamicEnabled ng-model=$ctrl.deal.priceDynamic.isEnabled class=switch-input ng-change=$ctrl.isDynamicPriceChanged()><label for=priceDynamicEnabled class=switch-label><i class="fa fa-bolt"></i> <span translate>Price changes every day</span></label></div><div class="form-group has-feedback text-right" ng-if=$ctrl.deal.priceDynamic.isEnabled><input type=checkbox id=priceDynamicRemindersEnabled ng-model=$ctrl.deal.priceDynamic.isReminderEnabled class=switch-input><label for=priceDynamicRemindersEnabled class="switch-label small"><i class="fa fa-envelope"></i> <span translate>Remind me to update price</span></label></div></div><div class="separator mb-4"></div><div class="form-group has-feedback row mb-0 pb-0"><div for=distributionPeriod class="col-md-3 col-lg-4 pr-0"><select ng-model=" $ctrl.deal.distribution" class=form-control ng-change=$ctrl.dealDistributionChanged() ng-options="op.value as op.label for op in $ctrl.lookup.distributionMethods"></select></div><!-- <label for="distributionPeriod" class="col-md-3 col-lg-4 text-md-right control-label col-form-label" translate>Delivery</label> --><div class="col-md-2 pr-0" ng-class="{\'has-error\': $ctrl.formDeal.distributionOptionsStart.$invalid}"><input type=number class="form-control pl-2 pr-1" ng-model=$ctrl.deal.distributionOptions.start name=distributionOptionsStart><div class="small pl-2" translate>From</div></div><div class="col-md-2 pr-0" ng-class="{\'has-error\': $ctrl.formDeal.distributionOptionsEnd.$invalid}"><input type=number class="form-control pl-2 pr-1" ng-model=$ctrl.deal.distributionOptions.end name=distributionOptionsEnd><div class="small pl-2" translate>Until</div></div><div class="col-md-4 mb-0"><select class=form-control ng-model=$ctrl.deal.distributionOptions.timeUnit ng-options="dm.value as dm.label for dm in $ctrl.lookup.distributionOptionsTimeUnits"></select></div></div><div class="form-group has-feedback text-right mt-2 pt-0" ng-if=$ctrl.dealsService.isDistributionCollection($ctrl.deal)><a ng-click=$ctrl.manageCollection() class="text-success padding-ver-clear">{{$ctrl.deal.collectionPoints.length}} / {{$root.app.Auth.User.supplier.collectionPoints.length}} <span translate>Collection points</span></a></div><div class="form-group has-feedback text-right mt-0 pt-0" ng-if="!$ctrl.dealsService.isDistributionCollection($ctrl.deal) && $ctrl.isCategoryDiesel()"><input type=checkbox id=deliveryConfirmation ng-model=$ctrl.deal.distributionOptions.isConfirmationNeeded ng-change=$ctrl.isConfirmationNeededChanged() class=switch-input><label for=deliveryConfirmation class="switch-label small"><span translate>Customers must confirm quantity delivered</span></label></div><div class="separator mb-4"></div><div ng-if=!$ctrl.utils.isSupplierDistributor() class="form-group has-feedback text-right mb-0 pb-0"><input type=checkbox id=isPushNotificationEnabled ng-model=$ctrl.product.isPushNotificationEnabled class=switch-input><label for=isPushNotificationEnabled class=switch-label><i class="fa fa-comment"></i> <span translate>Send push notification to customers</span></label></div><div ng-if=$ctrl.product.isPushNotificationEnabled ng-class="{\'has-error\': !$ctrl.product.pushNotificationMessage }"><textarea ng-model=$ctrl.product.pushNotificationMessage class=form-control id=pushNotificationMessage name=pushNotificationMessage placeholder="{{\'Message\'|translate}}" maxlength=140 required> \n                    </textarea></div></div></form></div><div class="separator-2 mt-2"></div><div class="col-12 pr-0 row"><div class=col-md-6><button type=button ng-click=$ctrl.cancel() class="btn btn-dark col-md-6"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-md-6 text-right pr-0"><button type=submit ng-click=$ctrl.ok() class="btn btn-success col-md-8" data-dismiss=modal><i class="fa fa-check"></i> <span ng-if=!$ctrl.product.isPushNotificationEnabled translate>Save</span> <span ng-if=$ctrl.product.isPushNotificationEnabled translate>Save and send notification</span></button></div></div></div><script type=text/ng-template id=typeahead.tpl.html><a tabindex="-1" class="typeahead-general p-1">\n        {{match.model}}\n    </a></script>');
$templateCache.put('app/modules/product/products/product-images-import-dialog/product-images-import.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-product-hunt"></i> <span translate>Import product images</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class=modal-body><div class="col-md-12 mt-0 pt-0"><form name=$ctrl.form role=form><div class="alert alert-icon alert-danger" ng-if=$ctrl.browserNotSupported><i class="fa fa-warning"></i> <span translate>This browser does not support the import function.</span></div><div class="alert alert-icon alert-danger" ng-if=$ctrl.invalidInportFile><i class="fa fa-warning"></i> <span translate>Upload failed. File must be a valid Excel or CSV file.</span></div><div ng-if="!$ctrl.loading && !$ctrl.productRows.length"><label for=input-select-file class="file_uploader btn btn-outline-success mb-2 p-4" style="width: 100%"><i class="fa fa-desktop"></i> <span translate>Select file from your computer</span> <input type=file id=input-select-file name=input-select-file ngf-select=$ctrl.selectFile($files) ngf-resize="{width:600, height:600}" ngf-multiple=true accept=".png, .jpg, .jpeg"></label><div class=file-paste-or-drop contenteditable=false ngf-model-options="{updateOn: \'change click drop dropUrl paste\', allowInvalid: false, debounce: 0}" ngf-drop=$ctrl.selectFile($files) ngf-multiple=true ngf-accept="\'.png, .jpg, .jpeg\'" ngf-resize="{width:600, height:600}" accept=".png, .jpg, .jpeg"><i class="fa fa-clipboard p-3" style="font-size: 200%"></i><br><span translate>Drag-and-drop here</span><div><span translate>Or</span></div><div><span translate>Copy image (CTRL + C) and paste here using CTRL + V</span></div></div></div><div class="row text-center" ng-if="!$ctrl.productRows && $ctrl.loading"><div class=col-md-12><img src=app/shared/images/excel_loading.gif style="max-width: 300px; margin: 0 auto" alt=""></div><p class=col-md-12>Processing document please wait ...</p></div><div class="row import-list" ng-if=$ctrl.productRows.length><table class=col-md-12 cellpadding=0 cellspacing=0><thead><tr style="width: 100%"><th style="width: 30%"><span translate>Image</span></th><th style="width: 40%"><span translate>File name</span></th><th style="width: 30%"><span translate>Product</span></th></tr></thead><tbody><tr ng-repeat="row in $ctrl.productRows" ng-class="{ \'invalid\': row.isInvalid }"><td style="width: 30%" class=p-0><img ng-src={{row.filePreview}} class="img-responsive p-3" style="max-width: 100px; max-height: 100px"></td><td style="width: 40%">{{row.fileName}}</td><td style="width: 30%">{{row.vendorProductId}}</td></tr></tbody></table></div><hr><div class=row><div class=col-6><button type=button ng-click=cancel() class="btn btn-dark col-8"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button type=button ng-click=ok() class="btn btn-success col-12" data-dismiss=modal ng-disabled="$ctrl.browserNotSupported || $ctrl.invalidInportFile || $ctrl.loading"><i class="fa fa-check"></i> <span translate>Save</span></button></div></div></form></div></div>');
$templateCache.put('app/modules/product/products/products-import-dialog/products-import.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-product-hunt"></i> <span translate>Import products</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class="modal-body pt-0 mt-0"><div class="col-md-12 mt-0 pt-0"><form name=$ctrl.form role=form><div class=row><label class=col-3 translate>Configuration</label><div class=col><select id=configSelec class=form-control name=configSelec data-ng-model=$ctrl.importConfig ng-options="config as config.label for config in $ctrl.importConfigList" required></select></div></div><div class="alert alert-icon alert-danger" ng-if=$ctrl.browserNotSupported><i class="fa fa-warning"></i> <span translate>This browser does not support the import function.</span></div><div class="alert alert-icon alert-danger" ng-if=$ctrl.invalidInportFile><i class="fa fa-warning"></i> <span translate>Upload failed. File must be a valid Excel or CSV file.</span></div><div ng-if="!$ctrl.loading && !$ctrl.productRows.length"><label for=input-select-file class="file_uploader btn btn-outline-success mb-2 p-4" style="width: 100%"><i class="fa fa-desktop"></i> <span translate>Select file from your computer</span> <input type=file id=input-select-file name=input-select-file ngf-select=$ctrl.selectFile($file) ngf-multiple=false accept=".xlsx, .xls, .csv"></label><div class=file-paste-or-drop contenteditable=false ngf-model-options="{updateOn: \'change click drop dropUrl paste\', allowInvalid: false, debounce: 0}" ngf-drop=$ctrl.selectFile($file) ngf-multiple=false ngf-accept="\'.xls,.xlsx,.csv\'" accept=".xlsx, .xls, .csv"><i class="fa fa-clipboard p-3" style="font-size: 200%"></i><br><span translate>Drag-and-drop here</span><div><span translate>Or</span></div><div><span translate>Copy image (CTRL + C) and paste here using CTRL + V</span></div></div></div><div class="row text-center" ng-if="!$ctrl.productRows && $ctrl.loading"><div class=col-md-12><img src=app/shared/images/excel_loading.gif style="max-width: 300px; margin: 0 auto" alt=""></div><p class=col-md-12>Processing document please wait ...</p></div><div class="row import-list" ng-if=$ctrl.productRows.length><table class=col-md-12 cellpadding=5 cellspacing=5><thead><tr><th ng-repeat="k in $ctrl.columns" ng-style="{\'width\': k.width + \'%\'}" ng-if="k.field !== \'attributes\'">{{k.label}}</th></tr></thead><tbody><tr ng-repeat-start="prod in $ctrl.productRows" ng-class="{ \'invalid text-warning\': prod.isInvalid }"><td ng-repeat="k in $ctrl.columns" ng-style="{\'width\': k.width + \'%\'}" style="overflow: hidden"><span ng-if="!k.value && k.field">{{prod[k.field]}}</span> <span ng-if=k.value>{{k.value(prod)}}</span></td></tr><tr ng-repeat-end ng-if="prod[\'attributes\']" ng-class="{ \'invalid text-warning\': prod.isInvalid }"><td></td><td></td><td colspan="{{$ctrl.columns.length - 2}}" style="font-size: 0.7rem" class="pt-0 mt-0"><span ng-repeat="attr in prod[\'attributes\']">{{attr.label}}:&nbsp;{{attr.value}};</span></td></tr></tbody></table><div class="pull-right clearfix pt-3"><input type=checkbox id=productsPublic ng-model=$ctrl.productsPublic class=switch-input><label for=productsPublic class=switch-label><i class="fa fa-user"></i> <span translate>Make products visible to customers (Public)</span></label></div><div class="alert alert-icon alert-warning" ng-if=$ctrl.hasInvalidRows><i class="fa fa-times-circle"></i> <span translate>One or more items are not valid. Please review the list below before going ahead.</span></div><div class="alert alert-icon alert-info" ng-if=$ctrl.validRowsCount><i class="fa fa-info-circle"></i> <span translate>Please note: if a product with same ID or name already exists, the existing product data will be updated.</span></div></div><hr><div class=row><div class=col-6><button type=button ng-click=cancel() class="btn btn-dark col-8"><i class="fa fa-times"></i> <span translate>Cancel</span></button></div><div class="col-6 text-right"><button type=button ng-click=ok() class="btn btn-success col-12" data-dismiss=modal ng-disabled="$ctrl.browserNotSupported || $ctrl.invalidInportFile || !$ctrl.validRowsCount"><i class="fa fa-check"></i> <span ng-if=!$ctrl.validRowsCount translate>Save</span> <span ng-if="!$ctrl.productsPublic && $ctrl.validRowsCount === 1" translate>Save 1 product</span> <span ng-if="$ctrl.productsPublic && $ctrl.validRowsCount === 1" translate>Save and publish 1 product</span> <span ng-if="!$ctrl.productsPublic && $ctrl.validRowsCount > 1" translate>Save {{$ctrl.validRowsCount}} products</span> <span ng-if="$ctrl.productsPublic && $ctrl.validRowsCount > 1" translate>Save and publish {{$ctrl.validRowsCount}} products</span></button></div></div></form></div></div>');
$templateCache.put('app/modules/product/products/templates/update-message.tpl.html','<div class="mt-2 mb-4 p-2"><div class=mb-3><div><label translate>Receipients</label>({{$ctrl.messageData.toUsers.length}})</div><div style="max-height: 200px; overflow: scroll"><chips ng-model=$ctrl.messageData.toUsers><chip-tmpl><div class=default-chip><small>{{chip.name.first}} {{chip.name.last}}</small>&nbsp;<span class="fa fa-times-circle" remove-chip></span></div></chip-tmpl></chips></div></div><div class=mb-3><div><label translate>Subject</label></div><div><input type=text class=form-control ng-model=$ctrl.messageData.subject placeholder="{{\'Message subject\' | translate}}"></div></div><div style="min-height: 360px"><div><label translate>Content</label></div><div><rich-text-editor ng-model=$ctrl.messageData.html></rich-text-editor></div></div></div>');
$templateCache.put('app/modules/product/products/templates/update-price.tpl.html','<div class="pl-2 pr-2 pt-3 pb-2"><div class=input-group><input type=text name=price ng-model=$ctrl.deal.benchmarkPrice class=form-control id=price ng-currency currency-symbol="" fraction="{{$ctrl.deal.priceDecimalDigits || 2}}" autofocus required> <span class=input-group-addon>{{$root.app.Auth.User.supplier.currencySymbol || \'\u20AC\'}} / {{$ctrl.product.unit}}</span></div><div ng-if="$ctrl.deal.priceDynamic && $ctrl.deal.priceDynamic.isEnabled"><div class="text-right mt-2 small"><span translate>Last update</span>: <span class="chip text-info">{{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.priceDynamic.updatedAt)}}</span></div><div class="text-right mt-2 mb-3 small"><span translate>Update due</span>: <span class="chip text-info">{{$ctrl.utils.getLocalizedDateAndTime($ctrl.deal.priceDynamic.nextUpdateAt)}}</span></div></div></div>');
$templateCache.put('app/modules/profile/profile/profile-image/profile-image.tpl.html','<div class=modal-header><h4 class=modal-title><i class="fa fa-cloud-upload"></i> <span translate>Upload Profile image</span></h4><button type=button ng-click=cancel() class=close><span aria-hidden=true>&times;</span><span class=sr-only translate>Close</span></button></div><div class=modal-body><div class=col-md-12><form role=form name=Form.imgForm ng-show=!uploading><div class="form-group col-md-12" ng-if=!filepreview ng-class="{\'has-error\': Form.imgForm.$submitted && !validateFile() }"><label class=label for=inputFile translate>Click to choose an image</label><input type=file id=inputFile name=inputFile class=file_uploader placeholder="{{\'Click to choose an image\'|translate}}" ngf-select=onFileSelect($files) ng-model=selectedFile ngf-model-options="{updateOn: \'change drop dropUrl paste\', allowInvalid: false, debounce: 0}" ngf-drag-over-class="\'dragover\'" ngf-enable-firefox-paste=true ngf-multiple=false ngf-pattern="\'image/*\'" ngf-accept="\'.png,.gif,.jpg,.jpeg\'" ngf-resize="{width:800, height:800}"><!--<i class="fa fa-image fa-2x"></i>--><!--<p class="col-12" translate>click to add an image or drop image file here</p>--><div class=text-danger ng-if="Form.imgForm.$submitted && !formValid"><small class=form-control-feedback ng-if=validateFile().NoFile translate>* Field is required</small> <small class=form-control-feedback ng-if=!validateFile().Size translate>* file size cannot exceed 4.0 MB</small> <small class=form-control-feedback ng-if=!validateFile().Type translate>* selected file must be an image file</small></div></div><div ng-if=filepreview class=col-md-12 id=imgPreview><a ng-click=resetFile() class="text-danger btn-lg-link pull-right"><i class="fa fa-2x fa-times-circle-o"></i></a> <img ng-src={{filepreview}} class=img-responsive></div><div class=col-12><div class=row><div class="col-12 text-right"><button type=button ng-click=cancel() class="btn btn-dark"><i class="fa fa-times"></i> <span translate>Cancel</span></button> <button type=button ng-click=ok() class="btn btn-success"><i class="fa fa-cloud-upload"></i> <span translate>Upload</span></button></div></div></div></form><div class=col-md-12 ng-if=uploading><p class="text-sm-center text-info margin--bottom-clear"><i class="fa fa-info-circle"></i> <span translate>This window will auto-close once the image upload completes.</span></p><p class="text-sm-center text-warning margin-top-clear"><span translate>Please donot press <i class="fa fa-arrow-circle-o-left"></i> back or <i class="fa fa-refresh"></i> refresh while image is uploading.</span></p><div class="col-md-8 offset-2 padding-ver-clear"><img src=./app/shared/images/uploading.gif width=120 style="margin: 0 auto" alt=""></div><div class="progress style-1 col-md-8 offset-2"><span class=text></span><div class="progress-bar progress-bar-default" data-animate-width=90%><span class="label object-non-visible" data-animation-effect=fadeInLeftSmall data-effect-delay=1000>{{uploadProgress}}</span></div></div></div></div></div>');}]);